/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/emojimation/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 340);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyFunction = __webpack_require__(6);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  (function () {
    var printWarning = function printWarning(format) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };

    warning = function warning(condition, format) {
      if (format === undefined) {
        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
      }

      if (format.indexOf('Failed Composite propType: ') === 0) {
        return; // Ignore CompositeComponent proptype check.
      }

      if (!condition) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        printWarning.apply(undefined, [format].concat(args));
      }
    };
  })();
}

module.exports = warning;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var DOMProperty = __webpack_require__(26);
var ReactDOMComponentFlags = __webpack_require__(131);

var invariant = __webpack_require__(0);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 8 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(3);

var CallbackQueue = __webpack_require__(129);
var PooledClass = __webpack_require__(19);
var ReactFeatureFlags = __webpack_require__(134);
var ReactReconciler = __webpack_require__(27);
var Transaction = __webpack_require__(47);

var invariant = __webpack_require__(0);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var PooledClass = __webpack_require__(19);

var emptyFunction = __webpack_require__(6);
var warning = __webpack_require__(1);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}
/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(21)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(12)
  , core      = __webpack_require__(8)
  , ctx       = __webpack_require__(98)
  , hide      = __webpack_require__(22)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(30)
  , IE8_DOM_DEFINE = __webpack_require__(100)
  , toPrimitive    = __webpack_require__(62)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(13) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(101)
  , defined = __webpack_require__(52);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_color__ = __webpack_require__(65);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "color", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "rgb", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hsl", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_lab__ = __webpack_require__(211);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "lab", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hcl", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__ = __webpack_require__(210);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cubehelix", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__["a"]; });





/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(28);


/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(16)
  , createDesc = __webpack_require__(40);
module.exports = __webpack_require__(13) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(106)
  , enumBugKeys = __webpack_require__(53);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var store      = __webpack_require__(60)('wks')
  , uid        = __webpack_require__(42)
  , Symbol     = __webpack_require__(12).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = __webpack_require__(73);
var setInnerHTML = __webpack_require__(49);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(81);
var setTextContent = __webpack_require__(147);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactRef = __webpack_require__(284);
var ReactInstrumentation = __webpack_require__(7);

var warning = __webpack_require__(1);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var ReactBaseClasses = __webpack_require__(150);
var ReactChildren = __webpack_require__(315);
var ReactDOMFactories = __webpack_require__(316);
var ReactElement = __webpack_require__(29);
var ReactPropTypes = __webpack_require__(317);
var ReactVersion = __webpack_require__(318);

var createReactClass = __webpack_require__(319);
var onlyChild = __webpack_require__(323);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var ReactCurrentOwner = __webpack_require__(11);

var warning = __webpack_require__(1);
var canDefineProperty = __webpack_require__(154);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(152);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(31);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: http://codemirror.net/LICENSE

// This is CodeMirror (http://codemirror.net), a code editor
// implemented in JavaScript on top of the browser's DOM.
//
// You can find some technical background for some of the code below
// at http://marijnhaverbeke.nl/blog/#cm-internals .

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.CodeMirror = factory());
}(this, (function () { 'use strict';

// Kludges for bugs and behavior differences that can't be feature
// detected are enabled based on userAgent etc sniffing.
var userAgent = navigator.userAgent;
var platform = navigator.platform;

var gecko = /gecko\/\d/i.test(userAgent);
var ie_upto10 = /MSIE \d/.test(userAgent);
var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(userAgent);
var edge = /Edge\/(\d+)/.exec(userAgent);
var ie = ie_upto10 || ie_11up || edge;
var ie_version = ie && (ie_upto10 ? document.documentMode || 6 : +(edge || ie_11up)[1]);
var webkit = !edge && /WebKit\//.test(userAgent);
var qtwebkit = webkit && /Qt\/\d+\.\d+/.test(userAgent);
var chrome = !edge && /Chrome\//.test(userAgent);
var presto = /Opera\//.test(userAgent);
var safari = /Apple Computer/.test(navigator.vendor);
var mac_geMountainLion = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(userAgent);
var phantom = /PhantomJS/.test(userAgent);

var ios = !edge && /AppleWebKit/.test(userAgent) && /Mobile\/\w+/.test(userAgent);
var android = /Android/.test(userAgent);
// This is woefully incomplete. Suggestions for alternative methods welcome.
var mobile = ios || android || /webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(userAgent);
var mac = ios || /Mac/.test(platform);
var chromeOS = /\bCrOS\b/.test(userAgent);
var windows = /win/i.test(platform);

var presto_version = presto && userAgent.match(/Version\/(\d*\.\d*)/);
if (presto_version) { presto_version = Number(presto_version[1]); }
if (presto_version && presto_version >= 15) { presto = false; webkit = true; }
// Some browsers use the wrong event properties to signal cmd/ctrl on OS X
var flipCtrlCmd = mac && (qtwebkit || presto && (presto_version == null || presto_version < 12.11));
var captureRightClick = gecko || (ie && ie_version >= 9);

function classTest(cls) { return new RegExp("(^|\\s)" + cls + "(?:$|\\s)\\s*") }

var rmClass = function(node, cls) {
  var current = node.className;
  var match = classTest(cls).exec(current);
  if (match) {
    var after = current.slice(match.index + match[0].length);
    node.className = current.slice(0, match.index) + (after ? match[1] + after : "");
  }
};

function removeChildren(e) {
  for (var count = e.childNodes.length; count > 0; --count)
    { e.removeChild(e.firstChild); }
  return e
}

function removeChildrenAndAdd(parent, e) {
  return removeChildren(parent).appendChild(e)
}

function elt(tag, content, className, style) {
  var e = document.createElement(tag);
  if (className) { e.className = className; }
  if (style) { e.style.cssText = style; }
  if (typeof content == "string") { e.appendChild(document.createTextNode(content)); }
  else if (content) { for (var i = 0; i < content.length; ++i) { e.appendChild(content[i]); } }
  return e
}
// wrapper for elt, which removes the elt from the accessibility tree
function eltP(tag, content, className, style) {
  var e = elt(tag, content, className, style);
  e.setAttribute("role", "presentation");
  return e
}

var range;
if (document.createRange) { range = function(node, start, end, endNode) {
  var r = document.createRange();
  r.setEnd(endNode || node, end);
  r.setStart(node, start);
  return r
}; }
else { range = function(node, start, end) {
  var r = document.body.createTextRange();
  try { r.moveToElementText(node.parentNode); }
  catch(e) { return r }
  r.collapse(true);
  r.moveEnd("character", end);
  r.moveStart("character", start);
  return r
}; }

function contains(parent, child) {
  if (child.nodeType == 3) // Android browser always returns false when child is a textnode
    { child = child.parentNode; }
  if (parent.contains)
    { return parent.contains(child) }
  do {
    if (child.nodeType == 11) { child = child.host; }
    if (child == parent) { return true }
  } while (child = child.parentNode)
}

function activeElt() {
  // IE and Edge may throw an "Unspecified Error" when accessing document.activeElement.
  // IE < 10 will throw when accessed while the page is loading or in an iframe.
  // IE > 9 and Edge will throw when accessed in an iframe if document.body is unavailable.
  var activeElement;
  try {
    activeElement = document.activeElement;
  } catch(e) {
    activeElement = document.body || null;
  }
  while (activeElement && activeElement.shadowRoot && activeElement.shadowRoot.activeElement)
    { activeElement = activeElement.shadowRoot.activeElement; }
  return activeElement
}

function addClass(node, cls) {
  var current = node.className;
  if (!classTest(cls).test(current)) { node.className += (current ? " " : "") + cls; }
}
function joinClasses(a, b) {
  var as = a.split(" ");
  for (var i = 0; i < as.length; i++)
    { if (as[i] && !classTest(as[i]).test(b)) { b += " " + as[i]; } }
  return b
}

var selectInput = function(node) { node.select(); };
if (ios) // Mobile Safari apparently has a bug where select() is broken.
  { selectInput = function(node) { node.selectionStart = 0; node.selectionEnd = node.value.length; }; }
else if (ie) // Suppress mysterious IE10 errors
  { selectInput = function(node) { try { node.select(); } catch(_e) {} }; }

function bind(f) {
  var args = Array.prototype.slice.call(arguments, 1);
  return function(){return f.apply(null, args)}
}

function copyObj(obj, target, overwrite) {
  if (!target) { target = {}; }
  for (var prop in obj)
    { if (obj.hasOwnProperty(prop) && (overwrite !== false || !target.hasOwnProperty(prop)))
      { target[prop] = obj[prop]; } }
  return target
}

// Counts the column offset in a string, taking tabs into account.
// Used mostly to find indentation.
function countColumn(string, end, tabSize, startIndex, startValue) {
  if (end == null) {
    end = string.search(/[^\s\u00a0]/);
    if (end == -1) { end = string.length; }
  }
  for (var i = startIndex || 0, n = startValue || 0;;) {
    var nextTab = string.indexOf("\t", i);
    if (nextTab < 0 || nextTab >= end)
      { return n + (end - i) }
    n += nextTab - i;
    n += tabSize - (n % tabSize);
    i = nextTab + 1;
  }
}

var Delayed = function() {this.id = null;};
Delayed.prototype.set = function (ms, f) {
  clearTimeout(this.id);
  this.id = setTimeout(f, ms);
};

function indexOf(array, elt) {
  for (var i = 0; i < array.length; ++i)
    { if (array[i] == elt) { return i } }
  return -1
}

// Number of pixels added to scroller and sizer to hide scrollbar
var scrollerGap = 30;

// Returned or thrown by various protocols to signal 'I'm not
// handling this'.
var Pass = {toString: function(){return "CodeMirror.Pass"}};

// Reused option objects for setSelection & friends
var sel_dontScroll = {scroll: false};
var sel_mouse = {origin: "*mouse"};
var sel_move = {origin: "+move"};

// The inverse of countColumn -- find the offset that corresponds to
// a particular column.
function findColumn(string, goal, tabSize) {
  for (var pos = 0, col = 0;;) {
    var nextTab = string.indexOf("\t", pos);
    if (nextTab == -1) { nextTab = string.length; }
    var skipped = nextTab - pos;
    if (nextTab == string.length || col + skipped >= goal)
      { return pos + Math.min(skipped, goal - col) }
    col += nextTab - pos;
    col += tabSize - (col % tabSize);
    pos = nextTab + 1;
    if (col >= goal) { return pos }
  }
}

var spaceStrs = [""];
function spaceStr(n) {
  while (spaceStrs.length <= n)
    { spaceStrs.push(lst(spaceStrs) + " "); }
  return spaceStrs[n]
}

function lst(arr) { return arr[arr.length-1] }

function map(array, f) {
  var out = [];
  for (var i = 0; i < array.length; i++) { out[i] = f(array[i], i); }
  return out
}

function insertSorted(array, value, score) {
  var pos = 0, priority = score(value);
  while (pos < array.length && score(array[pos]) <= priority) { pos++; }
  array.splice(pos, 0, value);
}

function nothing() {}

function createObj(base, props) {
  var inst;
  if (Object.create) {
    inst = Object.create(base);
  } else {
    nothing.prototype = base;
    inst = new nothing();
  }
  if (props) { copyObj(props, inst); }
  return inst
}

var nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
function isWordCharBasic(ch) {
  return /\w/.test(ch) || ch > "\x80" &&
    (ch.toUpperCase() != ch.toLowerCase() || nonASCIISingleCaseWordChar.test(ch))
}
function isWordChar(ch, helper) {
  if (!helper) { return isWordCharBasic(ch) }
  if (helper.source.indexOf("\\w") > -1 && isWordCharBasic(ch)) { return true }
  return helper.test(ch)
}

function isEmpty(obj) {
  for (var n in obj) { if (obj.hasOwnProperty(n) && obj[n]) { return false } }
  return true
}

// Extending unicode characters. A series of a non-extending char +
// any number of extending chars is treated as a single unit as far
// as editing and measuring is concerned. This is not fully correct,
// since some scripts/fonts/browsers also treat other configurations
// of code points as a group.
var extendingChars = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;
function isExtendingChar(ch) { return ch.charCodeAt(0) >= 768 && extendingChars.test(ch) }

// Returns a number from the range [`0`; `str.length`] unless `pos` is outside that range.
function skipExtendingChars(str, pos, dir) {
  while ((dir < 0 ? pos > 0 : pos < str.length) && isExtendingChar(str.charAt(pos))) { pos += dir; }
  return pos
}

// Returns the value from the range [`from`; `to`] that satisfies
// `pred` and is closest to `from`. Assumes that at least `to` satisfies `pred`.
function findFirst(pred, from, to) {
  for (;;) {
    if (Math.abs(from - to) <= 1) { return pred(from) ? from : to }
    var mid = Math.floor((from + to) / 2);
    if (pred(mid)) { to = mid; }
    else { from = mid; }
  }
}

// The display handles the DOM integration, both for input reading
// and content drawing. It holds references to DOM nodes and
// display-related state.

function Display(place, doc, input) {
  var d = this;
  this.input = input;

  // Covers bottom-right square when both scrollbars are present.
  d.scrollbarFiller = elt("div", null, "CodeMirror-scrollbar-filler");
  d.scrollbarFiller.setAttribute("cm-not-content", "true");
  // Covers bottom of gutter when coverGutterNextToScrollbar is on
  // and h scrollbar is present.
  d.gutterFiller = elt("div", null, "CodeMirror-gutter-filler");
  d.gutterFiller.setAttribute("cm-not-content", "true");
  // Will contain the actual code, positioned to cover the viewport.
  d.lineDiv = eltP("div", null, "CodeMirror-code");
  // Elements are added to these to represent selection and cursors.
  d.selectionDiv = elt("div", null, null, "position: relative; z-index: 1");
  d.cursorDiv = elt("div", null, "CodeMirror-cursors");
  // A visibility: hidden element used to find the size of things.
  d.measure = elt("div", null, "CodeMirror-measure");
  // When lines outside of the viewport are measured, they are drawn in this.
  d.lineMeasure = elt("div", null, "CodeMirror-measure");
  // Wraps everything that needs to exist inside the vertically-padded coordinate system
  d.lineSpace = eltP("div", [d.measure, d.lineMeasure, d.selectionDiv, d.cursorDiv, d.lineDiv],
                    null, "position: relative; outline: none");
  var lines = eltP("div", [d.lineSpace], "CodeMirror-lines");
  // Moved around its parent to cover visible view.
  d.mover = elt("div", [lines], null, "position: relative");
  // Set to the height of the document, allowing scrolling.
  d.sizer = elt("div", [d.mover], "CodeMirror-sizer");
  d.sizerWidth = null;
  // Behavior of elts with overflow: auto and padding is
  // inconsistent across browsers. This is used to ensure the
  // scrollable area is big enough.
  d.heightForcer = elt("div", null, null, "position: absolute; height: " + scrollerGap + "px; width: 1px;");
  // Will contain the gutters, if any.
  d.gutters = elt("div", null, "CodeMirror-gutters");
  d.lineGutter = null;
  // Actual scrollable element.
  d.scroller = elt("div", [d.sizer, d.heightForcer, d.gutters], "CodeMirror-scroll");
  d.scroller.setAttribute("tabIndex", "-1");
  // The element in which the editor lives.
  d.wrapper = elt("div", [d.scrollbarFiller, d.gutterFiller, d.scroller], "CodeMirror");

  // Work around IE7 z-index bug (not perfect, hence IE7 not really being supported)
  if (ie && ie_version < 8) { d.gutters.style.zIndex = -1; d.scroller.style.paddingRight = 0; }
  if (!webkit && !(gecko && mobile)) { d.scroller.draggable = true; }

  if (place) {
    if (place.appendChild) { place.appendChild(d.wrapper); }
    else { place(d.wrapper); }
  }

  // Current rendered range (may be bigger than the view window).
  d.viewFrom = d.viewTo = doc.first;
  d.reportedViewFrom = d.reportedViewTo = doc.first;
  // Information about the rendered lines.
  d.view = [];
  d.renderedView = null;
  // Holds info about a single rendered line when it was rendered
  // for measurement, while not in view.
  d.externalMeasured = null;
  // Empty space (in pixels) above the view
  d.viewOffset = 0;
  d.lastWrapHeight = d.lastWrapWidth = 0;
  d.updateLineNumbers = null;

  d.nativeBarWidth = d.barHeight = d.barWidth = 0;
  d.scrollbarsClipped = false;

  // Used to only resize the line number gutter when necessary (when
  // the amount of lines crosses a boundary that makes its width change)
  d.lineNumWidth = d.lineNumInnerWidth = d.lineNumChars = null;
  // Set to true when a non-horizontal-scrolling line widget is
  // added. As an optimization, line widget aligning is skipped when
  // this is false.
  d.alignWidgets = false;

  d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;

  // Tracks the maximum line length so that the horizontal scrollbar
  // can be kept static when scrolling.
  d.maxLine = null;
  d.maxLineLength = 0;
  d.maxLineChanged = false;

  // Used for measuring wheel scrolling granularity
  d.wheelDX = d.wheelDY = d.wheelStartX = d.wheelStartY = null;

  // True when shift is held down.
  d.shift = false;

  // Used to track whether anything happened since the context menu
  // was opened.
  d.selForContextMenu = null;

  d.activeTouch = null;

  input.init(d);
}

// Find the line object corresponding to the given line number.
function getLine(doc, n) {
  n -= doc.first;
  if (n < 0 || n >= doc.size) { throw new Error("There is no line " + (n + doc.first) + " in the document.") }
  var chunk = doc;
  while (!chunk.lines) {
    for (var i = 0;; ++i) {
      var child = chunk.children[i], sz = child.chunkSize();
      if (n < sz) { chunk = child; break }
      n -= sz;
    }
  }
  return chunk.lines[n]
}

// Get the part of a document between two positions, as an array of
// strings.
function getBetween(doc, start, end) {
  var out = [], n = start.line;
  doc.iter(start.line, end.line + 1, function (line) {
    var text = line.text;
    if (n == end.line) { text = text.slice(0, end.ch); }
    if (n == start.line) { text = text.slice(start.ch); }
    out.push(text);
    ++n;
  });
  return out
}
// Get the lines between from and to, as array of strings.
function getLines(doc, from, to) {
  var out = [];
  doc.iter(from, to, function (line) { out.push(line.text); }); // iter aborts when callback returns truthy value
  return out
}

// Update the height of a line, propagating the height change
// upwards to parent nodes.
function updateLineHeight(line, height) {
  var diff = height - line.height;
  if (diff) { for (var n = line; n; n = n.parent) { n.height += diff; } }
}

// Given a line object, find its line number by walking up through
// its parent links.
function lineNo(line) {
  if (line.parent == null) { return null }
  var cur = line.parent, no = indexOf(cur.lines, line);
  for (var chunk = cur.parent; chunk; cur = chunk, chunk = chunk.parent) {
    for (var i = 0;; ++i) {
      if (chunk.children[i] == cur) { break }
      no += chunk.children[i].chunkSize();
    }
  }
  return no + cur.first
}

// Find the line at the given vertical position, using the height
// information in the document tree.
function lineAtHeight(chunk, h) {
  var n = chunk.first;
  outer: do {
    for (var i$1 = 0; i$1 < chunk.children.length; ++i$1) {
      var child = chunk.children[i$1], ch = child.height;
      if (h < ch) { chunk = child; continue outer }
      h -= ch;
      n += child.chunkSize();
    }
    return n
  } while (!chunk.lines)
  var i = 0;
  for (; i < chunk.lines.length; ++i) {
    var line = chunk.lines[i], lh = line.height;
    if (h < lh) { break }
    h -= lh;
  }
  return n + i
}

function isLine(doc, l) {return l >= doc.first && l < doc.first + doc.size}

function lineNumberFor(options, i) {
  return String(options.lineNumberFormatter(i + options.firstLineNumber))
}

// A Pos instance represents a position within the text.
function Pos(line, ch, sticky) {
  if ( sticky === void 0 ) sticky = null;

  if (!(this instanceof Pos)) { return new Pos(line, ch, sticky) }
  this.line = line;
  this.ch = ch;
  this.sticky = sticky;
}

// Compare two positions, return 0 if they are the same, a negative
// number when a is less, and a positive number otherwise.
function cmp(a, b) { return a.line - b.line || a.ch - b.ch }

function equalCursorPos(a, b) { return a.sticky == b.sticky && cmp(a, b) == 0 }

function copyPos(x) {return Pos(x.line, x.ch)}
function maxPos(a, b) { return cmp(a, b) < 0 ? b : a }
function minPos(a, b) { return cmp(a, b) < 0 ? a : b }

// Most of the external API clips given positions to make sure they
// actually exist within the document.
function clipLine(doc, n) {return Math.max(doc.first, Math.min(n, doc.first + doc.size - 1))}
function clipPos(doc, pos) {
  if (pos.line < doc.first) { return Pos(doc.first, 0) }
  var last = doc.first + doc.size - 1;
  if (pos.line > last) { return Pos(last, getLine(doc, last).text.length) }
  return clipToLen(pos, getLine(doc, pos.line).text.length)
}
function clipToLen(pos, linelen) {
  var ch = pos.ch;
  if (ch == null || ch > linelen) { return Pos(pos.line, linelen) }
  else if (ch < 0) { return Pos(pos.line, 0) }
  else { return pos }
}
function clipPosArray(doc, array) {
  var out = [];
  for (var i = 0; i < array.length; i++) { out[i] = clipPos(doc, array[i]); }
  return out
}

// Optimize some code when these features are not used.
var sawReadOnlySpans = false;
var sawCollapsedSpans = false;

function seeReadOnlySpans() {
  sawReadOnlySpans = true;
}

function seeCollapsedSpans() {
  sawCollapsedSpans = true;
}

// TEXTMARKER SPANS

function MarkedSpan(marker, from, to) {
  this.marker = marker;
  this.from = from; this.to = to;
}

// Search an array of spans for a span matching the given marker.
function getMarkedSpanFor(spans, marker) {
  if (spans) { for (var i = 0; i < spans.length; ++i) {
    var span = spans[i];
    if (span.marker == marker) { return span }
  } }
}
// Remove a span from an array, returning undefined if no spans are
// left (we don't store arrays for lines without spans).
function removeMarkedSpan(spans, span) {
  var r;
  for (var i = 0; i < spans.length; ++i)
    { if (spans[i] != span) { (r || (r = [])).push(spans[i]); } }
  return r
}
// Add a span to a line.
function addMarkedSpan(line, span) {
  line.markedSpans = line.markedSpans ? line.markedSpans.concat([span]) : [span];
  span.marker.attachLine(line);
}

// Used for the algorithm that adjusts markers for a change in the
// document. These functions cut an array of spans at a given
// character position, returning an array of remaining chunks (or
// undefined if nothing remains).
function markedSpansBefore(old, startCh, isInsert) {
  var nw;
  if (old) { for (var i = 0; i < old.length; ++i) {
    var span = old[i], marker = span.marker;
    var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= startCh : span.from < startCh);
    if (startsBefore || span.from == startCh && marker.type == "bookmark" && (!isInsert || !span.marker.insertLeft)) {
      var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= startCh : span.to > startCh);(nw || (nw = [])).push(new MarkedSpan(marker, span.from, endsAfter ? null : span.to));
    }
  } }
  return nw
}
function markedSpansAfter(old, endCh, isInsert) {
  var nw;
  if (old) { for (var i = 0; i < old.length; ++i) {
    var span = old[i], marker = span.marker;
    var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= endCh : span.to > endCh);
    if (endsAfter || span.from == endCh && marker.type == "bookmark" && (!isInsert || span.marker.insertLeft)) {
      var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= endCh : span.from < endCh);(nw || (nw = [])).push(new MarkedSpan(marker, startsBefore ? null : span.from - endCh,
                                            span.to == null ? null : span.to - endCh));
    }
  } }
  return nw
}

// Given a change object, compute the new set of marker spans that
// cover the line in which the change took place. Removes spans
// entirely within the change, reconnects spans belonging to the
// same marker that appear on both sides of the change, and cuts off
// spans partially within the change. Returns an array of span
// arrays with one element for each line in (after) the change.
function stretchSpansOverChange(doc, change) {
  if (change.full) { return null }
  var oldFirst = isLine(doc, change.from.line) && getLine(doc, change.from.line).markedSpans;
  var oldLast = isLine(doc, change.to.line) && getLine(doc, change.to.line).markedSpans;
  if (!oldFirst && !oldLast) { return null }

  var startCh = change.from.ch, endCh = change.to.ch, isInsert = cmp(change.from, change.to) == 0;
  // Get the spans that 'stick out' on both sides
  var first = markedSpansBefore(oldFirst, startCh, isInsert);
  var last = markedSpansAfter(oldLast, endCh, isInsert);

  // Next, merge those two ends
  var sameLine = change.text.length == 1, offset = lst(change.text).length + (sameLine ? startCh : 0);
  if (first) {
    // Fix up .to properties of first
    for (var i = 0; i < first.length; ++i) {
      var span = first[i];
      if (span.to == null) {
        var found = getMarkedSpanFor(last, span.marker);
        if (!found) { span.to = startCh; }
        else if (sameLine) { span.to = found.to == null ? null : found.to + offset; }
      }
    }
  }
  if (last) {
    // Fix up .from in last (or move them into first in case of sameLine)
    for (var i$1 = 0; i$1 < last.length; ++i$1) {
      var span$1 = last[i$1];
      if (span$1.to != null) { span$1.to += offset; }
      if (span$1.from == null) {
        var found$1 = getMarkedSpanFor(first, span$1.marker);
        if (!found$1) {
          span$1.from = offset;
          if (sameLine) { (first || (first = [])).push(span$1); }
        }
      } else {
        span$1.from += offset;
        if (sameLine) { (first || (first = [])).push(span$1); }
      }
    }
  }
  // Make sure we didn't create any zero-length spans
  if (first) { first = clearEmptySpans(first); }
  if (last && last != first) { last = clearEmptySpans(last); }

  var newMarkers = [first];
  if (!sameLine) {
    // Fill gap with whole-line-spans
    var gap = change.text.length - 2, gapMarkers;
    if (gap > 0 && first)
      { for (var i$2 = 0; i$2 < first.length; ++i$2)
        { if (first[i$2].to == null)
          { (gapMarkers || (gapMarkers = [])).push(new MarkedSpan(first[i$2].marker, null, null)); } } }
    for (var i$3 = 0; i$3 < gap; ++i$3)
      { newMarkers.push(gapMarkers); }
    newMarkers.push(last);
  }
  return newMarkers
}

// Remove spans that are empty and don't have a clearWhenEmpty
// option of false.
function clearEmptySpans(spans) {
  for (var i = 0; i < spans.length; ++i) {
    var span = spans[i];
    if (span.from != null && span.from == span.to && span.marker.clearWhenEmpty !== false)
      { spans.splice(i--, 1); }
  }
  if (!spans.length) { return null }
  return spans
}

// Used to 'clip' out readOnly ranges when making a change.
function removeReadOnlyRanges(doc, from, to) {
  var markers = null;
  doc.iter(from.line, to.line + 1, function (line) {
    if (line.markedSpans) { for (var i = 0; i < line.markedSpans.length; ++i) {
      var mark = line.markedSpans[i].marker;
      if (mark.readOnly && (!markers || indexOf(markers, mark) == -1))
        { (markers || (markers = [])).push(mark); }
    } }
  });
  if (!markers) { return null }
  var parts = [{from: from, to: to}];
  for (var i = 0; i < markers.length; ++i) {
    var mk = markers[i], m = mk.find(0);
    for (var j = 0; j < parts.length; ++j) {
      var p = parts[j];
      if (cmp(p.to, m.from) < 0 || cmp(p.from, m.to) > 0) { continue }
      var newParts = [j, 1], dfrom = cmp(p.from, m.from), dto = cmp(p.to, m.to);
      if (dfrom < 0 || !mk.inclusiveLeft && !dfrom)
        { newParts.push({from: p.from, to: m.from}); }
      if (dto > 0 || !mk.inclusiveRight && !dto)
        { newParts.push({from: m.to, to: p.to}); }
      parts.splice.apply(parts, newParts);
      j += newParts.length - 3;
    }
  }
  return parts
}

// Connect or disconnect spans from a line.
function detachMarkedSpans(line) {
  var spans = line.markedSpans;
  if (!spans) { return }
  for (var i = 0; i < spans.length; ++i)
    { spans[i].marker.detachLine(line); }
  line.markedSpans = null;
}
function attachMarkedSpans(line, spans) {
  if (!spans) { return }
  for (var i = 0; i < spans.length; ++i)
    { spans[i].marker.attachLine(line); }
  line.markedSpans = spans;
}

// Helpers used when computing which overlapping collapsed span
// counts as the larger one.
function extraLeft(marker) { return marker.inclusiveLeft ? -1 : 0 }
function extraRight(marker) { return marker.inclusiveRight ? 1 : 0 }

// Returns a number indicating which of two overlapping collapsed
// spans is larger (and thus includes the other). Falls back to
// comparing ids when the spans cover exactly the same range.
function compareCollapsedMarkers(a, b) {
  var lenDiff = a.lines.length - b.lines.length;
  if (lenDiff != 0) { return lenDiff }
  var aPos = a.find(), bPos = b.find();
  var fromCmp = cmp(aPos.from, bPos.from) || extraLeft(a) - extraLeft(b);
  if (fromCmp) { return -fromCmp }
  var toCmp = cmp(aPos.to, bPos.to) || extraRight(a) - extraRight(b);
  if (toCmp) { return toCmp }
  return b.id - a.id
}

// Find out whether a line ends or starts in a collapsed span. If
// so, return the marker for that span.
function collapsedSpanAtSide(line, start) {
  var sps = sawCollapsedSpans && line.markedSpans, found;
  if (sps) { for (var sp = (void 0), i = 0; i < sps.length; ++i) {
    sp = sps[i];
    if (sp.marker.collapsed && (start ? sp.from : sp.to) == null &&
        (!found || compareCollapsedMarkers(found, sp.marker) < 0))
      { found = sp.marker; }
  } }
  return found
}
function collapsedSpanAtStart(line) { return collapsedSpanAtSide(line, true) }
function collapsedSpanAtEnd(line) { return collapsedSpanAtSide(line, false) }

// Test whether there exists a collapsed span that partially
// overlaps (covers the start or end, but not both) of a new span.
// Such overlap is not allowed.
function conflictingCollapsedRange(doc, lineNo$$1, from, to, marker) {
  var line = getLine(doc, lineNo$$1);
  var sps = sawCollapsedSpans && line.markedSpans;
  if (sps) { for (var i = 0; i < sps.length; ++i) {
    var sp = sps[i];
    if (!sp.marker.collapsed) { continue }
    var found = sp.marker.find(0);
    var fromCmp = cmp(found.from, from) || extraLeft(sp.marker) - extraLeft(marker);
    var toCmp = cmp(found.to, to) || extraRight(sp.marker) - extraRight(marker);
    if (fromCmp >= 0 && toCmp <= 0 || fromCmp <= 0 && toCmp >= 0) { continue }
    if (fromCmp <= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.to, from) >= 0 : cmp(found.to, from) > 0) ||
        fromCmp >= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.from, to) <= 0 : cmp(found.from, to) < 0))
      { return true }
  } }
}

// A visual line is a line as drawn on the screen. Folding, for
// example, can cause multiple logical lines to appear on the same
// visual line. This finds the start of the visual line that the
// given line is part of (usually that is the line itself).
function visualLine(line) {
  var merged;
  while (merged = collapsedSpanAtStart(line))
    { line = merged.find(-1, true).line; }
  return line
}

function visualLineEnd(line) {
  var merged;
  while (merged = collapsedSpanAtEnd(line))
    { line = merged.find(1, true).line; }
  return line
}

// Returns an array of logical lines that continue the visual line
// started by the argument, or undefined if there are no such lines.
function visualLineContinued(line) {
  var merged, lines;
  while (merged = collapsedSpanAtEnd(line)) {
    line = merged.find(1, true).line
    ;(lines || (lines = [])).push(line);
  }
  return lines
}

// Get the line number of the start of the visual line that the
// given line number is part of.
function visualLineNo(doc, lineN) {
  var line = getLine(doc, lineN), vis = visualLine(line);
  if (line == vis) { return lineN }
  return lineNo(vis)
}

// Get the line number of the start of the next visual line after
// the given line.
function visualLineEndNo(doc, lineN) {
  if (lineN > doc.lastLine()) { return lineN }
  var line = getLine(doc, lineN), merged;
  if (!lineIsHidden(doc, line)) { return lineN }
  while (merged = collapsedSpanAtEnd(line))
    { line = merged.find(1, true).line; }
  return lineNo(line) + 1
}

// Compute whether a line is hidden. Lines count as hidden when they
// are part of a visual line that starts with another line, or when
// they are entirely covered by collapsed, non-widget span.
function lineIsHidden(doc, line) {
  var sps = sawCollapsedSpans && line.markedSpans;
  if (sps) { for (var sp = (void 0), i = 0; i < sps.length; ++i) {
    sp = sps[i];
    if (!sp.marker.collapsed) { continue }
    if (sp.from == null) { return true }
    if (sp.marker.widgetNode) { continue }
    if (sp.from == 0 && sp.marker.inclusiveLeft && lineIsHiddenInner(doc, line, sp))
      { return true }
  } }
}
function lineIsHiddenInner(doc, line, span) {
  if (span.to == null) {
    var end = span.marker.find(1, true);
    return lineIsHiddenInner(doc, end.line, getMarkedSpanFor(end.line.markedSpans, span.marker))
  }
  if (span.marker.inclusiveRight && span.to == line.text.length)
    { return true }
  for (var sp = (void 0), i = 0; i < line.markedSpans.length; ++i) {
    sp = line.markedSpans[i];
    if (sp.marker.collapsed && !sp.marker.widgetNode && sp.from == span.to &&
        (sp.to == null || sp.to != span.from) &&
        (sp.marker.inclusiveLeft || span.marker.inclusiveRight) &&
        lineIsHiddenInner(doc, line, sp)) { return true }
  }
}

// Find the height above the given line.
function heightAtLine(lineObj) {
  lineObj = visualLine(lineObj);

  var h = 0, chunk = lineObj.parent;
  for (var i = 0; i < chunk.lines.length; ++i) {
    var line = chunk.lines[i];
    if (line == lineObj) { break }
    else { h += line.height; }
  }
  for (var p = chunk.parent; p; chunk = p, p = chunk.parent) {
    for (var i$1 = 0; i$1 < p.children.length; ++i$1) {
      var cur = p.children[i$1];
      if (cur == chunk) { break }
      else { h += cur.height; }
    }
  }
  return h
}

// Compute the character length of a line, taking into account
// collapsed ranges (see markText) that might hide parts, and join
// other lines onto it.
function lineLength(line) {
  if (line.height == 0) { return 0 }
  var len = line.text.length, merged, cur = line;
  while (merged = collapsedSpanAtStart(cur)) {
    var found = merged.find(0, true);
    cur = found.from.line;
    len += found.from.ch - found.to.ch;
  }
  cur = line;
  while (merged = collapsedSpanAtEnd(cur)) {
    var found$1 = merged.find(0, true);
    len -= cur.text.length - found$1.from.ch;
    cur = found$1.to.line;
    len += cur.text.length - found$1.to.ch;
  }
  return len
}

// Find the longest line in the document.
function findMaxLine(cm) {
  var d = cm.display, doc = cm.doc;
  d.maxLine = getLine(doc, doc.first);
  d.maxLineLength = lineLength(d.maxLine);
  d.maxLineChanged = true;
  doc.iter(function (line) {
    var len = lineLength(line);
    if (len > d.maxLineLength) {
      d.maxLineLength = len;
      d.maxLine = line;
    }
  });
}

// BIDI HELPERS

function iterateBidiSections(order, from, to, f) {
  if (!order) { return f(from, to, "ltr") }
  var found = false;
  for (var i = 0; i < order.length; ++i) {
    var part = order[i];
    if (part.from < to && part.to > from || from == to && part.to == from) {
      f(Math.max(part.from, from), Math.min(part.to, to), part.level == 1 ? "rtl" : "ltr");
      found = true;
    }
  }
  if (!found) { f(from, to, "ltr"); }
}

var bidiOther = null;
function getBidiPartAt(order, ch, sticky) {
  var found;
  bidiOther = null;
  for (var i = 0; i < order.length; ++i) {
    var cur = order[i];
    if (cur.from < ch && cur.to > ch) { return i }
    if (cur.to == ch) {
      if (cur.from != cur.to && sticky == "before") { found = i; }
      else { bidiOther = i; }
    }
    if (cur.from == ch) {
      if (cur.from != cur.to && sticky != "before") { found = i; }
      else { bidiOther = i; }
    }
  }
  return found != null ? found : bidiOther
}

// Bidirectional ordering algorithm
// See http://unicode.org/reports/tr9/tr9-13.html for the algorithm
// that this (partially) implements.

// One-char codes used for character types:
// L (L):   Left-to-Right
// R (R):   Right-to-Left
// r (AL):  Right-to-Left Arabic
// 1 (EN):  European Number
// + (ES):  European Number Separator
// % (ET):  European Number Terminator
// n (AN):  Arabic Number
// , (CS):  Common Number Separator
// m (NSM): Non-Spacing Mark
// b (BN):  Boundary Neutral
// s (B):   Paragraph Separator
// t (S):   Segment Separator
// w (WS):  Whitespace
// N (ON):  Other Neutrals

// Returns null if characters are ordered as they appear
// (left-to-right), or an array of sections ({from, to, level}
// objects) in the order in which they occur visually.
var bidiOrdering = (function() {
  // Character types for codepoints 0 to 0xff
  var lowTypes = "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN";
  // Character types for codepoints 0x600 to 0x6f9
  var arabicTypes = "nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111";
  function charType(code) {
    if (code <= 0xf7) { return lowTypes.charAt(code) }
    else if (0x590 <= code && code <= 0x5f4) { return "R" }
    else if (0x600 <= code && code <= 0x6f9) { return arabicTypes.charAt(code - 0x600) }
    else if (0x6ee <= code && code <= 0x8ac) { return "r" }
    else if (0x2000 <= code && code <= 0x200b) { return "w" }
    else if (code == 0x200c) { return "b" }
    else { return "L" }
  }

  var bidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
  var isNeutral = /[stwN]/, isStrong = /[LRr]/, countsAsLeft = /[Lb1n]/, countsAsNum = /[1n]/;

  function BidiSpan(level, from, to) {
    this.level = level;
    this.from = from; this.to = to;
  }

  return function(str, direction) {
    var outerType = direction == "ltr" ? "L" : "R";

    if (str.length == 0 || direction == "ltr" && !bidiRE.test(str)) { return false }
    var len = str.length, types = [];
    for (var i = 0; i < len; ++i)
      { types.push(charType(str.charCodeAt(i))); }

    // W1. Examine each non-spacing mark (NSM) in the level run, and
    // change the type of the NSM to the type of the previous
    // character. If the NSM is at the start of the level run, it will
    // get the type of sor.
    for (var i$1 = 0, prev = outerType; i$1 < len; ++i$1) {
      var type = types[i$1];
      if (type == "m") { types[i$1] = prev; }
      else { prev = type; }
    }

    // W2. Search backwards from each instance of a European number
    // until the first strong type (R, L, AL, or sor) is found. If an
    // AL is found, change the type of the European number to Arabic
    // number.
    // W3. Change all ALs to R.
    for (var i$2 = 0, cur = outerType; i$2 < len; ++i$2) {
      var type$1 = types[i$2];
      if (type$1 == "1" && cur == "r") { types[i$2] = "n"; }
      else if (isStrong.test(type$1)) { cur = type$1; if (type$1 == "r") { types[i$2] = "R"; } }
    }

    // W4. A single European separator between two European numbers
    // changes to a European number. A single common separator between
    // two numbers of the same type changes to that type.
    for (var i$3 = 1, prev$1 = types[0]; i$3 < len - 1; ++i$3) {
      var type$2 = types[i$3];
      if (type$2 == "+" && prev$1 == "1" && types[i$3+1] == "1") { types[i$3] = "1"; }
      else if (type$2 == "," && prev$1 == types[i$3+1] &&
               (prev$1 == "1" || prev$1 == "n")) { types[i$3] = prev$1; }
      prev$1 = type$2;
    }

    // W5. A sequence of European terminators adjacent to European
    // numbers changes to all European numbers.
    // W6. Otherwise, separators and terminators change to Other
    // Neutral.
    for (var i$4 = 0; i$4 < len; ++i$4) {
      var type$3 = types[i$4];
      if (type$3 == ",") { types[i$4] = "N"; }
      else if (type$3 == "%") {
        var end = (void 0);
        for (end = i$4 + 1; end < len && types[end] == "%"; ++end) {}
        var replace = (i$4 && types[i$4-1] == "!") || (end < len && types[end] == "1") ? "1" : "N";
        for (var j = i$4; j < end; ++j) { types[j] = replace; }
        i$4 = end - 1;
      }
    }

    // W7. Search backwards from each instance of a European number
    // until the first strong type (R, L, or sor) is found. If an L is
    // found, then change the type of the European number to L.
    for (var i$5 = 0, cur$1 = outerType; i$5 < len; ++i$5) {
      var type$4 = types[i$5];
      if (cur$1 == "L" && type$4 == "1") { types[i$5] = "L"; }
      else if (isStrong.test(type$4)) { cur$1 = type$4; }
    }

    // N1. A sequence of neutrals takes the direction of the
    // surrounding strong text if the text on both sides has the same
    // direction. European and Arabic numbers act as if they were R in
    // terms of their influence on neutrals. Start-of-level-run (sor)
    // and end-of-level-run (eor) are used at level run boundaries.
    // N2. Any remaining neutrals take the embedding direction.
    for (var i$6 = 0; i$6 < len; ++i$6) {
      if (isNeutral.test(types[i$6])) {
        var end$1 = (void 0);
        for (end$1 = i$6 + 1; end$1 < len && isNeutral.test(types[end$1]); ++end$1) {}
        var before = (i$6 ? types[i$6-1] : outerType) == "L";
        var after = (end$1 < len ? types[end$1] : outerType) == "L";
        var replace$1 = before == after ? (before ? "L" : "R") : outerType;
        for (var j$1 = i$6; j$1 < end$1; ++j$1) { types[j$1] = replace$1; }
        i$6 = end$1 - 1;
      }
    }

    // Here we depart from the documented algorithm, in order to avoid
    // building up an actual levels array. Since there are only three
    // levels (0, 1, 2) in an implementation that doesn't take
    // explicit embedding into account, we can build up the order on
    // the fly, without following the level-based algorithm.
    var order = [], m;
    for (var i$7 = 0; i$7 < len;) {
      if (countsAsLeft.test(types[i$7])) {
        var start = i$7;
        for (++i$7; i$7 < len && countsAsLeft.test(types[i$7]); ++i$7) {}
        order.push(new BidiSpan(0, start, i$7));
      } else {
        var pos = i$7, at = order.length;
        for (++i$7; i$7 < len && types[i$7] != "L"; ++i$7) {}
        for (var j$2 = pos; j$2 < i$7;) {
          if (countsAsNum.test(types[j$2])) {
            if (pos < j$2) { order.splice(at, 0, new BidiSpan(1, pos, j$2)); }
            var nstart = j$2;
            for (++j$2; j$2 < i$7 && countsAsNum.test(types[j$2]); ++j$2) {}
            order.splice(at, 0, new BidiSpan(2, nstart, j$2));
            pos = j$2;
          } else { ++j$2; }
        }
        if (pos < i$7) { order.splice(at, 0, new BidiSpan(1, pos, i$7)); }
      }
    }
    if (order[0].level == 1 && (m = str.match(/^\s+/))) {
      order[0].from = m[0].length;
      order.unshift(new BidiSpan(0, 0, m[0].length));
    }
    if (lst(order).level == 1 && (m = str.match(/\s+$/))) {
      lst(order).to -= m[0].length;
      order.push(new BidiSpan(0, len - m[0].length, len));
    }

    return direction == "rtl" ? order.reverse() : order
  }
})();

// Get the bidi ordering for the given line (and cache it). Returns
// false for lines that are fully left-to-right, and an array of
// BidiSpan objects otherwise.
function getOrder(line, direction) {
  var order = line.order;
  if (order == null) { order = line.order = bidiOrdering(line.text, direction); }
  return order
}

function moveCharLogically(line, ch, dir) {
  var target = skipExtendingChars(line.text, ch + dir, dir);
  return target < 0 || target > line.text.length ? null : target
}

function moveLogically(line, start, dir) {
  var ch = moveCharLogically(line, start.ch, dir);
  return ch == null ? null : new Pos(start.line, ch, dir < 0 ? "after" : "before")
}

function endOfLine(visually, cm, lineObj, lineNo, dir) {
  if (visually) {
    var order = getOrder(lineObj, cm.doc.direction);
    if (order) {
      var part = dir < 0 ? lst(order) : order[0];
      var moveInStorageOrder = (dir < 0) == (part.level == 1);
      var sticky = moveInStorageOrder ? "after" : "before";
      var ch;
      // With a wrapped rtl chunk (possibly spanning multiple bidi parts),
      // it could be that the last bidi part is not on the last visual line,
      // since visual lines contain content order-consecutive chunks.
      // Thus, in rtl, we are looking for the first (content-order) character
      // in the rtl chunk that is on the last line (that is, the same line
      // as the last (content-order) character).
      if (part.level > 0) {
        var prep = prepareMeasureForLine(cm, lineObj);
        ch = dir < 0 ? lineObj.text.length - 1 : 0;
        var targetTop = measureCharPrepared(cm, prep, ch).top;
        ch = findFirst(function (ch) { return measureCharPrepared(cm, prep, ch).top == targetTop; }, (dir < 0) == (part.level == 1) ? part.from : part.to - 1, ch);
        if (sticky == "before") { ch = moveCharLogically(lineObj, ch, 1); }
      } else { ch = dir < 0 ? part.to : part.from; }
      return new Pos(lineNo, ch, sticky)
    }
  }
  return new Pos(lineNo, dir < 0 ? lineObj.text.length : 0, dir < 0 ? "before" : "after")
}

function moveVisually(cm, line, start, dir) {
  var bidi = getOrder(line, cm.doc.direction);
  if (!bidi) { return moveLogically(line, start, dir) }
  if (start.ch >= line.text.length) {
    start.ch = line.text.length;
    start.sticky = "before";
  } else if (start.ch <= 0) {
    start.ch = 0;
    start.sticky = "after";
  }
  var partPos = getBidiPartAt(bidi, start.ch, start.sticky), part = bidi[partPos];
  if (cm.doc.direction == "ltr" && part.level % 2 == 0 && (dir > 0 ? part.to > start.ch : part.from < start.ch)) {
    // Case 1: We move within an ltr part in an ltr editor. Even with wrapped lines,
    // nothing interesting happens.
    return moveLogically(line, start, dir)
  }

  var mv = function (pos, dir) { return moveCharLogically(line, pos instanceof Pos ? pos.ch : pos, dir); };
  var prep;
  var getWrappedLineExtent = function (ch) {
    if (!cm.options.lineWrapping) { return {begin: 0, end: line.text.length} }
    prep = prep || prepareMeasureForLine(cm, line);
    return wrappedLineExtentChar(cm, line, prep, ch)
  };
  var wrappedLineExtent = getWrappedLineExtent(start.sticky == "before" ? mv(start, -1) : start.ch);

  if (cm.doc.direction == "rtl" || part.level == 1) {
    var moveInStorageOrder = (part.level == 1) == (dir < 0);
    var ch = mv(start, moveInStorageOrder ? 1 : -1);
    if (ch != null && (!moveInStorageOrder ? ch >= part.from && ch >= wrappedLineExtent.begin : ch <= part.to && ch <= wrappedLineExtent.end)) {
      // Case 2: We move within an rtl part or in an rtl editor on the same visual line
      var sticky = moveInStorageOrder ? "before" : "after";
      return new Pos(start.line, ch, sticky)
    }
  }

  // Case 3: Could not move within this bidi part in this visual line, so leave
  // the current bidi part

  var searchInVisualLine = function (partPos, dir, wrappedLineExtent) {
    var getRes = function (ch, moveInStorageOrder) { return moveInStorageOrder
      ? new Pos(start.line, mv(ch, 1), "before")
      : new Pos(start.line, ch, "after"); };

    for (; partPos >= 0 && partPos < bidi.length; partPos += dir) {
      var part = bidi[partPos];
      var moveInStorageOrder = (dir > 0) == (part.level != 1);
      var ch = moveInStorageOrder ? wrappedLineExtent.begin : mv(wrappedLineExtent.end, -1);
      if (part.from <= ch && ch < part.to) { return getRes(ch, moveInStorageOrder) }
      ch = moveInStorageOrder ? part.from : mv(part.to, -1);
      if (wrappedLineExtent.begin <= ch && ch < wrappedLineExtent.end) { return getRes(ch, moveInStorageOrder) }
    }
  };

  // Case 3a: Look for other bidi parts on the same visual line
  var res = searchInVisualLine(partPos + dir, dir, wrappedLineExtent);
  if (res) { return res }

  // Case 3b: Look for other bidi parts on the next visual line
  var nextCh = dir > 0 ? wrappedLineExtent.end : mv(wrappedLineExtent.begin, -1);
  if (nextCh != null && !(dir > 0 && nextCh == line.text.length)) {
    res = searchInVisualLine(dir > 0 ? 0 : bidi.length - 1, dir, getWrappedLineExtent(nextCh));
    if (res) { return res }
  }

  // Case 4: Nowhere to move
  return null
}

// EVENT HANDLING

// Lightweight event framework. on/off also work on DOM nodes,
// registering native DOM handlers.

var noHandlers = [];

var on = function(emitter, type, f) {
  if (emitter.addEventListener) {
    emitter.addEventListener(type, f, false);
  } else if (emitter.attachEvent) {
    emitter.attachEvent("on" + type, f);
  } else {
    var map$$1 = emitter._handlers || (emitter._handlers = {});
    map$$1[type] = (map$$1[type] || noHandlers).concat(f);
  }
};

function getHandlers(emitter, type) {
  return emitter._handlers && emitter._handlers[type] || noHandlers
}

function off(emitter, type, f) {
  if (emitter.removeEventListener) {
    emitter.removeEventListener(type, f, false);
  } else if (emitter.detachEvent) {
    emitter.detachEvent("on" + type, f);
  } else {
    var map$$1 = emitter._handlers, arr = map$$1 && map$$1[type];
    if (arr) {
      var index = indexOf(arr, f);
      if (index > -1)
        { map$$1[type] = arr.slice(0, index).concat(arr.slice(index + 1)); }
    }
  }
}

function signal(emitter, type /*, values...*/) {
  var handlers = getHandlers(emitter, type);
  if (!handlers.length) { return }
  var args = Array.prototype.slice.call(arguments, 2);
  for (var i = 0; i < handlers.length; ++i) { handlers[i].apply(null, args); }
}

// The DOM events that CodeMirror handles can be overridden by
// registering a (non-DOM) handler on the editor for the event name,
// and preventDefault-ing the event in that handler.
function signalDOMEvent(cm, e, override) {
  if (typeof e == "string")
    { e = {type: e, preventDefault: function() { this.defaultPrevented = true; }}; }
  signal(cm, override || e.type, cm, e);
  return e_defaultPrevented(e) || e.codemirrorIgnore
}

function signalCursorActivity(cm) {
  var arr = cm._handlers && cm._handlers.cursorActivity;
  if (!arr) { return }
  var set = cm.curOp.cursorActivityHandlers || (cm.curOp.cursorActivityHandlers = []);
  for (var i = 0; i < arr.length; ++i) { if (indexOf(set, arr[i]) == -1)
    { set.push(arr[i]); } }
}

function hasHandler(emitter, type) {
  return getHandlers(emitter, type).length > 0
}

// Add on and off methods to a constructor's prototype, to make
// registering events on such objects more convenient.
function eventMixin(ctor) {
  ctor.prototype.on = function(type, f) {on(this, type, f);};
  ctor.prototype.off = function(type, f) {off(this, type, f);};
}

// Due to the fact that we still support jurassic IE versions, some
// compatibility wrappers are needed.

function e_preventDefault(e) {
  if (e.preventDefault) { e.preventDefault(); }
  else { e.returnValue = false; }
}
function e_stopPropagation(e) {
  if (e.stopPropagation) { e.stopPropagation(); }
  else { e.cancelBubble = true; }
}
function e_defaultPrevented(e) {
  return e.defaultPrevented != null ? e.defaultPrevented : e.returnValue == false
}
function e_stop(e) {e_preventDefault(e); e_stopPropagation(e);}

function e_target(e) {return e.target || e.srcElement}
function e_button(e) {
  var b = e.which;
  if (b == null) {
    if (e.button & 1) { b = 1; }
    else if (e.button & 2) { b = 3; }
    else if (e.button & 4) { b = 2; }
  }
  if (mac && e.ctrlKey && b == 1) { b = 3; }
  return b
}

// Detect drag-and-drop
var dragAndDrop = function() {
  // There is *some* kind of drag-and-drop support in IE6-8, but I
  // couldn't get it to work yet.
  if (ie && ie_version < 9) { return false }
  var div = elt('div');
  return "draggable" in div || "dragDrop" in div
}();

var zwspSupported;
function zeroWidthElement(measure) {
  if (zwspSupported == null) {
    var test = elt("span", "\u200b");
    removeChildrenAndAdd(measure, elt("span", [test, document.createTextNode("x")]));
    if (measure.firstChild.offsetHeight != 0)
      { zwspSupported = test.offsetWidth <= 1 && test.offsetHeight > 2 && !(ie && ie_version < 8); }
  }
  var node = zwspSupported ? elt("span", "\u200b") :
    elt("span", "\u00a0", null, "display: inline-block; width: 1px; margin-right: -1px");
  node.setAttribute("cm-text", "");
  return node
}

// Feature-detect IE's crummy client rect reporting for bidi text
var badBidiRects;
function hasBadBidiRects(measure) {
  if (badBidiRects != null) { return badBidiRects }
  var txt = removeChildrenAndAdd(measure, document.createTextNode("A\u062eA"));
  var r0 = range(txt, 0, 1).getBoundingClientRect();
  var r1 = range(txt, 1, 2).getBoundingClientRect();
  removeChildren(measure);
  if (!r0 || r0.left == r0.right) { return false } // Safari returns null in some cases (#2780)
  return badBidiRects = (r1.right - r0.right < 3)
}

// See if "".split is the broken IE version, if so, provide an
// alternative way to split lines.
var splitLinesAuto = "\n\nb".split(/\n/).length != 3 ? function (string) {
  var pos = 0, result = [], l = string.length;
  while (pos <= l) {
    var nl = string.indexOf("\n", pos);
    if (nl == -1) { nl = string.length; }
    var line = string.slice(pos, string.charAt(nl - 1) == "\r" ? nl - 1 : nl);
    var rt = line.indexOf("\r");
    if (rt != -1) {
      result.push(line.slice(0, rt));
      pos += rt + 1;
    } else {
      result.push(line);
      pos = nl + 1;
    }
  }
  return result
} : function (string) { return string.split(/\r\n?|\n/); };

var hasSelection = window.getSelection ? function (te) {
  try { return te.selectionStart != te.selectionEnd }
  catch(e) { return false }
} : function (te) {
  var range$$1;
  try {range$$1 = te.ownerDocument.selection.createRange();}
  catch(e) {}
  if (!range$$1 || range$$1.parentElement() != te) { return false }
  return range$$1.compareEndPoints("StartToEnd", range$$1) != 0
};

var hasCopyEvent = (function () {
  var e = elt("div");
  if ("oncopy" in e) { return true }
  e.setAttribute("oncopy", "return;");
  return typeof e.oncopy == "function"
})();

var badZoomedRects = null;
function hasBadZoomedRects(measure) {
  if (badZoomedRects != null) { return badZoomedRects }
  var node = removeChildrenAndAdd(measure, elt("span", "x"));
  var normal = node.getBoundingClientRect();
  var fromRange = range(node, 0, 1).getBoundingClientRect();
  return badZoomedRects = Math.abs(normal.left - fromRange.left) > 1
}

// Known modes, by name and by MIME
var modes = {};
var mimeModes = {};

// Extra arguments are stored as the mode's dependencies, which is
// used by (legacy) mechanisms like loadmode.js to automatically
// load a mode. (Preferred mechanism is the require/define calls.)
function defineMode(name, mode) {
  if (arguments.length > 2)
    { mode.dependencies = Array.prototype.slice.call(arguments, 2); }
  modes[name] = mode;
}

function defineMIME(mime, spec) {
  mimeModes[mime] = spec;
}

// Given a MIME type, a {name, ...options} config object, or a name
// string, return a mode config object.
function resolveMode(spec) {
  if (typeof spec == "string" && mimeModes.hasOwnProperty(spec)) {
    spec = mimeModes[spec];
  } else if (spec && typeof spec.name == "string" && mimeModes.hasOwnProperty(spec.name)) {
    var found = mimeModes[spec.name];
    if (typeof found == "string") { found = {name: found}; }
    spec = createObj(found, spec);
    spec.name = found.name;
  } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+xml$/.test(spec)) {
    return resolveMode("application/xml")
  } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+json$/.test(spec)) {
    return resolveMode("application/json")
  }
  if (typeof spec == "string") { return {name: spec} }
  else { return spec || {name: "null"} }
}

// Given a mode spec (anything that resolveMode accepts), find and
// initialize an actual mode object.
function getMode(options, spec) {
  spec = resolveMode(spec);
  var mfactory = modes[spec.name];
  if (!mfactory) { return getMode(options, "text/plain") }
  var modeObj = mfactory(options, spec);
  if (modeExtensions.hasOwnProperty(spec.name)) {
    var exts = modeExtensions[spec.name];
    for (var prop in exts) {
      if (!exts.hasOwnProperty(prop)) { continue }
      if (modeObj.hasOwnProperty(prop)) { modeObj["_" + prop] = modeObj[prop]; }
      modeObj[prop] = exts[prop];
    }
  }
  modeObj.name = spec.name;
  if (spec.helperType) { modeObj.helperType = spec.helperType; }
  if (spec.modeProps) { for (var prop$1 in spec.modeProps)
    { modeObj[prop$1] = spec.modeProps[prop$1]; } }

  return modeObj
}

// This can be used to attach properties to mode objects from
// outside the actual mode definition.
var modeExtensions = {};
function extendMode(mode, properties) {
  var exts = modeExtensions.hasOwnProperty(mode) ? modeExtensions[mode] : (modeExtensions[mode] = {});
  copyObj(properties, exts);
}

function copyState(mode, state) {
  if (state === true) { return state }
  if (mode.copyState) { return mode.copyState(state) }
  var nstate = {};
  for (var n in state) {
    var val = state[n];
    if (val instanceof Array) { val = val.concat([]); }
    nstate[n] = val;
  }
  return nstate
}

// Given a mode and a state (for that mode), find the inner mode and
// state at the position that the state refers to.
function innerMode(mode, state) {
  var info;
  while (mode.innerMode) {
    info = mode.innerMode(state);
    if (!info || info.mode == mode) { break }
    state = info.state;
    mode = info.mode;
  }
  return info || {mode: mode, state: state}
}

function startState(mode, a1, a2) {
  return mode.startState ? mode.startState(a1, a2) : true
}

// STRING STREAM

// Fed to the mode parsers, provides helper functions to make
// parsers more succinct.

var StringStream = function(string, tabSize, lineOracle) {
  this.pos = this.start = 0;
  this.string = string;
  this.tabSize = tabSize || 8;
  this.lastColumnPos = this.lastColumnValue = 0;
  this.lineStart = 0;
  this.lineOracle = lineOracle;
};

StringStream.prototype.eol = function () {return this.pos >= this.string.length};
StringStream.prototype.sol = function () {return this.pos == this.lineStart};
StringStream.prototype.peek = function () {return this.string.charAt(this.pos) || undefined};
StringStream.prototype.next = function () {
  if (this.pos < this.string.length)
    { return this.string.charAt(this.pos++) }
};
StringStream.prototype.eat = function (match) {
  var ch = this.string.charAt(this.pos);
  var ok;
  if (typeof match == "string") { ok = ch == match; }
  else { ok = ch && (match.test ? match.test(ch) : match(ch)); }
  if (ok) {++this.pos; return ch}
};
StringStream.prototype.eatWhile = function (match) {
  var start = this.pos;
  while (this.eat(match)){}
  return this.pos > start
};
StringStream.prototype.eatSpace = function () {
    var this$1 = this;

  var start = this.pos;
  while (/[\s\u00a0]/.test(this.string.charAt(this.pos))) { ++this$1.pos; }
  return this.pos > start
};
StringStream.prototype.skipToEnd = function () {this.pos = this.string.length;};
StringStream.prototype.skipTo = function (ch) {
  var found = this.string.indexOf(ch, this.pos);
  if (found > -1) {this.pos = found; return true}
};
StringStream.prototype.backUp = function (n) {this.pos -= n;};
StringStream.prototype.column = function () {
  if (this.lastColumnPos < this.start) {
    this.lastColumnValue = countColumn(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
    this.lastColumnPos = this.start;
  }
  return this.lastColumnValue - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0)
};
StringStream.prototype.indentation = function () {
  return countColumn(this.string, null, this.tabSize) -
    (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0)
};
StringStream.prototype.match = function (pattern, consume, caseInsensitive) {
  if (typeof pattern == "string") {
    var cased = function (str) { return caseInsensitive ? str.toLowerCase() : str; };
    var substr = this.string.substr(this.pos, pattern.length);
    if (cased(substr) == cased(pattern)) {
      if (consume !== false) { this.pos += pattern.length; }
      return true
    }
  } else {
    var match = this.string.slice(this.pos).match(pattern);
    if (match && match.index > 0) { return null }
    if (match && consume !== false) { this.pos += match[0].length; }
    return match
  }
};
StringStream.prototype.current = function (){return this.string.slice(this.start, this.pos)};
StringStream.prototype.hideFirstChars = function (n, inner) {
  this.lineStart += n;
  try { return inner() }
  finally { this.lineStart -= n; }
};
StringStream.prototype.lookAhead = function (n) {
  var oracle = this.lineOracle;
  return oracle && oracle.lookAhead(n)
};

var SavedContext = function(state, lookAhead) {
  this.state = state;
  this.lookAhead = lookAhead;
};

var Context = function(doc, state, line, lookAhead) {
  this.state = state;
  this.doc = doc;
  this.line = line;
  this.maxLookAhead = lookAhead || 0;
};

Context.prototype.lookAhead = function (n) {
  var line = this.doc.getLine(this.line + n);
  if (line != null && n > this.maxLookAhead) { this.maxLookAhead = n; }
  return line
};

Context.prototype.nextLine = function () {
  this.line++;
  if (this.maxLookAhead > 0) { this.maxLookAhead--; }
};

Context.fromSaved = function (doc, saved, line) {
  if (saved instanceof SavedContext)
    { return new Context(doc, copyState(doc.mode, saved.state), line, saved.lookAhead) }
  else
    { return new Context(doc, copyState(doc.mode, saved), line) }
};

Context.prototype.save = function (copy) {
  var state = copy !== false ? copyState(this.doc.mode, this.state) : this.state;
  return this.maxLookAhead > 0 ? new SavedContext(state, this.maxLookAhead) : state
};


// Compute a style array (an array starting with a mode generation
// -- for invalidation -- followed by pairs of end positions and
// style strings), which is used to highlight the tokens on the
// line.
function highlightLine(cm, line, context, forceToEnd) {
  // A styles array always starts with a number identifying the
  // mode/overlays that it is based on (for easy invalidation).
  var st = [cm.state.modeGen], lineClasses = {};
  // Compute the base array of styles
  runMode(cm, line.text, cm.doc.mode, context, function (end, style) { return st.push(end, style); },
          lineClasses, forceToEnd);
  var state = context.state;

  // Run overlays, adjust style array.
  var loop = function ( o ) {
    var overlay = cm.state.overlays[o], i = 1, at = 0;
    context.state = true;
    runMode(cm, line.text, overlay.mode, context, function (end, style) {
      var start = i;
      // Ensure there's a token end at the current position, and that i points at it
      while (at < end) {
        var i_end = st[i];
        if (i_end > end)
          { st.splice(i, 1, end, st[i+1], i_end); }
        i += 2;
        at = Math.min(end, i_end);
      }
      if (!style) { return }
      if (overlay.opaque) {
        st.splice(start, i - start, end, "overlay " + style);
        i = start + 2;
      } else {
        for (; start < i; start += 2) {
          var cur = st[start+1];
          st[start+1] = (cur ? cur + " " : "") + "overlay " + style;
        }
      }
    }, lineClasses);
  };

  for (var o = 0; o < cm.state.overlays.length; ++o) loop( o );
  context.state = state;

  return {styles: st, classes: lineClasses.bgClass || lineClasses.textClass ? lineClasses : null}
}

function getLineStyles(cm, line, updateFrontier) {
  if (!line.styles || line.styles[0] != cm.state.modeGen) {
    var context = getContextBefore(cm, lineNo(line));
    var resetState = line.text.length > cm.options.maxHighlightLength && copyState(cm.doc.mode, context.state);
    var result = highlightLine(cm, line, context);
    if (resetState) { context.state = resetState; }
    line.stateAfter = context.save(!resetState);
    line.styles = result.styles;
    if (result.classes) { line.styleClasses = result.classes; }
    else if (line.styleClasses) { line.styleClasses = null; }
    if (updateFrontier === cm.doc.highlightFrontier)
      { cm.doc.modeFrontier = Math.max(cm.doc.modeFrontier, ++cm.doc.highlightFrontier); }
  }
  return line.styles
}

function getContextBefore(cm, n, precise) {
  var doc = cm.doc, display = cm.display;
  if (!doc.mode.startState) { return new Context(doc, true, n) }
  var start = findStartLine(cm, n, precise);
  var saved = start > doc.first && getLine(doc, start - 1).stateAfter;
  var context = saved ? Context.fromSaved(doc, saved, start) : new Context(doc, startState(doc.mode), start);

  doc.iter(start, n, function (line) {
    processLine(cm, line.text, context);
    var pos = context.line;
    line.stateAfter = pos == n - 1 || pos % 5 == 0 || pos >= display.viewFrom && pos < display.viewTo ? context.save() : null;
    context.nextLine();
  });
  if (precise) { doc.modeFrontier = context.line; }
  return context
}

// Lightweight form of highlight -- proceed over this line and
// update state, but don't save a style array. Used for lines that
// aren't currently visible.
function processLine(cm, text, context, startAt) {
  var mode = cm.doc.mode;
  var stream = new StringStream(text, cm.options.tabSize, context);
  stream.start = stream.pos = startAt || 0;
  if (text == "") { callBlankLine(mode, context.state); }
  while (!stream.eol()) {
    readToken(mode, stream, context.state);
    stream.start = stream.pos;
  }
}

function callBlankLine(mode, state) {
  if (mode.blankLine) { return mode.blankLine(state) }
  if (!mode.innerMode) { return }
  var inner = innerMode(mode, state);
  if (inner.mode.blankLine) { return inner.mode.blankLine(inner.state) }
}

function readToken(mode, stream, state, inner) {
  for (var i = 0; i < 10; i++) {
    if (inner) { inner[0] = innerMode(mode, state).mode; }
    var style = mode.token(stream, state);
    if (stream.pos > stream.start) { return style }
  }
  throw new Error("Mode " + mode.name + " failed to advance stream.")
}

var Token = function(stream, type, state) {
  this.start = stream.start; this.end = stream.pos;
  this.string = stream.current();
  this.type = type || null;
  this.state = state;
};

// Utility for getTokenAt and getLineTokens
function takeToken(cm, pos, precise, asArray) {
  var doc = cm.doc, mode = doc.mode, style;
  pos = clipPos(doc, pos);
  var line = getLine(doc, pos.line), context = getContextBefore(cm, pos.line, precise);
  var stream = new StringStream(line.text, cm.options.tabSize, context), tokens;
  if (asArray) { tokens = []; }
  while ((asArray || stream.pos < pos.ch) && !stream.eol()) {
    stream.start = stream.pos;
    style = readToken(mode, stream, context.state);
    if (asArray) { tokens.push(new Token(stream, style, copyState(doc.mode, context.state))); }
  }
  return asArray ? tokens : new Token(stream, style, context.state)
}

function extractLineClasses(type, output) {
  if (type) { for (;;) {
    var lineClass = type.match(/(?:^|\s+)line-(background-)?(\S+)/);
    if (!lineClass) { break }
    type = type.slice(0, lineClass.index) + type.slice(lineClass.index + lineClass[0].length);
    var prop = lineClass[1] ? "bgClass" : "textClass";
    if (output[prop] == null)
      { output[prop] = lineClass[2]; }
    else if (!(new RegExp("(?:^|\s)" + lineClass[2] + "(?:$|\s)")).test(output[prop]))
      { output[prop] += " " + lineClass[2]; }
  } }
  return type
}

// Run the given mode's parser over a line, calling f for each token.
function runMode(cm, text, mode, context, f, lineClasses, forceToEnd) {
  var flattenSpans = mode.flattenSpans;
  if (flattenSpans == null) { flattenSpans = cm.options.flattenSpans; }
  var curStart = 0, curStyle = null;
  var stream = new StringStream(text, cm.options.tabSize, context), style;
  var inner = cm.options.addModeClass && [null];
  if (text == "") { extractLineClasses(callBlankLine(mode, context.state), lineClasses); }
  while (!stream.eol()) {
    if (stream.pos > cm.options.maxHighlightLength) {
      flattenSpans = false;
      if (forceToEnd) { processLine(cm, text, context, stream.pos); }
      stream.pos = text.length;
      style = null;
    } else {
      style = extractLineClasses(readToken(mode, stream, context.state, inner), lineClasses);
    }
    if (inner) {
      var mName = inner[0].name;
      if (mName) { style = "m-" + (style ? mName + " " + style : mName); }
    }
    if (!flattenSpans || curStyle != style) {
      while (curStart < stream.start) {
        curStart = Math.min(stream.start, curStart + 5000);
        f(curStart, curStyle);
      }
      curStyle = style;
    }
    stream.start = stream.pos;
  }
  while (curStart < stream.pos) {
    // Webkit seems to refuse to render text nodes longer than 57444
    // characters, and returns inaccurate measurements in nodes
    // starting around 5000 chars.
    var pos = Math.min(stream.pos, curStart + 5000);
    f(pos, curStyle);
    curStart = pos;
  }
}

// Finds the line to start with when starting a parse. Tries to
// find a line with a stateAfter, so that it can start with a
// valid state. If that fails, it returns the line with the
// smallest indentation, which tends to need the least context to
// parse correctly.
function findStartLine(cm, n, precise) {
  var minindent, minline, doc = cm.doc;
  var lim = precise ? -1 : n - (cm.doc.mode.innerMode ? 1000 : 100);
  for (var search = n; search > lim; --search) {
    if (search <= doc.first) { return doc.first }
    var line = getLine(doc, search - 1), after = line.stateAfter;
    if (after && (!precise || search + (after instanceof SavedContext ? after.lookAhead : 0) <= doc.modeFrontier))
      { return search }
    var indented = countColumn(line.text, null, cm.options.tabSize);
    if (minline == null || minindent > indented) {
      minline = search - 1;
      minindent = indented;
    }
  }
  return minline
}

function retreatFrontier(doc, n) {
  doc.modeFrontier = Math.min(doc.modeFrontier, n);
  if (doc.highlightFrontier < n - 10) { return }
  var start = doc.first;
  for (var line = n - 1; line > start; line--) {
    var saved = getLine(doc, line).stateAfter;
    // change is on 3
    // state on line 1 looked ahead 2 -- so saw 3
    // test 1 + 2 < 3 should cover this
    if (saved && (!(saved instanceof SavedContext) || line + saved.lookAhead < n)) {
      start = line + 1;
      break
    }
  }
  doc.highlightFrontier = Math.min(doc.highlightFrontier, start);
}

// LINE DATA STRUCTURE

// Line objects. These hold state related to a line, including
// highlighting info (the styles array).
var Line = function(text, markedSpans, estimateHeight) {
  this.text = text;
  attachMarkedSpans(this, markedSpans);
  this.height = estimateHeight ? estimateHeight(this) : 1;
};

Line.prototype.lineNo = function () { return lineNo(this) };
eventMixin(Line);

// Change the content (text, markers) of a line. Automatically
// invalidates cached information and tries to re-estimate the
// line's height.
function updateLine(line, text, markedSpans, estimateHeight) {
  line.text = text;
  if (line.stateAfter) { line.stateAfter = null; }
  if (line.styles) { line.styles = null; }
  if (line.order != null) { line.order = null; }
  detachMarkedSpans(line);
  attachMarkedSpans(line, markedSpans);
  var estHeight = estimateHeight ? estimateHeight(line) : 1;
  if (estHeight != line.height) { updateLineHeight(line, estHeight); }
}

// Detach a line from the document tree and its markers.
function cleanUpLine(line) {
  line.parent = null;
  detachMarkedSpans(line);
}

// Convert a style as returned by a mode (either null, or a string
// containing one or more styles) to a CSS style. This is cached,
// and also looks for line-wide styles.
var styleToClassCache = {};
var styleToClassCacheWithMode = {};
function interpretTokenStyle(style, options) {
  if (!style || /^\s*$/.test(style)) { return null }
  var cache = options.addModeClass ? styleToClassCacheWithMode : styleToClassCache;
  return cache[style] ||
    (cache[style] = style.replace(/\S+/g, "cm-$&"))
}

// Render the DOM representation of the text of a line. Also builds
// up a 'line map', which points at the DOM nodes that represent
// specific stretches of text, and is used by the measuring code.
// The returned object contains the DOM node, this map, and
// information about line-wide styles that were set by the mode.
function buildLineContent(cm, lineView) {
  // The padding-right forces the element to have a 'border', which
  // is needed on Webkit to be able to get line-level bounding
  // rectangles for it (in measureChar).
  var content = eltP("span", null, null, webkit ? "padding-right: .1px" : null);
  var builder = {pre: eltP("pre", [content], "CodeMirror-line"), content: content,
                 col: 0, pos: 0, cm: cm,
                 trailingSpace: false,
                 splitSpaces: (ie || webkit) && cm.getOption("lineWrapping")};
  lineView.measure = {};

  // Iterate over the logical lines that make up this visual line.
  for (var i = 0; i <= (lineView.rest ? lineView.rest.length : 0); i++) {
    var line = i ? lineView.rest[i - 1] : lineView.line, order = (void 0);
    builder.pos = 0;
    builder.addToken = buildToken;
    // Optionally wire in some hacks into the token-rendering
    // algorithm, to deal with browser quirks.
    if (hasBadBidiRects(cm.display.measure) && (order = getOrder(line, cm.doc.direction)))
      { builder.addToken = buildTokenBadBidi(builder.addToken, order); }
    builder.map = [];
    var allowFrontierUpdate = lineView != cm.display.externalMeasured && lineNo(line);
    insertLineContent(line, builder, getLineStyles(cm, line, allowFrontierUpdate));
    if (line.styleClasses) {
      if (line.styleClasses.bgClass)
        { builder.bgClass = joinClasses(line.styleClasses.bgClass, builder.bgClass || ""); }
      if (line.styleClasses.textClass)
        { builder.textClass = joinClasses(line.styleClasses.textClass, builder.textClass || ""); }
    }

    // Ensure at least a single node is present, for measuring.
    if (builder.map.length == 0)
      { builder.map.push(0, 0, builder.content.appendChild(zeroWidthElement(cm.display.measure))); }

    // Store the map and a cache object for the current logical line
    if (i == 0) {
      lineView.measure.map = builder.map;
      lineView.measure.cache = {};
    } else {
      (lineView.measure.maps || (lineView.measure.maps = [])).push(builder.map)
      ;(lineView.measure.caches || (lineView.measure.caches = [])).push({});
    }
  }

  // See issue #2901
  if (webkit) {
    var last = builder.content.lastChild;
    if (/\bcm-tab\b/.test(last.className) || (last.querySelector && last.querySelector(".cm-tab")))
      { builder.content.className = "cm-tab-wrap-hack"; }
  }

  signal(cm, "renderLine", cm, lineView.line, builder.pre);
  if (builder.pre.className)
    { builder.textClass = joinClasses(builder.pre.className, builder.textClass || ""); }

  return builder
}

function defaultSpecialCharPlaceholder(ch) {
  var token = elt("span", "\u2022", "cm-invalidchar");
  token.title = "\\u" + ch.charCodeAt(0).toString(16);
  token.setAttribute("aria-label", token.title);
  return token
}

// Build up the DOM representation for a single token, and add it to
// the line map. Takes care to render special characters separately.
function buildToken(builder, text, style, startStyle, endStyle, title, css) {
  if (!text) { return }
  var displayText = builder.splitSpaces ? splitSpaces(text, builder.trailingSpace) : text;
  var special = builder.cm.state.specialChars, mustWrap = false;
  var content;
  if (!special.test(text)) {
    builder.col += text.length;
    content = document.createTextNode(displayText);
    builder.map.push(builder.pos, builder.pos + text.length, content);
    if (ie && ie_version < 9) { mustWrap = true; }
    builder.pos += text.length;
  } else {
    content = document.createDocumentFragment();
    var pos = 0;
    while (true) {
      special.lastIndex = pos;
      var m = special.exec(text);
      var skipped = m ? m.index - pos : text.length - pos;
      if (skipped) {
        var txt = document.createTextNode(displayText.slice(pos, pos + skipped));
        if (ie && ie_version < 9) { content.appendChild(elt("span", [txt])); }
        else { content.appendChild(txt); }
        builder.map.push(builder.pos, builder.pos + skipped, txt);
        builder.col += skipped;
        builder.pos += skipped;
      }
      if (!m) { break }
      pos += skipped + 1;
      var txt$1 = (void 0);
      if (m[0] == "\t") {
        var tabSize = builder.cm.options.tabSize, tabWidth = tabSize - builder.col % tabSize;
        txt$1 = content.appendChild(elt("span", spaceStr(tabWidth), "cm-tab"));
        txt$1.setAttribute("role", "presentation");
        txt$1.setAttribute("cm-text", "\t");
        builder.col += tabWidth;
      } else if (m[0] == "\r" || m[0] == "\n") {
        txt$1 = content.appendChild(elt("span", m[0] == "\r" ? "\u240d" : "\u2424", "cm-invalidchar"));
        txt$1.setAttribute("cm-text", m[0]);
        builder.col += 1;
      } else {
        txt$1 = builder.cm.options.specialCharPlaceholder(m[0]);
        txt$1.setAttribute("cm-text", m[0]);
        if (ie && ie_version < 9) { content.appendChild(elt("span", [txt$1])); }
        else { content.appendChild(txt$1); }
        builder.col += 1;
      }
      builder.map.push(builder.pos, builder.pos + 1, txt$1);
      builder.pos++;
    }
  }
  builder.trailingSpace = displayText.charCodeAt(text.length - 1) == 32;
  if (style || startStyle || endStyle || mustWrap || css) {
    var fullStyle = style || "";
    if (startStyle) { fullStyle += startStyle; }
    if (endStyle) { fullStyle += endStyle; }
    var token = elt("span", [content], fullStyle, css);
    if (title) { token.title = title; }
    return builder.content.appendChild(token)
  }
  builder.content.appendChild(content);
}

function splitSpaces(text, trailingBefore) {
  if (text.length > 1 && !/  /.test(text)) { return text }
  var spaceBefore = trailingBefore, result = "";
  for (var i = 0; i < text.length; i++) {
    var ch = text.charAt(i);
    if (ch == " " && spaceBefore && (i == text.length - 1 || text.charCodeAt(i + 1) == 32))
      { ch = "\u00a0"; }
    result += ch;
    spaceBefore = ch == " ";
  }
  return result
}

// Work around nonsense dimensions being reported for stretches of
// right-to-left text.
function buildTokenBadBidi(inner, order) {
  return function (builder, text, style, startStyle, endStyle, title, css) {
    style = style ? style + " cm-force-border" : "cm-force-border";
    var start = builder.pos, end = start + text.length;
    for (;;) {
      // Find the part that overlaps with the start of this text
      var part = (void 0);
      for (var i = 0; i < order.length; i++) {
        part = order[i];
        if (part.to > start && part.from <= start) { break }
      }
      if (part.to >= end) { return inner(builder, text, style, startStyle, endStyle, title, css) }
      inner(builder, text.slice(0, part.to - start), style, startStyle, null, title, css);
      startStyle = null;
      text = text.slice(part.to - start);
      start = part.to;
    }
  }
}

function buildCollapsedSpan(builder, size, marker, ignoreWidget) {
  var widget = !ignoreWidget && marker.widgetNode;
  if (widget) { builder.map.push(builder.pos, builder.pos + size, widget); }
  if (!ignoreWidget && builder.cm.display.input.needsContentAttribute) {
    if (!widget)
      { widget = builder.content.appendChild(document.createElement("span")); }
    widget.setAttribute("cm-marker", marker.id);
  }
  if (widget) {
    builder.cm.display.input.setUneditable(widget);
    builder.content.appendChild(widget);
  }
  builder.pos += size;
  builder.trailingSpace = false;
}

// Outputs a number of spans to make up a line, taking highlighting
// and marked text into account.
function insertLineContent(line, builder, styles) {
  var spans = line.markedSpans, allText = line.text, at = 0;
  if (!spans) {
    for (var i$1 = 1; i$1 < styles.length; i$1+=2)
      { builder.addToken(builder, allText.slice(at, at = styles[i$1]), interpretTokenStyle(styles[i$1+1], builder.cm.options)); }
    return
  }

  var len = allText.length, pos = 0, i = 1, text = "", style, css;
  var nextChange = 0, spanStyle, spanEndStyle, spanStartStyle, title, collapsed;
  for (;;) {
    if (nextChange == pos) { // Update current marker set
      spanStyle = spanEndStyle = spanStartStyle = title = css = "";
      collapsed = null; nextChange = Infinity;
      var foundBookmarks = [], endStyles = (void 0);
      for (var j = 0; j < spans.length; ++j) {
        var sp = spans[j], m = sp.marker;
        if (m.type == "bookmark" && sp.from == pos && m.widgetNode) {
          foundBookmarks.push(m);
        } else if (sp.from <= pos && (sp.to == null || sp.to > pos || m.collapsed && sp.to == pos && sp.from == pos)) {
          if (sp.to != null && sp.to != pos && nextChange > sp.to) {
            nextChange = sp.to;
            spanEndStyle = "";
          }
          if (m.className) { spanStyle += " " + m.className; }
          if (m.css) { css = (css ? css + ";" : "") + m.css; }
          if (m.startStyle && sp.from == pos) { spanStartStyle += " " + m.startStyle; }
          if (m.endStyle && sp.to == nextChange) { (endStyles || (endStyles = [])).push(m.endStyle, sp.to); }
          if (m.title && !title) { title = m.title; }
          if (m.collapsed && (!collapsed || compareCollapsedMarkers(collapsed.marker, m) < 0))
            { collapsed = sp; }
        } else if (sp.from > pos && nextChange > sp.from) {
          nextChange = sp.from;
        }
      }
      if (endStyles) { for (var j$1 = 0; j$1 < endStyles.length; j$1 += 2)
        { if (endStyles[j$1 + 1] == nextChange) { spanEndStyle += " " + endStyles[j$1]; } } }

      if (!collapsed || collapsed.from == pos) { for (var j$2 = 0; j$2 < foundBookmarks.length; ++j$2)
        { buildCollapsedSpan(builder, 0, foundBookmarks[j$2]); } }
      if (collapsed && (collapsed.from || 0) == pos) {
        buildCollapsedSpan(builder, (collapsed.to == null ? len + 1 : collapsed.to) - pos,
                           collapsed.marker, collapsed.from == null);
        if (collapsed.to == null) { return }
        if (collapsed.to == pos) { collapsed = false; }
      }
    }
    if (pos >= len) { break }

    var upto = Math.min(len, nextChange);
    while (true) {
      if (text) {
        var end = pos + text.length;
        if (!collapsed) {
          var tokenText = end > upto ? text.slice(0, upto - pos) : text;
          builder.addToken(builder, tokenText, style ? style + spanStyle : spanStyle,
                           spanStartStyle, pos + tokenText.length == nextChange ? spanEndStyle : "", title, css);
        }
        if (end >= upto) {text = text.slice(upto - pos); pos = upto; break}
        pos = end;
        spanStartStyle = "";
      }
      text = allText.slice(at, at = styles[i++]);
      style = interpretTokenStyle(styles[i++], builder.cm.options);
    }
  }
}


// These objects are used to represent the visible (currently drawn)
// part of the document. A LineView may correspond to multiple
// logical lines, if those are connected by collapsed ranges.
function LineView(doc, line, lineN) {
  // The starting line
  this.line = line;
  // Continuing lines, if any
  this.rest = visualLineContinued(line);
  // Number of logical lines in this visual line
  this.size = this.rest ? lineNo(lst(this.rest)) - lineN + 1 : 1;
  this.node = this.text = null;
  this.hidden = lineIsHidden(doc, line);
}

// Create a range of LineView objects for the given lines.
function buildViewArray(cm, from, to) {
  var array = [], nextPos;
  for (var pos = from; pos < to; pos = nextPos) {
    var view = new LineView(cm.doc, getLine(cm.doc, pos), pos);
    nextPos = pos + view.size;
    array.push(view);
  }
  return array
}

var operationGroup = null;

function pushOperation(op) {
  if (operationGroup) {
    operationGroup.ops.push(op);
  } else {
    op.ownsGroup = operationGroup = {
      ops: [op],
      delayedCallbacks: []
    };
  }
}

function fireCallbacksForOps(group) {
  // Calls delayed callbacks and cursorActivity handlers until no
  // new ones appear
  var callbacks = group.delayedCallbacks, i = 0;
  do {
    for (; i < callbacks.length; i++)
      { callbacks[i].call(null); }
    for (var j = 0; j < group.ops.length; j++) {
      var op = group.ops[j];
      if (op.cursorActivityHandlers)
        { while (op.cursorActivityCalled < op.cursorActivityHandlers.length)
          { op.cursorActivityHandlers[op.cursorActivityCalled++].call(null, op.cm); } }
    }
  } while (i < callbacks.length)
}

function finishOperation(op, endCb) {
  var group = op.ownsGroup;
  if (!group) { return }

  try { fireCallbacksForOps(group); }
  finally {
    operationGroup = null;
    endCb(group);
  }
}

var orphanDelayedCallbacks = null;

// Often, we want to signal events at a point where we are in the
// middle of some work, but don't want the handler to start calling
// other methods on the editor, which might be in an inconsistent
// state or simply not expect any other events to happen.
// signalLater looks whether there are any handlers, and schedules
// them to be executed when the last operation ends, or, if no
// operation is active, when a timeout fires.
function signalLater(emitter, type /*, values...*/) {
  var arr = getHandlers(emitter, type);
  if (!arr.length) { return }
  var args = Array.prototype.slice.call(arguments, 2), list;
  if (operationGroup) {
    list = operationGroup.delayedCallbacks;
  } else if (orphanDelayedCallbacks) {
    list = orphanDelayedCallbacks;
  } else {
    list = orphanDelayedCallbacks = [];
    setTimeout(fireOrphanDelayed, 0);
  }
  var loop = function ( i ) {
    list.push(function () { return arr[i].apply(null, args); });
  };

  for (var i = 0; i < arr.length; ++i)
    loop( i );
}

function fireOrphanDelayed() {
  var delayed = orphanDelayedCallbacks;
  orphanDelayedCallbacks = null;
  for (var i = 0; i < delayed.length; ++i) { delayed[i](); }
}

// When an aspect of a line changes, a string is added to
// lineView.changes. This updates the relevant part of the line's
// DOM structure.
function updateLineForChanges(cm, lineView, lineN, dims) {
  for (var j = 0; j < lineView.changes.length; j++) {
    var type = lineView.changes[j];
    if (type == "text") { updateLineText(cm, lineView); }
    else if (type == "gutter") { updateLineGutter(cm, lineView, lineN, dims); }
    else if (type == "class") { updateLineClasses(cm, lineView); }
    else if (type == "widget") { updateLineWidgets(cm, lineView, dims); }
  }
  lineView.changes = null;
}

// Lines with gutter elements, widgets or a background class need to
// be wrapped, and have the extra elements added to the wrapper div
function ensureLineWrapped(lineView) {
  if (lineView.node == lineView.text) {
    lineView.node = elt("div", null, null, "position: relative");
    if (lineView.text.parentNode)
      { lineView.text.parentNode.replaceChild(lineView.node, lineView.text); }
    lineView.node.appendChild(lineView.text);
    if (ie && ie_version < 8) { lineView.node.style.zIndex = 2; }
  }
  return lineView.node
}

function updateLineBackground(cm, lineView) {
  var cls = lineView.bgClass ? lineView.bgClass + " " + (lineView.line.bgClass || "") : lineView.line.bgClass;
  if (cls) { cls += " CodeMirror-linebackground"; }
  if (lineView.background) {
    if (cls) { lineView.background.className = cls; }
    else { lineView.background.parentNode.removeChild(lineView.background); lineView.background = null; }
  } else if (cls) {
    var wrap = ensureLineWrapped(lineView);
    lineView.background = wrap.insertBefore(elt("div", null, cls), wrap.firstChild);
    cm.display.input.setUneditable(lineView.background);
  }
}

// Wrapper around buildLineContent which will reuse the structure
// in display.externalMeasured when possible.
function getLineContent(cm, lineView) {
  var ext = cm.display.externalMeasured;
  if (ext && ext.line == lineView.line) {
    cm.display.externalMeasured = null;
    lineView.measure = ext.measure;
    return ext.built
  }
  return buildLineContent(cm, lineView)
}

// Redraw the line's text. Interacts with the background and text
// classes because the mode may output tokens that influence these
// classes.
function updateLineText(cm, lineView) {
  var cls = lineView.text.className;
  var built = getLineContent(cm, lineView);
  if (lineView.text == lineView.node) { lineView.node = built.pre; }
  lineView.text.parentNode.replaceChild(built.pre, lineView.text);
  lineView.text = built.pre;
  if (built.bgClass != lineView.bgClass || built.textClass != lineView.textClass) {
    lineView.bgClass = built.bgClass;
    lineView.textClass = built.textClass;
    updateLineClasses(cm, lineView);
  } else if (cls) {
    lineView.text.className = cls;
  }
}

function updateLineClasses(cm, lineView) {
  updateLineBackground(cm, lineView);
  if (lineView.line.wrapClass)
    { ensureLineWrapped(lineView).className = lineView.line.wrapClass; }
  else if (lineView.node != lineView.text)
    { lineView.node.className = ""; }
  var textClass = lineView.textClass ? lineView.textClass + " " + (lineView.line.textClass || "") : lineView.line.textClass;
  lineView.text.className = textClass || "";
}

function updateLineGutter(cm, lineView, lineN, dims) {
  if (lineView.gutter) {
    lineView.node.removeChild(lineView.gutter);
    lineView.gutter = null;
  }
  if (lineView.gutterBackground) {
    lineView.node.removeChild(lineView.gutterBackground);
    lineView.gutterBackground = null;
  }
  if (lineView.line.gutterClass) {
    var wrap = ensureLineWrapped(lineView);
    lineView.gutterBackground = elt("div", null, "CodeMirror-gutter-background " + lineView.line.gutterClass,
                                    ("left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px; width: " + (dims.gutterTotalWidth) + "px"));
    cm.display.input.setUneditable(lineView.gutterBackground);
    wrap.insertBefore(lineView.gutterBackground, lineView.text);
  }
  var markers = lineView.line.gutterMarkers;
  if (cm.options.lineNumbers || markers) {
    var wrap$1 = ensureLineWrapped(lineView);
    var gutterWrap = lineView.gutter = elt("div", null, "CodeMirror-gutter-wrapper", ("left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px"));
    cm.display.input.setUneditable(gutterWrap);
    wrap$1.insertBefore(gutterWrap, lineView.text);
    if (lineView.line.gutterClass)
      { gutterWrap.className += " " + lineView.line.gutterClass; }
    if (cm.options.lineNumbers && (!markers || !markers["CodeMirror-linenumbers"]))
      { lineView.lineNumber = gutterWrap.appendChild(
        elt("div", lineNumberFor(cm.options, lineN),
            "CodeMirror-linenumber CodeMirror-gutter-elt",
            ("left: " + (dims.gutterLeft["CodeMirror-linenumbers"]) + "px; width: " + (cm.display.lineNumInnerWidth) + "px"))); }
    if (markers) { for (var k = 0; k < cm.options.gutters.length; ++k) {
      var id = cm.options.gutters[k], found = markers.hasOwnProperty(id) && markers[id];
      if (found)
        { gutterWrap.appendChild(elt("div", [found], "CodeMirror-gutter-elt",
                                   ("left: " + (dims.gutterLeft[id]) + "px; width: " + (dims.gutterWidth[id]) + "px"))); }
    } }
  }
}

function updateLineWidgets(cm, lineView, dims) {
  if (lineView.alignable) { lineView.alignable = null; }
  for (var node = lineView.node.firstChild, next = (void 0); node; node = next) {
    next = node.nextSibling;
    if (node.className == "CodeMirror-linewidget")
      { lineView.node.removeChild(node); }
  }
  insertLineWidgets(cm, lineView, dims);
}

// Build a line's DOM representation from scratch
function buildLineElement(cm, lineView, lineN, dims) {
  var built = getLineContent(cm, lineView);
  lineView.text = lineView.node = built.pre;
  if (built.bgClass) { lineView.bgClass = built.bgClass; }
  if (built.textClass) { lineView.textClass = built.textClass; }

  updateLineClasses(cm, lineView);
  updateLineGutter(cm, lineView, lineN, dims);
  insertLineWidgets(cm, lineView, dims);
  return lineView.node
}

// A lineView may contain multiple logical lines (when merged by
// collapsed spans). The widgets for all of them need to be drawn.
function insertLineWidgets(cm, lineView, dims) {
  insertLineWidgetsFor(cm, lineView.line, lineView, dims, true);
  if (lineView.rest) { for (var i = 0; i < lineView.rest.length; i++)
    { insertLineWidgetsFor(cm, lineView.rest[i], lineView, dims, false); } }
}

function insertLineWidgetsFor(cm, line, lineView, dims, allowAbove) {
  if (!line.widgets) { return }
  var wrap = ensureLineWrapped(lineView);
  for (var i = 0, ws = line.widgets; i < ws.length; ++i) {
    var widget = ws[i], node = elt("div", [widget.node], "CodeMirror-linewidget");
    if (!widget.handleMouseEvents) { node.setAttribute("cm-ignore-events", "true"); }
    positionLineWidget(widget, node, lineView, dims);
    cm.display.input.setUneditable(node);
    if (allowAbove && widget.above)
      { wrap.insertBefore(node, lineView.gutter || lineView.text); }
    else
      { wrap.appendChild(node); }
    signalLater(widget, "redraw");
  }
}

function positionLineWidget(widget, node, lineView, dims) {
  if (widget.noHScroll) {
    (lineView.alignable || (lineView.alignable = [])).push(node);
    var width = dims.wrapperWidth;
    node.style.left = dims.fixedPos + "px";
    if (!widget.coverGutter) {
      width -= dims.gutterTotalWidth;
      node.style.paddingLeft = dims.gutterTotalWidth + "px";
    }
    node.style.width = width + "px";
  }
  if (widget.coverGutter) {
    node.style.zIndex = 5;
    node.style.position = "relative";
    if (!widget.noHScroll) { node.style.marginLeft = -dims.gutterTotalWidth + "px"; }
  }
}

function widgetHeight(widget) {
  if (widget.height != null) { return widget.height }
  var cm = widget.doc.cm;
  if (!cm) { return 0 }
  if (!contains(document.body, widget.node)) {
    var parentStyle = "position: relative;";
    if (widget.coverGutter)
      { parentStyle += "margin-left: -" + cm.display.gutters.offsetWidth + "px;"; }
    if (widget.noHScroll)
      { parentStyle += "width: " + cm.display.wrapper.clientWidth + "px;"; }
    removeChildrenAndAdd(cm.display.measure, elt("div", [widget.node], null, parentStyle));
  }
  return widget.height = widget.node.parentNode.offsetHeight
}

// Return true when the given mouse event happened in a widget
function eventInWidget(display, e) {
  for (var n = e_target(e); n != display.wrapper; n = n.parentNode) {
    if (!n || (n.nodeType == 1 && n.getAttribute("cm-ignore-events") == "true") ||
        (n.parentNode == display.sizer && n != display.mover))
      { return true }
  }
}

// POSITION MEASUREMENT

function paddingTop(display) {return display.lineSpace.offsetTop}
function paddingVert(display) {return display.mover.offsetHeight - display.lineSpace.offsetHeight}
function paddingH(display) {
  if (display.cachedPaddingH) { return display.cachedPaddingH }
  var e = removeChildrenAndAdd(display.measure, elt("pre", "x"));
  var style = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle;
  var data = {left: parseInt(style.paddingLeft), right: parseInt(style.paddingRight)};
  if (!isNaN(data.left) && !isNaN(data.right)) { display.cachedPaddingH = data; }
  return data
}

function scrollGap(cm) { return scrollerGap - cm.display.nativeBarWidth }
function displayWidth(cm) {
  return cm.display.scroller.clientWidth - scrollGap(cm) - cm.display.barWidth
}
function displayHeight(cm) {
  return cm.display.scroller.clientHeight - scrollGap(cm) - cm.display.barHeight
}

// Ensure the lineView.wrapping.heights array is populated. This is
// an array of bottom offsets for the lines that make up a drawn
// line. When lineWrapping is on, there might be more than one
// height.
function ensureLineHeights(cm, lineView, rect) {
  var wrapping = cm.options.lineWrapping;
  var curWidth = wrapping && displayWidth(cm);
  if (!lineView.measure.heights || wrapping && lineView.measure.width != curWidth) {
    var heights = lineView.measure.heights = [];
    if (wrapping) {
      lineView.measure.width = curWidth;
      var rects = lineView.text.firstChild.getClientRects();
      for (var i = 0; i < rects.length - 1; i++) {
        var cur = rects[i], next = rects[i + 1];
        if (Math.abs(cur.bottom - next.bottom) > 2)
          { heights.push((cur.bottom + next.top) / 2 - rect.top); }
      }
    }
    heights.push(rect.bottom - rect.top);
  }
}

// Find a line map (mapping character offsets to text nodes) and a
// measurement cache for the given line number. (A line view might
// contain multiple lines when collapsed ranges are present.)
function mapFromLineView(lineView, line, lineN) {
  if (lineView.line == line)
    { return {map: lineView.measure.map, cache: lineView.measure.cache} }
  for (var i = 0; i < lineView.rest.length; i++)
    { if (lineView.rest[i] == line)
      { return {map: lineView.measure.maps[i], cache: lineView.measure.caches[i]} } }
  for (var i$1 = 0; i$1 < lineView.rest.length; i$1++)
    { if (lineNo(lineView.rest[i$1]) > lineN)
      { return {map: lineView.measure.maps[i$1], cache: lineView.measure.caches[i$1], before: true} } }
}

// Render a line into the hidden node display.externalMeasured. Used
// when measurement is needed for a line that's not in the viewport.
function updateExternalMeasurement(cm, line) {
  line = visualLine(line);
  var lineN = lineNo(line);
  var view = cm.display.externalMeasured = new LineView(cm.doc, line, lineN);
  view.lineN = lineN;
  var built = view.built = buildLineContent(cm, view);
  view.text = built.pre;
  removeChildrenAndAdd(cm.display.lineMeasure, built.pre);
  return view
}

// Get a {top, bottom, left, right} box (in line-local coordinates)
// for a given character.
function measureChar(cm, line, ch, bias) {
  return measureCharPrepared(cm, prepareMeasureForLine(cm, line), ch, bias)
}

// Find a line view that corresponds to the given line number.
function findViewForLine(cm, lineN) {
  if (lineN >= cm.display.viewFrom && lineN < cm.display.viewTo)
    { return cm.display.view[findViewIndex(cm, lineN)] }
  var ext = cm.display.externalMeasured;
  if (ext && lineN >= ext.lineN && lineN < ext.lineN + ext.size)
    { return ext }
}

// Measurement can be split in two steps, the set-up work that
// applies to the whole line, and the measurement of the actual
// character. Functions like coordsChar, that need to do a lot of
// measurements in a row, can thus ensure that the set-up work is
// only done once.
function prepareMeasureForLine(cm, line) {
  var lineN = lineNo(line);
  var view = findViewForLine(cm, lineN);
  if (view && !view.text) {
    view = null;
  } else if (view && view.changes) {
    updateLineForChanges(cm, view, lineN, getDimensions(cm));
    cm.curOp.forceUpdate = true;
  }
  if (!view)
    { view = updateExternalMeasurement(cm, line); }

  var info = mapFromLineView(view, line, lineN);
  return {
    line: line, view: view, rect: null,
    map: info.map, cache: info.cache, before: info.before,
    hasHeights: false
  }
}

// Given a prepared measurement object, measures the position of an
// actual character (or fetches it from the cache).
function measureCharPrepared(cm, prepared, ch, bias, varHeight) {
  if (prepared.before) { ch = -1; }
  var key = ch + (bias || ""), found;
  if (prepared.cache.hasOwnProperty(key)) {
    found = prepared.cache[key];
  } else {
    if (!prepared.rect)
      { prepared.rect = prepared.view.text.getBoundingClientRect(); }
    if (!prepared.hasHeights) {
      ensureLineHeights(cm, prepared.view, prepared.rect);
      prepared.hasHeights = true;
    }
    found = measureCharInner(cm, prepared, ch, bias);
    if (!found.bogus) { prepared.cache[key] = found; }
  }
  return {left: found.left, right: found.right,
          top: varHeight ? found.rtop : found.top,
          bottom: varHeight ? found.rbottom : found.bottom}
}

var nullRect = {left: 0, right: 0, top: 0, bottom: 0};

function nodeAndOffsetInLineMap(map$$1, ch, bias) {
  var node, start, end, collapse, mStart, mEnd;
  // First, search the line map for the text node corresponding to,
  // or closest to, the target character.
  for (var i = 0; i < map$$1.length; i += 3) {
    mStart = map$$1[i];
    mEnd = map$$1[i + 1];
    if (ch < mStart) {
      start = 0; end = 1;
      collapse = "left";
    } else if (ch < mEnd) {
      start = ch - mStart;
      end = start + 1;
    } else if (i == map$$1.length - 3 || ch == mEnd && map$$1[i + 3] > ch) {
      end = mEnd - mStart;
      start = end - 1;
      if (ch >= mEnd) { collapse = "right"; }
    }
    if (start != null) {
      node = map$$1[i + 2];
      if (mStart == mEnd && bias == (node.insertLeft ? "left" : "right"))
        { collapse = bias; }
      if (bias == "left" && start == 0)
        { while (i && map$$1[i - 2] == map$$1[i - 3] && map$$1[i - 1].insertLeft) {
          node = map$$1[(i -= 3) + 2];
          collapse = "left";
        } }
      if (bias == "right" && start == mEnd - mStart)
        { while (i < map$$1.length - 3 && map$$1[i + 3] == map$$1[i + 4] && !map$$1[i + 5].insertLeft) {
          node = map$$1[(i += 3) + 2];
          collapse = "right";
        } }
      break
    }
  }
  return {node: node, start: start, end: end, collapse: collapse, coverStart: mStart, coverEnd: mEnd}
}

function getUsefulRect(rects, bias) {
  var rect = nullRect;
  if (bias == "left") { for (var i = 0; i < rects.length; i++) {
    if ((rect = rects[i]).left != rect.right) { break }
  } } else { for (var i$1 = rects.length - 1; i$1 >= 0; i$1--) {
    if ((rect = rects[i$1]).left != rect.right) { break }
  } }
  return rect
}

function measureCharInner(cm, prepared, ch, bias) {
  var place = nodeAndOffsetInLineMap(prepared.map, ch, bias);
  var node = place.node, start = place.start, end = place.end, collapse = place.collapse;

  var rect;
  if (node.nodeType == 3) { // If it is a text node, use a range to retrieve the coordinates.
    for (var i$1 = 0; i$1 < 4; i$1++) { // Retry a maximum of 4 times when nonsense rectangles are returned
      while (start && isExtendingChar(prepared.line.text.charAt(place.coverStart + start))) { --start; }
      while (place.coverStart + end < place.coverEnd && isExtendingChar(prepared.line.text.charAt(place.coverStart + end))) { ++end; }
      if (ie && ie_version < 9 && start == 0 && end == place.coverEnd - place.coverStart)
        { rect = node.parentNode.getBoundingClientRect(); }
      else
        { rect = getUsefulRect(range(node, start, end).getClientRects(), bias); }
      if (rect.left || rect.right || start == 0) { break }
      end = start;
      start = start - 1;
      collapse = "right";
    }
    if (ie && ie_version < 11) { rect = maybeUpdateRectForZooming(cm.display.measure, rect); }
  } else { // If it is a widget, simply get the box for the whole widget.
    if (start > 0) { collapse = bias = "right"; }
    var rects;
    if (cm.options.lineWrapping && (rects = node.getClientRects()).length > 1)
      { rect = rects[bias == "right" ? rects.length - 1 : 0]; }
    else
      { rect = node.getBoundingClientRect(); }
  }
  if (ie && ie_version < 9 && !start && (!rect || !rect.left && !rect.right)) {
    var rSpan = node.parentNode.getClientRects()[0];
    if (rSpan)
      { rect = {left: rSpan.left, right: rSpan.left + charWidth(cm.display), top: rSpan.top, bottom: rSpan.bottom}; }
    else
      { rect = nullRect; }
  }

  var rtop = rect.top - prepared.rect.top, rbot = rect.bottom - prepared.rect.top;
  var mid = (rtop + rbot) / 2;
  var heights = prepared.view.measure.heights;
  var i = 0;
  for (; i < heights.length - 1; i++)
    { if (mid < heights[i]) { break } }
  var top = i ? heights[i - 1] : 0, bot = heights[i];
  var result = {left: (collapse == "right" ? rect.right : rect.left) - prepared.rect.left,
                right: (collapse == "left" ? rect.left : rect.right) - prepared.rect.left,
                top: top, bottom: bot};
  if (!rect.left && !rect.right) { result.bogus = true; }
  if (!cm.options.singleCursorHeightPerLine) { result.rtop = rtop; result.rbottom = rbot; }

  return result
}

// Work around problem with bounding client rects on ranges being
// returned incorrectly when zoomed on IE10 and below.
function maybeUpdateRectForZooming(measure, rect) {
  if (!window.screen || screen.logicalXDPI == null ||
      screen.logicalXDPI == screen.deviceXDPI || !hasBadZoomedRects(measure))
    { return rect }
  var scaleX = screen.logicalXDPI / screen.deviceXDPI;
  var scaleY = screen.logicalYDPI / screen.deviceYDPI;
  return {left: rect.left * scaleX, right: rect.right * scaleX,
          top: rect.top * scaleY, bottom: rect.bottom * scaleY}
}

function clearLineMeasurementCacheFor(lineView) {
  if (lineView.measure) {
    lineView.measure.cache = {};
    lineView.measure.heights = null;
    if (lineView.rest) { for (var i = 0; i < lineView.rest.length; i++)
      { lineView.measure.caches[i] = {}; } }
  }
}

function clearLineMeasurementCache(cm) {
  cm.display.externalMeasure = null;
  removeChildren(cm.display.lineMeasure);
  for (var i = 0; i < cm.display.view.length; i++)
    { clearLineMeasurementCacheFor(cm.display.view[i]); }
}

function clearCaches(cm) {
  clearLineMeasurementCache(cm);
  cm.display.cachedCharWidth = cm.display.cachedTextHeight = cm.display.cachedPaddingH = null;
  if (!cm.options.lineWrapping) { cm.display.maxLineChanged = true; }
  cm.display.lineNumChars = null;
}

function pageScrollX() {
  // Work around https://bugs.chromium.org/p/chromium/issues/detail?id=489206
  // which causes page_Offset and bounding client rects to use
  // different reference viewports and invalidate our calculations.
  if (chrome && android) { return -(document.body.getBoundingClientRect().left - parseInt(getComputedStyle(document.body).marginLeft)) }
  return window.pageXOffset || (document.documentElement || document.body).scrollLeft
}
function pageScrollY() {
  if (chrome && android) { return -(document.body.getBoundingClientRect().top - parseInt(getComputedStyle(document.body).marginTop)) }
  return window.pageYOffset || (document.documentElement || document.body).scrollTop
}

// Converts a {top, bottom, left, right} box from line-local
// coordinates into another coordinate system. Context may be one of
// "line", "div" (display.lineDiv), "local"./null (editor), "window",
// or "page".
function intoCoordSystem(cm, lineObj, rect, context, includeWidgets) {
  if (!includeWidgets && lineObj.widgets) { for (var i = 0; i < lineObj.widgets.length; ++i) { if (lineObj.widgets[i].above) {
    var size = widgetHeight(lineObj.widgets[i]);
    rect.top += size; rect.bottom += size;
  } } }
  if (context == "line") { return rect }
  if (!context) { context = "local"; }
  var yOff = heightAtLine(lineObj);
  if (context == "local") { yOff += paddingTop(cm.display); }
  else { yOff -= cm.display.viewOffset; }
  if (context == "page" || context == "window") {
    var lOff = cm.display.lineSpace.getBoundingClientRect();
    yOff += lOff.top + (context == "window" ? 0 : pageScrollY());
    var xOff = lOff.left + (context == "window" ? 0 : pageScrollX());
    rect.left += xOff; rect.right += xOff;
  }
  rect.top += yOff; rect.bottom += yOff;
  return rect
}

// Coverts a box from "div" coords to another coordinate system.
// Context may be "window", "page", "div", or "local"./null.
function fromCoordSystem(cm, coords, context) {
  if (context == "div") { return coords }
  var left = coords.left, top = coords.top;
  // First move into "page" coordinate system
  if (context == "page") {
    left -= pageScrollX();
    top -= pageScrollY();
  } else if (context == "local" || !context) {
    var localBox = cm.display.sizer.getBoundingClientRect();
    left += localBox.left;
    top += localBox.top;
  }

  var lineSpaceBox = cm.display.lineSpace.getBoundingClientRect();
  return {left: left - lineSpaceBox.left, top: top - lineSpaceBox.top}
}

function charCoords(cm, pos, context, lineObj, bias) {
  if (!lineObj) { lineObj = getLine(cm.doc, pos.line); }
  return intoCoordSystem(cm, lineObj, measureChar(cm, lineObj, pos.ch, bias), context)
}

// Returns a box for a given cursor position, which may have an
// 'other' property containing the position of the secondary cursor
// on a bidi boundary.
// A cursor Pos(line, char, "before") is on the same visual line as `char - 1`
// and after `char - 1` in writing order of `char - 1`
// A cursor Pos(line, char, "after") is on the same visual line as `char`
// and before `char` in writing order of `char`
// Examples (upper-case letters are RTL, lower-case are LTR):
//     Pos(0, 1, ...)
//     before   after
// ab     a|b     a|b
// aB     a|B     aB|
// Ab     |Ab     A|b
// AB     B|A     B|A
// Every position after the last character on a line is considered to stick
// to the last character on the line.
function cursorCoords(cm, pos, context, lineObj, preparedMeasure, varHeight) {
  lineObj = lineObj || getLine(cm.doc, pos.line);
  if (!preparedMeasure) { preparedMeasure = prepareMeasureForLine(cm, lineObj); }
  function get(ch, right) {
    var m = measureCharPrepared(cm, preparedMeasure, ch, right ? "right" : "left", varHeight);
    if (right) { m.left = m.right; } else { m.right = m.left; }
    return intoCoordSystem(cm, lineObj, m, context)
  }
  var order = getOrder(lineObj, cm.doc.direction), ch = pos.ch, sticky = pos.sticky;
  if (ch >= lineObj.text.length) {
    ch = lineObj.text.length;
    sticky = "before";
  } else if (ch <= 0) {
    ch = 0;
    sticky = "after";
  }
  if (!order) { return get(sticky == "before" ? ch - 1 : ch, sticky == "before") }

  function getBidi(ch, partPos, invert) {
    var part = order[partPos], right = (part.level % 2) != 0;
    return get(invert ? ch - 1 : ch, right != invert)
  }
  var partPos = getBidiPartAt(order, ch, sticky);
  var other = bidiOther;
  var val = getBidi(ch, partPos, sticky == "before");
  if (other != null) { val.other = getBidi(ch, other, sticky != "before"); }
  return val
}

// Used to cheaply estimate the coordinates for a position. Used for
// intermediate scroll updates.
function estimateCoords(cm, pos) {
  var left = 0;
  pos = clipPos(cm.doc, pos);
  if (!cm.options.lineWrapping) { left = charWidth(cm.display) * pos.ch; }
  var lineObj = getLine(cm.doc, pos.line);
  var top = heightAtLine(lineObj) + paddingTop(cm.display);
  return {left: left, right: left, top: top, bottom: top + lineObj.height}
}

// Positions returned by coordsChar contain some extra information.
// xRel is the relative x position of the input coordinates compared
// to the found position (so xRel > 0 means the coordinates are to
// the right of the character position, for example). When outside
// is true, that means the coordinates lie outside the line's
// vertical range.
function PosWithInfo(line, ch, sticky, outside, xRel) {
  var pos = Pos(line, ch, sticky);
  pos.xRel = xRel;
  if (outside) { pos.outside = true; }
  return pos
}

// Compute the character position closest to the given coordinates.
// Input must be lineSpace-local ("div" coordinate system).
function coordsChar(cm, x, y) {
  var doc = cm.doc;
  y += cm.display.viewOffset;
  if (y < 0) { return PosWithInfo(doc.first, 0, null, true, -1) }
  var lineN = lineAtHeight(doc, y), last = doc.first + doc.size - 1;
  if (lineN > last)
    { return PosWithInfo(doc.first + doc.size - 1, getLine(doc, last).text.length, null, true, 1) }
  if (x < 0) { x = 0; }

  var lineObj = getLine(doc, lineN);
  for (;;) {
    var found = coordsCharInner(cm, lineObj, lineN, x, y);
    var merged = collapsedSpanAtEnd(lineObj);
    var mergedPos = merged && merged.find(0, true);
    if (merged && (found.ch > mergedPos.from.ch || found.ch == mergedPos.from.ch && found.xRel > 0))
      { lineN = lineNo(lineObj = mergedPos.to.line); }
    else
      { return found }
  }
}

function wrappedLineExtent(cm, lineObj, preparedMeasure, y) {
  var measure = function (ch) { return intoCoordSystem(cm, lineObj, measureCharPrepared(cm, preparedMeasure, ch), "line"); };
  var end = lineObj.text.length;
  var begin = findFirst(function (ch) { return measure(ch - 1).bottom <= y; }, end, 0);
  end = findFirst(function (ch) { return measure(ch).top > y; }, begin, end);
  return {begin: begin, end: end}
}

function wrappedLineExtentChar(cm, lineObj, preparedMeasure, target) {
  var targetTop = intoCoordSystem(cm, lineObj, measureCharPrepared(cm, preparedMeasure, target), "line").top;
  return wrappedLineExtent(cm, lineObj, preparedMeasure, targetTop)
}

function coordsCharInner(cm, lineObj, lineNo$$1, x, y) {
  y -= heightAtLine(lineObj);
  var begin = 0, end = lineObj.text.length;
  var preparedMeasure = prepareMeasureForLine(cm, lineObj);
  var pos;
  var order = getOrder(lineObj, cm.doc.direction);
  if (order) {
    if (cm.options.lineWrapping) {
      var assign;
      ((assign = wrappedLineExtent(cm, lineObj, preparedMeasure, y), begin = assign.begin, end = assign.end, assign));
    }
    pos = new Pos(lineNo$$1, Math.floor(begin + (end - begin) / 2));
    var beginLeft = cursorCoords(cm, pos, "line", lineObj, preparedMeasure).left;
    var dir = beginLeft < x ? 1 : -1;
    var prevDiff, diff = beginLeft - x, prevPos;
    var steps = Math.ceil((end - begin) / 4);
    outer: do {
      prevDiff = diff;
      prevPos = pos;
      var i = 0;
      for (; i < steps; ++i) {
        var prevPos$1 = pos;
        pos = moveVisually(cm, lineObj, pos, dir);
        if (pos == null || pos.ch < begin || end <= (pos.sticky == "before" ? pos.ch - 1 : pos.ch)) {
          pos = prevPos$1;
          break outer
        }
      }
      diff = cursorCoords(cm, pos, "line", lineObj, preparedMeasure).left - x;
      if (steps > 1) {
        var diff_change_per_step = Math.abs(diff - prevDiff) / steps;
        steps = Math.min(steps, Math.ceil(Math.abs(diff) / diff_change_per_step));
        dir = diff < 0 ? 1 : -1;
      }
    } while (diff != 0 && (steps > 1 || ((dir < 0) != (diff < 0) && (Math.abs(diff) <= Math.abs(prevDiff)))))
    if (Math.abs(diff) > Math.abs(prevDiff)) {
      if ((diff < 0) == (prevDiff < 0)) { throw new Error("Broke out of infinite loop in coordsCharInner") }
      pos = prevPos;
    }
  } else {
    var ch = findFirst(function (ch) {
      var box = intoCoordSystem(cm, lineObj, measureCharPrepared(cm, preparedMeasure, ch), "line");
      if (box.top > y) {
        // For the cursor stickiness
        end = Math.min(ch, end);
        return true
      }
      else if (box.bottom <= y) { return false }
      else if (box.left > x) { return true }
      else if (box.right < x) { return false }
      else { return (x - box.left < box.right - x) }
    }, begin, end);
    ch = skipExtendingChars(lineObj.text, ch, 1);
    pos = new Pos(lineNo$$1, ch, ch == end ? "before" : "after");
  }
  var coords = cursorCoords(cm, pos, "line", lineObj, preparedMeasure);
  if (y < coords.top || coords.bottom < y) { pos.outside = true; }
  pos.xRel = x < coords.left ? -1 : (x > coords.right ? 1 : 0);
  return pos
}

var measureText;
// Compute the default text height.
function textHeight(display) {
  if (display.cachedTextHeight != null) { return display.cachedTextHeight }
  if (measureText == null) {
    measureText = elt("pre");
    // Measure a bunch of lines, for browsers that compute
    // fractional heights.
    for (var i = 0; i < 49; ++i) {
      measureText.appendChild(document.createTextNode("x"));
      measureText.appendChild(elt("br"));
    }
    measureText.appendChild(document.createTextNode("x"));
  }
  removeChildrenAndAdd(display.measure, measureText);
  var height = measureText.offsetHeight / 50;
  if (height > 3) { display.cachedTextHeight = height; }
  removeChildren(display.measure);
  return height || 1
}

// Compute the default character width.
function charWidth(display) {
  if (display.cachedCharWidth != null) { return display.cachedCharWidth }
  var anchor = elt("span", "xxxxxxxxxx");
  var pre = elt("pre", [anchor]);
  removeChildrenAndAdd(display.measure, pre);
  var rect = anchor.getBoundingClientRect(), width = (rect.right - rect.left) / 10;
  if (width > 2) { display.cachedCharWidth = width; }
  return width || 10
}

// Do a bulk-read of the DOM positions and sizes needed to draw the
// view, so that we don't interleave reading and writing to the DOM.
function getDimensions(cm) {
  var d = cm.display, left = {}, width = {};
  var gutterLeft = d.gutters.clientLeft;
  for (var n = d.gutters.firstChild, i = 0; n; n = n.nextSibling, ++i) {
    left[cm.options.gutters[i]] = n.offsetLeft + n.clientLeft + gutterLeft;
    width[cm.options.gutters[i]] = n.clientWidth;
  }
  return {fixedPos: compensateForHScroll(d),
          gutterTotalWidth: d.gutters.offsetWidth,
          gutterLeft: left,
          gutterWidth: width,
          wrapperWidth: d.wrapper.clientWidth}
}

// Computes display.scroller.scrollLeft + display.gutters.offsetWidth,
// but using getBoundingClientRect to get a sub-pixel-accurate
// result.
function compensateForHScroll(display) {
  return display.scroller.getBoundingClientRect().left - display.sizer.getBoundingClientRect().left
}

// Returns a function that estimates the height of a line, to use as
// first approximation until the line becomes visible (and is thus
// properly measurable).
function estimateHeight(cm) {
  var th = textHeight(cm.display), wrapping = cm.options.lineWrapping;
  var perLine = wrapping && Math.max(5, cm.display.scroller.clientWidth / charWidth(cm.display) - 3);
  return function (line) {
    if (lineIsHidden(cm.doc, line)) { return 0 }

    var widgetsHeight = 0;
    if (line.widgets) { for (var i = 0; i < line.widgets.length; i++) {
      if (line.widgets[i].height) { widgetsHeight += line.widgets[i].height; }
    } }

    if (wrapping)
      { return widgetsHeight + (Math.ceil(line.text.length / perLine) || 1) * th }
    else
      { return widgetsHeight + th }
  }
}

function estimateLineHeights(cm) {
  var doc = cm.doc, est = estimateHeight(cm);
  doc.iter(function (line) {
    var estHeight = est(line);
    if (estHeight != line.height) { updateLineHeight(line, estHeight); }
  });
}

// Given a mouse event, find the corresponding position. If liberal
// is false, it checks whether a gutter or scrollbar was clicked,
// and returns null if it was. forRect is used by rectangular
// selections, and tries to estimate a character position even for
// coordinates beyond the right of the text.
function posFromMouse(cm, e, liberal, forRect) {
  var display = cm.display;
  if (!liberal && e_target(e).getAttribute("cm-not-content") == "true") { return null }

  var x, y, space = display.lineSpace.getBoundingClientRect();
  // Fails unpredictably on IE[67] when mouse is dragged around quickly.
  try { x = e.clientX - space.left; y = e.clientY - space.top; }
  catch (e) { return null }
  var coords = coordsChar(cm, x, y), line;
  if (forRect && coords.xRel == 1 && (line = getLine(cm.doc, coords.line).text).length == coords.ch) {
    var colDiff = countColumn(line, line.length, cm.options.tabSize) - line.length;
    coords = Pos(coords.line, Math.max(0, Math.round((x - paddingH(cm.display).left) / charWidth(cm.display)) - colDiff));
  }
  return coords
}

// Find the view element corresponding to a given line. Return null
// when the line isn't visible.
function findViewIndex(cm, n) {
  if (n >= cm.display.viewTo) { return null }
  n -= cm.display.viewFrom;
  if (n < 0) { return null }
  var view = cm.display.view;
  for (var i = 0; i < view.length; i++) {
    n -= view[i].size;
    if (n < 0) { return i }
  }
}

function updateSelection(cm) {
  cm.display.input.showSelection(cm.display.input.prepareSelection());
}

function prepareSelection(cm, primary) {
  var doc = cm.doc, result = {};
  var curFragment = result.cursors = document.createDocumentFragment();
  var selFragment = result.selection = document.createDocumentFragment();

  for (var i = 0; i < doc.sel.ranges.length; i++) {
    if (primary === false && i == doc.sel.primIndex) { continue }
    var range$$1 = doc.sel.ranges[i];
    if (range$$1.from().line >= cm.display.viewTo || range$$1.to().line < cm.display.viewFrom) { continue }
    var collapsed = range$$1.empty();
    if (collapsed || cm.options.showCursorWhenSelecting)
      { drawSelectionCursor(cm, range$$1.head, curFragment); }
    if (!collapsed)
      { drawSelectionRange(cm, range$$1, selFragment); }
  }
  return result
}

// Draws a cursor for the given range
function drawSelectionCursor(cm, head, output) {
  var pos = cursorCoords(cm, head, "div", null, null, !cm.options.singleCursorHeightPerLine);

  var cursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor"));
  cursor.style.left = pos.left + "px";
  cursor.style.top = pos.top + "px";
  cursor.style.height = Math.max(0, pos.bottom - pos.top) * cm.options.cursorHeight + "px";

  if (pos.other) {
    // Secondary cursor, shown when on a 'jump' in bi-directional text
    var otherCursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor CodeMirror-secondarycursor"));
    otherCursor.style.display = "";
    otherCursor.style.left = pos.other.left + "px";
    otherCursor.style.top = pos.other.top + "px";
    otherCursor.style.height = (pos.other.bottom - pos.other.top) * .85 + "px";
  }
}

// Draws the given range as a highlighted selection
function drawSelectionRange(cm, range$$1, output) {
  var display = cm.display, doc = cm.doc;
  var fragment = document.createDocumentFragment();
  var padding = paddingH(cm.display), leftSide = padding.left;
  var rightSide = Math.max(display.sizerWidth, displayWidth(cm) - display.sizer.offsetLeft) - padding.right;

  function add(left, top, width, bottom) {
    if (top < 0) { top = 0; }
    top = Math.round(top);
    bottom = Math.round(bottom);
    fragment.appendChild(elt("div", null, "CodeMirror-selected", ("position: absolute; left: " + left + "px;\n                             top: " + top + "px; width: " + (width == null ? rightSide - left : width) + "px;\n                             height: " + (bottom - top) + "px")));
  }

  function drawForLine(line, fromArg, toArg) {
    var lineObj = getLine(doc, line);
    var lineLen = lineObj.text.length;
    var start, end;
    function coords(ch, bias) {
      return charCoords(cm, Pos(line, ch), "div", lineObj, bias)
    }

    iterateBidiSections(getOrder(lineObj, doc.direction), fromArg || 0, toArg == null ? lineLen : toArg, function (from, to, dir) {
      var leftPos = coords(from, "left"), rightPos, left, right;
      if (from == to) {
        rightPos = leftPos;
        left = right = leftPos.left;
      } else {
        rightPos = coords(to - 1, "right");
        if (dir == "rtl") { var tmp = leftPos; leftPos = rightPos; rightPos = tmp; }
        left = leftPos.left;
        right = rightPos.right;
      }
      if (fromArg == null && from == 0) { left = leftSide; }
      if (rightPos.top - leftPos.top > 3) { // Different lines, draw top part
        add(left, leftPos.top, null, leftPos.bottom);
        left = leftSide;
        if (leftPos.bottom < rightPos.top) { add(left, leftPos.bottom, null, rightPos.top); }
      }
      if (toArg == null && to == lineLen) { right = rightSide; }
      if (!start || leftPos.top < start.top || leftPos.top == start.top && leftPos.left < start.left)
        { start = leftPos; }
      if (!end || rightPos.bottom > end.bottom || rightPos.bottom == end.bottom && rightPos.right > end.right)
        { end = rightPos; }
      if (left < leftSide + 1) { left = leftSide; }
      add(left, rightPos.top, right - left, rightPos.bottom);
    });
    return {start: start, end: end}
  }

  var sFrom = range$$1.from(), sTo = range$$1.to();
  if (sFrom.line == sTo.line) {
    drawForLine(sFrom.line, sFrom.ch, sTo.ch);
  } else {
    var fromLine = getLine(doc, sFrom.line), toLine = getLine(doc, sTo.line);
    var singleVLine = visualLine(fromLine) == visualLine(toLine);
    var leftEnd = drawForLine(sFrom.line, sFrom.ch, singleVLine ? fromLine.text.length + 1 : null).end;
    var rightStart = drawForLine(sTo.line, singleVLine ? 0 : null, sTo.ch).start;
    if (singleVLine) {
      if (leftEnd.top < rightStart.top - 2) {
        add(leftEnd.right, leftEnd.top, null, leftEnd.bottom);
        add(leftSide, rightStart.top, rightStart.left, rightStart.bottom);
      } else {
        add(leftEnd.right, leftEnd.top, rightStart.left - leftEnd.right, leftEnd.bottom);
      }
    }
    if (leftEnd.bottom < rightStart.top)
      { add(leftSide, leftEnd.bottom, null, rightStart.top); }
  }

  output.appendChild(fragment);
}

// Cursor-blinking
function restartBlink(cm) {
  if (!cm.state.focused) { return }
  var display = cm.display;
  clearInterval(display.blinker);
  var on = true;
  display.cursorDiv.style.visibility = "";
  if (cm.options.cursorBlinkRate > 0)
    { display.blinker = setInterval(function () { return display.cursorDiv.style.visibility = (on = !on) ? "" : "hidden"; },
      cm.options.cursorBlinkRate); }
  else if (cm.options.cursorBlinkRate < 0)
    { display.cursorDiv.style.visibility = "hidden"; }
}

function ensureFocus(cm) {
  if (!cm.state.focused) { cm.display.input.focus(); onFocus(cm); }
}

function delayBlurEvent(cm) {
  cm.state.delayingBlurEvent = true;
  setTimeout(function () { if (cm.state.delayingBlurEvent) {
    cm.state.delayingBlurEvent = false;
    onBlur(cm);
  } }, 100);
}

function onFocus(cm, e) {
  if (cm.state.delayingBlurEvent) { cm.state.delayingBlurEvent = false; }

  if (cm.options.readOnly == "nocursor") { return }
  if (!cm.state.focused) {
    signal(cm, "focus", cm, e);
    cm.state.focused = true;
    addClass(cm.display.wrapper, "CodeMirror-focused");
    // This test prevents this from firing when a context
    // menu is closed (since the input reset would kill the
    // select-all detection hack)
    if (!cm.curOp && cm.display.selForContextMenu != cm.doc.sel) {
      cm.display.input.reset();
      if (webkit) { setTimeout(function () { return cm.display.input.reset(true); }, 20); } // Issue #1730
    }
    cm.display.input.receivedFocus();
  }
  restartBlink(cm);
}
function onBlur(cm, e) {
  if (cm.state.delayingBlurEvent) { return }

  if (cm.state.focused) {
    signal(cm, "blur", cm, e);
    cm.state.focused = false;
    rmClass(cm.display.wrapper, "CodeMirror-focused");
  }
  clearInterval(cm.display.blinker);
  setTimeout(function () { if (!cm.state.focused) { cm.display.shift = false; } }, 150);
}

// Read the actual heights of the rendered lines, and update their
// stored heights to match.
function updateHeightsInViewport(cm) {
  var display = cm.display;
  var prevBottom = display.lineDiv.offsetTop;
  for (var i = 0; i < display.view.length; i++) {
    var cur = display.view[i], height = (void 0);
    if (cur.hidden) { continue }
    if (ie && ie_version < 8) {
      var bot = cur.node.offsetTop + cur.node.offsetHeight;
      height = bot - prevBottom;
      prevBottom = bot;
    } else {
      var box = cur.node.getBoundingClientRect();
      height = box.bottom - box.top;
    }
    var diff = cur.line.height - height;
    if (height < 2) { height = textHeight(display); }
    if (diff > .005 || diff < -.005) {
      updateLineHeight(cur.line, height);
      updateWidgetHeight(cur.line);
      if (cur.rest) { for (var j = 0; j < cur.rest.length; j++)
        { updateWidgetHeight(cur.rest[j]); } }
    }
  }
}

// Read and store the height of line widgets associated with the
// given line.
function updateWidgetHeight(line) {
  if (line.widgets) { for (var i = 0; i < line.widgets.length; ++i)
    { line.widgets[i].height = line.widgets[i].node.parentNode.offsetHeight; } }
}

// Compute the lines that are visible in a given viewport (defaults
// the the current scroll position). viewport may contain top,
// height, and ensure (see op.scrollToPos) properties.
function visibleLines(display, doc, viewport) {
  var top = viewport && viewport.top != null ? Math.max(0, viewport.top) : display.scroller.scrollTop;
  top = Math.floor(top - paddingTop(display));
  var bottom = viewport && viewport.bottom != null ? viewport.bottom : top + display.wrapper.clientHeight;

  var from = lineAtHeight(doc, top), to = lineAtHeight(doc, bottom);
  // Ensure is a {from: {line, ch}, to: {line, ch}} object, and
  // forces those lines into the viewport (if possible).
  if (viewport && viewport.ensure) {
    var ensureFrom = viewport.ensure.from.line, ensureTo = viewport.ensure.to.line;
    if (ensureFrom < from) {
      from = ensureFrom;
      to = lineAtHeight(doc, heightAtLine(getLine(doc, ensureFrom)) + display.wrapper.clientHeight);
    } else if (Math.min(ensureTo, doc.lastLine()) >= to) {
      from = lineAtHeight(doc, heightAtLine(getLine(doc, ensureTo)) - display.wrapper.clientHeight);
      to = ensureTo;
    }
  }
  return {from: from, to: Math.max(to, from + 1)}
}

// Re-align line numbers and gutter marks to compensate for
// horizontal scrolling.
function alignHorizontally(cm) {
  var display = cm.display, view = display.view;
  if (!display.alignWidgets && (!display.gutters.firstChild || !cm.options.fixedGutter)) { return }
  var comp = compensateForHScroll(display) - display.scroller.scrollLeft + cm.doc.scrollLeft;
  var gutterW = display.gutters.offsetWidth, left = comp + "px";
  for (var i = 0; i < view.length; i++) { if (!view[i].hidden) {
    if (cm.options.fixedGutter) {
      if (view[i].gutter)
        { view[i].gutter.style.left = left; }
      if (view[i].gutterBackground)
        { view[i].gutterBackground.style.left = left; }
    }
    var align = view[i].alignable;
    if (align) { for (var j = 0; j < align.length; j++)
      { align[j].style.left = left; } }
  } }
  if (cm.options.fixedGutter)
    { display.gutters.style.left = (comp + gutterW) + "px"; }
}

// Used to ensure that the line number gutter is still the right
// size for the current document size. Returns true when an update
// is needed.
function maybeUpdateLineNumberWidth(cm) {
  if (!cm.options.lineNumbers) { return false }
  var doc = cm.doc, last = lineNumberFor(cm.options, doc.first + doc.size - 1), display = cm.display;
  if (last.length != display.lineNumChars) {
    var test = display.measure.appendChild(elt("div", [elt("div", last)],
                                               "CodeMirror-linenumber CodeMirror-gutter-elt"));
    var innerW = test.firstChild.offsetWidth, padding = test.offsetWidth - innerW;
    display.lineGutter.style.width = "";
    display.lineNumInnerWidth = Math.max(innerW, display.lineGutter.offsetWidth - padding) + 1;
    display.lineNumWidth = display.lineNumInnerWidth + padding;
    display.lineNumChars = display.lineNumInnerWidth ? last.length : -1;
    display.lineGutter.style.width = display.lineNumWidth + "px";
    updateGutterSpace(cm);
    return true
  }
  return false
}

// SCROLLING THINGS INTO VIEW

// If an editor sits on the top or bottom of the window, partially
// scrolled out of view, this ensures that the cursor is visible.
function maybeScrollWindow(cm, rect) {
  if (signalDOMEvent(cm, "scrollCursorIntoView")) { return }

  var display = cm.display, box = display.sizer.getBoundingClientRect(), doScroll = null;
  if (rect.top + box.top < 0) { doScroll = true; }
  else if (rect.bottom + box.top > (window.innerHeight || document.documentElement.clientHeight)) { doScroll = false; }
  if (doScroll != null && !phantom) {
    var scrollNode = elt("div", "\u200b", null, ("position: absolute;\n                         top: " + (rect.top - display.viewOffset - paddingTop(cm.display)) + "px;\n                         height: " + (rect.bottom - rect.top + scrollGap(cm) + display.barHeight) + "px;\n                         left: " + (rect.left) + "px; width: " + (Math.max(2, rect.right - rect.left)) + "px;"));
    cm.display.lineSpace.appendChild(scrollNode);
    scrollNode.scrollIntoView(doScroll);
    cm.display.lineSpace.removeChild(scrollNode);
  }
}

// Scroll a given position into view (immediately), verifying that
// it actually became visible (as line heights are accurately
// measured, the position of something may 'drift' during drawing).
function scrollPosIntoView(cm, pos, end, margin) {
  if (margin == null) { margin = 0; }
  var rect;
  if (!cm.options.lineWrapping && pos == end) {
    // Set pos and end to the cursor positions around the character pos sticks to
    // If pos.sticky == "before", that is around pos.ch - 1, otherwise around pos.ch
    // If pos == Pos(_, 0, "before"), pos and end are unchanged
    pos = pos.ch ? Pos(pos.line, pos.sticky == "before" ? pos.ch - 1 : pos.ch, "after") : pos;
    end = pos.sticky == "before" ? Pos(pos.line, pos.ch + 1, "before") : pos;
  }
  for (var limit = 0; limit < 5; limit++) {
    var changed = false;
    var coords = cursorCoords(cm, pos);
    var endCoords = !end || end == pos ? coords : cursorCoords(cm, end);
    rect = {left: Math.min(coords.left, endCoords.left),
            top: Math.min(coords.top, endCoords.top) - margin,
            right: Math.max(coords.left, endCoords.left),
            bottom: Math.max(coords.bottom, endCoords.bottom) + margin};
    var scrollPos = calculateScrollPos(cm, rect);
    var startTop = cm.doc.scrollTop, startLeft = cm.doc.scrollLeft;
    if (scrollPos.scrollTop != null) {
      updateScrollTop(cm, scrollPos.scrollTop);
      if (Math.abs(cm.doc.scrollTop - startTop) > 1) { changed = true; }
    }
    if (scrollPos.scrollLeft != null) {
      setScrollLeft(cm, scrollPos.scrollLeft);
      if (Math.abs(cm.doc.scrollLeft - startLeft) > 1) { changed = true; }
    }
    if (!changed) { break }
  }
  return rect
}

// Scroll a given set of coordinates into view (immediately).
function scrollIntoView(cm, rect) {
  var scrollPos = calculateScrollPos(cm, rect);
  if (scrollPos.scrollTop != null) { updateScrollTop(cm, scrollPos.scrollTop); }
  if (scrollPos.scrollLeft != null) { setScrollLeft(cm, scrollPos.scrollLeft); }
}

// Calculate a new scroll position needed to scroll the given
// rectangle into view. Returns an object with scrollTop and
// scrollLeft properties. When these are undefined, the
// vertical/horizontal position does not need to be adjusted.
function calculateScrollPos(cm, rect) {
  var display = cm.display, snapMargin = textHeight(cm.display);
  if (rect.top < 0) { rect.top = 0; }
  var screentop = cm.curOp && cm.curOp.scrollTop != null ? cm.curOp.scrollTop : display.scroller.scrollTop;
  var screen = displayHeight(cm), result = {};
  if (rect.bottom - rect.top > screen) { rect.bottom = rect.top + screen; }
  var docBottom = cm.doc.height + paddingVert(display);
  var atTop = rect.top < snapMargin, atBottom = rect.bottom > docBottom - snapMargin;
  if (rect.top < screentop) {
    result.scrollTop = atTop ? 0 : rect.top;
  } else if (rect.bottom > screentop + screen) {
    var newTop = Math.min(rect.top, (atBottom ? docBottom : rect.bottom) - screen);
    if (newTop != screentop) { result.scrollTop = newTop; }
  }

  var screenleft = cm.curOp && cm.curOp.scrollLeft != null ? cm.curOp.scrollLeft : display.scroller.scrollLeft;
  var screenw = displayWidth(cm) - (cm.options.fixedGutter ? display.gutters.offsetWidth : 0);
  var tooWide = rect.right - rect.left > screenw;
  if (tooWide) { rect.right = rect.left + screenw; }
  if (rect.left < 10)
    { result.scrollLeft = 0; }
  else if (rect.left < screenleft)
    { result.scrollLeft = Math.max(0, rect.left - (tooWide ? 0 : 10)); }
  else if (rect.right > screenw + screenleft - 3)
    { result.scrollLeft = rect.right + (tooWide ? 0 : 10) - screenw; }
  return result
}

// Store a relative adjustment to the scroll position in the current
// operation (to be applied when the operation finishes).
function addToScrollTop(cm, top) {
  if (top == null) { return }
  resolveScrollToPos(cm);
  cm.curOp.scrollTop = (cm.curOp.scrollTop == null ? cm.doc.scrollTop : cm.curOp.scrollTop) + top;
}

// Make sure that at the end of the operation the current cursor is
// shown.
function ensureCursorVisible(cm) {
  resolveScrollToPos(cm);
  var cur = cm.getCursor();
  cm.curOp.scrollToPos = {from: cur, to: cur, margin: cm.options.cursorScrollMargin};
}

function scrollToCoords(cm, x, y) {
  if (x != null || y != null) { resolveScrollToPos(cm); }
  if (x != null) { cm.curOp.scrollLeft = x; }
  if (y != null) { cm.curOp.scrollTop = y; }
}

function scrollToRange(cm, range$$1) {
  resolveScrollToPos(cm);
  cm.curOp.scrollToPos = range$$1;
}

// When an operation has its scrollToPos property set, and another
// scroll action is applied before the end of the operation, this
// 'simulates' scrolling that position into view in a cheap way, so
// that the effect of intermediate scroll commands is not ignored.
function resolveScrollToPos(cm) {
  var range$$1 = cm.curOp.scrollToPos;
  if (range$$1) {
    cm.curOp.scrollToPos = null;
    var from = estimateCoords(cm, range$$1.from), to = estimateCoords(cm, range$$1.to);
    scrollToCoordsRange(cm, from, to, range$$1.margin);
  }
}

function scrollToCoordsRange(cm, from, to, margin) {
  var sPos = calculateScrollPos(cm, {
    left: Math.min(from.left, to.left),
    top: Math.min(from.top, to.top) - margin,
    right: Math.max(from.right, to.right),
    bottom: Math.max(from.bottom, to.bottom) + margin
  });
  scrollToCoords(cm, sPos.scrollLeft, sPos.scrollTop);
}

// Sync the scrollable area and scrollbars, ensure the viewport
// covers the visible area.
function updateScrollTop(cm, val) {
  if (Math.abs(cm.doc.scrollTop - val) < 2) { return }
  if (!gecko) { updateDisplaySimple(cm, {top: val}); }
  setScrollTop(cm, val, true);
  if (gecko) { updateDisplaySimple(cm); }
  startWorker(cm, 100);
}

function setScrollTop(cm, val, forceScroll) {
  val = Math.min(cm.display.scroller.scrollHeight - cm.display.scroller.clientHeight, val);
  if (cm.display.scroller.scrollTop == val && !forceScroll) { return }
  cm.doc.scrollTop = val;
  cm.display.scrollbars.setScrollTop(val);
  if (cm.display.scroller.scrollTop != val) { cm.display.scroller.scrollTop = val; }
}

// Sync scroller and scrollbar, ensure the gutter elements are
// aligned.
function setScrollLeft(cm, val, isScroller, forceScroll) {
  val = Math.min(val, cm.display.scroller.scrollWidth - cm.display.scroller.clientWidth);
  if ((isScroller ? val == cm.doc.scrollLeft : Math.abs(cm.doc.scrollLeft - val) < 2) && !forceScroll) { return }
  cm.doc.scrollLeft = val;
  alignHorizontally(cm);
  if (cm.display.scroller.scrollLeft != val) { cm.display.scroller.scrollLeft = val; }
  cm.display.scrollbars.setScrollLeft(val);
}

// SCROLLBARS

// Prepare DOM reads needed to update the scrollbars. Done in one
// shot to minimize update/measure roundtrips.
function measureForScrollbars(cm) {
  var d = cm.display, gutterW = d.gutters.offsetWidth;
  var docH = Math.round(cm.doc.height + paddingVert(cm.display));
  return {
    clientHeight: d.scroller.clientHeight,
    viewHeight: d.wrapper.clientHeight,
    scrollWidth: d.scroller.scrollWidth, clientWidth: d.scroller.clientWidth,
    viewWidth: d.wrapper.clientWidth,
    barLeft: cm.options.fixedGutter ? gutterW : 0,
    docHeight: docH,
    scrollHeight: docH + scrollGap(cm) + d.barHeight,
    nativeBarWidth: d.nativeBarWidth,
    gutterWidth: gutterW
  }
}

var NativeScrollbars = function(place, scroll, cm) {
  this.cm = cm;
  var vert = this.vert = elt("div", [elt("div", null, null, "min-width: 1px")], "CodeMirror-vscrollbar");
  var horiz = this.horiz = elt("div", [elt("div", null, null, "height: 100%; min-height: 1px")], "CodeMirror-hscrollbar");
  place(vert); place(horiz);

  on(vert, "scroll", function () {
    if (vert.clientHeight) { scroll(vert.scrollTop, "vertical"); }
  });
  on(horiz, "scroll", function () {
    if (horiz.clientWidth) { scroll(horiz.scrollLeft, "horizontal"); }
  });

  this.checkedZeroWidth = false;
  // Need to set a minimum width to see the scrollbar on IE7 (but must not set it on IE8).
  if (ie && ie_version < 8) { this.horiz.style.minHeight = this.vert.style.minWidth = "18px"; }
};

NativeScrollbars.prototype.update = function (measure) {
  var needsH = measure.scrollWidth > measure.clientWidth + 1;
  var needsV = measure.scrollHeight > measure.clientHeight + 1;
  var sWidth = measure.nativeBarWidth;

  if (needsV) {
    this.vert.style.display = "block";
    this.vert.style.bottom = needsH ? sWidth + "px" : "0";
    var totalHeight = measure.viewHeight - (needsH ? sWidth : 0);
    // A bug in IE8 can cause this value to be negative, so guard it.
    this.vert.firstChild.style.height =
      Math.max(0, measure.scrollHeight - measure.clientHeight + totalHeight) + "px";
  } else {
    this.vert.style.display = "";
    this.vert.firstChild.style.height = "0";
  }

  if (needsH) {
    this.horiz.style.display = "block";
    this.horiz.style.right = needsV ? sWidth + "px" : "0";
    this.horiz.style.left = measure.barLeft + "px";
    var totalWidth = measure.viewWidth - measure.barLeft - (needsV ? sWidth : 0);
    this.horiz.firstChild.style.width =
      Math.max(0, measure.scrollWidth - measure.clientWidth + totalWidth) + "px";
  } else {
    this.horiz.style.display = "";
    this.horiz.firstChild.style.width = "0";
  }

  if (!this.checkedZeroWidth && measure.clientHeight > 0) {
    if (sWidth == 0) { this.zeroWidthHack(); }
    this.checkedZeroWidth = true;
  }

  return {right: needsV ? sWidth : 0, bottom: needsH ? sWidth : 0}
};

NativeScrollbars.prototype.setScrollLeft = function (pos) {
  if (this.horiz.scrollLeft != pos) { this.horiz.scrollLeft = pos; }
  if (this.disableHoriz) { this.enableZeroWidthBar(this.horiz, this.disableHoriz, "horiz"); }
};

NativeScrollbars.prototype.setScrollTop = function (pos) {
  if (this.vert.scrollTop != pos) { this.vert.scrollTop = pos; }
  if (this.disableVert) { this.enableZeroWidthBar(this.vert, this.disableVert, "vert"); }
};

NativeScrollbars.prototype.zeroWidthHack = function () {
  var w = mac && !mac_geMountainLion ? "12px" : "18px";
  this.horiz.style.height = this.vert.style.width = w;
  this.horiz.style.pointerEvents = this.vert.style.pointerEvents = "none";
  this.disableHoriz = new Delayed;
  this.disableVert = new Delayed;
};

NativeScrollbars.prototype.enableZeroWidthBar = function (bar, delay, type) {
  bar.style.pointerEvents = "auto";
  function maybeDisable() {
    // To find out whether the scrollbar is still visible, we
    // check whether the element under the pixel in the bottom
    // right corner of the scrollbar box is the scrollbar box
    // itself (when the bar is still visible) or its filler child
    // (when the bar is hidden). If it is still visible, we keep
    // it enabled, if it's hidden, we disable pointer events.
    var box = bar.getBoundingClientRect();
    var elt$$1 = type == "vert" ? document.elementFromPoint(box.right - 1, (box.top + box.bottom) / 2)
        : document.elementFromPoint((box.right + box.left) / 2, box.bottom - 1);
    if (elt$$1 != bar) { bar.style.pointerEvents = "none"; }
    else { delay.set(1000, maybeDisable); }
  }
  delay.set(1000, maybeDisable);
};

NativeScrollbars.prototype.clear = function () {
  var parent = this.horiz.parentNode;
  parent.removeChild(this.horiz);
  parent.removeChild(this.vert);
};

var NullScrollbars = function () {};

NullScrollbars.prototype.update = function () { return {bottom: 0, right: 0} };
NullScrollbars.prototype.setScrollLeft = function () {};
NullScrollbars.prototype.setScrollTop = function () {};
NullScrollbars.prototype.clear = function () {};

function updateScrollbars(cm, measure) {
  if (!measure) { measure = measureForScrollbars(cm); }
  var startWidth = cm.display.barWidth, startHeight = cm.display.barHeight;
  updateScrollbarsInner(cm, measure);
  for (var i = 0; i < 4 && startWidth != cm.display.barWidth || startHeight != cm.display.barHeight; i++) {
    if (startWidth != cm.display.barWidth && cm.options.lineWrapping)
      { updateHeightsInViewport(cm); }
    updateScrollbarsInner(cm, measureForScrollbars(cm));
    startWidth = cm.display.barWidth; startHeight = cm.display.barHeight;
  }
}

// Re-synchronize the fake scrollbars with the actual size of the
// content.
function updateScrollbarsInner(cm, measure) {
  var d = cm.display;
  var sizes = d.scrollbars.update(measure);

  d.sizer.style.paddingRight = (d.barWidth = sizes.right) + "px";
  d.sizer.style.paddingBottom = (d.barHeight = sizes.bottom) + "px";
  d.heightForcer.style.borderBottom = sizes.bottom + "px solid transparent";

  if (sizes.right && sizes.bottom) {
    d.scrollbarFiller.style.display = "block";
    d.scrollbarFiller.style.height = sizes.bottom + "px";
    d.scrollbarFiller.style.width = sizes.right + "px";
  } else { d.scrollbarFiller.style.display = ""; }
  if (sizes.bottom && cm.options.coverGutterNextToScrollbar && cm.options.fixedGutter) {
    d.gutterFiller.style.display = "block";
    d.gutterFiller.style.height = sizes.bottom + "px";
    d.gutterFiller.style.width = measure.gutterWidth + "px";
  } else { d.gutterFiller.style.display = ""; }
}

var scrollbarModel = {"native": NativeScrollbars, "null": NullScrollbars};

function initScrollbars(cm) {
  if (cm.display.scrollbars) {
    cm.display.scrollbars.clear();
    if (cm.display.scrollbars.addClass)
      { rmClass(cm.display.wrapper, cm.display.scrollbars.addClass); }
  }

  cm.display.scrollbars = new scrollbarModel[cm.options.scrollbarStyle](function (node) {
    cm.display.wrapper.insertBefore(node, cm.display.scrollbarFiller);
    // Prevent clicks in the scrollbars from killing focus
    on(node, "mousedown", function () {
      if (cm.state.focused) { setTimeout(function () { return cm.display.input.focus(); }, 0); }
    });
    node.setAttribute("cm-not-content", "true");
  }, function (pos, axis) {
    if (axis == "horizontal") { setScrollLeft(cm, pos); }
    else { updateScrollTop(cm, pos); }
  }, cm);
  if (cm.display.scrollbars.addClass)
    { addClass(cm.display.wrapper, cm.display.scrollbars.addClass); }
}

// Operations are used to wrap a series of changes to the editor
// state in such a way that each change won't have to update the
// cursor and display (which would be awkward, slow, and
// error-prone). Instead, display updates are batched and then all
// combined and executed at once.

var nextOpId = 0;
// Start a new operation.
function startOperation(cm) {
  cm.curOp = {
    cm: cm,
    viewChanged: false,      // Flag that indicates that lines might need to be redrawn
    startHeight: cm.doc.height, // Used to detect need to update scrollbar
    forceUpdate: false,      // Used to force a redraw
    updateInput: null,       // Whether to reset the input textarea
    typing: false,           // Whether this reset should be careful to leave existing text (for compositing)
    changeObjs: null,        // Accumulated changes, for firing change events
    cursorActivityHandlers: null, // Set of handlers to fire cursorActivity on
    cursorActivityCalled: 0, // Tracks which cursorActivity handlers have been called already
    selectionChanged: false, // Whether the selection needs to be redrawn
    updateMaxLine: false,    // Set when the widest line needs to be determined anew
    scrollLeft: null, scrollTop: null, // Intermediate scroll position, not pushed to DOM yet
    scrollToPos: null,       // Used to scroll to a specific position
    focus: false,
    id: ++nextOpId           // Unique ID
  };
  pushOperation(cm.curOp);
}

// Finish an operation, updating the display and signalling delayed events
function endOperation(cm) {
  var op = cm.curOp;
  finishOperation(op, function (group) {
    for (var i = 0; i < group.ops.length; i++)
      { group.ops[i].cm.curOp = null; }
    endOperations(group);
  });
}

// The DOM updates done when an operation finishes are batched so
// that the minimum number of relayouts are required.
function endOperations(group) {
  var ops = group.ops;
  for (var i = 0; i < ops.length; i++) // Read DOM
    { endOperation_R1(ops[i]); }
  for (var i$1 = 0; i$1 < ops.length; i$1++) // Write DOM (maybe)
    { endOperation_W1(ops[i$1]); }
  for (var i$2 = 0; i$2 < ops.length; i$2++) // Read DOM
    { endOperation_R2(ops[i$2]); }
  for (var i$3 = 0; i$3 < ops.length; i$3++) // Write DOM (maybe)
    { endOperation_W2(ops[i$3]); }
  for (var i$4 = 0; i$4 < ops.length; i$4++) // Read DOM
    { endOperation_finish(ops[i$4]); }
}

function endOperation_R1(op) {
  var cm = op.cm, display = cm.display;
  maybeClipScrollbars(cm);
  if (op.updateMaxLine) { findMaxLine(cm); }

  op.mustUpdate = op.viewChanged || op.forceUpdate || op.scrollTop != null ||
    op.scrollToPos && (op.scrollToPos.from.line < display.viewFrom ||
                       op.scrollToPos.to.line >= display.viewTo) ||
    display.maxLineChanged && cm.options.lineWrapping;
  op.update = op.mustUpdate &&
    new DisplayUpdate(cm, op.mustUpdate && {top: op.scrollTop, ensure: op.scrollToPos}, op.forceUpdate);
}

function endOperation_W1(op) {
  op.updatedDisplay = op.mustUpdate && updateDisplayIfNeeded(op.cm, op.update);
}

function endOperation_R2(op) {
  var cm = op.cm, display = cm.display;
  if (op.updatedDisplay) { updateHeightsInViewport(cm); }

  op.barMeasure = measureForScrollbars(cm);

  // If the max line changed since it was last measured, measure it,
  // and ensure the document's width matches it.
  // updateDisplay_W2 will use these properties to do the actual resizing
  if (display.maxLineChanged && !cm.options.lineWrapping) {
    op.adjustWidthTo = measureChar(cm, display.maxLine, display.maxLine.text.length).left + 3;
    cm.display.sizerWidth = op.adjustWidthTo;
    op.barMeasure.scrollWidth =
      Math.max(display.scroller.clientWidth, display.sizer.offsetLeft + op.adjustWidthTo + scrollGap(cm) + cm.display.barWidth);
    op.maxScrollLeft = Math.max(0, display.sizer.offsetLeft + op.adjustWidthTo - displayWidth(cm));
  }

  if (op.updatedDisplay || op.selectionChanged)
    { op.preparedSelection = display.input.prepareSelection(op.focus); }
}

function endOperation_W2(op) {
  var cm = op.cm;

  if (op.adjustWidthTo != null) {
    cm.display.sizer.style.minWidth = op.adjustWidthTo + "px";
    if (op.maxScrollLeft < cm.doc.scrollLeft)
      { setScrollLeft(cm, Math.min(cm.display.scroller.scrollLeft, op.maxScrollLeft), true); }
    cm.display.maxLineChanged = false;
  }

  var takeFocus = op.focus && op.focus == activeElt() && (!document.hasFocus || document.hasFocus());
  if (op.preparedSelection)
    { cm.display.input.showSelection(op.preparedSelection, takeFocus); }
  if (op.updatedDisplay || op.startHeight != cm.doc.height)
    { updateScrollbars(cm, op.barMeasure); }
  if (op.updatedDisplay)
    { setDocumentHeight(cm, op.barMeasure); }

  if (op.selectionChanged) { restartBlink(cm); }

  if (cm.state.focused && op.updateInput)
    { cm.display.input.reset(op.typing); }
  if (takeFocus) { ensureFocus(op.cm); }
}

function endOperation_finish(op) {
  var cm = op.cm, display = cm.display, doc = cm.doc;

  if (op.updatedDisplay) { postUpdateDisplay(cm, op.update); }

  // Abort mouse wheel delta measurement, when scrolling explicitly
  if (display.wheelStartX != null && (op.scrollTop != null || op.scrollLeft != null || op.scrollToPos))
    { display.wheelStartX = display.wheelStartY = null; }

  // Propagate the scroll position to the actual DOM scroller
  if (op.scrollTop != null) { setScrollTop(cm, op.scrollTop, op.forceScroll); }

  if (op.scrollLeft != null) { setScrollLeft(cm, op.scrollLeft, true, true); }
  // If we need to scroll a specific position into view, do so.
  if (op.scrollToPos) {
    var rect = scrollPosIntoView(cm, clipPos(doc, op.scrollToPos.from),
                                 clipPos(doc, op.scrollToPos.to), op.scrollToPos.margin);
    maybeScrollWindow(cm, rect);
  }

  // Fire events for markers that are hidden/unidden by editing or
  // undoing
  var hidden = op.maybeHiddenMarkers, unhidden = op.maybeUnhiddenMarkers;
  if (hidden) { for (var i = 0; i < hidden.length; ++i)
    { if (!hidden[i].lines.length) { signal(hidden[i], "hide"); } } }
  if (unhidden) { for (var i$1 = 0; i$1 < unhidden.length; ++i$1)
    { if (unhidden[i$1].lines.length) { signal(unhidden[i$1], "unhide"); } } }

  if (display.wrapper.offsetHeight)
    { doc.scrollTop = cm.display.scroller.scrollTop; }

  // Fire change events, and delayed event handlers
  if (op.changeObjs)
    { signal(cm, "changes", cm, op.changeObjs); }
  if (op.update)
    { op.update.finish(); }
}

// Run the given function in an operation
function runInOp(cm, f) {
  if (cm.curOp) { return f() }
  startOperation(cm);
  try { return f() }
  finally { endOperation(cm); }
}
// Wraps a function in an operation. Returns the wrapped function.
function operation(cm, f) {
  return function() {
    if (cm.curOp) { return f.apply(cm, arguments) }
    startOperation(cm);
    try { return f.apply(cm, arguments) }
    finally { endOperation(cm); }
  }
}
// Used to add methods to editor and doc instances, wrapping them in
// operations.
function methodOp(f) {
  return function() {
    if (this.curOp) { return f.apply(this, arguments) }
    startOperation(this);
    try { return f.apply(this, arguments) }
    finally { endOperation(this); }
  }
}
function docMethodOp(f) {
  return function() {
    var cm = this.cm;
    if (!cm || cm.curOp) { return f.apply(this, arguments) }
    startOperation(cm);
    try { return f.apply(this, arguments) }
    finally { endOperation(cm); }
  }
}

// Updates the display.view data structure for a given change to the
// document. From and to are in pre-change coordinates. Lendiff is
// the amount of lines added or subtracted by the change. This is
// used for changes that span multiple lines, or change the way
// lines are divided into visual lines. regLineChange (below)
// registers single-line changes.
function regChange(cm, from, to, lendiff) {
  if (from == null) { from = cm.doc.first; }
  if (to == null) { to = cm.doc.first + cm.doc.size; }
  if (!lendiff) { lendiff = 0; }

  var display = cm.display;
  if (lendiff && to < display.viewTo &&
      (display.updateLineNumbers == null || display.updateLineNumbers > from))
    { display.updateLineNumbers = from; }

  cm.curOp.viewChanged = true;

  if (from >= display.viewTo) { // Change after
    if (sawCollapsedSpans && visualLineNo(cm.doc, from) < display.viewTo)
      { resetView(cm); }
  } else if (to <= display.viewFrom) { // Change before
    if (sawCollapsedSpans && visualLineEndNo(cm.doc, to + lendiff) > display.viewFrom) {
      resetView(cm);
    } else {
      display.viewFrom += lendiff;
      display.viewTo += lendiff;
    }
  } else if (from <= display.viewFrom && to >= display.viewTo) { // Full overlap
    resetView(cm);
  } else if (from <= display.viewFrom) { // Top overlap
    var cut = viewCuttingPoint(cm, to, to + lendiff, 1);
    if (cut) {
      display.view = display.view.slice(cut.index);
      display.viewFrom = cut.lineN;
      display.viewTo += lendiff;
    } else {
      resetView(cm);
    }
  } else if (to >= display.viewTo) { // Bottom overlap
    var cut$1 = viewCuttingPoint(cm, from, from, -1);
    if (cut$1) {
      display.view = display.view.slice(0, cut$1.index);
      display.viewTo = cut$1.lineN;
    } else {
      resetView(cm);
    }
  } else { // Gap in the middle
    var cutTop = viewCuttingPoint(cm, from, from, -1);
    var cutBot = viewCuttingPoint(cm, to, to + lendiff, 1);
    if (cutTop && cutBot) {
      display.view = display.view.slice(0, cutTop.index)
        .concat(buildViewArray(cm, cutTop.lineN, cutBot.lineN))
        .concat(display.view.slice(cutBot.index));
      display.viewTo += lendiff;
    } else {
      resetView(cm);
    }
  }

  var ext = display.externalMeasured;
  if (ext) {
    if (to < ext.lineN)
      { ext.lineN += lendiff; }
    else if (from < ext.lineN + ext.size)
      { display.externalMeasured = null; }
  }
}

// Register a change to a single line. Type must be one of "text",
// "gutter", "class", "widget"
function regLineChange(cm, line, type) {
  cm.curOp.viewChanged = true;
  var display = cm.display, ext = cm.display.externalMeasured;
  if (ext && line >= ext.lineN && line < ext.lineN + ext.size)
    { display.externalMeasured = null; }

  if (line < display.viewFrom || line >= display.viewTo) { return }
  var lineView = display.view[findViewIndex(cm, line)];
  if (lineView.node == null) { return }
  var arr = lineView.changes || (lineView.changes = []);
  if (indexOf(arr, type) == -1) { arr.push(type); }
}

// Clear the view.
function resetView(cm) {
  cm.display.viewFrom = cm.display.viewTo = cm.doc.first;
  cm.display.view = [];
  cm.display.viewOffset = 0;
}

function viewCuttingPoint(cm, oldN, newN, dir) {
  var index = findViewIndex(cm, oldN), diff, view = cm.display.view;
  if (!sawCollapsedSpans || newN == cm.doc.first + cm.doc.size)
    { return {index: index, lineN: newN} }
  var n = cm.display.viewFrom;
  for (var i = 0; i < index; i++)
    { n += view[i].size; }
  if (n != oldN) {
    if (dir > 0) {
      if (index == view.length - 1) { return null }
      diff = (n + view[index].size) - oldN;
      index++;
    } else {
      diff = n - oldN;
    }
    oldN += diff; newN += diff;
  }
  while (visualLineNo(cm.doc, newN) != newN) {
    if (index == (dir < 0 ? 0 : view.length - 1)) { return null }
    newN += dir * view[index - (dir < 0 ? 1 : 0)].size;
    index += dir;
  }
  return {index: index, lineN: newN}
}

// Force the view to cover a given range, adding empty view element
// or clipping off existing ones as needed.
function adjustView(cm, from, to) {
  var display = cm.display, view = display.view;
  if (view.length == 0 || from >= display.viewTo || to <= display.viewFrom) {
    display.view = buildViewArray(cm, from, to);
    display.viewFrom = from;
  } else {
    if (display.viewFrom > from)
      { display.view = buildViewArray(cm, from, display.viewFrom).concat(display.view); }
    else if (display.viewFrom < from)
      { display.view = display.view.slice(findViewIndex(cm, from)); }
    display.viewFrom = from;
    if (display.viewTo < to)
      { display.view = display.view.concat(buildViewArray(cm, display.viewTo, to)); }
    else if (display.viewTo > to)
      { display.view = display.view.slice(0, findViewIndex(cm, to)); }
  }
  display.viewTo = to;
}

// Count the number of lines in the view whose DOM representation is
// out of date (or nonexistent).
function countDirtyView(cm) {
  var view = cm.display.view, dirty = 0;
  for (var i = 0; i < view.length; i++) {
    var lineView = view[i];
    if (!lineView.hidden && (!lineView.node || lineView.changes)) { ++dirty; }
  }
  return dirty
}

// HIGHLIGHT WORKER

function startWorker(cm, time) {
  if (cm.doc.highlightFrontier < cm.display.viewTo)
    { cm.state.highlight.set(time, bind(highlightWorker, cm)); }
}

function highlightWorker(cm) {
  var doc = cm.doc;
  if (doc.highlightFrontier >= cm.display.viewTo) { return }
  var end = +new Date + cm.options.workTime;
  var context = getContextBefore(cm, doc.highlightFrontier);
  var changedLines = [];

  doc.iter(context.line, Math.min(doc.first + doc.size, cm.display.viewTo + 500), function (line) {
    if (context.line >= cm.display.viewFrom) { // Visible
      var oldStyles = line.styles;
      var resetState = line.text.length > cm.options.maxHighlightLength ? copyState(doc.mode, context.state) : null;
      var highlighted = highlightLine(cm, line, context, true);
      if (resetState) { context.state = resetState; }
      line.styles = highlighted.styles;
      var oldCls = line.styleClasses, newCls = highlighted.classes;
      if (newCls) { line.styleClasses = newCls; }
      else if (oldCls) { line.styleClasses = null; }
      var ischange = !oldStyles || oldStyles.length != line.styles.length ||
        oldCls != newCls && (!oldCls || !newCls || oldCls.bgClass != newCls.bgClass || oldCls.textClass != newCls.textClass);
      for (var i = 0; !ischange && i < oldStyles.length; ++i) { ischange = oldStyles[i] != line.styles[i]; }
      if (ischange) { changedLines.push(context.line); }
      line.stateAfter = context.save();
      context.nextLine();
    } else {
      if (line.text.length <= cm.options.maxHighlightLength)
        { processLine(cm, line.text, context); }
      line.stateAfter = context.line % 5 == 0 ? context.save() : null;
      context.nextLine();
    }
    if (+new Date > end) {
      startWorker(cm, cm.options.workDelay);
      return true
    }
  });
  doc.highlightFrontier = context.line;
  doc.modeFrontier = Math.max(doc.modeFrontier, context.line);
  if (changedLines.length) { runInOp(cm, function () {
    for (var i = 0; i < changedLines.length; i++)
      { regLineChange(cm, changedLines[i], "text"); }
  }); }
}

// DISPLAY DRAWING

var DisplayUpdate = function(cm, viewport, force) {
  var display = cm.display;

  this.viewport = viewport;
  // Store some values that we'll need later (but don't want to force a relayout for)
  this.visible = visibleLines(display, cm.doc, viewport);
  this.editorIsHidden = !display.wrapper.offsetWidth;
  this.wrapperHeight = display.wrapper.clientHeight;
  this.wrapperWidth = display.wrapper.clientWidth;
  this.oldDisplayWidth = displayWidth(cm);
  this.force = force;
  this.dims = getDimensions(cm);
  this.events = [];
};

DisplayUpdate.prototype.signal = function (emitter, type) {
  if (hasHandler(emitter, type))
    { this.events.push(arguments); }
};
DisplayUpdate.prototype.finish = function () {
    var this$1 = this;

  for (var i = 0; i < this.events.length; i++)
    { signal.apply(null, this$1.events[i]); }
};

function maybeClipScrollbars(cm) {
  var display = cm.display;
  if (!display.scrollbarsClipped && display.scroller.offsetWidth) {
    display.nativeBarWidth = display.scroller.offsetWidth - display.scroller.clientWidth;
    display.heightForcer.style.height = scrollGap(cm) + "px";
    display.sizer.style.marginBottom = -display.nativeBarWidth + "px";
    display.sizer.style.borderRightWidth = scrollGap(cm) + "px";
    display.scrollbarsClipped = true;
  }
}

function selectionSnapshot(cm) {
  if (cm.hasFocus()) { return null }
  var active = activeElt();
  if (!active || !contains(cm.display.lineDiv, active)) { return null }
  var result = {activeElt: active};
  if (window.getSelection) {
    var sel = window.getSelection();
    if (sel.anchorNode && sel.extend && contains(cm.display.lineDiv, sel.anchorNode)) {
      result.anchorNode = sel.anchorNode;
      result.anchorOffset = sel.anchorOffset;
      result.focusNode = sel.focusNode;
      result.focusOffset = sel.focusOffset;
    }
  }
  return result
}

function restoreSelection(snapshot) {
  if (!snapshot || !snapshot.activeElt || snapshot.activeElt == activeElt()) { return }
  snapshot.activeElt.focus();
  if (snapshot.anchorNode && contains(document.body, snapshot.anchorNode) && contains(document.body, snapshot.focusNode)) {
    var sel = window.getSelection(), range$$1 = document.createRange();
    range$$1.setEnd(snapshot.anchorNode, snapshot.anchorOffset);
    range$$1.collapse(false);
    sel.removeAllRanges();
    sel.addRange(range$$1);
    sel.extend(snapshot.focusNode, snapshot.focusOffset);
  }
}

// Does the actual updating of the line display. Bails out
// (returning false) when there is nothing to be done and forced is
// false.
function updateDisplayIfNeeded(cm, update) {
  var display = cm.display, doc = cm.doc;

  if (update.editorIsHidden) {
    resetView(cm);
    return false
  }

  // Bail out if the visible area is already rendered and nothing changed.
  if (!update.force &&
      update.visible.from >= display.viewFrom && update.visible.to <= display.viewTo &&
      (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo) &&
      display.renderedView == display.view && countDirtyView(cm) == 0)
    { return false }

  if (maybeUpdateLineNumberWidth(cm)) {
    resetView(cm);
    update.dims = getDimensions(cm);
  }

  // Compute a suitable new viewport (from & to)
  var end = doc.first + doc.size;
  var from = Math.max(update.visible.from - cm.options.viewportMargin, doc.first);
  var to = Math.min(end, update.visible.to + cm.options.viewportMargin);
  if (display.viewFrom < from && from - display.viewFrom < 20) { from = Math.max(doc.first, display.viewFrom); }
  if (display.viewTo > to && display.viewTo - to < 20) { to = Math.min(end, display.viewTo); }
  if (sawCollapsedSpans) {
    from = visualLineNo(cm.doc, from);
    to = visualLineEndNo(cm.doc, to);
  }

  var different = from != display.viewFrom || to != display.viewTo ||
    display.lastWrapHeight != update.wrapperHeight || display.lastWrapWidth != update.wrapperWidth;
  adjustView(cm, from, to);

  display.viewOffset = heightAtLine(getLine(cm.doc, display.viewFrom));
  // Position the mover div to align with the current scroll position
  cm.display.mover.style.top = display.viewOffset + "px";

  var toUpdate = countDirtyView(cm);
  if (!different && toUpdate == 0 && !update.force && display.renderedView == display.view &&
      (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo))
    { return false }

  // For big changes, we hide the enclosing element during the
  // update, since that speeds up the operations on most browsers.
  var selSnapshot = selectionSnapshot(cm);
  if (toUpdate > 4) { display.lineDiv.style.display = "none"; }
  patchDisplay(cm, display.updateLineNumbers, update.dims);
  if (toUpdate > 4) { display.lineDiv.style.display = ""; }
  display.renderedView = display.view;
  // There might have been a widget with a focused element that got
  // hidden or updated, if so re-focus it.
  restoreSelection(selSnapshot);

  // Prevent selection and cursors from interfering with the scroll
  // width and height.
  removeChildren(display.cursorDiv);
  removeChildren(display.selectionDiv);
  display.gutters.style.height = display.sizer.style.minHeight = 0;

  if (different) {
    display.lastWrapHeight = update.wrapperHeight;
    display.lastWrapWidth = update.wrapperWidth;
    startWorker(cm, 400);
  }

  display.updateLineNumbers = null;

  return true
}

function postUpdateDisplay(cm, update) {
  var viewport = update.viewport;

  for (var first = true;; first = false) {
    if (!first || !cm.options.lineWrapping || update.oldDisplayWidth == displayWidth(cm)) {
      // Clip forced viewport to actual scrollable area.
      if (viewport && viewport.top != null)
        { viewport = {top: Math.min(cm.doc.height + paddingVert(cm.display) - displayHeight(cm), viewport.top)}; }
      // Updated line heights might result in the drawn area not
      // actually covering the viewport. Keep looping until it does.
      update.visible = visibleLines(cm.display, cm.doc, viewport);
      if (update.visible.from >= cm.display.viewFrom && update.visible.to <= cm.display.viewTo)
        { break }
    }
    if (!updateDisplayIfNeeded(cm, update)) { break }
    updateHeightsInViewport(cm);
    var barMeasure = measureForScrollbars(cm);
    updateSelection(cm);
    updateScrollbars(cm, barMeasure);
    setDocumentHeight(cm, barMeasure);
    update.force = false;
  }

  update.signal(cm, "update", cm);
  if (cm.display.viewFrom != cm.display.reportedViewFrom || cm.display.viewTo != cm.display.reportedViewTo) {
    update.signal(cm, "viewportChange", cm, cm.display.viewFrom, cm.display.viewTo);
    cm.display.reportedViewFrom = cm.display.viewFrom; cm.display.reportedViewTo = cm.display.viewTo;
  }
}

function updateDisplaySimple(cm, viewport) {
  var update = new DisplayUpdate(cm, viewport);
  if (updateDisplayIfNeeded(cm, update)) {
    updateHeightsInViewport(cm);
    postUpdateDisplay(cm, update);
    var barMeasure = measureForScrollbars(cm);
    updateSelection(cm);
    updateScrollbars(cm, barMeasure);
    setDocumentHeight(cm, barMeasure);
    update.finish();
  }
}

// Sync the actual display DOM structure with display.view, removing
// nodes for lines that are no longer in view, and creating the ones
// that are not there yet, and updating the ones that are out of
// date.
function patchDisplay(cm, updateNumbersFrom, dims) {
  var display = cm.display, lineNumbers = cm.options.lineNumbers;
  var container = display.lineDiv, cur = container.firstChild;

  function rm(node) {
    var next = node.nextSibling;
    // Works around a throw-scroll bug in OS X Webkit
    if (webkit && mac && cm.display.currentWheelTarget == node)
      { node.style.display = "none"; }
    else
      { node.parentNode.removeChild(node); }
    return next
  }

  var view = display.view, lineN = display.viewFrom;
  // Loop over the elements in the view, syncing cur (the DOM nodes
  // in display.lineDiv) with the view as we go.
  for (var i = 0; i < view.length; i++) {
    var lineView = view[i];
    if (lineView.hidden) {
    } else if (!lineView.node || lineView.node.parentNode != container) { // Not drawn yet
      var node = buildLineElement(cm, lineView, lineN, dims);
      container.insertBefore(node, cur);
    } else { // Already drawn
      while (cur != lineView.node) { cur = rm(cur); }
      var updateNumber = lineNumbers && updateNumbersFrom != null &&
        updateNumbersFrom <= lineN && lineView.lineNumber;
      if (lineView.changes) {
        if (indexOf(lineView.changes, "gutter") > -1) { updateNumber = false; }
        updateLineForChanges(cm, lineView, lineN, dims);
      }
      if (updateNumber) {
        removeChildren(lineView.lineNumber);
        lineView.lineNumber.appendChild(document.createTextNode(lineNumberFor(cm.options, lineN)));
      }
      cur = lineView.node.nextSibling;
    }
    lineN += lineView.size;
  }
  while (cur) { cur = rm(cur); }
}

function updateGutterSpace(cm) {
  var width = cm.display.gutters.offsetWidth;
  cm.display.sizer.style.marginLeft = width + "px";
}

function setDocumentHeight(cm, measure) {
  cm.display.sizer.style.minHeight = measure.docHeight + "px";
  cm.display.heightForcer.style.top = measure.docHeight + "px";
  cm.display.gutters.style.height = (measure.docHeight + cm.display.barHeight + scrollGap(cm)) + "px";
}

// Rebuild the gutter elements, ensure the margin to the left of the
// code matches their width.
function updateGutters(cm) {
  var gutters = cm.display.gutters, specs = cm.options.gutters;
  removeChildren(gutters);
  var i = 0;
  for (; i < specs.length; ++i) {
    var gutterClass = specs[i];
    var gElt = gutters.appendChild(elt("div", null, "CodeMirror-gutter " + gutterClass));
    if (gutterClass == "CodeMirror-linenumbers") {
      cm.display.lineGutter = gElt;
      gElt.style.width = (cm.display.lineNumWidth || 1) + "px";
    }
  }
  gutters.style.display = i ? "" : "none";
  updateGutterSpace(cm);
}

// Make sure the gutters options contains the element
// "CodeMirror-linenumbers" when the lineNumbers option is true.
function setGuttersForLineNumbers(options) {
  var found = indexOf(options.gutters, "CodeMirror-linenumbers");
  if (found == -1 && options.lineNumbers) {
    options.gutters = options.gutters.concat(["CodeMirror-linenumbers"]);
  } else if (found > -1 && !options.lineNumbers) {
    options.gutters = options.gutters.slice(0);
    options.gutters.splice(found, 1);
  }
}

// Since the delta values reported on mouse wheel events are
// unstandardized between browsers and even browser versions, and
// generally horribly unpredictable, this code starts by measuring
// the scroll effect that the first few mouse wheel events have,
// and, from that, detects the way it can convert deltas to pixel
// offsets afterwards.
//
// The reason we want to know the amount a wheel event will scroll
// is that it gives us a chance to update the display before the
// actual scrolling happens, reducing flickering.

var wheelSamples = 0;
var wheelPixelsPerUnit = null;
// Fill in a browser-detected starting value on browsers where we
// know one. These don't have to be accurate -- the result of them
// being wrong would just be a slight flicker on the first wheel
// scroll (if it is large enough).
if (ie) { wheelPixelsPerUnit = -.53; }
else if (gecko) { wheelPixelsPerUnit = 15; }
else if (chrome) { wheelPixelsPerUnit = -.7; }
else if (safari) { wheelPixelsPerUnit = -1/3; }

function wheelEventDelta(e) {
  var dx = e.wheelDeltaX, dy = e.wheelDeltaY;
  if (dx == null && e.detail && e.axis == e.HORIZONTAL_AXIS) { dx = e.detail; }
  if (dy == null && e.detail && e.axis == e.VERTICAL_AXIS) { dy = e.detail; }
  else if (dy == null) { dy = e.wheelDelta; }
  return {x: dx, y: dy}
}
function wheelEventPixels(e) {
  var delta = wheelEventDelta(e);
  delta.x *= wheelPixelsPerUnit;
  delta.y *= wheelPixelsPerUnit;
  return delta
}

function onScrollWheel(cm, e) {
  var delta = wheelEventDelta(e), dx = delta.x, dy = delta.y;

  var display = cm.display, scroll = display.scroller;
  // Quit if there's nothing to scroll here
  var canScrollX = scroll.scrollWidth > scroll.clientWidth;
  var canScrollY = scroll.scrollHeight > scroll.clientHeight;
  if (!(dx && canScrollX || dy && canScrollY)) { return }

  // Webkit browsers on OS X abort momentum scrolls when the target
  // of the scroll event is removed from the scrollable element.
  // This hack (see related code in patchDisplay) makes sure the
  // element is kept around.
  if (dy && mac && webkit) {
    outer: for (var cur = e.target, view = display.view; cur != scroll; cur = cur.parentNode) {
      for (var i = 0; i < view.length; i++) {
        if (view[i].node == cur) {
          cm.display.currentWheelTarget = cur;
          break outer
        }
      }
    }
  }

  // On some browsers, horizontal scrolling will cause redraws to
  // happen before the gutter has been realigned, causing it to
  // wriggle around in a most unseemly way. When we have an
  // estimated pixels/delta value, we just handle horizontal
  // scrolling entirely here. It'll be slightly off from native, but
  // better than glitching out.
  if (dx && !gecko && !presto && wheelPixelsPerUnit != null) {
    if (dy && canScrollY)
      { updateScrollTop(cm, Math.max(0, scroll.scrollTop + dy * wheelPixelsPerUnit)); }
    setScrollLeft(cm, Math.max(0, scroll.scrollLeft + dx * wheelPixelsPerUnit));
    // Only prevent default scrolling if vertical scrolling is
    // actually possible. Otherwise, it causes vertical scroll
    // jitter on OSX trackpads when deltaX is small and deltaY
    // is large (issue #3579)
    if (!dy || (dy && canScrollY))
      { e_preventDefault(e); }
    display.wheelStartX = null; // Abort measurement, if in progress
    return
  }

  // 'Project' the visible viewport to cover the area that is being
  // scrolled into view (if we know enough to estimate it).
  if (dy && wheelPixelsPerUnit != null) {
    var pixels = dy * wheelPixelsPerUnit;
    var top = cm.doc.scrollTop, bot = top + display.wrapper.clientHeight;
    if (pixels < 0) { top = Math.max(0, top + pixels - 50); }
    else { bot = Math.min(cm.doc.height, bot + pixels + 50); }
    updateDisplaySimple(cm, {top: top, bottom: bot});
  }

  if (wheelSamples < 20) {
    if (display.wheelStartX == null) {
      display.wheelStartX = scroll.scrollLeft; display.wheelStartY = scroll.scrollTop;
      display.wheelDX = dx; display.wheelDY = dy;
      setTimeout(function () {
        if (display.wheelStartX == null) { return }
        var movedX = scroll.scrollLeft - display.wheelStartX;
        var movedY = scroll.scrollTop - display.wheelStartY;
        var sample = (movedY && display.wheelDY && movedY / display.wheelDY) ||
          (movedX && display.wheelDX && movedX / display.wheelDX);
        display.wheelStartX = display.wheelStartY = null;
        if (!sample) { return }
        wheelPixelsPerUnit = (wheelPixelsPerUnit * wheelSamples + sample) / (wheelSamples + 1);
        ++wheelSamples;
      }, 200);
    } else {
      display.wheelDX += dx; display.wheelDY += dy;
    }
  }
}

// Selection objects are immutable. A new one is created every time
// the selection changes. A selection is one or more non-overlapping
// (and non-touching) ranges, sorted, and an integer that indicates
// which one is the primary selection (the one that's scrolled into
// view, that getCursor returns, etc).
var Selection = function(ranges, primIndex) {
  this.ranges = ranges;
  this.primIndex = primIndex;
};

Selection.prototype.primary = function () { return this.ranges[this.primIndex] };

Selection.prototype.equals = function (other) {
    var this$1 = this;

  if (other == this) { return true }
  if (other.primIndex != this.primIndex || other.ranges.length != this.ranges.length) { return false }
  for (var i = 0; i < this.ranges.length; i++) {
    var here = this$1.ranges[i], there = other.ranges[i];
    if (!equalCursorPos(here.anchor, there.anchor) || !equalCursorPos(here.head, there.head)) { return false }
  }
  return true
};

Selection.prototype.deepCopy = function () {
    var this$1 = this;

  var out = [];
  for (var i = 0; i < this.ranges.length; i++)
    { out[i] = new Range(copyPos(this$1.ranges[i].anchor), copyPos(this$1.ranges[i].head)); }
  return new Selection(out, this.primIndex)
};

Selection.prototype.somethingSelected = function () {
    var this$1 = this;

  for (var i = 0; i < this.ranges.length; i++)
    { if (!this$1.ranges[i].empty()) { return true } }
  return false
};

Selection.prototype.contains = function (pos, end) {
    var this$1 = this;

  if (!end) { end = pos; }
  for (var i = 0; i < this.ranges.length; i++) {
    var range = this$1.ranges[i];
    if (cmp(end, range.from()) >= 0 && cmp(pos, range.to()) <= 0)
      { return i }
  }
  return -1
};

var Range = function(anchor, head) {
  this.anchor = anchor; this.head = head;
};

Range.prototype.from = function () { return minPos(this.anchor, this.head) };
Range.prototype.to = function () { return maxPos(this.anchor, this.head) };
Range.prototype.empty = function () { return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch };

// Take an unsorted, potentially overlapping set of ranges, and
// build a selection out of it. 'Consumes' ranges array (modifying
// it).
function normalizeSelection(ranges, primIndex) {
  var prim = ranges[primIndex];
  ranges.sort(function (a, b) { return cmp(a.from(), b.from()); });
  primIndex = indexOf(ranges, prim);
  for (var i = 1; i < ranges.length; i++) {
    var cur = ranges[i], prev = ranges[i - 1];
    if (cmp(prev.to(), cur.from()) >= 0) {
      var from = minPos(prev.from(), cur.from()), to = maxPos(prev.to(), cur.to());
      var inv = prev.empty() ? cur.from() == cur.head : prev.from() == prev.head;
      if (i <= primIndex) { --primIndex; }
      ranges.splice(--i, 2, new Range(inv ? to : from, inv ? from : to));
    }
  }
  return new Selection(ranges, primIndex)
}

function simpleSelection(anchor, head) {
  return new Selection([new Range(anchor, head || anchor)], 0)
}

// Compute the position of the end of a change (its 'to' property
// refers to the pre-change end).
function changeEnd(change) {
  if (!change.text) { return change.to }
  return Pos(change.from.line + change.text.length - 1,
             lst(change.text).length + (change.text.length == 1 ? change.from.ch : 0))
}

// Adjust a position to refer to the post-change position of the
// same text, or the end of the change if the change covers it.
function adjustForChange(pos, change) {
  if (cmp(pos, change.from) < 0) { return pos }
  if (cmp(pos, change.to) <= 0) { return changeEnd(change) }

  var line = pos.line + change.text.length - (change.to.line - change.from.line) - 1, ch = pos.ch;
  if (pos.line == change.to.line) { ch += changeEnd(change).ch - change.to.ch; }
  return Pos(line, ch)
}

function computeSelAfterChange(doc, change) {
  var out = [];
  for (var i = 0; i < doc.sel.ranges.length; i++) {
    var range = doc.sel.ranges[i];
    out.push(new Range(adjustForChange(range.anchor, change),
                       adjustForChange(range.head, change)));
  }
  return normalizeSelection(out, doc.sel.primIndex)
}

function offsetPos(pos, old, nw) {
  if (pos.line == old.line)
    { return Pos(nw.line, pos.ch - old.ch + nw.ch) }
  else
    { return Pos(nw.line + (pos.line - old.line), pos.ch) }
}

// Used by replaceSelections to allow moving the selection to the
// start or around the replaced test. Hint may be "start" or "around".
function computeReplacedSel(doc, changes, hint) {
  var out = [];
  var oldPrev = Pos(doc.first, 0), newPrev = oldPrev;
  for (var i = 0; i < changes.length; i++) {
    var change = changes[i];
    var from = offsetPos(change.from, oldPrev, newPrev);
    var to = offsetPos(changeEnd(change), oldPrev, newPrev);
    oldPrev = change.to;
    newPrev = to;
    if (hint == "around") {
      var range = doc.sel.ranges[i], inv = cmp(range.head, range.anchor) < 0;
      out[i] = new Range(inv ? to : from, inv ? from : to);
    } else {
      out[i] = new Range(from, from);
    }
  }
  return new Selection(out, doc.sel.primIndex)
}

// Used to get the editor into a consistent state again when options change.

function loadMode(cm) {
  cm.doc.mode = getMode(cm.options, cm.doc.modeOption);
  resetModeState(cm);
}

function resetModeState(cm) {
  cm.doc.iter(function (line) {
    if (line.stateAfter) { line.stateAfter = null; }
    if (line.styles) { line.styles = null; }
  });
  cm.doc.modeFrontier = cm.doc.highlightFrontier = cm.doc.first;
  startWorker(cm, 100);
  cm.state.modeGen++;
  if (cm.curOp) { regChange(cm); }
}

// DOCUMENT DATA STRUCTURE

// By default, updates that start and end at the beginning of a line
// are treated specially, in order to make the association of line
// widgets and marker elements with the text behave more intuitive.
function isWholeLineUpdate(doc, change) {
  return change.from.ch == 0 && change.to.ch == 0 && lst(change.text) == "" &&
    (!doc.cm || doc.cm.options.wholeLineUpdateBefore)
}

// Perform a change on the document data structure.
function updateDoc(doc, change, markedSpans, estimateHeight$$1) {
  function spansFor(n) {return markedSpans ? markedSpans[n] : null}
  function update(line, text, spans) {
    updateLine(line, text, spans, estimateHeight$$1);
    signalLater(line, "change", line, change);
  }
  function linesFor(start, end) {
    var result = [];
    for (var i = start; i < end; ++i)
      { result.push(new Line(text[i], spansFor(i), estimateHeight$$1)); }
    return result
  }

  var from = change.from, to = change.to, text = change.text;
  var firstLine = getLine(doc, from.line), lastLine = getLine(doc, to.line);
  var lastText = lst(text), lastSpans = spansFor(text.length - 1), nlines = to.line - from.line;

  // Adjust the line structure
  if (change.full) {
    doc.insert(0, linesFor(0, text.length));
    doc.remove(text.length, doc.size - text.length);
  } else if (isWholeLineUpdate(doc, change)) {
    // This is a whole-line replace. Treated specially to make
    // sure line objects move the way they are supposed to.
    var added = linesFor(0, text.length - 1);
    update(lastLine, lastLine.text, lastSpans);
    if (nlines) { doc.remove(from.line, nlines); }
    if (added.length) { doc.insert(from.line, added); }
  } else if (firstLine == lastLine) {
    if (text.length == 1) {
      update(firstLine, firstLine.text.slice(0, from.ch) + lastText + firstLine.text.slice(to.ch), lastSpans);
    } else {
      var added$1 = linesFor(1, text.length - 1);
      added$1.push(new Line(lastText + firstLine.text.slice(to.ch), lastSpans, estimateHeight$$1));
      update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
      doc.insert(from.line + 1, added$1);
    }
  } else if (text.length == 1) {
    update(firstLine, firstLine.text.slice(0, from.ch) + text[0] + lastLine.text.slice(to.ch), spansFor(0));
    doc.remove(from.line + 1, nlines);
  } else {
    update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
    update(lastLine, lastText + lastLine.text.slice(to.ch), lastSpans);
    var added$2 = linesFor(1, text.length - 1);
    if (nlines > 1) { doc.remove(from.line + 1, nlines - 1); }
    doc.insert(from.line + 1, added$2);
  }

  signalLater(doc, "change", doc, change);
}

// Call f for all linked documents.
function linkedDocs(doc, f, sharedHistOnly) {
  function propagate(doc, skip, sharedHist) {
    if (doc.linked) { for (var i = 0; i < doc.linked.length; ++i) {
      var rel = doc.linked[i];
      if (rel.doc == skip) { continue }
      var shared = sharedHist && rel.sharedHist;
      if (sharedHistOnly && !shared) { continue }
      f(rel.doc, shared);
      propagate(rel.doc, doc, shared);
    } }
  }
  propagate(doc, null, true);
}

// Attach a document to an editor.
function attachDoc(cm, doc) {
  if (doc.cm) { throw new Error("This document is already in use.") }
  cm.doc = doc;
  doc.cm = cm;
  estimateLineHeights(cm);
  loadMode(cm);
  setDirectionClass(cm);
  if (!cm.options.lineWrapping) { findMaxLine(cm); }
  cm.options.mode = doc.modeOption;
  regChange(cm);
}

function setDirectionClass(cm) {
  (cm.doc.direction == "rtl" ? addClass : rmClass)(cm.display.lineDiv, "CodeMirror-rtl");
}

function directionChanged(cm) {
  runInOp(cm, function () {
    setDirectionClass(cm);
    regChange(cm);
  });
}

function History(startGen) {
  // Arrays of change events and selections. Doing something adds an
  // event to done and clears undo. Undoing moves events from done
  // to undone, redoing moves them in the other direction.
  this.done = []; this.undone = [];
  this.undoDepth = Infinity;
  // Used to track when changes can be merged into a single undo
  // event
  this.lastModTime = this.lastSelTime = 0;
  this.lastOp = this.lastSelOp = null;
  this.lastOrigin = this.lastSelOrigin = null;
  // Used by the isClean() method
  this.generation = this.maxGeneration = startGen || 1;
}

// Create a history change event from an updateDoc-style change
// object.
function historyChangeFromChange(doc, change) {
  var histChange = {from: copyPos(change.from), to: changeEnd(change), text: getBetween(doc, change.from, change.to)};
  attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
  linkedDocs(doc, function (doc) { return attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1); }, true);
  return histChange
}

// Pop all selection events off the end of a history array. Stop at
// a change event.
function clearSelectionEvents(array) {
  while (array.length) {
    var last = lst(array);
    if (last.ranges) { array.pop(); }
    else { break }
  }
}

// Find the top change event in the history. Pop off selection
// events that are in the way.
function lastChangeEvent(hist, force) {
  if (force) {
    clearSelectionEvents(hist.done);
    return lst(hist.done)
  } else if (hist.done.length && !lst(hist.done).ranges) {
    return lst(hist.done)
  } else if (hist.done.length > 1 && !hist.done[hist.done.length - 2].ranges) {
    hist.done.pop();
    return lst(hist.done)
  }
}

// Register a change in the history. Merges changes that are within
// a single operation, or are close together with an origin that
// allows merging (starting with "+") into a single event.
function addChangeToHistory(doc, change, selAfter, opId) {
  var hist = doc.history;
  hist.undone.length = 0;
  var time = +new Date, cur;
  var last;

  if ((hist.lastOp == opId ||
       hist.lastOrigin == change.origin && change.origin &&
       ((change.origin.charAt(0) == "+" && doc.cm && hist.lastModTime > time - doc.cm.options.historyEventDelay) ||
        change.origin.charAt(0) == "*")) &&
      (cur = lastChangeEvent(hist, hist.lastOp == opId))) {
    // Merge this change into the last event
    last = lst(cur.changes);
    if (cmp(change.from, change.to) == 0 && cmp(change.from, last.to) == 0) {
      // Optimized case for simple insertion -- don't want to add
      // new changesets for every character typed
      last.to = changeEnd(change);
    } else {
      // Add new sub-event
      cur.changes.push(historyChangeFromChange(doc, change));
    }
  } else {
    // Can not be merged, start a new event.
    var before = lst(hist.done);
    if (!before || !before.ranges)
      { pushSelectionToHistory(doc.sel, hist.done); }
    cur = {changes: [historyChangeFromChange(doc, change)],
           generation: hist.generation};
    hist.done.push(cur);
    while (hist.done.length > hist.undoDepth) {
      hist.done.shift();
      if (!hist.done[0].ranges) { hist.done.shift(); }
    }
  }
  hist.done.push(selAfter);
  hist.generation = ++hist.maxGeneration;
  hist.lastModTime = hist.lastSelTime = time;
  hist.lastOp = hist.lastSelOp = opId;
  hist.lastOrigin = hist.lastSelOrigin = change.origin;

  if (!last) { signal(doc, "historyAdded"); }
}

function selectionEventCanBeMerged(doc, origin, prev, sel) {
  var ch = origin.charAt(0);
  return ch == "*" ||
    ch == "+" &&
    prev.ranges.length == sel.ranges.length &&
    prev.somethingSelected() == sel.somethingSelected() &&
    new Date - doc.history.lastSelTime <= (doc.cm ? doc.cm.options.historyEventDelay : 500)
}

// Called whenever the selection changes, sets the new selection as
// the pending selection in the history, and pushes the old pending
// selection into the 'done' array when it was significantly
// different (in number of selected ranges, emptiness, or time).
function addSelectionToHistory(doc, sel, opId, options) {
  var hist = doc.history, origin = options && options.origin;

  // A new event is started when the previous origin does not match
  // the current, or the origins don't allow matching. Origins
  // starting with * are always merged, those starting with + are
  // merged when similar and close together in time.
  if (opId == hist.lastSelOp ||
      (origin && hist.lastSelOrigin == origin &&
       (hist.lastModTime == hist.lastSelTime && hist.lastOrigin == origin ||
        selectionEventCanBeMerged(doc, origin, lst(hist.done), sel))))
    { hist.done[hist.done.length - 1] = sel; }
  else
    { pushSelectionToHistory(sel, hist.done); }

  hist.lastSelTime = +new Date;
  hist.lastSelOrigin = origin;
  hist.lastSelOp = opId;
  if (options && options.clearRedo !== false)
    { clearSelectionEvents(hist.undone); }
}

function pushSelectionToHistory(sel, dest) {
  var top = lst(dest);
  if (!(top && top.ranges && top.equals(sel)))
    { dest.push(sel); }
}

// Used to store marked span information in the history.
function attachLocalSpans(doc, change, from, to) {
  var existing = change["spans_" + doc.id], n = 0;
  doc.iter(Math.max(doc.first, from), Math.min(doc.first + doc.size, to), function (line) {
    if (line.markedSpans)
      { (existing || (existing = change["spans_" + doc.id] = {}))[n] = line.markedSpans; }
    ++n;
  });
}

// When un/re-doing restores text containing marked spans, those
// that have been explicitly cleared should not be restored.
function removeClearedSpans(spans) {
  if (!spans) { return null }
  var out;
  for (var i = 0; i < spans.length; ++i) {
    if (spans[i].marker.explicitlyCleared) { if (!out) { out = spans.slice(0, i); } }
    else if (out) { out.push(spans[i]); }
  }
  return !out ? spans : out.length ? out : null
}

// Retrieve and filter the old marked spans stored in a change event.
function getOldSpans(doc, change) {
  var found = change["spans_" + doc.id];
  if (!found) { return null }
  var nw = [];
  for (var i = 0; i < change.text.length; ++i)
    { nw.push(removeClearedSpans(found[i])); }
  return nw
}

// Used for un/re-doing changes from the history. Combines the
// result of computing the existing spans with the set of spans that
// existed in the history (so that deleting around a span and then
// undoing brings back the span).
function mergeOldSpans(doc, change) {
  var old = getOldSpans(doc, change);
  var stretched = stretchSpansOverChange(doc, change);
  if (!old) { return stretched }
  if (!stretched) { return old }

  for (var i = 0; i < old.length; ++i) {
    var oldCur = old[i], stretchCur = stretched[i];
    if (oldCur && stretchCur) {
      spans: for (var j = 0; j < stretchCur.length; ++j) {
        var span = stretchCur[j];
        for (var k = 0; k < oldCur.length; ++k)
          { if (oldCur[k].marker == span.marker) { continue spans } }
        oldCur.push(span);
      }
    } else if (stretchCur) {
      old[i] = stretchCur;
    }
  }
  return old
}

// Used both to provide a JSON-safe object in .getHistory, and, when
// detaching a document, to split the history in two
function copyHistoryArray(events, newGroup, instantiateSel) {
  var copy = [];
  for (var i = 0; i < events.length; ++i) {
    var event = events[i];
    if (event.ranges) {
      copy.push(instantiateSel ? Selection.prototype.deepCopy.call(event) : event);
      continue
    }
    var changes = event.changes, newChanges = [];
    copy.push({changes: newChanges});
    for (var j = 0; j < changes.length; ++j) {
      var change = changes[j], m = (void 0);
      newChanges.push({from: change.from, to: change.to, text: change.text});
      if (newGroup) { for (var prop in change) { if (m = prop.match(/^spans_(\d+)$/)) {
        if (indexOf(newGroup, Number(m[1])) > -1) {
          lst(newChanges)[prop] = change[prop];
          delete change[prop];
        }
      } } }
    }
  }
  return copy
}

// The 'scroll' parameter given to many of these indicated whether
// the new cursor position should be scrolled into view after
// modifying the selection.

// If shift is held or the extend flag is set, extends a range to
// include a given position (and optionally a second position).
// Otherwise, simply returns the range between the given positions.
// Used for cursor motion and such.
function extendRange(range, head, other, extend) {
  if (extend) {
    var anchor = range.anchor;
    if (other) {
      var posBefore = cmp(head, anchor) < 0;
      if (posBefore != (cmp(other, anchor) < 0)) {
        anchor = head;
        head = other;
      } else if (posBefore != (cmp(head, other) < 0)) {
        head = other;
      }
    }
    return new Range(anchor, head)
  } else {
    return new Range(other || head, head)
  }
}

// Extend the primary selection range, discard the rest.
function extendSelection(doc, head, other, options, extend) {
  if (extend == null) { extend = doc.cm && (doc.cm.display.shift || doc.extend); }
  setSelection(doc, new Selection([extendRange(doc.sel.primary(), head, other, extend)], 0), options);
}

// Extend all selections (pos is an array of selections with length
// equal the number of selections)
function extendSelections(doc, heads, options) {
  var out = [];
  var extend = doc.cm && (doc.cm.display.shift || doc.extend);
  for (var i = 0; i < doc.sel.ranges.length; i++)
    { out[i] = extendRange(doc.sel.ranges[i], heads[i], null, extend); }
  var newSel = normalizeSelection(out, doc.sel.primIndex);
  setSelection(doc, newSel, options);
}

// Updates a single range in the selection.
function replaceOneSelection(doc, i, range, options) {
  var ranges = doc.sel.ranges.slice(0);
  ranges[i] = range;
  setSelection(doc, normalizeSelection(ranges, doc.sel.primIndex), options);
}

// Reset the selection to a single range.
function setSimpleSelection(doc, anchor, head, options) {
  setSelection(doc, simpleSelection(anchor, head), options);
}

// Give beforeSelectionChange handlers a change to influence a
// selection update.
function filterSelectionChange(doc, sel, options) {
  var obj = {
    ranges: sel.ranges,
    update: function(ranges) {
      var this$1 = this;

      this.ranges = [];
      for (var i = 0; i < ranges.length; i++)
        { this$1.ranges[i] = new Range(clipPos(doc, ranges[i].anchor),
                                   clipPos(doc, ranges[i].head)); }
    },
    origin: options && options.origin
  };
  signal(doc, "beforeSelectionChange", doc, obj);
  if (doc.cm) { signal(doc.cm, "beforeSelectionChange", doc.cm, obj); }
  if (obj.ranges != sel.ranges) { return normalizeSelection(obj.ranges, obj.ranges.length - 1) }
  else { return sel }
}

function setSelectionReplaceHistory(doc, sel, options) {
  var done = doc.history.done, last = lst(done);
  if (last && last.ranges) {
    done[done.length - 1] = sel;
    setSelectionNoUndo(doc, sel, options);
  } else {
    setSelection(doc, sel, options);
  }
}

// Set a new selection.
function setSelection(doc, sel, options) {
  setSelectionNoUndo(doc, sel, options);
  addSelectionToHistory(doc, doc.sel, doc.cm ? doc.cm.curOp.id : NaN, options);
}

function setSelectionNoUndo(doc, sel, options) {
  if (hasHandler(doc, "beforeSelectionChange") || doc.cm && hasHandler(doc.cm, "beforeSelectionChange"))
    { sel = filterSelectionChange(doc, sel, options); }

  var bias = options && options.bias ||
    (cmp(sel.primary().head, doc.sel.primary().head) < 0 ? -1 : 1);
  setSelectionInner(doc, skipAtomicInSelection(doc, sel, bias, true));

  if (!(options && options.scroll === false) && doc.cm)
    { ensureCursorVisible(doc.cm); }
}

function setSelectionInner(doc, sel) {
  if (sel.equals(doc.sel)) { return }

  doc.sel = sel;

  if (doc.cm) {
    doc.cm.curOp.updateInput = doc.cm.curOp.selectionChanged = true;
    signalCursorActivity(doc.cm);
  }
  signalLater(doc, "cursorActivity", doc);
}

// Verify that the selection does not partially select any atomic
// marked ranges.
function reCheckSelection(doc) {
  setSelectionInner(doc, skipAtomicInSelection(doc, doc.sel, null, false));
}

// Return a selection that does not partially select any atomic
// ranges.
function skipAtomicInSelection(doc, sel, bias, mayClear) {
  var out;
  for (var i = 0; i < sel.ranges.length; i++) {
    var range = sel.ranges[i];
    var old = sel.ranges.length == doc.sel.ranges.length && doc.sel.ranges[i];
    var newAnchor = skipAtomic(doc, range.anchor, old && old.anchor, bias, mayClear);
    var newHead = skipAtomic(doc, range.head, old && old.head, bias, mayClear);
    if (out || newAnchor != range.anchor || newHead != range.head) {
      if (!out) { out = sel.ranges.slice(0, i); }
      out[i] = new Range(newAnchor, newHead);
    }
  }
  return out ? normalizeSelection(out, sel.primIndex) : sel
}

function skipAtomicInner(doc, pos, oldPos, dir, mayClear) {
  var line = getLine(doc, pos.line);
  if (line.markedSpans) { for (var i = 0; i < line.markedSpans.length; ++i) {
    var sp = line.markedSpans[i], m = sp.marker;
    if ((sp.from == null || (m.inclusiveLeft ? sp.from <= pos.ch : sp.from < pos.ch)) &&
        (sp.to == null || (m.inclusiveRight ? sp.to >= pos.ch : sp.to > pos.ch))) {
      if (mayClear) {
        signal(m, "beforeCursorEnter");
        if (m.explicitlyCleared) {
          if (!line.markedSpans) { break }
          else {--i; continue}
        }
      }
      if (!m.atomic) { continue }

      if (oldPos) {
        var near = m.find(dir < 0 ? 1 : -1), diff = (void 0);
        if (dir < 0 ? m.inclusiveRight : m.inclusiveLeft)
          { near = movePos(doc, near, -dir, near && near.line == pos.line ? line : null); }
        if (near && near.line == pos.line && (diff = cmp(near, oldPos)) && (dir < 0 ? diff < 0 : diff > 0))
          { return skipAtomicInner(doc, near, pos, dir, mayClear) }
      }

      var far = m.find(dir < 0 ? -1 : 1);
      if (dir < 0 ? m.inclusiveLeft : m.inclusiveRight)
        { far = movePos(doc, far, dir, far.line == pos.line ? line : null); }
      return far ? skipAtomicInner(doc, far, pos, dir, mayClear) : null
    }
  } }
  return pos
}

// Ensure a given position is not inside an atomic range.
function skipAtomic(doc, pos, oldPos, bias, mayClear) {
  var dir = bias || 1;
  var found = skipAtomicInner(doc, pos, oldPos, dir, mayClear) ||
      (!mayClear && skipAtomicInner(doc, pos, oldPos, dir, true)) ||
      skipAtomicInner(doc, pos, oldPos, -dir, mayClear) ||
      (!mayClear && skipAtomicInner(doc, pos, oldPos, -dir, true));
  if (!found) {
    doc.cantEdit = true;
    return Pos(doc.first, 0)
  }
  return found
}

function movePos(doc, pos, dir, line) {
  if (dir < 0 && pos.ch == 0) {
    if (pos.line > doc.first) { return clipPos(doc, Pos(pos.line - 1)) }
    else { return null }
  } else if (dir > 0 && pos.ch == (line || getLine(doc, pos.line)).text.length) {
    if (pos.line < doc.first + doc.size - 1) { return Pos(pos.line + 1, 0) }
    else { return null }
  } else {
    return new Pos(pos.line, pos.ch + dir)
  }
}

function selectAll(cm) {
  cm.setSelection(Pos(cm.firstLine(), 0), Pos(cm.lastLine()), sel_dontScroll);
}

// UPDATING

// Allow "beforeChange" event handlers to influence a change
function filterChange(doc, change, update) {
  var obj = {
    canceled: false,
    from: change.from,
    to: change.to,
    text: change.text,
    origin: change.origin,
    cancel: function () { return obj.canceled = true; }
  };
  if (update) { obj.update = function (from, to, text, origin) {
    if (from) { obj.from = clipPos(doc, from); }
    if (to) { obj.to = clipPos(doc, to); }
    if (text) { obj.text = text; }
    if (origin !== undefined) { obj.origin = origin; }
  }; }
  signal(doc, "beforeChange", doc, obj);
  if (doc.cm) { signal(doc.cm, "beforeChange", doc.cm, obj); }

  if (obj.canceled) { return null }
  return {from: obj.from, to: obj.to, text: obj.text, origin: obj.origin}
}

// Apply a change to a document, and add it to the document's
// history, and propagating it to all linked documents.
function makeChange(doc, change, ignoreReadOnly) {
  if (doc.cm) {
    if (!doc.cm.curOp) { return operation(doc.cm, makeChange)(doc, change, ignoreReadOnly) }
    if (doc.cm.state.suppressEdits) { return }
  }

  if (hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange")) {
    change = filterChange(doc, change, true);
    if (!change) { return }
  }

  // Possibly split or suppress the update based on the presence
  // of read-only spans in its range.
  var split = sawReadOnlySpans && !ignoreReadOnly && removeReadOnlyRanges(doc, change.from, change.to);
  if (split) {
    for (var i = split.length - 1; i >= 0; --i)
      { makeChangeInner(doc, {from: split[i].from, to: split[i].to, text: i ? [""] : change.text}); }
  } else {
    makeChangeInner(doc, change);
  }
}

function makeChangeInner(doc, change) {
  if (change.text.length == 1 && change.text[0] == "" && cmp(change.from, change.to) == 0) { return }
  var selAfter = computeSelAfterChange(doc, change);
  addChangeToHistory(doc, change, selAfter, doc.cm ? doc.cm.curOp.id : NaN);

  makeChangeSingleDoc(doc, change, selAfter, stretchSpansOverChange(doc, change));
  var rebased = [];

  linkedDocs(doc, function (doc, sharedHist) {
    if (!sharedHist && indexOf(rebased, doc.history) == -1) {
      rebaseHist(doc.history, change);
      rebased.push(doc.history);
    }
    makeChangeSingleDoc(doc, change, null, stretchSpansOverChange(doc, change));
  });
}

// Revert a change stored in a document's history.
function makeChangeFromHistory(doc, type, allowSelectionOnly) {
  if (doc.cm && doc.cm.state.suppressEdits && !allowSelectionOnly) { return }

  var hist = doc.history, event, selAfter = doc.sel;
  var source = type == "undo" ? hist.done : hist.undone, dest = type == "undo" ? hist.undone : hist.done;

  // Verify that there is a useable event (so that ctrl-z won't
  // needlessly clear selection events)
  var i = 0;
  for (; i < source.length; i++) {
    event = source[i];
    if (allowSelectionOnly ? event.ranges && !event.equals(doc.sel) : !event.ranges)
      { break }
  }
  if (i == source.length) { return }
  hist.lastOrigin = hist.lastSelOrigin = null;

  for (;;) {
    event = source.pop();
    if (event.ranges) {
      pushSelectionToHistory(event, dest);
      if (allowSelectionOnly && !event.equals(doc.sel)) {
        setSelection(doc, event, {clearRedo: false});
        return
      }
      selAfter = event;
    }
    else { break }
  }

  // Build up a reverse change object to add to the opposite history
  // stack (redo when undoing, and vice versa).
  var antiChanges = [];
  pushSelectionToHistory(selAfter, dest);
  dest.push({changes: antiChanges, generation: hist.generation});
  hist.generation = event.generation || ++hist.maxGeneration;

  var filter = hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange");

  var loop = function ( i ) {
    var change = event.changes[i];
    change.origin = type;
    if (filter && !filterChange(doc, change, false)) {
      source.length = 0;
      return {}
    }

    antiChanges.push(historyChangeFromChange(doc, change));

    var after = i ? computeSelAfterChange(doc, change) : lst(source);
    makeChangeSingleDoc(doc, change, after, mergeOldSpans(doc, change));
    if (!i && doc.cm) { doc.cm.scrollIntoView({from: change.from, to: changeEnd(change)}); }
    var rebased = [];

    // Propagate to the linked documents
    linkedDocs(doc, function (doc, sharedHist) {
      if (!sharedHist && indexOf(rebased, doc.history) == -1) {
        rebaseHist(doc.history, change);
        rebased.push(doc.history);
      }
      makeChangeSingleDoc(doc, change, null, mergeOldSpans(doc, change));
    });
  };

  for (var i$1 = event.changes.length - 1; i$1 >= 0; --i$1) {
    var returned = loop( i$1 );

    if ( returned ) return returned.v;
  }
}

// Sub-views need their line numbers shifted when text is added
// above or below them in the parent document.
function shiftDoc(doc, distance) {
  if (distance == 0) { return }
  doc.first += distance;
  doc.sel = new Selection(map(doc.sel.ranges, function (range) { return new Range(
    Pos(range.anchor.line + distance, range.anchor.ch),
    Pos(range.head.line + distance, range.head.ch)
  ); }), doc.sel.primIndex);
  if (doc.cm) {
    regChange(doc.cm, doc.first, doc.first - distance, distance);
    for (var d = doc.cm.display, l = d.viewFrom; l < d.viewTo; l++)
      { regLineChange(doc.cm, l, "gutter"); }
  }
}

// More lower-level change function, handling only a single document
// (not linked ones).
function makeChangeSingleDoc(doc, change, selAfter, spans) {
  if (doc.cm && !doc.cm.curOp)
    { return operation(doc.cm, makeChangeSingleDoc)(doc, change, selAfter, spans) }

  if (change.to.line < doc.first) {
    shiftDoc(doc, change.text.length - 1 - (change.to.line - change.from.line));
    return
  }
  if (change.from.line > doc.lastLine()) { return }

  // Clip the change to the size of this doc
  if (change.from.line < doc.first) {
    var shift = change.text.length - 1 - (doc.first - change.from.line);
    shiftDoc(doc, shift);
    change = {from: Pos(doc.first, 0), to: Pos(change.to.line + shift, change.to.ch),
              text: [lst(change.text)], origin: change.origin};
  }
  var last = doc.lastLine();
  if (change.to.line > last) {
    change = {from: change.from, to: Pos(last, getLine(doc, last).text.length),
              text: [change.text[0]], origin: change.origin};
  }

  change.removed = getBetween(doc, change.from, change.to);

  if (!selAfter) { selAfter = computeSelAfterChange(doc, change); }
  if (doc.cm) { makeChangeSingleDocInEditor(doc.cm, change, spans); }
  else { updateDoc(doc, change, spans); }
  setSelectionNoUndo(doc, selAfter, sel_dontScroll);
}

// Handle the interaction of a change to a document with the editor
// that this document is part of.
function makeChangeSingleDocInEditor(cm, change, spans) {
  var doc = cm.doc, display = cm.display, from = change.from, to = change.to;

  var recomputeMaxLength = false, checkWidthStart = from.line;
  if (!cm.options.lineWrapping) {
    checkWidthStart = lineNo(visualLine(getLine(doc, from.line)));
    doc.iter(checkWidthStart, to.line + 1, function (line) {
      if (line == display.maxLine) {
        recomputeMaxLength = true;
        return true
      }
    });
  }

  if (doc.sel.contains(change.from, change.to) > -1)
    { signalCursorActivity(cm); }

  updateDoc(doc, change, spans, estimateHeight(cm));

  if (!cm.options.lineWrapping) {
    doc.iter(checkWidthStart, from.line + change.text.length, function (line) {
      var len = lineLength(line);
      if (len > display.maxLineLength) {
        display.maxLine = line;
        display.maxLineLength = len;
        display.maxLineChanged = true;
        recomputeMaxLength = false;
      }
    });
    if (recomputeMaxLength) { cm.curOp.updateMaxLine = true; }
  }

  retreatFrontier(doc, from.line);
  startWorker(cm, 400);

  var lendiff = change.text.length - (to.line - from.line) - 1;
  // Remember that these lines changed, for updating the display
  if (change.full)
    { regChange(cm); }
  else if (from.line == to.line && change.text.length == 1 && !isWholeLineUpdate(cm.doc, change))
    { regLineChange(cm, from.line, "text"); }
  else
    { regChange(cm, from.line, to.line + 1, lendiff); }

  var changesHandler = hasHandler(cm, "changes"), changeHandler = hasHandler(cm, "change");
  if (changeHandler || changesHandler) {
    var obj = {
      from: from, to: to,
      text: change.text,
      removed: change.removed,
      origin: change.origin
    };
    if (changeHandler) { signalLater(cm, "change", cm, obj); }
    if (changesHandler) { (cm.curOp.changeObjs || (cm.curOp.changeObjs = [])).push(obj); }
  }
  cm.display.selForContextMenu = null;
}

function replaceRange(doc, code, from, to, origin) {
  if (!to) { to = from; }
  if (cmp(to, from) < 0) { var tmp = to; to = from; from = tmp; }
  if (typeof code == "string") { code = doc.splitLines(code); }
  makeChange(doc, {from: from, to: to, text: code, origin: origin});
}

// Rebasing/resetting history to deal with externally-sourced changes

function rebaseHistSelSingle(pos, from, to, diff) {
  if (to < pos.line) {
    pos.line += diff;
  } else if (from < pos.line) {
    pos.line = from;
    pos.ch = 0;
  }
}

// Tries to rebase an array of history events given a change in the
// document. If the change touches the same lines as the event, the
// event, and everything 'behind' it, is discarded. If the change is
// before the event, the event's positions are updated. Uses a
// copy-on-write scheme for the positions, to avoid having to
// reallocate them all on every rebase, but also avoid problems with
// shared position objects being unsafely updated.
function rebaseHistArray(array, from, to, diff) {
  for (var i = 0; i < array.length; ++i) {
    var sub = array[i], ok = true;
    if (sub.ranges) {
      if (!sub.copied) { sub = array[i] = sub.deepCopy(); sub.copied = true; }
      for (var j = 0; j < sub.ranges.length; j++) {
        rebaseHistSelSingle(sub.ranges[j].anchor, from, to, diff);
        rebaseHistSelSingle(sub.ranges[j].head, from, to, diff);
      }
      continue
    }
    for (var j$1 = 0; j$1 < sub.changes.length; ++j$1) {
      var cur = sub.changes[j$1];
      if (to < cur.from.line) {
        cur.from = Pos(cur.from.line + diff, cur.from.ch);
        cur.to = Pos(cur.to.line + diff, cur.to.ch);
      } else if (from <= cur.to.line) {
        ok = false;
        break
      }
    }
    if (!ok) {
      array.splice(0, i + 1);
      i = 0;
    }
  }
}

function rebaseHist(hist, change) {
  var from = change.from.line, to = change.to.line, diff = change.text.length - (to - from) - 1;
  rebaseHistArray(hist.done, from, to, diff);
  rebaseHistArray(hist.undone, from, to, diff);
}

// Utility for applying a change to a line by handle or number,
// returning the number and optionally registering the line as
// changed.
function changeLine(doc, handle, changeType, op) {
  var no = handle, line = handle;
  if (typeof handle == "number") { line = getLine(doc, clipLine(doc, handle)); }
  else { no = lineNo(handle); }
  if (no == null) { return null }
  if (op(line, no) && doc.cm) { regLineChange(doc.cm, no, changeType); }
  return line
}

// The document is represented as a BTree consisting of leaves, with
// chunk of lines in them, and branches, with up to ten leaves or
// other branch nodes below them. The top node is always a branch
// node, and is the document object itself (meaning it has
// additional methods and properties).
//
// All nodes have parent links. The tree is used both to go from
// line numbers to line objects, and to go from objects to numbers.
// It also indexes by height, and is used to convert between height
// and line object, and to find the total height of the document.
//
// See also http://marijnhaverbeke.nl/blog/codemirror-line-tree.html

function LeafChunk(lines) {
  var this$1 = this;

  this.lines = lines;
  this.parent = null;
  var height = 0;
  for (var i = 0; i < lines.length; ++i) {
    lines[i].parent = this$1;
    height += lines[i].height;
  }
  this.height = height;
}

LeafChunk.prototype = {
  chunkSize: function chunkSize() { return this.lines.length },

  // Remove the n lines at offset 'at'.
  removeInner: function removeInner(at, n) {
    var this$1 = this;

    for (var i = at, e = at + n; i < e; ++i) {
      var line = this$1.lines[i];
      this$1.height -= line.height;
      cleanUpLine(line);
      signalLater(line, "delete");
    }
    this.lines.splice(at, n);
  },

  // Helper used to collapse a small branch into a single leaf.
  collapse: function collapse(lines) {
    lines.push.apply(lines, this.lines);
  },

  // Insert the given array of lines at offset 'at', count them as
  // having the given height.
  insertInner: function insertInner(at, lines, height) {
    var this$1 = this;

    this.height += height;
    this.lines = this.lines.slice(0, at).concat(lines).concat(this.lines.slice(at));
    for (var i = 0; i < lines.length; ++i) { lines[i].parent = this$1; }
  },

  // Used to iterate over a part of the tree.
  iterN: function iterN(at, n, op) {
    var this$1 = this;

    for (var e = at + n; at < e; ++at)
      { if (op(this$1.lines[at])) { return true } }
  }
};

function BranchChunk(children) {
  var this$1 = this;

  this.children = children;
  var size = 0, height = 0;
  for (var i = 0; i < children.length; ++i) {
    var ch = children[i];
    size += ch.chunkSize(); height += ch.height;
    ch.parent = this$1;
  }
  this.size = size;
  this.height = height;
  this.parent = null;
}

BranchChunk.prototype = {
  chunkSize: function chunkSize() { return this.size },

  removeInner: function removeInner(at, n) {
    var this$1 = this;

    this.size -= n;
    for (var i = 0; i < this.children.length; ++i) {
      var child = this$1.children[i], sz = child.chunkSize();
      if (at < sz) {
        var rm = Math.min(n, sz - at), oldHeight = child.height;
        child.removeInner(at, rm);
        this$1.height -= oldHeight - child.height;
        if (sz == rm) { this$1.children.splice(i--, 1); child.parent = null; }
        if ((n -= rm) == 0) { break }
        at = 0;
      } else { at -= sz; }
    }
    // If the result is smaller than 25 lines, ensure that it is a
    // single leaf node.
    if (this.size - n < 25 &&
        (this.children.length > 1 || !(this.children[0] instanceof LeafChunk))) {
      var lines = [];
      this.collapse(lines);
      this.children = [new LeafChunk(lines)];
      this.children[0].parent = this;
    }
  },

  collapse: function collapse(lines) {
    var this$1 = this;

    for (var i = 0; i < this.children.length; ++i) { this$1.children[i].collapse(lines); }
  },

  insertInner: function insertInner(at, lines, height) {
    var this$1 = this;

    this.size += lines.length;
    this.height += height;
    for (var i = 0; i < this.children.length; ++i) {
      var child = this$1.children[i], sz = child.chunkSize();
      if (at <= sz) {
        child.insertInner(at, lines, height);
        if (child.lines && child.lines.length > 50) {
          // To avoid memory thrashing when child.lines is huge (e.g. first view of a large file), it's never spliced.
          // Instead, small slices are taken. They're taken in order because sequential memory accesses are fastest.
          var remaining = child.lines.length % 25 + 25;
          for (var pos = remaining; pos < child.lines.length;) {
            var leaf = new LeafChunk(child.lines.slice(pos, pos += 25));
            child.height -= leaf.height;
            this$1.children.splice(++i, 0, leaf);
            leaf.parent = this$1;
          }
          child.lines = child.lines.slice(0, remaining);
          this$1.maybeSpill();
        }
        break
      }
      at -= sz;
    }
  },

  // When a node has grown, check whether it should be split.
  maybeSpill: function maybeSpill() {
    if (this.children.length <= 10) { return }
    var me = this;
    do {
      var spilled = me.children.splice(me.children.length - 5, 5);
      var sibling = new BranchChunk(spilled);
      if (!me.parent) { // Become the parent node
        var copy = new BranchChunk(me.children);
        copy.parent = me;
        me.children = [copy, sibling];
        me = copy;
     } else {
        me.size -= sibling.size;
        me.height -= sibling.height;
        var myIndex = indexOf(me.parent.children, me);
        me.parent.children.splice(myIndex + 1, 0, sibling);
      }
      sibling.parent = me.parent;
    } while (me.children.length > 10)
    me.parent.maybeSpill();
  },

  iterN: function iterN(at, n, op) {
    var this$1 = this;

    for (var i = 0; i < this.children.length; ++i) {
      var child = this$1.children[i], sz = child.chunkSize();
      if (at < sz) {
        var used = Math.min(n, sz - at);
        if (child.iterN(at, used, op)) { return true }
        if ((n -= used) == 0) { break }
        at = 0;
      } else { at -= sz; }
    }
  }
};

// Line widgets are block elements displayed above or below a line.

var LineWidget = function(doc, node, options) {
  var this$1 = this;

  if (options) { for (var opt in options) { if (options.hasOwnProperty(opt))
    { this$1[opt] = options[opt]; } } }
  this.doc = doc;
  this.node = node;
};

LineWidget.prototype.clear = function () {
    var this$1 = this;

  var cm = this.doc.cm, ws = this.line.widgets, line = this.line, no = lineNo(line);
  if (no == null || !ws) { return }
  for (var i = 0; i < ws.length; ++i) { if (ws[i] == this$1) { ws.splice(i--, 1); } }
  if (!ws.length) { line.widgets = null; }
  var height = widgetHeight(this);
  updateLineHeight(line, Math.max(0, line.height - height));
  if (cm) {
    runInOp(cm, function () {
      adjustScrollWhenAboveVisible(cm, line, -height);
      regLineChange(cm, no, "widget");
    });
    signalLater(cm, "lineWidgetCleared", cm, this, no);
  }
};

LineWidget.prototype.changed = function () {
    var this$1 = this;

  var oldH = this.height, cm = this.doc.cm, line = this.line;
  this.height = null;
  var diff = widgetHeight(this) - oldH;
  if (!diff) { return }
  updateLineHeight(line, line.height + diff);
  if (cm) {
    runInOp(cm, function () {
      cm.curOp.forceUpdate = true;
      adjustScrollWhenAboveVisible(cm, line, diff);
      signalLater(cm, "lineWidgetChanged", cm, this$1, lineNo(line));
    });
  }
};
eventMixin(LineWidget);

function adjustScrollWhenAboveVisible(cm, line, diff) {
  if (heightAtLine(line) < ((cm.curOp && cm.curOp.scrollTop) || cm.doc.scrollTop))
    { addToScrollTop(cm, diff); }
}

function addLineWidget(doc, handle, node, options) {
  var widget = new LineWidget(doc, node, options);
  var cm = doc.cm;
  if (cm && widget.noHScroll) { cm.display.alignWidgets = true; }
  changeLine(doc, handle, "widget", function (line) {
    var widgets = line.widgets || (line.widgets = []);
    if (widget.insertAt == null) { widgets.push(widget); }
    else { widgets.splice(Math.min(widgets.length - 1, Math.max(0, widget.insertAt)), 0, widget); }
    widget.line = line;
    if (cm && !lineIsHidden(doc, line)) {
      var aboveVisible = heightAtLine(line) < doc.scrollTop;
      updateLineHeight(line, line.height + widgetHeight(widget));
      if (aboveVisible) { addToScrollTop(cm, widget.height); }
      cm.curOp.forceUpdate = true;
    }
    return true
  });
  signalLater(cm, "lineWidgetAdded", cm, widget, typeof handle == "number" ? handle : lineNo(handle));
  return widget
}

// TEXTMARKERS

// Created with markText and setBookmark methods. A TextMarker is a
// handle that can be used to clear or find a marked position in the
// document. Line objects hold arrays (markedSpans) containing
// {from, to, marker} object pointing to such marker objects, and
// indicating that such a marker is present on that line. Multiple
// lines may point to the same marker when it spans across lines.
// The spans will have null for their from/to properties when the
// marker continues beyond the start/end of the line. Markers have
// links back to the lines they currently touch.

// Collapsed markers have unique ids, in order to be able to order
// them, which is needed for uniquely determining an outer marker
// when they overlap (they may nest, but not partially overlap).
var nextMarkerId = 0;

var TextMarker = function(doc, type) {
  this.lines = [];
  this.type = type;
  this.doc = doc;
  this.id = ++nextMarkerId;
};

// Clear the marker.
TextMarker.prototype.clear = function () {
    var this$1 = this;

  if (this.explicitlyCleared) { return }
  var cm = this.doc.cm, withOp = cm && !cm.curOp;
  if (withOp) { startOperation(cm); }
  if (hasHandler(this, "clear")) {
    var found = this.find();
    if (found) { signalLater(this, "clear", found.from, found.to); }
  }
  var min = null, max = null;
  for (var i = 0; i < this.lines.length; ++i) {
    var line = this$1.lines[i];
    var span = getMarkedSpanFor(line.markedSpans, this$1);
    if (cm && !this$1.collapsed) { regLineChange(cm, lineNo(line), "text"); }
    else if (cm) {
      if (span.to != null) { max = lineNo(line); }
      if (span.from != null) { min = lineNo(line); }
    }
    line.markedSpans = removeMarkedSpan(line.markedSpans, span);
    if (span.from == null && this$1.collapsed && !lineIsHidden(this$1.doc, line) && cm)
      { updateLineHeight(line, textHeight(cm.display)); }
  }
  if (cm && this.collapsed && !cm.options.lineWrapping) { for (var i$1 = 0; i$1 < this.lines.length; ++i$1) {
    var visual = visualLine(this$1.lines[i$1]), len = lineLength(visual);
    if (len > cm.display.maxLineLength) {
      cm.display.maxLine = visual;
      cm.display.maxLineLength = len;
      cm.display.maxLineChanged = true;
    }
  } }

  if (min != null && cm && this.collapsed) { regChange(cm, min, max + 1); }
  this.lines.length = 0;
  this.explicitlyCleared = true;
  if (this.atomic && this.doc.cantEdit) {
    this.doc.cantEdit = false;
    if (cm) { reCheckSelection(cm.doc); }
  }
  if (cm) { signalLater(cm, "markerCleared", cm, this, min, max); }
  if (withOp) { endOperation(cm); }
  if (this.parent) { this.parent.clear(); }
};

// Find the position of the marker in the document. Returns a {from,
// to} object by default. Side can be passed to get a specific side
// -- 0 (both), -1 (left), or 1 (right). When lineObj is true, the
// Pos objects returned contain a line object, rather than a line
// number (used to prevent looking up the same line twice).
TextMarker.prototype.find = function (side, lineObj) {
    var this$1 = this;

  if (side == null && this.type == "bookmark") { side = 1; }
  var from, to;
  for (var i = 0; i < this.lines.length; ++i) {
    var line = this$1.lines[i];
    var span = getMarkedSpanFor(line.markedSpans, this$1);
    if (span.from != null) {
      from = Pos(lineObj ? line : lineNo(line), span.from);
      if (side == -1) { return from }
    }
    if (span.to != null) {
      to = Pos(lineObj ? line : lineNo(line), span.to);
      if (side == 1) { return to }
    }
  }
  return from && {from: from, to: to}
};

// Signals that the marker's widget changed, and surrounding layout
// should be recomputed.
TextMarker.prototype.changed = function () {
    var this$1 = this;

  var pos = this.find(-1, true), widget = this, cm = this.doc.cm;
  if (!pos || !cm) { return }
  runInOp(cm, function () {
    var line = pos.line, lineN = lineNo(pos.line);
    var view = findViewForLine(cm, lineN);
    if (view) {
      clearLineMeasurementCacheFor(view);
      cm.curOp.selectionChanged = cm.curOp.forceUpdate = true;
    }
    cm.curOp.updateMaxLine = true;
    if (!lineIsHidden(widget.doc, line) && widget.height != null) {
      var oldHeight = widget.height;
      widget.height = null;
      var dHeight = widgetHeight(widget) - oldHeight;
      if (dHeight)
        { updateLineHeight(line, line.height + dHeight); }
    }
    signalLater(cm, "markerChanged", cm, this$1);
  });
};

TextMarker.prototype.attachLine = function (line) {
  if (!this.lines.length && this.doc.cm) {
    var op = this.doc.cm.curOp;
    if (!op.maybeHiddenMarkers || indexOf(op.maybeHiddenMarkers, this) == -1)
      { (op.maybeUnhiddenMarkers || (op.maybeUnhiddenMarkers = [])).push(this); }
  }
  this.lines.push(line);
};

TextMarker.prototype.detachLine = function (line) {
  this.lines.splice(indexOf(this.lines, line), 1);
  if (!this.lines.length && this.doc.cm) {
    var op = this.doc.cm.curOp;(op.maybeHiddenMarkers || (op.maybeHiddenMarkers = [])).push(this);
  }
};
eventMixin(TextMarker);

// Create a marker, wire it up to the right lines, and
function markText(doc, from, to, options, type) {
  // Shared markers (across linked documents) are handled separately
  // (markTextShared will call out to this again, once per
  // document).
  if (options && options.shared) { return markTextShared(doc, from, to, options, type) }
  // Ensure we are in an operation.
  if (doc.cm && !doc.cm.curOp) { return operation(doc.cm, markText)(doc, from, to, options, type) }

  var marker = new TextMarker(doc, type), diff = cmp(from, to);
  if (options) { copyObj(options, marker, false); }
  // Don't connect empty markers unless clearWhenEmpty is false
  if (diff > 0 || diff == 0 && marker.clearWhenEmpty !== false)
    { return marker }
  if (marker.replacedWith) {
    // Showing up as a widget implies collapsed (widget replaces text)
    marker.collapsed = true;
    marker.widgetNode = eltP("span", [marker.replacedWith], "CodeMirror-widget");
    if (!options.handleMouseEvents) { marker.widgetNode.setAttribute("cm-ignore-events", "true"); }
    if (options.insertLeft) { marker.widgetNode.insertLeft = true; }
  }
  if (marker.collapsed) {
    if (conflictingCollapsedRange(doc, from.line, from, to, marker) ||
        from.line != to.line && conflictingCollapsedRange(doc, to.line, from, to, marker))
      { throw new Error("Inserting collapsed marker partially overlapping an existing one") }
    seeCollapsedSpans();
  }

  if (marker.addToHistory)
    { addChangeToHistory(doc, {from: from, to: to, origin: "markText"}, doc.sel, NaN); }

  var curLine = from.line, cm = doc.cm, updateMaxLine;
  doc.iter(curLine, to.line + 1, function (line) {
    if (cm && marker.collapsed && !cm.options.lineWrapping && visualLine(line) == cm.display.maxLine)
      { updateMaxLine = true; }
    if (marker.collapsed && curLine != from.line) { updateLineHeight(line, 0); }
    addMarkedSpan(line, new MarkedSpan(marker,
                                       curLine == from.line ? from.ch : null,
                                       curLine == to.line ? to.ch : null));
    ++curLine;
  });
  // lineIsHidden depends on the presence of the spans, so needs a second pass
  if (marker.collapsed) { doc.iter(from.line, to.line + 1, function (line) {
    if (lineIsHidden(doc, line)) { updateLineHeight(line, 0); }
  }); }

  if (marker.clearOnEnter) { on(marker, "beforeCursorEnter", function () { return marker.clear(); }); }

  if (marker.readOnly) {
    seeReadOnlySpans();
    if (doc.history.done.length || doc.history.undone.length)
      { doc.clearHistory(); }
  }
  if (marker.collapsed) {
    marker.id = ++nextMarkerId;
    marker.atomic = true;
  }
  if (cm) {
    // Sync editor state
    if (updateMaxLine) { cm.curOp.updateMaxLine = true; }
    if (marker.collapsed)
      { regChange(cm, from.line, to.line + 1); }
    else if (marker.className || marker.title || marker.startStyle || marker.endStyle || marker.css)
      { for (var i = from.line; i <= to.line; i++) { regLineChange(cm, i, "text"); } }
    if (marker.atomic) { reCheckSelection(cm.doc); }
    signalLater(cm, "markerAdded", cm, marker);
  }
  return marker
}

// SHARED TEXTMARKERS

// A shared marker spans multiple linked documents. It is
// implemented as a meta-marker-object controlling multiple normal
// markers.
var SharedTextMarker = function(markers, primary) {
  var this$1 = this;

  this.markers = markers;
  this.primary = primary;
  for (var i = 0; i < markers.length; ++i)
    { markers[i].parent = this$1; }
};

SharedTextMarker.prototype.clear = function () {
    var this$1 = this;

  if (this.explicitlyCleared) { return }
  this.explicitlyCleared = true;
  for (var i = 0; i < this.markers.length; ++i)
    { this$1.markers[i].clear(); }
  signalLater(this, "clear");
};

SharedTextMarker.prototype.find = function (side, lineObj) {
  return this.primary.find(side, lineObj)
};
eventMixin(SharedTextMarker);

function markTextShared(doc, from, to, options, type) {
  options = copyObj(options);
  options.shared = false;
  var markers = [markText(doc, from, to, options, type)], primary = markers[0];
  var widget = options.widgetNode;
  linkedDocs(doc, function (doc) {
    if (widget) { options.widgetNode = widget.cloneNode(true); }
    markers.push(markText(doc, clipPos(doc, from), clipPos(doc, to), options, type));
    for (var i = 0; i < doc.linked.length; ++i)
      { if (doc.linked[i].isParent) { return } }
    primary = lst(markers);
  });
  return new SharedTextMarker(markers, primary)
}

function findSharedMarkers(doc) {
  return doc.findMarks(Pos(doc.first, 0), doc.clipPos(Pos(doc.lastLine())), function (m) { return m.parent; })
}

function copySharedMarkers(doc, markers) {
  for (var i = 0; i < markers.length; i++) {
    var marker = markers[i], pos = marker.find();
    var mFrom = doc.clipPos(pos.from), mTo = doc.clipPos(pos.to);
    if (cmp(mFrom, mTo)) {
      var subMark = markText(doc, mFrom, mTo, marker.primary, marker.primary.type);
      marker.markers.push(subMark);
      subMark.parent = marker;
    }
  }
}

function detachSharedMarkers(markers) {
  var loop = function ( i ) {
    var marker = markers[i], linked = [marker.primary.doc];
    linkedDocs(marker.primary.doc, function (d) { return linked.push(d); });
    for (var j = 0; j < marker.markers.length; j++) {
      var subMarker = marker.markers[j];
      if (indexOf(linked, subMarker.doc) == -1) {
        subMarker.parent = null;
        marker.markers.splice(j--, 1);
      }
    }
  };

  for (var i = 0; i < markers.length; i++) loop( i );
}

var nextDocId = 0;
var Doc = function(text, mode, firstLine, lineSep, direction) {
  if (!(this instanceof Doc)) { return new Doc(text, mode, firstLine, lineSep, direction) }
  if (firstLine == null) { firstLine = 0; }

  BranchChunk.call(this, [new LeafChunk([new Line("", null)])]);
  this.first = firstLine;
  this.scrollTop = this.scrollLeft = 0;
  this.cantEdit = false;
  this.cleanGeneration = 1;
  this.modeFrontier = this.highlightFrontier = firstLine;
  var start = Pos(firstLine, 0);
  this.sel = simpleSelection(start);
  this.history = new History(null);
  this.id = ++nextDocId;
  this.modeOption = mode;
  this.lineSep = lineSep;
  this.direction = (direction == "rtl") ? "rtl" : "ltr";
  this.extend = false;

  if (typeof text == "string") { text = this.splitLines(text); }
  updateDoc(this, {from: start, to: start, text: text});
  setSelection(this, simpleSelection(start), sel_dontScroll);
};

Doc.prototype = createObj(BranchChunk.prototype, {
  constructor: Doc,
  // Iterate over the document. Supports two forms -- with only one
  // argument, it calls that for each line in the document. With
  // three, it iterates over the range given by the first two (with
  // the second being non-inclusive).
  iter: function(from, to, op) {
    if (op) { this.iterN(from - this.first, to - from, op); }
    else { this.iterN(this.first, this.first + this.size, from); }
  },

  // Non-public interface for adding and removing lines.
  insert: function(at, lines) {
    var height = 0;
    for (var i = 0; i < lines.length; ++i) { height += lines[i].height; }
    this.insertInner(at - this.first, lines, height);
  },
  remove: function(at, n) { this.removeInner(at - this.first, n); },

  // From here, the methods are part of the public interface. Most
  // are also available from CodeMirror (editor) instances.

  getValue: function(lineSep) {
    var lines = getLines(this, this.first, this.first + this.size);
    if (lineSep === false) { return lines }
    return lines.join(lineSep || this.lineSeparator())
  },
  setValue: docMethodOp(function(code) {
    var top = Pos(this.first, 0), last = this.first + this.size - 1;
    makeChange(this, {from: top, to: Pos(last, getLine(this, last).text.length),
                      text: this.splitLines(code), origin: "setValue", full: true}, true);
    if (this.cm) { scrollToCoords(this.cm, 0, 0); }
    setSelection(this, simpleSelection(top), sel_dontScroll);
  }),
  replaceRange: function(code, from, to, origin) {
    from = clipPos(this, from);
    to = to ? clipPos(this, to) : from;
    replaceRange(this, code, from, to, origin);
  },
  getRange: function(from, to, lineSep) {
    var lines = getBetween(this, clipPos(this, from), clipPos(this, to));
    if (lineSep === false) { return lines }
    return lines.join(lineSep || this.lineSeparator())
  },

  getLine: function(line) {var l = this.getLineHandle(line); return l && l.text},

  getLineHandle: function(line) {if (isLine(this, line)) { return getLine(this, line) }},
  getLineNumber: function(line) {return lineNo(line)},

  getLineHandleVisualStart: function(line) {
    if (typeof line == "number") { line = getLine(this, line); }
    return visualLine(line)
  },

  lineCount: function() {return this.size},
  firstLine: function() {return this.first},
  lastLine: function() {return this.first + this.size - 1},

  clipPos: function(pos) {return clipPos(this, pos)},

  getCursor: function(start) {
    var range$$1 = this.sel.primary(), pos;
    if (start == null || start == "head") { pos = range$$1.head; }
    else if (start == "anchor") { pos = range$$1.anchor; }
    else if (start == "end" || start == "to" || start === false) { pos = range$$1.to(); }
    else { pos = range$$1.from(); }
    return pos
  },
  listSelections: function() { return this.sel.ranges },
  somethingSelected: function() {return this.sel.somethingSelected()},

  setCursor: docMethodOp(function(line, ch, options) {
    setSimpleSelection(this, clipPos(this, typeof line == "number" ? Pos(line, ch || 0) : line), null, options);
  }),
  setSelection: docMethodOp(function(anchor, head, options) {
    setSimpleSelection(this, clipPos(this, anchor), clipPos(this, head || anchor), options);
  }),
  extendSelection: docMethodOp(function(head, other, options) {
    extendSelection(this, clipPos(this, head), other && clipPos(this, other), options);
  }),
  extendSelections: docMethodOp(function(heads, options) {
    extendSelections(this, clipPosArray(this, heads), options);
  }),
  extendSelectionsBy: docMethodOp(function(f, options) {
    var heads = map(this.sel.ranges, f);
    extendSelections(this, clipPosArray(this, heads), options);
  }),
  setSelections: docMethodOp(function(ranges, primary, options) {
    var this$1 = this;

    if (!ranges.length) { return }
    var out = [];
    for (var i = 0; i < ranges.length; i++)
      { out[i] = new Range(clipPos(this$1, ranges[i].anchor),
                         clipPos(this$1, ranges[i].head)); }
    if (primary == null) { primary = Math.min(ranges.length - 1, this.sel.primIndex); }
    setSelection(this, normalizeSelection(out, primary), options);
  }),
  addSelection: docMethodOp(function(anchor, head, options) {
    var ranges = this.sel.ranges.slice(0);
    ranges.push(new Range(clipPos(this, anchor), clipPos(this, head || anchor)));
    setSelection(this, normalizeSelection(ranges, ranges.length - 1), options);
  }),

  getSelection: function(lineSep) {
    var this$1 = this;

    var ranges = this.sel.ranges, lines;
    for (var i = 0; i < ranges.length; i++) {
      var sel = getBetween(this$1, ranges[i].from(), ranges[i].to());
      lines = lines ? lines.concat(sel) : sel;
    }
    if (lineSep === false) { return lines }
    else { return lines.join(lineSep || this.lineSeparator()) }
  },
  getSelections: function(lineSep) {
    var this$1 = this;

    var parts = [], ranges = this.sel.ranges;
    for (var i = 0; i < ranges.length; i++) {
      var sel = getBetween(this$1, ranges[i].from(), ranges[i].to());
      if (lineSep !== false) { sel = sel.join(lineSep || this$1.lineSeparator()); }
      parts[i] = sel;
    }
    return parts
  },
  replaceSelection: function(code, collapse, origin) {
    var dup = [];
    for (var i = 0; i < this.sel.ranges.length; i++)
      { dup[i] = code; }
    this.replaceSelections(dup, collapse, origin || "+input");
  },
  replaceSelections: docMethodOp(function(code, collapse, origin) {
    var this$1 = this;

    var changes = [], sel = this.sel;
    for (var i = 0; i < sel.ranges.length; i++) {
      var range$$1 = sel.ranges[i];
      changes[i] = {from: range$$1.from(), to: range$$1.to(), text: this$1.splitLines(code[i]), origin: origin};
    }
    var newSel = collapse && collapse != "end" && computeReplacedSel(this, changes, collapse);
    for (var i$1 = changes.length - 1; i$1 >= 0; i$1--)
      { makeChange(this$1, changes[i$1]); }
    if (newSel) { setSelectionReplaceHistory(this, newSel); }
    else if (this.cm) { ensureCursorVisible(this.cm); }
  }),
  undo: docMethodOp(function() {makeChangeFromHistory(this, "undo");}),
  redo: docMethodOp(function() {makeChangeFromHistory(this, "redo");}),
  undoSelection: docMethodOp(function() {makeChangeFromHistory(this, "undo", true);}),
  redoSelection: docMethodOp(function() {makeChangeFromHistory(this, "redo", true);}),

  setExtending: function(val) {this.extend = val;},
  getExtending: function() {return this.extend},

  historySize: function() {
    var hist = this.history, done = 0, undone = 0;
    for (var i = 0; i < hist.done.length; i++) { if (!hist.done[i].ranges) { ++done; } }
    for (var i$1 = 0; i$1 < hist.undone.length; i$1++) { if (!hist.undone[i$1].ranges) { ++undone; } }
    return {undo: done, redo: undone}
  },
  clearHistory: function() {this.history = new History(this.history.maxGeneration);},

  markClean: function() {
    this.cleanGeneration = this.changeGeneration(true);
  },
  changeGeneration: function(forceSplit) {
    if (forceSplit)
      { this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null; }
    return this.history.generation
  },
  isClean: function (gen) {
    return this.history.generation == (gen || this.cleanGeneration)
  },

  getHistory: function() {
    return {done: copyHistoryArray(this.history.done),
            undone: copyHistoryArray(this.history.undone)}
  },
  setHistory: function(histData) {
    var hist = this.history = new History(this.history.maxGeneration);
    hist.done = copyHistoryArray(histData.done.slice(0), null, true);
    hist.undone = copyHistoryArray(histData.undone.slice(0), null, true);
  },

  setGutterMarker: docMethodOp(function(line, gutterID, value) {
    return changeLine(this, line, "gutter", function (line) {
      var markers = line.gutterMarkers || (line.gutterMarkers = {});
      markers[gutterID] = value;
      if (!value && isEmpty(markers)) { line.gutterMarkers = null; }
      return true
    })
  }),

  clearGutter: docMethodOp(function(gutterID) {
    var this$1 = this;

    this.iter(function (line) {
      if (line.gutterMarkers && line.gutterMarkers[gutterID]) {
        changeLine(this$1, line, "gutter", function () {
          line.gutterMarkers[gutterID] = null;
          if (isEmpty(line.gutterMarkers)) { line.gutterMarkers = null; }
          return true
        });
      }
    });
  }),

  lineInfo: function(line) {
    var n;
    if (typeof line == "number") {
      if (!isLine(this, line)) { return null }
      n = line;
      line = getLine(this, line);
      if (!line) { return null }
    } else {
      n = lineNo(line);
      if (n == null) { return null }
    }
    return {line: n, handle: line, text: line.text, gutterMarkers: line.gutterMarkers,
            textClass: line.textClass, bgClass: line.bgClass, wrapClass: line.wrapClass,
            widgets: line.widgets}
  },

  addLineClass: docMethodOp(function(handle, where, cls) {
    return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
      var prop = where == "text" ? "textClass"
               : where == "background" ? "bgClass"
               : where == "gutter" ? "gutterClass" : "wrapClass";
      if (!line[prop]) { line[prop] = cls; }
      else if (classTest(cls).test(line[prop])) { return false }
      else { line[prop] += " " + cls; }
      return true
    })
  }),
  removeLineClass: docMethodOp(function(handle, where, cls) {
    return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
      var prop = where == "text" ? "textClass"
               : where == "background" ? "bgClass"
               : where == "gutter" ? "gutterClass" : "wrapClass";
      var cur = line[prop];
      if (!cur) { return false }
      else if (cls == null) { line[prop] = null; }
      else {
        var found = cur.match(classTest(cls));
        if (!found) { return false }
        var end = found.index + found[0].length;
        line[prop] = cur.slice(0, found.index) + (!found.index || end == cur.length ? "" : " ") + cur.slice(end) || null;
      }
      return true
    })
  }),

  addLineWidget: docMethodOp(function(handle, node, options) {
    return addLineWidget(this, handle, node, options)
  }),
  removeLineWidget: function(widget) { widget.clear(); },

  markText: function(from, to, options) {
    return markText(this, clipPos(this, from), clipPos(this, to), options, options && options.type || "range")
  },
  setBookmark: function(pos, options) {
    var realOpts = {replacedWith: options && (options.nodeType == null ? options.widget : options),
                    insertLeft: options && options.insertLeft,
                    clearWhenEmpty: false, shared: options && options.shared,
                    handleMouseEvents: options && options.handleMouseEvents};
    pos = clipPos(this, pos);
    return markText(this, pos, pos, realOpts, "bookmark")
  },
  findMarksAt: function(pos) {
    pos = clipPos(this, pos);
    var markers = [], spans = getLine(this, pos.line).markedSpans;
    if (spans) { for (var i = 0; i < spans.length; ++i) {
      var span = spans[i];
      if ((span.from == null || span.from <= pos.ch) &&
          (span.to == null || span.to >= pos.ch))
        { markers.push(span.marker.parent || span.marker); }
    } }
    return markers
  },
  findMarks: function(from, to, filter) {
    from = clipPos(this, from); to = clipPos(this, to);
    var found = [], lineNo$$1 = from.line;
    this.iter(from.line, to.line + 1, function (line) {
      var spans = line.markedSpans;
      if (spans) { for (var i = 0; i < spans.length; i++) {
        var span = spans[i];
        if (!(span.to != null && lineNo$$1 == from.line && from.ch >= span.to ||
              span.from == null && lineNo$$1 != from.line ||
              span.from != null && lineNo$$1 == to.line && span.from >= to.ch) &&
            (!filter || filter(span.marker)))
          { found.push(span.marker.parent || span.marker); }
      } }
      ++lineNo$$1;
    });
    return found
  },
  getAllMarks: function() {
    var markers = [];
    this.iter(function (line) {
      var sps = line.markedSpans;
      if (sps) { for (var i = 0; i < sps.length; ++i)
        { if (sps[i].from != null) { markers.push(sps[i].marker); } } }
    });
    return markers
  },

  posFromIndex: function(off) {
    var ch, lineNo$$1 = this.first, sepSize = this.lineSeparator().length;
    this.iter(function (line) {
      var sz = line.text.length + sepSize;
      if (sz > off) { ch = off; return true }
      off -= sz;
      ++lineNo$$1;
    });
    return clipPos(this, Pos(lineNo$$1, ch))
  },
  indexFromPos: function (coords) {
    coords = clipPos(this, coords);
    var index = coords.ch;
    if (coords.line < this.first || coords.ch < 0) { return 0 }
    var sepSize = this.lineSeparator().length;
    this.iter(this.first, coords.line, function (line) { // iter aborts when callback returns a truthy value
      index += line.text.length + sepSize;
    });
    return index
  },

  copy: function(copyHistory) {
    var doc = new Doc(getLines(this, this.first, this.first + this.size),
                      this.modeOption, this.first, this.lineSep, this.direction);
    doc.scrollTop = this.scrollTop; doc.scrollLeft = this.scrollLeft;
    doc.sel = this.sel;
    doc.extend = false;
    if (copyHistory) {
      doc.history.undoDepth = this.history.undoDepth;
      doc.setHistory(this.getHistory());
    }
    return doc
  },

  linkedDoc: function(options) {
    if (!options) { options = {}; }
    var from = this.first, to = this.first + this.size;
    if (options.from != null && options.from > from) { from = options.from; }
    if (options.to != null && options.to < to) { to = options.to; }
    var copy = new Doc(getLines(this, from, to), options.mode || this.modeOption, from, this.lineSep, this.direction);
    if (options.sharedHist) { copy.history = this.history
    ; }(this.linked || (this.linked = [])).push({doc: copy, sharedHist: options.sharedHist});
    copy.linked = [{doc: this, isParent: true, sharedHist: options.sharedHist}];
    copySharedMarkers(copy, findSharedMarkers(this));
    return copy
  },
  unlinkDoc: function(other) {
    var this$1 = this;

    if (other instanceof CodeMirror$1) { other = other.doc; }
    if (this.linked) { for (var i = 0; i < this.linked.length; ++i) {
      var link = this$1.linked[i];
      if (link.doc != other) { continue }
      this$1.linked.splice(i, 1);
      other.unlinkDoc(this$1);
      detachSharedMarkers(findSharedMarkers(this$1));
      break
    } }
    // If the histories were shared, split them again
    if (other.history == this.history) {
      var splitIds = [other.id];
      linkedDocs(other, function (doc) { return splitIds.push(doc.id); }, true);
      other.history = new History(null);
      other.history.done = copyHistoryArray(this.history.done, splitIds);
      other.history.undone = copyHistoryArray(this.history.undone, splitIds);
    }
  },
  iterLinkedDocs: function(f) {linkedDocs(this, f);},

  getMode: function() {return this.mode},
  getEditor: function() {return this.cm},

  splitLines: function(str) {
    if (this.lineSep) { return str.split(this.lineSep) }
    return splitLinesAuto(str)
  },
  lineSeparator: function() { return this.lineSep || "\n" },

  setDirection: docMethodOp(function (dir) {
    if (dir != "rtl") { dir = "ltr"; }
    if (dir == this.direction) { return }
    this.direction = dir;
    this.iter(function (line) { return line.order = null; });
    if (this.cm) { directionChanged(this.cm); }
  })
});

// Public alias.
Doc.prototype.eachLine = Doc.prototype.iter;

// Kludge to work around strange IE behavior where it'll sometimes
// re-fire a series of drag-related events right after the drop (#1551)
var lastDrop = 0;

function onDrop(e) {
  var cm = this;
  clearDragCursor(cm);
  if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e))
    { return }
  e_preventDefault(e);
  if (ie) { lastDrop = +new Date; }
  var pos = posFromMouse(cm, e, true), files = e.dataTransfer.files;
  if (!pos || cm.isReadOnly()) { return }
  // Might be a file drop, in which case we simply extract the text
  // and insert it.
  if (files && files.length && window.FileReader && window.File) {
    var n = files.length, text = Array(n), read = 0;
    var loadFile = function (file, i) {
      if (cm.options.allowDropFileTypes &&
          indexOf(cm.options.allowDropFileTypes, file.type) == -1)
        { return }

      var reader = new FileReader;
      reader.onload = operation(cm, function () {
        var content = reader.result;
        if (/[\x00-\x08\x0e-\x1f]{2}/.test(content)) { content = ""; }
        text[i] = content;
        if (++read == n) {
          pos = clipPos(cm.doc, pos);
          var change = {from: pos, to: pos,
                        text: cm.doc.splitLines(text.join(cm.doc.lineSeparator())),
                        origin: "paste"};
          makeChange(cm.doc, change);
          setSelectionReplaceHistory(cm.doc, simpleSelection(pos, changeEnd(change)));
        }
      });
      reader.readAsText(file);
    };
    for (var i = 0; i < n; ++i) { loadFile(files[i], i); }
  } else { // Normal drop
    // Don't do a replace if the drop happened inside of the selected text.
    if (cm.state.draggingText && cm.doc.sel.contains(pos) > -1) {
      cm.state.draggingText(e);
      // Ensure the editor is re-focused
      setTimeout(function () { return cm.display.input.focus(); }, 20);
      return
    }
    try {
      var text$1 = e.dataTransfer.getData("Text");
      if (text$1) {
        var selected;
        if (cm.state.draggingText && !cm.state.draggingText.copy)
          { selected = cm.listSelections(); }
        setSelectionNoUndo(cm.doc, simpleSelection(pos, pos));
        if (selected) { for (var i$1 = 0; i$1 < selected.length; ++i$1)
          { replaceRange(cm.doc, "", selected[i$1].anchor, selected[i$1].head, "drag"); } }
        cm.replaceSelection(text$1, "around", "paste");
        cm.display.input.focus();
      }
    }
    catch(e){}
  }
}

function onDragStart(cm, e) {
  if (ie && (!cm.state.draggingText || +new Date - lastDrop < 100)) { e_stop(e); return }
  if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) { return }

  e.dataTransfer.setData("Text", cm.getSelection());
  e.dataTransfer.effectAllowed = "copyMove";

  // Use dummy image instead of default browsers image.
  // Recent Safari (~6.0.2) have a tendency to segfault when this happens, so we don't do it there.
  if (e.dataTransfer.setDragImage && !safari) {
    var img = elt("img", null, null, "position: fixed; left: 0; top: 0;");
    img.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
    if (presto) {
      img.width = img.height = 1;
      cm.display.wrapper.appendChild(img);
      // Force a relayout, or Opera won't use our image for some obscure reason
      img._top = img.offsetTop;
    }
    e.dataTransfer.setDragImage(img, 0, 0);
    if (presto) { img.parentNode.removeChild(img); }
  }
}

function onDragOver(cm, e) {
  var pos = posFromMouse(cm, e);
  if (!pos) { return }
  var frag = document.createDocumentFragment();
  drawSelectionCursor(cm, pos, frag);
  if (!cm.display.dragCursor) {
    cm.display.dragCursor = elt("div", null, "CodeMirror-cursors CodeMirror-dragcursors");
    cm.display.lineSpace.insertBefore(cm.display.dragCursor, cm.display.cursorDiv);
  }
  removeChildrenAndAdd(cm.display.dragCursor, frag);
}

function clearDragCursor(cm) {
  if (cm.display.dragCursor) {
    cm.display.lineSpace.removeChild(cm.display.dragCursor);
    cm.display.dragCursor = null;
  }
}

// These must be handled carefully, because naively registering a
// handler for each editor will cause the editors to never be
// garbage collected.

function forEachCodeMirror(f) {
  if (!document.getElementsByClassName) { return }
  var byClass = document.getElementsByClassName("CodeMirror");
  for (var i = 0; i < byClass.length; i++) {
    var cm = byClass[i].CodeMirror;
    if (cm) { f(cm); }
  }
}

var globalsRegistered = false;
function ensureGlobalHandlers() {
  if (globalsRegistered) { return }
  registerGlobalHandlers();
  globalsRegistered = true;
}
function registerGlobalHandlers() {
  // When the window resizes, we need to refresh active editors.
  var resizeTimer;
  on(window, "resize", function () {
    if (resizeTimer == null) { resizeTimer = setTimeout(function () {
      resizeTimer = null;
      forEachCodeMirror(onResize);
    }, 100); }
  });
  // When the window loses focus, we want to show the editor as blurred
  on(window, "blur", function () { return forEachCodeMirror(onBlur); });
}
// Called when the window resizes
function onResize(cm) {
  var d = cm.display;
  if (d.lastWrapHeight == d.wrapper.clientHeight && d.lastWrapWidth == d.wrapper.clientWidth)
    { return }
  // Might be a text scaling operation, clear size caches.
  d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
  d.scrollbarsClipped = false;
  cm.setSize();
}

var keyNames = {
  3: "Enter", 8: "Backspace", 9: "Tab", 13: "Enter", 16: "Shift", 17: "Ctrl", 18: "Alt",
  19: "Pause", 20: "CapsLock", 27: "Esc", 32: "Space", 33: "PageUp", 34: "PageDown", 35: "End",
  36: "Home", 37: "Left", 38: "Up", 39: "Right", 40: "Down", 44: "PrintScrn", 45: "Insert",
  46: "Delete", 59: ";", 61: "=", 91: "Mod", 92: "Mod", 93: "Mod",
  106: "*", 107: "=", 109: "-", 110: ".", 111: "/", 127: "Delete",
  173: "-", 186: ";", 187: "=", 188: ",", 189: "-", 190: ".", 191: "/", 192: "`", 219: "[", 220: "\\",
  221: "]", 222: "'", 63232: "Up", 63233: "Down", 63234: "Left", 63235: "Right", 63272: "Delete",
  63273: "Home", 63275: "End", 63276: "PageUp", 63277: "PageDown", 63302: "Insert"
};

// Number keys
for (var i = 0; i < 10; i++) { keyNames[i + 48] = keyNames[i + 96] = String(i); }
// Alphabetic keys
for (var i$1 = 65; i$1 <= 90; i$1++) { keyNames[i$1] = String.fromCharCode(i$1); }
// Function keys
for (var i$2 = 1; i$2 <= 12; i$2++) { keyNames[i$2 + 111] = keyNames[i$2 + 63235] = "F" + i$2; }

var keyMap = {};

keyMap.basic = {
  "Left": "goCharLeft", "Right": "goCharRight", "Up": "goLineUp", "Down": "goLineDown",
  "End": "goLineEnd", "Home": "goLineStartSmart", "PageUp": "goPageUp", "PageDown": "goPageDown",
  "Delete": "delCharAfter", "Backspace": "delCharBefore", "Shift-Backspace": "delCharBefore",
  "Tab": "defaultTab", "Shift-Tab": "indentAuto",
  "Enter": "newlineAndIndent", "Insert": "toggleOverwrite",
  "Esc": "singleSelection"
};
// Note that the save and find-related commands aren't defined by
// default. User code or addons can define them. Unknown commands
// are simply ignored.
keyMap.pcDefault = {
  "Ctrl-A": "selectAll", "Ctrl-D": "deleteLine", "Ctrl-Z": "undo", "Shift-Ctrl-Z": "redo", "Ctrl-Y": "redo",
  "Ctrl-Home": "goDocStart", "Ctrl-End": "goDocEnd", "Ctrl-Up": "goLineUp", "Ctrl-Down": "goLineDown",
  "Ctrl-Left": "goGroupLeft", "Ctrl-Right": "goGroupRight", "Alt-Left": "goLineStart", "Alt-Right": "goLineEnd",
  "Ctrl-Backspace": "delGroupBefore", "Ctrl-Delete": "delGroupAfter", "Ctrl-S": "save", "Ctrl-F": "find",
  "Ctrl-G": "findNext", "Shift-Ctrl-G": "findPrev", "Shift-Ctrl-F": "replace", "Shift-Ctrl-R": "replaceAll",
  "Ctrl-[": "indentLess", "Ctrl-]": "indentMore",
  "Ctrl-U": "undoSelection", "Shift-Ctrl-U": "redoSelection", "Alt-U": "redoSelection",
  fallthrough: "basic"
};
// Very basic readline/emacs-style bindings, which are standard on Mac.
keyMap.emacsy = {
  "Ctrl-F": "goCharRight", "Ctrl-B": "goCharLeft", "Ctrl-P": "goLineUp", "Ctrl-N": "goLineDown",
  "Alt-F": "goWordRight", "Alt-B": "goWordLeft", "Ctrl-A": "goLineStart", "Ctrl-E": "goLineEnd",
  "Ctrl-V": "goPageDown", "Shift-Ctrl-V": "goPageUp", "Ctrl-D": "delCharAfter", "Ctrl-H": "delCharBefore",
  "Alt-D": "delWordAfter", "Alt-Backspace": "delWordBefore", "Ctrl-K": "killLine", "Ctrl-T": "transposeChars",
  "Ctrl-O": "openLine"
};
keyMap.macDefault = {
  "Cmd-A": "selectAll", "Cmd-D": "deleteLine", "Cmd-Z": "undo", "Shift-Cmd-Z": "redo", "Cmd-Y": "redo",
  "Cmd-Home": "goDocStart", "Cmd-Up": "goDocStart", "Cmd-End": "goDocEnd", "Cmd-Down": "goDocEnd", "Alt-Left": "goGroupLeft",
  "Alt-Right": "goGroupRight", "Cmd-Left": "goLineLeft", "Cmd-Right": "goLineRight", "Alt-Backspace": "delGroupBefore",
  "Ctrl-Alt-Backspace": "delGroupAfter", "Alt-Delete": "delGroupAfter", "Cmd-S": "save", "Cmd-F": "find",
  "Cmd-G": "findNext", "Shift-Cmd-G": "findPrev", "Cmd-Alt-F": "replace", "Shift-Cmd-Alt-F": "replaceAll",
  "Cmd-[": "indentLess", "Cmd-]": "indentMore", "Cmd-Backspace": "delWrappedLineLeft", "Cmd-Delete": "delWrappedLineRight",
  "Cmd-U": "undoSelection", "Shift-Cmd-U": "redoSelection", "Ctrl-Up": "goDocStart", "Ctrl-Down": "goDocEnd",
  fallthrough: ["basic", "emacsy"]
};
keyMap["default"] = mac ? keyMap.macDefault : keyMap.pcDefault;

// KEYMAP DISPATCH

function normalizeKeyName(name) {
  var parts = name.split(/-(?!$)/);
  name = parts[parts.length - 1];
  var alt, ctrl, shift, cmd;
  for (var i = 0; i < parts.length - 1; i++) {
    var mod = parts[i];
    if (/^(cmd|meta|m)$/i.test(mod)) { cmd = true; }
    else if (/^a(lt)?$/i.test(mod)) { alt = true; }
    else if (/^(c|ctrl|control)$/i.test(mod)) { ctrl = true; }
    else if (/^s(hift)?$/i.test(mod)) { shift = true; }
    else { throw new Error("Unrecognized modifier name: " + mod) }
  }
  if (alt) { name = "Alt-" + name; }
  if (ctrl) { name = "Ctrl-" + name; }
  if (cmd) { name = "Cmd-" + name; }
  if (shift) { name = "Shift-" + name; }
  return name
}

// This is a kludge to keep keymaps mostly working as raw objects
// (backwards compatibility) while at the same time support features
// like normalization and multi-stroke key bindings. It compiles a
// new normalized keymap, and then updates the old object to reflect
// this.
function normalizeKeyMap(keymap) {
  var copy = {};
  for (var keyname in keymap) { if (keymap.hasOwnProperty(keyname)) {
    var value = keymap[keyname];
    if (/^(name|fallthrough|(de|at)tach)$/.test(keyname)) { continue }
    if (value == "...") { delete keymap[keyname]; continue }

    var keys = map(keyname.split(" "), normalizeKeyName);
    for (var i = 0; i < keys.length; i++) {
      var val = (void 0), name = (void 0);
      if (i == keys.length - 1) {
        name = keys.join(" ");
        val = value;
      } else {
        name = keys.slice(0, i + 1).join(" ");
        val = "...";
      }
      var prev = copy[name];
      if (!prev) { copy[name] = val; }
      else if (prev != val) { throw new Error("Inconsistent bindings for " + name) }
    }
    delete keymap[keyname];
  } }
  for (var prop in copy) { keymap[prop] = copy[prop]; }
  return keymap
}

function lookupKey(key, map$$1, handle, context) {
  map$$1 = getKeyMap(map$$1);
  var found = map$$1.call ? map$$1.call(key, context) : map$$1[key];
  if (found === false) { return "nothing" }
  if (found === "...") { return "multi" }
  if (found != null && handle(found)) { return "handled" }

  if (map$$1.fallthrough) {
    if (Object.prototype.toString.call(map$$1.fallthrough) != "[object Array]")
      { return lookupKey(key, map$$1.fallthrough, handle, context) }
    for (var i = 0; i < map$$1.fallthrough.length; i++) {
      var result = lookupKey(key, map$$1.fallthrough[i], handle, context);
      if (result) { return result }
    }
  }
}

// Modifier key presses don't count as 'real' key presses for the
// purpose of keymap fallthrough.
function isModifierKey(value) {
  var name = typeof value == "string" ? value : keyNames[value.keyCode];
  return name == "Ctrl" || name == "Alt" || name == "Shift" || name == "Mod"
}

function addModifierNames(name, event, noShift) {
  var base = name;
  if (event.altKey && base != "Alt") { name = "Alt-" + name; }
  if ((flipCtrlCmd ? event.metaKey : event.ctrlKey) && base != "Ctrl") { name = "Ctrl-" + name; }
  if ((flipCtrlCmd ? event.ctrlKey : event.metaKey) && base != "Cmd") { name = "Cmd-" + name; }
  if (!noShift && event.shiftKey && base != "Shift") { name = "Shift-" + name; }
  return name
}

// Look up the name of a key as indicated by an event object.
function keyName(event, noShift) {
  if (presto && event.keyCode == 34 && event["char"]) { return false }
  var name = keyNames[event.keyCode];
  if (name == null || event.altGraphKey) { return false }
  return addModifierNames(name, event, noShift)
}

function getKeyMap(val) {
  return typeof val == "string" ? keyMap[val] : val
}

// Helper for deleting text near the selection(s), used to implement
// backspace, delete, and similar functionality.
function deleteNearSelection(cm, compute) {
  var ranges = cm.doc.sel.ranges, kill = [];
  // Build up a set of ranges to kill first, merging overlapping
  // ranges.
  for (var i = 0; i < ranges.length; i++) {
    var toKill = compute(ranges[i]);
    while (kill.length && cmp(toKill.from, lst(kill).to) <= 0) {
      var replaced = kill.pop();
      if (cmp(replaced.from, toKill.from) < 0) {
        toKill.from = replaced.from;
        break
      }
    }
    kill.push(toKill);
  }
  // Next, remove those actual ranges.
  runInOp(cm, function () {
    for (var i = kill.length - 1; i >= 0; i--)
      { replaceRange(cm.doc, "", kill[i].from, kill[i].to, "+delete"); }
    ensureCursorVisible(cm);
  });
}

// Commands are parameter-less actions that can be performed on an
// editor, mostly used for keybindings.
var commands = {
  selectAll: selectAll,
  singleSelection: function (cm) { return cm.setSelection(cm.getCursor("anchor"), cm.getCursor("head"), sel_dontScroll); },
  killLine: function (cm) { return deleteNearSelection(cm, function (range) {
    if (range.empty()) {
      var len = getLine(cm.doc, range.head.line).text.length;
      if (range.head.ch == len && range.head.line < cm.lastLine())
        { return {from: range.head, to: Pos(range.head.line + 1, 0)} }
      else
        { return {from: range.head, to: Pos(range.head.line, len)} }
    } else {
      return {from: range.from(), to: range.to()}
    }
  }); },
  deleteLine: function (cm) { return deleteNearSelection(cm, function (range) { return ({
    from: Pos(range.from().line, 0),
    to: clipPos(cm.doc, Pos(range.to().line + 1, 0))
  }); }); },
  delLineLeft: function (cm) { return deleteNearSelection(cm, function (range) { return ({
    from: Pos(range.from().line, 0), to: range.from()
  }); }); },
  delWrappedLineLeft: function (cm) { return deleteNearSelection(cm, function (range) {
    var top = cm.charCoords(range.head, "div").top + 5;
    var leftPos = cm.coordsChar({left: 0, top: top}, "div");
    return {from: leftPos, to: range.from()}
  }); },
  delWrappedLineRight: function (cm) { return deleteNearSelection(cm, function (range) {
    var top = cm.charCoords(range.head, "div").top + 5;
    var rightPos = cm.coordsChar({left: cm.display.lineDiv.offsetWidth + 100, top: top}, "div");
    return {from: range.from(), to: rightPos }
  }); },
  undo: function (cm) { return cm.undo(); },
  redo: function (cm) { return cm.redo(); },
  undoSelection: function (cm) { return cm.undoSelection(); },
  redoSelection: function (cm) { return cm.redoSelection(); },
  goDocStart: function (cm) { return cm.extendSelection(Pos(cm.firstLine(), 0)); },
  goDocEnd: function (cm) { return cm.extendSelection(Pos(cm.lastLine())); },
  goLineStart: function (cm) { return cm.extendSelectionsBy(function (range) { return lineStart(cm, range.head.line); },
    {origin: "+move", bias: 1}
  ); },
  goLineStartSmart: function (cm) { return cm.extendSelectionsBy(function (range) { return lineStartSmart(cm, range.head); },
    {origin: "+move", bias: 1}
  ); },
  goLineEnd: function (cm) { return cm.extendSelectionsBy(function (range) { return lineEnd(cm, range.head.line); },
    {origin: "+move", bias: -1}
  ); },
  goLineRight: function (cm) { return cm.extendSelectionsBy(function (range) {
    var top = cm.charCoords(range.head, "div").top + 5;
    return cm.coordsChar({left: cm.display.lineDiv.offsetWidth + 100, top: top}, "div")
  }, sel_move); },
  goLineLeft: function (cm) { return cm.extendSelectionsBy(function (range) {
    var top = cm.charCoords(range.head, "div").top + 5;
    return cm.coordsChar({left: 0, top: top}, "div")
  }, sel_move); },
  goLineLeftSmart: function (cm) { return cm.extendSelectionsBy(function (range) {
    var top = cm.charCoords(range.head, "div").top + 5;
    var pos = cm.coordsChar({left: 0, top: top}, "div");
    if (pos.ch < cm.getLine(pos.line).search(/\S/)) { return lineStartSmart(cm, range.head) }
    return pos
  }, sel_move); },
  goLineUp: function (cm) { return cm.moveV(-1, "line"); },
  goLineDown: function (cm) { return cm.moveV(1, "line"); },
  goPageUp: function (cm) { return cm.moveV(-1, "page"); },
  goPageDown: function (cm) { return cm.moveV(1, "page"); },
  goCharLeft: function (cm) { return cm.moveH(-1, "char"); },
  goCharRight: function (cm) { return cm.moveH(1, "char"); },
  goColumnLeft: function (cm) { return cm.moveH(-1, "column"); },
  goColumnRight: function (cm) { return cm.moveH(1, "column"); },
  goWordLeft: function (cm) { return cm.moveH(-1, "word"); },
  goGroupRight: function (cm) { return cm.moveH(1, "group"); },
  goGroupLeft: function (cm) { return cm.moveH(-1, "group"); },
  goWordRight: function (cm) { return cm.moveH(1, "word"); },
  delCharBefore: function (cm) { return cm.deleteH(-1, "char"); },
  delCharAfter: function (cm) { return cm.deleteH(1, "char"); },
  delWordBefore: function (cm) { return cm.deleteH(-1, "word"); },
  delWordAfter: function (cm) { return cm.deleteH(1, "word"); },
  delGroupBefore: function (cm) { return cm.deleteH(-1, "group"); },
  delGroupAfter: function (cm) { return cm.deleteH(1, "group"); },
  indentAuto: function (cm) { return cm.indentSelection("smart"); },
  indentMore: function (cm) { return cm.indentSelection("add"); },
  indentLess: function (cm) { return cm.indentSelection("subtract"); },
  insertTab: function (cm) { return cm.replaceSelection("\t"); },
  insertSoftTab: function (cm) {
    var spaces = [], ranges = cm.listSelections(), tabSize = cm.options.tabSize;
    for (var i = 0; i < ranges.length; i++) {
      var pos = ranges[i].from();
      var col = countColumn(cm.getLine(pos.line), pos.ch, tabSize);
      spaces.push(spaceStr(tabSize - col % tabSize));
    }
    cm.replaceSelections(spaces);
  },
  defaultTab: function (cm) {
    if (cm.somethingSelected()) { cm.indentSelection("add"); }
    else { cm.execCommand("insertTab"); }
  },
  // Swap the two chars left and right of each selection's head.
  // Move cursor behind the two swapped characters afterwards.
  //
  // Doesn't consider line feeds a character.
  // Doesn't scan more than one line above to find a character.
  // Doesn't do anything on an empty line.
  // Doesn't do anything with non-empty selections.
  transposeChars: function (cm) { return runInOp(cm, function () {
    var ranges = cm.listSelections(), newSel = [];
    for (var i = 0; i < ranges.length; i++) {
      if (!ranges[i].empty()) { continue }
      var cur = ranges[i].head, line = getLine(cm.doc, cur.line).text;
      if (line) {
        if (cur.ch == line.length) { cur = new Pos(cur.line, cur.ch - 1); }
        if (cur.ch > 0) {
          cur = new Pos(cur.line, cur.ch + 1);
          cm.replaceRange(line.charAt(cur.ch - 1) + line.charAt(cur.ch - 2),
                          Pos(cur.line, cur.ch - 2), cur, "+transpose");
        } else if (cur.line > cm.doc.first) {
          var prev = getLine(cm.doc, cur.line - 1).text;
          if (prev) {
            cur = new Pos(cur.line, 1);
            cm.replaceRange(line.charAt(0) + cm.doc.lineSeparator() +
                            prev.charAt(prev.length - 1),
                            Pos(cur.line - 1, prev.length - 1), cur, "+transpose");
          }
        }
      }
      newSel.push(new Range(cur, cur));
    }
    cm.setSelections(newSel);
  }); },
  newlineAndIndent: function (cm) { return runInOp(cm, function () {
    var sels = cm.listSelections();
    for (var i = sels.length - 1; i >= 0; i--)
      { cm.replaceRange(cm.doc.lineSeparator(), sels[i].anchor, sels[i].head, "+input"); }
    sels = cm.listSelections();
    for (var i$1 = 0; i$1 < sels.length; i$1++)
      { cm.indentLine(sels[i$1].from().line, null, true); }
    ensureCursorVisible(cm);
  }); },
  openLine: function (cm) { return cm.replaceSelection("\n", "start"); },
  toggleOverwrite: function (cm) { return cm.toggleOverwrite(); }
};


function lineStart(cm, lineN) {
  var line = getLine(cm.doc, lineN);
  var visual = visualLine(line);
  if (visual != line) { lineN = lineNo(visual); }
  return endOfLine(true, cm, visual, lineN, 1)
}
function lineEnd(cm, lineN) {
  var line = getLine(cm.doc, lineN);
  var visual = visualLineEnd(line);
  if (visual != line) { lineN = lineNo(visual); }
  return endOfLine(true, cm, line, lineN, -1)
}
function lineStartSmart(cm, pos) {
  var start = lineStart(cm, pos.line);
  var line = getLine(cm.doc, start.line);
  var order = getOrder(line, cm.doc.direction);
  if (!order || order[0].level == 0) {
    var firstNonWS = Math.max(0, line.text.search(/\S/));
    var inWS = pos.line == start.line && pos.ch <= firstNonWS && pos.ch;
    return Pos(start.line, inWS ? 0 : firstNonWS, start.sticky)
  }
  return start
}

// Run a handler that was bound to a key.
function doHandleBinding(cm, bound, dropShift) {
  if (typeof bound == "string") {
    bound = commands[bound];
    if (!bound) { return false }
  }
  // Ensure previous input has been read, so that the handler sees a
  // consistent view of the document
  cm.display.input.ensurePolled();
  var prevShift = cm.display.shift, done = false;
  try {
    if (cm.isReadOnly()) { cm.state.suppressEdits = true; }
    if (dropShift) { cm.display.shift = false; }
    done = bound(cm) != Pass;
  } finally {
    cm.display.shift = prevShift;
    cm.state.suppressEdits = false;
  }
  return done
}

function lookupKeyForEditor(cm, name, handle) {
  for (var i = 0; i < cm.state.keyMaps.length; i++) {
    var result = lookupKey(name, cm.state.keyMaps[i], handle, cm);
    if (result) { return result }
  }
  return (cm.options.extraKeys && lookupKey(name, cm.options.extraKeys, handle, cm))
    || lookupKey(name, cm.options.keyMap, handle, cm)
}

// Note that, despite the name, this function is also used to check
// for bound mouse clicks.

var stopSeq = new Delayed;
function dispatchKey(cm, name, e, handle) {
  var seq = cm.state.keySeq;
  if (seq) {
    if (isModifierKey(name)) { return "handled" }
    stopSeq.set(50, function () {
      if (cm.state.keySeq == seq) {
        cm.state.keySeq = null;
        cm.display.input.reset();
      }
    });
    name = seq + " " + name;
  }
  var result = lookupKeyForEditor(cm, name, handle);

  if (result == "multi")
    { cm.state.keySeq = name; }
  if (result == "handled")
    { signalLater(cm, "keyHandled", cm, name, e); }

  if (result == "handled" || result == "multi") {
    e_preventDefault(e);
    restartBlink(cm);
  }

  if (seq && !result && /\'$/.test(name)) {
    e_preventDefault(e);
    return true
  }
  return !!result
}

// Handle a key from the keydown event.
function handleKeyBinding(cm, e) {
  var name = keyName(e, true);
  if (!name) { return false }

  if (e.shiftKey && !cm.state.keySeq) {
    // First try to resolve full name (including 'Shift-'). Failing
    // that, see if there is a cursor-motion command (starting with
    // 'go') bound to the keyname without 'Shift-'.
    return dispatchKey(cm, "Shift-" + name, e, function (b) { return doHandleBinding(cm, b, true); })
        || dispatchKey(cm, name, e, function (b) {
             if (typeof b == "string" ? /^go[A-Z]/.test(b) : b.motion)
               { return doHandleBinding(cm, b) }
           })
  } else {
    return dispatchKey(cm, name, e, function (b) { return doHandleBinding(cm, b); })
  }
}

// Handle a key from the keypress event
function handleCharBinding(cm, e, ch) {
  return dispatchKey(cm, "'" + ch + "'", e, function (b) { return doHandleBinding(cm, b, true); })
}

var lastStoppedKey = null;
function onKeyDown(e) {
  var cm = this;
  cm.curOp.focus = activeElt();
  if (signalDOMEvent(cm, e)) { return }
  // IE does strange things with escape.
  if (ie && ie_version < 11 && e.keyCode == 27) { e.returnValue = false; }
  var code = e.keyCode;
  cm.display.shift = code == 16 || e.shiftKey;
  var handled = handleKeyBinding(cm, e);
  if (presto) {
    lastStoppedKey = handled ? code : null;
    // Opera has no cut event... we try to at least catch the key combo
    if (!handled && code == 88 && !hasCopyEvent && (mac ? e.metaKey : e.ctrlKey))
      { cm.replaceSelection("", null, "cut"); }
  }

  // Turn mouse into crosshair when Alt is held on Mac.
  if (code == 18 && !/\bCodeMirror-crosshair\b/.test(cm.display.lineDiv.className))
    { showCrossHair(cm); }
}

function showCrossHair(cm) {
  var lineDiv = cm.display.lineDiv;
  addClass(lineDiv, "CodeMirror-crosshair");

  function up(e) {
    if (e.keyCode == 18 || !e.altKey) {
      rmClass(lineDiv, "CodeMirror-crosshair");
      off(document, "keyup", up);
      off(document, "mouseover", up);
    }
  }
  on(document, "keyup", up);
  on(document, "mouseover", up);
}

function onKeyUp(e) {
  if (e.keyCode == 16) { this.doc.sel.shift = false; }
  signalDOMEvent(this, e);
}

function onKeyPress(e) {
  var cm = this;
  if (eventInWidget(cm.display, e) || signalDOMEvent(cm, e) || e.ctrlKey && !e.altKey || mac && e.metaKey) { return }
  var keyCode = e.keyCode, charCode = e.charCode;
  if (presto && keyCode == lastStoppedKey) {lastStoppedKey = null; e_preventDefault(e); return}
  if ((presto && (!e.which || e.which < 10)) && handleKeyBinding(cm, e)) { return }
  var ch = String.fromCharCode(charCode == null ? keyCode : charCode);
  // Some browsers fire keypress events for backspace
  if (ch == "\x08") { return }
  if (handleCharBinding(cm, e, ch)) { return }
  cm.display.input.onKeyPress(e);
}

var DOUBLECLICK_DELAY = 400;

var PastClick = function(time, pos, button) {
  this.time = time;
  this.pos = pos;
  this.button = button;
};

PastClick.prototype.compare = function (time, pos, button) {
  return this.time + DOUBLECLICK_DELAY > time &&
    cmp(pos, this.pos) == 0 && button == this.button
};

var lastClick;
var lastDoubleClick;
function clickRepeat(pos, button) {
  var now = +new Date;
  if (lastDoubleClick && lastDoubleClick.compare(now, pos, button)) {
    lastClick = lastDoubleClick = null;
    return "triple"
  } else if (lastClick && lastClick.compare(now, pos, button)) {
    lastDoubleClick = new PastClick(now, pos, button);
    lastClick = null;
    return "double"
  } else {
    lastClick = new PastClick(now, pos, button);
    lastDoubleClick = null;
    return "single"
  }
}

// A mouse down can be a single click, double click, triple click,
// start of selection drag, start of text drag, new cursor
// (ctrl-click), rectangle drag (alt-drag), or xwin
// middle-click-paste. Or it might be a click on something we should
// not interfere with, such as a scrollbar or widget.
function onMouseDown(e) {
  var cm = this, display = cm.display;
  if (signalDOMEvent(cm, e) || display.activeTouch && display.input.supportsTouch()) { return }
  display.input.ensurePolled();
  display.shift = e.shiftKey;

  if (eventInWidget(display, e)) {
    if (!webkit) {
      // Briefly turn off draggability, to allow widgets to do
      // normal dragging things.
      display.scroller.draggable = false;
      setTimeout(function () { return display.scroller.draggable = true; }, 100);
    }
    return
  }
  if (clickInGutter(cm, e)) { return }
  var pos = posFromMouse(cm, e), button = e_button(e), repeat = pos ? clickRepeat(pos, button) : "single";
  window.focus();

  // #3261: make sure, that we're not starting a second selection
  if (button == 1 && cm.state.selectingText)
    { cm.state.selectingText(e); }

  if (pos && handleMappedButton(cm, button, pos, repeat, e)) { return }

  if (button == 1) {
    if (pos) { leftButtonDown(cm, pos, repeat, e); }
    else if (e_target(e) == display.scroller) { e_preventDefault(e); }
  } else if (button == 2) {
    if (pos) { extendSelection(cm.doc, pos); }
    setTimeout(function () { return display.input.focus(); }, 20);
  } else if (button == 3) {
    if (captureRightClick) { onContextMenu(cm, e); }
    else { delayBlurEvent(cm); }
  }
}

function handleMappedButton(cm, button, pos, repeat, event) {
  var name = "Click";
  if (repeat == "double") { name = "Double" + name; }
  else if (repeat == "triple") { name = "Triple" + name; }
  name = (button == 1 ? "Left" : button == 2 ? "Middle" : "Right") + name;

  return dispatchKey(cm,  addModifierNames(name, event), event, function (bound) {
    if (typeof bound == "string") { bound = commands[bound]; }
    if (!bound) { return false }
    var done = false;
    try {
      if (cm.isReadOnly()) { cm.state.suppressEdits = true; }
      done = bound(cm, pos) != Pass;
    } finally {
      cm.state.suppressEdits = false;
    }
    return done
  })
}

function configureMouse(cm, repeat, event) {
  var option = cm.getOption("configureMouse");
  var value = option ? option(cm, repeat, event) : {};
  if (value.unit == null) {
    var rect = chromeOS ? event.shiftKey && event.metaKey : event.altKey;
    value.unit = rect ? "rectangle" : repeat == "single" ? "char" : repeat == "double" ? "word" : "line";
  }
  if (value.extend == null || cm.doc.extend) { value.extend = cm.doc.extend || event.shiftKey; }
  if (value.addNew == null) { value.addNew = mac ? event.metaKey : event.ctrlKey; }
  if (value.moveOnDrag == null) { value.moveOnDrag = !(mac ? event.altKey : event.ctrlKey); }
  return value
}

function leftButtonDown(cm, pos, repeat, event) {
  if (ie) { setTimeout(bind(ensureFocus, cm), 0); }
  else { cm.curOp.focus = activeElt(); }

  var behavior = configureMouse(cm, repeat, event);

  var sel = cm.doc.sel, contained;
  if (cm.options.dragDrop && dragAndDrop && !cm.isReadOnly() &&
      repeat == "single" && (contained = sel.contains(pos)) > -1 &&
      (cmp((contained = sel.ranges[contained]).from(), pos) < 0 || pos.xRel > 0) &&
      (cmp(contained.to(), pos) > 0 || pos.xRel < 0))
    { leftButtonStartDrag(cm, event, pos, behavior); }
  else
    { leftButtonSelect(cm, event, pos, behavior); }
}

// Start a text drag. When it ends, see if any dragging actually
// happen, and treat as a click if it didn't.
function leftButtonStartDrag(cm, event, pos, behavior) {
  var display = cm.display, moved = false;
  var dragEnd = operation(cm, function (e) {
    if (webkit) { display.scroller.draggable = false; }
    cm.state.draggingText = false;
    off(document, "mouseup", dragEnd);
    off(document, "mousemove", mouseMove);
    off(display.scroller, "dragstart", dragStart);
    off(display.scroller, "drop", dragEnd);
    if (!moved) {
      e_preventDefault(e);
      if (!behavior.addNew)
        { extendSelection(cm.doc, pos, null, null, behavior.extend); }
      // Work around unexplainable focus problem in IE9 (#2127) and Chrome (#3081)
      if (webkit || ie && ie_version == 9)
        { setTimeout(function () {document.body.focus(); display.input.focus();}, 20); }
      else
        { display.input.focus(); }
    }
  });
  var mouseMove = function(e2) {
    moved = moved || Math.abs(event.clientX - e2.clientX) + Math.abs(event.clientY - e2.clientY) >= 10;
  };
  var dragStart = function () { return moved = true; };
  // Let the drag handler handle this.
  if (webkit) { display.scroller.draggable = true; }
  cm.state.draggingText = dragEnd;
  dragEnd.copy = !behavior.moveOnDrag;
  // IE's approach to draggable
  if (display.scroller.dragDrop) { display.scroller.dragDrop(); }
  on(document, "mouseup", dragEnd);
  on(document, "mousemove", mouseMove);
  on(display.scroller, "dragstart", dragStart);
  on(display.scroller, "drop", dragEnd);

  delayBlurEvent(cm);
  setTimeout(function () { return display.input.focus(); }, 20);
}

function rangeForUnit(cm, pos, unit) {
  if (unit == "char") { return new Range(pos, pos) }
  if (unit == "word") { return cm.findWordAt(pos) }
  if (unit == "line") { return new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0))) }
  var result = unit(cm, pos);
  return new Range(result.from, result.to)
}

// Normal selection, as opposed to text dragging.
function leftButtonSelect(cm, event, start, behavior) {
  var display = cm.display, doc = cm.doc;
  e_preventDefault(event);

  var ourRange, ourIndex, startSel = doc.sel, ranges = startSel.ranges;
  if (behavior.addNew && !behavior.extend) {
    ourIndex = doc.sel.contains(start);
    if (ourIndex > -1)
      { ourRange = ranges[ourIndex]; }
    else
      { ourRange = new Range(start, start); }
  } else {
    ourRange = doc.sel.primary();
    ourIndex = doc.sel.primIndex;
  }

  if (behavior.unit == "rectangle") {
    if (!behavior.addNew) { ourRange = new Range(start, start); }
    start = posFromMouse(cm, event, true, true);
    ourIndex = -1;
  } else {
    var range$$1 = rangeForUnit(cm, start, behavior.unit);
    if (behavior.extend)
      { ourRange = extendRange(ourRange, range$$1.anchor, range$$1.head, behavior.extend); }
    else
      { ourRange = range$$1; }
  }

  if (!behavior.addNew) {
    ourIndex = 0;
    setSelection(doc, new Selection([ourRange], 0), sel_mouse);
    startSel = doc.sel;
  } else if (ourIndex == -1) {
    ourIndex = ranges.length;
    setSelection(doc, normalizeSelection(ranges.concat([ourRange]), ourIndex),
                 {scroll: false, origin: "*mouse"});
  } else if (ranges.length > 1 && ranges[ourIndex].empty() && behavior.unit == "char" && !behavior.extend) {
    setSelection(doc, normalizeSelection(ranges.slice(0, ourIndex).concat(ranges.slice(ourIndex + 1)), 0),
                 {scroll: false, origin: "*mouse"});
    startSel = doc.sel;
  } else {
    replaceOneSelection(doc, ourIndex, ourRange, sel_mouse);
  }

  var lastPos = start;
  function extendTo(pos) {
    if (cmp(lastPos, pos) == 0) { return }
    lastPos = pos;

    if (behavior.unit == "rectangle") {
      var ranges = [], tabSize = cm.options.tabSize;
      var startCol = countColumn(getLine(doc, start.line).text, start.ch, tabSize);
      var posCol = countColumn(getLine(doc, pos.line).text, pos.ch, tabSize);
      var left = Math.min(startCol, posCol), right = Math.max(startCol, posCol);
      for (var line = Math.min(start.line, pos.line), end = Math.min(cm.lastLine(), Math.max(start.line, pos.line));
           line <= end; line++) {
        var text = getLine(doc, line).text, leftPos = findColumn(text, left, tabSize);
        if (left == right)
          { ranges.push(new Range(Pos(line, leftPos), Pos(line, leftPos))); }
        else if (text.length > leftPos)
          { ranges.push(new Range(Pos(line, leftPos), Pos(line, findColumn(text, right, tabSize)))); }
      }
      if (!ranges.length) { ranges.push(new Range(start, start)); }
      setSelection(doc, normalizeSelection(startSel.ranges.slice(0, ourIndex).concat(ranges), ourIndex),
                   {origin: "*mouse", scroll: false});
      cm.scrollIntoView(pos);
    } else {
      var oldRange = ourRange;
      var range$$1 = rangeForUnit(cm, pos, behavior.unit);
      var anchor = oldRange.anchor, head;
      if (cmp(range$$1.anchor, anchor) > 0) {
        head = range$$1.head;
        anchor = minPos(oldRange.from(), range$$1.anchor);
      } else {
        head = range$$1.anchor;
        anchor = maxPos(oldRange.to(), range$$1.head);
      }
      var ranges$1 = startSel.ranges.slice(0);
      ranges$1[ourIndex] = new Range(clipPos(doc, anchor), head);
      setSelection(doc, normalizeSelection(ranges$1, ourIndex), sel_mouse);
    }
  }

  var editorSize = display.wrapper.getBoundingClientRect();
  // Used to ensure timeout re-tries don't fire when another extend
  // happened in the meantime (clearTimeout isn't reliable -- at
  // least on Chrome, the timeouts still happen even when cleared,
  // if the clear happens after their scheduled firing time).
  var counter = 0;

  function extend(e) {
    var curCount = ++counter;
    var cur = posFromMouse(cm, e, true, behavior.unit == "rectangle");
    if (!cur) { return }
    if (cmp(cur, lastPos) != 0) {
      cm.curOp.focus = activeElt();
      extendTo(cur);
      var visible = visibleLines(display, doc);
      if (cur.line >= visible.to || cur.line < visible.from)
        { setTimeout(operation(cm, function () {if (counter == curCount) { extend(e); }}), 150); }
    } else {
      var outside = e.clientY < editorSize.top ? -20 : e.clientY > editorSize.bottom ? 20 : 0;
      if (outside) { setTimeout(operation(cm, function () {
        if (counter != curCount) { return }
        display.scroller.scrollTop += outside;
        extend(e);
      }), 50); }
    }
  }

  function done(e) {
    cm.state.selectingText = false;
    counter = Infinity;
    e_preventDefault(e);
    display.input.focus();
    off(document, "mousemove", move);
    off(document, "mouseup", up);
    doc.history.lastSelOrigin = null;
  }

  var move = operation(cm, function (e) {
    if (!e_button(e)) { done(e); }
    else { extend(e); }
  });
  var up = operation(cm, done);
  cm.state.selectingText = up;
  on(document, "mousemove", move);
  on(document, "mouseup", up);
}


// Determines whether an event happened in the gutter, and fires the
// handlers for the corresponding event.
function gutterEvent(cm, e, type, prevent) {
  var mX, mY;
  try { mX = e.clientX; mY = e.clientY; }
  catch(e) { return false }
  if (mX >= Math.floor(cm.display.gutters.getBoundingClientRect().right)) { return false }
  if (prevent) { e_preventDefault(e); }

  var display = cm.display;
  var lineBox = display.lineDiv.getBoundingClientRect();

  if (mY > lineBox.bottom || !hasHandler(cm, type)) { return e_defaultPrevented(e) }
  mY -= lineBox.top - display.viewOffset;

  for (var i = 0; i < cm.options.gutters.length; ++i) {
    var g = display.gutters.childNodes[i];
    if (g && g.getBoundingClientRect().right >= mX) {
      var line = lineAtHeight(cm.doc, mY);
      var gutter = cm.options.gutters[i];
      signal(cm, type, cm, line, gutter, e);
      return e_defaultPrevented(e)
    }
  }
}

function clickInGutter(cm, e) {
  return gutterEvent(cm, e, "gutterClick", true)
}

// CONTEXT MENU HANDLING

// To make the context menu work, we need to briefly unhide the
// textarea (making it as unobtrusive as possible) to let the
// right-click take effect on it.
function onContextMenu(cm, e) {
  if (eventInWidget(cm.display, e) || contextMenuInGutter(cm, e)) { return }
  if (signalDOMEvent(cm, e, "contextmenu")) { return }
  cm.display.input.onContextMenu(e);
}

function contextMenuInGutter(cm, e) {
  if (!hasHandler(cm, "gutterContextMenu")) { return false }
  return gutterEvent(cm, e, "gutterContextMenu", false)
}

function themeChanged(cm) {
  cm.display.wrapper.className = cm.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") +
    cm.options.theme.replace(/(^|\s)\s*/g, " cm-s-");
  clearCaches(cm);
}

var Init = {toString: function(){return "CodeMirror.Init"}};

var defaults = {};
var optionHandlers = {};

function defineOptions(CodeMirror) {
  var optionHandlers = CodeMirror.optionHandlers;

  function option(name, deflt, handle, notOnInit) {
    CodeMirror.defaults[name] = deflt;
    if (handle) { optionHandlers[name] =
      notOnInit ? function (cm, val, old) {if (old != Init) { handle(cm, val, old); }} : handle; }
  }

  CodeMirror.defineOption = option;

  // Passed to option handlers when there is no old value.
  CodeMirror.Init = Init;

  // These two are, on init, called from the constructor because they
  // have to be initialized before the editor can start at all.
  option("value", "", function (cm, val) { return cm.setValue(val); }, true);
  option("mode", null, function (cm, val) {
    cm.doc.modeOption = val;
    loadMode(cm);
  }, true);

  option("indentUnit", 2, loadMode, true);
  option("indentWithTabs", false);
  option("smartIndent", true);
  option("tabSize", 4, function (cm) {
    resetModeState(cm);
    clearCaches(cm);
    regChange(cm);
  }, true);
  option("lineSeparator", null, function (cm, val) {
    cm.doc.lineSep = val;
    if (!val) { return }
    var newBreaks = [], lineNo = cm.doc.first;
    cm.doc.iter(function (line) {
      for (var pos = 0;;) {
        var found = line.text.indexOf(val, pos);
        if (found == -1) { break }
        pos = found + val.length;
        newBreaks.push(Pos(lineNo, found));
      }
      lineNo++;
    });
    for (var i = newBreaks.length - 1; i >= 0; i--)
      { replaceRange(cm.doc, val, newBreaks[i], Pos(newBreaks[i].line, newBreaks[i].ch + val.length)); }
  });
  option("specialChars", /[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u200b-\u200f\u2028\u2029\ufeff]/g, function (cm, val, old) {
    cm.state.specialChars = new RegExp(val.source + (val.test("\t") ? "" : "|\t"), "g");
    if (old != Init) { cm.refresh(); }
  });
  option("specialCharPlaceholder", defaultSpecialCharPlaceholder, function (cm) { return cm.refresh(); }, true);
  option("electricChars", true);
  option("inputStyle", mobile ? "contenteditable" : "textarea", function () {
    throw new Error("inputStyle can not (yet) be changed in a running editor") // FIXME
  }, true);
  option("spellcheck", false, function (cm, val) { return cm.getInputField().spellcheck = val; }, true);
  option("rtlMoveVisually", !windows);
  option("wholeLineUpdateBefore", true);

  option("theme", "default", function (cm) {
    themeChanged(cm);
    guttersChanged(cm);
  }, true);
  option("keyMap", "default", function (cm, val, old) {
    var next = getKeyMap(val);
    var prev = old != Init && getKeyMap(old);
    if (prev && prev.detach) { prev.detach(cm, next); }
    if (next.attach) { next.attach(cm, prev || null); }
  });
  option("extraKeys", null);
  option("configureMouse", null);

  option("lineWrapping", false, wrappingChanged, true);
  option("gutters", [], function (cm) {
    setGuttersForLineNumbers(cm.options);
    guttersChanged(cm);
  }, true);
  option("fixedGutter", true, function (cm, val) {
    cm.display.gutters.style.left = val ? compensateForHScroll(cm.display) + "px" : "0";
    cm.refresh();
  }, true);
  option("coverGutterNextToScrollbar", false, function (cm) { return updateScrollbars(cm); }, true);
  option("scrollbarStyle", "native", function (cm) {
    initScrollbars(cm);
    updateScrollbars(cm);
    cm.display.scrollbars.setScrollTop(cm.doc.scrollTop);
    cm.display.scrollbars.setScrollLeft(cm.doc.scrollLeft);
  }, true);
  option("lineNumbers", false, function (cm) {
    setGuttersForLineNumbers(cm.options);
    guttersChanged(cm);
  }, true);
  option("firstLineNumber", 1, guttersChanged, true);
  option("lineNumberFormatter", function (integer) { return integer; }, guttersChanged, true);
  option("showCursorWhenSelecting", false, updateSelection, true);

  option("resetSelectionOnContextMenu", true);
  option("lineWiseCopyCut", true);
  option("pasteLinesPerSelection", true);

  option("readOnly", false, function (cm, val) {
    if (val == "nocursor") {
      onBlur(cm);
      cm.display.input.blur();
    }
    cm.display.input.readOnlyChanged(val);
  });
  option("disableInput", false, function (cm, val) {if (!val) { cm.display.input.reset(); }}, true);
  option("dragDrop", true, dragDropChanged);
  option("allowDropFileTypes", null);

  option("cursorBlinkRate", 530);
  option("cursorScrollMargin", 0);
  option("cursorHeight", 1, updateSelection, true);
  option("singleCursorHeightPerLine", true, updateSelection, true);
  option("workTime", 100);
  option("workDelay", 100);
  option("flattenSpans", true, resetModeState, true);
  option("addModeClass", false, resetModeState, true);
  option("pollInterval", 100);
  option("undoDepth", 200, function (cm, val) { return cm.doc.history.undoDepth = val; });
  option("historyEventDelay", 1250);
  option("viewportMargin", 10, function (cm) { return cm.refresh(); }, true);
  option("maxHighlightLength", 10000, resetModeState, true);
  option("moveInputWithCursor", true, function (cm, val) {
    if (!val) { cm.display.input.resetPosition(); }
  });

  option("tabindex", null, function (cm, val) { return cm.display.input.getField().tabIndex = val || ""; });
  option("autofocus", null);
  option("direction", "ltr", function (cm, val) { return cm.doc.setDirection(val); }, true);
}

function guttersChanged(cm) {
  updateGutters(cm);
  regChange(cm);
  alignHorizontally(cm);
}

function dragDropChanged(cm, value, old) {
  var wasOn = old && old != Init;
  if (!value != !wasOn) {
    var funcs = cm.display.dragFunctions;
    var toggle = value ? on : off;
    toggle(cm.display.scroller, "dragstart", funcs.start);
    toggle(cm.display.scroller, "dragenter", funcs.enter);
    toggle(cm.display.scroller, "dragover", funcs.over);
    toggle(cm.display.scroller, "dragleave", funcs.leave);
    toggle(cm.display.scroller, "drop", funcs.drop);
  }
}

function wrappingChanged(cm) {
  if (cm.options.lineWrapping) {
    addClass(cm.display.wrapper, "CodeMirror-wrap");
    cm.display.sizer.style.minWidth = "";
    cm.display.sizerWidth = null;
  } else {
    rmClass(cm.display.wrapper, "CodeMirror-wrap");
    findMaxLine(cm);
  }
  estimateLineHeights(cm);
  regChange(cm);
  clearCaches(cm);
  setTimeout(function () { return updateScrollbars(cm); }, 100);
}

// A CodeMirror instance represents an editor. This is the object
// that user code is usually dealing with.

function CodeMirror$1(place, options) {
  var this$1 = this;

  if (!(this instanceof CodeMirror$1)) { return new CodeMirror$1(place, options) }

  this.options = options = options ? copyObj(options) : {};
  // Determine effective options based on given values and defaults.
  copyObj(defaults, options, false);
  setGuttersForLineNumbers(options);

  var doc = options.value;
  if (typeof doc == "string") { doc = new Doc(doc, options.mode, null, options.lineSeparator, options.direction); }
  this.doc = doc;

  var input = new CodeMirror$1.inputStyles[options.inputStyle](this);
  var display = this.display = new Display(place, doc, input);
  display.wrapper.CodeMirror = this;
  updateGutters(this);
  themeChanged(this);
  if (options.lineWrapping)
    { this.display.wrapper.className += " CodeMirror-wrap"; }
  initScrollbars(this);

  this.state = {
    keyMaps: [],  // stores maps added by addKeyMap
    overlays: [], // highlighting overlays, as added by addOverlay
    modeGen: 0,   // bumped when mode/overlay changes, used to invalidate highlighting info
    overwrite: false,
    delayingBlurEvent: false,
    focused: false,
    suppressEdits: false, // used to disable editing during key handlers when in readOnly mode
    pasteIncoming: false, cutIncoming: false, // help recognize paste/cut edits in input.poll
    selectingText: false,
    draggingText: false,
    highlight: new Delayed(), // stores highlight worker timeout
    keySeq: null,  // Unfinished key sequence
    specialChars: null
  };

  if (options.autofocus && !mobile) { display.input.focus(); }

  // Override magic textarea content restore that IE sometimes does
  // on our hidden textarea on reload
  if (ie && ie_version < 11) { setTimeout(function () { return this$1.display.input.reset(true); }, 20); }

  registerEventHandlers(this);
  ensureGlobalHandlers();

  startOperation(this);
  this.curOp.forceUpdate = true;
  attachDoc(this, doc);

  if ((options.autofocus && !mobile) || this.hasFocus())
    { setTimeout(bind(onFocus, this), 20); }
  else
    { onBlur(this); }

  for (var opt in optionHandlers) { if (optionHandlers.hasOwnProperty(opt))
    { optionHandlers[opt](this$1, options[opt], Init); } }
  maybeUpdateLineNumberWidth(this);
  if (options.finishInit) { options.finishInit(this); }
  for (var i = 0; i < initHooks.length; ++i) { initHooks[i](this$1); }
  endOperation(this);
  // Suppress optimizelegibility in Webkit, since it breaks text
  // measuring on line wrapping boundaries.
  if (webkit && options.lineWrapping &&
      getComputedStyle(display.lineDiv).textRendering == "optimizelegibility")
    { display.lineDiv.style.textRendering = "auto"; }
}

// The default configuration options.
CodeMirror$1.defaults = defaults;
// Functions to run when options are changed.
CodeMirror$1.optionHandlers = optionHandlers;

// Attach the necessary event handlers when initializing the editor
function registerEventHandlers(cm) {
  var d = cm.display;
  on(d.scroller, "mousedown", operation(cm, onMouseDown));
  // Older IE's will not fire a second mousedown for a double click
  if (ie && ie_version < 11)
    { on(d.scroller, "dblclick", operation(cm, function (e) {
      if (signalDOMEvent(cm, e)) { return }
      var pos = posFromMouse(cm, e);
      if (!pos || clickInGutter(cm, e) || eventInWidget(cm.display, e)) { return }
      e_preventDefault(e);
      var word = cm.findWordAt(pos);
      extendSelection(cm.doc, word.anchor, word.head);
    })); }
  else
    { on(d.scroller, "dblclick", function (e) { return signalDOMEvent(cm, e) || e_preventDefault(e); }); }
  // Some browsers fire contextmenu *after* opening the menu, at
  // which point we can't mess with it anymore. Context menu is
  // handled in onMouseDown for these browsers.
  if (!captureRightClick) { on(d.scroller, "contextmenu", function (e) { return onContextMenu(cm, e); }); }

  // Used to suppress mouse event handling when a touch happens
  var touchFinished, prevTouch = {end: 0};
  function finishTouch() {
    if (d.activeTouch) {
      touchFinished = setTimeout(function () { return d.activeTouch = null; }, 1000);
      prevTouch = d.activeTouch;
      prevTouch.end = +new Date;
    }
  }
  function isMouseLikeTouchEvent(e) {
    if (e.touches.length != 1) { return false }
    var touch = e.touches[0];
    return touch.radiusX <= 1 && touch.radiusY <= 1
  }
  function farAway(touch, other) {
    if (other.left == null) { return true }
    var dx = other.left - touch.left, dy = other.top - touch.top;
    return dx * dx + dy * dy > 20 * 20
  }
  on(d.scroller, "touchstart", function (e) {
    if (!signalDOMEvent(cm, e) && !isMouseLikeTouchEvent(e)) {
      d.input.ensurePolled();
      clearTimeout(touchFinished);
      var now = +new Date;
      d.activeTouch = {start: now, moved: false,
                       prev: now - prevTouch.end <= 300 ? prevTouch : null};
      if (e.touches.length == 1) {
        d.activeTouch.left = e.touches[0].pageX;
        d.activeTouch.top = e.touches[0].pageY;
      }
    }
  });
  on(d.scroller, "touchmove", function () {
    if (d.activeTouch) { d.activeTouch.moved = true; }
  });
  on(d.scroller, "touchend", function (e) {
    var touch = d.activeTouch;
    if (touch && !eventInWidget(d, e) && touch.left != null &&
        !touch.moved && new Date - touch.start < 300) {
      var pos = cm.coordsChar(d.activeTouch, "page"), range;
      if (!touch.prev || farAway(touch, touch.prev)) // Single tap
        { range = new Range(pos, pos); }
      else if (!touch.prev.prev || farAway(touch, touch.prev.prev)) // Double tap
        { range = cm.findWordAt(pos); }
      else // Triple tap
        { range = new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0))); }
      cm.setSelection(range.anchor, range.head);
      cm.focus();
      e_preventDefault(e);
    }
    finishTouch();
  });
  on(d.scroller, "touchcancel", finishTouch);

  // Sync scrolling between fake scrollbars and real scrollable
  // area, ensure viewport is updated when scrolling.
  on(d.scroller, "scroll", function () {
    if (d.scroller.clientHeight) {
      updateScrollTop(cm, d.scroller.scrollTop);
      setScrollLeft(cm, d.scroller.scrollLeft, true);
      signal(cm, "scroll", cm);
    }
  });

  // Listen to wheel events in order to try and update the viewport on time.
  on(d.scroller, "mousewheel", function (e) { return onScrollWheel(cm, e); });
  on(d.scroller, "DOMMouseScroll", function (e) { return onScrollWheel(cm, e); });

  // Prevent wrapper from ever scrolling
  on(d.wrapper, "scroll", function () { return d.wrapper.scrollTop = d.wrapper.scrollLeft = 0; });

  d.dragFunctions = {
    enter: function (e) {if (!signalDOMEvent(cm, e)) { e_stop(e); }},
    over: function (e) {if (!signalDOMEvent(cm, e)) { onDragOver(cm, e); e_stop(e); }},
    start: function (e) { return onDragStart(cm, e); },
    drop: operation(cm, onDrop),
    leave: function (e) {if (!signalDOMEvent(cm, e)) { clearDragCursor(cm); }}
  };

  var inp = d.input.getField();
  on(inp, "keyup", function (e) { return onKeyUp.call(cm, e); });
  on(inp, "keydown", operation(cm, onKeyDown));
  on(inp, "keypress", operation(cm, onKeyPress));
  on(inp, "focus", function (e) { return onFocus(cm, e); });
  on(inp, "blur", function (e) { return onBlur(cm, e); });
}

var initHooks = [];
CodeMirror$1.defineInitHook = function (f) { return initHooks.push(f); };

// Indent the given line. The how parameter can be "smart",
// "add"/null, "subtract", or "prev". When aggressive is false
// (typically set to true for forced single-line indents), empty
// lines are not indented, and places where the mode returns Pass
// are left alone.
function indentLine(cm, n, how, aggressive) {
  var doc = cm.doc, state;
  if (how == null) { how = "add"; }
  if (how == "smart") {
    // Fall back to "prev" when the mode doesn't have an indentation
    // method.
    if (!doc.mode.indent) { how = "prev"; }
    else { state = getContextBefore(cm, n).state; }
  }

  var tabSize = cm.options.tabSize;
  var line = getLine(doc, n), curSpace = countColumn(line.text, null, tabSize);
  if (line.stateAfter) { line.stateAfter = null; }
  var curSpaceString = line.text.match(/^\s*/)[0], indentation;
  if (!aggressive && !/\S/.test(line.text)) {
    indentation = 0;
    how = "not";
  } else if (how == "smart") {
    indentation = doc.mode.indent(state, line.text.slice(curSpaceString.length), line.text);
    if (indentation == Pass || indentation > 150) {
      if (!aggressive) { return }
      how = "prev";
    }
  }
  if (how == "prev") {
    if (n > doc.first) { indentation = countColumn(getLine(doc, n-1).text, null, tabSize); }
    else { indentation = 0; }
  } else if (how == "add") {
    indentation = curSpace + cm.options.indentUnit;
  } else if (how == "subtract") {
    indentation = curSpace - cm.options.indentUnit;
  } else if (typeof how == "number") {
    indentation = curSpace + how;
  }
  indentation = Math.max(0, indentation);

  var indentString = "", pos = 0;
  if (cm.options.indentWithTabs)
    { for (var i = Math.floor(indentation / tabSize); i; --i) {pos += tabSize; indentString += "\t";} }
  if (pos < indentation) { indentString += spaceStr(indentation - pos); }

  if (indentString != curSpaceString) {
    replaceRange(doc, indentString, Pos(n, 0), Pos(n, curSpaceString.length), "+input");
    line.stateAfter = null;
    return true
  } else {
    // Ensure that, if the cursor was in the whitespace at the start
    // of the line, it is moved to the end of that space.
    for (var i$1 = 0; i$1 < doc.sel.ranges.length; i$1++) {
      var range = doc.sel.ranges[i$1];
      if (range.head.line == n && range.head.ch < curSpaceString.length) {
        var pos$1 = Pos(n, curSpaceString.length);
        replaceOneSelection(doc, i$1, new Range(pos$1, pos$1));
        break
      }
    }
  }
}

// This will be set to a {lineWise: bool, text: [string]} object, so
// that, when pasting, we know what kind of selections the copied
// text was made out of.
var lastCopied = null;

function setLastCopied(newLastCopied) {
  lastCopied = newLastCopied;
}

function applyTextInput(cm, inserted, deleted, sel, origin) {
  var doc = cm.doc;
  cm.display.shift = false;
  if (!sel) { sel = doc.sel; }

  var paste = cm.state.pasteIncoming || origin == "paste";
  var textLines = splitLinesAuto(inserted), multiPaste = null;
  // When pasing N lines into N selections, insert one line per selection
  if (paste && sel.ranges.length > 1) {
    if (lastCopied && lastCopied.text.join("\n") == inserted) {
      if (sel.ranges.length % lastCopied.text.length == 0) {
        multiPaste = [];
        for (var i = 0; i < lastCopied.text.length; i++)
          { multiPaste.push(doc.splitLines(lastCopied.text[i])); }
      }
    } else if (textLines.length == sel.ranges.length && cm.options.pasteLinesPerSelection) {
      multiPaste = map(textLines, function (l) { return [l]; });
    }
  }

  var updateInput;
  // Normal behavior is to insert the new text into every selection
  for (var i$1 = sel.ranges.length - 1; i$1 >= 0; i$1--) {
    var range$$1 = sel.ranges[i$1];
    var from = range$$1.from(), to = range$$1.to();
    if (range$$1.empty()) {
      if (deleted && deleted > 0) // Handle deletion
        { from = Pos(from.line, from.ch - deleted); }
      else if (cm.state.overwrite && !paste) // Handle overwrite
        { to = Pos(to.line, Math.min(getLine(doc, to.line).text.length, to.ch + lst(textLines).length)); }
      else if (lastCopied && lastCopied.lineWise && lastCopied.text.join("\n") == inserted)
        { from = to = Pos(from.line, 0); }
    }
    updateInput = cm.curOp.updateInput;
    var changeEvent = {from: from, to: to, text: multiPaste ? multiPaste[i$1 % multiPaste.length] : textLines,
                       origin: origin || (paste ? "paste" : cm.state.cutIncoming ? "cut" : "+input")};
    makeChange(cm.doc, changeEvent);
    signalLater(cm, "inputRead", cm, changeEvent);
  }
  if (inserted && !paste)
    { triggerElectric(cm, inserted); }

  ensureCursorVisible(cm);
  cm.curOp.updateInput = updateInput;
  cm.curOp.typing = true;
  cm.state.pasteIncoming = cm.state.cutIncoming = false;
}

function handlePaste(e, cm) {
  var pasted = e.clipboardData && e.clipboardData.getData("Text");
  if (pasted) {
    e.preventDefault();
    if (!cm.isReadOnly() && !cm.options.disableInput)
      { runInOp(cm, function () { return applyTextInput(cm, pasted, 0, null, "paste"); }); }
    return true
  }
}

function triggerElectric(cm, inserted) {
  // When an 'electric' character is inserted, immediately trigger a reindent
  if (!cm.options.electricChars || !cm.options.smartIndent) { return }
  var sel = cm.doc.sel;

  for (var i = sel.ranges.length - 1; i >= 0; i--) {
    var range$$1 = sel.ranges[i];
    if (range$$1.head.ch > 100 || (i && sel.ranges[i - 1].head.line == range$$1.head.line)) { continue }
    var mode = cm.getModeAt(range$$1.head);
    var indented = false;
    if (mode.electricChars) {
      for (var j = 0; j < mode.electricChars.length; j++)
        { if (inserted.indexOf(mode.electricChars.charAt(j)) > -1) {
          indented = indentLine(cm, range$$1.head.line, "smart");
          break
        } }
    } else if (mode.electricInput) {
      if (mode.electricInput.test(getLine(cm.doc, range$$1.head.line).text.slice(0, range$$1.head.ch)))
        { indented = indentLine(cm, range$$1.head.line, "smart"); }
    }
    if (indented) { signalLater(cm, "electricInput", cm, range$$1.head.line); }
  }
}

function copyableRanges(cm) {
  var text = [], ranges = [];
  for (var i = 0; i < cm.doc.sel.ranges.length; i++) {
    var line = cm.doc.sel.ranges[i].head.line;
    var lineRange = {anchor: Pos(line, 0), head: Pos(line + 1, 0)};
    ranges.push(lineRange);
    text.push(cm.getRange(lineRange.anchor, lineRange.head));
  }
  return {text: text, ranges: ranges}
}

function disableBrowserMagic(field, spellcheck) {
  field.setAttribute("autocorrect", "off");
  field.setAttribute("autocapitalize", "off");
  field.setAttribute("spellcheck", !!spellcheck);
}

function hiddenTextarea() {
  var te = elt("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; outline: none");
  var div = elt("div", [te], null, "overflow: hidden; position: relative; width: 3px; height: 0px;");
  // The textarea is kept positioned near the cursor to prevent the
  // fact that it'll be scrolled into view on input from scrolling
  // our fake cursor out of view. On webkit, when wrap=off, paste is
  // very slow. So make the area wide instead.
  if (webkit) { te.style.width = "1000px"; }
  else { te.setAttribute("wrap", "off"); }
  // If border: 0; -- iOS fails to open keyboard (issue #1287)
  if (ios) { te.style.border = "1px solid black"; }
  disableBrowserMagic(te);
  return div
}

// The publicly visible API. Note that methodOp(f) means
// 'wrap f in an operation, performed on its `this` parameter'.

// This is not the complete set of editor methods. Most of the
// methods defined on the Doc type are also injected into
// CodeMirror.prototype, for backwards compatibility and
// convenience.

var addEditorMethods = function(CodeMirror) {
  var optionHandlers = CodeMirror.optionHandlers;

  var helpers = CodeMirror.helpers = {};

  CodeMirror.prototype = {
    constructor: CodeMirror,
    focus: function(){window.focus(); this.display.input.focus();},

    setOption: function(option, value) {
      var options = this.options, old = options[option];
      if (options[option] == value && option != "mode") { return }
      options[option] = value;
      if (optionHandlers.hasOwnProperty(option))
        { operation(this, optionHandlers[option])(this, value, old); }
      signal(this, "optionChange", this, option);
    },

    getOption: function(option) {return this.options[option]},
    getDoc: function() {return this.doc},

    addKeyMap: function(map$$1, bottom) {
      this.state.keyMaps[bottom ? "push" : "unshift"](getKeyMap(map$$1));
    },
    removeKeyMap: function(map$$1) {
      var maps = this.state.keyMaps;
      for (var i = 0; i < maps.length; ++i)
        { if (maps[i] == map$$1 || maps[i].name == map$$1) {
          maps.splice(i, 1);
          return true
        } }
    },

    addOverlay: methodOp(function(spec, options) {
      var mode = spec.token ? spec : CodeMirror.getMode(this.options, spec);
      if (mode.startState) { throw new Error("Overlays may not be stateful.") }
      insertSorted(this.state.overlays,
                   {mode: mode, modeSpec: spec, opaque: options && options.opaque,
                    priority: (options && options.priority) || 0},
                   function (overlay) { return overlay.priority; });
      this.state.modeGen++;
      regChange(this);
    }),
    removeOverlay: methodOp(function(spec) {
      var this$1 = this;

      var overlays = this.state.overlays;
      for (var i = 0; i < overlays.length; ++i) {
        var cur = overlays[i].modeSpec;
        if (cur == spec || typeof spec == "string" && cur.name == spec) {
          overlays.splice(i, 1);
          this$1.state.modeGen++;
          regChange(this$1);
          return
        }
      }
    }),

    indentLine: methodOp(function(n, dir, aggressive) {
      if (typeof dir != "string" && typeof dir != "number") {
        if (dir == null) { dir = this.options.smartIndent ? "smart" : "prev"; }
        else { dir = dir ? "add" : "subtract"; }
      }
      if (isLine(this.doc, n)) { indentLine(this, n, dir, aggressive); }
    }),
    indentSelection: methodOp(function(how) {
      var this$1 = this;

      var ranges = this.doc.sel.ranges, end = -1;
      for (var i = 0; i < ranges.length; i++) {
        var range$$1 = ranges[i];
        if (!range$$1.empty()) {
          var from = range$$1.from(), to = range$$1.to();
          var start = Math.max(end, from.line);
          end = Math.min(this$1.lastLine(), to.line - (to.ch ? 0 : 1)) + 1;
          for (var j = start; j < end; ++j)
            { indentLine(this$1, j, how); }
          var newRanges = this$1.doc.sel.ranges;
          if (from.ch == 0 && ranges.length == newRanges.length && newRanges[i].from().ch > 0)
            { replaceOneSelection(this$1.doc, i, new Range(from, newRanges[i].to()), sel_dontScroll); }
        } else if (range$$1.head.line > end) {
          indentLine(this$1, range$$1.head.line, how, true);
          end = range$$1.head.line;
          if (i == this$1.doc.sel.primIndex) { ensureCursorVisible(this$1); }
        }
      }
    }),

    // Fetch the parser token for a given character. Useful for hacks
    // that want to inspect the mode state (say, for completion).
    getTokenAt: function(pos, precise) {
      return takeToken(this, pos, precise)
    },

    getLineTokens: function(line, precise) {
      return takeToken(this, Pos(line), precise, true)
    },

    getTokenTypeAt: function(pos) {
      pos = clipPos(this.doc, pos);
      var styles = getLineStyles(this, getLine(this.doc, pos.line));
      var before = 0, after = (styles.length - 1) / 2, ch = pos.ch;
      var type;
      if (ch == 0) { type = styles[2]; }
      else { for (;;) {
        var mid = (before + after) >> 1;
        if ((mid ? styles[mid * 2 - 1] : 0) >= ch) { after = mid; }
        else if (styles[mid * 2 + 1] < ch) { before = mid + 1; }
        else { type = styles[mid * 2 + 2]; break }
      } }
      var cut = type ? type.indexOf("overlay ") : -1;
      return cut < 0 ? type : cut == 0 ? null : type.slice(0, cut - 1)
    },

    getModeAt: function(pos) {
      var mode = this.doc.mode;
      if (!mode.innerMode) { return mode }
      return CodeMirror.innerMode(mode, this.getTokenAt(pos).state).mode
    },

    getHelper: function(pos, type) {
      return this.getHelpers(pos, type)[0]
    },

    getHelpers: function(pos, type) {
      var this$1 = this;

      var found = [];
      if (!helpers.hasOwnProperty(type)) { return found }
      var help = helpers[type], mode = this.getModeAt(pos);
      if (typeof mode[type] == "string") {
        if (help[mode[type]]) { found.push(help[mode[type]]); }
      } else if (mode[type]) {
        for (var i = 0; i < mode[type].length; i++) {
          var val = help[mode[type][i]];
          if (val) { found.push(val); }
        }
      } else if (mode.helperType && help[mode.helperType]) {
        found.push(help[mode.helperType]);
      } else if (help[mode.name]) {
        found.push(help[mode.name]);
      }
      for (var i$1 = 0; i$1 < help._global.length; i$1++) {
        var cur = help._global[i$1];
        if (cur.pred(mode, this$1) && indexOf(found, cur.val) == -1)
          { found.push(cur.val); }
      }
      return found
    },

    getStateAfter: function(line, precise) {
      var doc = this.doc;
      line = clipLine(doc, line == null ? doc.first + doc.size - 1: line);
      return getContextBefore(this, line + 1, precise).state
    },

    cursorCoords: function(start, mode) {
      var pos, range$$1 = this.doc.sel.primary();
      if (start == null) { pos = range$$1.head; }
      else if (typeof start == "object") { pos = clipPos(this.doc, start); }
      else { pos = start ? range$$1.from() : range$$1.to(); }
      return cursorCoords(this, pos, mode || "page")
    },

    charCoords: function(pos, mode) {
      return charCoords(this, clipPos(this.doc, pos), mode || "page")
    },

    coordsChar: function(coords, mode) {
      coords = fromCoordSystem(this, coords, mode || "page");
      return coordsChar(this, coords.left, coords.top)
    },

    lineAtHeight: function(height, mode) {
      height = fromCoordSystem(this, {top: height, left: 0}, mode || "page").top;
      return lineAtHeight(this.doc, height + this.display.viewOffset)
    },
    heightAtLine: function(line, mode, includeWidgets) {
      var end = false, lineObj;
      if (typeof line == "number") {
        var last = this.doc.first + this.doc.size - 1;
        if (line < this.doc.first) { line = this.doc.first; }
        else if (line > last) { line = last; end = true; }
        lineObj = getLine(this.doc, line);
      } else {
        lineObj = line;
      }
      return intoCoordSystem(this, lineObj, {top: 0, left: 0}, mode || "page", includeWidgets || end).top +
        (end ? this.doc.height - heightAtLine(lineObj) : 0)
    },

    defaultTextHeight: function() { return textHeight(this.display) },
    defaultCharWidth: function() { return charWidth(this.display) },

    getViewport: function() { return {from: this.display.viewFrom, to: this.display.viewTo}},

    addWidget: function(pos, node, scroll, vert, horiz) {
      var display = this.display;
      pos = cursorCoords(this, clipPos(this.doc, pos));
      var top = pos.bottom, left = pos.left;
      node.style.position = "absolute";
      node.setAttribute("cm-ignore-events", "true");
      this.display.input.setUneditable(node);
      display.sizer.appendChild(node);
      if (vert == "over") {
        top = pos.top;
      } else if (vert == "above" || vert == "near") {
        var vspace = Math.max(display.wrapper.clientHeight, this.doc.height),
        hspace = Math.max(display.sizer.clientWidth, display.lineSpace.clientWidth);
        // Default to positioning above (if specified and possible); otherwise default to positioning below
        if ((vert == 'above' || pos.bottom + node.offsetHeight > vspace) && pos.top > node.offsetHeight)
          { top = pos.top - node.offsetHeight; }
        else if (pos.bottom + node.offsetHeight <= vspace)
          { top = pos.bottom; }
        if (left + node.offsetWidth > hspace)
          { left = hspace - node.offsetWidth; }
      }
      node.style.top = top + "px";
      node.style.left = node.style.right = "";
      if (horiz == "right") {
        left = display.sizer.clientWidth - node.offsetWidth;
        node.style.right = "0px";
      } else {
        if (horiz == "left") { left = 0; }
        else if (horiz == "middle") { left = (display.sizer.clientWidth - node.offsetWidth) / 2; }
        node.style.left = left + "px";
      }
      if (scroll)
        { scrollIntoView(this, {left: left, top: top, right: left + node.offsetWidth, bottom: top + node.offsetHeight}); }
    },

    triggerOnKeyDown: methodOp(onKeyDown),
    triggerOnKeyPress: methodOp(onKeyPress),
    triggerOnKeyUp: onKeyUp,
    triggerOnMouseDown: methodOp(onMouseDown),

    execCommand: function(cmd) {
      if (commands.hasOwnProperty(cmd))
        { return commands[cmd].call(null, this) }
    },

    triggerElectric: methodOp(function(text) { triggerElectric(this, text); }),

    findPosH: function(from, amount, unit, visually) {
      var this$1 = this;

      var dir = 1;
      if (amount < 0) { dir = -1; amount = -amount; }
      var cur = clipPos(this.doc, from);
      for (var i = 0; i < amount; ++i) {
        cur = findPosH(this$1.doc, cur, dir, unit, visually);
        if (cur.hitSide) { break }
      }
      return cur
    },

    moveH: methodOp(function(dir, unit) {
      var this$1 = this;

      this.extendSelectionsBy(function (range$$1) {
        if (this$1.display.shift || this$1.doc.extend || range$$1.empty())
          { return findPosH(this$1.doc, range$$1.head, dir, unit, this$1.options.rtlMoveVisually) }
        else
          { return dir < 0 ? range$$1.from() : range$$1.to() }
      }, sel_move);
    }),

    deleteH: methodOp(function(dir, unit) {
      var sel = this.doc.sel, doc = this.doc;
      if (sel.somethingSelected())
        { doc.replaceSelection("", null, "+delete"); }
      else
        { deleteNearSelection(this, function (range$$1) {
          var other = findPosH(doc, range$$1.head, dir, unit, false);
          return dir < 0 ? {from: other, to: range$$1.head} : {from: range$$1.head, to: other}
        }); }
    }),

    findPosV: function(from, amount, unit, goalColumn) {
      var this$1 = this;

      var dir = 1, x = goalColumn;
      if (amount < 0) { dir = -1; amount = -amount; }
      var cur = clipPos(this.doc, from);
      for (var i = 0; i < amount; ++i) {
        var coords = cursorCoords(this$1, cur, "div");
        if (x == null) { x = coords.left; }
        else { coords.left = x; }
        cur = findPosV(this$1, coords, dir, unit);
        if (cur.hitSide) { break }
      }
      return cur
    },

    moveV: methodOp(function(dir, unit) {
      var this$1 = this;

      var doc = this.doc, goals = [];
      var collapse = !this.display.shift && !doc.extend && doc.sel.somethingSelected();
      doc.extendSelectionsBy(function (range$$1) {
        if (collapse)
          { return dir < 0 ? range$$1.from() : range$$1.to() }
        var headPos = cursorCoords(this$1, range$$1.head, "div");
        if (range$$1.goalColumn != null) { headPos.left = range$$1.goalColumn; }
        goals.push(headPos.left);
        var pos = findPosV(this$1, headPos, dir, unit);
        if (unit == "page" && range$$1 == doc.sel.primary())
          { addToScrollTop(this$1, charCoords(this$1, pos, "div").top - headPos.top); }
        return pos
      }, sel_move);
      if (goals.length) { for (var i = 0; i < doc.sel.ranges.length; i++)
        { doc.sel.ranges[i].goalColumn = goals[i]; } }
    }),

    // Find the word at the given position (as returned by coordsChar).
    findWordAt: function(pos) {
      var doc = this.doc, line = getLine(doc, pos.line).text;
      var start = pos.ch, end = pos.ch;
      if (line) {
        var helper = this.getHelper(pos, "wordChars");
        if ((pos.sticky == "before" || end == line.length) && start) { --start; } else { ++end; }
        var startChar = line.charAt(start);
        var check = isWordChar(startChar, helper)
          ? function (ch) { return isWordChar(ch, helper); }
          : /\s/.test(startChar) ? function (ch) { return /\s/.test(ch); }
          : function (ch) { return (!/\s/.test(ch) && !isWordChar(ch)); };
        while (start > 0 && check(line.charAt(start - 1))) { --start; }
        while (end < line.length && check(line.charAt(end))) { ++end; }
      }
      return new Range(Pos(pos.line, start), Pos(pos.line, end))
    },

    toggleOverwrite: function(value) {
      if (value != null && value == this.state.overwrite) { return }
      if (this.state.overwrite = !this.state.overwrite)
        { addClass(this.display.cursorDiv, "CodeMirror-overwrite"); }
      else
        { rmClass(this.display.cursorDiv, "CodeMirror-overwrite"); }

      signal(this, "overwriteToggle", this, this.state.overwrite);
    },
    hasFocus: function() { return this.display.input.getField() == activeElt() },
    isReadOnly: function() { return !!(this.options.readOnly || this.doc.cantEdit) },

    scrollTo: methodOp(function (x, y) { scrollToCoords(this, x, y); }),
    getScrollInfo: function() {
      var scroller = this.display.scroller;
      return {left: scroller.scrollLeft, top: scroller.scrollTop,
              height: scroller.scrollHeight - scrollGap(this) - this.display.barHeight,
              width: scroller.scrollWidth - scrollGap(this) - this.display.barWidth,
              clientHeight: displayHeight(this), clientWidth: displayWidth(this)}
    },

    scrollIntoView: methodOp(function(range$$1, margin) {
      if (range$$1 == null) {
        range$$1 = {from: this.doc.sel.primary().head, to: null};
        if (margin == null) { margin = this.options.cursorScrollMargin; }
      } else if (typeof range$$1 == "number") {
        range$$1 = {from: Pos(range$$1, 0), to: null};
      } else if (range$$1.from == null) {
        range$$1 = {from: range$$1, to: null};
      }
      if (!range$$1.to) { range$$1.to = range$$1.from; }
      range$$1.margin = margin || 0;

      if (range$$1.from.line != null) {
        scrollToRange(this, range$$1);
      } else {
        scrollToCoordsRange(this, range$$1.from, range$$1.to, range$$1.margin);
      }
    }),

    setSize: methodOp(function(width, height) {
      var this$1 = this;

      var interpret = function (val) { return typeof val == "number" || /^\d+$/.test(String(val)) ? val + "px" : val; };
      if (width != null) { this.display.wrapper.style.width = interpret(width); }
      if (height != null) { this.display.wrapper.style.height = interpret(height); }
      if (this.options.lineWrapping) { clearLineMeasurementCache(this); }
      var lineNo$$1 = this.display.viewFrom;
      this.doc.iter(lineNo$$1, this.display.viewTo, function (line) {
        if (line.widgets) { for (var i = 0; i < line.widgets.length; i++)
          { if (line.widgets[i].noHScroll) { regLineChange(this$1, lineNo$$1, "widget"); break } } }
        ++lineNo$$1;
      });
      this.curOp.forceUpdate = true;
      signal(this, "refresh", this);
    }),

    operation: function(f){return runInOp(this, f)},

    refresh: methodOp(function() {
      var oldHeight = this.display.cachedTextHeight;
      regChange(this);
      this.curOp.forceUpdate = true;
      clearCaches(this);
      scrollToCoords(this, this.doc.scrollLeft, this.doc.scrollTop);
      updateGutterSpace(this);
      if (oldHeight == null || Math.abs(oldHeight - textHeight(this.display)) > .5)
        { estimateLineHeights(this); }
      signal(this, "refresh", this);
    }),

    swapDoc: methodOp(function(doc) {
      var old = this.doc;
      old.cm = null;
      attachDoc(this, doc);
      clearCaches(this);
      this.display.input.reset();
      scrollToCoords(this, doc.scrollLeft, doc.scrollTop);
      this.curOp.forceScroll = true;
      signalLater(this, "swapDoc", this, old);
      return old
    }),

    getInputField: function(){return this.display.input.getField()},
    getWrapperElement: function(){return this.display.wrapper},
    getScrollerElement: function(){return this.display.scroller},
    getGutterElement: function(){return this.display.gutters}
  };
  eventMixin(CodeMirror);

  CodeMirror.registerHelper = function(type, name, value) {
    if (!helpers.hasOwnProperty(type)) { helpers[type] = CodeMirror[type] = {_global: []}; }
    helpers[type][name] = value;
  };
  CodeMirror.registerGlobalHelper = function(type, name, predicate, value) {
    CodeMirror.registerHelper(type, name, value);
    helpers[type]._global.push({pred: predicate, val: value});
  };
};

// Used for horizontal relative motion. Dir is -1 or 1 (left or
// right), unit can be "char", "column" (like char, but doesn't
// cross line boundaries), "word" (across next word), or "group" (to
// the start of next group of word or non-word-non-whitespace
// chars). The visually param controls whether, in right-to-left
// text, direction 1 means to move towards the next index in the
// string, or towards the character to the right of the current
// position. The resulting position will have a hitSide=true
// property if it reached the end of the document.
function findPosH(doc, pos, dir, unit, visually) {
  var oldPos = pos;
  var origDir = dir;
  var lineObj = getLine(doc, pos.line);
  function findNextLine() {
    var l = pos.line + dir;
    if (l < doc.first || l >= doc.first + doc.size) { return false }
    pos = new Pos(l, pos.ch, pos.sticky);
    return lineObj = getLine(doc, l)
  }
  function moveOnce(boundToLine) {
    var next;
    if (visually) {
      next = moveVisually(doc.cm, lineObj, pos, dir);
    } else {
      next = moveLogically(lineObj, pos, dir);
    }
    if (next == null) {
      if (!boundToLine && findNextLine())
        { pos = endOfLine(visually, doc.cm, lineObj, pos.line, dir); }
      else
        { return false }
    } else {
      pos = next;
    }
    return true
  }

  if (unit == "char") {
    moveOnce();
  } else if (unit == "column") {
    moveOnce(true);
  } else if (unit == "word" || unit == "group") {
    var sawType = null, group = unit == "group";
    var helper = doc.cm && doc.cm.getHelper(pos, "wordChars");
    for (var first = true;; first = false) {
      if (dir < 0 && !moveOnce(!first)) { break }
      var cur = lineObj.text.charAt(pos.ch) || "\n";
      var type = isWordChar(cur, helper) ? "w"
        : group && cur == "\n" ? "n"
        : !group || /\s/.test(cur) ? null
        : "p";
      if (group && !first && !type) { type = "s"; }
      if (sawType && sawType != type) {
        if (dir < 0) {dir = 1; moveOnce(); pos.sticky = "after";}
        break
      }

      if (type) { sawType = type; }
      if (dir > 0 && !moveOnce(!first)) { break }
    }
  }
  var result = skipAtomic(doc, pos, oldPos, origDir, true);
  if (equalCursorPos(oldPos, result)) { result.hitSide = true; }
  return result
}

// For relative vertical movement. Dir may be -1 or 1. Unit can be
// "page" or "line". The resulting position will have a hitSide=true
// property if it reached the end of the document.
function findPosV(cm, pos, dir, unit) {
  var doc = cm.doc, x = pos.left, y;
  if (unit == "page") {
    var pageSize = Math.min(cm.display.wrapper.clientHeight, window.innerHeight || document.documentElement.clientHeight);
    var moveAmount = Math.max(pageSize - .5 * textHeight(cm.display), 3);
    y = (dir > 0 ? pos.bottom : pos.top) + dir * moveAmount;

  } else if (unit == "line") {
    y = dir > 0 ? pos.bottom + 3 : pos.top - 3;
  }
  var target;
  for (;;) {
    target = coordsChar(cm, x, y);
    if (!target.outside) { break }
    if (dir < 0 ? y <= 0 : y >= doc.height) { target.hitSide = true; break }
    y += dir * 5;
  }
  return target
}

// CONTENTEDITABLE INPUT STYLE

var ContentEditableInput = function(cm) {
  this.cm = cm;
  this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null;
  this.polling = new Delayed();
  this.composing = null;
  this.gracePeriod = false;
  this.readDOMTimeout = null;
};

ContentEditableInput.prototype.init = function (display) {
    var this$1 = this;

  var input = this, cm = input.cm;
  var div = input.div = display.lineDiv;
  disableBrowserMagic(div, cm.options.spellcheck);

  on(div, "paste", function (e) {
    if (signalDOMEvent(cm, e) || handlePaste(e, cm)) { return }
    // IE doesn't fire input events, so we schedule a read for the pasted content in this way
    if (ie_version <= 11) { setTimeout(operation(cm, function () { return this$1.updateFromDOM(); }), 20); }
  });

  on(div, "compositionstart", function (e) {
    this$1.composing = {data: e.data, done: false};
  });
  on(div, "compositionupdate", function (e) {
    if (!this$1.composing) { this$1.composing = {data: e.data, done: false}; }
  });
  on(div, "compositionend", function (e) {
    if (this$1.composing) {
      if (e.data != this$1.composing.data) { this$1.readFromDOMSoon(); }
      this$1.composing.done = true;
    }
  });

  on(div, "touchstart", function () { return input.forceCompositionEnd(); });

  on(div, "input", function () {
    if (!this$1.composing) { this$1.readFromDOMSoon(); }
  });

  function onCopyCut(e) {
    if (signalDOMEvent(cm, e)) { return }
    if (cm.somethingSelected()) {
      setLastCopied({lineWise: false, text: cm.getSelections()});
      if (e.type == "cut") { cm.replaceSelection("", null, "cut"); }
    } else if (!cm.options.lineWiseCopyCut) {
      return
    } else {
      var ranges = copyableRanges(cm);
      setLastCopied({lineWise: true, text: ranges.text});
      if (e.type == "cut") {
        cm.operation(function () {
          cm.setSelections(ranges.ranges, 0, sel_dontScroll);
          cm.replaceSelection("", null, "cut");
        });
      }
    }
    if (e.clipboardData) {
      e.clipboardData.clearData();
      var content = lastCopied.text.join("\n");
      // iOS exposes the clipboard API, but seems to discard content inserted into it
      e.clipboardData.setData("Text", content);
      if (e.clipboardData.getData("Text") == content) {
        e.preventDefault();
        return
      }
    }
    // Old-fashioned briefly-focus-a-textarea hack
    var kludge = hiddenTextarea(), te = kludge.firstChild;
    cm.display.lineSpace.insertBefore(kludge, cm.display.lineSpace.firstChild);
    te.value = lastCopied.text.join("\n");
    var hadFocus = document.activeElement;
    selectInput(te);
    setTimeout(function () {
      cm.display.lineSpace.removeChild(kludge);
      hadFocus.focus();
      if (hadFocus == div) { input.showPrimarySelection(); }
    }, 50);
  }
  on(div, "copy", onCopyCut);
  on(div, "cut", onCopyCut);
};

ContentEditableInput.prototype.prepareSelection = function () {
  var result = prepareSelection(this.cm, false);
  result.focus = this.cm.state.focused;
  return result
};

ContentEditableInput.prototype.showSelection = function (info, takeFocus) {
  if (!info || !this.cm.display.view.length) { return }
  if (info.focus || takeFocus) { this.showPrimarySelection(); }
  this.showMultipleSelections(info);
};

ContentEditableInput.prototype.showPrimarySelection = function () {
  var sel = window.getSelection(), cm = this.cm, prim = cm.doc.sel.primary();
  var from = prim.from(), to = prim.to();

  if (cm.display.viewTo == cm.display.viewFrom || from.line >= cm.display.viewTo || to.line < cm.display.viewFrom) {
    sel.removeAllRanges();
    return
  }

  var curAnchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
  var curFocus = domToPos(cm, sel.focusNode, sel.focusOffset);
  if (curAnchor && !curAnchor.bad && curFocus && !curFocus.bad &&
      cmp(minPos(curAnchor, curFocus), from) == 0 &&
      cmp(maxPos(curAnchor, curFocus), to) == 0)
    { return }

  var view = cm.display.view;
  var start = (from.line >= cm.display.viewFrom && posToDOM(cm, from)) ||
      {node: view[0].measure.map[2], offset: 0};
  var end = to.line < cm.display.viewTo && posToDOM(cm, to);
  if (!end) {
    var measure = view[view.length - 1].measure;
    var map$$1 = measure.maps ? measure.maps[measure.maps.length - 1] : measure.map;
    end = {node: map$$1[map$$1.length - 1], offset: map$$1[map$$1.length - 2] - map$$1[map$$1.length - 3]};
  }

  if (!start || !end) {
    sel.removeAllRanges();
    return
  }

  var old = sel.rangeCount && sel.getRangeAt(0), rng;
  try { rng = range(start.node, start.offset, end.offset, end.node); }
  catch(e) {} // Our model of the DOM might be outdated, in which case the range we try to set can be impossible
  if (rng) {
    if (!gecko && cm.state.focused) {
      sel.collapse(start.node, start.offset);
      if (!rng.collapsed) {
        sel.removeAllRanges();
        sel.addRange(rng);
      }
    } else {
      sel.removeAllRanges();
      sel.addRange(rng);
    }
    if (old && sel.anchorNode == null) { sel.addRange(old); }
    else if (gecko) { this.startGracePeriod(); }
  }
  this.rememberSelection();
};

ContentEditableInput.prototype.startGracePeriod = function () {
    var this$1 = this;

  clearTimeout(this.gracePeriod);
  this.gracePeriod = setTimeout(function () {
    this$1.gracePeriod = false;
    if (this$1.selectionChanged())
      { this$1.cm.operation(function () { return this$1.cm.curOp.selectionChanged = true; }); }
  }, 20);
};

ContentEditableInput.prototype.showMultipleSelections = function (info) {
  removeChildrenAndAdd(this.cm.display.cursorDiv, info.cursors);
  removeChildrenAndAdd(this.cm.display.selectionDiv, info.selection);
};

ContentEditableInput.prototype.rememberSelection = function () {
  var sel = window.getSelection();
  this.lastAnchorNode = sel.anchorNode; this.lastAnchorOffset = sel.anchorOffset;
  this.lastFocusNode = sel.focusNode; this.lastFocusOffset = sel.focusOffset;
};

ContentEditableInput.prototype.selectionInEditor = function () {
  var sel = window.getSelection();
  if (!sel.rangeCount) { return false }
  var node = sel.getRangeAt(0).commonAncestorContainer;
  return contains(this.div, node)
};

ContentEditableInput.prototype.focus = function () {
  if (this.cm.options.readOnly != "nocursor") {
    if (!this.selectionInEditor())
      { this.showSelection(this.prepareSelection(), true); }
    this.div.focus();
  }
};
ContentEditableInput.prototype.blur = function () { this.div.blur(); };
ContentEditableInput.prototype.getField = function () { return this.div };

ContentEditableInput.prototype.supportsTouch = function () { return true };

ContentEditableInput.prototype.receivedFocus = function () {
  var input = this;
  if (this.selectionInEditor())
    { this.pollSelection(); }
  else
    { runInOp(this.cm, function () { return input.cm.curOp.selectionChanged = true; }); }

  function poll() {
    if (input.cm.state.focused) {
      input.pollSelection();
      input.polling.set(input.cm.options.pollInterval, poll);
    }
  }
  this.polling.set(this.cm.options.pollInterval, poll);
};

ContentEditableInput.prototype.selectionChanged = function () {
  var sel = window.getSelection();
  return sel.anchorNode != this.lastAnchorNode || sel.anchorOffset != this.lastAnchorOffset ||
    sel.focusNode != this.lastFocusNode || sel.focusOffset != this.lastFocusOffset
};

ContentEditableInput.prototype.pollSelection = function () {
  if (this.readDOMTimeout != null || this.gracePeriod || !this.selectionChanged()) { return }
  var sel = window.getSelection(), cm = this.cm;
  // On Android Chrome (version 56, at least), backspacing into an
  // uneditable block element will put the cursor in that element,
  // and then, because it's not editable, hide the virtual keyboard.
  // Because Android doesn't allow us to actually detect backspace
  // presses in a sane way, this code checks for when that happens
  // and simulates a backspace press in this case.
  if (android && chrome && this.cm.options.gutters.length && isInGutter(sel.anchorNode)) {
    this.cm.triggerOnKeyDown({type: "keydown", keyCode: 8, preventDefault: Math.abs});
    this.blur();
    this.focus();
    return
  }
  if (this.composing) { return }
  this.rememberSelection();
  var anchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
  var head = domToPos(cm, sel.focusNode, sel.focusOffset);
  if (anchor && head) { runInOp(cm, function () {
    setSelection(cm.doc, simpleSelection(anchor, head), sel_dontScroll);
    if (anchor.bad || head.bad) { cm.curOp.selectionChanged = true; }
  }); }
};

ContentEditableInput.prototype.pollContent = function () {
  if (this.readDOMTimeout != null) {
    clearTimeout(this.readDOMTimeout);
    this.readDOMTimeout = null;
  }

  var cm = this.cm, display = cm.display, sel = cm.doc.sel.primary();
  var from = sel.from(), to = sel.to();
  if (from.ch == 0 && from.line > cm.firstLine())
    { from = Pos(from.line - 1, getLine(cm.doc, from.line - 1).length); }
  if (to.ch == getLine(cm.doc, to.line).text.length && to.line < cm.lastLine())
    { to = Pos(to.line + 1, 0); }
  if (from.line < display.viewFrom || to.line > display.viewTo - 1) { return false }

  var fromIndex, fromLine, fromNode;
  if (from.line == display.viewFrom || (fromIndex = findViewIndex(cm, from.line)) == 0) {
    fromLine = lineNo(display.view[0].line);
    fromNode = display.view[0].node;
  } else {
    fromLine = lineNo(display.view[fromIndex].line);
    fromNode = display.view[fromIndex - 1].node.nextSibling;
  }
  var toIndex = findViewIndex(cm, to.line);
  var toLine, toNode;
  if (toIndex == display.view.length - 1) {
    toLine = display.viewTo - 1;
    toNode = display.lineDiv.lastChild;
  } else {
    toLine = lineNo(display.view[toIndex + 1].line) - 1;
    toNode = display.view[toIndex + 1].node.previousSibling;
  }

  if (!fromNode) { return false }
  var newText = cm.doc.splitLines(domTextBetween(cm, fromNode, toNode, fromLine, toLine));
  var oldText = getBetween(cm.doc, Pos(fromLine, 0), Pos(toLine, getLine(cm.doc, toLine).text.length));
  while (newText.length > 1 && oldText.length > 1) {
    if (lst(newText) == lst(oldText)) { newText.pop(); oldText.pop(); toLine--; }
    else if (newText[0] == oldText[0]) { newText.shift(); oldText.shift(); fromLine++; }
    else { break }
  }

  var cutFront = 0, cutEnd = 0;
  var newTop = newText[0], oldTop = oldText[0], maxCutFront = Math.min(newTop.length, oldTop.length);
  while (cutFront < maxCutFront && newTop.charCodeAt(cutFront) == oldTop.charCodeAt(cutFront))
    { ++cutFront; }
  var newBot = lst(newText), oldBot = lst(oldText);
  var maxCutEnd = Math.min(newBot.length - (newText.length == 1 ? cutFront : 0),
                           oldBot.length - (oldText.length == 1 ? cutFront : 0));
  while (cutEnd < maxCutEnd &&
         newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1))
    { ++cutEnd; }
  // Try to move start of change to start of selection if ambiguous
  if (newText.length == 1 && oldText.length == 1 && fromLine == from.line) {
    while (cutFront && cutFront > from.ch &&
           newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1)) {
      cutFront--;
      cutEnd++;
    }
  }

  newText[newText.length - 1] = newBot.slice(0, newBot.length - cutEnd).replace(/^\u200b+/, "");
  newText[0] = newText[0].slice(cutFront).replace(/\u200b+$/, "");

  var chFrom = Pos(fromLine, cutFront);
  var chTo = Pos(toLine, oldText.length ? lst(oldText).length - cutEnd : 0);
  if (newText.length > 1 || newText[0] || cmp(chFrom, chTo)) {
    replaceRange(cm.doc, newText, chFrom, chTo, "+input");
    return true
  }
};

ContentEditableInput.prototype.ensurePolled = function () {
  this.forceCompositionEnd();
};
ContentEditableInput.prototype.reset = function () {
  this.forceCompositionEnd();
};
ContentEditableInput.prototype.forceCompositionEnd = function () {
  if (!this.composing) { return }
  clearTimeout(this.readDOMTimeout);
  this.composing = null;
  this.updateFromDOM();
  this.div.blur();
  this.div.focus();
};
ContentEditableInput.prototype.readFromDOMSoon = function () {
    var this$1 = this;

  if (this.readDOMTimeout != null) { return }
  this.readDOMTimeout = setTimeout(function () {
    this$1.readDOMTimeout = null;
    if (this$1.composing) {
      if (this$1.composing.done) { this$1.composing = null; }
      else { return }
    }
    this$1.updateFromDOM();
  }, 80);
};

ContentEditableInput.prototype.updateFromDOM = function () {
    var this$1 = this;

  if (this.cm.isReadOnly() || !this.pollContent())
    { runInOp(this.cm, function () { return regChange(this$1.cm); }); }
};

ContentEditableInput.prototype.setUneditable = function (node) {
  node.contentEditable = "false";
};

ContentEditableInput.prototype.onKeyPress = function (e) {
  if (e.charCode == 0) { return }
  e.preventDefault();
  if (!this.cm.isReadOnly())
    { operation(this.cm, applyTextInput)(this.cm, String.fromCharCode(e.charCode == null ? e.keyCode : e.charCode), 0); }
};

ContentEditableInput.prototype.readOnlyChanged = function (val) {
  this.div.contentEditable = String(val != "nocursor");
};

ContentEditableInput.prototype.onContextMenu = function () {};
ContentEditableInput.prototype.resetPosition = function () {};

ContentEditableInput.prototype.needsContentAttribute = true;

function posToDOM(cm, pos) {
  var view = findViewForLine(cm, pos.line);
  if (!view || view.hidden) { return null }
  var line = getLine(cm.doc, pos.line);
  var info = mapFromLineView(view, line, pos.line);

  var order = getOrder(line, cm.doc.direction), side = "left";
  if (order) {
    var partPos = getBidiPartAt(order, pos.ch);
    side = partPos % 2 ? "right" : "left";
  }
  var result = nodeAndOffsetInLineMap(info.map, pos.ch, side);
  result.offset = result.collapse == "right" ? result.end : result.start;
  return result
}

function isInGutter(node) {
  for (var scan = node; scan; scan = scan.parentNode)
    { if (/CodeMirror-gutter-wrapper/.test(scan.className)) { return true } }
  return false
}

function badPos(pos, bad) { if (bad) { pos.bad = true; } return pos }

function domTextBetween(cm, from, to, fromLine, toLine) {
  var text = "", closing = false, lineSep = cm.doc.lineSeparator();
  function recognizeMarker(id) { return function (marker) { return marker.id == id; } }
  function close() {
    if (closing) {
      text += lineSep;
      closing = false;
    }
  }
  function addText(str) {
    if (str) {
      close();
      text += str;
    }
  }
  function walk(node) {
    if (node.nodeType == 1) {
      var cmText = node.getAttribute("cm-text");
      if (cmText != null) {
        addText(cmText || node.textContent.replace(/\u200b/g, ""));
        return
      }
      var markerID = node.getAttribute("cm-marker"), range$$1;
      if (markerID) {
        var found = cm.findMarks(Pos(fromLine, 0), Pos(toLine + 1, 0), recognizeMarker(+markerID));
        if (found.length && (range$$1 = found[0].find()))
          { addText(getBetween(cm.doc, range$$1.from, range$$1.to).join(lineSep)); }
        return
      }
      if (node.getAttribute("contenteditable") == "false") { return }
      var isBlock = /^(pre|div|p)$/i.test(node.nodeName);
      if (isBlock) { close(); }
      for (var i = 0; i < node.childNodes.length; i++)
        { walk(node.childNodes[i]); }
      if (isBlock) { closing = true; }
    } else if (node.nodeType == 3) {
      addText(node.nodeValue);
    }
  }
  for (;;) {
    walk(from);
    if (from == to) { break }
    from = from.nextSibling;
  }
  return text
}

function domToPos(cm, node, offset) {
  var lineNode;
  if (node == cm.display.lineDiv) {
    lineNode = cm.display.lineDiv.childNodes[offset];
    if (!lineNode) { return badPos(cm.clipPos(Pos(cm.display.viewTo - 1)), true) }
    node = null; offset = 0;
  } else {
    for (lineNode = node;; lineNode = lineNode.parentNode) {
      if (!lineNode || lineNode == cm.display.lineDiv) { return null }
      if (lineNode.parentNode && lineNode.parentNode == cm.display.lineDiv) { break }
    }
  }
  for (var i = 0; i < cm.display.view.length; i++) {
    var lineView = cm.display.view[i];
    if (lineView.node == lineNode)
      { return locateNodeInLineView(lineView, node, offset) }
  }
}

function locateNodeInLineView(lineView, node, offset) {
  var wrapper = lineView.text.firstChild, bad = false;
  if (!node || !contains(wrapper, node)) { return badPos(Pos(lineNo(lineView.line), 0), true) }
  if (node == wrapper) {
    bad = true;
    node = wrapper.childNodes[offset];
    offset = 0;
    if (!node) {
      var line = lineView.rest ? lst(lineView.rest) : lineView.line;
      return badPos(Pos(lineNo(line), line.text.length), bad)
    }
  }

  var textNode = node.nodeType == 3 ? node : null, topNode = node;
  if (!textNode && node.childNodes.length == 1 && node.firstChild.nodeType == 3) {
    textNode = node.firstChild;
    if (offset) { offset = textNode.nodeValue.length; }
  }
  while (topNode.parentNode != wrapper) { topNode = topNode.parentNode; }
  var measure = lineView.measure, maps = measure.maps;

  function find(textNode, topNode, offset) {
    for (var i = -1; i < (maps ? maps.length : 0); i++) {
      var map$$1 = i < 0 ? measure.map : maps[i];
      for (var j = 0; j < map$$1.length; j += 3) {
        var curNode = map$$1[j + 2];
        if (curNode == textNode || curNode == topNode) {
          var line = lineNo(i < 0 ? lineView.line : lineView.rest[i]);
          var ch = map$$1[j] + offset;
          if (offset < 0 || curNode != textNode) { ch = map$$1[j + (offset ? 1 : 0)]; }
          return Pos(line, ch)
        }
      }
    }
  }
  var found = find(textNode, topNode, offset);
  if (found) { return badPos(found, bad) }

  // FIXME this is all really shaky. might handle the few cases it needs to handle, but likely to cause problems
  for (var after = topNode.nextSibling, dist = textNode ? textNode.nodeValue.length - offset : 0; after; after = after.nextSibling) {
    found = find(after, after.firstChild, 0);
    if (found)
      { return badPos(Pos(found.line, found.ch - dist), bad) }
    else
      { dist += after.textContent.length; }
  }
  for (var before = topNode.previousSibling, dist$1 = offset; before; before = before.previousSibling) {
    found = find(before, before.firstChild, -1);
    if (found)
      { return badPos(Pos(found.line, found.ch + dist$1), bad) }
    else
      { dist$1 += before.textContent.length; }
  }
}

// TEXTAREA INPUT STYLE

var TextareaInput = function(cm) {
  this.cm = cm;
  // See input.poll and input.reset
  this.prevInput = "";

  // Flag that indicates whether we expect input to appear real soon
  // now (after some event like 'keypress' or 'input') and are
  // polling intensively.
  this.pollingFast = false;
  // Self-resetting timeout for the poller
  this.polling = new Delayed();
  // Tracks when input.reset has punted to just putting a short
  // string into the textarea instead of the full selection.
  this.inaccurateSelection = false;
  // Used to work around IE issue with selection being forgotten when focus moves away from textarea
  this.hasSelection = false;
  this.composing = null;
};

TextareaInput.prototype.init = function (display) {
    var this$1 = this;

  var input = this, cm = this.cm;

  // Wraps and hides input textarea
  var div = this.wrapper = hiddenTextarea();
  // The semihidden textarea that is focused when the editor is
  // focused, and receives input.
  var te = this.textarea = div.firstChild;
  display.wrapper.insertBefore(div, display.wrapper.firstChild);

  // Needed to hide big blue blinking cursor on Mobile Safari (doesn't seem to work in iOS 8 anymore)
  if (ios) { te.style.width = "0px"; }

  on(te, "input", function () {
    if (ie && ie_version >= 9 && this$1.hasSelection) { this$1.hasSelection = null; }
    input.poll();
  });

  on(te, "paste", function (e) {
    if (signalDOMEvent(cm, e) || handlePaste(e, cm)) { return }

    cm.state.pasteIncoming = true;
    input.fastPoll();
  });

  function prepareCopyCut(e) {
    if (signalDOMEvent(cm, e)) { return }
    if (cm.somethingSelected()) {
      setLastCopied({lineWise: false, text: cm.getSelections()});
      if (input.inaccurateSelection) {
        input.prevInput = "";
        input.inaccurateSelection = false;
        te.value = lastCopied.text.join("\n");
        selectInput(te);
      }
    } else if (!cm.options.lineWiseCopyCut) {
      return
    } else {
      var ranges = copyableRanges(cm);
      setLastCopied({lineWise: true, text: ranges.text});
      if (e.type == "cut") {
        cm.setSelections(ranges.ranges, null, sel_dontScroll);
      } else {
        input.prevInput = "";
        te.value = ranges.text.join("\n");
        selectInput(te);
      }
    }
    if (e.type == "cut") { cm.state.cutIncoming = true; }
  }
  on(te, "cut", prepareCopyCut);
  on(te, "copy", prepareCopyCut);

  on(display.scroller, "paste", function (e) {
    if (eventInWidget(display, e) || signalDOMEvent(cm, e)) { return }
    cm.state.pasteIncoming = true;
    input.focus();
  });

  // Prevent normal selection in the editor (we handle our own)
  on(display.lineSpace, "selectstart", function (e) {
    if (!eventInWidget(display, e)) { e_preventDefault(e); }
  });

  on(te, "compositionstart", function () {
    var start = cm.getCursor("from");
    if (input.composing) { input.composing.range.clear(); }
    input.composing = {
      start: start,
      range: cm.markText(start, cm.getCursor("to"), {className: "CodeMirror-composing"})
    };
  });
  on(te, "compositionend", function () {
    if (input.composing) {
      input.poll();
      input.composing.range.clear();
      input.composing = null;
    }
  });
};

TextareaInput.prototype.prepareSelection = function () {
  // Redraw the selection and/or cursor
  var cm = this.cm, display = cm.display, doc = cm.doc;
  var result = prepareSelection(cm);

  // Move the hidden textarea near the cursor to prevent scrolling artifacts
  if (cm.options.moveInputWithCursor) {
    var headPos = cursorCoords(cm, doc.sel.primary().head, "div");
    var wrapOff = display.wrapper.getBoundingClientRect(), lineOff = display.lineDiv.getBoundingClientRect();
    result.teTop = Math.max(0, Math.min(display.wrapper.clientHeight - 10,
                                        headPos.top + lineOff.top - wrapOff.top));
    result.teLeft = Math.max(0, Math.min(display.wrapper.clientWidth - 10,
                                         headPos.left + lineOff.left - wrapOff.left));
  }

  return result
};

TextareaInput.prototype.showSelection = function (drawn) {
  var cm = this.cm, display = cm.display;
  removeChildrenAndAdd(display.cursorDiv, drawn.cursors);
  removeChildrenAndAdd(display.selectionDiv, drawn.selection);
  if (drawn.teTop != null) {
    this.wrapper.style.top = drawn.teTop + "px";
    this.wrapper.style.left = drawn.teLeft + "px";
  }
};

// Reset the input to correspond to the selection (or to be empty,
// when not typing and nothing is selected)
TextareaInput.prototype.reset = function (typing) {
  if (this.contextMenuPending || this.composing) { return }
  var minimal, selected, cm = this.cm, doc = cm.doc;
  if (cm.somethingSelected()) {
    this.prevInput = "";
    var range$$1 = doc.sel.primary();
    minimal = hasCopyEvent &&
      (range$$1.to().line - range$$1.from().line > 100 || (selected = cm.getSelection()).length > 1000);
    var content = minimal ? "-" : selected || cm.getSelection();
    this.textarea.value = content;
    if (cm.state.focused) { selectInput(this.textarea); }
    if (ie && ie_version >= 9) { this.hasSelection = content; }
  } else if (!typing) {
    this.prevInput = this.textarea.value = "";
    if (ie && ie_version >= 9) { this.hasSelection = null; }
  }
  this.inaccurateSelection = minimal;
};

TextareaInput.prototype.getField = function () { return this.textarea };

TextareaInput.prototype.supportsTouch = function () { return false };

TextareaInput.prototype.focus = function () {
  if (this.cm.options.readOnly != "nocursor" && (!mobile || activeElt() != this.textarea)) {
    try { this.textarea.focus(); }
    catch (e) {} // IE8 will throw if the textarea is display: none or not in DOM
  }
};

TextareaInput.prototype.blur = function () { this.textarea.blur(); };

TextareaInput.prototype.resetPosition = function () {
  this.wrapper.style.top = this.wrapper.style.left = 0;
};

TextareaInput.prototype.receivedFocus = function () { this.slowPoll(); };

// Poll for input changes, using the normal rate of polling. This
// runs as long as the editor is focused.
TextareaInput.prototype.slowPoll = function () {
    var this$1 = this;

  if (this.pollingFast) { return }
  this.polling.set(this.cm.options.pollInterval, function () {
    this$1.poll();
    if (this$1.cm.state.focused) { this$1.slowPoll(); }
  });
};

// When an event has just come in that is likely to add or change
// something in the input textarea, we poll faster, to ensure that
// the change appears on the screen quickly.
TextareaInput.prototype.fastPoll = function () {
  var missed = false, input = this;
  input.pollingFast = true;
  function p() {
    var changed = input.poll();
    if (!changed && !missed) {missed = true; input.polling.set(60, p);}
    else {input.pollingFast = false; input.slowPoll();}
  }
  input.polling.set(20, p);
};

// Read input from the textarea, and update the document to match.
// When something is selected, it is present in the textarea, and
// selected (unless it is huge, in which case a placeholder is
// used). When nothing is selected, the cursor sits after previously
// seen text (can be empty), which is stored in prevInput (we must
// not reset the textarea when typing, because that breaks IME).
TextareaInput.prototype.poll = function () {
    var this$1 = this;

  var cm = this.cm, input = this.textarea, prevInput = this.prevInput;
  // Since this is called a *lot*, try to bail out as cheaply as
  // possible when it is clear that nothing happened. hasSelection
  // will be the case when there is a lot of text in the textarea,
  // in which case reading its value would be expensive.
  if (this.contextMenuPending || !cm.state.focused ||
      (hasSelection(input) && !prevInput && !this.composing) ||
      cm.isReadOnly() || cm.options.disableInput || cm.state.keySeq)
    { return false }

  var text = input.value;
  // If nothing changed, bail.
  if (text == prevInput && !cm.somethingSelected()) { return false }
  // Work around nonsensical selection resetting in IE9/10, and
  // inexplicable appearance of private area unicode characters on
  // some key combos in Mac (#2689).
  if (ie && ie_version >= 9 && this.hasSelection === text ||
      mac && /[\uf700-\uf7ff]/.test(text)) {
    cm.display.input.reset();
    return false
  }

  if (cm.doc.sel == cm.display.selForContextMenu) {
    var first = text.charCodeAt(0);
    if (first == 0x200b && !prevInput) { prevInput = "\u200b"; }
    if (first == 0x21da) { this.reset(); return this.cm.execCommand("undo") }
  }
  // Find the part of the input that is actually new
  var same = 0, l = Math.min(prevInput.length, text.length);
  while (same < l && prevInput.charCodeAt(same) == text.charCodeAt(same)) { ++same; }

  runInOp(cm, function () {
    applyTextInput(cm, text.slice(same), prevInput.length - same,
                   null, this$1.composing ? "*compose" : null);

    // Don't leave long text in the textarea, since it makes further polling slow
    if (text.length > 1000 || text.indexOf("\n") > -1) { input.value = this$1.prevInput = ""; }
    else { this$1.prevInput = text; }

    if (this$1.composing) {
      this$1.composing.range.clear();
      this$1.composing.range = cm.markText(this$1.composing.start, cm.getCursor("to"),
                                         {className: "CodeMirror-composing"});
    }
  });
  return true
};

TextareaInput.prototype.ensurePolled = function () {
  if (this.pollingFast && this.poll()) { this.pollingFast = false; }
};

TextareaInput.prototype.onKeyPress = function () {
  if (ie && ie_version >= 9) { this.hasSelection = null; }
  this.fastPoll();
};

TextareaInput.prototype.onContextMenu = function (e) {
  var input = this, cm = input.cm, display = cm.display, te = input.textarea;
  var pos = posFromMouse(cm, e), scrollPos = display.scroller.scrollTop;
  if (!pos || presto) { return } // Opera is difficult.

  // Reset the current text selection only if the click is done outside of the selection
  // and 'resetSelectionOnContextMenu' option is true.
  var reset = cm.options.resetSelectionOnContextMenu;
  if (reset && cm.doc.sel.contains(pos) == -1)
    { operation(cm, setSelection)(cm.doc, simpleSelection(pos), sel_dontScroll); }

  var oldCSS = te.style.cssText, oldWrapperCSS = input.wrapper.style.cssText;
  input.wrapper.style.cssText = "position: absolute";
  var wrapperBox = input.wrapper.getBoundingClientRect();
  te.style.cssText = "position: absolute; width: 30px; height: 30px;\n      top: " + (e.clientY - wrapperBox.top - 5) + "px; left: " + (e.clientX - wrapperBox.left - 5) + "px;\n      z-index: 1000; background: " + (ie ? "rgba(255, 255, 255, .05)" : "transparent") + ";\n      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);";
  var oldScrollY;
  if (webkit) { oldScrollY = window.scrollY; } // Work around Chrome issue (#2712)
  display.input.focus();
  if (webkit) { window.scrollTo(null, oldScrollY); }
  display.input.reset();
  // Adds "Select all" to context menu in FF
  if (!cm.somethingSelected()) { te.value = input.prevInput = " "; }
  input.contextMenuPending = true;
  display.selForContextMenu = cm.doc.sel;
  clearTimeout(display.detectingSelectAll);

  // Select-all will be greyed out if there's nothing to select, so
  // this adds a zero-width space so that we can later check whether
  // it got selected.
  function prepareSelectAllHack() {
    if (te.selectionStart != null) {
      var selected = cm.somethingSelected();
      var extval = "\u200b" + (selected ? te.value : "");
      te.value = "\u21da"; // Used to catch context-menu undo
      te.value = extval;
      input.prevInput = selected ? "" : "\u200b";
      te.selectionStart = 1; te.selectionEnd = extval.length;
      // Re-set this, in case some other handler touched the
      // selection in the meantime.
      display.selForContextMenu = cm.doc.sel;
    }
  }
  function rehide() {
    input.contextMenuPending = false;
    input.wrapper.style.cssText = oldWrapperCSS;
    te.style.cssText = oldCSS;
    if (ie && ie_version < 9) { display.scrollbars.setScrollTop(display.scroller.scrollTop = scrollPos); }

    // Try to detect the user choosing select-all
    if (te.selectionStart != null) {
      if (!ie || (ie && ie_version < 9)) { prepareSelectAllHack(); }
      var i = 0, poll = function () {
        if (display.selForContextMenu == cm.doc.sel && te.selectionStart == 0 &&
            te.selectionEnd > 0 && input.prevInput == "\u200b") {
          operation(cm, selectAll)(cm);
        } else if (i++ < 10) {
          display.detectingSelectAll = setTimeout(poll, 500);
        } else {
          display.selForContextMenu = null;
          display.input.reset();
        }
      };
      display.detectingSelectAll = setTimeout(poll, 200);
    }
  }

  if (ie && ie_version >= 9) { prepareSelectAllHack(); }
  if (captureRightClick) {
    e_stop(e);
    var mouseup = function () {
      off(window, "mouseup", mouseup);
      setTimeout(rehide, 20);
    };
    on(window, "mouseup", mouseup);
  } else {
    setTimeout(rehide, 50);
  }
};

TextareaInput.prototype.readOnlyChanged = function (val) {
  if (!val) { this.reset(); }
  this.textarea.disabled = val == "nocursor";
};

TextareaInput.prototype.setUneditable = function () {};

TextareaInput.prototype.needsContentAttribute = false;

function fromTextArea(textarea, options) {
  options = options ? copyObj(options) : {};
  options.value = textarea.value;
  if (!options.tabindex && textarea.tabIndex)
    { options.tabindex = textarea.tabIndex; }
  if (!options.placeholder && textarea.placeholder)
    { options.placeholder = textarea.placeholder; }
  // Set autofocus to true if this textarea is focused, or if it has
  // autofocus and no other element is focused.
  if (options.autofocus == null) {
    var hasFocus = activeElt();
    options.autofocus = hasFocus == textarea ||
      textarea.getAttribute("autofocus") != null && hasFocus == document.body;
  }

  function save() {textarea.value = cm.getValue();}

  var realSubmit;
  if (textarea.form) {
    on(textarea.form, "submit", save);
    // Deplorable hack to make the submit method do the right thing.
    if (!options.leaveSubmitMethodAlone) {
      var form = textarea.form;
      realSubmit = form.submit;
      try {
        var wrappedSubmit = form.submit = function () {
          save();
          form.submit = realSubmit;
          form.submit();
          form.submit = wrappedSubmit;
        };
      } catch(e) {}
    }
  }

  options.finishInit = function (cm) {
    cm.save = save;
    cm.getTextArea = function () { return textarea; };
    cm.toTextArea = function () {
      cm.toTextArea = isNaN; // Prevent this from being ran twice
      save();
      textarea.parentNode.removeChild(cm.getWrapperElement());
      textarea.style.display = "";
      if (textarea.form) {
        off(textarea.form, "submit", save);
        if (typeof textarea.form.submit == "function")
          { textarea.form.submit = realSubmit; }
      }
    };
  };

  textarea.style.display = "none";
  var cm = CodeMirror$1(function (node) { return textarea.parentNode.insertBefore(node, textarea.nextSibling); },
    options);
  return cm
}

function addLegacyProps(CodeMirror) {
  CodeMirror.off = off;
  CodeMirror.on = on;
  CodeMirror.wheelEventPixels = wheelEventPixels;
  CodeMirror.Doc = Doc;
  CodeMirror.splitLines = splitLinesAuto;
  CodeMirror.countColumn = countColumn;
  CodeMirror.findColumn = findColumn;
  CodeMirror.isWordChar = isWordCharBasic;
  CodeMirror.Pass = Pass;
  CodeMirror.signal = signal;
  CodeMirror.Line = Line;
  CodeMirror.changeEnd = changeEnd;
  CodeMirror.scrollbarModel = scrollbarModel;
  CodeMirror.Pos = Pos;
  CodeMirror.cmpPos = cmp;
  CodeMirror.modes = modes;
  CodeMirror.mimeModes = mimeModes;
  CodeMirror.resolveMode = resolveMode;
  CodeMirror.getMode = getMode;
  CodeMirror.modeExtensions = modeExtensions;
  CodeMirror.extendMode = extendMode;
  CodeMirror.copyState = copyState;
  CodeMirror.startState = startState;
  CodeMirror.innerMode = innerMode;
  CodeMirror.commands = commands;
  CodeMirror.keyMap = keyMap;
  CodeMirror.keyName = keyName;
  CodeMirror.isModifierKey = isModifierKey;
  CodeMirror.lookupKey = lookupKey;
  CodeMirror.normalizeKeyMap = normalizeKeyMap;
  CodeMirror.StringStream = StringStream;
  CodeMirror.SharedTextMarker = SharedTextMarker;
  CodeMirror.TextMarker = TextMarker;
  CodeMirror.LineWidget = LineWidget;
  CodeMirror.e_preventDefault = e_preventDefault;
  CodeMirror.e_stopPropagation = e_stopPropagation;
  CodeMirror.e_stop = e_stop;
  CodeMirror.addClass = addClass;
  CodeMirror.contains = contains;
  CodeMirror.rmClass = rmClass;
  CodeMirror.keyNames = keyNames;
}

// EDITOR CONSTRUCTOR

defineOptions(CodeMirror$1);

addEditorMethods(CodeMirror$1);

// Set up methods on CodeMirror's prototype to redirect to the editor's document.
var dontDelegate = "iter insert remove copy getEditor constructor".split(" ");
for (var prop in Doc.prototype) { if (Doc.prototype.hasOwnProperty(prop) && indexOf(dontDelegate, prop) < 0)
  { CodeMirror$1.prototype[prop] = (function(method) {
    return function() {return method.apply(this.doc, arguments)}
  })(Doc.prototype[prop]); } }

eventMixin(Doc);

// INPUT HANDLING

CodeMirror$1.inputStyles = {"textarea": TextareaInput, "contenteditable": ContentEditableInput};

// MODE DEFINITION AND QUERYING

// Extra arguments are stored as the mode's dependencies, which is
// used by (legacy) mechanisms like loadmode.js to automatically
// load a mode. (Preferred mechanism is the require/define calls.)
CodeMirror$1.defineMode = function(name/*, mode, …*/) {
  if (!CodeMirror$1.defaults.mode && name != "null") { CodeMirror$1.defaults.mode = name; }
  defineMode.apply(this, arguments);
};

CodeMirror$1.defineMIME = defineMIME;

// Minimal default mode.
CodeMirror$1.defineMode("null", function () { return ({token: function (stream) { return stream.skipToEnd(); }}); });
CodeMirror$1.defineMIME("text/plain", "null");

// EXTENSIONS

CodeMirror$1.defineExtension = function (name, func) {
  CodeMirror$1.prototype[name] = func;
};
CodeMirror$1.defineDocExtension = function (name, func) {
  Doc.prototype[name] = func;
};

CodeMirror$1.fromTextArea = fromTextArea;

addLegacyProps(CodeMirror$1);

CodeMirror$1.version = "5.27.4";

return CodeMirror$1;

})));


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = hue;
/* harmony export (immutable) */ __webpack_exports__["c"] = gamma;
/* harmony export (immutable) */ __webpack_exports__["a"] = nogamma;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(114);


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var EventPluginRegistry = __webpack_require__(74);
var EventPluginUtils = __webpack_require__(75);
var ReactErrorUtils = __webpack_require__(79);

var accumulateInto = __webpack_require__(140);
var forEachAccumulated = __webpack_require__(141);
var invariant = __webpack_require__(0);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(34);
var EventPluginUtils = __webpack_require__(75);

var accumulateInto = __webpack_require__(140);
var forEachAccumulated = __webpack_require__(141);
var warning = __webpack_require__(1);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(10);

var getEventTarget = __webpack_require__(84);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 39 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(52);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 42 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
});


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var EventPluginRegistry = __webpack_require__(74);
var ReactEventEmitterMixin = __webpack_require__(276);
var ViewportMetrics = __webpack_require__(139);

var getVendorPrefixedEventName = __webpack_require__(308);
var isEventSupported = __webpack_require__(85);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(37);
var ViewportMetrics = __webpack_require__(139);

var getEventModifierState = __webpack_require__(83);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(5);
var DOMNamespaces = __webpack_require__(73);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(81);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(162);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(166);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(165);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 52 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 53 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = true;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = __webpack_require__(30)
  , dPs         = __webpack_require__(186)
  , enumBugKeys = __webpack_require__(53)
  , IE_PROTO    = __webpack_require__(59)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(99)('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(179).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 57 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(16).f
  , has = __webpack_require__(15)
  , TAG = __webpack_require__(24)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(60)('keys')
  , uid    = __webpack_require__(42);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(12)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 61 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(31);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var global         = __webpack_require__(12)
  , core           = __webpack_require__(8)
  , LIBRARY        = __webpack_require__(55)
  , wksExt         = __webpack_require__(64)
  , defineProperty = __webpack_require__(16).f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(24);

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = Color;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return darker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return brighter; });
/* harmony export (immutable) */ __webpack_exports__["a"] = color;
/* harmony export (immutable) */ __webpack_exports__["e"] = rgbConvert;
/* harmony export (immutable) */ __webpack_exports__["b"] = rgb;
/* harmony export (immutable) */ __webpack_exports__["d"] = Rgb;
/* unused harmony export hslConvert */
/* harmony export (immutable) */ __webpack_exports__["c"] = hsl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(66);


function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex3 = /^#([0-9a-f]{3})$/,
    reHex6 = /^#([0-9a-f]{6})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Color, color, {
  displayable: function() {
    return this.rgb().displayable();
  },
  toString: function() {
    return this.rgb() + "";
  }
});

function color(format) {
  var m;
  format = (format + "").trim().toLowerCase();
  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format])
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Rgb, rgb, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (0 <= this.r && this.r <= 255)
        && (0 <= this.g && this.g <= 255)
        && (0 <= this.b && this.b <= 255)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  toString: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(")
        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hsl, hsl, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extend;
/* harmony default export */ __webpack_exports__["a"] = (function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
});

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = basis;
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__string__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant__ = __webpack_require__(114);









/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__constant__["a" /* default */])(b)
      : (t === "number" ? __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]
      : t === "string" ? ((c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["color"])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_6__string__["a" /* default */])
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["color"] ? __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]
      : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_3__date__["a" /* default */]
      : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_2__array__["a" /* default */]
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_5__object__["a" /* default */]
      : __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */])(a, b);
});


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_timer__ = __webpack_require__(70);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "now", function() { return __WEBPACK_IMPORTED_MODULE_0__src_timer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "timer", function() { return __WEBPACK_IMPORTED_MODULE_0__src_timer__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "timerFlush", function() { return __WEBPACK_IMPORTED_MODULE_0__src_timer__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_timeout__ = __webpack_require__(224);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "timeout", function() { return __WEBPACK_IMPORTED_MODULE_1__src_timeout__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_interval__ = __webpack_require__(223);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interval", function() { return __WEBPACK_IMPORTED_MODULE_2__src_interval__["a"]; });







/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = now;
/* harmony export (immutable) */ __webpack_exports__["d"] = Timer;
/* harmony export (immutable) */ __webpack_exports__["b"] = timer;
/* harmony export (immutable) */ __webpack_exports__["c"] = timerFlush;
var frame = 0, // is an animation frame pending?
    timeout = 0, // is a timeout pending?
    interval = 0, // are any timers active?
    pokeDelay = 1000, // how frequently we check for clock skew
    taskHead,
    taskTail,
    clockLast = 0,
    clockNow = 0,
    clockSkew = 0,
    clock = typeof performance === "object" && performance.now ? performance : Date,
    setFrame = typeof requestAnimationFrame === "function" ? requestAnimationFrame : function(f) { setTimeout(f, 17); };

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call =
  this._time =
  this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer;
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now(); // Get the current time, if not already set.
  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(), delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (frame) return; // Soonest alarm already set, or will be.
  if (timeout) timeout = clearTimeout(timeout);
  var delay = time - clockNow;
  if (delay > 24) {
    if (time < Infinity) timeout = setTimeout(wake, delay);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clockNow, interval = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMLazyTree = __webpack_require__(25);
var Danger = __webpack_require__(253);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactInstrumentation = __webpack_require__(7);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(81);
var setInnerHTML = __webpack_require__(49);
var setTextContent = __webpack_require__(147);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactErrorUtils = __webpack_require__(79);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactPropTypesSecret = __webpack_require__(282);
var propTypesFactory = __webpack_require__(124);

var React = __webpack_require__(28);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = func.bind(null, a);
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactCurrentOwner = __webpack_require__(11);
var ReactInstanceMap = __webpack_require__(36);
var ReactInstrumentation = __webpack_require__(7);
var ReactUpdates = __webpack_require__(9);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(5);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var emptyFunction = __webpack_require__(6);
var warning = __webpack_require__(1);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 88 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(169), __esModule: true };

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(170), __esModule: true };

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(171), __esModule: true };

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(89);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(89);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(164);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(163);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(51);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(51);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 97 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(175);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(31)
  , document = __webpack_require__(12).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(13) && !__webpack_require__(21)(function(){
  return Object.defineProperty(__webpack_require__(99)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(97);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__(55)
  , $export        = __webpack_require__(14)
  , redefine       = __webpack_require__(108)
  , hide           = __webpack_require__(22)
  , has            = __webpack_require__(15)
  , Iterators      = __webpack_require__(54)
  , $iterCreate    = __webpack_require__(181)
  , setToStringTag = __webpack_require__(58)
  , getPrototypeOf = __webpack_require__(105)
  , ITERATOR       = __webpack_require__(24)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var pIE            = __webpack_require__(39)
  , createDesc     = __webpack_require__(40)
  , toIObject      = __webpack_require__(17)
  , toPrimitive    = __webpack_require__(62)
  , has            = __webpack_require__(15)
  , IE8_DOM_DEFINE = __webpack_require__(100)
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(13) ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = __webpack_require__(106)
  , hiddenKeys = __webpack_require__(53).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = __webpack_require__(15)
  , toObject    = __webpack_require__(41)
  , IE_PROTO    = __webpack_require__(59)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__(15)
  , toIObject    = __webpack_require__(17)
  , arrayIndexOf = __webpack_require__(177)(false)
  , IE_PROTO     = __webpack_require__(59)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(14)
  , core    = __webpack_require__(8)
  , fails   = __webpack_require__(21);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(22);

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var emptyObject = __webpack_require__(44);
var _invariant = __webpack_require__(0);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deg2rad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rad2deg; });
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;


/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(68);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(nb),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
});


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__basis__["b" /* basis */])((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var d = new Date;
  return a = +a, b -= a, function(t) {
    return d.setTime(a + b * t), d;
  };
});


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(68);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
});


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rgbBasis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return rgbBasisClosed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basisClosed__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__color__ = __webpack_require__(33);





/* harmony default export */ __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__color__["c" /* gamma */])(y);

  function rgb(start, end) {
    var r = color((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["rgb"])(start)).r, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["rgb"])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["rgb"])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis__["a" /* default */]);
var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed__["a" /* default */]);


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(43);


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
});


/***/ }),
/* 119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(6);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 123 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(246);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(245)();
}


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(261);


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(19);

var invariant = __webpack_require__(0);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(26);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactInstrumentation = __webpack_require__(7);

var quoteAttributeValueForBrowser = __webpack_require__(309);
var warning = __webpack_require__(1);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var LinkedValueUtils = __webpack_require__(77);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactUpdates = __webpack_require__(9);

var warning = __webpack_require__(1);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMSelection = __webpack_require__(269);

var containsNode = __webpack_require__(231);
var focusNode = __webpack_require__(121);
var getActiveElement = __webpack_require__(122);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var DOMLazyTree = __webpack_require__(25);
var DOMProperty = __webpack_require__(26);
var React = __webpack_require__(28);
var ReactBrowserEventEmitter = __webpack_require__(45);
var ReactCurrentOwner = __webpack_require__(11);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactDOMContainerInfo = __webpack_require__(263);
var ReactDOMFeatureFlags = __webpack_require__(265);
var ReactFeatureFlags = __webpack_require__(134);
var ReactInstanceMap = __webpack_require__(36);
var ReactInstrumentation = __webpack_require__(7);
var ReactMarkupChecksum = __webpack_require__(279);
var ReactReconciler = __webpack_require__(27);
var ReactUpdateQueue = __webpack_require__(80);
var ReactUpdates = __webpack_require__(9);

var emptyObject = __webpack_require__(44);
var instantiateReactComponent = __webpack_require__(145);
var invariant = __webpack_require__(0);
var setInnerHTML = __webpack_require__(49);
var shouldUpdateReactComponent = __webpack_require__(86);
var warning = __webpack_require__(1);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var React = __webpack_require__(28);

var invariant = __webpack_require__(0);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactNodeTypes = __webpack_require__(138);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(5);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(4);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  delete inst._wrapperState.valueTracker;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(3);

var ReactCompositeComponent = __webpack_require__(260);
var ReactEmptyComponent = __webpack_require__(133);
var ReactHostComponent = __webpack_require__(135);

var getNextDebugID = __webpack_require__(321);
var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(5);
var escapeTextContentForBrowser = __webpack_require__(48);
var setInnerHTML = __webpack_require__(49);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactCurrentOwner = __webpack_require__(11);
var REACT_ELEMENT_TYPE = __webpack_require__(275);

var getIteratorFn = __webpack_require__(306);
var invariant = __webpack_require__(0);
var KeyEscapeUtils = __webpack_require__(76);
var warning = __webpack_require__(1);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(159);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('not a function');
  }
  this._45 = 0;
  this._81 = 0;
  this._65 = null;
  this._54 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._10 = null;
Promise._97 = null;
Promise._61 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
};
function handle(self, deferred) {
  while (self._81 === 3) {
    self = self._65;
  }
  if (Promise._10) {
    Promise._10(self);
  }
  if (self._81 === 0) {
    if (self._45 === 0) {
      self._45 = 1;
      self._54 = deferred;
      return;
    }
    if (self._45 === 1) {
      self._45 = 2;
      self._54 = [self._54, deferred];
      return;
    }
    self._54.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._81 === 1) {
        resolve(deferred.promise, self._65);
      } else {
        reject(deferred.promise, self._65);
      }
      return;
    }
    var ret = tryCallOne(cb, self._65);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._81 = 3;
      self._65 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._81 = 1;
  self._65 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._81 = 2;
  self._65 = newValue;
  if (Promise._97) {
    Promise._97(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._45 === 1) {
    handle(self, self._54);
    self._54 = null;
  }
  if (self._45 === 2) {
    for (var i = 0; i < self._54.length; i++) {
      handle(self, self._54[i]);
    }
    self._54 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  })
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(38),
    _assign = __webpack_require__(3);

var ReactNoopUpdateQueue = __webpack_require__(153);

var canDefineProperty = __webpack_require__(154);
var emptyObject = __webpack_require__(44);
var invariant = __webpack_require__(0);
var lowPriorityWarning = __webpack_require__(322);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(38);

var ReactCurrentOwner = __webpack_require__(11);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var warning = __webpack_require__(1);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _NodeGroup = __webpack_require__(327);

var _NodeGroup2 = _interopRequireDefault(_NodeGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NodeGroup2.default; /* eslint-disable flowtype/require-valid-file-annotation */

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports = {
	"joy": {
		"lb": [
			{
				"x": 0.80942,
				"y": 0.656686
			},
			{
				"x": 0.805027,
				"y": 0.665678
			},
			{
				"x": 0.800255,
				"y": 0.674474
			},
			{
				"x": 0.795113,
				"y": 0.683058
			},
			{
				"x": 0.789609,
				"y": 0.691414
			},
			{
				"x": 0.783755,
				"y": 0.699527
			},
			{
				"x": 0.77756,
				"y": 0.707382
			},
			{
				"x": 0.771036,
				"y": 0.714965
			},
			{
				"x": 0.764195,
				"y": 0.722262
			},
			{
				"x": 0.757049,
				"y": 0.72926
			},
			{
				"x": 0.749611,
				"y": 0.735945
			},
			{
				"x": 0.741896,
				"y": 0.742307
			},
			{
				"x": 0.733916,
				"y": 0.748332
			},
			{
				"x": 0.725687,
				"y": 0.754011
			},
			{
				"x": 0.717223,
				"y": 0.759332
			},
			{
				"x": 0.708541,
				"y": 0.764287
			},
			{
				"x": 0.699655,
				"y": 0.768865
			},
			{
				"x": 0.690582,
				"y": 0.773059
			},
			{
				"x": 0.681339,
				"y": 0.776862
			},
			{
				"x": 0.671942,
				"y": 0.780265
			},
			{
				"x": 0.662409,
				"y": 0.783263
			},
			{
				"x": 0.652756,
				"y": 0.785851
			},
			{
				"x": 0.643003,
				"y": 0.788024
			},
			{
				"x": 0.646177,
				"y": 0.791121
			},
			{
				"x": 0.655697,
				"y": 0.794152
			},
			{
				"x": 0.665429,
				"y": 0.796415
			},
			{
				"x": 0.675309,
				"y": 0.797893
			},
			{
				"x": 0.685276,
				"y": 0.798578
			},
			{
				"x": 0.695265,
				"y": 0.798466
			},
			{
				"x": 0.705214,
				"y": 0.797557
			},
			{
				"x": 0.715059,
				"y": 0.795857
			},
			{
				"x": 0.724737,
				"y": 0.793377
			},
			{
				"x": 0.734188,
				"y": 0.790132
			},
			{
				"x": 0.743351,
				"y": 0.786144
			},
			{
				"x": 0.752167,
				"y": 0.781437
			},
			{
				"x": 0.760581,
				"y": 0.776041
			},
			{
				"x": 0.76854,
				"y": 0.769991
			},
			{
				"x": 0.775993,
				"y": 0.763325
			},
			{
				"x": 0.782892,
				"y": 0.756086
			},
			{
				"x": 0.789194,
				"y": 0.748319
			},
			{
				"x": 0.794858,
				"y": 0.740074
			},
			{
				"x": 0.799849,
				"y": 0.731403
			},
			{
				"x": 0.804135,
				"y": 0.722361
			},
			{
				"x": 0.807689,
				"y": 0.713006
			},
			{
				"x": 0.810488,
				"y": 0.703397
			},
			{
				"x": 0.812514,
				"y": 0.693595
			},
			{
				"x": 0.813754,
				"y": 0.683663
			},
			{
				"x": 0.814201,
				"y": 0.673663
			},
			{
				"x": 0.813852,
				"y": 0.66366
			},
			{
				"x": 0.812709,
				"y": 0.653716
			}
		],
		"rb": [
			{
				"x": 0.187977,
				"y": 0.65085
			},
			{
				"x": 0.192123,
				"y": 0.659958
			},
			{
				"x": 0.196654,
				"y": 0.668882
			},
			{
				"x": 0.201561,
				"y": 0.677603
			},
			{
				"x": 0.206836,
				"y": 0.686106
			},
			{
				"x": 0.212467,
				"y": 0.694376
			},
			{
				"x": 0.218446,
				"y": 0.702397
			},
			{
				"x": 0.224761,
				"y": 0.710156
			},
			{
				"x": 0.231401,
				"y": 0.717637
			},
			{
				"x": 0.238354,
				"y": 0.724827
			},
			{
				"x": 0.245607,
				"y": 0.731714
			},
			{
				"x": 0.253147,
				"y": 0.738283
			},
			{
				"x": 0.260959,
				"y": 0.744524
			},
			{
				"x": 0.269031,
				"y": 0.750426
			},
			{
				"x": 0.277347,
				"y": 0.755976
			},
			{
				"x": 0.285891,
				"y": 0.761166
			},
			{
				"x": 0.294649,
				"y": 0.765986
			},
			{
				"x": 0.303604,
				"y": 0.770426
			},
			{
				"x": 0.312741,
				"y": 0.77448
			},
			{
				"x": 0.322041,
				"y": 0.778138
			},
			{
				"x": 0.33149,
				"y": 0.781396
			},
			{
				"x": 0.341068,
				"y": 0.784247
			},
			{
				"x": 0.350759,
				"y": 0.786685
			},
			{
				"x": 0.359764,
				"y": 0.788791
			},
			{
				"x": 0.350409,
				"y": 0.792304
			},
			{
				"x": 0.340805,
				"y": 0.79506
			},
			{
				"x": 0.331013,
				"y": 0.79704
			},
			{
				"x": 0.321094,
				"y": 0.798233
			},
			{
				"x": 0.311112,
				"y": 0.79863
			},
			{
				"x": 0.30113,
				"y": 0.798229
			},
			{
				"x": 0.291212,
				"y": 0.797033
			},
			{
				"x": 0.28142,
				"y": 0.79505
			},
			{
				"x": 0.271817,
				"y": 0.792291
			},
			{
				"x": 0.262463,
				"y": 0.788775
			},
			{
				"x": 0.253419,
				"y": 0.784523
			},
			{
				"x": 0.244742,
				"y": 0.779564
			},
			{
				"x": 0.236486,
				"y": 0.773927
			},
			{
				"x": 0.228704,
				"y": 0.76765
			},
			{
				"x": 0.221447,
				"y": 0.760772
			},
			{
				"x": 0.214759,
				"y": 0.753336
			},
			{
				"x": 0.208683,
				"y": 0.74539
			},
			{
				"x": 0.203258,
				"y": 0.736985
			},
			{
				"x": 0.198518,
				"y": 0.728174
			},
			{
				"x": 0.194494,
				"y": 0.719012
			},
			{
				"x": 0.191211,
				"y": 0.709558
			},
			{
				"x": 0.18869,
				"y": 0.699872
			},
			{
				"x": 0.186947,
				"y": 0.690016
			},
			{
				"x": 0.185992,
				"y": 0.680052
			},
			{
				"x": 0.185833,
				"y": 0.670044
			},
			{
				"x": 0.18647,
				"y": 0.660055
			}
		],
		"le": [
			{
				"x": 0.708191,
				"y": 0.6214
			},
			{
				"x": 0.707865,
				"y": 0.614079
			},
			{
				"x": 0.706885,
				"y": 0.606817
			},
			{
				"x": 0.705245,
				"y": 0.599675
			},
			{
				"x": 0.702935,
				"y": 0.592722
			},
			{
				"x": 0.699944,
				"y": 0.586036
			},
			{
				"x": 0.696261,
				"y": 0.579706
			},
			{
				"x": 0.691878,
				"y": 0.573841
			},
			{
				"x": 0.6868,
				"y": 0.568571
			},
			{
				"x": 0.681053,
				"y": 0.564045
			},
			{
				"x": 0.674695,
				"y": 0.560432
			},
			{
				"x": 0.667839,
				"y": 0.557899
			},
			{
				"x": 0.66065,
				"y": 0.556591
			},
			{
				"x": 0.653343,
				"y": 0.556591
			},
			{
				"x": 0.646154,
				"y": 0.557899
			},
			{
				"x": 0.639298,
				"y": 0.560432
			},
			{
				"x": 0.632941,
				"y": 0.564045
			},
			{
				"x": 0.627193,
				"y": 0.568571
			},
			{
				"x": 0.622115,
				"y": 0.573841
			},
			{
				"x": 0.617732,
				"y": 0.579706
			},
			{
				"x": 0.614049,
				"y": 0.586036
			},
			{
				"x": 0.611058,
				"y": 0.592722
			},
			{
				"x": 0.608748,
				"y": 0.599675
			},
			{
				"x": 0.607108,
				"y": 0.606817
			},
			{
				"x": 0.606128,
				"y": 0.614079
			},
			{
				"x": 0.605802,
				"y": 0.6214
			},
			{
				"x": 0.606128,
				"y": 0.628721
			},
			{
				"x": 0.607108,
				"y": 0.635983
			},
			{
				"x": 0.608748,
				"y": 0.643125
			},
			{
				"x": 0.611058,
				"y": 0.650077
			},
			{
				"x": 0.614049,
				"y": 0.656764
			},
			{
				"x": 0.617732,
				"y": 0.663094
			},
			{
				"x": 0.622115,
				"y": 0.668959
			},
			{
				"x": 0.627193,
				"y": 0.674229
			},
			{
				"x": 0.632941,
				"y": 0.678755
			},
			{
				"x": 0.639298,
				"y": 0.682368
			},
			{
				"x": 0.646154,
				"y": 0.684901
			},
			{
				"x": 0.653343,
				"y": 0.686209
			},
			{
				"x": 0.66065,
				"y": 0.686209
			},
			{
				"x": 0.667839,
				"y": 0.684901
			},
			{
				"x": 0.674695,
				"y": 0.682368
			},
			{
				"x": 0.681053,
				"y": 0.678755
			},
			{
				"x": 0.6868,
				"y": 0.674229
			},
			{
				"x": 0.691878,
				"y": 0.668959
			},
			{
				"x": 0.696261,
				"y": 0.663094
			},
			{
				"x": 0.699944,
				"y": 0.656764
			},
			{
				"x": 0.702935,
				"y": 0.650077
			},
			{
				"x": 0.705245,
				"y": 0.643125
			},
			{
				"x": 0.706885,
				"y": 0.635983
			},
			{
				"x": 0.707865,
				"y": 0.628721
			}
		],
		"re": [
			{
				"x": 0.291809,
				"y": 0.6214
			},
			{
				"x": 0.292135,
				"y": 0.614079
			},
			{
				"x": 0.293115,
				"y": 0.606817
			},
			{
				"x": 0.294755,
				"y": 0.599675
			},
			{
				"x": 0.297065,
				"y": 0.592722
			},
			{
				"x": 0.300056,
				"y": 0.586036
			},
			{
				"x": 0.303739,
				"y": 0.579706
			},
			{
				"x": 0.308122,
				"y": 0.573841
			},
			{
				"x": 0.3132,
				"y": 0.568571
			},
			{
				"x": 0.318947,
				"y": 0.564045
			},
			{
				"x": 0.325305,
				"y": 0.560432
			},
			{
				"x": 0.332161,
				"y": 0.557899
			},
			{
				"x": 0.33935,
				"y": 0.556591
			},
			{
				"x": 0.346657,
				"y": 0.556591
			},
			{
				"x": 0.353846,
				"y": 0.557899
			},
			{
				"x": 0.360702,
				"y": 0.560432
			},
			{
				"x": 0.367059,
				"y": 0.564045
			},
			{
				"x": 0.372807,
				"y": 0.568571
			},
			{
				"x": 0.377885,
				"y": 0.573841
			},
			{
				"x": 0.382268,
				"y": 0.579706
			},
			{
				"x": 0.385951,
				"y": 0.586036
			},
			{
				"x": 0.388942,
				"y": 0.592722
			},
			{
				"x": 0.391252,
				"y": 0.599675
			},
			{
				"x": 0.392892,
				"y": 0.606817
			},
			{
				"x": 0.393872,
				"y": 0.614079
			},
			{
				"x": 0.394198,
				"y": 0.6214
			},
			{
				"x": 0.393872,
				"y": 0.628721
			},
			{
				"x": 0.392892,
				"y": 0.635983
			},
			{
				"x": 0.391252,
				"y": 0.643125
			},
			{
				"x": 0.388942,
				"y": 0.650077
			},
			{
				"x": 0.385951,
				"y": 0.656764
			},
			{
				"x": 0.382268,
				"y": 0.663094
			},
			{
				"x": 0.377885,
				"y": 0.668959
			},
			{
				"x": 0.372807,
				"y": 0.674229
			},
			{
				"x": 0.367059,
				"y": 0.678755
			},
			{
				"x": 0.360702,
				"y": 0.682368
			},
			{
				"x": 0.353846,
				"y": 0.684901
			},
			{
				"x": 0.346657,
				"y": 0.686209
			},
			{
				"x": 0.33935,
				"y": 0.686209
			},
			{
				"x": 0.332161,
				"y": 0.684901
			},
			{
				"x": 0.325305,
				"y": 0.682368
			},
			{
				"x": 0.318947,
				"y": 0.678755
			},
			{
				"x": 0.3132,
				"y": 0.674229
			},
			{
				"x": 0.308122,
				"y": 0.668959
			},
			{
				"x": 0.303739,
				"y": 0.663094
			},
			{
				"x": 0.300056,
				"y": 0.656764
			},
			{
				"x": 0.297065,
				"y": 0.650077
			},
			{
				"x": 0.294755,
				"y": 0.643125
			},
			{
				"x": 0.293115,
				"y": 0.635983
			},
			{
				"x": 0.292135,
				"y": 0.628721
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.168942,
				"y": 0.440155
			},
			{
				"x": 0.170863,
				"y": 0.4065
			},
			{
				"x": 0.176591,
				"y": 0.373281
			},
			{
				"x": 0.18603,
				"y": 0.340924
			},
			{
				"x": 0.199024,
				"y": 0.309829
			},
			{
				"x": 0.215366,
				"y": 0.280361
			},
			{
				"x": 0.234809,
				"y": 0.252847
			},
			{
				"x": 0.257076,
				"y": 0.227573
			},
			{
				"x": 0.281866,
				"y": 0.204778
			},
			{
				"x": 0.30887,
				"y": 0.184665
			},
			{
				"x": 0.337769,
				"y": 0.167396
			},
			{
				"x": 0.368243,
				"y": 0.1531
			},
			{
				"x": 0.399972,
				"y": 0.141876
			},
			{
				"x": 0.43264,
				"y": 0.133796
			},
			{
				"x": 0.465935,
				"y": 0.128912
			},
			{
				"x": 0.499543,
				"y": 0.127251
			},
			{
				"x": 0.533156,
				"y": 0.128824
			},
			{
				"x": 0.566462,
				"y": 0.133621
			},
			{
				"x": 0.599152,
				"y": 0.141614
			},
			{
				"x": 0.630911,
				"y": 0.152754
			},
			{
				"x": 0.661423,
				"y": 0.166968
			},
			{
				"x": 0.690368,
				"y": 0.184158
			},
			{
				"x": 0.717428,
				"y": 0.204196
			},
			{
				"x": 0.742283,
				"y": 0.22692
			},
			{
				"x": 0.764622,
				"y": 0.25213
			},
			{
				"x": 0.784146,
				"y": 0.279586
			},
			{
				"x": 0.800575,
				"y": 0.309005
			},
			{
				"x": 0.813663,
				"y": 0.340062
			},
			{
				"x": 0.823201,
				"y": 0.372389
			},
			{
				"x": 0.829032,
				"y": 0.40559
			},
			{
				"x": 0.831057,
				"y": 0.439239
			},
			{
				"x": 0.80007,
				"y": 0.429581
			},
			{
				"x": 0.767515,
				"y": 0.421019
			},
			{
				"x": 0.734605,
				"y": 0.413936
			},
			{
				"x": 0.701476,
				"y": 0.407967
			},
			{
				"x": 0.668192,
				"y": 0.402934
			},
			{
				"x": 0.634791,
				"y": 0.398746
			},
			{
				"x": 0.601298,
				"y": 0.395373
			},
			{
				"x": 0.567733,
				"y": 0.392829
			},
			{
				"x": 0.534112,
				"y": 0.391181
			},
			{
				"x": 0.500457,
				"y": 0.390569
			},
			{
				"x": 0.466802,
				"y": 0.391149
			},
			{
				"x": 0.433179,
				"y": 0.392772
			},
			{
				"x": 0.399612,
				"y": 0.395293
			},
			{
				"x": 0.366118,
				"y": 0.398644
			},
			{
				"x": 0.332714,
				"y": 0.402809
			},
			{
				"x": 0.299426,
				"y": 0.407819
			},
			{
				"x": 0.266292,
				"y": 0.41376
			},
			{
				"x": 0.233375,
				"y": 0.42081
			},
			{
				"x": 0.200807,
				"y": 0.429324
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"sadness": {
		"lb": [
			{
				"x": 0.871404,
				"y": 0.591322
			},
			{
				"x": 0.862798,
				"y": 0.586881
			},
			{
				"x": 0.85383,
				"y": 0.583232
			},
			{
				"x": 0.844581,
				"y": 0.58037
			},
			{
				"x": 0.835127,
				"y": 0.578284
			},
			{
				"x": 0.825537,
				"y": 0.576958
			},
			{
				"x": 0.815874,
				"y": 0.576371
			},
			{
				"x": 0.806195,
				"y": 0.576503
			},
			{
				"x": 0.796549,
				"y": 0.577331
			},
			{
				"x": 0.786985,
				"y": 0.578834
			},
			{
				"x": 0.777545,
				"y": 0.580988
			},
			{
				"x": 0.768272,
				"y": 0.583773
			},
			{
				"x": 0.759204,
				"y": 0.587169
			},
			{
				"x": 0.750378,
				"y": 0.591157
			},
			{
				"x": 0.741833,
				"y": 0.595716
			},
			{
				"x": 0.733606,
				"y": 0.600829
			},
			{
				"x": 0.725735,
				"y": 0.606477
			},
			{
				"x": 0.71826,
				"y": 0.612641
			},
			{
				"x": 0.711222,
				"y": 0.619302
			},
			{
				"x": 0.704664,
				"y": 0.626437
			},
			{
				"x": 0.698632,
				"y": 0.634024
			},
			{
				"x": 0.693174,
				"y": 0.642035
			},
			{
				"x": 0.68834,
				"y": 0.650439
			},
			{
				"x": 0.684184,
				"y": 0.659199
			},
			{
				"x": 0.680759,
				"y": 0.668271
			},
			{
				"x": 0.678122,
				"y": 0.677603
			},
			{
				"x": 0.676325,
				"y": 0.687133
			},
			{
				"x": 0.679812,
				"y": 0.686535
			},
			{
				"x": 0.686508,
				"y": 0.679527
			},
			{
				"x": 0.693438,
				"y": 0.672752
			},
			{
				"x": 0.700591,
				"y": 0.666213
			},
			{
				"x": 0.707955,
				"y": 0.659914
			},
			{
				"x": 0.715521,
				"y": 0.65386
			},
			{
				"x": 0.723278,
				"y": 0.648054
			},
			{
				"x": 0.731217,
				"y": 0.6425
			},
			{
				"x": 0.739329,
				"y": 0.637203
			},
			{
				"x": 0.747605,
				"y": 0.632167
			},
			{
				"x": 0.756036,
				"y": 0.627398
			},
			{
				"x": 0.764615,
				"y": 0.622899
			},
			{
				"x": 0.773332,
				"y": 0.618676
			},
			{
				"x": 0.78218,
				"y": 0.614736
			},
			{
				"x": 0.791151,
				"y": 0.611084
			},
			{
				"x": 0.800235,
				"y": 0.607726
			},
			{
				"x": 0.809424,
				"y": 0.60467
			},
			{
				"x": 0.818711,
				"y": 0.601923
			},
			{
				"x": 0.828084,
				"y": 0.599493
			},
			{
				"x": 0.837536,
				"y": 0.597389
			},
			{
				"x": 0.847056,
				"y": 0.595619
			},
			{
				"x": 0.856634,
				"y": 0.594193
			},
			{
				"x": 0.866257,
				"y": 0.593122
			}
		],
		"rb": [
			{
				"x": 0.126508,
				"y": 0.592557
			},
			{
				"x": 0.135009,
				"y": 0.587919
			},
			{
				"x": 0.143894,
				"y": 0.584072
			},
			{
				"x": 0.15308,
				"y": 0.581013
			},
			{
				"x": 0.16249,
				"y": 0.578734
			},
			{
				"x": 0.172051,
				"y": 0.57722
			},
			{
				"x": 0.181701,
				"y": 0.57645
			},
			{
				"x": 0.191382,
				"y": 0.576404
			},
			{
				"x": 0.201041,
				"y": 0.57706
			},
			{
				"x": 0.21063,
				"y": 0.578395
			},
			{
				"x": 0.220104,
				"y": 0.580388
			},
			{
				"x": 0.229423,
				"y": 0.583017
			},
			{
				"x": 0.238546,
				"y": 0.586262
			},
			{
				"x": 0.247436,
				"y": 0.590103
			},
			{
				"x": 0.256055,
				"y": 0.594521
			},
			{
				"x": 0.264365,
				"y": 0.599497
			},
			{
				"x": 0.272329,
				"y": 0.605013
			},
			{
				"x": 0.279907,
				"y": 0.61105
			},
			{
				"x": 0.287059,
				"y": 0.617588
			},
			{
				"x": 0.293741,
				"y": 0.624607
			},
			{
				"x": 0.299909,
				"y": 0.632083
			},
			{
				"x": 0.305516,
				"y": 0.63999
			},
			{
				"x": 0.310511,
				"y": 0.648299
			},
			{
				"x": 0.314842,
				"y": 0.656974
			},
			{
				"x": 0.318455,
				"y": 0.665972
			},
			{
				"x": 0.321294,
				"y": 0.675244
			},
			{
				"x": 0.323307,
				"y": 0.684731
			},
			{
				"x": 0.321827,
				"y": 0.688326
			},
			{
				"x": 0.315192,
				"y": 0.681261
			},
			{
				"x": 0.308319,
				"y": 0.674427
			},
			{
				"x": 0.301221,
				"y": 0.667828
			},
			{
				"x": 0.293909,
				"y": 0.661469
			},
			{
				"x": 0.286393,
				"y": 0.655353
			},
			{
				"x": 0.278683,
				"y": 0.649485
			},
			{
				"x": 0.270788,
				"y": 0.643867
			},
			{
				"x": 0.262719,
				"y": 0.638506
			},
			{
				"x": 0.254483,
				"y": 0.633404
			},
			{
				"x": 0.24609,
				"y": 0.628567
			},
			{
				"x": 0.237547,
				"y": 0.624
			},
			{
				"x": 0.228864,
				"y": 0.619708
			},
			{
				"x": 0.220048,
				"y": 0.615696
			},
			{
				"x": 0.211107,
				"y": 0.611971
			},
			{
				"x": 0.202051,
				"y": 0.608539
			},
			{
				"x": 0.192887,
				"y": 0.605407
			},
			{
				"x": 0.183624,
				"y": 0.602582
			},
			{
				"x": 0.174271,
				"y": 0.600072
			},
			{
				"x": 0.164838,
				"y": 0.597885
			},
			{
				"x": 0.155334,
				"y": 0.59603
			},
			{
				"x": 0.14577,
				"y": 0.594518
			},
			{
				"x": 0.136157,
				"y": 0.593356
			}
		],
		"le": [
			{
				"x": 0.820623,
				"y": 0.450304
			},
			{
				"x": 0.81908,
				"y": 0.437928
			},
			{
				"x": 0.815172,
				"y": 0.426085
			},
			{
				"x": 0.809222,
				"y": 0.415123
			},
			{
				"x": 0.801621,
				"y": 0.405235
			},
			{
				"x": 0.792734,
				"y": 0.396486
			},
			{
				"x": 0.782862,
				"y": 0.388866
			},
			{
				"x": 0.772241,
				"y": 0.382332
			},
			{
				"x": 0.761053,
				"y": 0.376829
			},
			{
				"x": 0.749436,
				"y": 0.372301
			},
			{
				"x": 0.7375,
				"y": 0.368701
			},
			{
				"x": 0.725332,
				"y": 0.365989
			},
			{
				"x": 0.713005,
				"y": 0.364135
			},
			{
				"x": 0.700581,
				"y": 0.363118
			},
			{
				"x": 0.688117,
				"y": 0.362924
			},
			{
				"x": 0.675667,
				"y": 0.36355
			},
			{
				"x": 0.663285,
				"y": 0.365
			},
			{
				"x": 0.65103,
				"y": 0.367285
			},
			{
				"x": 0.638966,
				"y": 0.370428
			},
			{
				"x": 0.627168,
				"y": 0.374457
			},
			{
				"x": 0.615726,
				"y": 0.379413
			},
			{
				"x": 0.604756,
				"y": 0.38534
			},
			{
				"x": 0.594402,
				"y": 0.39229
			},
			{
				"x": 0.584854,
				"y": 0.400313
			},
			{
				"x": 0.576359,
				"y": 0.409444
			},
			{
				"x": 0.569227,
				"y": 0.419677
			},
			{
				"x": 0.563828,
				"y": 0.430921
			},
			{
				"x": 0.560545,
				"y": 0.442953
			},
			{
				"x": 0.560362,
				"y": 0.453381
			},
			{
				"x": 0.569957,
				"y": 0.445477
			},
			{
				"x": 0.580968,
				"y": 0.439636
			},
			{
				"x": 0.59254,
				"y": 0.434997
			},
			{
				"x": 0.604415,
				"y": 0.431196
			},
			{
				"x": 0.616479,
				"y": 0.428045
			},
			{
				"x": 0.628672,
				"y": 0.42544
			},
			{
				"x": 0.640958,
				"y": 0.423319
			},
			{
				"x": 0.653313,
				"y": 0.421647
			},
			{
				"x": 0.665719,
				"y": 0.420408
			},
			{
				"x": 0.67816,
				"y": 0.419602
			},
			{
				"x": 0.690622,
				"y": 0.419245
			},
			{
				"x": 0.703089,
				"y": 0.419354
			},
			{
				"x": 0.715544,
				"y": 0.41991
			},
			{
				"x": 0.727972,
				"y": 0.420898
			},
			{
				"x": 0.740358,
				"y": 0.422322
			},
			{
				"x": 0.752684,
				"y": 0.4242
			},
			{
				"x": 0.764924,
				"y": 0.426572
			},
			{
				"x": 0.777042,
				"y": 0.429505
			},
			{
				"x": 0.788976,
				"y": 0.433113
			},
			{
				"x": 0.800606,
				"y": 0.437605
			},
			{
				"x": 0.811641,
				"y": 0.443395
			}
		],
		"re": [
			{
				"x": 0.179374,
				"y": 0.450451
			},
			{
				"x": 0.180888,
				"y": 0.438072
			},
			{
				"x": 0.18477,
				"y": 0.426219
			},
			{
				"x": 0.190698,
				"y": 0.415246
			},
			{
				"x": 0.198281,
				"y": 0.405345
			},
			{
				"x": 0.207156,
				"y": 0.396582
			},
			{
				"x": 0.217018,
				"y": 0.388949
			},
			{
				"x": 0.227631,
				"y": 0.382403
			},
			{
				"x": 0.238813,
				"y": 0.376888
			},
			{
				"x": 0.250425,
				"y": 0.372349
			},
			{
				"x": 0.262358,
				"y": 0.368738
			},
			{
				"x": 0.274524,
				"y": 0.366016
			},
			{
				"x": 0.28685,
				"y": 0.364152
			},
			{
				"x": 0.299273,
				"y": 0.363125
			},
			{
				"x": 0.311737,
				"y": 0.362922
			},
			{
				"x": 0.324187,
				"y": 0.363538
			},
			{
				"x": 0.33657,
				"y": 0.364978
			},
			{
				"x": 0.348827,
				"y": 0.367253
			},
			{
				"x": 0.360894,
				"y": 0.370386
			},
			{
				"x": 0.372696,
				"y": 0.374405
			},
			{
				"x": 0.384142,
				"y": 0.379349
			},
			{
				"x": 0.395119,
				"y": 0.385264
			},
			{
				"x": 0.405481,
				"y": 0.392202
			},
			{
				"x": 0.415039,
				"y": 0.400212
			},
			{
				"x": 0.423549,
				"y": 0.409331
			},
			{
				"x": 0.430699,
				"y": 0.41955
			},
			{
				"x": 0.43612,
				"y": 0.430783
			},
			{
				"x": 0.43943,
				"y": 0.442808
			},
			{
				"x": 0.439733,
				"y": 0.453493
			},
			{
				"x": 0.430166,
				"y": 0.445555
			},
			{
				"x": 0.419166,
				"y": 0.439697
			},
			{
				"x": 0.407598,
				"y": 0.435047
			},
			{
				"x": 0.395726,
				"y": 0.431236
			},
			{
				"x": 0.383664,
				"y": 0.428079
			},
			{
				"x": 0.371472,
				"y": 0.425468
			},
			{
				"x": 0.359187,
				"y": 0.423341
			},
			{
				"x": 0.346833,
				"y": 0.421664
			},
			{
				"x": 0.334427,
				"y": 0.42042
			},
			{
				"x": 0.321986,
				"y": 0.419609
			},
			{
				"x": 0.309524,
				"y": 0.419246
			},
			{
				"x": 0.297058,
				"y": 0.41935
			},
			{
				"x": 0.284602,
				"y": 0.419901
			},
			{
				"x": 0.272174,
				"y": 0.420884
			},
			{
				"x": 0.259787,
				"y": 0.422303
			},
			{
				"x": 0.247461,
				"y": 0.424176
			},
			{
				"x": 0.235219,
				"y": 0.426541
			},
			{
				"x": 0.223099,
				"y": 0.429466
			},
			{
				"x": 0.211163,
				"y": 0.433066
			},
			{
				"x": 0.199528,
				"y": 0.437546
			},
			{
				"x": 0.188483,
				"y": 0.443317
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.408498,
				"y": 0.218355
			},
			{
				"x": 0.403853,
				"y": 0.210108
			},
			{
				"x": 0.403338,
				"y": 0.200563
			},
			{
				"x": 0.40481,
				"y": 0.191179
			},
			{
				"x": 0.410777,
				"y": 0.183835
			},
			{
				"x": 0.419674,
				"y": 0.180638
			},
			{
				"x": 0.429241,
				"y": 0.180591
			},
			{
				"x": 0.43881,
				"y": 0.180591
			},
			{
				"x": 0.448378,
				"y": 0.180591
			},
			{
				"x": 0.457947,
				"y": 0.180591
			},
			{
				"x": 0.467515,
				"y": 0.180591
			},
			{
				"x": 0.477083,
				"y": 0.180591
			},
			{
				"x": 0.486652,
				"y": 0.180591
			},
			{
				"x": 0.49622,
				"y": 0.180591
			},
			{
				"x": 0.505789,
				"y": 0.180591
			},
			{
				"x": 0.515357,
				"y": 0.180591
			},
			{
				"x": 0.524926,
				"y": 0.180591
			},
			{
				"x": 0.534494,
				"y": 0.180591
			},
			{
				"x": 0.544063,
				"y": 0.180591
			},
			{
				"x": 0.553631,
				"y": 0.180591
			},
			{
				"x": 0.5632,
				"y": 0.180591
			},
			{
				"x": 0.572768,
				"y": 0.180591
			},
			{
				"x": 0.582337,
				"y": 0.180591
			},
			{
				"x": 0.591905,
				"y": 0.180591
			},
			{
				"x": 0.601432,
				"y": 0.181106
			},
			{
				"x": 0.609663,
				"y": 0.185761
			},
			{
				"x": 0.614308,
				"y": 0.194008
			},
			{
				"x": 0.614823,
				"y": 0.203554
			},
			{
				"x": 0.613351,
				"y": 0.212938
			},
			{
				"x": 0.607383,
				"y": 0.220282
			},
			{
				"x": 0.598487,
				"y": 0.223479
			},
			{
				"x": 0.58892,
				"y": 0.223525
			},
			{
				"x": 0.579351,
				"y": 0.223525
			},
			{
				"x": 0.569783,
				"y": 0.223525
			},
			{
				"x": 0.560214,
				"y": 0.223525
			},
			{
				"x": 0.550646,
				"y": 0.223525
			},
			{
				"x": 0.541077,
				"y": 0.223525
			},
			{
				"x": 0.531509,
				"y": 0.223525
			},
			{
				"x": 0.52194,
				"y": 0.223525
			},
			{
				"x": 0.512372,
				"y": 0.223525
			},
			{
				"x": 0.502804,
				"y": 0.223525
			},
			{
				"x": 0.493235,
				"y": 0.223525
			},
			{
				"x": 0.483667,
				"y": 0.223525
			},
			{
				"x": 0.474098,
				"y": 0.223525
			},
			{
				"x": 0.46453,
				"y": 0.223525
			},
			{
				"x": 0.454961,
				"y": 0.223525
			},
			{
				"x": 0.445393,
				"y": 0.223525
			},
			{
				"x": 0.435824,
				"y": 0.223525
			},
			{
				"x": 0.426256,
				"y": 0.223525
			},
			{
				"x": 0.416729,
				"y": 0.22301
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"disgust": {
		"lb": [
			{
				"x": 0.888628,
				"y": 0.549601
			},
			{
				"x": 0.882432,
				"y": 0.55825
			},
			{
				"x": 0.876457,
				"y": 0.567056
			},
			{
				"x": 0.8704,
				"y": 0.575806
			},
			{
				"x": 0.864155,
				"y": 0.584421
			},
			{
				"x": 0.857651,
				"y": 0.592841
			},
			{
				"x": 0.850828,
				"y": 0.601004
			},
			{
				"x": 0.843624,
				"y": 0.608831
			},
			{
				"x": 0.835975,
				"y": 0.616221
			},
			{
				"x": 0.827811,
				"y": 0.623033
			},
			{
				"x": 0.819063,
				"y": 0.62907
			},
			{
				"x": 0.80969,
				"y": 0.634075
			},
			{
				"x": 0.799785,
				"y": 0.637918
			},
			{
				"x": 0.789523,
				"y": 0.640668
			},
			{
				"x": 0.779048,
				"y": 0.642446
			},
			{
				"x": 0.768465,
				"y": 0.643388
			},
			{
				"x": 0.757842,
				"y": 0.643636
			},
			{
				"x": 0.74722,
				"y": 0.643325
			},
			{
				"x": 0.736618,
				"y": 0.642596
			},
			{
				"x": 0.726036,
				"y": 0.641613
			},
			{
				"x": 0.715455,
				"y": 0.640627
			},
			{
				"x": 0.70484,
				"y": 0.640274
			},
			{
				"x": 0.695899,
				"y": 0.644645
			},
			{
				"x": 0.699633,
				"y": 0.654235
			},
			{
				"x": 0.7073,
				"y": 0.661579
			},
			{
				"x": 0.716064,
				"y": 0.667589
			},
			{
				"x": 0.72546,
				"y": 0.672554
			},
			{
				"x": 0.735309,
				"y": 0.676542
			},
			{
				"x": 0.745503,
				"y": 0.679534
			},
			{
				"x": 0.755943,
				"y": 0.681507
			},
			{
				"x": 0.766522,
				"y": 0.682475
			},
			{
				"x": 0.777145,
				"y": 0.68244
			},
			{
				"x": 0.787717,
				"y": 0.681391
			},
			{
				"x": 0.798136,
				"y": 0.679316
			},
			{
				"x": 0.808296,
				"y": 0.676208
			},
			{
				"x": 0.818085,
				"y": 0.672075
			},
			{
				"x": 0.827391,
				"y": 0.666944
			},
			{
				"x": 0.836113,
				"y": 0.660868
			},
			{
				"x": 0.844163,
				"y": 0.653924
			},
			{
				"x": 0.851483,
				"y": 0.64621
			},
			{
				"x": 0.85807,
				"y": 0.637857
			},
			{
				"x": 0.864025,
				"y": 0.62904
			},
			{
				"x": 0.86944,
				"y": 0.619879
			},
			{
				"x": 0.874381,
				"y": 0.610453
			},
			{
				"x": 0.878893,
				"y": 0.600813
			},
			{
				"x": 0.882998,
				"y": 0.590992
			},
			{
				"x": 0.886698,
				"y": 0.58101
			},
			{
				"x": 0.889954,
				"y": 0.570875
			},
			{
				"x": 0.892645,
				"y": 0.560576
			},
			{
				"x": 0.894244,
				"y": 0.550063
			}
		],
		"rb": [
			{
				"x": 0.114958,
				"y": 0.55447
			},
			{
				"x": 0.120963,
				"y": 0.563255
			},
			{
				"x": 0.126967,
				"y": 0.572041
			},
			{
				"x": 0.133121,
				"y": 0.580722
			},
			{
				"x": 0.139506,
				"y": 0.589234
			},
			{
				"x": 0.146184,
				"y": 0.597516
			},
			{
				"x": 0.153216,
				"y": 0.605499
			},
			{
				"x": 0.160664,
				"y": 0.613093
			},
			{
				"x": 0.168597,
				"y": 0.620174
			},
			{
				"x": 0.177086,
				"y": 0.626575
			},
			{
				"x": 0.186189,
				"y": 0.632058
			},
			{
				"x": 0.195886,
				"y": 0.636399
			},
			{
				"x": 0.206014,
				"y": 0.639608
			},
			{
				"x": 0.216412,
				"y": 0.641789
			},
			{
				"x": 0.226959,
				"y": 0.643075
			},
			{
				"x": 0.237571,
				"y": 0.643605
			},
			{
				"x": 0.248197,
				"y": 0.643519
			},
			{
				"x": 0.258808,
				"y": 0.642953
			},
			{
				"x": 0.269398,
				"y": 0.642056
			},
			{
				"x": 0.279975,
				"y": 0.641028
			},
			{
				"x": 0.290574,
				"y": 0.640263
			},
			{
				"x": 0.301057,
				"y": 0.641417
			},
			{
				"x": 0.302948,
				"y": 0.650443
			},
			{
				"x": 0.296197,
				"y": 0.658605
			},
			{
				"x": 0.287813,
				"y": 0.665132
			},
			{
				"x": 0.278659,
				"y": 0.670531
			},
			{
				"x": 0.268991,
				"y": 0.67494
			},
			{
				"x": 0.258934,
				"y": 0.678368
			},
			{
				"x": 0.248587,
				"y": 0.680779
			},
			{
				"x": 0.238056,
				"y": 0.68218
			},
			{
				"x": 0.22744,
				"y": 0.682579
			},
			{
				"x": 0.216834,
				"y": 0.681969
			},
			{
				"x": 0.206336,
				"y": 0.680338
			},
			{
				"x": 0.196051,
				"y": 0.677676
			},
			{
				"x": 0.186088,
				"y": 0.673984
			},
			{
				"x": 0.17656,
				"y": 0.669279
			},
			{
				"x": 0.167574,
				"y": 0.663602
			},
			{
				"x": 0.159225,
				"y": 0.657022
			},
			{
				"x": 0.151584,
				"y": 0.649627
			},
			{
				"x": 0.144689,
				"y": 0.641529
			},
			{
				"x": 0.138474,
				"y": 0.632894
			},
			{
				"x": 0.132836,
				"y": 0.62387
			},
			{
				"x": 0.127697,
				"y": 0.614551
			},
			{
				"x": 0.123004,
				"y": 0.604998
			},
			{
				"x": 0.118725,
				"y": 0.595252
			},
			{
				"x": 0.114848,
				"y": 0.585338
			},
			{
				"x": 0.111392,
				"y": 0.575269
			},
			{
				"x": 0.108432,
				"y": 0.565044
			},
			{
				"x": 0.106222,
				"y": 0.554633
			},
			{
				"x": 0.10821,
				"y": 0.546289
			}
		],
		"le": [
			{
				"x": 0.839714,
				"y": 0.457489
			},
			{
				"x": 0.838428,
				"y": 0.446948
			},
			{
				"x": 0.834509,
				"y": 0.43708
			},
			{
				"x": 0.828409,
				"y": 0.428386
			},
			{
				"x": 0.820668,
				"y": 0.421116
			},
			{
				"x": 0.811708,
				"y": 0.415417
			},
			{
				"x": 0.801864,
				"y": 0.411446
			},
			{
				"x": 0.791455,
				"y": 0.409381
			},
			{
				"x": 0.780846,
				"y": 0.409361
			},
			{
				"x": 0.770487,
				"y": 0.411624
			},
			{
				"x": 0.76107,
				"y": 0.41648
			},
			{
				"x": 0.753604,
				"y": 0.423989
			},
			{
				"x": 0.748536,
				"y": 0.433326
			},
			{
				"x": 0.744822,
				"y": 0.443299
			},
			{
				"x": 0.741361,
				"y": 0.453366
			},
			{
				"x": 0.736919,
				"y": 0.463022
			},
			{
				"x": 0.729486,
				"y": 0.470445
			},
			{
				"x": 0.719266,
				"y": 0.47305
			},
			{
				"x": 0.708662,
				"y": 0.472623
			},
			{
				"x": 0.698168,
				"y": 0.470955
			},
			{
				"x": 0.687753,
				"y": 0.468838
			},
			{
				"x": 0.677348,
				"y": 0.466674
			},
			{
				"x": 0.66691,
				"y": 0.464674
			},
			{
				"x": 0.656429,
				"y": 0.462917
			},
			{
				"x": 0.645891,
				"y": 0.461548
			},
			{
				"x": 0.635285,
				"y": 0.460995
			},
			{
				"x": 0.627605,
				"y": 0.465407
			},
			{
				"x": 0.634864,
				"y": 0.47307
			},
			{
				"x": 0.643514,
				"y": 0.47925
			},
			{
				"x": 0.652542,
				"y": 0.484866
			},
			{
				"x": 0.661798,
				"y": 0.490096
			},
			{
				"x": 0.671246,
				"y": 0.494968
			},
			{
				"x": 0.680904,
				"y": 0.499409
			},
			{
				"x": 0.690797,
				"y": 0.503293
			},
			{
				"x": 0.700925,
				"y": 0.50651
			},
			{
				"x": 0.711248,
				"y": 0.509031
			},
			{
				"x": 0.721698,
				"y": 0.51096
			},
			{
				"x": 0.732221,
				"y": 0.512441
			},
			{
				"x": 0.742797,
				"y": 0.513481
			},
			{
				"x": 0.753408,
				"y": 0.514048
			},
			{
				"x": 0.764034,
				"y": 0.514104
			},
			{
				"x": 0.774648,
				"y": 0.513599
			},
			{
				"x": 0.785209,
				"y": 0.512436
			},
			{
				"x": 0.795631,
				"y": 0.510376
			},
			{
				"x": 0.805736,
				"y": 0.507109
			},
			{
				"x": 0.815204,
				"y": 0.502304
			},
			{
				"x": 0.823542,
				"y": 0.495734
			},
			{
				"x": 0.830297,
				"y": 0.487538
			},
			{
				"x": 0.835344,
				"y": 0.478186
			},
			{
				"x": 0.838564,
				"y": 0.468055
			}
		],
		"re": [
			{
				"x": 0.176752,
				"y": 0.463582
			},
			{
				"x": 0.186543,
				"y": 0.460986
			},
			{
				"x": 0.197139,
				"y": 0.46175
			},
			{
				"x": 0.207665,
				"y": 0.463204
			},
			{
				"x": 0.218138,
				"y": 0.465011
			},
			{
				"x": 0.228569,
				"y": 0.467047
			},
			{
				"x": 0.238972,
				"y": 0.469223
			},
			{
				"x": 0.249395,
				"y": 0.471297
			},
			{
				"x": 0.259909,
				"y": 0.472821
			},
			{
				"x": 0.270517,
				"y": 0.472885
			},
			{
				"x": 0.280473,
				"y": 0.469473
			},
			{
				"x": 0.287236,
				"y": 0.461394
			},
			{
				"x": 0.291386,
				"y": 0.451603
			},
			{
				"x": 0.294814,
				"y": 0.441524
			},
			{
				"x": 0.298683,
				"y": 0.431611
			},
			{
				"x": 0.304117,
				"y": 0.422492
			},
			{
				"x": 0.312004,
				"y": 0.415426
			},
			{
				"x": 0.321653,
				"y": 0.411046
			},
			{
				"x": 0.332097,
				"y": 0.409207
			},
			{
				"x": 0.3427,
				"y": 0.409601
			},
			{
				"x": 0.353035,
				"y": 0.412012
			},
			{
				"x": 0.362746,
				"y": 0.4163
			},
			{
				"x": 0.371516,
				"y": 0.422287
			},
			{
				"x": 0.379003,
				"y": 0.42982
			},
			{
				"x": 0.38476,
				"y": 0.438743
			},
			{
				"x": 0.388235,
				"y": 0.448775
			},
			{
				"x": 0.389062,
				"y": 0.459365
			},
			{
				"x": 0.387524,
				"y": 0.469882
			},
			{
				"x": 0.383968,
				"y": 0.479899
			},
			{
				"x": 0.378614,
				"y": 0.489079
			},
			{
				"x": 0.371565,
				"y": 0.497022
			},
			{
				"x": 0.362988,
				"y": 0.503275
			},
			{
				"x": 0.353376,
				"y": 0.507787
			},
			{
				"x": 0.343196,
				"y": 0.510817
			},
			{
				"x": 0.33274,
				"y": 0.512698
			},
			{
				"x": 0.322165,
				"y": 0.513731
			},
			{
				"x": 0.311547,
				"y": 0.514133
			},
			{
				"x": 0.300922,
				"y": 0.513984
			},
			{
				"x": 0.290316,
				"y": 0.513331
			},
			{
				"x": 0.279749,
				"y": 0.512212
			},
			{
				"x": 0.269237,
				"y": 0.510655
			},
			{
				"x": 0.258804,
				"y": 0.508634
			},
			{
				"x": 0.248511,
				"y": 0.505994
			},
			{
				"x": 0.238422,
				"y": 0.502654
			},
			{
				"x": 0.228571,
				"y": 0.498663
			},
			{
				"x": 0.218953,
				"y": 0.494138
			},
			{
				"x": 0.209538,
				"y": 0.4892
			},
			{
				"x": 0.200318,
				"y": 0.483906
			},
			{
				"x": 0.191341,
				"y": 0.478211
			},
			{
				"x": 0.182797,
				"y": 0.471886
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.359368,
				"y": 0.167633
			},
			{
				"x": 0.369543,
				"y": 0.177251
			},
			{
				"x": 0.380707,
				"y": 0.185704
			},
			{
				"x": 0.39254,
				"y": 0.19319
			},
			{
				"x": 0.404868,
				"y": 0.199828
			},
			{
				"x": 0.417584,
				"y": 0.205687
			},
			{
				"x": 0.430616,
				"y": 0.2108
			},
			{
				"x": 0.443915,
				"y": 0.215171
			},
			{
				"x": 0.457441,
				"y": 0.218774
			},
			{
				"x": 0.47116,
				"y": 0.22155
			},
			{
				"x": 0.485033,
				"y": 0.223395
			},
			{
				"x": 0.499007,
				"y": 0.224133
			},
			{
				"x": 0.512989,
				"y": 0.223573
			},
			{
				"x": 0.52688,
				"y": 0.221872
			},
			{
				"x": 0.540623,
				"y": 0.21922
			},
			{
				"x": 0.554179,
				"y": 0.21573
			},
			{
				"x": 0.567512,
				"y": 0.211466
			},
			{
				"x": 0.580585,
				"y": 0.206458
			},
			{
				"x": 0.593349,
				"y": 0.200706
			},
			{
				"x": 0.605738,
				"y": 0.194182
			},
			{
				"x": 0.61765,
				"y": 0.186822
			},
			{
				"x": 0.628923,
				"y": 0.178516
			},
			{
				"x": 0.639267,
				"y": 0.169079
			},
			{
				"x": 0.63974,
				"y": 0.179624
			},
			{
				"x": 0.636513,
				"y": 0.193254
			},
			{
				"x": 0.631122,
				"y": 0.206183
			},
			{
				"x": 0.623851,
				"y": 0.218153
			},
			{
				"x": 0.615006,
				"y": 0.229011
			},
			{
				"x": 0.604879,
				"y": 0.238681
			},
			{
				"x": 0.593724,
				"y": 0.247143
			},
			{
				"x": 0.581756,
				"y": 0.254406
			},
			{
				"x": 0.569151,
				"y": 0.260495
			},
			{
				"x": 0.556057,
				"y": 0.26544
			},
			{
				"x": 0.542595,
				"y": 0.26927
			},
			{
				"x": 0.52887,
				"y": 0.272008
			},
			{
				"x": 0.514975,
				"y": 0.273673
			},
			{
				"x": 0.500993,
				"y": 0.274276
			},
			{
				"x": 0.487006,
				"y": 0.273823
			},
			{
				"x": 0.473093,
				"y": 0.272309
			},
			{
				"x": 0.459339,
				"y": 0.269724
			},
			{
				"x": 0.445834,
				"y": 0.266051
			},
			{
				"x": 0.43268,
				"y": 0.261266
			},
			{
				"x": 0.419998,
				"y": 0.255341
			},
			{
				"x": 0.407929,
				"y": 0.248246
			},
			{
				"x": 0.396647,
				"y": 0.239956
			},
			{
				"x": 0.386359,
				"y": 0.230456
			},
			{
				"x": 0.377315,
				"y": 0.219764
			},
			{
				"x": 0.369802,
				"y": 0.207944
			},
			{
				"x": 0.364126,
				"y": 0.195139
			},
			{
				"x": 0.360578,
				"y": 0.181588
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"anger": {
		"lb": [
			{
				"x": 0.766058,
				"y": 0.567127
			},
			{
				"x": 0.75643,
				"y": 0.566107
			},
			{
				"x": 0.746841,
				"y": 0.564756
			},
			{
				"x": 0.737304,
				"y": 0.563083
			},
			{
				"x": 0.727827,
				"y": 0.561093
			},
			{
				"x": 0.718421,
				"y": 0.558794
			},
			{
				"x": 0.709094,
				"y": 0.556189
			},
			{
				"x": 0.699855,
				"y": 0.553286
			},
			{
				"x": 0.690713,
				"y": 0.550088
			},
			{
				"x": 0.681678,
				"y": 0.5466
			},
			{
				"x": 0.672758,
				"y": 0.542826
			},
			{
				"x": 0.663963,
				"y": 0.53877
			},
			{
				"x": 0.6553,
				"y": 0.534435
			},
			{
				"x": 0.646781,
				"y": 0.529826
			},
			{
				"x": 0.638413,
				"y": 0.524943
			},
			{
				"x": 0.630209,
				"y": 0.519792
			},
			{
				"x": 0.622177,
				"y": 0.514373
			},
			{
				"x": 0.61433,
				"y": 0.50869
			},
			{
				"x": 0.606678,
				"y": 0.502745
			},
			{
				"x": 0.599234,
				"y": 0.496541
			},
			{
				"x": 0.592011,
				"y": 0.49008
			},
			{
				"x": 0.585023,
				"y": 0.483366
			},
			{
				"x": 0.578284,
				"y": 0.4764
			},
			{
				"x": 0.57181,
				"y": 0.469186
			},
			{
				"x": 0.572407,
				"y": 0.477069
			},
			{
				"x": 0.574606,
				"y": 0.486514
			},
			{
				"x": 0.57762,
				"y": 0.495731
			},
			{
				"x": 0.581395,
				"y": 0.504662
			},
			{
				"x": 0.585876,
				"y": 0.51326
			},
			{
				"x": 0.59101,
				"y": 0.521484
			},
			{
				"x": 0.596744,
				"y": 0.529299
			},
			{
				"x": 0.603028,
				"y": 0.536677
			},
			{
				"x": 0.609817,
				"y": 0.543592
			},
			{
				"x": 0.617066,
				"y": 0.550023
			},
			{
				"x": 0.624731,
				"y": 0.555947
			},
			{
				"x": 0.632774,
				"y": 0.561346
			},
			{
				"x": 0.641155,
				"y": 0.566202
			},
			{
				"x": 0.649836,
				"y": 0.570495
			},
			{
				"x": 0.658781,
				"y": 0.574208
			},
			{
				"x": 0.66795,
				"y": 0.57732
			},
			{
				"x": 0.677306,
				"y": 0.579812
			},
			{
				"x": 0.686809,
				"y": 0.581663
			},
			{
				"x": 0.696417,
				"y": 0.582851
			},
			{
				"x": 0.706085,
				"y": 0.583355
			},
			{
				"x": 0.715764,
				"y": 0.583153
			},
			{
				"x": 0.7254,
				"y": 0.582221
			},
			{
				"x": 0.734934,
				"y": 0.58054
			},
			{
				"x": 0.7443,
				"y": 0.578092
			},
			{
				"x": 0.753427,
				"y": 0.574861
			},
			{
				"x": 0.762236,
				"y": 0.570839
			}
		],
		"rb": [
			{
				"x": 0.23147,
				"y": 0.567335
			},
			{
				"x": 0.241107,
				"y": 0.5664
			},
			{
				"x": 0.250707,
				"y": 0.565133
			},
			{
				"x": 0.260258,
				"y": 0.563542
			},
			{
				"x": 0.269751,
				"y": 0.561633
			},
			{
				"x": 0.279177,
				"y": 0.559412
			},
			{
				"x": 0.288525,
				"y": 0.556885
			},
			{
				"x": 0.297787,
				"y": 0.554058
			},
			{
				"x": 0.306954,
				"y": 0.550935
			},
			{
				"x": 0.316018,
				"y": 0.547521
			},
			{
				"x": 0.324968,
				"y": 0.54382
			},
			{
				"x": 0.333796,
				"y": 0.539836
			},
			{
				"x": 0.342494,
				"y": 0.535572
			},
			{
				"x": 0.351051,
				"y": 0.531033
			},
			{
				"x": 0.359458,
				"y": 0.52622
			},
			{
				"x": 0.367705,
				"y": 0.521137
			},
			{
				"x": 0.375782,
				"y": 0.515786
			},
			{
				"x": 0.383678,
				"y": 0.510171
			},
			{
				"x": 0.391381,
				"y": 0.504293
			},
			{
				"x": 0.398879,
				"y": 0.498155
			},
			{
				"x": 0.40616,
				"y": 0.49176
			},
			{
				"x": 0.41321,
				"y": 0.48511
			},
			{
				"x": 0.420014,
				"y": 0.478208
			},
			{
				"x": 0.426558,
				"y": 0.471057
			},
			{
				"x": 0.428019,
				"y": 0.47462
			},
			{
				"x": 0.426038,
				"y": 0.484114
			},
			{
				"x": 0.423227,
				"y": 0.493395
			},
			{
				"x": 0.419642,
				"y": 0.502404
			},
			{
				"x": 0.415336,
				"y": 0.511092
			},
			{
				"x": 0.410365,
				"y": 0.519414
			},
			{
				"x": 0.40478,
				"y": 0.527337
			},
			{
				"x": 0.398632,
				"y": 0.53483
			},
			{
				"x": 0.391968,
				"y": 0.541866
			},
			{
				"x": 0.384833,
				"y": 0.548423
			},
			{
				"x": 0.37727,
				"y": 0.554479
			},
			{
				"x": 0.36932,
				"y": 0.560014
			},
			{
				"x": 0.361022,
				"y": 0.565011
			},
			{
				"x": 0.352414,
				"y": 0.56945
			},
			{
				"x": 0.343534,
				"y": 0.573313
			},
			{
				"x": 0.334418,
				"y": 0.576581
			},
			{
				"x": 0.325106,
				"y": 0.579233
			},
			{
				"x": 0.315637,
				"y": 0.581251
			},
			{
				"x": 0.306052,
				"y": 0.582611
			},
			{
				"x": 0.296395,
				"y": 0.583293
			},
			{
				"x": 0.286714,
				"y": 0.583273
			},
			{
				"x": 0.277062,
				"y": 0.58253
			},
			{
				"x": 0.267496,
				"y": 0.581043
			},
			{
				"x": 0.25808,
				"y": 0.578793
			},
			{
				"x": 0.248884,
				"y": 0.575763
			},
			{
				"x": 0.239986,
				"y": 0.571945
			}
		],
		"le": [
			{
				"x": 0.687477,
				"y": 0.427502
			},
			{
				"x": 0.687257,
				"y": 0.420034
			},
			{
				"x": 0.686594,
				"y": 0.412592
			},
			{
				"x": 0.685475,
				"y": 0.405205
			},
			{
				"x": 0.683882,
				"y": 0.397906
			},
			{
				"x": 0.681785,
				"y": 0.390737
			},
			{
				"x": 0.679141,
				"y": 0.383751
			},
			{
				"x": 0.675897,
				"y": 0.377026
			},
			{
				"x": 0.67198,
				"y": 0.370671
			},
			{
				"x": 0.667306,
				"y": 0.364856
			},
			{
				"x": 0.66179,
				"y": 0.359841
			},
			{
				"x": 0.655399,
				"y": 0.35602
			},
			{
				"x": 0.648272,
				"y": 0.353901
			},
			{
				"x": 0.640841,
				"y": 0.353901
			},
			{
				"x": 0.633714,
				"y": 0.35602
			},
			{
				"x": 0.627322,
				"y": 0.359841
			},
			{
				"x": 0.621806,
				"y": 0.364856
			},
			{
				"x": 0.617132,
				"y": 0.370671
			},
			{
				"x": 0.613216,
				"y": 0.377026
			},
			{
				"x": 0.609971,
				"y": 0.383751
			},
			{
				"x": 0.607328,
				"y": 0.390737
			},
			{
				"x": 0.60523,
				"y": 0.397906
			},
			{
				"x": 0.603637,
				"y": 0.405205
			},
			{
				"x": 0.602519,
				"y": 0.412592
			},
			{
				"x": 0.601856,
				"y": 0.420034
			},
			{
				"x": 0.601636,
				"y": 0.427502
			},
			{
				"x": 0.601856,
				"y": 0.43497
			},
			{
				"x": 0.602519,
				"y": 0.442412
			},
			{
				"x": 0.603637,
				"y": 0.449799
			},
			{
				"x": 0.60523,
				"y": 0.457098
			},
			{
				"x": 0.607328,
				"y": 0.464267
			},
			{
				"x": 0.609971,
				"y": 0.471253
			},
			{
				"x": 0.613216,
				"y": 0.477978
			},
			{
				"x": 0.617132,
				"y": 0.484333
			},
			{
				"x": 0.621806,
				"y": 0.490148
			},
			{
				"x": 0.627322,
				"y": 0.495163
			},
			{
				"x": 0.633714,
				"y": 0.498984
			},
			{
				"x": 0.640841,
				"y": 0.501103
			},
			{
				"x": 0.648272,
				"y": 0.501103
			},
			{
				"x": 0.655399,
				"y": 0.498984
			},
			{
				"x": 0.66179,
				"y": 0.495163
			},
			{
				"x": 0.667306,
				"y": 0.490148
			},
			{
				"x": 0.67198,
				"y": 0.484333
			},
			{
				"x": 0.675897,
				"y": 0.477978
			},
			{
				"x": 0.679141,
				"y": 0.471253
			},
			{
				"x": 0.681785,
				"y": 0.464267
			},
			{
				"x": 0.683882,
				"y": 0.457098
			},
			{
				"x": 0.685475,
				"y": 0.449799
			},
			{
				"x": 0.686594,
				"y": 0.442412
			},
			{
				"x": 0.687257,
				"y": 0.43497
			}
		],
		"re": [
			{
				"x": 0.312523,
				"y": 0.427502
			},
			{
				"x": 0.312743,
				"y": 0.420034
			},
			{
				"x": 0.313406,
				"y": 0.412592
			},
			{
				"x": 0.314525,
				"y": 0.405205
			},
			{
				"x": 0.316118,
				"y": 0.397906
			},
			{
				"x": 0.318215,
				"y": 0.390737
			},
			{
				"x": 0.320859,
				"y": 0.383751
			},
			{
				"x": 0.324103,
				"y": 0.377026
			},
			{
				"x": 0.32802,
				"y": 0.370671
			},
			{
				"x": 0.332694,
				"y": 0.364856
			},
			{
				"x": 0.33821,
				"y": 0.359841
			},
			{
				"x": 0.344601,
				"y": 0.35602
			},
			{
				"x": 0.351728,
				"y": 0.353901
			},
			{
				"x": 0.359159,
				"y": 0.353901
			},
			{
				"x": 0.366286,
				"y": 0.35602
			},
			{
				"x": 0.372678,
				"y": 0.359841
			},
			{
				"x": 0.378194,
				"y": 0.364856
			},
			{
				"x": 0.382868,
				"y": 0.370671
			},
			{
				"x": 0.386784,
				"y": 0.377026
			},
			{
				"x": 0.390029,
				"y": 0.383751
			},
			{
				"x": 0.392672,
				"y": 0.390737
			},
			{
				"x": 0.39477,
				"y": 0.397906
			},
			{
				"x": 0.396363,
				"y": 0.405205
			},
			{
				"x": 0.397481,
				"y": 0.412592
			},
			{
				"x": 0.398144,
				"y": 0.420034
			},
			{
				"x": 0.398364,
				"y": 0.427502
			},
			{
				"x": 0.398144,
				"y": 0.43497
			},
			{
				"x": 0.397481,
				"y": 0.442412
			},
			{
				"x": 0.396363,
				"y": 0.449799
			},
			{
				"x": 0.39477,
				"y": 0.457098
			},
			{
				"x": 0.392672,
				"y": 0.464267
			},
			{
				"x": 0.390029,
				"y": 0.471253
			},
			{
				"x": 0.386784,
				"y": 0.477978
			},
			{
				"x": 0.382868,
				"y": 0.484333
			},
			{
				"x": 0.378194,
				"y": 0.490148
			},
			{
				"x": 0.372678,
				"y": 0.495163
			},
			{
				"x": 0.366286,
				"y": 0.498984
			},
			{
				"x": 0.359159,
				"y": 0.501103
			},
			{
				"x": 0.351728,
				"y": 0.501103
			},
			{
				"x": 0.344601,
				"y": 0.498984
			},
			{
				"x": 0.33821,
				"y": 0.495163
			},
			{
				"x": 0.332694,
				"y": 0.490148
			},
			{
				"x": 0.32802,
				"y": 0.484333
			},
			{
				"x": 0.324103,
				"y": 0.477978
			},
			{
				"x": 0.320859,
				"y": 0.471253
			},
			{
				"x": 0.318215,
				"y": 0.464267
			},
			{
				"x": 0.316118,
				"y": 0.457098
			},
			{
				"x": 0.314525,
				"y": 0.449799
			},
			{
				"x": 0.313406,
				"y": 0.442412
			},
			{
				"x": 0.312743,
				"y": 0.43497
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.372012,
				"y": 0.180837
			},
			{
				"x": 0.375868,
				"y": 0.179016
			},
			{
				"x": 0.38631,
				"y": 0.186447
			},
			{
				"x": 0.397391,
				"y": 0.19289
			},
			{
				"x": 0.408903,
				"y": 0.198526
			},
			{
				"x": 0.420732,
				"y": 0.203458
			},
			{
				"x": 0.43281,
				"y": 0.207744
			},
			{
				"x": 0.44509,
				"y": 0.211409
			},
			{
				"x": 0.457539,
				"y": 0.214449
			},
			{
				"x": 0.470129,
				"y": 0.216834
			},
			{
				"x": 0.482833,
				"y": 0.218501
			},
			{
				"x": 0.495617,
				"y": 0.219337
			},
			{
				"x": 0.508427,
				"y": 0.219173
			},
			{
				"x": 0.521191,
				"y": 0.218058
			},
			{
				"x": 0.533862,
				"y": 0.216154
			},
			{
				"x": 0.54641,
				"y": 0.213557
			},
			{
				"x": 0.558809,
				"y": 0.210318
			},
			{
				"x": 0.571029,
				"y": 0.206458
			},
			{
				"x": 0.583034,
				"y": 0.201972
			},
			{
				"x": 0.594773,
				"y": 0.196825
			},
			{
				"x": 0.606163,
				"y": 0.190949
			},
			{
				"x": 0.617072,
				"y": 0.184218
			},
			{
				"x": 0.627239,
				"y": 0.176416
			},
			{
				"x": 0.627056,
				"y": 0.184783
			},
			{
				"x": 0.623167,
				"y": 0.19701
			},
			{
				"x": 0.617949,
				"y": 0.208731
			},
			{
				"x": 0.611529,
				"y": 0.219836
			},
			{
				"x": 0.604023,
				"y": 0.230237
			},
			{
				"x": 0.595544,
				"y": 0.239858
			},
			{
				"x": 0.586195,
				"y": 0.248632
			},
			{
				"x": 0.576074,
				"y": 0.2565
			},
			{
				"x": 0.565274,
				"y": 0.263402
			},
			{
				"x": 0.553886,
				"y": 0.26928
			},
			{
				"x": 0.542002,
				"y": 0.274071
			},
			{
				"x": 0.529719,
				"y": 0.277713
			},
			{
				"x": 0.517141,
				"y": 0.280138
			},
			{
				"x": 0.504382,
				"y": 0.281275
			},
			{
				"x": 0.491576,
				"y": 0.281059
			},
			{
				"x": 0.478861,
				"y": 0.279508
			},
			{
				"x": 0.466363,
				"y": 0.276691
			},
			{
				"x": 0.454196,
				"y": 0.272679
			},
			{
				"x": 0.442458,
				"y": 0.267537
			},
			{
				"x": 0.431246,
				"y": 0.26133
			},
			{
				"x": 0.420651,
				"y": 0.254116
			},
			{
				"x": 0.410763,
				"y": 0.245956
			},
			{
				"x": 0.401679,
				"y": 0.236907
			},
			{
				"x": 0.393496,
				"y": 0.227032
			},
			{
				"x": 0.386321,
				"y": 0.2164
			},
			{
				"x": 0.380267,
				"y": 0.20509
			},
			{
				"x": 0.375455,
				"y": 0.193197
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"fear": {
		"lb": [
			{
				"x": 0.833505,
				"y": 0.670581
			},
			{
				"x": 0.826431,
				"y": 0.677206
			},
			{
				"x": 0.819136,
				"y": 0.683585
			},
			{
				"x": 0.81163,
				"y": 0.689713
			},
			{
				"x": 0.803925,
				"y": 0.695589
			},
			{
				"x": 0.796032,
				"y": 0.701208
			},
			{
				"x": 0.787961,
				"y": 0.706567
			},
			{
				"x": 0.779722,
				"y": 0.711664
			},
			{
				"x": 0.771324,
				"y": 0.716494
			},
			{
				"x": 0.762778,
				"y": 0.721053
			},
			{
				"x": 0.754091,
				"y": 0.725338
			},
			{
				"x": 0.745273,
				"y": 0.729345
			},
			{
				"x": 0.736332,
				"y": 0.733068
			},
			{
				"x": 0.727276,
				"y": 0.736503
			},
			{
				"x": 0.718115,
				"y": 0.739644
			},
			{
				"x": 0.708857,
				"y": 0.742485
			},
			{
				"x": 0.699511,
				"y": 0.745021
			},
			{
				"x": 0.690087,
				"y": 0.747245
			},
			{
				"x": 0.680593,
				"y": 0.749149
			},
			{
				"x": 0.671039,
				"y": 0.750727
			},
			{
				"x": 0.661436,
				"y": 0.751969
			},
			{
				"x": 0.651795,
				"y": 0.752867
			},
			{
				"x": 0.642128,
				"y": 0.753412
			},
			{
				"x": 0.632448,
				"y": 0.753595
			},
			{
				"x": 0.638092,
				"y": 0.758123
			},
			{
				"x": 0.646636,
				"y": 0.762681
			},
			{
				"x": 0.655546,
				"y": 0.766473
			},
			{
				"x": 0.664742,
				"y": 0.769501
			},
			{
				"x": 0.674153,
				"y": 0.771776
			},
			{
				"x": 0.683711,
				"y": 0.773311
			},
			{
				"x": 0.693358,
				"y": 0.774124
			},
			{
				"x": 0.703038,
				"y": 0.774232
			},
			{
				"x": 0.712702,
				"y": 0.773655
			},
			{
				"x": 0.722303,
				"y": 0.772412
			},
			{
				"x": 0.731799,
				"y": 0.770521
			},
			{
				"x": 0.741147,
				"y": 0.767999
			},
			{
				"x": 0.750309,
				"y": 0.764865
			},
			{
				"x": 0.759245,
				"y": 0.761133
			},
			{
				"x": 0.767918,
				"y": 0.756822
			},
			{
				"x": 0.776287,
				"y": 0.751946
			},
			{
				"x": 0.784313,
				"y": 0.746521
			},
			{
				"x": 0.791953,
				"y": 0.740565
			},
			{
				"x": 0.799165,
				"y": 0.734094
			},
			{
				"x": 0.805903,
				"y": 0.727128
			},
			{
				"x": 0.812116,
				"y": 0.71969
			},
			{
				"x": 0.817755,
				"y": 0.711805
			},
			{
				"x": 0.822764,
				"y": 0.703505
			},
			{
				"x": 0.827086,
				"y": 0.694827
			},
			{
				"x": 0.830665,
				"y": 0.685815
			},
			{
				"x": 0.833441,
				"y": 0.676523
			}
		],
		"rb": [
			{
				"x": 0.167571,
				"y": 0.671618
			},
			{
				"x": 0.174679,
				"y": 0.678206
			},
			{
				"x": 0.182008,
				"y": 0.684546
			},
			{
				"x": 0.189545,
				"y": 0.690636
			},
			{
				"x": 0.19728,
				"y": 0.696472
			},
			{
				"x": 0.205201,
				"y": 0.702051
			},
			{
				"x": 0.213299,
				"y": 0.70737
			},
			{
				"x": 0.221563,
				"y": 0.712426
			},
			{
				"x": 0.229984,
				"y": 0.717214
			},
			{
				"x": 0.238552,
				"y": 0.721732
			},
			{
				"x": 0.24726,
				"y": 0.725974
			},
			{
				"x": 0.256098,
				"y": 0.729937
			},
			{
				"x": 0.265057,
				"y": 0.733616
			},
			{
				"x": 0.274129,
				"y": 0.737006
			},
			{
				"x": 0.283306,
				"y": 0.740102
			},
			{
				"x": 0.292578,
				"y": 0.742896
			},
			{
				"x": 0.301937,
				"y": 0.745385
			},
			{
				"x": 0.311373,
				"y": 0.74756
			},
			{
				"x": 0.320877,
				"y": 0.749414
			},
			{
				"x": 0.330438,
				"y": 0.75094
			},
			{
				"x": 0.340048,
				"y": 0.75213
			},
			{
				"x": 0.349693,
				"y": 0.752974
			},
			{
				"x": 0.359363,
				"y": 0.753465
			},
			{
				"x": 0.368787,
				"y": 0.753673
			},
			{
				"x": 0.360618,
				"y": 0.758876
			},
			{
				"x": 0.352012,
				"y": 0.763316
			},
			{
				"x": 0.343053,
				"y": 0.766989
			},
			{
				"x": 0.333819,
				"y": 0.7699
			},
			{
				"x": 0.324382,
				"y": 0.77206
			},
			{
				"x": 0.314806,
				"y": 0.773483
			},
			{
				"x": 0.305151,
				"y": 0.774186
			},
			{
				"x": 0.29547,
				"y": 0.774188
			},
			{
				"x": 0.285813,
				"y": 0.773507
			},
			{
				"x": 0.276225,
				"y": 0.772162
			},
			{
				"x": 0.26675,
				"y": 0.770173
			},
			{
				"x": 0.257428,
				"y": 0.767555
			},
			{
				"x": 0.248298,
				"y": 0.764328
			},
			{
				"x": 0.2394,
				"y": 0.760506
			},
			{
				"x": 0.230772,
				"y": 0.756107
			},
			{
				"x": 0.222453,
				"y": 0.751145
			},
			{
				"x": 0.214483,
				"y": 0.745637
			},
			{
				"x": 0.206906,
				"y": 0.7396
			},
			{
				"x": 0.199764,
				"y": 0.733052
			},
			{
				"x": 0.193104,
				"y": 0.726012
			},
			{
				"x": 0.186976,
				"y": 0.718503
			},
			{
				"x": 0.181431,
				"y": 0.710552
			},
			{
				"x": 0.176524,
				"y": 0.702191
			},
			{
				"x": 0.172312,
				"y": 0.693458
			},
			{
				"x": 0.168854,
				"y": 0.684399
			},
			{
				"x": 0.166207,
				"y": 0.67507
			}
		],
		"le": [
			{
				"x": 0.750326,
				"y": 0.510601
			},
			{
				"x": 0.749886,
				"y": 0.501845
			},
			{
				"x": 0.748565,
				"y": 0.493177
			},
			{
				"x": 0.746364,
				"y": 0.484692
			},
			{
				"x": 0.743283,
				"y": 0.476486
			},
			{
				"x": 0.739327,
				"y": 0.468667
			},
			{
				"x": 0.734506,
				"y": 0.461351
			},
			{
				"x": 0.728843,
				"y": 0.454669
			},
			{
				"x": 0.72238,
				"y": 0.448763
			},
			{
				"x": 0.715184,
				"y": 0.443781
			},
			{
				"x": 0.707355,
				"y": 0.439874
			},
			{
				"x": 0.699033,
				"y": 0.437179
			},
			{
				"x": 0.690396,
				"y": 0.435802
			},
			{
				"x": 0.681651,
				"y": 0.435802
			},
			{
				"x": 0.673015,
				"y": 0.437179
			},
			{
				"x": 0.664693,
				"y": 0.439874
			},
			{
				"x": 0.656864,
				"y": 0.443781
			},
			{
				"x": 0.649668,
				"y": 0.448763
			},
			{
				"x": 0.643204,
				"y": 0.454669
			},
			{
				"x": 0.637542,
				"y": 0.461351
			},
			{
				"x": 0.632721,
				"y": 0.468667
			},
			{
				"x": 0.628764,
				"y": 0.476486
			},
			{
				"x": 0.625684,
				"y": 0.484692
			},
			{
				"x": 0.623482,
				"y": 0.493177
			},
			{
				"x": 0.622162,
				"y": 0.501845
			},
			{
				"x": 0.621722,
				"y": 0.510601
			},
			{
				"x": 0.622162,
				"y": 0.519358
			},
			{
				"x": 0.623482,
				"y": 0.528025
			},
			{
				"x": 0.625684,
				"y": 0.53651
			},
			{
				"x": 0.628764,
				"y": 0.544716
			},
			{
				"x": 0.632721,
				"y": 0.552535
			},
			{
				"x": 0.637542,
				"y": 0.559851
			},
			{
				"x": 0.643204,
				"y": 0.566533
			},
			{
				"x": 0.649668,
				"y": 0.57244
			},
			{
				"x": 0.656864,
				"y": 0.577421
			},
			{
				"x": 0.664693,
				"y": 0.581328
			},
			{
				"x": 0.673015,
				"y": 0.584023
			},
			{
				"x": 0.681651,
				"y": 0.5854
			},
			{
				"x": 0.690396,
				"y": 0.5854
			},
			{
				"x": 0.699033,
				"y": 0.584023
			},
			{
				"x": 0.707355,
				"y": 0.581328
			},
			{
				"x": 0.715184,
				"y": 0.577421
			},
			{
				"x": 0.72238,
				"y": 0.57244
			},
			{
				"x": 0.728843,
				"y": 0.566533
			},
			{
				"x": 0.734506,
				"y": 0.559851
			},
			{
				"x": 0.739327,
				"y": 0.552535
			},
			{
				"x": 0.743283,
				"y": 0.544716
			},
			{
				"x": 0.746364,
				"y": 0.53651
			},
			{
				"x": 0.748565,
				"y": 0.528025
			},
			{
				"x": 0.749886,
				"y": 0.519358
			}
		],
		"re": [
			{
				"x": 0.249674,
				"y": 0.510601
			},
			{
				"x": 0.250114,
				"y": 0.501845
			},
			{
				"x": 0.251435,
				"y": 0.493177
			},
			{
				"x": 0.253636,
				"y": 0.484692
			},
			{
				"x": 0.256717,
				"y": 0.476486
			},
			{
				"x": 0.260673,
				"y": 0.468667
			},
			{
				"x": 0.265494,
				"y": 0.461351
			},
			{
				"x": 0.271157,
				"y": 0.454669
			},
			{
				"x": 0.27762,
				"y": 0.448763
			},
			{
				"x": 0.284816,
				"y": 0.443781
			},
			{
				"x": 0.292645,
				"y": 0.439874
			},
			{
				"x": 0.300967,
				"y": 0.437179
			},
			{
				"x": 0.309604,
				"y": 0.435802
			},
			{
				"x": 0.318349,
				"y": 0.435802
			},
			{
				"x": 0.326985,
				"y": 0.437179
			},
			{
				"x": 0.335307,
				"y": 0.439874
			},
			{
				"x": 0.343136,
				"y": 0.443781
			},
			{
				"x": 0.350332,
				"y": 0.448763
			},
			{
				"x": 0.356796,
				"y": 0.454669
			},
			{
				"x": 0.362458,
				"y": 0.461351
			},
			{
				"x": 0.367279,
				"y": 0.468667
			},
			{
				"x": 0.371236,
				"y": 0.476486
			},
			{
				"x": 0.374316,
				"y": 0.484692
			},
			{
				"x": 0.376518,
				"y": 0.493177
			},
			{
				"x": 0.377838,
				"y": 0.501845
			},
			{
				"x": 0.378278,
				"y": 0.510601
			},
			{
				"x": 0.377838,
				"y": 0.519358
			},
			{
				"x": 0.376518,
				"y": 0.528025
			},
			{
				"x": 0.374316,
				"y": 0.53651
			},
			{
				"x": 0.371236,
				"y": 0.544716
			},
			{
				"x": 0.367279,
				"y": 0.552535
			},
			{
				"x": 0.362458,
				"y": 0.559851
			},
			{
				"x": 0.356796,
				"y": 0.566533
			},
			{
				"x": 0.350332,
				"y": 0.57244
			},
			{
				"x": 0.343136,
				"y": 0.577421
			},
			{
				"x": 0.335307,
				"y": 0.581328
			},
			{
				"x": 0.326985,
				"y": 0.584023
			},
			{
				"x": 0.318349,
				"y": 0.5854
			},
			{
				"x": 0.309604,
				"y": 0.5854
			},
			{
				"x": 0.300967,
				"y": 0.584023
			},
			{
				"x": 0.292645,
				"y": 0.581328
			},
			{
				"x": 0.284816,
				"y": 0.577421
			},
			{
				"x": 0.27762,
				"y": 0.57244
			},
			{
				"x": 0.271157,
				"y": 0.566533
			},
			{
				"x": 0.265494,
				"y": 0.559851
			},
			{
				"x": 0.260673,
				"y": 0.552535
			},
			{
				"x": 0.256717,
				"y": 0.544716
			},
			{
				"x": 0.253636,
				"y": 0.53651
			},
			{
				"x": 0.251435,
				"y": 0.528025
			},
			{
				"x": 0.250114,
				"y": 0.519358
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.364222,
				"y": 0.266079
			},
			{
				"x": 0.356036,
				"y": 0.252957
			},
			{
				"x": 0.350177,
				"y": 0.238652
			},
			{
				"x": 0.347724,
				"y": 0.223404
			},
			{
				"x": 0.349488,
				"y": 0.208071
			},
			{
				"x": 0.355779,
				"y": 0.194
			},
			{
				"x": 0.366523,
				"y": 0.182993
			},
			{
				"x": 0.380618,
				"y": 0.176875
			},
			{
				"x": 0.395993,
				"y": 0.176073
			},
			{
				"x": 0.411216,
				"y": 0.178681
			},
			{
				"x": 0.426137,
				"y": 0.182719
			},
			{
				"x": 0.440936,
				"y": 0.187192
			},
			{
				"x": 0.455783,
				"y": 0.1915
			},
			{
				"x": 0.470801,
				"y": 0.195154
			},
			{
				"x": 0.486049,
				"y": 0.197664
			},
			{
				"x": 0.501474,
				"y": 0.198487
			},
			{
				"x": 0.516876,
				"y": 0.197298
			},
			{
				"x": 0.53208,
				"y": 0.194529
			},
			{
				"x": 0.547059,
				"y": 0.190714
			},
			{
				"x": 0.561886,
				"y": 0.186336
			},
			{
				"x": 0.576693,
				"y": 0.181893
			},
			{
				"x": 0.59166,
				"y": 0.178031
			},
			{
				"x": 0.606949,
				"y": 0.175879
			},
			{
				"x": 0.622235,
				"y": 0.177614
			},
			{
				"x": 0.635837,
				"y": 0.184762
			},
			{
				"x": 0.645776,
				"y": 0.196508
			},
			{
				"x": 0.651191,
				"y": 0.210945
			},
			{
				"x": 0.65212,
				"y": 0.226354
			},
			{
				"x": 0.648931,
				"y": 0.241467
			},
			{
				"x": 0.642556,
				"y": 0.255552
			},
			{
				"x": 0.634016,
				"y": 0.268447
			},
			{
				"x": 0.623943,
				"y": 0.280184
			},
			{
				"x": 0.612705,
				"y": 0.290809
			},
			{
				"x": 0.600515,
				"y": 0.300323
			},
			{
				"x": 0.587493,
				"y": 0.308657
			},
			{
				"x": 0.57373,
				"y": 0.315694
			},
			{
				"x": 0.559353,
				"y": 0.321368
			},
			{
				"x": 0.544508,
				"y": 0.325662
			},
			{
				"x": 0.529337,
				"y": 0.328606
			},
			{
				"x": 0.513973,
				"y": 0.330266
			},
			{
				"x": 0.498526,
				"y": 0.330727
			},
			{
				"x": 0.483087,
				"y": 0.330044
			},
			{
				"x": 0.467751,
				"y": 0.328146
			},
			{
				"x": 0.452631,
				"y": 0.324949
			},
			{
				"x": 0.437864,
				"y": 0.320392
			},
			{
				"x": 0.423594,
				"y": 0.314456
			},
			{
				"x": 0.409963,
				"y": 0.307164
			},
			{
				"x": 0.397094,
				"y": 0.298596
			},
			{
				"x": 0.385073,
				"y": 0.288867
			},
			{
				"x": 0.374037,
				"y": 0.278032
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"grimacing": {
		"lb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"rb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"le": [
			{
				"x": 0.708191,
				"y": 0.6214
			},
			{
				"x": 0.707865,
				"y": 0.614079
			},
			{
				"x": 0.706885,
				"y": 0.606817
			},
			{
				"x": 0.705245,
				"y": 0.599675
			},
			{
				"x": 0.702935,
				"y": 0.592722
			},
			{
				"x": 0.699944,
				"y": 0.586036
			},
			{
				"x": 0.696261,
				"y": 0.579706
			},
			{
				"x": 0.691878,
				"y": 0.573841
			},
			{
				"x": 0.6868,
				"y": 0.568571
			},
			{
				"x": 0.681053,
				"y": 0.564045
			},
			{
				"x": 0.674695,
				"y": 0.560432
			},
			{
				"x": 0.667839,
				"y": 0.557899
			},
			{
				"x": 0.66065,
				"y": 0.556591
			},
			{
				"x": 0.653343,
				"y": 0.556591
			},
			{
				"x": 0.646154,
				"y": 0.557899
			},
			{
				"x": 0.639298,
				"y": 0.560432
			},
			{
				"x": 0.632941,
				"y": 0.564045
			},
			{
				"x": 0.627193,
				"y": 0.568571
			},
			{
				"x": 0.622115,
				"y": 0.573841
			},
			{
				"x": 0.617732,
				"y": 0.579706
			},
			{
				"x": 0.614049,
				"y": 0.586036
			},
			{
				"x": 0.611058,
				"y": 0.592722
			},
			{
				"x": 0.608748,
				"y": 0.599675
			},
			{
				"x": 0.607108,
				"y": 0.606817
			},
			{
				"x": 0.606128,
				"y": 0.614079
			},
			{
				"x": 0.605802,
				"y": 0.6214
			},
			{
				"x": 0.606128,
				"y": 0.628721
			},
			{
				"x": 0.607108,
				"y": 0.635983
			},
			{
				"x": 0.608748,
				"y": 0.643125
			},
			{
				"x": 0.611058,
				"y": 0.650077
			},
			{
				"x": 0.614049,
				"y": 0.656764
			},
			{
				"x": 0.617732,
				"y": 0.663094
			},
			{
				"x": 0.622115,
				"y": 0.668959
			},
			{
				"x": 0.627193,
				"y": 0.674229
			},
			{
				"x": 0.632941,
				"y": 0.678755
			},
			{
				"x": 0.639298,
				"y": 0.682368
			},
			{
				"x": 0.646154,
				"y": 0.684901
			},
			{
				"x": 0.653343,
				"y": 0.686209
			},
			{
				"x": 0.66065,
				"y": 0.686209
			},
			{
				"x": 0.667839,
				"y": 0.684901
			},
			{
				"x": 0.674695,
				"y": 0.682368
			},
			{
				"x": 0.681053,
				"y": 0.678755
			},
			{
				"x": 0.6868,
				"y": 0.674229
			},
			{
				"x": 0.691878,
				"y": 0.668959
			},
			{
				"x": 0.696261,
				"y": 0.663094
			},
			{
				"x": 0.699944,
				"y": 0.656764
			},
			{
				"x": 0.702935,
				"y": 0.650077
			},
			{
				"x": 0.705245,
				"y": 0.643125
			},
			{
				"x": 0.706885,
				"y": 0.635983
			},
			{
				"x": 0.707865,
				"y": 0.628721
			}
		],
		"re": [
			{
				"x": 0.291809,
				"y": 0.6214
			},
			{
				"x": 0.292135,
				"y": 0.614079
			},
			{
				"x": 0.293115,
				"y": 0.606817
			},
			{
				"x": 0.294755,
				"y": 0.599675
			},
			{
				"x": 0.297065,
				"y": 0.592722
			},
			{
				"x": 0.300056,
				"y": 0.586036
			},
			{
				"x": 0.303739,
				"y": 0.579706
			},
			{
				"x": 0.308122,
				"y": 0.573841
			},
			{
				"x": 0.3132,
				"y": 0.568571
			},
			{
				"x": 0.318947,
				"y": 0.564045
			},
			{
				"x": 0.325305,
				"y": 0.560432
			},
			{
				"x": 0.332161,
				"y": 0.557899
			},
			{
				"x": 0.33935,
				"y": 0.556591
			},
			{
				"x": 0.346657,
				"y": 0.556591
			},
			{
				"x": 0.353846,
				"y": 0.557899
			},
			{
				"x": 0.360702,
				"y": 0.560432
			},
			{
				"x": 0.367059,
				"y": 0.564045
			},
			{
				"x": 0.372807,
				"y": 0.568571
			},
			{
				"x": 0.377885,
				"y": 0.573841
			},
			{
				"x": 0.382268,
				"y": 0.579706
			},
			{
				"x": 0.385951,
				"y": 0.586036
			},
			{
				"x": 0.388942,
				"y": 0.592722
			},
			{
				"x": 0.391252,
				"y": 0.599675
			},
			{
				"x": 0.392892,
				"y": 0.606817
			},
			{
				"x": 0.393872,
				"y": 0.614079
			},
			{
				"x": 0.394198,
				"y": 0.6214
			},
			{
				"x": 0.393872,
				"y": 0.628721
			},
			{
				"x": 0.392892,
				"y": 0.635983
			},
			{
				"x": 0.391252,
				"y": 0.643125
			},
			{
				"x": 0.388942,
				"y": 0.650077
			},
			{
				"x": 0.385951,
				"y": 0.656764
			},
			{
				"x": 0.382268,
				"y": 0.663094
			},
			{
				"x": 0.377885,
				"y": 0.668959
			},
			{
				"x": 0.372807,
				"y": 0.674229
			},
			{
				"x": 0.367059,
				"y": 0.678755
			},
			{
				"x": 0.360702,
				"y": 0.682368
			},
			{
				"x": 0.353846,
				"y": 0.684901
			},
			{
				"x": 0.346657,
				"y": 0.686209
			},
			{
				"x": 0.33935,
				"y": 0.686209
			},
			{
				"x": 0.332161,
				"y": 0.684901
			},
			{
				"x": 0.325305,
				"y": 0.682368
			},
			{
				"x": 0.318947,
				"y": 0.678755
			},
			{
				"x": 0.3132,
				"y": 0.674229
			},
			{
				"x": 0.308122,
				"y": 0.668959
			},
			{
				"x": 0.303739,
				"y": 0.663094
			},
			{
				"x": 0.300056,
				"y": 0.656764
			},
			{
				"x": 0.297065,
				"y": 0.650077
			},
			{
				"x": 0.294755,
				"y": 0.643125
			},
			{
				"x": 0.293115,
				"y": 0.635983
			},
			{
				"x": 0.292135,
				"y": 0.628721
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.193171,
				"y": 0.418165
			},
			{
				"x": 0.18001,
				"y": 0.39105
			},
			{
				"x": 0.17743,
				"y": 0.360891
			},
			{
				"x": 0.178092,
				"y": 0.330544
			},
			{
				"x": 0.187423,
				"y": 0.301846
			},
			{
				"x": 0.208072,
				"y": 0.280065
			},
			{
				"x": 0.23718,
				"y": 0.273499
			},
			{
				"x": 0.267494,
				"y": 0.273499
			},
			{
				"x": 0.297809,
				"y": 0.273499
			},
			{
				"x": 0.328124,
				"y": 0.273499
			},
			{
				"x": 0.358438,
				"y": 0.273499
			},
			{
				"x": 0.388753,
				"y": 0.273499
			},
			{
				"x": 0.419068,
				"y": 0.273499
			},
			{
				"x": 0.449382,
				"y": 0.273499
			},
			{
				"x": 0.479697,
				"y": 0.273499
			},
			{
				"x": 0.510012,
				"y": 0.273499
			},
			{
				"x": 0.540326,
				"y": 0.273499
			},
			{
				"x": 0.570641,
				"y": 0.273499
			},
			{
				"x": 0.600956,
				"y": 0.273499
			},
			{
				"x": 0.631271,
				"y": 0.273499
			},
			{
				"x": 0.661585,
				"y": 0.273499
			},
			{
				"x": 0.6919,
				"y": 0.273499
			},
			{
				"x": 0.722215,
				"y": 0.273499
			},
			{
				"x": 0.752529,
				"y": 0.273499
			},
			{
				"x": 0.7826,
				"y": 0.275757
			},
			{
				"x": 0.806829,
				"y": 0.293305
			},
			{
				"x": 0.81999,
				"y": 0.32042
			},
			{
				"x": 0.82257,
				"y": 0.350579
			},
			{
				"x": 0.821908,
				"y": 0.380926
			},
			{
				"x": 0.812577,
				"y": 0.409624
			},
			{
				"x": 0.791928,
				"y": 0.431405
			},
			{
				"x": 0.76282,
				"y": 0.437971
			},
			{
				"x": 0.732506,
				"y": 0.437971
			},
			{
				"x": 0.702191,
				"y": 0.437971
			},
			{
				"x": 0.671876,
				"y": 0.437971
			},
			{
				"x": 0.641562,
				"y": 0.437971
			},
			{
				"x": 0.611247,
				"y": 0.437971
			},
			{
				"x": 0.580932,
				"y": 0.437971
			},
			{
				"x": 0.550618,
				"y": 0.437971
			},
			{
				"x": 0.520303,
				"y": 0.437971
			},
			{
				"x": 0.489988,
				"y": 0.437971
			},
			{
				"x": 0.459674,
				"y": 0.437971
			},
			{
				"x": 0.429359,
				"y": 0.437971
			},
			{
				"x": 0.399044,
				"y": 0.437971
			},
			{
				"x": 0.368729,
				"y": 0.437971
			},
			{
				"x": 0.338415,
				"y": 0.437971
			},
			{
				"x": 0.3081,
				"y": 0.437971
			},
			{
				"x": 0.277785,
				"y": 0.437971
			},
			{
				"x": 0.247471,
				"y": 0.437971
			},
			{
				"x": 0.2174,
				"y": 0.435713
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"grin": {
		"lb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"rb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"le": [
			{
				"x": 0.705551,
				"y": 0.520668
			},
			{
				"x": 0.702107,
				"y": 0.52959
			},
			{
				"x": 0.696999,
				"y": 0.538579
			},
			{
				"x": 0.690642,
				"y": 0.546732
			},
			{
				"x": 0.683267,
				"y": 0.553975
			},
			{
				"x": 0.67505,
				"y": 0.560243
			},
			{
				"x": 0.66613,
				"y": 0.565458
			},
			{
				"x": 0.656631,
				"y": 0.569518
			},
			{
				"x": 0.646681,
				"y": 0.572284
			},
			{
				"x": 0.636437,
				"y": 0.573566
			},
			{
				"x": 0.626121,
				"y": 0.573184
			},
			{
				"x": 0.61598,
				"y": 0.57124
			},
			{
				"x": 0.606211,
				"y": 0.56789
			},
			{
				"x": 0.596977,
				"y": 0.563258
			},
			{
				"x": 0.58844,
				"y": 0.557438
			},
			{
				"x": 0.580774,
				"y": 0.550506
			},
			{
				"x": 0.574192,
				"y": 0.542537
			},
			{
				"x": 0.56896,
				"y": 0.533622
			},
			{
				"x": 0.565798,
				"y": 0.526687
			},
			{
				"x": 0.5661,
				"y": 0.537036
			},
			{
				"x": 0.566807,
				"y": 0.547365
			},
			{
				"x": 0.567931,
				"y": 0.557658
			},
			{
				"x": 0.569484,
				"y": 0.567893
			},
			{
				"x": 0.571486,
				"y": 0.578051
			},
			{
				"x": 0.573966,
				"y": 0.588101
			},
			{
				"x": 0.576959,
				"y": 0.59801
			},
			{
				"x": 0.580512,
				"y": 0.607732
			},
			{
				"x": 0.584686,
				"y": 0.617202
			},
			{
				"x": 0.589557,
				"y": 0.62633
			},
			{
				"x": 0.595225,
				"y": 0.634983
			},
			{
				"x": 0.601808,
				"y": 0.642956
			},
			{
				"x": 0.609433,
				"y": 0.649929
			},
			{
				"x": 0.618179,
				"y": 0.65541
			},
			{
				"x": 0.627936,
				"y": 0.658735
			},
			{
				"x": 0.63822,
				"y": 0.659288
			},
			{
				"x": 0.648255,
				"y": 0.656954
			},
			{
				"x": 0.657424,
				"y": 0.652224
			},
			{
				"x": 0.6655,
				"y": 0.645785
			},
			{
				"x": 0.672514,
				"y": 0.638191
			},
			{
				"x": 0.678581,
				"y": 0.629815
			},
			{
				"x": 0.683822,
				"y": 0.620895
			},
			{
				"x": 0.68834,
				"y": 0.611585
			},
			{
				"x": 0.692218,
				"y": 0.60199
			},
			{
				"x": 0.695521,
				"y": 0.59218
			},
			{
				"x": 0.698299,
				"y": 0.582208
			},
			{
				"x": 0.700591,
				"y": 0.572112
			},
			{
				"x": 0.702426,
				"y": 0.561923
			},
			{
				"x": 0.703826,
				"y": 0.551665
			},
			{
				"x": 0.704807,
				"y": 0.541358
			},
			{
				"x": 0.705381,
				"y": 0.531021
			}
		],
		"re": [
			{
				"x": 0.289567,
				"y": 0.52607
			},
			{
				"x": 0.293003,
				"y": 0.534177
			},
			{
				"x": 0.298324,
				"y": 0.543039
			},
			{
				"x": 0.304977,
				"y": 0.550949
			},
			{
				"x": 0.3127,
				"y": 0.557816
			},
			{
				"x": 0.321284,
				"y": 0.563568
			},
			{
				"x": 0.330554,
				"y": 0.568126
			},
			{
				"x": 0.340351,
				"y": 0.571396
			},
			{
				"x": 0.350508,
				"y": 0.573252
			},
			{
				"x": 0.360827,
				"y": 0.573535
			},
			{
				"x": 0.371058,
				"y": 0.572159
			},
			{
				"x": 0.380985,
				"y": 0.569311
			},
			{
				"x": 0.390453,
				"y": 0.565179
			},
			{
				"x": 0.399335,
				"y": 0.559899
			},
			{
				"x": 0.407506,
				"y": 0.553571
			},
			{
				"x": 0.414825,
				"y": 0.546271
			},
			{
				"x": 0.421115,
				"y": 0.538066
			},
			{
				"x": 0.42614,
				"y": 0.52903
			},
			{
				"x": 0.429327,
				"y": 0.521285
			},
			{
				"x": 0.429133,
				"y": 0.531637
			},
			{
				"x": 0.428535,
				"y": 0.541973
			},
			{
				"x": 0.427529,
				"y": 0.552278
			},
			{
				"x": 0.426104,
				"y": 0.562532
			},
			{
				"x": 0.424242,
				"y": 0.572716
			},
			{
				"x": 0.421923,
				"y": 0.582805
			},
			{
				"x": 0.419115,
				"y": 0.592769
			},
			{
				"x": 0.415779,
				"y": 0.602568
			},
			{
				"x": 0.411864,
				"y": 0.612149
			},
			{
				"x": 0.407306,
				"y": 0.621438
			},
			{
				"x": 0.402019,
				"y": 0.630331
			},
			{
				"x": 0.395899,
				"y": 0.638668
			},
			{
				"x": 0.388825,
				"y": 0.646205
			},
			{
				"x": 0.380683,
				"y": 0.65256
			},
			{
				"x": 0.371453,
				"y": 0.657167
			},
			{
				"x": 0.361381,
				"y": 0.659338
			},
			{
				"x": 0.351108,
				"y": 0.65861
			},
			{
				"x": 0.341402,
				"y": 0.655137
			},
			{
				"x": 0.332723,
				"y": 0.64955
			},
			{
				"x": 0.325163,
				"y": 0.642506
			},
			{
				"x": 0.318638,
				"y": 0.634485
			},
			{
				"x": 0.313021,
				"y": 0.625799
			},
			{
				"x": 0.308194,
				"y": 0.616647
			},
			{
				"x": 0.304059,
				"y": 0.607159
			},
			{
				"x": 0.300541,
				"y": 0.597425
			},
			{
				"x": 0.29758,
				"y": 0.587506
			},
			{
				"x": 0.295129,
				"y": 0.577448
			},
			{
				"x": 0.293154,
				"y": 0.567286
			},
			{
				"x": 0.291627,
				"y": 0.557046
			},
			{
				"x": 0.290529,
				"y": 0.546751
			},
			{
				"x": 0.289845,
				"y": 0.53642
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.193171,
				"y": 0.418165
			},
			{
				"x": 0.18001,
				"y": 0.39105
			},
			{
				"x": 0.17743,
				"y": 0.360891
			},
			{
				"x": 0.178092,
				"y": 0.330544
			},
			{
				"x": 0.187423,
				"y": 0.301846
			},
			{
				"x": 0.208072,
				"y": 0.280065
			},
			{
				"x": 0.23718,
				"y": 0.273499
			},
			{
				"x": 0.267494,
				"y": 0.273499
			},
			{
				"x": 0.297809,
				"y": 0.273499
			},
			{
				"x": 0.328124,
				"y": 0.273499
			},
			{
				"x": 0.358438,
				"y": 0.273499
			},
			{
				"x": 0.388753,
				"y": 0.273499
			},
			{
				"x": 0.419068,
				"y": 0.273499
			},
			{
				"x": 0.449382,
				"y": 0.273499
			},
			{
				"x": 0.479697,
				"y": 0.273499
			},
			{
				"x": 0.510012,
				"y": 0.273499
			},
			{
				"x": 0.540326,
				"y": 0.273499
			},
			{
				"x": 0.570641,
				"y": 0.273499
			},
			{
				"x": 0.600956,
				"y": 0.273499
			},
			{
				"x": 0.631271,
				"y": 0.273499
			},
			{
				"x": 0.661585,
				"y": 0.273499
			},
			{
				"x": 0.6919,
				"y": 0.273499
			},
			{
				"x": 0.722215,
				"y": 0.273499
			},
			{
				"x": 0.752529,
				"y": 0.273499
			},
			{
				"x": 0.7826,
				"y": 0.275757
			},
			{
				"x": 0.806829,
				"y": 0.293305
			},
			{
				"x": 0.81999,
				"y": 0.32042
			},
			{
				"x": 0.82257,
				"y": 0.350579
			},
			{
				"x": 0.821908,
				"y": 0.380926
			},
			{
				"x": 0.812577,
				"y": 0.409624
			},
			{
				"x": 0.791928,
				"y": 0.431405
			},
			{
				"x": 0.76282,
				"y": 0.437971
			},
			{
				"x": 0.732506,
				"y": 0.437971
			},
			{
				"x": 0.702191,
				"y": 0.437971
			},
			{
				"x": 0.671876,
				"y": 0.437971
			},
			{
				"x": 0.641562,
				"y": 0.437971
			},
			{
				"x": 0.611247,
				"y": 0.437971
			},
			{
				"x": 0.580932,
				"y": 0.437971
			},
			{
				"x": 0.550618,
				"y": 0.437971
			},
			{
				"x": 0.520303,
				"y": 0.437971
			},
			{
				"x": 0.489988,
				"y": 0.437971
			},
			{
				"x": 0.459674,
				"y": 0.437971
			},
			{
				"x": 0.429359,
				"y": 0.437971
			},
			{
				"x": 0.399044,
				"y": 0.437971
			},
			{
				"x": 0.368729,
				"y": 0.437971
			},
			{
				"x": 0.338415,
				"y": 0.437971
			},
			{
				"x": 0.3081,
				"y": 0.437971
			},
			{
				"x": 0.277785,
				"y": 0.437971
			},
			{
				"x": 0.247471,
				"y": 0.437971
			},
			{
				"x": 0.2174,
				"y": 0.435713
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"smiley": {
		"lb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"rb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"le": [
			{
				"x": 0.708191,
				"y": 0.646677
			},
			{
				"x": 0.707976,
				"y": 0.634637
			},
			{
				"x": 0.707326,
				"y": 0.622613
			},
			{
				"x": 0.706228,
				"y": 0.610621
			},
			{
				"x": 0.704658,
				"y": 0.598682
			},
			{
				"x": 0.702577,
				"y": 0.586822
			},
			{
				"x": 0.699932,
				"y": 0.575076
			},
			{
				"x": 0.696641,
				"y": 0.563495
			},
			{
				"x": 0.692582,
				"y": 0.552163
			},
			{
				"x": 0.687568,
				"y": 0.541223
			},
			{
				"x": 0.681296,
				"y": 0.530962
			},
			{
				"x": 0.673274,
				"y": 0.522031
			},
			{
				"x": 0.66292,
				"y": 0.516092
			},
			{
				"x": 0.651073,
				"y": 0.516092
			},
			{
				"x": 0.640719,
				"y": 0.522031
			},
			{
				"x": 0.632697,
				"y": 0.530962
			},
			{
				"x": 0.626425,
				"y": 0.541223
			},
			{
				"x": 0.621411,
				"y": 0.552163
			},
			{
				"x": 0.617352,
				"y": 0.563495
			},
			{
				"x": 0.614061,
				"y": 0.575076
			},
			{
				"x": 0.611416,
				"y": 0.586822
			},
			{
				"x": 0.609336,
				"y": 0.598682
			},
			{
				"x": 0.607765,
				"y": 0.610621
			},
			{
				"x": 0.606667,
				"y": 0.622613
			},
			{
				"x": 0.606017,
				"y": 0.634637
			},
			{
				"x": 0.605802,
				"y": 0.646677
			},
			{
				"x": 0.606017,
				"y": 0.658718
			},
			{
				"x": 0.606667,
				"y": 0.670742
			},
			{
				"x": 0.607765,
				"y": 0.682734
			},
			{
				"x": 0.609336,
				"y": 0.694673
			},
			{
				"x": 0.611416,
				"y": 0.706533
			},
			{
				"x": 0.614061,
				"y": 0.718279
			},
			{
				"x": 0.617352,
				"y": 0.72986
			},
			{
				"x": 0.621411,
				"y": 0.741192
			},
			{
				"x": 0.626425,
				"y": 0.752132
			},
			{
				"x": 0.632697,
				"y": 0.762393
			},
			{
				"x": 0.640719,
				"y": 0.771324
			},
			{
				"x": 0.651073,
				"y": 0.777263
			},
			{
				"x": 0.66292,
				"y": 0.777263
			},
			{
				"x": 0.673274,
				"y": 0.771324
			},
			{
				"x": 0.681296,
				"y": 0.762393
			},
			{
				"x": 0.687568,
				"y": 0.752132
			},
			{
				"x": 0.692582,
				"y": 0.741192
			},
			{
				"x": 0.696641,
				"y": 0.72986
			},
			{
				"x": 0.699932,
				"y": 0.718279
			},
			{
				"x": 0.702577,
				"y": 0.706533
			},
			{
				"x": 0.704658,
				"y": 0.694673
			},
			{
				"x": 0.706228,
				"y": 0.682734
			},
			{
				"x": 0.707326,
				"y": 0.670742
			},
			{
				"x": 0.707976,
				"y": 0.658718
			}
		],
		"re": [
			{
				"x": 0.291809,
				"y": 0.646677
			},
			{
				"x": 0.292024,
				"y": 0.634637
			},
			{
				"x": 0.292674,
				"y": 0.622613
			},
			{
				"x": 0.293772,
				"y": 0.610621
			},
			{
				"x": 0.295342,
				"y": 0.598682
			},
			{
				"x": 0.297423,
				"y": 0.586822
			},
			{
				"x": 0.300068,
				"y": 0.575076
			},
			{
				"x": 0.303359,
				"y": 0.563495
			},
			{
				"x": 0.307418,
				"y": 0.552163
			},
			{
				"x": 0.312432,
				"y": 0.541223
			},
			{
				"x": 0.318704,
				"y": 0.530962
			},
			{
				"x": 0.326726,
				"y": 0.522031
			},
			{
				"x": 0.33708,
				"y": 0.516092
			},
			{
				"x": 0.348927,
				"y": 0.516092
			},
			{
				"x": 0.359281,
				"y": 0.522031
			},
			{
				"x": 0.367303,
				"y": 0.530962
			},
			{
				"x": 0.373575,
				"y": 0.541223
			},
			{
				"x": 0.378589,
				"y": 0.552163
			},
			{
				"x": 0.382648,
				"y": 0.563495
			},
			{
				"x": 0.385939,
				"y": 0.575076
			},
			{
				"x": 0.388584,
				"y": 0.586822
			},
			{
				"x": 0.390664,
				"y": 0.598682
			},
			{
				"x": 0.392235,
				"y": 0.610621
			},
			{
				"x": 0.393333,
				"y": 0.622613
			},
			{
				"x": 0.393983,
				"y": 0.634637
			},
			{
				"x": 0.394198,
				"y": 0.646677
			},
			{
				"x": 0.393983,
				"y": 0.658718
			},
			{
				"x": 0.393333,
				"y": 0.670742
			},
			{
				"x": 0.392235,
				"y": 0.682734
			},
			{
				"x": 0.390664,
				"y": 0.694673
			},
			{
				"x": 0.388584,
				"y": 0.706533
			},
			{
				"x": 0.385939,
				"y": 0.718279
			},
			{
				"x": 0.382648,
				"y": 0.72986
			},
			{
				"x": 0.378589,
				"y": 0.741192
			},
			{
				"x": 0.373575,
				"y": 0.752132
			},
			{
				"x": 0.367303,
				"y": 0.762393
			},
			{
				"x": 0.359281,
				"y": 0.771324
			},
			{
				"x": 0.348927,
				"y": 0.777263
			},
			{
				"x": 0.33708,
				"y": 0.777263
			},
			{
				"x": 0.326726,
				"y": 0.771324
			},
			{
				"x": 0.318704,
				"y": 0.762393
			},
			{
				"x": 0.312432,
				"y": 0.752132
			},
			{
				"x": 0.307418,
				"y": 0.741192
			},
			{
				"x": 0.303359,
				"y": 0.72986
			},
			{
				"x": 0.300068,
				"y": 0.718279
			},
			{
				"x": 0.297423,
				"y": 0.706533
			},
			{
				"x": 0.295342,
				"y": 0.694673
			},
			{
				"x": 0.293772,
				"y": 0.682734
			},
			{
				"x": 0.292674,
				"y": 0.670742
			},
			{
				"x": 0.292024,
				"y": 0.658718
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.168942,
				"y": 0.440155
			},
			{
				"x": 0.170863,
				"y": 0.4065
			},
			{
				"x": 0.176591,
				"y": 0.373281
			},
			{
				"x": 0.18603,
				"y": 0.340924
			},
			{
				"x": 0.199024,
				"y": 0.309829
			},
			{
				"x": 0.215366,
				"y": 0.280361
			},
			{
				"x": 0.234809,
				"y": 0.252847
			},
			{
				"x": 0.257076,
				"y": 0.227573
			},
			{
				"x": 0.281866,
				"y": 0.204778
			},
			{
				"x": 0.30887,
				"y": 0.184665
			},
			{
				"x": 0.337769,
				"y": 0.167396
			},
			{
				"x": 0.368243,
				"y": 0.1531
			},
			{
				"x": 0.399972,
				"y": 0.141876
			},
			{
				"x": 0.43264,
				"y": 0.133796
			},
			{
				"x": 0.465935,
				"y": 0.128912
			},
			{
				"x": 0.499543,
				"y": 0.127251
			},
			{
				"x": 0.533156,
				"y": 0.128824
			},
			{
				"x": 0.566462,
				"y": 0.133621
			},
			{
				"x": 0.599152,
				"y": 0.141614
			},
			{
				"x": 0.630911,
				"y": 0.152754
			},
			{
				"x": 0.661423,
				"y": 0.166968
			},
			{
				"x": 0.690368,
				"y": 0.184158
			},
			{
				"x": 0.717428,
				"y": 0.204196
			},
			{
				"x": 0.742283,
				"y": 0.22692
			},
			{
				"x": 0.764622,
				"y": 0.25213
			},
			{
				"x": 0.784146,
				"y": 0.279586
			},
			{
				"x": 0.800575,
				"y": 0.309005
			},
			{
				"x": 0.813663,
				"y": 0.340062
			},
			{
				"x": 0.823201,
				"y": 0.372389
			},
			{
				"x": 0.829032,
				"y": 0.40559
			},
			{
				"x": 0.831057,
				"y": 0.439239
			},
			{
				"x": 0.80007,
				"y": 0.429581
			},
			{
				"x": 0.767515,
				"y": 0.421019
			},
			{
				"x": 0.734605,
				"y": 0.413936
			},
			{
				"x": 0.701476,
				"y": 0.407967
			},
			{
				"x": 0.668192,
				"y": 0.402934
			},
			{
				"x": 0.634791,
				"y": 0.398746
			},
			{
				"x": 0.601298,
				"y": 0.395373
			},
			{
				"x": 0.567733,
				"y": 0.392829
			},
			{
				"x": 0.534112,
				"y": 0.391181
			},
			{
				"x": 0.500457,
				"y": 0.390569
			},
			{
				"x": 0.466802,
				"y": 0.391149
			},
			{
				"x": 0.433179,
				"y": 0.392772
			},
			{
				"x": 0.399612,
				"y": 0.395293
			},
			{
				"x": 0.366118,
				"y": 0.398644
			},
			{
				"x": 0.332714,
				"y": 0.402809
			},
			{
				"x": 0.299426,
				"y": 0.407819
			},
			{
				"x": 0.266292,
				"y": 0.41376
			},
			{
				"x": 0.233375,
				"y": 0.42081
			},
			{
				"x": 0.200807,
				"y": 0.429324
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"smile": {
		"lb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"rb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"le": [
			{
				"x": 0.705552,
				"y": 0.521446
			},
			{
				"x": 0.702432,
				"y": 0.528884
			},
			{
				"x": 0.697429,
				"y": 0.537932
			},
			{
				"x": 0.691157,
				"y": 0.546151
			},
			{
				"x": 0.683852,
				"y": 0.553465
			},
			{
				"x": 0.675692,
				"y": 0.559808
			},
			{
				"x": 0.666821,
				"y": 0.565105
			},
			{
				"x": 0.657361,
				"y": 0.569256
			},
			{
				"x": 0.64744,
				"y": 0.572125
			},
			{
				"x": 0.637212,
				"y": 0.573526
			},
			{
				"x": 0.626892,
				"y": 0.573269
			},
			{
				"x": 0.616731,
				"y": 0.571436
			},
			{
				"x": 0.606927,
				"y": 0.568187
			},
			{
				"x": 0.597648,
				"y": 0.563648
			},
			{
				"x": 0.589053,
				"y": 0.557914
			},
			{
				"x": 0.581315,
				"y": 0.551064
			},
			{
				"x": 0.574643,
				"y": 0.54317
			},
			{
				"x": 0.569299,
				"y": 0.534321
			},
			{
				"x": 0.565791,
				"y": 0.525909
			},
			{
				"x": 0.566063,
				"y": 0.53626
			},
			{
				"x": 0.56674,
				"y": 0.546591
			},
			{
				"x": 0.567832,
				"y": 0.556887
			},
			{
				"x": 0.569352,
				"y": 0.567128
			},
			{
				"x": 0.57132,
				"y": 0.577291
			},
			{
				"x": 0.573763,
				"y": 0.587351
			},
			{
				"x": 0.576716,
				"y": 0.597272
			},
			{
				"x": 0.580225,
				"y": 0.60701
			},
			{
				"x": 0.584349,
				"y": 0.616502
			},
			{
				"x": 0.589165,
				"y": 0.62566
			},
			{
				"x": 0.594769,
				"y": 0.634354
			},
			{
				"x": 0.601279,
				"y": 0.642388
			},
			{
				"x": 0.608822,
				"y": 0.64945
			},
			{
				"x": 0.617484,
				"y": 0.655065
			},
			{
				"x": 0.627176,
				"y": 0.658576
			},
			{
				"x": 0.637446,
				"y": 0.659349
			},
			{
				"x": 0.647527,
				"y": 0.657221
			},
			{
				"x": 0.656773,
				"y": 0.652647
			},
			{
				"x": 0.664932,
				"y": 0.646314
			},
			{
				"x": 0.672022,
				"y": 0.638792
			},
			{
				"x": 0.678156,
				"y": 0.630465
			},
			{
				"x": 0.683455,
				"y": 0.62158
			},
			{
				"x": 0.688024,
				"y": 0.612295
			},
			{
				"x": 0.691948,
				"y": 0.602718
			},
			{
				"x": 0.695292,
				"y": 0.592922
			},
			{
				"x": 0.698108,
				"y": 0.582961
			},
			{
				"x": 0.700435,
				"y": 0.572874
			},
			{
				"x": 0.702303,
				"y": 0.562691
			},
			{
				"x": 0.703736,
				"y": 0.552437
			},
			{
				"x": 0.704748,
				"y": 0.542133
			},
			{
				"x": 0.705352,
				"y": 0.531797
			}
		],
		"re": [
			{
				"x": 0.289567,
				"y": 0.52607
			},
			{
				"x": 0.293003,
				"y": 0.534177
			},
			{
				"x": 0.298324,
				"y": 0.543039
			},
			{
				"x": 0.304977,
				"y": 0.550949
			},
			{
				"x": 0.3127,
				"y": 0.557816
			},
			{
				"x": 0.321284,
				"y": 0.563568
			},
			{
				"x": 0.330554,
				"y": 0.568126
			},
			{
				"x": 0.340351,
				"y": 0.571396
			},
			{
				"x": 0.350508,
				"y": 0.573252
			},
			{
				"x": 0.360827,
				"y": 0.573535
			},
			{
				"x": 0.371058,
				"y": 0.572159
			},
			{
				"x": 0.380985,
				"y": 0.569311
			},
			{
				"x": 0.390453,
				"y": 0.565179
			},
			{
				"x": 0.399335,
				"y": 0.559899
			},
			{
				"x": 0.407506,
				"y": 0.553571
			},
			{
				"x": 0.414825,
				"y": 0.546271
			},
			{
				"x": 0.421115,
				"y": 0.538066
			},
			{
				"x": 0.42614,
				"y": 0.52903
			},
			{
				"x": 0.429327,
				"y": 0.521285
			},
			{
				"x": 0.429133,
				"y": 0.531637
			},
			{
				"x": 0.428535,
				"y": 0.541973
			},
			{
				"x": 0.427529,
				"y": 0.552278
			},
			{
				"x": 0.426104,
				"y": 0.562532
			},
			{
				"x": 0.424242,
				"y": 0.572716
			},
			{
				"x": 0.421923,
				"y": 0.582805
			},
			{
				"x": 0.419115,
				"y": 0.592769
			},
			{
				"x": 0.415779,
				"y": 0.602568
			},
			{
				"x": 0.411864,
				"y": 0.612149
			},
			{
				"x": 0.407306,
				"y": 0.621438
			},
			{
				"x": 0.402019,
				"y": 0.630331
			},
			{
				"x": 0.395899,
				"y": 0.638668
			},
			{
				"x": 0.388825,
				"y": 0.646205
			},
			{
				"x": 0.380683,
				"y": 0.65256
			},
			{
				"x": 0.371453,
				"y": 0.657167
			},
			{
				"x": 0.361381,
				"y": 0.659338
			},
			{
				"x": 0.351108,
				"y": 0.65861
			},
			{
				"x": 0.341402,
				"y": 0.655137
			},
			{
				"x": 0.332723,
				"y": 0.64955
			},
			{
				"x": 0.325163,
				"y": 0.642506
			},
			{
				"x": 0.318638,
				"y": 0.634485
			},
			{
				"x": 0.313021,
				"y": 0.625799
			},
			{
				"x": 0.308194,
				"y": 0.616647
			},
			{
				"x": 0.304059,
				"y": 0.607159
			},
			{
				"x": 0.300541,
				"y": 0.597425
			},
			{
				"x": 0.29758,
				"y": 0.587506
			},
			{
				"x": 0.295129,
				"y": 0.577448
			},
			{
				"x": 0.293154,
				"y": 0.567286
			},
			{
				"x": 0.291627,
				"y": 0.557046
			},
			{
				"x": 0.290529,
				"y": 0.546751
			},
			{
				"x": 0.289845,
				"y": 0.53642
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.168942,
				"y": 0.440155
			},
			{
				"x": 0.170863,
				"y": 0.4065
			},
			{
				"x": 0.176591,
				"y": 0.373281
			},
			{
				"x": 0.18603,
				"y": 0.340924
			},
			{
				"x": 0.199024,
				"y": 0.309829
			},
			{
				"x": 0.215366,
				"y": 0.280361
			},
			{
				"x": 0.234809,
				"y": 0.252847
			},
			{
				"x": 0.257076,
				"y": 0.227573
			},
			{
				"x": 0.281866,
				"y": 0.204778
			},
			{
				"x": 0.30887,
				"y": 0.184665
			},
			{
				"x": 0.337769,
				"y": 0.167396
			},
			{
				"x": 0.368243,
				"y": 0.1531
			},
			{
				"x": 0.399972,
				"y": 0.141876
			},
			{
				"x": 0.43264,
				"y": 0.133796
			},
			{
				"x": 0.465935,
				"y": 0.128912
			},
			{
				"x": 0.499543,
				"y": 0.127251
			},
			{
				"x": 0.533156,
				"y": 0.128824
			},
			{
				"x": 0.566462,
				"y": 0.133621
			},
			{
				"x": 0.599152,
				"y": 0.141614
			},
			{
				"x": 0.630911,
				"y": 0.152754
			},
			{
				"x": 0.661423,
				"y": 0.166968
			},
			{
				"x": 0.690368,
				"y": 0.184158
			},
			{
				"x": 0.717428,
				"y": 0.204196
			},
			{
				"x": 0.742283,
				"y": 0.22692
			},
			{
				"x": 0.764622,
				"y": 0.25213
			},
			{
				"x": 0.784146,
				"y": 0.279586
			},
			{
				"x": 0.800575,
				"y": 0.309005
			},
			{
				"x": 0.813663,
				"y": 0.340062
			},
			{
				"x": 0.823201,
				"y": 0.372389
			},
			{
				"x": 0.829032,
				"y": 0.40559
			},
			{
				"x": 0.831057,
				"y": 0.439239
			},
			{
				"x": 0.80007,
				"y": 0.429581
			},
			{
				"x": 0.767515,
				"y": 0.421019
			},
			{
				"x": 0.734605,
				"y": 0.413936
			},
			{
				"x": 0.701476,
				"y": 0.407967
			},
			{
				"x": 0.668192,
				"y": 0.402934
			},
			{
				"x": 0.634791,
				"y": 0.398746
			},
			{
				"x": 0.601298,
				"y": 0.395373
			},
			{
				"x": 0.567733,
				"y": 0.392829
			},
			{
				"x": 0.534112,
				"y": 0.391181
			},
			{
				"x": 0.500457,
				"y": 0.390569
			},
			{
				"x": 0.466802,
				"y": 0.391149
			},
			{
				"x": 0.433179,
				"y": 0.392772
			},
			{
				"x": 0.399612,
				"y": 0.395293
			},
			{
				"x": 0.366118,
				"y": 0.398644
			},
			{
				"x": 0.332714,
				"y": 0.402809
			},
			{
				"x": 0.299426,
				"y": 0.407819
			},
			{
				"x": 0.266292,
				"y": 0.41376
			},
			{
				"x": 0.233375,
				"y": 0.42081
			},
			{
				"x": 0.200807,
				"y": 0.429324
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"laughing": {
		"lb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"rb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"le": [
			{
				"x": 0.742417,
				"y": 0.511001
			},
			{
				"x": 0.733497,
				"y": 0.50166
			},
			{
				"x": 0.719736,
				"y": 0.500487
			},
			{
				"x": 0.706177,
				"y": 0.503326
			},
			{
				"x": 0.69355,
				"y": 0.509075
			},
			{
				"x": 0.681831,
				"y": 0.516531
			},
			{
				"x": 0.670695,
				"y": 0.524844
			},
			{
				"x": 0.65983,
				"y": 0.53351
			},
			{
				"x": 0.648979,
				"y": 0.542195
			},
			{
				"x": 0.63794,
				"y": 0.550638
			},
			{
				"x": 0.626692,
				"y": 0.5588
			},
			{
				"x": 0.615372,
				"y": 0.566862
			},
			{
				"x": 0.604137,
				"y": 0.575041
			},
			{
				"x": 0.593264,
				"y": 0.583694
			},
			{
				"x": 0.583686,
				"y": 0.593723
			},
			{
				"x": 0.581571,
				"y": 0.606831
			},
			{
				"x": 0.590403,
				"y": 0.617413
			},
			{
				"x": 0.601399,
				"y": 0.625907
			},
			{
				"x": 0.612668,
				"y": 0.634041
			},
			{
				"x": 0.624097,
				"y": 0.641945
			},
			{
				"x": 0.635698,
				"y": 0.649595
			},
			{
				"x": 0.647473,
				"y": 0.656973
			},
			{
				"x": 0.65942,
				"y": 0.664067
			},
			{
				"x": 0.671537,
				"y": 0.670866
			},
			{
				"x": 0.68383,
				"y": 0.677341
			},
			{
				"x": 0.696321,
				"y": 0.683422
			},
			{
				"x": 0.70906,
				"y": 0.688959
			},
			{
				"x": 0.722142,
				"y": 0.693617
			},
			{
				"x": 0.735726,
				"y": 0.69637
			},
			{
				"x": 0.748157,
				"y": 0.6919
			},
			{
				"x": 0.746338,
				"y": 0.678733
			},
			{
				"x": 0.737537,
				"y": 0.668026
			},
			{
				"x": 0.726788,
				"y": 0.659232
			},
			{
				"x": 0.71525,
				"y": 0.651491
			},
			{
				"x": 0.703358,
				"y": 0.644306
			},
			{
				"x": 0.691282,
				"y": 0.637434
			},
			{
				"x": 0.67912,
				"y": 0.630715
			},
			{
				"x": 0.666956,
				"y": 0.623999
			},
			{
				"x": 0.654915,
				"y": 0.617067
			},
			{
				"x": 0.643401,
				"y": 0.609305
			},
			{
				"x": 0.636968,
				"y": 0.597799
			},
			{
				"x": 0.645452,
				"y": 0.587074
			},
			{
				"x": 0.656667,
				"y": 0.578874
			},
			{
				"x": 0.668288,
				"y": 0.571255
			},
			{
				"x": 0.680005,
				"y": 0.563785
			},
			{
				"x": 0.691711,
				"y": 0.556298
			},
			{
				"x": 0.703332,
				"y": 0.548679
			},
			{
				"x": 0.714775,
				"y": 0.540793
			},
			{
				"x": 0.72587,
				"y": 0.532427
			},
			{
				"x": 0.736135,
				"y": 0.523073
			}
		],
		"re": [
			{
				"x": 0.250774,
				"y": 0.51683
			},
			{
				"x": 0.259885,
				"y": 0.508232
			},
			{
				"x": 0.273621,
				"y": 0.509722
			},
			{
				"x": 0.286842,
				"y": 0.513958
			},
			{
				"x": 0.299677,
				"y": 0.519268
			},
			{
				"x": 0.31224,
				"y": 0.525198
			},
			{
				"x": 0.324591,
				"y": 0.531559
			},
			{
				"x": 0.336763,
				"y": 0.53826
			},
			{
				"x": 0.348764,
				"y": 0.545262
			},
			{
				"x": 0.360594,
				"y": 0.552551
			},
			{
				"x": 0.37225,
				"y": 0.560117
			},
			{
				"x": 0.383733,
				"y": 0.567943
			},
			{
				"x": 0.39505,
				"y": 0.576008
			},
			{
				"x": 0.406189,
				"y": 0.584318
			},
			{
				"x": 0.416221,
				"y": 0.593884
			},
			{
				"x": 0.418425,
				"y": 0.606936
			},
			{
				"x": 0.410002,
				"y": 0.61787
			},
			{
				"x": 0.399364,
				"y": 0.626807
			},
			{
				"x": 0.388203,
				"y": 0.635086
			},
			{
				"x": 0.37689,
				"y": 0.643158
			},
			{
				"x": 0.365604,
				"y": 0.651268
			},
			{
				"x": 0.354488,
				"y": 0.659608
			},
			{
				"x": 0.343596,
				"y": 0.668241
			},
			{
				"x": 0.33276,
				"y": 0.676945
			},
			{
				"x": 0.321741,
				"y": 0.685414
			},
			{
				"x": 0.310243,
				"y": 0.693212
			},
			{
				"x": 0.297932,
				"y": 0.699623
			},
			{
				"x": 0.284627,
				"y": 0.703495
			},
			{
				"x": 0.270794,
				"y": 0.703791
			},
			{
				"x": 0.258766,
				"y": 0.697692
			},
			{
				"x": 0.261055,
				"y": 0.684823
			},
			{
				"x": 0.270747,
				"y": 0.674897
			},
			{
				"x": 0.281664,
				"y": 0.6663
			},
			{
				"x": 0.293021,
				"y": 0.658293
			},
			{
				"x": 0.304597,
				"y": 0.650605
			},
			{
				"x": 0.316285,
				"y": 0.643089
			},
			{
				"x": 0.328008,
				"y": 0.635627
			},
			{
				"x": 0.339676,
				"y": 0.628081
			},
			{
				"x": 0.351086,
				"y": 0.620152
			},
			{
				"x": 0.361187,
				"y": 0.61068
			},
			{
				"x": 0.35984,
				"y": 0.598178
			},
			{
				"x": 0.348829,
				"y": 0.589754
			},
			{
				"x": 0.336877,
				"y": 0.582669
			},
			{
				"x": 0.324734,
				"y": 0.575916
			},
			{
				"x": 0.312563,
				"y": 0.569215
			},
			{
				"x": 0.30045,
				"y": 0.562407
			},
			{
				"x": 0.288486,
				"y": 0.555341
			},
			{
				"x": 0.276808,
				"y": 0.547812
			},
			{
				"x": 0.265728,
				"y": 0.539434
			},
			{
				"x": 0.256107,
				"y": 0.529436
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.168942,
				"y": 0.440155
			},
			{
				"x": 0.170863,
				"y": 0.4065
			},
			{
				"x": 0.176591,
				"y": 0.373281
			},
			{
				"x": 0.18603,
				"y": 0.340924
			},
			{
				"x": 0.199024,
				"y": 0.309829
			},
			{
				"x": 0.215366,
				"y": 0.280361
			},
			{
				"x": 0.234809,
				"y": 0.252847
			},
			{
				"x": 0.257076,
				"y": 0.227573
			},
			{
				"x": 0.281866,
				"y": 0.204778
			},
			{
				"x": 0.30887,
				"y": 0.184665
			},
			{
				"x": 0.337769,
				"y": 0.167396
			},
			{
				"x": 0.368243,
				"y": 0.1531
			},
			{
				"x": 0.399972,
				"y": 0.141876
			},
			{
				"x": 0.43264,
				"y": 0.133796
			},
			{
				"x": 0.465935,
				"y": 0.128912
			},
			{
				"x": 0.499543,
				"y": 0.127251
			},
			{
				"x": 0.533156,
				"y": 0.128824
			},
			{
				"x": 0.566462,
				"y": 0.133621
			},
			{
				"x": 0.599152,
				"y": 0.141614
			},
			{
				"x": 0.630911,
				"y": 0.152754
			},
			{
				"x": 0.661423,
				"y": 0.166968
			},
			{
				"x": 0.690368,
				"y": 0.184158
			},
			{
				"x": 0.717428,
				"y": 0.204196
			},
			{
				"x": 0.742283,
				"y": 0.22692
			},
			{
				"x": 0.764622,
				"y": 0.25213
			},
			{
				"x": 0.784146,
				"y": 0.279586
			},
			{
				"x": 0.800575,
				"y": 0.309005
			},
			{
				"x": 0.813663,
				"y": 0.340062
			},
			{
				"x": 0.823201,
				"y": 0.372389
			},
			{
				"x": 0.829032,
				"y": 0.40559
			},
			{
				"x": 0.831057,
				"y": 0.439239
			},
			{
				"x": 0.80007,
				"y": 0.429581
			},
			{
				"x": 0.767515,
				"y": 0.421019
			},
			{
				"x": 0.734605,
				"y": 0.413936
			},
			{
				"x": 0.701476,
				"y": 0.407967
			},
			{
				"x": 0.668192,
				"y": 0.402934
			},
			{
				"x": 0.634791,
				"y": 0.398746
			},
			{
				"x": 0.601298,
				"y": 0.395373
			},
			{
				"x": 0.567733,
				"y": 0.392829
			},
			{
				"x": 0.534112,
				"y": 0.391181
			},
			{
				"x": 0.500457,
				"y": 0.390569
			},
			{
				"x": 0.466802,
				"y": 0.391149
			},
			{
				"x": 0.433179,
				"y": 0.392772
			},
			{
				"x": 0.399612,
				"y": 0.395293
			},
			{
				"x": 0.366118,
				"y": 0.398644
			},
			{
				"x": 0.332714,
				"y": 0.402809
			},
			{
				"x": 0.299426,
				"y": 0.407819
			},
			{
				"x": 0.266292,
				"y": 0.41376
			},
			{
				"x": 0.233375,
				"y": 0.42081
			},
			{
				"x": 0.200807,
				"y": 0.429324
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"wink": {
		"lb": [
			{
				"x": 0.815428,
				"y": 0.526703
			},
			{
				"x": 0.810466,
				"y": 0.529034
			},
			{
				"x": 0.802606,
				"y": 0.535216
			},
			{
				"x": 0.79449,
				"y": 0.541055
			},
			{
				"x": 0.786132,
				"y": 0.546542
			},
			{
				"x": 0.777549,
				"y": 0.551667
			},
			{
				"x": 0.768754,
				"y": 0.556419
			},
			{
				"x": 0.759766,
				"y": 0.560792
			},
			{
				"x": 0.750599,
				"y": 0.564775
			},
			{
				"x": 0.741271,
				"y": 0.568363
			},
			{
				"x": 0.731798,
				"y": 0.571548
			},
			{
				"x": 0.722198,
				"y": 0.574326
			},
			{
				"x": 0.712489,
				"y": 0.57669
			},
			{
				"x": 0.702688,
				"y": 0.578636
			},
			{
				"x": 0.692813,
				"y": 0.580162
			},
			{
				"x": 0.682881,
				"y": 0.581264
			},
			{
				"x": 0.672912,
				"y": 0.58194
			},
			{
				"x": 0.662923,
				"y": 0.582188
			},
			{
				"x": 0.652933,
				"y": 0.58201
			},
			{
				"x": 0.64296,
				"y": 0.581404
			},
			{
				"x": 0.633021,
				"y": 0.580372
			},
			{
				"x": 0.623135,
				"y": 0.578915
			},
			{
				"x": 0.613321,
				"y": 0.577037
			},
			{
				"x": 0.603595,
				"y": 0.574741
			},
			{
				"x": 0.606249,
				"y": 0.579559
			},
			{
				"x": 0.613562,
				"y": 0.586379
			},
			{
				"x": 0.621393,
				"y": 0.592594
			},
			{
				"x": 0.629694,
				"y": 0.598163
			},
			{
				"x": 0.63841,
				"y": 0.603053
			},
			{
				"x": 0.647488,
				"y": 0.607232
			},
			{
				"x": 0.65687,
				"y": 0.610673
			},
			{
				"x": 0.666494,
				"y": 0.613354
			},
			{
				"x": 0.676302,
				"y": 0.615259
			},
			{
				"x": 0.68623,
				"y": 0.616375
			},
			{
				"x": 0.696214,
				"y": 0.616695
			},
			{
				"x": 0.706193,
				"y": 0.616218
			},
			{
				"x": 0.716102,
				"y": 0.614946
			},
			{
				"x": 0.725878,
				"y": 0.612887
			},
			{
				"x": 0.73546,
				"y": 0.610054
			},
			{
				"x": 0.744786,
				"y": 0.606466
			},
			{
				"x": 0.753797,
				"y": 0.602145
			},
			{
				"x": 0.762437,
				"y": 0.597119
			},
			{
				"x": 0.770649,
				"y": 0.591419
			},
			{
				"x": 0.778382,
				"y": 0.585082
			},
			{
				"x": 0.785587,
				"y": 0.578148
			},
			{
				"x": 0.792217,
				"y": 0.570661
			},
			{
				"x": 0.798232,
				"y": 0.562669
			},
			{
				"x": 0.803592,
				"y": 0.554222
			},
			{
				"x": 0.808264,
				"y": 0.545374
			},
			{
				"x": 0.812218,
				"y": 0.536182
			}
		],
		"rb": [
			{
				"x": 0.189386,
				"y": 0.569298
			},
			{
				"x": 0.192745,
				"y": 0.57277
			},
			{
				"x": 0.197148,
				"y": 0.581758
			},
			{
				"x": 0.20193,
				"y": 0.590548
			},
			{
				"x": 0.207082,
				"y": 0.599126
			},
			{
				"x": 0.212595,
				"y": 0.607476
			},
			{
				"x": 0.218459,
				"y": 0.615582
			},
			{
				"x": 0.224663,
				"y": 0.623431
			},
			{
				"x": 0.231195,
				"y": 0.631006
			},
			{
				"x": 0.238045,
				"y": 0.638295
			},
			{
				"x": 0.245198,
				"y": 0.645285
			},
			{
				"x": 0.252644,
				"y": 0.651962
			},
			{
				"x": 0.260366,
				"y": 0.658315
			},
			{
				"x": 0.268353,
				"y": 0.664331
			},
			{
				"x": 0.276588,
				"y": 0.67
			},
			{
				"x": 0.285058,
				"y": 0.675312
			},
			{
				"x": 0.293746,
				"y": 0.680257
			},
			{
				"x": 0.302637,
				"y": 0.684825
			},
			{
				"x": 0.311714,
				"y": 0.689009
			},
			{
				"x": 0.320962,
				"y": 0.692801
			},
			{
				"x": 0.330363,
				"y": 0.696194
			},
			{
				"x": 0.339899,
				"y": 0.699181
			},
			{
				"x": 0.349555,
				"y": 0.701758
			},
			{
				"x": 0.359311,
				"y": 0.70392
			},
			{
				"x": 0.355629,
				"y": 0.707055
			},
			{
				"x": 0.346102,
				"y": 0.710066
			},
			{
				"x": 0.336365,
				"y": 0.712308
			},
			{
				"x": 0.326482,
				"y": 0.713766
			},
			{
				"x": 0.316514,
				"y": 0.71443
			},
			{
				"x": 0.306525,
				"y": 0.714297
			},
			{
				"x": 0.296578,
				"y": 0.713367
			},
			{
				"x": 0.286737,
				"y": 0.711646
			},
			{
				"x": 0.277063,
				"y": 0.709145
			},
			{
				"x": 0.26762,
				"y": 0.70588
			},
			{
				"x": 0.258466,
				"y": 0.701872
			},
			{
				"x": 0.249659,
				"y": 0.697147
			},
			{
				"x": 0.241256,
				"y": 0.691733
			},
			{
				"x": 0.23331,
				"y": 0.685667
			},
			{
				"x": 0.225871,
				"y": 0.678985
			},
			{
				"x": 0.218988,
				"y": 0.671731
			},
			{
				"x": 0.212702,
				"y": 0.663951
			},
			{
				"x": 0.207055,
				"y": 0.655694
			},
			{
				"x": 0.202082,
				"y": 0.647012
			},
			{
				"x": 0.197815,
				"y": 0.637961
			},
			{
				"x": 0.194282,
				"y": 0.628599
			},
			{
				"x": 0.191503,
				"y": 0.618984
			},
			{
				"x": 0.189498,
				"y": 0.609178
			},
			{
				"x": 0.188278,
				"y": 0.599243
			},
			{
				"x": 0.187852,
				"y": 0.589243
			},
			{
				"x": 0.188222,
				"y": 0.57924
			}
		],
		"le": [
			{
				"x": 0.74231,
				"y": 0.436585
			},
			{
				"x": 0.737558,
				"y": 0.437394
			},
			{
				"x": 0.730472,
				"y": 0.440898
			},
			{
				"x": 0.723214,
				"y": 0.444027
			},
			{
				"x": 0.715812,
				"y": 0.446797
			},
			{
				"x": 0.70829,
				"y": 0.449225
			},
			{
				"x": 0.700671,
				"y": 0.451325
			},
			{
				"x": 0.692973,
				"y": 0.453113
			},
			{
				"x": 0.685212,
				"y": 0.454601
			},
			{
				"x": 0.677402,
				"y": 0.455803
			},
			{
				"x": 0.669554,
				"y": 0.45673
			},
			{
				"x": 0.66168,
				"y": 0.457393
			},
			{
				"x": 0.653788,
				"y": 0.457802
			},
			{
				"x": 0.645887,
				"y": 0.457965
			},
			{
				"x": 0.637986,
				"y": 0.457891
			},
			{
				"x": 0.630089,
				"y": 0.457587
			},
			{
				"x": 0.622204,
				"y": 0.457059
			},
			{
				"x": 0.614337,
				"y": 0.456314
			},
			{
				"x": 0.606493,
				"y": 0.455357
			},
			{
				"x": 0.598676,
				"y": 0.454193
			},
			{
				"x": 0.590893,
				"y": 0.452826
			},
			{
				"x": 0.583147,
				"y": 0.451259
			},
			{
				"x": 0.575443,
				"y": 0.449496
			},
			{
				"x": 0.567786,
				"y": 0.44754
			},
			{
				"x": 0.569002,
				"y": 0.452677
			},
			{
				"x": 0.573562,
				"y": 0.459134
			},
			{
				"x": 0.579027,
				"y": 0.464844
			},
			{
				"x": 0.585192,
				"y": 0.469791
			},
			{
				"x": 0.591878,
				"y": 0.474004
			},
			{
				"x": 0.598949,
				"y": 0.477533
			},
			{
				"x": 0.6063,
				"y": 0.480433
			},
			{
				"x": 0.613852,
				"y": 0.482759
			},
			{
				"x": 0.621547,
				"y": 0.484559
			},
			{
				"x": 0.629338,
				"y": 0.485875
			},
			{
				"x": 0.637192,
				"y": 0.486743
			},
			{
				"x": 0.645081,
				"y": 0.487192
			},
			{
				"x": 0.652982,
				"y": 0.487221
			},
			{
				"x": 0.660875,
				"y": 0.486853
			},
			{
				"x": 0.668746,
				"y": 0.486146
			},
			{
				"x": 0.676574,
				"y": 0.48507
			},
			{
				"x": 0.684337,
				"y": 0.483592
			},
			{
				"x": 0.692001,
				"y": 0.48167
			},
			{
				"x": 0.699526,
				"y": 0.479256
			},
			{
				"x": 0.706853,
				"y": 0.476295
			},
			{
				"x": 0.713904,
				"y": 0.472725
			},
			{
				"x": 0.720573,
				"y": 0.468484
			},
			{
				"x": 0.726719,
				"y": 0.463514
			},
			{
				"x": 0.732162,
				"y": 0.457783
			},
			{
				"x": 0.736698,
				"y": 0.451309
			},
			{
				"x": 0.740127,
				"y": 0.444186
			}
		],
		"re": [
			{
				"x": 0.311439,
				"y": 0.480442
			},
			{
				"x": 0.311765,
				"y": 0.473121
			},
			{
				"x": 0.312745,
				"y": 0.465859
			},
			{
				"x": 0.314385,
				"y": 0.458717
			},
			{
				"x": 0.316695,
				"y": 0.451765
			},
			{
				"x": 0.319686,
				"y": 0.445078
			},
			{
				"x": 0.323369,
				"y": 0.438748
			},
			{
				"x": 0.327752,
				"y": 0.432884
			},
			{
				"x": 0.332829,
				"y": 0.427613
			},
			{
				"x": 0.338577,
				"y": 0.423087
			},
			{
				"x": 0.344934,
				"y": 0.419474
			},
			{
				"x": 0.351791,
				"y": 0.416941
			},
			{
				"x": 0.35898,
				"y": 0.415633
			},
			{
				"x": 0.366286,
				"y": 0.415633
			},
			{
				"x": 0.373475,
				"y": 0.416941
			},
			{
				"x": 0.380332,
				"y": 0.419474
			},
			{
				"x": 0.386689,
				"y": 0.423087
			},
			{
				"x": 0.392437,
				"y": 0.427613
			},
			{
				"x": 0.397515,
				"y": 0.432884
			},
			{
				"x": 0.401897,
				"y": 0.438748
			},
			{
				"x": 0.405581,
				"y": 0.445078
			},
			{
				"x": 0.408571,
				"y": 0.451765
			},
			{
				"x": 0.410881,
				"y": 0.458717
			},
			{
				"x": 0.412522,
				"y": 0.465859
			},
			{
				"x": 0.413502,
				"y": 0.473121
			},
			{
				"x": 0.413828,
				"y": 0.480442
			},
			{
				"x": 0.413502,
				"y": 0.487763
			},
			{
				"x": 0.412522,
				"y": 0.495025
			},
			{
				"x": 0.410881,
				"y": 0.502167
			},
			{
				"x": 0.408571,
				"y": 0.50912
			},
			{
				"x": 0.405581,
				"y": 0.515806
			},
			{
				"x": 0.401897,
				"y": 0.522136
			},
			{
				"x": 0.397515,
				"y": 0.528001
			},
			{
				"x": 0.392437,
				"y": 0.533271
			},
			{
				"x": 0.386689,
				"y": 0.537797
			},
			{
				"x": 0.380332,
				"y": 0.54141
			},
			{
				"x": 0.373475,
				"y": 0.543943
			},
			{
				"x": 0.366286,
				"y": 0.545251
			},
			{
				"x": 0.35898,
				"y": 0.545251
			},
			{
				"x": 0.351791,
				"y": 0.543943
			},
			{
				"x": 0.344934,
				"y": 0.54141
			},
			{
				"x": 0.338577,
				"y": 0.537797
			},
			{
				"x": 0.332829,
				"y": 0.533271
			},
			{
				"x": 0.327752,
				"y": 0.528001
			},
			{
				"x": 0.323369,
				"y": 0.522136
			},
			{
				"x": 0.319686,
				"y": 0.515806
			},
			{
				"x": 0.316695,
				"y": 0.50912
			},
			{
				"x": 0.314385,
				"y": 0.502167
			},
			{
				"x": 0.312745,
				"y": 0.495025
			},
			{
				"x": 0.311765,
				"y": 0.487763
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.389789,
				"y": 0.263318
			},
			{
				"x": 0.392696,
				"y": 0.2535
			},
			{
				"x": 0.39717,
				"y": 0.244289
			},
			{
				"x": 0.402912,
				"y": 0.23581
			},
			{
				"x": 0.409665,
				"y": 0.228113
			},
			{
				"x": 0.417222,
				"y": 0.221206
			},
			{
				"x": 0.425422,
				"y": 0.215077
			},
			{
				"x": 0.434138,
				"y": 0.209709
			},
			{
				"x": 0.44327,
				"y": 0.205087
			},
			{
				"x": 0.452736,
				"y": 0.201197
			},
			{
				"x": 0.462468,
				"y": 0.198033
			},
			{
				"x": 0.472407,
				"y": 0.195597
			},
			{
				"x": 0.482497,
				"y": 0.193897
			},
			{
				"x": 0.492684,
				"y": 0.192949
			},
			{
				"x": 0.502914,
				"y": 0.192779
			},
			{
				"x": 0.513127,
				"y": 0.193396
			},
			{
				"x": 0.523265,
				"y": 0.194775
			},
			{
				"x": 0.533276,
				"y": 0.196895
			},
			{
				"x": 0.543104,
				"y": 0.199746
			},
			{
				"x": 0.552692,
				"y": 0.203323
			},
			{
				"x": 0.561977,
				"y": 0.207629
			},
			{
				"x": 0.570883,
				"y": 0.212674
			},
			{
				"x": 0.579319,
				"y": 0.218473
			},
			{
				"x": 0.58717,
				"y": 0.225044
			},
			{
				"x": 0.594292,
				"y": 0.2324
			},
			{
				"x": 0.600498,
				"y": 0.240545
			},
			{
				"x": 0.605552,
				"y": 0.249451
			},
			{
				"x": 0.609172,
				"y": 0.25903
			},
			{
				"x": 0.605349,
				"y": 0.2601
			},
			{
				"x": 0.596354,
				"y": 0.255216
			},
			{
				"x": 0.587004,
				"y": 0.251052
			},
			{
				"x": 0.577426,
				"y": 0.247444
			},
			{
				"x": 0.567685,
				"y": 0.244303
			},
			{
				"x": 0.55782,
				"y": 0.241577
			},
			{
				"x": 0.547856,
				"y": 0.239242
			},
			{
				"x": 0.53781,
				"y": 0.23729
			},
			{
				"x": 0.527696,
				"y": 0.235727
			},
			{
				"x": 0.517527,
				"y": 0.234581
			},
			{
				"x": 0.507317,
				"y": 0.2339
			},
			{
				"x": 0.497086,
				"y": 0.23377
			},
			{
				"x": 0.486863,
				"y": 0.234227
			},
			{
				"x": 0.476675,
				"y": 0.235181
			},
			{
				"x": 0.466536,
				"y": 0.236568
			},
			{
				"x": 0.456459,
				"y": 0.238355
			},
			{
				"x": 0.446458,
				"y": 0.240525
			},
			{
				"x": 0.436547,
				"y": 0.24308
			},
			{
				"x": 0.426749,
				"y": 0.246038
			},
			{
				"x": 0.417095,
				"y": 0.249437
			},
			{
				"x": 0.407636,
				"y": 0.253347
			},
			{
				"x": 0.398466,
				"y": 0.257894
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"slightly_smiling_face": {
		"lb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"rb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"le": [
			{
				"x": 0.708191,
				"y": 0.6214
			},
			{
				"x": 0.707865,
				"y": 0.614079
			},
			{
				"x": 0.706885,
				"y": 0.606817
			},
			{
				"x": 0.705245,
				"y": 0.599675
			},
			{
				"x": 0.702935,
				"y": 0.592722
			},
			{
				"x": 0.699944,
				"y": 0.586036
			},
			{
				"x": 0.696261,
				"y": 0.579706
			},
			{
				"x": 0.691878,
				"y": 0.573841
			},
			{
				"x": 0.6868,
				"y": 0.568571
			},
			{
				"x": 0.681053,
				"y": 0.564045
			},
			{
				"x": 0.674695,
				"y": 0.560432
			},
			{
				"x": 0.667839,
				"y": 0.557899
			},
			{
				"x": 0.66065,
				"y": 0.556591
			},
			{
				"x": 0.653343,
				"y": 0.556591
			},
			{
				"x": 0.646154,
				"y": 0.557899
			},
			{
				"x": 0.639298,
				"y": 0.560432
			},
			{
				"x": 0.632941,
				"y": 0.564045
			},
			{
				"x": 0.627193,
				"y": 0.568571
			},
			{
				"x": 0.622115,
				"y": 0.573841
			},
			{
				"x": 0.617732,
				"y": 0.579706
			},
			{
				"x": 0.614049,
				"y": 0.586036
			},
			{
				"x": 0.611058,
				"y": 0.592722
			},
			{
				"x": 0.608748,
				"y": 0.599675
			},
			{
				"x": 0.607108,
				"y": 0.606817
			},
			{
				"x": 0.606128,
				"y": 0.614079
			},
			{
				"x": 0.605802,
				"y": 0.6214
			},
			{
				"x": 0.606128,
				"y": 0.628721
			},
			{
				"x": 0.607108,
				"y": 0.635983
			},
			{
				"x": 0.608748,
				"y": 0.643125
			},
			{
				"x": 0.611058,
				"y": 0.650077
			},
			{
				"x": 0.614049,
				"y": 0.656764
			},
			{
				"x": 0.617732,
				"y": 0.663094
			},
			{
				"x": 0.622115,
				"y": 0.668959
			},
			{
				"x": 0.627193,
				"y": 0.674229
			},
			{
				"x": 0.632941,
				"y": 0.678755
			},
			{
				"x": 0.639298,
				"y": 0.682368
			},
			{
				"x": 0.646154,
				"y": 0.684901
			},
			{
				"x": 0.653343,
				"y": 0.686209
			},
			{
				"x": 0.66065,
				"y": 0.686209
			},
			{
				"x": 0.667839,
				"y": 0.684901
			},
			{
				"x": 0.674695,
				"y": 0.682368
			},
			{
				"x": 0.681053,
				"y": 0.678755
			},
			{
				"x": 0.6868,
				"y": 0.674229
			},
			{
				"x": 0.691878,
				"y": 0.668959
			},
			{
				"x": 0.696261,
				"y": 0.663094
			},
			{
				"x": 0.699944,
				"y": 0.656764
			},
			{
				"x": 0.702935,
				"y": 0.650077
			},
			{
				"x": 0.705245,
				"y": 0.643125
			},
			{
				"x": 0.706885,
				"y": 0.635983
			},
			{
				"x": 0.707865,
				"y": 0.628721
			}
		],
		"re": [
			{
				"x": 0.291809,
				"y": 0.6214
			},
			{
				"x": 0.292135,
				"y": 0.614079
			},
			{
				"x": 0.293115,
				"y": 0.606817
			},
			{
				"x": 0.294755,
				"y": 0.599675
			},
			{
				"x": 0.297065,
				"y": 0.592722
			},
			{
				"x": 0.300056,
				"y": 0.586036
			},
			{
				"x": 0.303739,
				"y": 0.579706
			},
			{
				"x": 0.308122,
				"y": 0.573841
			},
			{
				"x": 0.3132,
				"y": 0.568571
			},
			{
				"x": 0.318947,
				"y": 0.564045
			},
			{
				"x": 0.325305,
				"y": 0.560432
			},
			{
				"x": 0.332161,
				"y": 0.557899
			},
			{
				"x": 0.33935,
				"y": 0.556591
			},
			{
				"x": 0.346657,
				"y": 0.556591
			},
			{
				"x": 0.353846,
				"y": 0.557899
			},
			{
				"x": 0.360702,
				"y": 0.560432
			},
			{
				"x": 0.367059,
				"y": 0.564045
			},
			{
				"x": 0.372807,
				"y": 0.568571
			},
			{
				"x": 0.377885,
				"y": 0.573841
			},
			{
				"x": 0.382268,
				"y": 0.579706
			},
			{
				"x": 0.385951,
				"y": 0.586036
			},
			{
				"x": 0.388942,
				"y": 0.592722
			},
			{
				"x": 0.391252,
				"y": 0.599675
			},
			{
				"x": 0.392892,
				"y": 0.606817
			},
			{
				"x": 0.393872,
				"y": 0.614079
			},
			{
				"x": 0.394198,
				"y": 0.6214
			},
			{
				"x": 0.393872,
				"y": 0.628721
			},
			{
				"x": 0.392892,
				"y": 0.635983
			},
			{
				"x": 0.391252,
				"y": 0.643125
			},
			{
				"x": 0.388942,
				"y": 0.650077
			},
			{
				"x": 0.385951,
				"y": 0.656764
			},
			{
				"x": 0.382268,
				"y": 0.663094
			},
			{
				"x": 0.377885,
				"y": 0.668959
			},
			{
				"x": 0.372807,
				"y": 0.674229
			},
			{
				"x": 0.367059,
				"y": 0.678755
			},
			{
				"x": 0.360702,
				"y": 0.682368
			},
			{
				"x": 0.353846,
				"y": 0.684901
			},
			{
				"x": 0.346657,
				"y": 0.686209
			},
			{
				"x": 0.33935,
				"y": 0.686209
			},
			{
				"x": 0.332161,
				"y": 0.684901
			},
			{
				"x": 0.325305,
				"y": 0.682368
			},
			{
				"x": 0.318947,
				"y": 0.678755
			},
			{
				"x": 0.3132,
				"y": 0.674229
			},
			{
				"x": 0.308122,
				"y": 0.668959
			},
			{
				"x": 0.303739,
				"y": 0.663094
			},
			{
				"x": 0.300056,
				"y": 0.656764
			},
			{
				"x": 0.297065,
				"y": 0.650077
			},
			{
				"x": 0.294755,
				"y": 0.643125
			},
			{
				"x": 0.293115,
				"y": 0.635983
			},
			{
				"x": 0.292135,
				"y": 0.628721
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.312763,
				"y": 0.337119
			},
			{
				"x": 0.316114,
				"y": 0.320601
			},
			{
				"x": 0.324841,
				"y": 0.306135
			},
			{
				"x": 0.336783,
				"y": 0.29415
			},
			{
				"x": 0.350547,
				"y": 0.284296
			},
			{
				"x": 0.365396,
				"y": 0.276165
			},
			{
				"x": 0.380935,
				"y": 0.269444
			},
			{
				"x": 0.396935,
				"y": 0.26391
			},
			{
				"x": 0.413255,
				"y": 0.259408
			},
			{
				"x": 0.429801,
				"y": 0.255826
			},
			{
				"x": 0.446506,
				"y": 0.253085
			},
			{
				"x": 0.463322,
				"y": 0.251129
			},
			{
				"x": 0.480207,
				"y": 0.249922
			},
			{
				"x": 0.497129,
				"y": 0.24944
			},
			{
				"x": 0.514056,
				"y": 0.249678
			},
			{
				"x": 0.530957,
				"y": 0.250637
			},
			{
				"x": 0.5478,
				"y": 0.252336
			},
			{
				"x": 0.564548,
				"y": 0.254806
			},
			{
				"x": 0.581154,
				"y": 0.258095
			},
			{
				"x": 0.59756,
				"y": 0.262274
			},
			{
				"x": 0.613682,
				"y": 0.267443
			},
			{
				"x": 0.629397,
				"y": 0.27374
			},
			{
				"x": 0.644514,
				"y": 0.281363
			},
			{
				"x": 0.658706,
				"y": 0.290591
			},
			{
				"x": 0.671382,
				"y": 0.301804
			},
			{
				"x": 0.68141,
				"y": 0.315413
			},
			{
				"x": 0.686836,
				"y": 0.331384
			},
			{
				"x": 0.678513,
				"y": 0.330108
			},
			{
				"x": 0.664398,
				"y": 0.320752
			},
			{
				"x": 0.649564,
				"y": 0.312585
			},
			{
				"x": 0.634235,
				"y": 0.305389
			},
			{
				"x": 0.61854,
				"y": 0.299035
			},
			{
				"x": 0.602557,
				"y": 0.293448
			},
			{
				"x": 0.586338,
				"y": 0.28859
			},
			{
				"x": 0.569922,
				"y": 0.284448
			},
			{
				"x": 0.553339,
				"y": 0.28104
			},
			{
				"x": 0.536615,
				"y": 0.27841
			},
			{
				"x": 0.51978,
				"y": 0.276639
			},
			{
				"x": 0.502871,
				"y": 0.275864
			},
			{
				"x": 0.485949,
				"y": 0.276255
			},
			{
				"x": 0.469084,
				"y": 0.277707
			},
			{
				"x": 0.452319,
				"y": 0.280058
			},
			{
				"x": 0.435686,
				"y": 0.283209
			},
			{
				"x": 0.41921,
				"y": 0.287104
			},
			{
				"x": 0.40292,
				"y": 0.29172
			},
			{
				"x": 0.386852,
				"y": 0.297057
			},
			{
				"x": 0.371052,
				"y": 0.303144
			},
			{
				"x": 0.355588,
				"y": 0.310044
			},
			{
				"x": 0.340567,
				"y": 0.317862
			},
			{
				"x": 0.326173,
				"y": 0.326782
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"upside_down_face": {
		"lb": [
			{
				"x": 0.826179,
				"y": 0.632958
			},
			{
				"x": 0.818519,
				"y": 0.639386
			},
			{
				"x": 0.810591,
				"y": 0.645481
			},
			{
				"x": 0.802412,
				"y": 0.651231
			},
			{
				"x": 0.793995,
				"y": 0.656626
			},
			{
				"x": 0.785355,
				"y": 0.661655
			},
			{
				"x": 0.776509,
				"y": 0.666311
			},
			{
				"x": 0.767473,
				"y": 0.670584
			},
			{
				"x": 0.758263,
				"y": 0.674466
			},
			{
				"x": 0.748896,
				"y": 0.677951
			},
			{
				"x": 0.739389,
				"y": 0.681032
			},
			{
				"x": 0.72976,
				"y": 0.683704
			},
			{
				"x": 0.720025,
				"y": 0.685961
			},
			{
				"x": 0.710203,
				"y": 0.6878
			},
			{
				"x": 0.700312,
				"y": 0.689217
			},
			{
				"x": 0.690369,
				"y": 0.690209
			},
			{
				"x": 0.680393,
				"y": 0.690775
			},
			{
				"x": 0.670402,
				"y": 0.690914
			},
			{
				"x": 0.660415,
				"y": 0.690625
			},
			{
				"x": 0.650448,
				"y": 0.68991
			},
			{
				"x": 0.640522,
				"y": 0.688768
			},
			{
				"x": 0.630653,
				"y": 0.687204
			},
			{
				"x": 0.620859,
				"y": 0.685218
			},
			{
				"x": 0.611228,
				"y": 0.682857
			},
			{
				"x": 0.618124,
				"y": 0.690099
			},
			{
				"x": 0.625575,
				"y": 0.696767
			},
			{
				"x": 0.633532,
				"y": 0.702819
			},
			{
				"x": 0.641945,
				"y": 0.708218
			},
			{
				"x": 0.65076,
				"y": 0.712927
			},
			{
				"x": 0.659921,
				"y": 0.716919
			},
			{
				"x": 0.669371,
				"y": 0.720166
			},
			{
				"x": 0.679049,
				"y": 0.722649
			},
			{
				"x": 0.688893,
				"y": 0.724352
			},
			{
				"x": 0.698841,
				"y": 0.725264
			},
			{
				"x": 0.708831,
				"y": 0.72538
			},
			{
				"x": 0.718797,
				"y": 0.724697
			},
			{
				"x": 0.728678,
				"y": 0.723222
			},
			{
				"x": 0.73841,
				"y": 0.720963
			},
			{
				"x": 0.747932,
				"y": 0.717934
			},
			{
				"x": 0.757183,
				"y": 0.714155
			},
			{
				"x": 0.766104,
				"y": 0.70965
			},
			{
				"x": 0.774638,
				"y": 0.704447
			},
			{
				"x": 0.782732,
				"y": 0.69858
			},
			{
				"x": 0.790334,
				"y": 0.692086
			},
			{
				"x": 0.797396,
				"y": 0.685005
			},
			{
				"x": 0.803872,
				"y": 0.677384
			},
			{
				"x": 0.809722,
				"y": 0.66927
			},
			{
				"x": 0.814908,
				"y": 0.660714
			},
			{
				"x": 0.819398,
				"y": 0.651773
			},
			{
				"x": 0.823163,
				"y": 0.642501
			}
		],
		"rb": [
			{
				"x": 0.173821,
				"y": 0.632958
			},
			{
				"x": 0.181481,
				"y": 0.639386
			},
			{
				"x": 0.189409,
				"y": 0.645481
			},
			{
				"x": 0.197588,
				"y": 0.651231
			},
			{
				"x": 0.206005,
				"y": 0.656626
			},
			{
				"x": 0.214645,
				"y": 0.661655
			},
			{
				"x": 0.223491,
				"y": 0.666311
			},
			{
				"x": 0.232527,
				"y": 0.670584
			},
			{
				"x": 0.241737,
				"y": 0.674466
			},
			{
				"x": 0.251104,
				"y": 0.677951
			},
			{
				"x": 0.260611,
				"y": 0.681032
			},
			{
				"x": 0.27024,
				"y": 0.683704
			},
			{
				"x": 0.279975,
				"y": 0.685961
			},
			{
				"x": 0.289797,
				"y": 0.6878
			},
			{
				"x": 0.299688,
				"y": 0.689217
			},
			{
				"x": 0.309631,
				"y": 0.690209
			},
			{
				"x": 0.319607,
				"y": 0.690775
			},
			{
				"x": 0.329598,
				"y": 0.690914
			},
			{
				"x": 0.339585,
				"y": 0.690625
			},
			{
				"x": 0.349552,
				"y": 0.68991
			},
			{
				"x": 0.359478,
				"y": 0.688768
			},
			{
				"x": 0.369347,
				"y": 0.687204
			},
			{
				"x": 0.379141,
				"y": 0.685218
			},
			{
				"x": 0.388772,
				"y": 0.682857
			},
			{
				"x": 0.381876,
				"y": 0.690099
			},
			{
				"x": 0.374425,
				"y": 0.696767
			},
			{
				"x": 0.366468,
				"y": 0.702819
			},
			{
				"x": 0.358055,
				"y": 0.708218
			},
			{
				"x": 0.34924,
				"y": 0.712927
			},
			{
				"x": 0.340079,
				"y": 0.716919
			},
			{
				"x": 0.330629,
				"y": 0.720166
			},
			{
				"x": 0.320951,
				"y": 0.722649
			},
			{
				"x": 0.311107,
				"y": 0.724352
			},
			{
				"x": 0.301159,
				"y": 0.725264
			},
			{
				"x": 0.291169,
				"y": 0.72538
			},
			{
				"x": 0.281203,
				"y": 0.724697
			},
			{
				"x": 0.271322,
				"y": 0.723222
			},
			{
				"x": 0.26159,
				"y": 0.720963
			},
			{
				"x": 0.252068,
				"y": 0.717934
			},
			{
				"x": 0.242817,
				"y": 0.714155
			},
			{
				"x": 0.233896,
				"y": 0.70965
			},
			{
				"x": 0.225362,
				"y": 0.704447
			},
			{
				"x": 0.217268,
				"y": 0.69858
			},
			{
				"x": 0.209666,
				"y": 0.692086
			},
			{
				"x": 0.202604,
				"y": 0.685005
			},
			{
				"x": 0.196128,
				"y": 0.677384
			},
			{
				"x": 0.190278,
				"y": 0.66927
			},
			{
				"x": 0.185092,
				"y": 0.660714
			},
			{
				"x": 0.180602,
				"y": 0.651773
			},
			{
				"x": 0.176837,
				"y": 0.642501
			}
		],
		"le": [
			{
				"x": 0.762083,
				"y": 0.481681
			},
			{
				"x": 0.754616,
				"y": 0.486573
			},
			{
				"x": 0.746893,
				"y": 0.491049
			},
			{
				"x": 0.738951,
				"y": 0.495122
			},
			{
				"x": 0.730823,
				"y": 0.498809
			},
			{
				"x": 0.722538,
				"y": 0.502124
			},
			{
				"x": 0.714119,
				"y": 0.505085
			},
			{
				"x": 0.705589,
				"y": 0.507703
			},
			{
				"x": 0.696964,
				"y": 0.509995
			},
			{
				"x": 0.688263,
				"y": 0.511972
			},
			{
				"x": 0.679499,
				"y": 0.513645
			},
			{
				"x": 0.670683,
				"y": 0.515027
			},
			{
				"x": 0.661829,
				"y": 0.516126
			},
			{
				"x": 0.652945,
				"y": 0.516952
			},
			{
				"x": 0.64404,
				"y": 0.517514
			},
			{
				"x": 0.635123,
				"y": 0.517817
			},
			{
				"x": 0.626201,
				"y": 0.517871
			},
			{
				"x": 0.61728,
				"y": 0.517679
			},
			{
				"x": 0.608368,
				"y": 0.517248
			},
			{
				"x": 0.599471,
				"y": 0.516582
			},
			{
				"x": 0.590593,
				"y": 0.515686
			},
			{
				"x": 0.581741,
				"y": 0.514562
			},
			{
				"x": 0.572921,
				"y": 0.513215
			},
			{
				"x": 0.564787,
				"y": 0.512129
			},
			{
				"x": 0.569635,
				"y": 0.519622
			},
			{
				"x": 0.57562,
				"y": 0.526241
			},
			{
				"x": 0.582493,
				"y": 0.531931
			},
			{
				"x": 0.590028,
				"y": 0.53671
			},
			{
				"x": 0.598042,
				"y": 0.540631
			},
			{
				"x": 0.606395,
				"y": 0.543767
			},
			{
				"x": 0.614981,
				"y": 0.546189
			},
			{
				"x": 0.623725,
				"y": 0.547962
			},
			{
				"x": 0.632568,
				"y": 0.549145
			},
			{
				"x": 0.641466,
				"y": 0.549786
			},
			{
				"x": 0.650386,
				"y": 0.549927
			},
			{
				"x": 0.659302,
				"y": 0.549603
			},
			{
				"x": 0.668187,
				"y": 0.548792
			},
			{
				"x": 0.677025,
				"y": 0.547569
			},
			{
				"x": 0.685801,
				"y": 0.545959
			},
			{
				"x": 0.69449,
				"y": 0.54393
			},
			{
				"x": 0.703059,
				"y": 0.541442
			},
			{
				"x": 0.711466,
				"y": 0.538451
			},
			{
				"x": 0.719654,
				"y": 0.534905
			},
			{
				"x": 0.72755,
				"y": 0.530745
			},
			{
				"x": 0.735051,
				"y": 0.52591
			},
			{
				"x": 0.742022,
				"y": 0.520337
			},
			{
				"x": 0.74829,
				"y": 0.513982
			},
			{
				"x": 0.75364,
				"y": 0.506837
			},
			{
				"x": 0.757843,
				"y": 0.498962
			},
			{
				"x": 0.760695,
				"y": 0.490501
			}
		],
		"re": [
			{
				"x": 0.237917,
				"y": 0.481681
			},
			{
				"x": 0.245384,
				"y": 0.486573
			},
			{
				"x": 0.253107,
				"y": 0.491049
			},
			{
				"x": 0.261049,
				"y": 0.495122
			},
			{
				"x": 0.269177,
				"y": 0.498809
			},
			{
				"x": 0.277462,
				"y": 0.502124
			},
			{
				"x": 0.285881,
				"y": 0.505085
			},
			{
				"x": 0.294411,
				"y": 0.507703
			},
			{
				"x": 0.303036,
				"y": 0.509995
			},
			{
				"x": 0.311737,
				"y": 0.511972
			},
			{
				"x": 0.320501,
				"y": 0.513645
			},
			{
				"x": 0.329317,
				"y": 0.515027
			},
			{
				"x": 0.338171,
				"y": 0.516126
			},
			{
				"x": 0.347055,
				"y": 0.516952
			},
			{
				"x": 0.35596,
				"y": 0.517514
			},
			{
				"x": 0.364877,
				"y": 0.517817
			},
			{
				"x": 0.373799,
				"y": 0.517871
			},
			{
				"x": 0.38272,
				"y": 0.517679
			},
			{
				"x": 0.391632,
				"y": 0.517248
			},
			{
				"x": 0.400529,
				"y": 0.516582
			},
			{
				"x": 0.409407,
				"y": 0.515686
			},
			{
				"x": 0.418259,
				"y": 0.514562
			},
			{
				"x": 0.427079,
				"y": 0.513215
			},
			{
				"x": 0.435213,
				"y": 0.512129
			},
			{
				"x": 0.430365,
				"y": 0.519622
			},
			{
				"x": 0.42438,
				"y": 0.526241
			},
			{
				"x": 0.417507,
				"y": 0.531931
			},
			{
				"x": 0.409972,
				"y": 0.53671
			},
			{
				"x": 0.401958,
				"y": 0.540631
			},
			{
				"x": 0.393605,
				"y": 0.543767
			},
			{
				"x": 0.385019,
				"y": 0.546189
			},
			{
				"x": 0.376275,
				"y": 0.547962
			},
			{
				"x": 0.367432,
				"y": 0.549145
			},
			{
				"x": 0.358534,
				"y": 0.549786
			},
			{
				"x": 0.349614,
				"y": 0.549927
			},
			{
				"x": 0.340698,
				"y": 0.549603
			},
			{
				"x": 0.331813,
				"y": 0.548792
			},
			{
				"x": 0.322975,
				"y": 0.547569
			},
			{
				"x": 0.314199,
				"y": 0.545959
			},
			{
				"x": 0.30551,
				"y": 0.54393
			},
			{
				"x": 0.296941,
				"y": 0.541442
			},
			{
				"x": 0.288534,
				"y": 0.538451
			},
			{
				"x": 0.280346,
				"y": 0.534905
			},
			{
				"x": 0.27245,
				"y": 0.530745
			},
			{
				"x": 0.264949,
				"y": 0.52591
			},
			{
				"x": 0.257978,
				"y": 0.520337
			},
			{
				"x": 0.25171,
				"y": 0.513982
			},
			{
				"x": 0.24636,
				"y": 0.506837
			},
			{
				"x": 0.242157,
				"y": 0.498962
			},
			{
				"x": 0.239305,
				"y": 0.490501
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.389789,
				"y": 0.263318
			},
			{
				"x": 0.392696,
				"y": 0.2535
			},
			{
				"x": 0.39717,
				"y": 0.244289
			},
			{
				"x": 0.402912,
				"y": 0.23581
			},
			{
				"x": 0.409665,
				"y": 0.228113
			},
			{
				"x": 0.417222,
				"y": 0.221206
			},
			{
				"x": 0.425422,
				"y": 0.215077
			},
			{
				"x": 0.434138,
				"y": 0.209709
			},
			{
				"x": 0.44327,
				"y": 0.205087
			},
			{
				"x": 0.452736,
				"y": 0.201197
			},
			{
				"x": 0.462468,
				"y": 0.198033
			},
			{
				"x": 0.472407,
				"y": 0.195597
			},
			{
				"x": 0.482497,
				"y": 0.193897
			},
			{
				"x": 0.492684,
				"y": 0.192949
			},
			{
				"x": 0.502914,
				"y": 0.192779
			},
			{
				"x": 0.513127,
				"y": 0.193396
			},
			{
				"x": 0.523265,
				"y": 0.194775
			},
			{
				"x": 0.533276,
				"y": 0.196895
			},
			{
				"x": 0.543104,
				"y": 0.199746
			},
			{
				"x": 0.552692,
				"y": 0.203323
			},
			{
				"x": 0.561977,
				"y": 0.207629
			},
			{
				"x": 0.570883,
				"y": 0.212674
			},
			{
				"x": 0.579319,
				"y": 0.218473
			},
			{
				"x": 0.58717,
				"y": 0.225044
			},
			{
				"x": 0.594292,
				"y": 0.2324
			},
			{
				"x": 0.600498,
				"y": 0.240545
			},
			{
				"x": 0.605552,
				"y": 0.249451
			},
			{
				"x": 0.609172,
				"y": 0.25903
			},
			{
				"x": 0.605349,
				"y": 0.2601
			},
			{
				"x": 0.596354,
				"y": 0.255216
			},
			{
				"x": 0.587004,
				"y": 0.251052
			},
			{
				"x": 0.577426,
				"y": 0.247444
			},
			{
				"x": 0.567685,
				"y": 0.244303
			},
			{
				"x": 0.55782,
				"y": 0.241577
			},
			{
				"x": 0.547856,
				"y": 0.239242
			},
			{
				"x": 0.53781,
				"y": 0.23729
			},
			{
				"x": 0.527696,
				"y": 0.235727
			},
			{
				"x": 0.517527,
				"y": 0.234581
			},
			{
				"x": 0.507317,
				"y": 0.2339
			},
			{
				"x": 0.497086,
				"y": 0.23377
			},
			{
				"x": 0.486863,
				"y": 0.234227
			},
			{
				"x": 0.476675,
				"y": 0.235181
			},
			{
				"x": 0.466536,
				"y": 0.236568
			},
			{
				"x": 0.456459,
				"y": 0.238355
			},
			{
				"x": 0.446458,
				"y": 0.240525
			},
			{
				"x": 0.436547,
				"y": 0.24308
			},
			{
				"x": 0.426749,
				"y": 0.246038
			},
			{
				"x": 0.417095,
				"y": 0.249437
			},
			{
				"x": 0.407636,
				"y": 0.253347
			},
			{
				"x": 0.398466,
				"y": 0.257894
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"relaxed": {
		"lb": [
			{
				"x": 0.826179,
				"y": 0.632958
			},
			{
				"x": 0.818519,
				"y": 0.639386
			},
			{
				"x": 0.810591,
				"y": 0.645481
			},
			{
				"x": 0.802412,
				"y": 0.651231
			},
			{
				"x": 0.793995,
				"y": 0.656626
			},
			{
				"x": 0.785355,
				"y": 0.661655
			},
			{
				"x": 0.776509,
				"y": 0.666311
			},
			{
				"x": 0.767473,
				"y": 0.670584
			},
			{
				"x": 0.758263,
				"y": 0.674466
			},
			{
				"x": 0.748896,
				"y": 0.677951
			},
			{
				"x": 0.739389,
				"y": 0.681032
			},
			{
				"x": 0.72976,
				"y": 0.683704
			},
			{
				"x": 0.720025,
				"y": 0.685961
			},
			{
				"x": 0.710203,
				"y": 0.6878
			},
			{
				"x": 0.700312,
				"y": 0.689217
			},
			{
				"x": 0.690369,
				"y": 0.690209
			},
			{
				"x": 0.680393,
				"y": 0.690775
			},
			{
				"x": 0.670402,
				"y": 0.690914
			},
			{
				"x": 0.660415,
				"y": 0.690625
			},
			{
				"x": 0.650448,
				"y": 0.68991
			},
			{
				"x": 0.640522,
				"y": 0.688768
			},
			{
				"x": 0.630653,
				"y": 0.687204
			},
			{
				"x": 0.620859,
				"y": 0.685218
			},
			{
				"x": 0.611228,
				"y": 0.682857
			},
			{
				"x": 0.618124,
				"y": 0.690099
			},
			{
				"x": 0.625575,
				"y": 0.696767
			},
			{
				"x": 0.633532,
				"y": 0.702819
			},
			{
				"x": 0.641945,
				"y": 0.708218
			},
			{
				"x": 0.65076,
				"y": 0.712927
			},
			{
				"x": 0.659921,
				"y": 0.716919
			},
			{
				"x": 0.669371,
				"y": 0.720166
			},
			{
				"x": 0.679049,
				"y": 0.722649
			},
			{
				"x": 0.688893,
				"y": 0.724352
			},
			{
				"x": 0.698841,
				"y": 0.725264
			},
			{
				"x": 0.708831,
				"y": 0.72538
			},
			{
				"x": 0.718797,
				"y": 0.724697
			},
			{
				"x": 0.728678,
				"y": 0.723222
			},
			{
				"x": 0.73841,
				"y": 0.720963
			},
			{
				"x": 0.747932,
				"y": 0.717934
			},
			{
				"x": 0.757183,
				"y": 0.714155
			},
			{
				"x": 0.766104,
				"y": 0.70965
			},
			{
				"x": 0.774638,
				"y": 0.704447
			},
			{
				"x": 0.782732,
				"y": 0.69858
			},
			{
				"x": 0.790334,
				"y": 0.692086
			},
			{
				"x": 0.797396,
				"y": 0.685005
			},
			{
				"x": 0.803872,
				"y": 0.677384
			},
			{
				"x": 0.809722,
				"y": 0.66927
			},
			{
				"x": 0.814908,
				"y": 0.660714
			},
			{
				"x": 0.819398,
				"y": 0.651773
			},
			{
				"x": 0.823163,
				"y": 0.642501
			}
		],
		"rb": [
			{
				"x": 0.173821,
				"y": 0.632958
			},
			{
				"x": 0.181481,
				"y": 0.639386
			},
			{
				"x": 0.189409,
				"y": 0.645481
			},
			{
				"x": 0.197588,
				"y": 0.651231
			},
			{
				"x": 0.206005,
				"y": 0.656626
			},
			{
				"x": 0.214645,
				"y": 0.661655
			},
			{
				"x": 0.223491,
				"y": 0.666311
			},
			{
				"x": 0.232527,
				"y": 0.670584
			},
			{
				"x": 0.241737,
				"y": 0.674466
			},
			{
				"x": 0.251104,
				"y": 0.677951
			},
			{
				"x": 0.260611,
				"y": 0.681032
			},
			{
				"x": 0.27024,
				"y": 0.683704
			},
			{
				"x": 0.279975,
				"y": 0.685961
			},
			{
				"x": 0.289797,
				"y": 0.6878
			},
			{
				"x": 0.299688,
				"y": 0.689217
			},
			{
				"x": 0.309631,
				"y": 0.690209
			},
			{
				"x": 0.319607,
				"y": 0.690775
			},
			{
				"x": 0.329598,
				"y": 0.690914
			},
			{
				"x": 0.339585,
				"y": 0.690625
			},
			{
				"x": 0.349552,
				"y": 0.68991
			},
			{
				"x": 0.359478,
				"y": 0.688768
			},
			{
				"x": 0.369347,
				"y": 0.687204
			},
			{
				"x": 0.379141,
				"y": 0.685218
			},
			{
				"x": 0.388772,
				"y": 0.682857
			},
			{
				"x": 0.381876,
				"y": 0.690099
			},
			{
				"x": 0.374425,
				"y": 0.696767
			},
			{
				"x": 0.366468,
				"y": 0.702819
			},
			{
				"x": 0.358055,
				"y": 0.708218
			},
			{
				"x": 0.34924,
				"y": 0.712927
			},
			{
				"x": 0.340079,
				"y": 0.716919
			},
			{
				"x": 0.330629,
				"y": 0.720166
			},
			{
				"x": 0.320951,
				"y": 0.722649
			},
			{
				"x": 0.311107,
				"y": 0.724352
			},
			{
				"x": 0.301159,
				"y": 0.725264
			},
			{
				"x": 0.291169,
				"y": 0.72538
			},
			{
				"x": 0.281203,
				"y": 0.724697
			},
			{
				"x": 0.271322,
				"y": 0.723222
			},
			{
				"x": 0.26159,
				"y": 0.720963
			},
			{
				"x": 0.252068,
				"y": 0.717934
			},
			{
				"x": 0.242817,
				"y": 0.714155
			},
			{
				"x": 0.233896,
				"y": 0.70965
			},
			{
				"x": 0.225362,
				"y": 0.704447
			},
			{
				"x": 0.217268,
				"y": 0.69858
			},
			{
				"x": 0.209666,
				"y": 0.692086
			},
			{
				"x": 0.202604,
				"y": 0.685005
			},
			{
				"x": 0.196128,
				"y": 0.677384
			},
			{
				"x": 0.190278,
				"y": 0.66927
			},
			{
				"x": 0.185092,
				"y": 0.660714
			},
			{
				"x": 0.180602,
				"y": 0.651773
			},
			{
				"x": 0.176837,
				"y": 0.642501
			}
		],
		"le": [
			{
				"x": 0.762083,
				"y": 0.481681
			},
			{
				"x": 0.754616,
				"y": 0.486573
			},
			{
				"x": 0.746893,
				"y": 0.491049
			},
			{
				"x": 0.738951,
				"y": 0.495122
			},
			{
				"x": 0.730823,
				"y": 0.498809
			},
			{
				"x": 0.722538,
				"y": 0.502124
			},
			{
				"x": 0.714119,
				"y": 0.505085
			},
			{
				"x": 0.705589,
				"y": 0.507703
			},
			{
				"x": 0.696964,
				"y": 0.509995
			},
			{
				"x": 0.688263,
				"y": 0.511972
			},
			{
				"x": 0.679499,
				"y": 0.513645
			},
			{
				"x": 0.670683,
				"y": 0.515027
			},
			{
				"x": 0.661829,
				"y": 0.516126
			},
			{
				"x": 0.652945,
				"y": 0.516952
			},
			{
				"x": 0.64404,
				"y": 0.517514
			},
			{
				"x": 0.635123,
				"y": 0.517817
			},
			{
				"x": 0.626201,
				"y": 0.517871
			},
			{
				"x": 0.61728,
				"y": 0.517679
			},
			{
				"x": 0.608368,
				"y": 0.517248
			},
			{
				"x": 0.599471,
				"y": 0.516582
			},
			{
				"x": 0.590593,
				"y": 0.515686
			},
			{
				"x": 0.581741,
				"y": 0.514562
			},
			{
				"x": 0.572921,
				"y": 0.513215
			},
			{
				"x": 0.564787,
				"y": 0.512129
			},
			{
				"x": 0.569635,
				"y": 0.519622
			},
			{
				"x": 0.57562,
				"y": 0.526241
			},
			{
				"x": 0.582493,
				"y": 0.531931
			},
			{
				"x": 0.590028,
				"y": 0.53671
			},
			{
				"x": 0.598042,
				"y": 0.540631
			},
			{
				"x": 0.606395,
				"y": 0.543767
			},
			{
				"x": 0.614981,
				"y": 0.546189
			},
			{
				"x": 0.623725,
				"y": 0.547962
			},
			{
				"x": 0.632568,
				"y": 0.549145
			},
			{
				"x": 0.641466,
				"y": 0.549786
			},
			{
				"x": 0.650386,
				"y": 0.549927
			},
			{
				"x": 0.659302,
				"y": 0.549603
			},
			{
				"x": 0.668187,
				"y": 0.548792
			},
			{
				"x": 0.677025,
				"y": 0.547569
			},
			{
				"x": 0.685801,
				"y": 0.545959
			},
			{
				"x": 0.69449,
				"y": 0.54393
			},
			{
				"x": 0.703059,
				"y": 0.541442
			},
			{
				"x": 0.711466,
				"y": 0.538451
			},
			{
				"x": 0.719654,
				"y": 0.534905
			},
			{
				"x": 0.72755,
				"y": 0.530745
			},
			{
				"x": 0.735051,
				"y": 0.52591
			},
			{
				"x": 0.742022,
				"y": 0.520337
			},
			{
				"x": 0.74829,
				"y": 0.513982
			},
			{
				"x": 0.75364,
				"y": 0.506837
			},
			{
				"x": 0.757843,
				"y": 0.498962
			},
			{
				"x": 0.760695,
				"y": 0.490501
			}
		],
		"re": [
			{
				"x": 0.237917,
				"y": 0.481681
			},
			{
				"x": 0.245384,
				"y": 0.486573
			},
			{
				"x": 0.253107,
				"y": 0.491049
			},
			{
				"x": 0.261049,
				"y": 0.495122
			},
			{
				"x": 0.269177,
				"y": 0.498809
			},
			{
				"x": 0.277462,
				"y": 0.502124
			},
			{
				"x": 0.285881,
				"y": 0.505085
			},
			{
				"x": 0.294411,
				"y": 0.507703
			},
			{
				"x": 0.303036,
				"y": 0.509995
			},
			{
				"x": 0.311737,
				"y": 0.511972
			},
			{
				"x": 0.320501,
				"y": 0.513645
			},
			{
				"x": 0.329317,
				"y": 0.515027
			},
			{
				"x": 0.338171,
				"y": 0.516126
			},
			{
				"x": 0.347055,
				"y": 0.516952
			},
			{
				"x": 0.35596,
				"y": 0.517514
			},
			{
				"x": 0.364877,
				"y": 0.517817
			},
			{
				"x": 0.373799,
				"y": 0.517871
			},
			{
				"x": 0.38272,
				"y": 0.517679
			},
			{
				"x": 0.391632,
				"y": 0.517248
			},
			{
				"x": 0.400529,
				"y": 0.516582
			},
			{
				"x": 0.409407,
				"y": 0.515686
			},
			{
				"x": 0.418259,
				"y": 0.514562
			},
			{
				"x": 0.427079,
				"y": 0.513215
			},
			{
				"x": 0.435213,
				"y": 0.512129
			},
			{
				"x": 0.430365,
				"y": 0.519622
			},
			{
				"x": 0.42438,
				"y": 0.526241
			},
			{
				"x": 0.417507,
				"y": 0.531931
			},
			{
				"x": 0.409972,
				"y": 0.53671
			},
			{
				"x": 0.401958,
				"y": 0.540631
			},
			{
				"x": 0.393605,
				"y": 0.543767
			},
			{
				"x": 0.385019,
				"y": 0.546189
			},
			{
				"x": 0.376275,
				"y": 0.547962
			},
			{
				"x": 0.367432,
				"y": 0.549145
			},
			{
				"x": 0.358534,
				"y": 0.549786
			},
			{
				"x": 0.349614,
				"y": 0.549927
			},
			{
				"x": 0.340698,
				"y": 0.549603
			},
			{
				"x": 0.331813,
				"y": 0.548792
			},
			{
				"x": 0.322975,
				"y": 0.547569
			},
			{
				"x": 0.314199,
				"y": 0.545959
			},
			{
				"x": 0.30551,
				"y": 0.54393
			},
			{
				"x": 0.296941,
				"y": 0.541442
			},
			{
				"x": 0.288534,
				"y": 0.538451
			},
			{
				"x": 0.280346,
				"y": 0.534905
			},
			{
				"x": 0.27245,
				"y": 0.530745
			},
			{
				"x": 0.264949,
				"y": 0.52591
			},
			{
				"x": 0.257978,
				"y": 0.520337
			},
			{
				"x": 0.25171,
				"y": 0.513982
			},
			{
				"x": 0.24636,
				"y": 0.506837
			},
			{
				"x": 0.242157,
				"y": 0.498962
			},
			{
				"x": 0.239305,
				"y": 0.490501
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.389789,
				"y": 0.263318
			},
			{
				"x": 0.392696,
				"y": 0.2535
			},
			{
				"x": 0.39717,
				"y": 0.244289
			},
			{
				"x": 0.402912,
				"y": 0.23581
			},
			{
				"x": 0.409665,
				"y": 0.228113
			},
			{
				"x": 0.417222,
				"y": 0.221206
			},
			{
				"x": 0.425422,
				"y": 0.215077
			},
			{
				"x": 0.434138,
				"y": 0.209709
			},
			{
				"x": 0.44327,
				"y": 0.205087
			},
			{
				"x": 0.452736,
				"y": 0.201197
			},
			{
				"x": 0.462468,
				"y": 0.198033
			},
			{
				"x": 0.472407,
				"y": 0.195597
			},
			{
				"x": 0.482497,
				"y": 0.193897
			},
			{
				"x": 0.492684,
				"y": 0.192949
			},
			{
				"x": 0.502914,
				"y": 0.192779
			},
			{
				"x": 0.513127,
				"y": 0.193396
			},
			{
				"x": 0.523265,
				"y": 0.194775
			},
			{
				"x": 0.533276,
				"y": 0.196895
			},
			{
				"x": 0.543104,
				"y": 0.199746
			},
			{
				"x": 0.552692,
				"y": 0.203323
			},
			{
				"x": 0.561977,
				"y": 0.207629
			},
			{
				"x": 0.570883,
				"y": 0.212674
			},
			{
				"x": 0.579319,
				"y": 0.218473
			},
			{
				"x": 0.58717,
				"y": 0.225044
			},
			{
				"x": 0.594292,
				"y": 0.2324
			},
			{
				"x": 0.600498,
				"y": 0.240545
			},
			{
				"x": 0.605552,
				"y": 0.249451
			},
			{
				"x": 0.609172,
				"y": 0.25903
			},
			{
				"x": 0.605349,
				"y": 0.2601
			},
			{
				"x": 0.596354,
				"y": 0.255216
			},
			{
				"x": 0.587004,
				"y": 0.251052
			},
			{
				"x": 0.577426,
				"y": 0.247444
			},
			{
				"x": 0.567685,
				"y": 0.244303
			},
			{
				"x": 0.55782,
				"y": 0.241577
			},
			{
				"x": 0.547856,
				"y": 0.239242
			},
			{
				"x": 0.53781,
				"y": 0.23729
			},
			{
				"x": 0.527696,
				"y": 0.235727
			},
			{
				"x": 0.517527,
				"y": 0.234581
			},
			{
				"x": 0.507317,
				"y": 0.2339
			},
			{
				"x": 0.497086,
				"y": 0.23377
			},
			{
				"x": 0.486863,
				"y": 0.234227
			},
			{
				"x": 0.476675,
				"y": 0.235181
			},
			{
				"x": 0.466536,
				"y": 0.236568
			},
			{
				"x": 0.456459,
				"y": 0.238355
			},
			{
				"x": 0.446458,
				"y": 0.240525
			},
			{
				"x": 0.436547,
				"y": 0.24308
			},
			{
				"x": 0.426749,
				"y": 0.246038
			},
			{
				"x": 0.417095,
				"y": 0.249437
			},
			{
				"x": 0.407636,
				"y": 0.253347
			},
			{
				"x": 0.398466,
				"y": 0.257894
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"blush": {
		"lb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"rb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"le": [
			{
				"x": 0.70555,
				"y": 0.520267
			},
			{
				"x": 0.701936,
				"y": 0.529953
			},
			{
				"x": 0.696774,
				"y": 0.538911
			},
			{
				"x": 0.690373,
				"y": 0.54703
			},
			{
				"x": 0.682963,
				"y": 0.554237
			},
			{
				"x": 0.674716,
				"y": 0.560466
			},
			{
				"x": 0.665771,
				"y": 0.565638
			},
			{
				"x": 0.656253,
				"y": 0.569651
			},
			{
				"x": 0.646288,
				"y": 0.572363
			},
			{
				"x": 0.636037,
				"y": 0.573582
			},
			{
				"x": 0.625723,
				"y": 0.573137
			},
			{
				"x": 0.615594,
				"y": 0.571135
			},
			{
				"x": 0.605842,
				"y": 0.567734
			},
			{
				"x": 0.596632,
				"y": 0.563054
			},
			{
				"x": 0.588125,
				"y": 0.557189
			},
			{
				"x": 0.580497,
				"y": 0.550216
			},
			{
				"x": 0.573962,
				"y": 0.542208
			},
			{
				"x": 0.568789,
				"y": 0.533259
			},
			{
				"x": 0.565802,
				"y": 0.527088
			},
			{
				"x": 0.566119,
				"y": 0.537437
			},
			{
				"x": 0.566843,
				"y": 0.547765
			},
			{
				"x": 0.567983,
				"y": 0.558055
			},
			{
				"x": 0.569553,
				"y": 0.568289
			},
			{
				"x": 0.571573,
				"y": 0.578442
			},
			{
				"x": 0.574073,
				"y": 0.588488
			},
			{
				"x": 0.577086,
				"y": 0.598391
			},
			{
				"x": 0.580662,
				"y": 0.608104
			},
			{
				"x": 0.584861,
				"y": 0.617563
			},
			{
				"x": 0.589761,
				"y": 0.626676
			},
			{
				"x": 0.595462,
				"y": 0.635307
			},
			{
				"x": 0.602083,
				"y": 0.643248
			},
			{
				"x": 0.609751,
				"y": 0.650173
			},
			{
				"x": 0.61854,
				"y": 0.655584
			},
			{
				"x": 0.628329,
				"y": 0.658811
			},
			{
				"x": 0.638618,
				"y": 0.65925
			},
			{
				"x": 0.648629,
				"y": 0.656811
			},
			{
				"x": 0.657758,
				"y": 0.652002
			},
			{
				"x": 0.665791,
				"y": 0.645509
			},
			{
				"x": 0.672766,
				"y": 0.637879
			},
			{
				"x": 0.678799,
				"y": 0.629478
			},
			{
				"x": 0.68401,
				"y": 0.620541
			},
			{
				"x": 0.688502,
				"y": 0.611218
			},
			{
				"x": 0.692357,
				"y": 0.601613
			},
			{
				"x": 0.695638,
				"y": 0.591796
			},
			{
				"x": 0.698397,
				"y": 0.581819
			},
			{
				"x": 0.70067,
				"y": 0.571719
			},
			{
				"x": 0.702488,
				"y": 0.561527
			},
			{
				"x": 0.703872,
				"y": 0.551267
			},
			{
				"x": 0.704837,
				"y": 0.540958
			},
			{
				"x": 0.705395,
				"y": 0.53062
			}
		],
		"re": [
			{
				"x": 0.296293,
				"y": 0.52607
			},
			{
				"x": 0.299728,
				"y": 0.534177
			},
			{
				"x": 0.305049,
				"y": 0.543039
			},
			{
				"x": 0.311702,
				"y": 0.550949
			},
			{
				"x": 0.319426,
				"y": 0.557816
			},
			{
				"x": 0.328009,
				"y": 0.563568
			},
			{
				"x": 0.337279,
				"y": 0.568126
			},
			{
				"x": 0.347076,
				"y": 0.571396
			},
			{
				"x": 0.357233,
				"y": 0.573252
			},
			{
				"x": 0.367552,
				"y": 0.573535
			},
			{
				"x": 0.377784,
				"y": 0.572159
			},
			{
				"x": 0.387711,
				"y": 0.569311
			},
			{
				"x": 0.397178,
				"y": 0.565179
			},
			{
				"x": 0.40606,
				"y": 0.559899
			},
			{
				"x": 0.414231,
				"y": 0.553571
			},
			{
				"x": 0.421551,
				"y": 0.546271
			},
			{
				"x": 0.427841,
				"y": 0.538066
			},
			{
				"x": 0.432865,
				"y": 0.52903
			},
			{
				"x": 0.436052,
				"y": 0.521285
			},
			{
				"x": 0.435858,
				"y": 0.531637
			},
			{
				"x": 0.435261,
				"y": 0.541973
			},
			{
				"x": 0.434255,
				"y": 0.552278
			},
			{
				"x": 0.432829,
				"y": 0.562532
			},
			{
				"x": 0.430968,
				"y": 0.572716
			},
			{
				"x": 0.428648,
				"y": 0.582805
			},
			{
				"x": 0.42584,
				"y": 0.592769
			},
			{
				"x": 0.422504,
				"y": 0.602568
			},
			{
				"x": 0.41859,
				"y": 0.612149
			},
			{
				"x": 0.414031,
				"y": 0.621438
			},
			{
				"x": 0.408744,
				"y": 0.630331
			},
			{
				"x": 0.402624,
				"y": 0.638668
			},
			{
				"x": 0.39555,
				"y": 0.646205
			},
			{
				"x": 0.387408,
				"y": 0.65256
			},
			{
				"x": 0.378178,
				"y": 0.657167
			},
			{
				"x": 0.368106,
				"y": 0.659338
			},
			{
				"x": 0.357833,
				"y": 0.65861
			},
			{
				"x": 0.348127,
				"y": 0.655137
			},
			{
				"x": 0.339448,
				"y": 0.64955
			},
			{
				"x": 0.331888,
				"y": 0.642506
			},
			{
				"x": 0.325363,
				"y": 0.634485
			},
			{
				"x": 0.319746,
				"y": 0.625799
			},
			{
				"x": 0.314919,
				"y": 0.616647
			},
			{
				"x": 0.310784,
				"y": 0.607159
			},
			{
				"x": 0.307266,
				"y": 0.597425
			},
			{
				"x": 0.304305,
				"y": 0.587506
			},
			{
				"x": 0.301854,
				"y": 0.577448
			},
			{
				"x": 0.299879,
				"y": 0.567286
			},
			{
				"x": 0.298352,
				"y": 0.557046
			},
			{
				"x": 0.297254,
				"y": 0.546751
			},
			{
				"x": 0.29657,
				"y": 0.53642
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.312763,
				"y": 0.337119
			},
			{
				"x": 0.316114,
				"y": 0.320601
			},
			{
				"x": 0.324841,
				"y": 0.306135
			},
			{
				"x": 0.336783,
				"y": 0.29415
			},
			{
				"x": 0.350547,
				"y": 0.284296
			},
			{
				"x": 0.365396,
				"y": 0.276165
			},
			{
				"x": 0.380935,
				"y": 0.269444
			},
			{
				"x": 0.396935,
				"y": 0.26391
			},
			{
				"x": 0.413255,
				"y": 0.259408
			},
			{
				"x": 0.429801,
				"y": 0.255826
			},
			{
				"x": 0.446506,
				"y": 0.253085
			},
			{
				"x": 0.463322,
				"y": 0.251129
			},
			{
				"x": 0.480207,
				"y": 0.249922
			},
			{
				"x": 0.497129,
				"y": 0.24944
			},
			{
				"x": 0.514056,
				"y": 0.249678
			},
			{
				"x": 0.530957,
				"y": 0.250637
			},
			{
				"x": 0.5478,
				"y": 0.252336
			},
			{
				"x": 0.564548,
				"y": 0.254806
			},
			{
				"x": 0.581154,
				"y": 0.258095
			},
			{
				"x": 0.59756,
				"y": 0.262274
			},
			{
				"x": 0.613682,
				"y": 0.267443
			},
			{
				"x": 0.629397,
				"y": 0.27374
			},
			{
				"x": 0.644514,
				"y": 0.281363
			},
			{
				"x": 0.658706,
				"y": 0.290591
			},
			{
				"x": 0.671382,
				"y": 0.301804
			},
			{
				"x": 0.68141,
				"y": 0.315413
			},
			{
				"x": 0.686836,
				"y": 0.331384
			},
			{
				"x": 0.678513,
				"y": 0.330108
			},
			{
				"x": 0.664398,
				"y": 0.320752
			},
			{
				"x": 0.649564,
				"y": 0.312585
			},
			{
				"x": 0.634235,
				"y": 0.305389
			},
			{
				"x": 0.61854,
				"y": 0.299035
			},
			{
				"x": 0.602557,
				"y": 0.293448
			},
			{
				"x": 0.586338,
				"y": 0.28859
			},
			{
				"x": 0.569922,
				"y": 0.284448
			},
			{
				"x": 0.553339,
				"y": 0.28104
			},
			{
				"x": 0.536615,
				"y": 0.27841
			},
			{
				"x": 0.51978,
				"y": 0.276639
			},
			{
				"x": 0.502871,
				"y": 0.275864
			},
			{
				"x": 0.485949,
				"y": 0.276255
			},
			{
				"x": 0.469084,
				"y": 0.277707
			},
			{
				"x": 0.452319,
				"y": 0.280058
			},
			{
				"x": 0.435686,
				"y": 0.283209
			},
			{
				"x": 0.41921,
				"y": 0.287104
			},
			{
				"x": 0.40292,
				"y": 0.29172
			},
			{
				"x": 0.386852,
				"y": 0.297057
			},
			{
				"x": 0.371052,
				"y": 0.303144
			},
			{
				"x": 0.355588,
				"y": 0.310044
			},
			{
				"x": 0.340567,
				"y": 0.317862
			},
			{
				"x": 0.326173,
				"y": 0.326782
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"yum": {
		"lb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"rb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"le": [
			{
				"x": 0.76752,
				"y": 0.514546
			},
			{
				"x": 0.762982,
				"y": 0.526706
			},
			{
				"x": 0.756502,
				"y": 0.537953
			},
			{
				"x": 0.748466,
				"y": 0.548146
			},
			{
				"x": 0.739163,
				"y": 0.557194
			},
			{
				"x": 0.728809,
				"y": 0.565014
			},
			{
				"x": 0.717579,
				"y": 0.571508
			},
			{
				"x": 0.705629,
				"y": 0.576546
			},
			{
				"x": 0.693118,
				"y": 0.579951
			},
			{
				"x": 0.680248,
				"y": 0.581482
			},
			{
				"x": 0.6673,
				"y": 0.580923
			},
			{
				"x": 0.654582,
				"y": 0.578409
			},
			{
				"x": 0.642339,
				"y": 0.574139
			},
			{
				"x": 0.630776,
				"y": 0.568263
			},
			{
				"x": 0.620095,
				"y": 0.560901
			},
			{
				"x": 0.610519,
				"y": 0.552146
			},
			{
				"x": 0.602314,
				"y": 0.542093
			},
			{
				"x": 0.595819,
				"y": 0.530857
			},
			{
				"x": 0.592069,
				"y": 0.523109
			},
			{
				"x": 0.592468,
				"y": 0.536102
			},
			{
				"x": 0.593377,
				"y": 0.549069
			},
			{
				"x": 0.594807,
				"y": 0.561988
			},
			{
				"x": 0.596778,
				"y": 0.574836
			},
			{
				"x": 0.599315,
				"y": 0.587584
			},
			{
				"x": 0.602453,
				"y": 0.600196
			},
			{
				"x": 0.606237,
				"y": 0.612629
			},
			{
				"x": 0.610726,
				"y": 0.624823
			},
			{
				"x": 0.615998,
				"y": 0.636699
			},
			{
				"x": 0.62215,
				"y": 0.64814
			},
			{
				"x": 0.629307,
				"y": 0.658976
			},
			{
				"x": 0.63762,
				"y": 0.668946
			},
			{
				"x": 0.647246,
				"y": 0.67764
			},
			{
				"x": 0.658281,
				"y": 0.684433
			},
			{
				"x": 0.670571,
				"y": 0.688484
			},
			{
				"x": 0.683489,
				"y": 0.689036
			},
			{
				"x": 0.696057,
				"y": 0.685974
			},
			{
				"x": 0.707518,
				"y": 0.679937
			},
			{
				"x": 0.717604,
				"y": 0.671785
			},
			{
				"x": 0.726361,
				"y": 0.662206
			},
			{
				"x": 0.733934,
				"y": 0.651658
			},
			{
				"x": 0.740477,
				"y": 0.640437
			},
			{
				"x": 0.746116,
				"y": 0.628733
			},
			{
				"x": 0.750956,
				"y": 0.616674
			},
			{
				"x": 0.755076,
				"y": 0.604349
			},
			{
				"x": 0.758539,
				"y": 0.591822
			},
			{
				"x": 0.761394,
				"y": 0.579142
			},
			{
				"x": 0.763676,
				"y": 0.566347
			},
			{
				"x": 0.765413,
				"y": 0.553465
			},
			{
				"x": 0.766625,
				"y": 0.540523
			},
			{
				"x": 0.767325,
				"y": 0.527543
			}
		],
		"re": [
			{
				"x": 0.22635,
				"y": 0.521831
			},
			{
				"x": 0.230663,
				"y": 0.532009
			},
			{
				"x": 0.237343,
				"y": 0.543136
			},
			{
				"x": 0.245697,
				"y": 0.553066
			},
			{
				"x": 0.255393,
				"y": 0.561688
			},
			{
				"x": 0.266169,
				"y": 0.568909
			},
			{
				"x": 0.277808,
				"y": 0.574632
			},
			{
				"x": 0.290107,
				"y": 0.578737
			},
			{
				"x": 0.302859,
				"y": 0.581068
			},
			{
				"x": 0.315814,
				"y": 0.581422
			},
			{
				"x": 0.32866,
				"y": 0.579695
			},
			{
				"x": 0.341123,
				"y": 0.57612
			},
			{
				"x": 0.35301,
				"y": 0.570932
			},
			{
				"x": 0.364161,
				"y": 0.564302
			},
			{
				"x": 0.37442,
				"y": 0.556358
			},
			{
				"x": 0.383609,
				"y": 0.547193
			},
			{
				"x": 0.391506,
				"y": 0.536892
			},
			{
				"x": 0.397814,
				"y": 0.525548
			},
			{
				"x": 0.401815,
				"y": 0.515824
			},
			{
				"x": 0.401571,
				"y": 0.52882
			},
			{
				"x": 0.400821,
				"y": 0.541797
			},
			{
				"x": 0.399558,
				"y": 0.554734
			},
			{
				"x": 0.397768,
				"y": 0.567609
			},
			{
				"x": 0.395431,
				"y": 0.580395
			},
			{
				"x": 0.392519,
				"y": 0.593061
			},
			{
				"x": 0.388994,
				"y": 0.60557
			},
			{
				"x": 0.384806,
				"y": 0.617872
			},
			{
				"x": 0.379891,
				"y": 0.629901
			},
			{
				"x": 0.374168,
				"y": 0.641564
			},
			{
				"x": 0.36753,
				"y": 0.652729
			},
			{
				"x": 0.359847,
				"y": 0.663196
			},
			{
				"x": 0.350966,
				"y": 0.672659
			},
			{
				"x": 0.340744,
				"y": 0.680637
			},
			{
				"x": 0.329155,
				"y": 0.686421
			},
			{
				"x": 0.316511,
				"y": 0.689147
			},
			{
				"x": 0.303613,
				"y": 0.688232
			},
			{
				"x": 0.291427,
				"y": 0.683872
			},
			{
				"x": 0.280531,
				"y": 0.676858
			},
			{
				"x": 0.271039,
				"y": 0.668014
			},
			{
				"x": 0.262847,
				"y": 0.657944
			},
			{
				"x": 0.255795,
				"y": 0.647038
			},
			{
				"x": 0.249735,
				"y": 0.635548
			},
			{
				"x": 0.244544,
				"y": 0.623637
			},
			{
				"x": 0.240127,
				"y": 0.611416
			},
			{
				"x": 0.236409,
				"y": 0.598963
			},
			{
				"x": 0.233332,
				"y": 0.586336
			},
			{
				"x": 0.230852,
				"y": 0.573577
			},
			{
				"x": 0.228936,
				"y": 0.560721
			},
			{
				"x": 0.227557,
				"y": 0.547796
			},
			{
				"x": 0.226699,
				"y": 0.534825
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.183352,
				"y": 0.429053
			},
			{
				"x": 0.186006,
				"y": 0.393968
			},
			{
				"x": 0.193861,
				"y": 0.359673
			},
			{
				"x": 0.206616,
				"y": 0.326887
			},
			{
				"x": 0.223826,
				"y": 0.29621
			},
			{
				"x": 0.244963,
				"y": 0.268102
			},
			{
				"x": 0.269472,
				"y": 0.242887
			},
			{
				"x": 0.296808,
				"y": 0.22078
			},
			{
				"x": 0.326464,
				"y": 0.201908
			},
			{
				"x": 0.357976,
				"y": 0.186343
			},
			{
				"x": 0.390924,
				"y": 0.174116
			},
			{
				"x": 0.424924,
				"y": 0.165239
			},
			{
				"x": 0.459624,
				"y": 0.159713
			},
			{
				"x": 0.494693,
				"y": 0.157534
			},
			{
				"x": 0.529809,
				"y": 0.158702
			},
			{
				"x": 0.564655,
				"y": 0.163217
			},
			{
				"x": 0.598903,
				"y": 0.171082
			},
			{
				"x": 0.632207,
				"y": 0.182298
			},
			{
				"x": 0.664194,
				"y": 0.196857
			},
			{
				"x": 0.694458,
				"y": 0.214736
			},
			{
				"x": 0.722547,
				"y": 0.235876
			},
			{
				"x": 0.747965,
				"y": 0.26017
			},
			{
				"x": 0.770179,
				"y": 0.287434
			},
			{
				"x": 0.788633,
				"y": 0.317377
			},
			{
				"x": 0.802785,
				"y": 0.349582
			},
			{
				"x": 0.81216,
				"y": 0.383493
			},
			{
				"x": 0.816405,
				"y": 0.41842
			},
			{
				"x": 0.808187,
				"y": 0.405986
			},
			{
				"x": 0.792774,
				"y": 0.374356
			},
			{
				"x": 0.773935,
				"y": 0.344643
			},
			{
				"x": 0.752091,
				"y": 0.31707
			},
			{
				"x": 0.727595,
				"y": 0.291834
			},
			{
				"x": 0.700744,
				"y": 0.269127
			},
			{
				"x": 0.671806,
				"y": 0.249162
			},
			{
				"x": 0.641028,
				"y": 0.232183
			},
			{
				"x": 0.608666,
				"y": 0.218481
			},
			{
				"x": 0.575004,
				"y": 0.208408
			},
			{
				"x": 0.540395,
				"y": 0.202388
			},
			{
				"x": 0.505303,
				"y": 0.200917
			},
			{
				"x": 0.470178,
				"y": 0.20144
			},
			{
				"x": 0.435367,
				"y": 0.206142
			},
			{
				"x": 0.401378,
				"y": 0.215039
			},
			{
				"x": 0.368591,
				"y": 0.227684
			},
			{
				"x": 0.337307,
				"y": 0.243707
			},
			{
				"x": 0.307786,
				"y": 0.262798
			},
			{
				"x": 0.280279,
				"y": 0.2847
			},
			{
				"x": 0.255042,
				"y": 0.309194
			},
			{
				"x": 0.232362,
				"y": 0.336081
			},
			{
				"x": 0.212575,
				"y": 0.365169
			},
			{
				"x": 0.196078,
				"y": 0.396247
			}
		],
		"tongue": [
			{
				"x": 0.687874,
				"y": 0.236452
			},
			{
				"x": 0.699666,
				"y": 0.225437
			},
			{
				"x": 0.711679,
				"y": 0.214665
			},
			{
				"x": 0.723942,
				"y": 0.204179
			},
			{
				"x": 0.736487,
				"y": 0.194034
			},
			{
				"x": 0.749351,
				"y": 0.184299
			},
			{
				"x": 0.762578,
				"y": 0.175065
			},
			{
				"x": 0.776214,
				"y": 0.166452
			},
			{
				"x": 0.790307,
				"y": 0.158613
			},
			{
				"x": 0.804894,
				"y": 0.151742
			},
			{
				"x": 0.819981,
				"y": 0.146063
			},
			{
				"x": 0.835521,
				"y": 0.141787
			},
			{
				"x": 0.851396,
				"y": 0.139005
			},
			{
				"x": 0.867463,
				"y": 0.13777
			},
			{
				"x": 0.883559,
				"y": 0.138441
			},
			{
				"x": 0.899375,
				"y": 0.141481
			},
			{
				"x": 0.914379,
				"y": 0.147318
			},
			{
				"x": 0.927855,
				"y": 0.156126
			},
			{
				"x": 0.939123,
				"y": 0.167635
			},
			{
				"x": 0.94768,
				"y": 0.18129
			},
			{
				"x": 0.953382,
				"y": 0.196375
			},
			{
				"x": 0.956473,
				"y": 0.212213
			},
			{
				"x": 0.957372,
				"y": 0.228331
			},
			{
				"x": 0.956502,
				"y": 0.244455
			},
			{
				"x": 0.954066,
				"y": 0.260415
			},
			{
				"x": 0.949719,
				"y": 0.275958
			},
			{
				"x": 0.943372,
				"y": 0.290795
			},
			{
				"x": 0.935258,
				"y": 0.304743
			},
			{
				"x": 0.92572,
				"y": 0.317759
			},
			{
				"x": 0.915083,
				"y": 0.329892
			},
			{
				"x": 0.903606,
				"y": 0.341232
			},
			{
				"x": 0.891484,
				"y": 0.351878
			},
			{
				"x": 0.878858,
				"y": 0.361921
			},
			{
				"x": 0.865834,
				"y": 0.371439
			},
			{
				"x": 0.852488,
				"y": 0.380501
			},
			{
				"x": 0.83888,
				"y": 0.389161
			},
			{
				"x": 0.825054,
				"y": 0.397468
			},
			{
				"x": 0.812899,
				"y": 0.400722
			},
			{
				"x": 0.807386,
				"y": 0.385544
			},
			{
				"x": 0.801029,
				"y": 0.370702
			},
			{
				"x": 0.793881,
				"y": 0.356225
			},
			{
				"x": 0.785991,
				"y": 0.34214
			},
			{
				"x": 0.777404,
				"y": 0.328471
			},
			{
				"x": 0.768159,
				"y": 0.315239
			},
			{
				"x": 0.758296,
				"y": 0.302463
			},
			{
				"x": 0.747847,
				"y": 0.290164
			},
			{
				"x": 0.736845,
				"y": 0.278358
			},
			{
				"x": 0.72532,
				"y": 0.267065
			},
			{
				"x": 0.713299,
				"y": 0.256303
			},
			{
				"x": 0.700809,
				"y": 0.246091
			}
		]
	},
	"relieved": {
		"lb": [
			{
				"x": 0.816256,
				"y": 0.581522
			},
			{
				"x": 0.810211,
				"y": 0.589101
			},
			{
				"x": 0.80391,
				"y": 0.596467
			},
			{
				"x": 0.797364,
				"y": 0.603616
			},
			{
				"x": 0.790584,
				"y": 0.610542
			},
			{
				"x": 0.78358,
				"y": 0.617241
			},
			{
				"x": 0.776363,
				"y": 0.623708
			},
			{
				"x": 0.768941,
				"y": 0.629939
			},
			{
				"x": 0.761324,
				"y": 0.635928
			},
			{
				"x": 0.75352,
				"y": 0.641671
			},
			{
				"x": 0.745538,
				"y": 0.647163
			},
			{
				"x": 0.737386,
				"y": 0.652398
			},
			{
				"x": 0.729072,
				"y": 0.657371
			},
			{
				"x": 0.720604,
				"y": 0.662074
			},
			{
				"x": 0.711989,
				"y": 0.666503
			},
			{
				"x": 0.703236,
				"y": 0.67065
			},
			{
				"x": 0.694352,
				"y": 0.674508
			},
			{
				"x": 0.685345,
				"y": 0.678069
			},
			{
				"x": 0.676224,
				"y": 0.681326
			},
			{
				"x": 0.666998,
				"y": 0.684268
			},
			{
				"x": 0.657675,
				"y": 0.686887
			},
			{
				"x": 0.648265,
				"y": 0.689173
			},
			{
				"x": 0.638779,
				"y": 0.691116
			},
			{
				"x": 0.629227,
				"y": 0.692704
			},
			{
				"x": 0.631408,
				"y": 0.695876
			},
			{
				"x": 0.640428,
				"y": 0.699397
			},
			{
				"x": 0.649722,
				"y": 0.702106
			},
			{
				"x": 0.659213,
				"y": 0.704016
			},
			{
				"x": 0.668827,
				"y": 0.705146
			},
			{
				"x": 0.678501,
				"y": 0.705518
			},
			{
				"x": 0.688175,
				"y": 0.705156
			},
			{
				"x": 0.697796,
				"y": 0.704087
			},
			{
				"x": 0.707318,
				"y": 0.702336
			},
			{
				"x": 0.716696,
				"y": 0.699927
			},
			{
				"x": 0.725889,
				"y": 0.696886
			},
			{
				"x": 0.734859,
				"y": 0.693236
			},
			{
				"x": 0.743568,
				"y": 0.688999
			},
			{
				"x": 0.75198,
				"y": 0.684197
			},
			{
				"x": 0.760059,
				"y": 0.678853
			},
			{
				"x": 0.767769,
				"y": 0.672986
			},
			{
				"x": 0.775072,
				"y": 0.666618
			},
			{
				"x": 0.781929,
				"y": 0.659771
			},
			{
				"x": 0.788301,
				"y": 0.652468
			},
			{
				"x": 0.794144,
				"y": 0.644734
			},
			{
				"x": 0.799414,
				"y": 0.636597
			},
			{
				"x": 0.804064,
				"y": 0.62809
			},
			{
				"x": 0.808044,
				"y": 0.619248
			},
			{
				"x": 0.811305,
				"y": 0.610115
			},
			{
				"x": 0.813793,
				"y": 0.600742
			},
			{
				"x": 0.815459,
				"y": 0.591188
			}
		],
		"rb": [
			{
				"x": 0.183744,
				"y": 0.581522
			},
			{
				"x": 0.189789,
				"y": 0.589101
			},
			{
				"x": 0.19609,
				"y": 0.596467
			},
			{
				"x": 0.202636,
				"y": 0.603616
			},
			{
				"x": 0.209416,
				"y": 0.610542
			},
			{
				"x": 0.21642,
				"y": 0.617241
			},
			{
				"x": 0.223637,
				"y": 0.623708
			},
			{
				"x": 0.231059,
				"y": 0.629939
			},
			{
				"x": 0.238676,
				"y": 0.635928
			},
			{
				"x": 0.24648,
				"y": 0.641671
			},
			{
				"x": 0.254462,
				"y": 0.647163
			},
			{
				"x": 0.262614,
				"y": 0.652398
			},
			{
				"x": 0.270928,
				"y": 0.657371
			},
			{
				"x": 0.279396,
				"y": 0.662074
			},
			{
				"x": 0.288011,
				"y": 0.666503
			},
			{
				"x": 0.296764,
				"y": 0.67065
			},
			{
				"x": 0.305648,
				"y": 0.674508
			},
			{
				"x": 0.314655,
				"y": 0.678069
			},
			{
				"x": 0.323776,
				"y": 0.681326
			},
			{
				"x": 0.333002,
				"y": 0.684268
			},
			{
				"x": 0.342325,
				"y": 0.686887
			},
			{
				"x": 0.351735,
				"y": 0.689173
			},
			{
				"x": 0.361221,
				"y": 0.691116
			},
			{
				"x": 0.370773,
				"y": 0.692704
			},
			{
				"x": 0.368592,
				"y": 0.695876
			},
			{
				"x": 0.359572,
				"y": 0.699397
			},
			{
				"x": 0.350278,
				"y": 0.702106
			},
			{
				"x": 0.340787,
				"y": 0.704016
			},
			{
				"x": 0.331173,
				"y": 0.705146
			},
			{
				"x": 0.321499,
				"y": 0.705518
			},
			{
				"x": 0.311825,
				"y": 0.705156
			},
			{
				"x": 0.302204,
				"y": 0.704087
			},
			{
				"x": 0.292682,
				"y": 0.702336
			},
			{
				"x": 0.283304,
				"y": 0.699927
			},
			{
				"x": 0.274111,
				"y": 0.696886
			},
			{
				"x": 0.265141,
				"y": 0.693236
			},
			{
				"x": 0.256432,
				"y": 0.688999
			},
			{
				"x": 0.24802,
				"y": 0.684197
			},
			{
				"x": 0.239941,
				"y": 0.678853
			},
			{
				"x": 0.232231,
				"y": 0.672986
			},
			{
				"x": 0.224928,
				"y": 0.666618
			},
			{
				"x": 0.218071,
				"y": 0.659771
			},
			{
				"x": 0.211699,
				"y": 0.652468
			},
			{
				"x": 0.205856,
				"y": 0.644734
			},
			{
				"x": 0.200586,
				"y": 0.636597
			},
			{
				"x": 0.195936,
				"y": 0.62809
			},
			{
				"x": 0.191956,
				"y": 0.619248
			},
			{
				"x": 0.188695,
				"y": 0.610115
			},
			{
				"x": 0.186207,
				"y": 0.600742
			},
			{
				"x": 0.184541,
				"y": 0.591188
			}
		],
		"le": [
			{
				"x": 0.820635,
				"y": 0.529788
			},
			{
				"x": 0.819225,
				"y": 0.517397
			},
			{
				"x": 0.815436,
				"y": 0.505515
			},
			{
				"x": 0.809586,
				"y": 0.4945
			},
			{
				"x": 0.802064,
				"y": 0.484552
			},
			{
				"x": 0.793237,
				"y": 0.475741
			},
			{
				"x": 0.783411,
				"y": 0.468062
			},
			{
				"x": 0.772826,
				"y": 0.461471
			},
			{
				"x": 0.761664,
				"y": 0.455914
			},
			{
				"x": 0.750067,
				"y": 0.451335
			},
			{
				"x": 0.738146,
				"y": 0.447686
			},
			{
				"x": 0.725989,
				"y": 0.444928
			},
			{
				"x": 0.713668,
				"y": 0.443029
			},
			{
				"x": 0.701248,
				"y": 0.441967
			},
			{
				"x": 0.688784,
				"y": 0.44173
			},
			{
				"x": 0.676332,
				"y": 0.442312
			},
			{
				"x": 0.663946,
				"y": 0.443717
			},
			{
				"x": 0.651682,
				"y": 0.445957
			},
			{
				"x": 0.639606,
				"y": 0.449053
			},
			{
				"x": 0.627791,
				"y": 0.453034
			},
			{
				"x": 0.616328,
				"y": 0.457939
			},
			{
				"x": 0.605329,
				"y": 0.463812
			},
			{
				"x": 0.594938,
				"y": 0.470706
			},
			{
				"x": 0.585341,
				"y": 0.478671
			},
			{
				"x": 0.576782,
				"y": 0.487743
			},
			{
				"x": 0.569568,
				"y": 0.497917
			},
			{
				"x": 0.564067,
				"y": 0.509111
			},
			{
				"x": 0.560661,
				"y": 0.521109
			},
			{
				"x": 0.559935,
				"y": 0.532712
			},
			{
				"x": 0.569394,
				"y": 0.524652
			},
			{
				"x": 0.58036,
				"y": 0.518729
			},
			{
				"x": 0.591912,
				"y": 0.514038
			},
			{
				"x": 0.603774,
				"y": 0.510197
			},
			{
				"x": 0.615829,
				"y": 0.507015
			},
			{
				"x": 0.628016,
				"y": 0.504382
			},
			{
				"x": 0.640298,
				"y": 0.502236
			},
			{
				"x": 0.65265,
				"y": 0.500541
			},
			{
				"x": 0.665053,
				"y": 0.499279
			},
			{
				"x": 0.677493,
				"y": 0.498449
			},
			{
				"x": 0.689954,
				"y": 0.498068
			},
			{
				"x": 0.702421,
				"y": 0.498152
			},
			{
				"x": 0.714877,
				"y": 0.498685
			},
			{
				"x": 0.727307,
				"y": 0.49965
			},
			{
				"x": 0.739696,
				"y": 0.50105
			},
			{
				"x": 0.752025,
				"y": 0.502903
			},
			{
				"x": 0.764271,
				"y": 0.505247
			},
			{
				"x": 0.776397,
				"y": 0.508147
			},
			{
				"x": 0.788343,
				"y": 0.511716
			},
			{
				"x": 0.799994,
				"y": 0.516152
			},
			{
				"x": 0.811075,
				"y": 0.521855
			}
		],
		"re": [
			{
				"x": 0.179365,
				"y": 0.529788
			},
			{
				"x": 0.180775,
				"y": 0.517397
			},
			{
				"x": 0.184564,
				"y": 0.505515
			},
			{
				"x": 0.190414,
				"y": 0.4945
			},
			{
				"x": 0.197936,
				"y": 0.484552
			},
			{
				"x": 0.206763,
				"y": 0.475741
			},
			{
				"x": 0.216589,
				"y": 0.468062
			},
			{
				"x": 0.227174,
				"y": 0.461471
			},
			{
				"x": 0.238336,
				"y": 0.455914
			},
			{
				"x": 0.249933,
				"y": 0.451335
			},
			{
				"x": 0.261854,
				"y": 0.447686
			},
			{
				"x": 0.274011,
				"y": 0.444928
			},
			{
				"x": 0.286332,
				"y": 0.443029
			},
			{
				"x": 0.298752,
				"y": 0.441967
			},
			{
				"x": 0.311216,
				"y": 0.44173
			},
			{
				"x": 0.323668,
				"y": 0.442312
			},
			{
				"x": 0.336054,
				"y": 0.443717
			},
			{
				"x": 0.348318,
				"y": 0.445957
			},
			{
				"x": 0.360394,
				"y": 0.449053
			},
			{
				"x": 0.372209,
				"y": 0.453034
			},
			{
				"x": 0.383672,
				"y": 0.457939
			},
			{
				"x": 0.394671,
				"y": 0.463812
			},
			{
				"x": 0.405062,
				"y": 0.470706
			},
			{
				"x": 0.414659,
				"y": 0.478671
			},
			{
				"x": 0.423218,
				"y": 0.487743
			},
			{
				"x": 0.430432,
				"y": 0.497917
			},
			{
				"x": 0.435933,
				"y": 0.509111
			},
			{
				"x": 0.439339,
				"y": 0.521109
			},
			{
				"x": 0.440065,
				"y": 0.532712
			},
			{
				"x": 0.430606,
				"y": 0.524652
			},
			{
				"x": 0.41964,
				"y": 0.518729
			},
			{
				"x": 0.408088,
				"y": 0.514038
			},
			{
				"x": 0.396226,
				"y": 0.510197
			},
			{
				"x": 0.384171,
				"y": 0.507015
			},
			{
				"x": 0.371984,
				"y": 0.504382
			},
			{
				"x": 0.359702,
				"y": 0.502236
			},
			{
				"x": 0.34735,
				"y": 0.500541
			},
			{
				"x": 0.334947,
				"y": 0.499279
			},
			{
				"x": 0.322507,
				"y": 0.498449
			},
			{
				"x": 0.310046,
				"y": 0.498068
			},
			{
				"x": 0.297579,
				"y": 0.498152
			},
			{
				"x": 0.285123,
				"y": 0.498685
			},
			{
				"x": 0.272693,
				"y": 0.49965
			},
			{
				"x": 0.260304,
				"y": 0.50105
			},
			{
				"x": 0.247975,
				"y": 0.502903
			},
			{
				"x": 0.235729,
				"y": 0.505247
			},
			{
				"x": 0.223603,
				"y": 0.508147
			},
			{
				"x": 0.211657,
				"y": 0.511716
			},
			{
				"x": 0.200006,
				"y": 0.516152
			},
			{
				"x": 0.188925,
				"y": 0.521855
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.389789,
				"y": 0.263318
			},
			{
				"x": 0.392696,
				"y": 0.2535
			},
			{
				"x": 0.39717,
				"y": 0.244289
			},
			{
				"x": 0.402912,
				"y": 0.23581
			},
			{
				"x": 0.409665,
				"y": 0.228113
			},
			{
				"x": 0.417222,
				"y": 0.221206
			},
			{
				"x": 0.425422,
				"y": 0.215077
			},
			{
				"x": 0.434138,
				"y": 0.209709
			},
			{
				"x": 0.44327,
				"y": 0.205087
			},
			{
				"x": 0.452736,
				"y": 0.201197
			},
			{
				"x": 0.462468,
				"y": 0.198033
			},
			{
				"x": 0.472407,
				"y": 0.195597
			},
			{
				"x": 0.482497,
				"y": 0.193897
			},
			{
				"x": 0.492684,
				"y": 0.192949
			},
			{
				"x": 0.502914,
				"y": 0.192779
			},
			{
				"x": 0.513127,
				"y": 0.193396
			},
			{
				"x": 0.523265,
				"y": 0.194775
			},
			{
				"x": 0.533276,
				"y": 0.196895
			},
			{
				"x": 0.543104,
				"y": 0.199746
			},
			{
				"x": 0.552692,
				"y": 0.203323
			},
			{
				"x": 0.561977,
				"y": 0.207629
			},
			{
				"x": 0.570883,
				"y": 0.212674
			},
			{
				"x": 0.579319,
				"y": 0.218473
			},
			{
				"x": 0.58717,
				"y": 0.225044
			},
			{
				"x": 0.594292,
				"y": 0.2324
			},
			{
				"x": 0.600498,
				"y": 0.240545
			},
			{
				"x": 0.605552,
				"y": 0.249451
			},
			{
				"x": 0.609172,
				"y": 0.25903
			},
			{
				"x": 0.605349,
				"y": 0.2601
			},
			{
				"x": 0.596354,
				"y": 0.255216
			},
			{
				"x": 0.587004,
				"y": 0.251052
			},
			{
				"x": 0.577426,
				"y": 0.247444
			},
			{
				"x": 0.567685,
				"y": 0.244303
			},
			{
				"x": 0.55782,
				"y": 0.241577
			},
			{
				"x": 0.547856,
				"y": 0.239242
			},
			{
				"x": 0.53781,
				"y": 0.23729
			},
			{
				"x": 0.527696,
				"y": 0.235727
			},
			{
				"x": 0.517527,
				"y": 0.234581
			},
			{
				"x": 0.507317,
				"y": 0.2339
			},
			{
				"x": 0.497086,
				"y": 0.23377
			},
			{
				"x": 0.486863,
				"y": 0.234227
			},
			{
				"x": 0.476675,
				"y": 0.235181
			},
			{
				"x": 0.466536,
				"y": 0.236568
			},
			{
				"x": 0.456459,
				"y": 0.238355
			},
			{
				"x": 0.446458,
				"y": 0.240525
			},
			{
				"x": 0.436547,
				"y": 0.24308
			},
			{
				"x": 0.426749,
				"y": 0.246038
			},
			{
				"x": 0.417095,
				"y": 0.249437
			},
			{
				"x": 0.407636,
				"y": 0.253347
			},
			{
				"x": 0.398466,
				"y": 0.257894
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"heart_eyes": {
		"lb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"rb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"le": [
			{
				"x": 0.672226,
				"y": 0.438536
			},
			{
				"x": 0.664207,
				"y": 0.455345
			},
			{
				"x": 0.656188,
				"y": 0.472153
			},
			{
				"x": 0.648169,
				"y": 0.488962
			},
			{
				"x": 0.64015,
				"y": 0.50577
			},
			{
				"x": 0.632131,
				"y": 0.522579
			},
			{
				"x": 0.624112,
				"y": 0.539387
			},
			{
				"x": 0.616094,
				"y": 0.556196
			},
			{
				"x": 0.608075,
				"y": 0.573004
			},
			{
				"x": 0.600056,
				"y": 0.589813
			},
			{
				"x": 0.591966,
				"y": 0.606583
			},
			{
				"x": 0.586944,
				"y": 0.624468
			},
			{
				"x": 0.58662,
				"y": 0.643044
			},
			{
				"x": 0.591016,
				"y": 0.661093
			},
			{
				"x": 0.599843,
				"y": 0.677432
			},
			{
				"x": 0.612522,
				"y": 0.690989
			},
			{
				"x": 0.628222,
				"y": 0.700875
			},
			{
				"x": 0.645913,
				"y": 0.706441
			},
			{
				"x": 0.664434,
				"y": 0.707322
			},
			{
				"x": 0.682572,
				"y": 0.703461
			},
			{
				"x": 0.699136,
				"y": 0.69511
			},
			{
				"x": 0.71304,
				"y": 0.682818
			},
			{
				"x": 0.723372,
				"y": 0.667391
			},
			{
				"x": 0.729455,
				"y": 0.64984
			},
			{
				"x": 0.73089,
				"y": 0.631317
			},
			{
				"x": 0.727582,
				"y": 0.613036
			},
			{
				"x": 0.735415,
				"y": 0.629876
			},
			{
				"x": 0.747261,
				"y": 0.64417
			},
			{
				"x": 0.762341,
				"y": 0.65498
			},
			{
				"x": 0.779667,
				"y": 0.661599
			},
			{
				"x": 0.798102,
				"y": 0.663591
			},
			{
				"x": 0.816438,
				"y": 0.660827
			},
			{
				"x": 0.833472,
				"y": 0.653486
			},
			{
				"x": 0.848087,
				"y": 0.642052
			},
			{
				"x": 0.859324,
				"y": 0.627273
			},
			{
				"x": 0.866446,
				"y": 0.610119
			},
			{
				"x": 0.868986,
				"y": 0.591715
			},
			{
				"x": 0.866778,
				"y": 0.573268
			},
			{
				"x": 0.859966,
				"y": 0.555988
			},
			{
				"x": 0.848998,
				"y": 0.541008
			},
			{
				"x": 0.834592,
				"y": 0.529311
			},
			{
				"x": 0.818323,
				"y": 0.520299
			},
			{
				"x": 0.80209,
				"y": 0.511214
			},
			{
				"x": 0.785857,
				"y": 0.502129
			},
			{
				"x": 0.769624,
				"y": 0.493044
			},
			{
				"x": 0.753391,
				"y": 0.48396
			},
			{
				"x": 0.737158,
				"y": 0.474875
			},
			{
				"x": 0.720925,
				"y": 0.46579
			},
			{
				"x": 0.704692,
				"y": 0.456705
			},
			{
				"x": 0.688459,
				"y": 0.447621
			}
		],
		"re": [
			{
				"x": 0.327774,
				"y": 0.438536
			},
			{
				"x": 0.335793,
				"y": 0.455345
			},
			{
				"x": 0.343812,
				"y": 0.472153
			},
			{
				"x": 0.351831,
				"y": 0.488962
			},
			{
				"x": 0.35985,
				"y": 0.50577
			},
			{
				"x": 0.367869,
				"y": 0.522579
			},
			{
				"x": 0.375888,
				"y": 0.539387
			},
			{
				"x": 0.383906,
				"y": 0.556196
			},
			{
				"x": 0.391925,
				"y": 0.573004
			},
			{
				"x": 0.399944,
				"y": 0.589813
			},
			{
				"x": 0.408034,
				"y": 0.606583
			},
			{
				"x": 0.413056,
				"y": 0.624468
			},
			{
				"x": 0.41338,
				"y": 0.643044
			},
			{
				"x": 0.408984,
				"y": 0.661093
			},
			{
				"x": 0.400157,
				"y": 0.677432
			},
			{
				"x": 0.387478,
				"y": 0.690989
			},
			{
				"x": 0.371778,
				"y": 0.700875
			},
			{
				"x": 0.354087,
				"y": 0.706441
			},
			{
				"x": 0.335566,
				"y": 0.707322
			},
			{
				"x": 0.317428,
				"y": 0.703461
			},
			{
				"x": 0.300864,
				"y": 0.69511
			},
			{
				"x": 0.28696,
				"y": 0.682818
			},
			{
				"x": 0.276628,
				"y": 0.667391
			},
			{
				"x": 0.270545,
				"y": 0.64984
			},
			{
				"x": 0.26911,
				"y": 0.631317
			},
			{
				"x": 0.272418,
				"y": 0.613036
			},
			{
				"x": 0.264585,
				"y": 0.629876
			},
			{
				"x": 0.252739,
				"y": 0.64417
			},
			{
				"x": 0.237659,
				"y": 0.65498
			},
			{
				"x": 0.220333,
				"y": 0.661599
			},
			{
				"x": 0.201898,
				"y": 0.663591
			},
			{
				"x": 0.183562,
				"y": 0.660827
			},
			{
				"x": 0.166528,
				"y": 0.653486
			},
			{
				"x": 0.151913,
				"y": 0.642052
			},
			{
				"x": 0.140676,
				"y": 0.627273
			},
			{
				"x": 0.133554,
				"y": 0.610119
			},
			{
				"x": 0.131014,
				"y": 0.591715
			},
			{
				"x": 0.133222,
				"y": 0.573268
			},
			{
				"x": 0.140034,
				"y": 0.555988
			},
			{
				"x": 0.151002,
				"y": 0.541008
			},
			{
				"x": 0.165408,
				"y": 0.529311
			},
			{
				"x": 0.181677,
				"y": 0.520299
			},
			{
				"x": 0.19791,
				"y": 0.511214
			},
			{
				"x": 0.214143,
				"y": 0.502129
			},
			{
				"x": 0.230376,
				"y": 0.493044
			},
			{
				"x": 0.246609,
				"y": 0.48396
			},
			{
				"x": 0.262842,
				"y": 0.474875
			},
			{
				"x": 0.279075,
				"y": 0.46579
			},
			{
				"x": 0.295308,
				"y": 0.456705
			},
			{
				"x": 0.311541,
				"y": 0.447621
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.265699,
				"y": 0.30606
			},
			{
				"x": 0.267619,
				"y": 0.283761
			},
			{
				"x": 0.273253,
				"y": 0.262101
			},
			{
				"x": 0.282259,
				"y": 0.241614
			},
			{
				"x": 0.294174,
				"y": 0.222672
			},
			{
				"x": 0.308511,
				"y": 0.205492
			},
			{
				"x": 0.324814,
				"y": 0.19017
			},
			{
				"x": 0.342691,
				"y": 0.176722
			},
			{
				"x": 0.361816,
				"y": 0.165121
			},
			{
				"x": 0.38192,
				"y": 0.155321
			},
			{
				"x": 0.402785,
				"y": 0.147269
			},
			{
				"x": 0.424226,
				"y": 0.140916
			},
			{
				"x": 0.446089,
				"y": 0.13622
			},
			{
				"x": 0.468237,
				"y": 0.133149
			},
			{
				"x": 0.490549,
				"y": 0.13168
			},
			{
				"x": 0.512909,
				"y": 0.131803
			},
			{
				"x": 0.535203,
				"y": 0.133519
			},
			{
				"x": 0.557316,
				"y": 0.13684
			},
			{
				"x": 0.579123,
				"y": 0.14179
			},
			{
				"x": 0.600486,
				"y": 0.148403
			},
			{
				"x": 0.621245,
				"y": 0.156722
			},
			{
				"x": 0.641214,
				"y": 0.166797
			},
			{
				"x": 0.660164,
				"y": 0.178681
			},
			{
				"x": 0.677821,
				"y": 0.192418
			},
			{
				"x": 0.693847,
				"y": 0.20803
			},
			{
				"x": 0.70784,
				"y": 0.225491
			},
			{
				"x": 0.719337,
				"y": 0.24469
			},
			{
				"x": 0.72785,
				"y": 0.265388
			},
			{
				"x": 0.732927,
				"y": 0.287185
			},
			{
				"x": 0.730994,
				"y": 0.30504
			},
			{
				"x": 0.709336,
				"y": 0.299469
			},
			{
				"x": 0.687415,
				"y": 0.295033
			},
			{
				"x": 0.665359,
				"y": 0.291331
			},
			{
				"x": 0.643215,
				"y": 0.288188
			},
			{
				"x": 0.621011,
				"y": 0.285516
			},
			{
				"x": 0.598759,
				"y": 0.283268
			},
			{
				"x": 0.57647,
				"y": 0.281425
			},
			{
				"x": 0.554152,
				"y": 0.279988
			},
			{
				"x": 0.53181,
				"y": 0.278982
			},
			{
				"x": 0.509452,
				"y": 0.278458
			},
			{
				"x": 0.487088,
				"y": 0.278504
			},
			{
				"x": 0.464732,
				"y": 0.279108
			},
			{
				"x": 0.442393,
				"y": 0.280183
			},
			{
				"x": 0.420079,
				"y": 0.281684
			},
			{
				"x": 0.397795,
				"y": 0.283589
			},
			{
				"x": 0.37555,
				"y": 0.285901
			},
			{
				"x": 0.353354,
				"y": 0.288642
			},
			{
				"x": 0.331222,
				"y": 0.291864
			},
			{
				"x": 0.309182,
				"y": 0.295665
			},
			{
				"x": 0.287291,
				"y": 0.300241
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"kissing_heart": {
		"lb": [
			{
				"x": 0.792978,
				"y": 0.575503
			},
			{
				"x": 0.785437,
				"y": 0.581931
			},
			{
				"x": 0.777634,
				"y": 0.588026
			},
			{
				"x": 0.769582,
				"y": 0.593776
			},
			{
				"x": 0.761296,
				"y": 0.599171
			},
			{
				"x": 0.752791,
				"y": 0.6042
			},
			{
				"x": 0.744084,
				"y": 0.608856
			},
			{
				"x": 0.735188,
				"y": 0.613129
			},
			{
				"x": 0.726122,
				"y": 0.617011
			},
			{
				"x": 0.716901,
				"y": 0.620496
			},
			{
				"x": 0.707543,
				"y": 0.623577
			},
			{
				"x": 0.698063,
				"y": 0.626249
			},
			{
				"x": 0.68848,
				"y": 0.628506
			},
			{
				"x": 0.678812,
				"y": 0.630345
			},
			{
				"x": 0.669075,
				"y": 0.631762
			},
			{
				"x": 0.659287,
				"y": 0.632754
			},
			{
				"x": 0.649467,
				"y": 0.63332
			},
			{
				"x": 0.639632,
				"y": 0.633459
			},
			{
				"x": 0.6298,
				"y": 0.633171
			},
			{
				"x": 0.619989,
				"y": 0.632455
			},
			{
				"x": 0.610217,
				"y": 0.631314
			},
			{
				"x": 0.600502,
				"y": 0.629749
			},
			{
				"x": 0.590861,
				"y": 0.627763
			},
			{
				"x": 0.58138,
				"y": 0.625403
			},
			{
				"x": 0.588169,
				"y": 0.632644
			},
			{
				"x": 0.595503,
				"y": 0.639312
			},
			{
				"x": 0.603336,
				"y": 0.645365
			},
			{
				"x": 0.611618,
				"y": 0.650763
			},
			{
				"x": 0.620295,
				"y": 0.655472
			},
			{
				"x": 0.629314,
				"y": 0.659464
			},
			{
				"x": 0.638616,
				"y": 0.662711
			},
			{
				"x": 0.648143,
				"y": 0.665195
			},
			{
				"x": 0.657834,
				"y": 0.666898
			},
			{
				"x": 0.667627,
				"y": 0.66781
			},
			{
				"x": 0.67746,
				"y": 0.667925
			},
			{
				"x": 0.687272,
				"y": 0.667243
			},
			{
				"x": 0.696999,
				"y": 0.665767
			},
			{
				"x": 0.706579,
				"y": 0.663508
			},
			{
				"x": 0.715952,
				"y": 0.660479
			},
			{
				"x": 0.725059,
				"y": 0.6567
			},
			{
				"x": 0.73384,
				"y": 0.652195
			},
			{
				"x": 0.742242,
				"y": 0.646992
			},
			{
				"x": 0.750209,
				"y": 0.641125
			},
			{
				"x": 0.757693,
				"y": 0.634631
			},
			{
				"x": 0.764644,
				"y": 0.62755
			},
			{
				"x": 0.771019,
				"y": 0.619929
			},
			{
				"x": 0.776778,
				"y": 0.611815
			},
			{
				"x": 0.781883,
				"y": 0.603259
			},
			{
				"x": 0.786303,
				"y": 0.594318
			},
			{
				"x": 0.790009,
				"y": 0.585046
			}
		],
		"rb": [
			{
				"x": 0.169696,
				"y": 0.621506
			},
			{
				"x": 0.173778,
				"y": 0.630615
			},
			{
				"x": 0.178238,
				"y": 0.639538
			},
			{
				"x": 0.183068,
				"y": 0.648259
			},
			{
				"x": 0.18826,
				"y": 0.656762
			},
			{
				"x": 0.193804,
				"y": 0.665032
			},
			{
				"x": 0.19969,
				"y": 0.673054
			},
			{
				"x": 0.205906,
				"y": 0.680812
			},
			{
				"x": 0.212443,
				"y": 0.688293
			},
			{
				"x": 0.219287,
				"y": 0.695484
			},
			{
				"x": 0.226427,
				"y": 0.70237
			},
			{
				"x": 0.233849,
				"y": 0.70894
			},
			{
				"x": 0.24154,
				"y": 0.715181
			},
			{
				"x": 0.249486,
				"y": 0.721082
			},
			{
				"x": 0.257671,
				"y": 0.726633
			},
			{
				"x": 0.266083,
				"y": 0.731823
			},
			{
				"x": 0.274704,
				"y": 0.736642
			},
			{
				"x": 0.28352,
				"y": 0.741083
			},
			{
				"x": 0.292513,
				"y": 0.745136
			},
			{
				"x": 0.301669,
				"y": 0.748795
			},
			{
				"x": 0.31097,
				"y": 0.752053
			},
			{
				"x": 0.320399,
				"y": 0.754903
			},
			{
				"x": 0.329939,
				"y": 0.757341
			},
			{
				"x": 0.338803,
				"y": 0.759448
			},
			{
				"x": 0.329595,
				"y": 0.762961
			},
			{
				"x": 0.32014,
				"y": 0.765716
			},
			{
				"x": 0.310501,
				"y": 0.767697
			},
			{
				"x": 0.300736,
				"y": 0.768889
			},
			{
				"x": 0.29091,
				"y": 0.769286
			},
			{
				"x": 0.281084,
				"y": 0.768886
			},
			{
				"x": 0.27132,
				"y": 0.76769
			},
			{
				"x": 0.261681,
				"y": 0.765706
			},
			{
				"x": 0.252228,
				"y": 0.762948
			},
			{
				"x": 0.24302,
				"y": 0.759431
			},
			{
				"x": 0.234117,
				"y": 0.75518
			},
			{
				"x": 0.225575,
				"y": 0.75022
			},
			{
				"x": 0.217448,
				"y": 0.744584
			},
			{
				"x": 0.209788,
				"y": 0.738307
			},
			{
				"x": 0.202643,
				"y": 0.731428
			},
			{
				"x": 0.19606,
				"y": 0.723993
			},
			{
				"x": 0.190079,
				"y": 0.716047
			},
			{
				"x": 0.184738,
				"y": 0.707642
			},
			{
				"x": 0.180073,
				"y": 0.69883
			},
			{
				"x": 0.176112,
				"y": 0.689668
			},
			{
				"x": 0.17288,
				"y": 0.680215
			},
			{
				"x": 0.170398,
				"y": 0.670529
			},
			{
				"x": 0.168682,
				"y": 0.660673
			},
			{
				"x": 0.167742,
				"y": 0.650709
			},
			{
				"x": 0.167585,
				"y": 0.6407
			},
			{
				"x": 0.168212,
				"y": 0.630711
			}
		],
		"le": [
			{
				"x": 0.72066,
				"y": 0.485829
			},
			{
				"x": 0.713831,
				"y": 0.48962
			},
			{
				"x": 0.706809,
				"y": 0.493025
			},
			{
				"x": 0.699624,
				"y": 0.496059
			},
			{
				"x": 0.692305,
				"y": 0.498738
			},
			{
				"x": 0.684874,
				"y": 0.501079
			},
			{
				"x": 0.677352,
				"y": 0.503097
			},
			{
				"x": 0.669756,
				"y": 0.504805
			},
			{
				"x": 0.662102,
				"y": 0.506217
			},
			{
				"x": 0.654403,
				"y": 0.507347
			},
			{
				"x": 0.64667,
				"y": 0.508204
			},
			{
				"x": 0.638913,
				"y": 0.5088
			},
			{
				"x": 0.631142,
				"y": 0.509143
			},
			{
				"x": 0.623363,
				"y": 0.509244
			},
			{
				"x": 0.615585,
				"y": 0.509109
			},
			{
				"x": 0.607815,
				"y": 0.508746
			},
			{
				"x": 0.600057,
				"y": 0.508162
			},
			{
				"x": 0.592318,
				"y": 0.507361
			},
			{
				"x": 0.584602,
				"y": 0.50635
			},
			{
				"x": 0.576916,
				"y": 0.505132
			},
			{
				"x": 0.569263,
				"y": 0.503713
			},
			{
				"x": 0.561648,
				"y": 0.502095
			},
			{
				"x": 0.554076,
				"y": 0.500281
			},
			{
				"x": 0.547082,
				"y": 0.498746
			},
			{
				"x": 0.550776,
				"y": 0.505704
			},
			{
				"x": 0.555517,
				"y": 0.511971
			},
			{
				"x": 0.561096,
				"y": 0.517482
			},
			{
				"x": 0.567313,
				"y": 0.522233
			},
			{
				"x": 0.574005,
				"y": 0.526263
			},
			{
				"x": 0.581047,
				"y": 0.529623
			},
			{
				"x": 0.588341,
				"y": 0.532368
			},
			{
				"x": 0.595817,
				"y": 0.534553
			},
			{
				"x": 0.60342,
				"y": 0.536223
			},
			{
				"x": 0.611109,
				"y": 0.537419
			},
			{
				"x": 0.618851,
				"y": 0.538175
			},
			{
				"x": 0.626622,
				"y": 0.53852
			},
			{
				"x": 0.6344,
				"y": 0.538433
			},
			{
				"x": 0.642166,
				"y": 0.537978
			},
			{
				"x": 0.649905,
				"y": 0.537178
			},
			{
				"x": 0.657597,
				"y": 0.536001
			},
			{
				"x": 0.665216,
				"y": 0.534412
			},
			{
				"x": 0.67273,
				"y": 0.532366
			},
			{
				"x": 0.680093,
				"y": 0.529815
			},
			{
				"x": 0.687243,
				"y": 0.526702
			},
			{
				"x": 0.694098,
				"y": 0.522964
			},
			{
				"x": 0.700543,
				"y": 0.518537
			},
			{
				"x": 0.706431,
				"y": 0.513371
			},
			{
				"x": 0.711577,
				"y": 0.507441
			},
			{
				"x": 0.715776,
				"y": 0.500786
			},
			{
				"x": 0.718842,
				"y": 0.493519
			}
		],
		"re": [
			{
				"x": 0.297895,
				"y": 0.540559
			},
			{
				"x": 0.298216,
				"y": 0.533238
			},
			{
				"x": 0.299181,
				"y": 0.525976
			},
			{
				"x": 0.300796,
				"y": 0.518834
			},
			{
				"x": 0.303069,
				"y": 0.511881
			},
			{
				"x": 0.306014,
				"y": 0.505195
			},
			{
				"x": 0.30964,
				"y": 0.498865
			},
			{
				"x": 0.313954,
				"y": 0.493
			},
			{
				"x": 0.318952,
				"y": 0.48773
			},
			{
				"x": 0.32461,
				"y": 0.483204
			},
			{
				"x": 0.330868,
				"y": 0.479591
			},
			{
				"x": 0.337618,
				"y": 0.477058
			},
			{
				"x": 0.344695,
				"y": 0.47575
			},
			{
				"x": 0.351887,
				"y": 0.47575
			},
			{
				"x": 0.358964,
				"y": 0.477058
			},
			{
				"x": 0.365714,
				"y": 0.479591
			},
			{
				"x": 0.371972,
				"y": 0.483204
			},
			{
				"x": 0.37763,
				"y": 0.48773
			},
			{
				"x": 0.382629,
				"y": 0.493
			},
			{
				"x": 0.386943,
				"y": 0.498865
			},
			{
				"x": 0.390569,
				"y": 0.505195
			},
			{
				"x": 0.393513,
				"y": 0.511881
			},
			{
				"x": 0.395787,
				"y": 0.518834
			},
			{
				"x": 0.397401,
				"y": 0.525976
			},
			{
				"x": 0.398366,
				"y": 0.533238
			},
			{
				"x": 0.398687,
				"y": 0.540559
			},
			{
				"x": 0.398366,
				"y": 0.54788
			},
			{
				"x": 0.397401,
				"y": 0.555142
			},
			{
				"x": 0.395787,
				"y": 0.562283
			},
			{
				"x": 0.393513,
				"y": 0.569236
			},
			{
				"x": 0.390569,
				"y": 0.575923
			},
			{
				"x": 0.386943,
				"y": 0.582253
			},
			{
				"x": 0.382629,
				"y": 0.588117
			},
			{
				"x": 0.37763,
				"y": 0.593388
			},
			{
				"x": 0.371972,
				"y": 0.597913
			},
			{
				"x": 0.365714,
				"y": 0.601527
			},
			{
				"x": 0.358964,
				"y": 0.60406
			},
			{
				"x": 0.351887,
				"y": 0.605368
			},
			{
				"x": 0.344695,
				"y": 0.605368
			},
			{
				"x": 0.337618,
				"y": 0.60406
			},
			{
				"x": 0.330868,
				"y": 0.601527
			},
			{
				"x": 0.32461,
				"y": 0.597913
			},
			{
				"x": 0.318952,
				"y": 0.593388
			},
			{
				"x": 0.313954,
				"y": 0.588117
			},
			{
				"x": 0.30964,
				"y": 0.582253
			},
			{
				"x": 0.306014,
				"y": 0.575923
			},
			{
				"x": 0.303069,
				"y": 0.569236
			},
			{
				"x": 0.300796,
				"y": 0.562283
			},
			{
				"x": 0.299181,
				"y": 0.555142
			},
			{
				"x": 0.298216,
				"y": 0.54788
			}
		],
		"head": [
			{
				"x": 0.984402,
				"y": 0.5
			},
			{
				"x": 0.980521,
				"y": 0.562791
			},
			{
				"x": 0.968939,
				"y": 0.624591
			},
			{
				"x": 0.949838,
				"y": 0.684426
			},
			{
				"x": 0.92352,
				"y": 0.741353
			},
			{
				"x": 0.8904,
				"y": 0.794474
			},
			{
				"x": 0.851,
				"y": 0.84295
			},
			{
				"x": 0.805942,
				"y": 0.886018
			},
			{
				"x": 0.755935,
				"y": 0.922999
			},
			{
				"x": 0.70177,
				"y": 0.953308
			},
			{
				"x": 0.644299,
				"y": 0.976468
			},
			{
				"x": 0.58443,
				"y": 0.992115
			},
			{
				"x": 0.523107,
				"y": 1
			},
			{
				"x": 0.461295,
				"y": 1
			},
			{
				"x": 0.399972,
				"y": 0.992115
			},
			{
				"x": 0.340103,
				"y": 0.976468
			},
			{
				"x": 0.282632,
				"y": 0.953308
			},
			{
				"x": 0.228467,
				"y": 0.922999
			},
			{
				"x": 0.17846,
				"y": 0.886018
			},
			{
				"x": 0.133402,
				"y": 0.84295
			},
			{
				"x": 0.094002,
				"y": 0.794474
			},
			{
				"x": 0.060882,
				"y": 0.741353
			},
			{
				"x": 0.034564,
				"y": 0.684426
			},
			{
				"x": 0.015463,
				"y": 0.624591
			},
			{
				"x": 0.003881,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003881,
				"y": 0.437209
			},
			{
				"x": 0.015463,
				"y": 0.375409
			},
			{
				"x": 0.034564,
				"y": 0.315574
			},
			{
				"x": 0.060882,
				"y": 0.258647
			},
			{
				"x": 0.094002,
				"y": 0.205526
			},
			{
				"x": 0.133402,
				"y": 0.15705
			},
			{
				"x": 0.17846,
				"y": 0.113982
			},
			{
				"x": 0.228467,
				"y": 0.077001
			},
			{
				"x": 0.282632,
				"y": 0.046692
			},
			{
				"x": 0.340103,
				"y": 0.023532
			},
			{
				"x": 0.399972,
				"y": 0.007885
			},
			{
				"x": 0.461295,
				"y": 0
			},
			{
				"x": 0.523107,
				"y": 3.4834e-10
			},
			{
				"x": 0.58443,
				"y": 0.007885
			},
			{
				"x": 0.644299,
				"y": 0.023532
			},
			{
				"x": 0.70177,
				"y": 0.046692
			},
			{
				"x": 0.755936,
				"y": 0.077001
			},
			{
				"x": 0.805942,
				"y": 0.113982
			},
			{
				"x": 0.851,
				"y": 0.15705
			},
			{
				"x": 0.8904,
				"y": 0.205526
			},
			{
				"x": 0.92352,
				"y": 0.258647
			},
			{
				"x": 0.949838,
				"y": 0.315574
			},
			{
				"x": 0.968939,
				"y": 0.375409
			},
			{
				"x": 0.980521,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.490188,
				"y": 0.161438
			},
			{
				"x": 0.509546,
				"y": 0.160552
			},
			{
				"x": 0.529335,
				"y": 0.163971
			},
			{
				"x": 0.548916,
				"y": 0.168475
			},
			{
				"x": 0.568299,
				"y": 0.173794
			},
			{
				"x": 0.587421,
				"y": 0.180009
			},
			{
				"x": 0.606089,
				"y": 0.187509
			},
			{
				"x": 0.623495,
				"y": 0.1976
			},
			{
				"x": 0.628147,
				"y": 0.214639
			},
			{
				"x": 0.611223,
				"y": 0.225401
			},
			{
				"x": 0.592625,
				"y": 0.233086
			},
			{
				"x": 0.573792,
				"y": 0.240164
			},
			{
				"x": 0.555109,
				"y": 0.247636
			},
			{
				"x": 0.537394,
				"y": 0.257168
			},
			{
				"x": 0.533871,
				"y": 0.274059
			},
			{
				"x": 0.550055,
				"y": 0.286005
			},
			{
				"x": 0.567937,
				"y": 0.295286
			},
			{
				"x": 0.586118,
				"y": 0.303954
			},
			{
				"x": 0.604141,
				"y": 0.312951
			},
			{
				"x": 0.621035,
				"y": 0.323913
			},
			{
				"x": 0.623359,
				"y": 0.341466
			},
			{
				"x": 0.606482,
				"y": 0.352281
			},
			{
				"x": 0.587592,
				"y": 0.359166
			},
			{
				"x": 0.568182,
				"y": 0.364369
			},
			{
				"x": 0.548519,
				"y": 0.368486
			},
			{
				"x": 0.528692,
				"y": 0.371683
			},
			{
				"x": 0.508729,
				"y": 0.373819
			},
			{
				"x": 0.490906,
				"y": 0.371809
			},
			{
				"x": 0.510015,
				"y": 0.365757
			},
			{
				"x": 0.529547,
				"y": 0.361033
			},
			{
				"x": 0.549011,
				"y": 0.356026
			},
			{
				"x": 0.568242,
				"y": 0.35017
			},
			{
				"x": 0.586705,
				"y": 0.34222
			},
			{
				"x": 0.594053,
				"y": 0.326525
			},
			{
				"x": 0.577703,
				"y": 0.314882
			},
			{
				"x": 0.559557,
				"y": 0.306147
			},
			{
				"x": 0.541156,
				"y": 0.297975
			},
			{
				"x": 0.52291,
				"y": 0.289456
			},
			{
				"x": 0.50559,
				"y": 0.279179
			},
			{
				"x": 0.500789,
				"y": 0.262399
			},
			{
				"x": 0.517529,
				"y": 0.251334
			},
			{
				"x": 0.536007,
				"y": 0.243356
			},
			{
				"x": 0.554739,
				"y": 0.236005
			},
			{
				"x": 0.573264,
				"y": 0.228139
			},
			{
				"x": 0.589864,
				"y": 0.216957
			},
			{
				"x": 0.582107,
				"y": 0.200801
			},
			{
				"x": 0.56426,
				"y": 0.191498
			},
			{
				"x": 0.545543,
				"y": 0.184115
			},
			{
				"x": 0.526564,
				"y": 0.177455
			},
			{
				"x": 0.507569,
				"y": 0.170839
			}
		],
		"tongue": [
			{
				"x": 0.860802,
				"y": 0.299823
			},
			{
				"x": 0.864058,
				"y": 0.318104
			},
			{
				"x": 0.862646,
				"y": 0.336627
			},
			{
				"x": 0.856658,
				"y": 0.354178
			},
			{
				"x": 0.846486,
				"y": 0.369606
			},
			{
				"x": 0.832799,
				"y": 0.381897
			},
			{
				"x": 0.816494,
				"y": 0.390248
			},
			{
				"x": 0.798639,
				"y": 0.394109
			},
			{
				"x": 0.780406,
				"y": 0.393228
			},
			{
				"x": 0.762991,
				"y": 0.387662
			},
			{
				"x": 0.747536,
				"y": 0.377776
			},
			{
				"x": 0.735055,
				"y": 0.36422
			},
			{
				"x": 0.726366,
				"y": 0.347881
			},
			{
				"x": 0.722039,
				"y": 0.329831
			},
			{
				"x": 0.722357,
				"y": 0.311255
			},
			{
				"x": 0.727301,
				"y": 0.29337
			},
			{
				"x": 0.735264,
				"y": 0.2766
			},
			{
				"x": 0.743158,
				"y": 0.259792
			},
			{
				"x": 0.751052,
				"y": 0.242983
			},
			{
				"x": 0.758946,
				"y": 0.226174
			},
			{
				"x": 0.76684,
				"y": 0.209366
			},
			{
				"x": 0.774734,
				"y": 0.192557
			},
			{
				"x": 0.782628,
				"y": 0.175749
			},
			{
				"x": 0.790521,
				"y": 0.15894
			},
			{
				"x": 0.798415,
				"y": 0.142132
			},
			{
				"x": 0.806309,
				"y": 0.125323
			},
			{
				"x": 0.822289,
				"y": 0.134408
			},
			{
				"x": 0.838269,
				"y": 0.143493
			},
			{
				"x": 0.854248,
				"y": 0.152577
			},
			{
				"x": 0.870228,
				"y": 0.161662
			},
			{
				"x": 0.886208,
				"y": 0.170747
			},
			{
				"x": 0.902188,
				"y": 0.179832
			},
			{
				"x": 0.918168,
				"y": 0.188916
			},
			{
				"x": 0.934147,
				"y": 0.198001
			},
			{
				"x": 0.950127,
				"y": 0.207086
			},
			{
				"x": 0.966142,
				"y": 0.216098
			},
			{
				"x": 0.980323,
				"y": 0.227795
			},
			{
				"x": 0.991121,
				"y": 0.242775
			},
			{
				"x": 0.997826,
				"y": 0.260055
			},
			{
				"x": 1,
				"y": 0.278502
			},
			{
				"x": 0.997499,
				"y": 0.296906
			},
			{
				"x": 0.990488,
				"y": 0.31406
			},
			{
				"x": 0.979427,
				"y": 0.328839
			},
			{
				"x": 0.96504,
				"y": 0.340273
			},
			{
				"x": 0.948272,
				"y": 0.347614
			},
			{
				"x": 0.930222,
				"y": 0.350378
			},
			{
				"x": 0.912074,
				"y": 0.348386
			},
			{
				"x": 0.895018,
				"y": 0.341767
			},
			{
				"x": 0.880173,
				"y": 0.330957
			},
			{
				"x": 0.868513,
				"y": 0.316663
			}
		]
	},
	"kissing": {
		"lb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"rb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"le": [
			{
				"x": 0.708191,
				"y": 0.6214
			},
			{
				"x": 0.707865,
				"y": 0.614079
			},
			{
				"x": 0.706885,
				"y": 0.606817
			},
			{
				"x": 0.705245,
				"y": 0.599675
			},
			{
				"x": 0.702935,
				"y": 0.592722
			},
			{
				"x": 0.699944,
				"y": 0.586036
			},
			{
				"x": 0.696261,
				"y": 0.579706
			},
			{
				"x": 0.691878,
				"y": 0.573841
			},
			{
				"x": 0.6868,
				"y": 0.568571
			},
			{
				"x": 0.681053,
				"y": 0.564045
			},
			{
				"x": 0.674695,
				"y": 0.560432
			},
			{
				"x": 0.667839,
				"y": 0.557899
			},
			{
				"x": 0.66065,
				"y": 0.556591
			},
			{
				"x": 0.653343,
				"y": 0.556591
			},
			{
				"x": 0.646154,
				"y": 0.557899
			},
			{
				"x": 0.639298,
				"y": 0.560432
			},
			{
				"x": 0.632941,
				"y": 0.564045
			},
			{
				"x": 0.627193,
				"y": 0.568571
			},
			{
				"x": 0.622115,
				"y": 0.573841
			},
			{
				"x": 0.617732,
				"y": 0.579706
			},
			{
				"x": 0.614049,
				"y": 0.586036
			},
			{
				"x": 0.611058,
				"y": 0.592722
			},
			{
				"x": 0.608748,
				"y": 0.599675
			},
			{
				"x": 0.607108,
				"y": 0.606817
			},
			{
				"x": 0.606128,
				"y": 0.614079
			},
			{
				"x": 0.605802,
				"y": 0.6214
			},
			{
				"x": 0.606128,
				"y": 0.628721
			},
			{
				"x": 0.607108,
				"y": 0.635983
			},
			{
				"x": 0.608748,
				"y": 0.643125
			},
			{
				"x": 0.611058,
				"y": 0.650077
			},
			{
				"x": 0.614049,
				"y": 0.656764
			},
			{
				"x": 0.617732,
				"y": 0.663094
			},
			{
				"x": 0.622115,
				"y": 0.668959
			},
			{
				"x": 0.627193,
				"y": 0.674229
			},
			{
				"x": 0.632941,
				"y": 0.678755
			},
			{
				"x": 0.639298,
				"y": 0.682368
			},
			{
				"x": 0.646154,
				"y": 0.684901
			},
			{
				"x": 0.653343,
				"y": 0.686209
			},
			{
				"x": 0.66065,
				"y": 0.686209
			},
			{
				"x": 0.667839,
				"y": 0.684901
			},
			{
				"x": 0.674695,
				"y": 0.682368
			},
			{
				"x": 0.681053,
				"y": 0.678755
			},
			{
				"x": 0.6868,
				"y": 0.674229
			},
			{
				"x": 0.691878,
				"y": 0.668959
			},
			{
				"x": 0.696261,
				"y": 0.663094
			},
			{
				"x": 0.699944,
				"y": 0.656764
			},
			{
				"x": 0.702935,
				"y": 0.650077
			},
			{
				"x": 0.705245,
				"y": 0.643125
			},
			{
				"x": 0.706885,
				"y": 0.635983
			},
			{
				"x": 0.707865,
				"y": 0.628721
			}
		],
		"re": [
			{
				"x": 0.291809,
				"y": 0.6214
			},
			{
				"x": 0.292135,
				"y": 0.614079
			},
			{
				"x": 0.293115,
				"y": 0.606817
			},
			{
				"x": 0.294755,
				"y": 0.599675
			},
			{
				"x": 0.297065,
				"y": 0.592722
			},
			{
				"x": 0.300056,
				"y": 0.586036
			},
			{
				"x": 0.303739,
				"y": 0.579706
			},
			{
				"x": 0.308122,
				"y": 0.573841
			},
			{
				"x": 0.3132,
				"y": 0.568571
			},
			{
				"x": 0.318947,
				"y": 0.564045
			},
			{
				"x": 0.325305,
				"y": 0.560432
			},
			{
				"x": 0.332161,
				"y": 0.557899
			},
			{
				"x": 0.33935,
				"y": 0.556591
			},
			{
				"x": 0.346657,
				"y": 0.556591
			},
			{
				"x": 0.353846,
				"y": 0.557899
			},
			{
				"x": 0.360702,
				"y": 0.560432
			},
			{
				"x": 0.367059,
				"y": 0.564045
			},
			{
				"x": 0.372807,
				"y": 0.568571
			},
			{
				"x": 0.377885,
				"y": 0.573841
			},
			{
				"x": 0.382268,
				"y": 0.579706
			},
			{
				"x": 0.385951,
				"y": 0.586036
			},
			{
				"x": 0.388942,
				"y": 0.592722
			},
			{
				"x": 0.391252,
				"y": 0.599675
			},
			{
				"x": 0.392892,
				"y": 0.606817
			},
			{
				"x": 0.393872,
				"y": 0.614079
			},
			{
				"x": 0.394198,
				"y": 0.6214
			},
			{
				"x": 0.393872,
				"y": 0.628721
			},
			{
				"x": 0.392892,
				"y": 0.635983
			},
			{
				"x": 0.391252,
				"y": 0.643125
			},
			{
				"x": 0.388942,
				"y": 0.650077
			},
			{
				"x": 0.385951,
				"y": 0.656764
			},
			{
				"x": 0.382268,
				"y": 0.663094
			},
			{
				"x": 0.377885,
				"y": 0.668959
			},
			{
				"x": 0.372807,
				"y": 0.674229
			},
			{
				"x": 0.367059,
				"y": 0.678755
			},
			{
				"x": 0.360702,
				"y": 0.682368
			},
			{
				"x": 0.353846,
				"y": 0.684901
			},
			{
				"x": 0.346657,
				"y": 0.686209
			},
			{
				"x": 0.33935,
				"y": 0.686209
			},
			{
				"x": 0.332161,
				"y": 0.684901
			},
			{
				"x": 0.325305,
				"y": 0.682368
			},
			{
				"x": 0.318947,
				"y": 0.678755
			},
			{
				"x": 0.3132,
				"y": 0.674229
			},
			{
				"x": 0.308122,
				"y": 0.668959
			},
			{
				"x": 0.303739,
				"y": 0.663094
			},
			{
				"x": 0.300056,
				"y": 0.656764
			},
			{
				"x": 0.297065,
				"y": 0.650077
			},
			{
				"x": 0.294755,
				"y": 0.643125
			},
			{
				"x": 0.293115,
				"y": 0.635983
			},
			{
				"x": 0.292135,
				"y": 0.628721
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.497955,
				"y": 0.161438
			},
			{
				"x": 0.51762,
				"y": 0.160552
			},
			{
				"x": 0.537723,
				"y": 0.163971
			},
			{
				"x": 0.557614,
				"y": 0.168475
			},
			{
				"x": 0.577303,
				"y": 0.173794
			},
			{
				"x": 0.596729,
				"y": 0.180009
			},
			{
				"x": 0.615693,
				"y": 0.187509
			},
			{
				"x": 0.633375,
				"y": 0.1976
			},
			{
				"x": 0.6381,
				"y": 0.214639
			},
			{
				"x": 0.620908,
				"y": 0.225401
			},
			{
				"x": 0.602016,
				"y": 0.233086
			},
			{
				"x": 0.582884,
				"y": 0.240164
			},
			{
				"x": 0.563904,
				"y": 0.247636
			},
			{
				"x": 0.545909,
				"y": 0.257168
			},
			{
				"x": 0.54233,
				"y": 0.274059
			},
			{
				"x": 0.558771,
				"y": 0.286005
			},
			{
				"x": 0.576936,
				"y": 0.295286
			},
			{
				"x": 0.595405,
				"y": 0.303954
			},
			{
				"x": 0.613714,
				"y": 0.312951
			},
			{
				"x": 0.630876,
				"y": 0.323913
			},
			{
				"x": 0.633236,
				"y": 0.341466
			},
			{
				"x": 0.616092,
				"y": 0.352281
			},
			{
				"x": 0.596903,
				"y": 0.359166
			},
			{
				"x": 0.577184,
				"y": 0.364369
			},
			{
				"x": 0.55721,
				"y": 0.368486
			},
			{
				"x": 0.537069,
				"y": 0.371683
			},
			{
				"x": 0.51679,
				"y": 0.373819
			},
			{
				"x": 0.498684,
				"y": 0.371809
			},
			{
				"x": 0.518096,
				"y": 0.365757
			},
			{
				"x": 0.537938,
				"y": 0.361033
			},
			{
				"x": 0.55771,
				"y": 0.356026
			},
			{
				"x": 0.577246,
				"y": 0.35017
			},
			{
				"x": 0.596002,
				"y": 0.34222
			},
			{
				"x": 0.603466,
				"y": 0.326525
			},
			{
				"x": 0.586857,
				"y": 0.314882
			},
			{
				"x": 0.568423,
				"y": 0.306147
			},
			{
				"x": 0.549731,
				"y": 0.297975
			},
			{
				"x": 0.531196,
				"y": 0.289456
			},
			{
				"x": 0.513601,
				"y": 0.279179
			},
			{
				"x": 0.508724,
				"y": 0.262399
			},
			{
				"x": 0.525729,
				"y": 0.251334
			},
			{
				"x": 0.5445,
				"y": 0.243356
			},
			{
				"x": 0.563529,
				"y": 0.236005
			},
			{
				"x": 0.582348,
				"y": 0.228139
			},
			{
				"x": 0.59921,
				"y": 0.216957
			},
			{
				"x": 0.591331,
				"y": 0.200801
			},
			{
				"x": 0.573201,
				"y": 0.191498
			},
			{
				"x": 0.554188,
				"y": 0.184115
			},
			{
				"x": 0.534907,
				"y": 0.177455
			},
			{
				"x": 0.515612,
				"y": 0.170839
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"kissing_smiling_eyes": {
		"lb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"rb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"le": [
			{
				"x": 0.70555,
				"y": 0.520267
			},
			{
				"x": 0.701936,
				"y": 0.529953
			},
			{
				"x": 0.696774,
				"y": 0.538911
			},
			{
				"x": 0.690373,
				"y": 0.54703
			},
			{
				"x": 0.682963,
				"y": 0.554237
			},
			{
				"x": 0.674716,
				"y": 0.560466
			},
			{
				"x": 0.665771,
				"y": 0.565638
			},
			{
				"x": 0.656253,
				"y": 0.569651
			},
			{
				"x": 0.646288,
				"y": 0.572363
			},
			{
				"x": 0.636037,
				"y": 0.573582
			},
			{
				"x": 0.625723,
				"y": 0.573137
			},
			{
				"x": 0.615594,
				"y": 0.571135
			},
			{
				"x": 0.605842,
				"y": 0.567734
			},
			{
				"x": 0.596632,
				"y": 0.563054
			},
			{
				"x": 0.588125,
				"y": 0.557189
			},
			{
				"x": 0.580497,
				"y": 0.550216
			},
			{
				"x": 0.573962,
				"y": 0.542208
			},
			{
				"x": 0.568789,
				"y": 0.533259
			},
			{
				"x": 0.565802,
				"y": 0.527088
			},
			{
				"x": 0.566119,
				"y": 0.537437
			},
			{
				"x": 0.566843,
				"y": 0.547765
			},
			{
				"x": 0.567983,
				"y": 0.558055
			},
			{
				"x": 0.569553,
				"y": 0.568289
			},
			{
				"x": 0.571573,
				"y": 0.578442
			},
			{
				"x": 0.574073,
				"y": 0.588488
			},
			{
				"x": 0.577086,
				"y": 0.598391
			},
			{
				"x": 0.580662,
				"y": 0.608104
			},
			{
				"x": 0.584861,
				"y": 0.617563
			},
			{
				"x": 0.589761,
				"y": 0.626676
			},
			{
				"x": 0.595462,
				"y": 0.635307
			},
			{
				"x": 0.602083,
				"y": 0.643248
			},
			{
				"x": 0.609751,
				"y": 0.650173
			},
			{
				"x": 0.61854,
				"y": 0.655584
			},
			{
				"x": 0.628329,
				"y": 0.658811
			},
			{
				"x": 0.638618,
				"y": 0.65925
			},
			{
				"x": 0.648629,
				"y": 0.656811
			},
			{
				"x": 0.657758,
				"y": 0.652002
			},
			{
				"x": 0.665791,
				"y": 0.645509
			},
			{
				"x": 0.672766,
				"y": 0.637879
			},
			{
				"x": 0.678799,
				"y": 0.629478
			},
			{
				"x": 0.68401,
				"y": 0.620541
			},
			{
				"x": 0.688502,
				"y": 0.611218
			},
			{
				"x": 0.692357,
				"y": 0.601613
			},
			{
				"x": 0.695638,
				"y": 0.591796
			},
			{
				"x": 0.698397,
				"y": 0.581819
			},
			{
				"x": 0.70067,
				"y": 0.571719
			},
			{
				"x": 0.702488,
				"y": 0.561527
			},
			{
				"x": 0.703872,
				"y": 0.551267
			},
			{
				"x": 0.704837,
				"y": 0.540958
			},
			{
				"x": 0.705395,
				"y": 0.53062
			}
		],
		"re": [
			{
				"x": 0.296293,
				"y": 0.52607
			},
			{
				"x": 0.299728,
				"y": 0.534177
			},
			{
				"x": 0.305049,
				"y": 0.543039
			},
			{
				"x": 0.311702,
				"y": 0.550949
			},
			{
				"x": 0.319426,
				"y": 0.557816
			},
			{
				"x": 0.328009,
				"y": 0.563568
			},
			{
				"x": 0.337279,
				"y": 0.568126
			},
			{
				"x": 0.347076,
				"y": 0.571396
			},
			{
				"x": 0.357233,
				"y": 0.573252
			},
			{
				"x": 0.367552,
				"y": 0.573535
			},
			{
				"x": 0.377784,
				"y": 0.572159
			},
			{
				"x": 0.387711,
				"y": 0.569311
			},
			{
				"x": 0.397178,
				"y": 0.565179
			},
			{
				"x": 0.40606,
				"y": 0.559899
			},
			{
				"x": 0.414231,
				"y": 0.553571
			},
			{
				"x": 0.421551,
				"y": 0.546271
			},
			{
				"x": 0.427841,
				"y": 0.538066
			},
			{
				"x": 0.432865,
				"y": 0.52903
			},
			{
				"x": 0.436052,
				"y": 0.521285
			},
			{
				"x": 0.435858,
				"y": 0.531637
			},
			{
				"x": 0.435261,
				"y": 0.541973
			},
			{
				"x": 0.434255,
				"y": 0.552278
			},
			{
				"x": 0.432829,
				"y": 0.562532
			},
			{
				"x": 0.430968,
				"y": 0.572716
			},
			{
				"x": 0.428648,
				"y": 0.582805
			},
			{
				"x": 0.42584,
				"y": 0.592769
			},
			{
				"x": 0.422504,
				"y": 0.602568
			},
			{
				"x": 0.41859,
				"y": 0.612149
			},
			{
				"x": 0.414031,
				"y": 0.621438
			},
			{
				"x": 0.408744,
				"y": 0.630331
			},
			{
				"x": 0.402624,
				"y": 0.638668
			},
			{
				"x": 0.39555,
				"y": 0.646205
			},
			{
				"x": 0.387408,
				"y": 0.65256
			},
			{
				"x": 0.378178,
				"y": 0.657167
			},
			{
				"x": 0.368106,
				"y": 0.659338
			},
			{
				"x": 0.357833,
				"y": 0.65861
			},
			{
				"x": 0.348127,
				"y": 0.655137
			},
			{
				"x": 0.339448,
				"y": 0.64955
			},
			{
				"x": 0.331888,
				"y": 0.642506
			},
			{
				"x": 0.325363,
				"y": 0.634485
			},
			{
				"x": 0.319746,
				"y": 0.625799
			},
			{
				"x": 0.314919,
				"y": 0.616647
			},
			{
				"x": 0.310784,
				"y": 0.607159
			},
			{
				"x": 0.307266,
				"y": 0.597425
			},
			{
				"x": 0.304305,
				"y": 0.587506
			},
			{
				"x": 0.301854,
				"y": 0.577448
			},
			{
				"x": 0.299879,
				"y": 0.567286
			},
			{
				"x": 0.298352,
				"y": 0.557046
			},
			{
				"x": 0.297254,
				"y": 0.546751
			},
			{
				"x": 0.29657,
				"y": 0.53642
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.497955,
				"y": 0.161438
			},
			{
				"x": 0.51762,
				"y": 0.160552
			},
			{
				"x": 0.537723,
				"y": 0.163971
			},
			{
				"x": 0.557614,
				"y": 0.168475
			},
			{
				"x": 0.577303,
				"y": 0.173794
			},
			{
				"x": 0.596729,
				"y": 0.180009
			},
			{
				"x": 0.615693,
				"y": 0.187509
			},
			{
				"x": 0.633375,
				"y": 0.1976
			},
			{
				"x": 0.6381,
				"y": 0.214639
			},
			{
				"x": 0.620908,
				"y": 0.225401
			},
			{
				"x": 0.602016,
				"y": 0.233086
			},
			{
				"x": 0.582884,
				"y": 0.240164
			},
			{
				"x": 0.563904,
				"y": 0.247636
			},
			{
				"x": 0.545909,
				"y": 0.257168
			},
			{
				"x": 0.54233,
				"y": 0.274059
			},
			{
				"x": 0.558771,
				"y": 0.286005
			},
			{
				"x": 0.576936,
				"y": 0.295286
			},
			{
				"x": 0.595405,
				"y": 0.303954
			},
			{
				"x": 0.613714,
				"y": 0.312951
			},
			{
				"x": 0.630876,
				"y": 0.323913
			},
			{
				"x": 0.633236,
				"y": 0.341466
			},
			{
				"x": 0.616092,
				"y": 0.352281
			},
			{
				"x": 0.596903,
				"y": 0.359166
			},
			{
				"x": 0.577184,
				"y": 0.364369
			},
			{
				"x": 0.55721,
				"y": 0.368486
			},
			{
				"x": 0.537069,
				"y": 0.371683
			},
			{
				"x": 0.51679,
				"y": 0.373819
			},
			{
				"x": 0.498684,
				"y": 0.371809
			},
			{
				"x": 0.518096,
				"y": 0.365757
			},
			{
				"x": 0.537938,
				"y": 0.361033
			},
			{
				"x": 0.55771,
				"y": 0.356026
			},
			{
				"x": 0.577246,
				"y": 0.35017
			},
			{
				"x": 0.596002,
				"y": 0.34222
			},
			{
				"x": 0.603466,
				"y": 0.326525
			},
			{
				"x": 0.586857,
				"y": 0.314882
			},
			{
				"x": 0.568423,
				"y": 0.306147
			},
			{
				"x": 0.549731,
				"y": 0.297975
			},
			{
				"x": 0.531196,
				"y": 0.289456
			},
			{
				"x": 0.513601,
				"y": 0.279179
			},
			{
				"x": 0.508724,
				"y": 0.262399
			},
			{
				"x": 0.525729,
				"y": 0.251334
			},
			{
				"x": 0.5445,
				"y": 0.243356
			},
			{
				"x": 0.563529,
				"y": 0.236005
			},
			{
				"x": 0.582348,
				"y": 0.228139
			},
			{
				"x": 0.59921,
				"y": 0.216957
			},
			{
				"x": 0.591331,
				"y": 0.200801
			},
			{
				"x": 0.573201,
				"y": 0.191498
			},
			{
				"x": 0.554188,
				"y": 0.184115
			},
			{
				"x": 0.534907,
				"y": 0.177455
			},
			{
				"x": 0.515612,
				"y": 0.170839
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"kissing_closed_eyes": {
		"lb": [
			{
				"x": 0.826179,
				"y": 0.632958
			},
			{
				"x": 0.823163,
				"y": 0.642501
			},
			{
				"x": 0.819398,
				"y": 0.651773
			},
			{
				"x": 0.814908,
				"y": 0.660714
			},
			{
				"x": 0.809722,
				"y": 0.66927
			},
			{
				"x": 0.803872,
				"y": 0.677384
			},
			{
				"x": 0.797396,
				"y": 0.685005
			},
			{
				"x": 0.790334,
				"y": 0.692086
			},
			{
				"x": 0.782732,
				"y": 0.69858
			},
			{
				"x": 0.774638,
				"y": 0.704447
			},
			{
				"x": 0.766104,
				"y": 0.70965
			},
			{
				"x": 0.757183,
				"y": 0.714155
			},
			{
				"x": 0.747932,
				"y": 0.717934
			},
			{
				"x": 0.73841,
				"y": 0.720963
			},
			{
				"x": 0.728678,
				"y": 0.723222
			},
			{
				"x": 0.718797,
				"y": 0.724697
			},
			{
				"x": 0.708831,
				"y": 0.72538
			},
			{
				"x": 0.698841,
				"y": 0.725264
			},
			{
				"x": 0.688893,
				"y": 0.724352
			},
			{
				"x": 0.679049,
				"y": 0.722649
			},
			{
				"x": 0.669371,
				"y": 0.720166
			},
			{
				"x": 0.659921,
				"y": 0.716919
			},
			{
				"x": 0.65076,
				"y": 0.712927
			},
			{
				"x": 0.641945,
				"y": 0.708218
			},
			{
				"x": 0.633532,
				"y": 0.702819
			},
			{
				"x": 0.625575,
				"y": 0.696767
			},
			{
				"x": 0.618124,
				"y": 0.690099
			},
			{
				"x": 0.611228,
				"y": 0.682857
			},
			{
				"x": 0.620859,
				"y": 0.685218
			},
			{
				"x": 0.630653,
				"y": 0.687204
			},
			{
				"x": 0.640522,
				"y": 0.688768
			},
			{
				"x": 0.650448,
				"y": 0.68991
			},
			{
				"x": 0.660415,
				"y": 0.690625
			},
			{
				"x": 0.670402,
				"y": 0.690914
			},
			{
				"x": 0.680393,
				"y": 0.690775
			},
			{
				"x": 0.690369,
				"y": 0.690209
			},
			{
				"x": 0.700312,
				"y": 0.689217
			},
			{
				"x": 0.710203,
				"y": 0.6878
			},
			{
				"x": 0.720025,
				"y": 0.685961
			},
			{
				"x": 0.72976,
				"y": 0.683704
			},
			{
				"x": 0.739389,
				"y": 0.681032
			},
			{
				"x": 0.748896,
				"y": 0.677951
			},
			{
				"x": 0.758263,
				"y": 0.674466
			},
			{
				"x": 0.767473,
				"y": 0.670584
			},
			{
				"x": 0.776509,
				"y": 0.666311
			},
			{
				"x": 0.785355,
				"y": 0.661655
			},
			{
				"x": 0.793995,
				"y": 0.656626
			},
			{
				"x": 0.802412,
				"y": 0.651231
			},
			{
				"x": 0.810591,
				"y": 0.645481
			},
			{
				"x": 0.818519,
				"y": 0.639386
			}
		],
		"rb": [
			{
				"x": 0.173821,
				"y": 0.632958
			},
			{
				"x": 0.176837,
				"y": 0.642501
			},
			{
				"x": 0.180602,
				"y": 0.651773
			},
			{
				"x": 0.185092,
				"y": 0.660714
			},
			{
				"x": 0.190278,
				"y": 0.66927
			},
			{
				"x": 0.196128,
				"y": 0.677384
			},
			{
				"x": 0.202604,
				"y": 0.685005
			},
			{
				"x": 0.209666,
				"y": 0.692086
			},
			{
				"x": 0.217268,
				"y": 0.69858
			},
			{
				"x": 0.225362,
				"y": 0.704447
			},
			{
				"x": 0.233896,
				"y": 0.70965
			},
			{
				"x": 0.242817,
				"y": 0.714155
			},
			{
				"x": 0.252068,
				"y": 0.717934
			},
			{
				"x": 0.26159,
				"y": 0.720963
			},
			{
				"x": 0.271322,
				"y": 0.723222
			},
			{
				"x": 0.281203,
				"y": 0.724697
			},
			{
				"x": 0.291169,
				"y": 0.72538
			},
			{
				"x": 0.301159,
				"y": 0.725264
			},
			{
				"x": 0.311107,
				"y": 0.724352
			},
			{
				"x": 0.320951,
				"y": 0.722649
			},
			{
				"x": 0.330629,
				"y": 0.720166
			},
			{
				"x": 0.340079,
				"y": 0.716919
			},
			{
				"x": 0.34924,
				"y": 0.712927
			},
			{
				"x": 0.358055,
				"y": 0.708218
			},
			{
				"x": 0.366468,
				"y": 0.702819
			},
			{
				"x": 0.374425,
				"y": 0.696767
			},
			{
				"x": 0.381876,
				"y": 0.690099
			},
			{
				"x": 0.388772,
				"y": 0.682857
			},
			{
				"x": 0.379141,
				"y": 0.685218
			},
			{
				"x": 0.369347,
				"y": 0.687204
			},
			{
				"x": 0.359478,
				"y": 0.688768
			},
			{
				"x": 0.349552,
				"y": 0.68991
			},
			{
				"x": 0.339585,
				"y": 0.690625
			},
			{
				"x": 0.329598,
				"y": 0.690914
			},
			{
				"x": 0.319607,
				"y": 0.690775
			},
			{
				"x": 0.309631,
				"y": 0.690209
			},
			{
				"x": 0.299688,
				"y": 0.689217
			},
			{
				"x": 0.289797,
				"y": 0.6878
			},
			{
				"x": 0.279975,
				"y": 0.685961
			},
			{
				"x": 0.27024,
				"y": 0.683704
			},
			{
				"x": 0.260611,
				"y": 0.681032
			},
			{
				"x": 0.251104,
				"y": 0.677951
			},
			{
				"x": 0.241737,
				"y": 0.674466
			},
			{
				"x": 0.232527,
				"y": 0.670584
			},
			{
				"x": 0.223491,
				"y": 0.666311
			},
			{
				"x": 0.214645,
				"y": 0.661655
			},
			{
				"x": 0.206005,
				"y": 0.656626
			},
			{
				"x": 0.197588,
				"y": 0.651231
			},
			{
				"x": 0.189409,
				"y": 0.645481
			},
			{
				"x": 0.181481,
				"y": 0.639386
			}
		],
		"le": [
			{
				"x": 0.762083,
				"y": 0.481681
			},
			{
				"x": 0.754616,
				"y": 0.486573
			},
			{
				"x": 0.746893,
				"y": 0.491049
			},
			{
				"x": 0.738951,
				"y": 0.495122
			},
			{
				"x": 0.730823,
				"y": 0.498809
			},
			{
				"x": 0.722538,
				"y": 0.502124
			},
			{
				"x": 0.714119,
				"y": 0.505085
			},
			{
				"x": 0.705589,
				"y": 0.507703
			},
			{
				"x": 0.696964,
				"y": 0.509995
			},
			{
				"x": 0.688263,
				"y": 0.511972
			},
			{
				"x": 0.679499,
				"y": 0.513645
			},
			{
				"x": 0.670683,
				"y": 0.515027
			},
			{
				"x": 0.661829,
				"y": 0.516126
			},
			{
				"x": 0.652945,
				"y": 0.516952
			},
			{
				"x": 0.64404,
				"y": 0.517514
			},
			{
				"x": 0.635123,
				"y": 0.517817
			},
			{
				"x": 0.626201,
				"y": 0.517871
			},
			{
				"x": 0.61728,
				"y": 0.517679
			},
			{
				"x": 0.608368,
				"y": 0.517248
			},
			{
				"x": 0.599471,
				"y": 0.516582
			},
			{
				"x": 0.590593,
				"y": 0.515686
			},
			{
				"x": 0.581741,
				"y": 0.514562
			},
			{
				"x": 0.572921,
				"y": 0.513215
			},
			{
				"x": 0.564787,
				"y": 0.512129
			},
			{
				"x": 0.569635,
				"y": 0.519622
			},
			{
				"x": 0.57562,
				"y": 0.526241
			},
			{
				"x": 0.582493,
				"y": 0.531931
			},
			{
				"x": 0.590028,
				"y": 0.53671
			},
			{
				"x": 0.598042,
				"y": 0.540631
			},
			{
				"x": 0.606395,
				"y": 0.543767
			},
			{
				"x": 0.614981,
				"y": 0.546189
			},
			{
				"x": 0.623725,
				"y": 0.547962
			},
			{
				"x": 0.632568,
				"y": 0.549145
			},
			{
				"x": 0.641466,
				"y": 0.549786
			},
			{
				"x": 0.650386,
				"y": 0.549927
			},
			{
				"x": 0.659302,
				"y": 0.549603
			},
			{
				"x": 0.668187,
				"y": 0.548792
			},
			{
				"x": 0.677025,
				"y": 0.547569
			},
			{
				"x": 0.685801,
				"y": 0.545959
			},
			{
				"x": 0.69449,
				"y": 0.54393
			},
			{
				"x": 0.703059,
				"y": 0.541442
			},
			{
				"x": 0.711466,
				"y": 0.538451
			},
			{
				"x": 0.719654,
				"y": 0.534905
			},
			{
				"x": 0.72755,
				"y": 0.530745
			},
			{
				"x": 0.735051,
				"y": 0.52591
			},
			{
				"x": 0.742022,
				"y": 0.520337
			},
			{
				"x": 0.74829,
				"y": 0.513982
			},
			{
				"x": 0.75364,
				"y": 0.506837
			},
			{
				"x": 0.757843,
				"y": 0.498962
			},
			{
				"x": 0.760695,
				"y": 0.490501
			}
		],
		"re": [
			{
				"x": 0.237917,
				"y": 0.481681
			},
			{
				"x": 0.245384,
				"y": 0.486573
			},
			{
				"x": 0.253107,
				"y": 0.491049
			},
			{
				"x": 0.261049,
				"y": 0.495122
			},
			{
				"x": 0.269177,
				"y": 0.498809
			},
			{
				"x": 0.277462,
				"y": 0.502124
			},
			{
				"x": 0.285881,
				"y": 0.505085
			},
			{
				"x": 0.294411,
				"y": 0.507703
			},
			{
				"x": 0.303036,
				"y": 0.509995
			},
			{
				"x": 0.311737,
				"y": 0.511972
			},
			{
				"x": 0.320501,
				"y": 0.513645
			},
			{
				"x": 0.329317,
				"y": 0.515027
			},
			{
				"x": 0.338171,
				"y": 0.516126
			},
			{
				"x": 0.347055,
				"y": 0.516952
			},
			{
				"x": 0.35596,
				"y": 0.517514
			},
			{
				"x": 0.364877,
				"y": 0.517817
			},
			{
				"x": 0.373799,
				"y": 0.517871
			},
			{
				"x": 0.38272,
				"y": 0.517679
			},
			{
				"x": 0.391632,
				"y": 0.517248
			},
			{
				"x": 0.400529,
				"y": 0.516582
			},
			{
				"x": 0.409407,
				"y": 0.515686
			},
			{
				"x": 0.418259,
				"y": 0.514562
			},
			{
				"x": 0.427079,
				"y": 0.513215
			},
			{
				"x": 0.435213,
				"y": 0.512129
			},
			{
				"x": 0.430365,
				"y": 0.519622
			},
			{
				"x": 0.42438,
				"y": 0.526241
			},
			{
				"x": 0.417507,
				"y": 0.531931
			},
			{
				"x": 0.409972,
				"y": 0.53671
			},
			{
				"x": 0.401958,
				"y": 0.540631
			},
			{
				"x": 0.393605,
				"y": 0.543767
			},
			{
				"x": 0.385019,
				"y": 0.546189
			},
			{
				"x": 0.376275,
				"y": 0.547962
			},
			{
				"x": 0.367432,
				"y": 0.549145
			},
			{
				"x": 0.358534,
				"y": 0.549786
			},
			{
				"x": 0.349614,
				"y": 0.549927
			},
			{
				"x": 0.340698,
				"y": 0.549603
			},
			{
				"x": 0.331813,
				"y": 0.548792
			},
			{
				"x": 0.322975,
				"y": 0.547569
			},
			{
				"x": 0.314199,
				"y": 0.545959
			},
			{
				"x": 0.30551,
				"y": 0.54393
			},
			{
				"x": 0.296941,
				"y": 0.541442
			},
			{
				"x": 0.288534,
				"y": 0.538451
			},
			{
				"x": 0.280346,
				"y": 0.534905
			},
			{
				"x": 0.27245,
				"y": 0.530745
			},
			{
				"x": 0.264949,
				"y": 0.52591
			},
			{
				"x": 0.257978,
				"y": 0.520337
			},
			{
				"x": 0.25171,
				"y": 0.513982
			},
			{
				"x": 0.24636,
				"y": 0.506837
			},
			{
				"x": 0.242157,
				"y": 0.498962
			},
			{
				"x": 0.239305,
				"y": 0.490501
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.497955,
				"y": 0.161438
			},
			{
				"x": 0.51762,
				"y": 0.160552
			},
			{
				"x": 0.537723,
				"y": 0.163971
			},
			{
				"x": 0.557614,
				"y": 0.168475
			},
			{
				"x": 0.577303,
				"y": 0.173794
			},
			{
				"x": 0.596729,
				"y": 0.180009
			},
			{
				"x": 0.615693,
				"y": 0.187509
			},
			{
				"x": 0.633375,
				"y": 0.1976
			},
			{
				"x": 0.6381,
				"y": 0.214639
			},
			{
				"x": 0.620908,
				"y": 0.225401
			},
			{
				"x": 0.602016,
				"y": 0.233086
			},
			{
				"x": 0.582884,
				"y": 0.240164
			},
			{
				"x": 0.563904,
				"y": 0.247636
			},
			{
				"x": 0.545909,
				"y": 0.257168
			},
			{
				"x": 0.54233,
				"y": 0.274059
			},
			{
				"x": 0.558771,
				"y": 0.286005
			},
			{
				"x": 0.576936,
				"y": 0.295286
			},
			{
				"x": 0.595405,
				"y": 0.303954
			},
			{
				"x": 0.613714,
				"y": 0.312951
			},
			{
				"x": 0.630876,
				"y": 0.323913
			},
			{
				"x": 0.633236,
				"y": 0.341466
			},
			{
				"x": 0.616092,
				"y": 0.352281
			},
			{
				"x": 0.596903,
				"y": 0.359166
			},
			{
				"x": 0.577184,
				"y": 0.364369
			},
			{
				"x": 0.55721,
				"y": 0.368486
			},
			{
				"x": 0.537069,
				"y": 0.371683
			},
			{
				"x": 0.51679,
				"y": 0.373819
			},
			{
				"x": 0.498684,
				"y": 0.371809
			},
			{
				"x": 0.518096,
				"y": 0.365757
			},
			{
				"x": 0.537938,
				"y": 0.361033
			},
			{
				"x": 0.55771,
				"y": 0.356026
			},
			{
				"x": 0.577246,
				"y": 0.35017
			},
			{
				"x": 0.596002,
				"y": 0.34222
			},
			{
				"x": 0.603466,
				"y": 0.326525
			},
			{
				"x": 0.586857,
				"y": 0.314882
			},
			{
				"x": 0.568423,
				"y": 0.306147
			},
			{
				"x": 0.549731,
				"y": 0.297975
			},
			{
				"x": 0.531196,
				"y": 0.289456
			},
			{
				"x": 0.513601,
				"y": 0.279179
			},
			{
				"x": 0.508724,
				"y": 0.262399
			},
			{
				"x": 0.525729,
				"y": 0.251334
			},
			{
				"x": 0.5445,
				"y": 0.243356
			},
			{
				"x": 0.563529,
				"y": 0.236005
			},
			{
				"x": 0.582348,
				"y": 0.228139
			},
			{
				"x": 0.59921,
				"y": 0.216957
			},
			{
				"x": 0.591331,
				"y": 0.200801
			},
			{
				"x": 0.573201,
				"y": 0.191498
			},
			{
				"x": 0.554188,
				"y": 0.184115
			},
			{
				"x": 0.534907,
				"y": 0.177455
			},
			{
				"x": 0.515612,
				"y": 0.170839
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"stuck_out_tongue_winking_eye": {
		"lb": [
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			}
		],
		"rb": [
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			}
		],
		"le": [
			{
				"x": 0.895004,
				"y": 0.591011
			},
			{
				"x": 0.893739,
				"y": 0.573044
			},
			{
				"x": 0.889972,
				"y": 0.555389
			},
			{
				"x": 0.88378,
				"y": 0.538352
			},
			{
				"x": 0.875287,
				"y": 0.522218
			},
			{
				"x": 0.86466,
				"y": 0.507246
			},
			{
				"x": 0.852097,
				"y": 0.493669
			},
			{
				"x": 0.837822,
				"y": 0.481683
			},
			{
				"x": 0.822079,
				"y": 0.471456
			},
			{
				"x": 0.805125,
				"y": 0.463121
			},
			{
				"x": 0.787222,
				"y": 0.456782
			},
			{
				"x": 0.76864,
				"y": 0.452515
			},
			{
				"x": 0.749649,
				"y": 0.45037
			},
			{
				"x": 0.730522,
				"y": 0.45037
			},
			{
				"x": 0.711531,
				"y": 0.452515
			},
			{
				"x": 0.692948,
				"y": 0.456782
			},
			{
				"x": 0.675046,
				"y": 0.463121
			},
			{
				"x": 0.658091,
				"y": 0.471456
			},
			{
				"x": 0.642348,
				"y": 0.481683
			},
			{
				"x": 0.628074,
				"y": 0.493669
			},
			{
				"x": 0.61551,
				"y": 0.507246
			},
			{
				"x": 0.604883,
				"y": 0.522218
			},
			{
				"x": 0.59639,
				"y": 0.538352
			},
			{
				"x": 0.590198,
				"y": 0.555389
			},
			{
				"x": 0.586431,
				"y": 0.573044
			},
			{
				"x": 0.585166,
				"y": 0.591011
			},
			{
				"x": 0.586431,
				"y": 0.608978
			},
			{
				"x": 0.590198,
				"y": 0.626632
			},
			{
				"x": 0.59639,
				"y": 0.643669
			},
			{
				"x": 0.604883,
				"y": 0.659804
			},
			{
				"x": 0.61551,
				"y": 0.674775
			},
			{
				"x": 0.628074,
				"y": 0.688353
			},
			{
				"x": 0.642348,
				"y": 0.700339
			},
			{
				"x": 0.658091,
				"y": 0.710566
			},
			{
				"x": 0.675046,
				"y": 0.718901
			},
			{
				"x": 0.692948,
				"y": 0.72524
			},
			{
				"x": 0.711531,
				"y": 0.729507
			},
			{
				"x": 0.730522,
				"y": 0.731652
			},
			{
				"x": 0.749649,
				"y": 0.731652
			},
			{
				"x": 0.76864,
				"y": 0.729507
			},
			{
				"x": 0.787222,
				"y": 0.72524
			},
			{
				"x": 0.805125,
				"y": 0.718901
			},
			{
				"x": 0.822079,
				"y": 0.710566
			},
			{
				"x": 0.837822,
				"y": 0.700339
			},
			{
				"x": 0.852097,
				"y": 0.688353
			},
			{
				"x": 0.86466,
				"y": 0.674775
			},
			{
				"x": 0.875287,
				"y": 0.659804
			},
			{
				"x": 0.88378,
				"y": 0.643669
			},
			{
				"x": 0.889972,
				"y": 0.626632
			},
			{
				"x": 0.893739,
				"y": 0.608978
			}
		],
		"re": [
			{
				"x": 0.203508,
				"y": 0.521005
			},
			{
				"x": 0.214016,
				"y": 0.525503
			},
			{
				"x": 0.224769,
				"y": 0.529453
			},
			{
				"x": 0.235724,
				"y": 0.53288
			},
			{
				"x": 0.246841,
				"y": 0.535807
			},
			{
				"x": 0.258087,
				"y": 0.53826
			},
			{
				"x": 0.269433,
				"y": 0.54026
			},
			{
				"x": 0.280856,
				"y": 0.54183
			},
			{
				"x": 0.292334,
				"y": 0.542988
			},
			{
				"x": 0.303849,
				"y": 0.543754
			},
			{
				"x": 0.315386,
				"y": 0.544145
			},
			{
				"x": 0.32693,
				"y": 0.544175
			},
			{
				"x": 0.338469,
				"y": 0.543859
			},
			{
				"x": 0.349992,
				"y": 0.543209
			},
			{
				"x": 0.36149,
				"y": 0.542236
			},
			{
				"x": 0.372953,
				"y": 0.540952
			},
			{
				"x": 0.384374,
				"y": 0.539366
			},
			{
				"x": 0.395744,
				"y": 0.537486
			},
			{
				"x": 0.407057,
				"y": 0.53532
			},
			{
				"x": 0.418305,
				"y": 0.532875
			},
			{
				"x": 0.429482,
				"y": 0.530156
			},
			{
				"x": 0.440582,
				"y": 0.527169
			},
			{
				"x": 0.451598,
				"y": 0.523919
			},
			{
				"x": 0.461787,
				"y": 0.521109
			},
			{
				"x": 0.457056,
				"y": 0.53101
			},
			{
				"x": 0.4507,
				"y": 0.540071
			},
			{
				"x": 0.443026,
				"y": 0.548181
			},
			{
				"x": 0.434326,
				"y": 0.555316
			},
			{
				"x": 0.424846,
				"y": 0.561511
			},
			{
				"x": 0.414779,
				"y": 0.566824
			},
			{
				"x": 0.404272,
				"y": 0.571322
			},
			{
				"x": 0.393439,
				"y": 0.575071
			},
			{
				"x": 0.382362,
				"y": 0.578127
			},
			{
				"x": 0.371108,
				"y": 0.580543
			},
			{
				"x": 0.359728,
				"y": 0.582362
			},
			{
				"x": 0.348262,
				"y": 0.583622
			},
			{
				"x": 0.336741,
				"y": 0.58429
			},
			{
				"x": 0.325199,
				"y": 0.584455
			},
			{
				"x": 0.31366,
				"y": 0.584143
			},
			{
				"x": 0.302151,
				"y": 0.583311
			},
			{
				"x": 0.290705,
				"y": 0.581906
			},
			{
				"x": 0.279367,
				"y": 0.579866
			},
			{
				"x": 0.2682,
				"y": 0.577119
			},
			{
				"x": 0.257288,
				"y": 0.573581
			},
			{
				"x": 0.246747,
				"y": 0.569157
			},
			{
				"x": 0.236739,
				"y": 0.563749
			},
			{
				"x": 0.227478,
				"y": 0.557272
			},
			{
				"x": 0.219236,
				"y": 0.549675
			},
			{
				"x": 0.212318,
				"y": 0.540988
			},
			{
				"x": 0.207012,
				"y": 0.531348
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.530151
			},
			{
				"x": 0.996057,
				"y": 0.589155
			},
			{
				"x": 0.984292,
				"y": 0.647229
			},
			{
				"x": 0.964888,
				"y": 0.703456
			},
			{
				"x": 0.938153,
				"y": 0.75695
			},
			{
				"x": 0.904508,
				"y": 0.806867
			},
			{
				"x": 0.864484,
				"y": 0.852421
			},
			{
				"x": 0.818712,
				"y": 0.892892
			},
			{
				"x": 0.767913,
				"y": 0.927642
			},
			{
				"x": 0.71289,
				"y": 0.956124
			},
			{
				"x": 0.654508,
				"y": 0.977887
			},
			{
				"x": 0.593691,
				"y": 0.99259
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.99259
			},
			{
				"x": 0.345492,
				"y": 0.977887
			},
			{
				"x": 0.28711,
				"y": 0.956124
			},
			{
				"x": 0.232087,
				"y": 0.927642
			},
			{
				"x": 0.181288,
				"y": 0.892892
			},
			{
				"x": 0.135516,
				"y": 0.852421
			},
			{
				"x": 0.095492,
				"y": 0.806867
			},
			{
				"x": 0.061847,
				"y": 0.75695
			},
			{
				"x": 0.035112,
				"y": 0.703456
			},
			{
				"x": 0.015708,
				"y": 0.647229
			},
			{
				"x": 0.003943,
				"y": 0.589155
			},
			{
				"x": 0,
				"y": 0.530151
			},
			{
				"x": 0.003943,
				"y": 0.471147
			},
			{
				"x": 0.015708,
				"y": 0.413073
			},
			{
				"x": 0.035112,
				"y": 0.356846
			},
			{
				"x": 0.061847,
				"y": 0.303352
			},
			{
				"x": 0.095492,
				"y": 0.253434
			},
			{
				"x": 0.135516,
				"y": 0.207881
			},
			{
				"x": 0.181288,
				"y": 0.16741
			},
			{
				"x": 0.232087,
				"y": 0.13266
			},
			{
				"x": 0.28711,
				"y": 0.104178
			},
			{
				"x": 0.345492,
				"y": 0.082414
			},
			{
				"x": 0.406309,
				"y": 0.067711
			},
			{
				"x": 0.468605,
				"y": 0.060302
			},
			{
				"x": 0.531395,
				"y": 0.060302
			},
			{
				"x": 0.593691,
				"y": 0.067711
			},
			{
				"x": 0.654508,
				"y": 0.082414
			},
			{
				"x": 0.71289,
				"y": 0.104178
			},
			{
				"x": 0.767913,
				"y": 0.13266
			},
			{
				"x": 0.818712,
				"y": 0.16741
			},
			{
				"x": 0.864484,
				"y": 0.207881
			},
			{
				"x": 0.904508,
				"y": 0.253434
			},
			{
				"x": 0.938153,
				"y": 0.303352
			},
			{
				"x": 0.964888,
				"y": 0.356846
			},
			{
				"x": 0.984292,
				"y": 0.413073
			},
			{
				"x": 0.996057,
				"y": 0.471147
			}
		],
		"mouth": [
			{
				"x": 0.247984,
				"y": 0.378448
			},
			{
				"x": 0.250099,
				"y": 0.353733
			},
			{
				"x": 0.256326,
				"y": 0.32964
			},
			{
				"x": 0.266348,
				"y": 0.306707
			},
			{
				"x": 0.279719,
				"y": 0.285338
			},
			{
				"x": 0.295946,
				"y": 0.265798
			},
			{
				"x": 0.314551,
				"y": 0.248232
			},
			{
				"x": 0.335099,
				"y": 0.232702
			},
			{
				"x": 0.357218,
				"y": 0.219216
			},
			{
				"x": 0.380589,
				"y": 0.207752
			},
			{
				"x": 0.404945,
				"y": 0.198274
			},
			{
				"x": 0.430056,
				"y": 0.190743
			},
			{
				"x": 0.455727,
				"y": 0.185124
			},
			{
				"x": 0.481782,
				"y": 0.181386
			},
			{
				"x": 0.508062,
				"y": 0.179511
			},
			{
				"x": 0.534417,
				"y": 0.179486
			},
			{
				"x": 0.560702,
				"y": 0.181313
			},
			{
				"x": 0.586764,
				"y": 0.185001
			},
			{
				"x": 0.612447,
				"y": 0.190571
			},
			{
				"x": 0.637575,
				"y": 0.198051
			},
			{
				"x": 0.661954,
				"y": 0.207478
			},
			{
				"x": 0.685354,
				"y": 0.218889
			},
			{
				"x": 0.70751,
				"y": 0.232321
			},
			{
				"x": 0.728104,
				"y": 0.247797
			},
			{
				"x": 0.746765,
				"y": 0.26531
			},
			{
				"x": 0.763061,
				"y": 0.2848
			},
			{
				"x": 0.776513,
				"y": 0.306124
			},
			{
				"x": 0.786629,
				"y": 0.32902
			},
			{
				"x": 0.792961,
				"y": 0.353089
			},
			{
				"x": 0.795186,
				"y": 0.377795
			},
			{
				"x": 0.770479,
				"y": 0.371922
			},
			{
				"x": 0.744723,
				"y": 0.366642
			},
			{
				"x": 0.718776,
				"y": 0.362262
			},
			{
				"x": 0.692711,
				"y": 0.358554
			},
			{
				"x": 0.666563,
				"y": 0.355402
			},
			{
				"x": 0.640352,
				"y": 0.352749
			},
			{
				"x": 0.614093,
				"y": 0.350567
			},
			{
				"x": 0.587794,
				"y": 0.348856
			},
			{
				"x": 0.561465,
				"y": 0.34764
			},
			{
				"x": 0.535113,
				"y": 0.346977
			},
			{
				"x": 0.508752,
				"y": 0.346968
			},
			{
				"x": 0.4824,
				"y": 0.347615
			},
			{
				"x": 0.456069,
				"y": 0.348817
			},
			{
				"x": 0.42977,
				"y": 0.350516
			},
			{
				"x": 0.403509,
				"y": 0.352685
			},
			{
				"x": 0.377298,
				"y": 0.355326
			},
			{
				"x": 0.351148,
				"y": 0.358464
			},
			{
				"x": 0.32508,
				"y": 0.362157
			},
			{
				"x": 0.299129,
				"y": 0.366517
			},
			{
				"x": 0.273366,
				"y": 0.371769
			}
		],
		"tongue": [
			{
				"x": 0.64019,
				"y": 0.325741
			},
			{
				"x": 0.64019,
				"y": 0.305201
			},
			{
				"x": 0.64019,
				"y": 0.284662
			},
			{
				"x": 0.64019,
				"y": 0.264123
			},
			{
				"x": 0.64019,
				"y": 0.243584
			},
			{
				"x": 0.64019,
				"y": 0.223044
			},
			{
				"x": 0.64019,
				"y": 0.202505
			},
			{
				"x": 0.64019,
				"y": 0.181966
			},
			{
				"x": 0.64019,
				"y": 0.161427
			},
			{
				"x": 0.64019,
				"y": 0.140887
			},
			{
				"x": 0.640185,
				"y": 0.120348
			},
			{
				"x": 0.637929,
				"y": 0.09995
			},
			{
				"x": 0.631589,
				"y": 0.08033
			},
			{
				"x": 0.621508,
				"y": 0.062147
			},
			{
				"x": 0.608294,
				"y": 0.045832
			},
			{
				"x": 0.592585,
				"y": 0.031608
			},
			{
				"x": 0.574912,
				"y": 0.019595
			},
			{
				"x": 0.555667,
				"y": 0.009958
			},
			{
				"x": 0.535136,
				"y": 0.003084
			},
			{
				"x": 0.513619,
				"y": 0
			},
			{
				"x": 0.492011,
				"y": 0.002384
			},
			{
				"x": 0.471319,
				"y": 0.008813
			},
			{
				"x": 0.451879,
				"y": 0.018095
			},
			{
				"x": 0.433965,
				"y": 0.029787
			},
			{
				"x": 0.417951,
				"y": 0.043708
			},
			{
				"x": 0.40435,
				"y": 0.059738
			},
			{
				"x": 0.393791,
				"y": 0.07768
			},
			{
				"x": 0.386896,
				"y": 0.097134
			},
			{
				"x": 0.384062,
				"y": 0.117468
			},
			{
				"x": 0.383988,
				"y": 0.138006
			},
			{
				"x": 0.383988,
				"y": 0.158545
			},
			{
				"x": 0.383988,
				"y": 0.179084
			},
			{
				"x": 0.383988,
				"y": 0.199624
			},
			{
				"x": 0.383988,
				"y": 0.220163
			},
			{
				"x": 0.383988,
				"y": 0.240702
			},
			{
				"x": 0.383988,
				"y": 0.261242
			},
			{
				"x": 0.383988,
				"y": 0.281781
			},
			{
				"x": 0.383988,
				"y": 0.30232
			},
			{
				"x": 0.383988,
				"y": 0.322859
			},
			{
				"x": 0.400661,
				"y": 0.325956
			},
			{
				"x": 0.422384,
				"y": 0.324085
			},
			{
				"x": 0.444136,
				"y": 0.322535
			},
			{
				"x": 0.465911,
				"y": 0.321314
			},
			{
				"x": 0.487705,
				"y": 0.320445
			},
			{
				"x": 0.509513,
				"y": 0.319965
			},
			{
				"x": 0.531327,
				"y": 0.31994
			},
			{
				"x": 0.553136,
				"y": 0.320374
			},
			{
				"x": 0.574932,
				"y": 0.321204
			},
			{
				"x": 0.596709,
				"y": 0.322389
			},
			{
				"x": 0.618464,
				"y": 0.323904
			}
		]
	},
	"stuck_out_tongue_closed_eyes": {
		"lb": [
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			}
		],
		"rb": [
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			}
		],
		"le": [
			{
				"x": 0.781904,
				"y": 0.467951
			},
			{
				"x": 0.769261,
				"y": 0.456739
			},
			{
				"x": 0.750201,
				"y": 0.458683
			},
			{
				"x": 0.731854,
				"y": 0.464206
			},
			{
				"x": 0.714044,
				"y": 0.47113
			},
			{
				"x": 0.696612,
				"y": 0.478862
			},
			{
				"x": 0.679473,
				"y": 0.487157
			},
			{
				"x": 0.662584,
				"y": 0.495895
			},
			{
				"x": 0.64593,
				"y": 0.505024
			},
			{
				"x": 0.629515,
				"y": 0.514529
			},
			{
				"x": 0.613341,
				"y": 0.524394
			},
			{
				"x": 0.597407,
				"y": 0.534599
			},
			{
				"x": 0.581703,
				"y": 0.545115
			},
			{
				"x": 0.566246,
				"y": 0.555951
			},
			{
				"x": 0.552326,
				"y": 0.568425
			},
			{
				"x": 0.549267,
				"y": 0.585444
			},
			{
				"x": 0.560955,
				"y": 0.599702
			},
			{
				"x": 0.575716,
				"y": 0.611355
			},
			{
				"x": 0.591204,
				"y": 0.622151
			},
			{
				"x": 0.606902,
				"y": 0.632676
			},
			{
				"x": 0.622562,
				"y": 0.643251
			},
			{
				"x": 0.637988,
				"y": 0.654125
			},
			{
				"x": 0.653102,
				"y": 0.665383
			},
			{
				"x": 0.668138,
				"y": 0.676732
			},
			{
				"x": 0.683428,
				"y": 0.687775
			},
			{
				"x": 0.699383,
				"y": 0.697943
			},
			{
				"x": 0.716466,
				"y": 0.706303
			},
			{
				"x": 0.734929,
				"y": 0.711352
			},
			{
				"x": 0.754124,
				"y": 0.711738
			},
			{
				"x": 0.770814,
				"y": 0.703785
			},
			{
				"x": 0.767638,
				"y": 0.687005
			},
			{
				"x": 0.754188,
				"y": 0.674062
			},
			{
				"x": 0.73904,
				"y": 0.662851
			},
			{
				"x": 0.72328,
				"y": 0.652411
			},
			{
				"x": 0.707217,
				"y": 0.642387
			},
			{
				"x": 0.690999,
				"y": 0.632586
			},
			{
				"x": 0.674733,
				"y": 0.622856
			},
			{
				"x": 0.658541,
				"y": 0.613016
			},
			{
				"x": 0.642708,
				"y": 0.602677
			},
			{
				"x": 0.628692,
				"y": 0.590326
			},
			{
				"x": 0.630561,
				"y": 0.574024
			},
			{
				"x": 0.645841,
				"y": 0.56304
			},
			{
				"x": 0.662425,
				"y": 0.553801
			},
			{
				"x": 0.679275,
				"y": 0.544995
			},
			{
				"x": 0.696164,
				"y": 0.536257
			},
			{
				"x": 0.712971,
				"y": 0.52738
			},
			{
				"x": 0.729573,
				"y": 0.518167
			},
			{
				"x": 0.745778,
				"y": 0.50835
			},
			{
				"x": 0.761153,
				"y": 0.497425
			},
			{
				"x": 0.774504,
				"y": 0.484389
			}
		],
		"re": [
			{
				"x": 0.218096,
				"y": 0.467951
			},
			{
				"x": 0.230739,
				"y": 0.456739
			},
			{
				"x": 0.249799,
				"y": 0.458683
			},
			{
				"x": 0.268146,
				"y": 0.464206
			},
			{
				"x": 0.285956,
				"y": 0.47113
			},
			{
				"x": 0.303388,
				"y": 0.478862
			},
			{
				"x": 0.320527,
				"y": 0.487157
			},
			{
				"x": 0.337416,
				"y": 0.495895
			},
			{
				"x": 0.35407,
				"y": 0.505024
			},
			{
				"x": 0.370485,
				"y": 0.514529
			},
			{
				"x": 0.386659,
				"y": 0.524394
			},
			{
				"x": 0.402593,
				"y": 0.534599
			},
			{
				"x": 0.418297,
				"y": 0.545115
			},
			{
				"x": 0.433754,
				"y": 0.555951
			},
			{
				"x": 0.447674,
				"y": 0.568425
			},
			{
				"x": 0.450733,
				"y": 0.585444
			},
			{
				"x": 0.439045,
				"y": 0.599702
			},
			{
				"x": 0.424284,
				"y": 0.611355
			},
			{
				"x": 0.408796,
				"y": 0.622151
			},
			{
				"x": 0.393098,
				"y": 0.632676
			},
			{
				"x": 0.377438,
				"y": 0.643251
			},
			{
				"x": 0.362012,
				"y": 0.654125
			},
			{
				"x": 0.346898,
				"y": 0.665383
			},
			{
				"x": 0.331862,
				"y": 0.676732
			},
			{
				"x": 0.316572,
				"y": 0.687775
			},
			{
				"x": 0.300617,
				"y": 0.697943
			},
			{
				"x": 0.283534,
				"y": 0.706303
			},
			{
				"x": 0.265071,
				"y": 0.711352
			},
			{
				"x": 0.245876,
				"y": 0.711738
			},
			{
				"x": 0.229186,
				"y": 0.703785
			},
			{
				"x": 0.232362,
				"y": 0.687005
			},
			{
				"x": 0.245812,
				"y": 0.674062
			},
			{
				"x": 0.26096,
				"y": 0.662851
			},
			{
				"x": 0.27672,
				"y": 0.652411
			},
			{
				"x": 0.292783,
				"y": 0.642387
			},
			{
				"x": 0.309001,
				"y": 0.632586
			},
			{
				"x": 0.325267,
				"y": 0.622856
			},
			{
				"x": 0.341459,
				"y": 0.613016
			},
			{
				"x": 0.357292,
				"y": 0.602677
			},
			{
				"x": 0.371308,
				"y": 0.590326
			},
			{
				"x": 0.369439,
				"y": 0.574024
			},
			{
				"x": 0.354159,
				"y": 0.56304
			},
			{
				"x": 0.337575,
				"y": 0.553801
			},
			{
				"x": 0.320725,
				"y": 0.544995
			},
			{
				"x": 0.303836,
				"y": 0.536257
			},
			{
				"x": 0.287029,
				"y": 0.52738
			},
			{
				"x": 0.270427,
				"y": 0.518167
			},
			{
				"x": 0.254222,
				"y": 0.50835
			},
			{
				"x": 0.238847,
				"y": 0.497425
			},
			{
				"x": 0.225496,
				"y": 0.484389
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.530151
			},
			{
				"x": 0.996057,
				"y": 0.589155
			},
			{
				"x": 0.984292,
				"y": 0.647229
			},
			{
				"x": 0.964888,
				"y": 0.703456
			},
			{
				"x": 0.938153,
				"y": 0.75695
			},
			{
				"x": 0.904508,
				"y": 0.806867
			},
			{
				"x": 0.864484,
				"y": 0.852421
			},
			{
				"x": 0.818712,
				"y": 0.892892
			},
			{
				"x": 0.767913,
				"y": 0.927642
			},
			{
				"x": 0.71289,
				"y": 0.956124
			},
			{
				"x": 0.654508,
				"y": 0.977887
			},
			{
				"x": 0.593691,
				"y": 0.99259
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.99259
			},
			{
				"x": 0.345492,
				"y": 0.977887
			},
			{
				"x": 0.28711,
				"y": 0.956124
			},
			{
				"x": 0.232087,
				"y": 0.927642
			},
			{
				"x": 0.181288,
				"y": 0.892892
			},
			{
				"x": 0.135516,
				"y": 0.852421
			},
			{
				"x": 0.095492,
				"y": 0.806867
			},
			{
				"x": 0.061847,
				"y": 0.75695
			},
			{
				"x": 0.035112,
				"y": 0.703456
			},
			{
				"x": 0.015708,
				"y": 0.647229
			},
			{
				"x": 0.003943,
				"y": 0.589155
			},
			{
				"x": 0,
				"y": 0.530151
			},
			{
				"x": 0.003943,
				"y": 0.471147
			},
			{
				"x": 0.015708,
				"y": 0.413073
			},
			{
				"x": 0.035112,
				"y": 0.356846
			},
			{
				"x": 0.061847,
				"y": 0.303352
			},
			{
				"x": 0.095492,
				"y": 0.253434
			},
			{
				"x": 0.135516,
				"y": 0.207881
			},
			{
				"x": 0.181288,
				"y": 0.16741
			},
			{
				"x": 0.232087,
				"y": 0.13266
			},
			{
				"x": 0.28711,
				"y": 0.104178
			},
			{
				"x": 0.345492,
				"y": 0.082414
			},
			{
				"x": 0.406309,
				"y": 0.067711
			},
			{
				"x": 0.468605,
				"y": 0.060302
			},
			{
				"x": 0.531395,
				"y": 0.060302
			},
			{
				"x": 0.593691,
				"y": 0.067711
			},
			{
				"x": 0.654508,
				"y": 0.082414
			},
			{
				"x": 0.71289,
				"y": 0.104178
			},
			{
				"x": 0.767913,
				"y": 0.13266
			},
			{
				"x": 0.818712,
				"y": 0.16741
			},
			{
				"x": 0.864484,
				"y": 0.207881
			},
			{
				"x": 0.904508,
				"y": 0.253434
			},
			{
				"x": 0.938153,
				"y": 0.303352
			},
			{
				"x": 0.964888,
				"y": 0.356846
			},
			{
				"x": 0.984292,
				"y": 0.413073
			},
			{
				"x": 0.996057,
				"y": 0.471147
			}
		],
		"mouth": [
			{
				"x": 0.247984,
				"y": 0.378448
			},
			{
				"x": 0.250099,
				"y": 0.353733
			},
			{
				"x": 0.256326,
				"y": 0.32964
			},
			{
				"x": 0.266348,
				"y": 0.306707
			},
			{
				"x": 0.279719,
				"y": 0.285338
			},
			{
				"x": 0.295946,
				"y": 0.265798
			},
			{
				"x": 0.314551,
				"y": 0.248232
			},
			{
				"x": 0.335099,
				"y": 0.232702
			},
			{
				"x": 0.357218,
				"y": 0.219216
			},
			{
				"x": 0.380589,
				"y": 0.207752
			},
			{
				"x": 0.404945,
				"y": 0.198274
			},
			{
				"x": 0.430056,
				"y": 0.190743
			},
			{
				"x": 0.455727,
				"y": 0.185124
			},
			{
				"x": 0.481782,
				"y": 0.181386
			},
			{
				"x": 0.508062,
				"y": 0.179511
			},
			{
				"x": 0.534417,
				"y": 0.179486
			},
			{
				"x": 0.560702,
				"y": 0.181313
			},
			{
				"x": 0.586764,
				"y": 0.185001
			},
			{
				"x": 0.612447,
				"y": 0.190571
			},
			{
				"x": 0.637575,
				"y": 0.198051
			},
			{
				"x": 0.661954,
				"y": 0.207478
			},
			{
				"x": 0.685354,
				"y": 0.218889
			},
			{
				"x": 0.70751,
				"y": 0.232321
			},
			{
				"x": 0.728104,
				"y": 0.247797
			},
			{
				"x": 0.746765,
				"y": 0.26531
			},
			{
				"x": 0.763061,
				"y": 0.2848
			},
			{
				"x": 0.776513,
				"y": 0.306124
			},
			{
				"x": 0.786629,
				"y": 0.32902
			},
			{
				"x": 0.792961,
				"y": 0.353089
			},
			{
				"x": 0.795186,
				"y": 0.377795
			},
			{
				"x": 0.770479,
				"y": 0.371922
			},
			{
				"x": 0.744723,
				"y": 0.366642
			},
			{
				"x": 0.718776,
				"y": 0.362262
			},
			{
				"x": 0.692711,
				"y": 0.358554
			},
			{
				"x": 0.666563,
				"y": 0.355402
			},
			{
				"x": 0.640352,
				"y": 0.352749
			},
			{
				"x": 0.614093,
				"y": 0.350567
			},
			{
				"x": 0.587794,
				"y": 0.348856
			},
			{
				"x": 0.561465,
				"y": 0.34764
			},
			{
				"x": 0.535113,
				"y": 0.346977
			},
			{
				"x": 0.508752,
				"y": 0.346968
			},
			{
				"x": 0.4824,
				"y": 0.347615
			},
			{
				"x": 0.456069,
				"y": 0.348817
			},
			{
				"x": 0.42977,
				"y": 0.350516
			},
			{
				"x": 0.403509,
				"y": 0.352685
			},
			{
				"x": 0.377298,
				"y": 0.355326
			},
			{
				"x": 0.351148,
				"y": 0.358464
			},
			{
				"x": 0.32508,
				"y": 0.362157
			},
			{
				"x": 0.299129,
				"y": 0.366517
			},
			{
				"x": 0.273366,
				"y": 0.371769
			}
		],
		"tongue": [
			{
				"x": 0.64019,
				"y": 0.325741
			},
			{
				"x": 0.64019,
				"y": 0.305201
			},
			{
				"x": 0.64019,
				"y": 0.284662
			},
			{
				"x": 0.64019,
				"y": 0.264123
			},
			{
				"x": 0.64019,
				"y": 0.243584
			},
			{
				"x": 0.64019,
				"y": 0.223044
			},
			{
				"x": 0.64019,
				"y": 0.202505
			},
			{
				"x": 0.64019,
				"y": 0.181966
			},
			{
				"x": 0.64019,
				"y": 0.161427
			},
			{
				"x": 0.64019,
				"y": 0.140887
			},
			{
				"x": 0.640185,
				"y": 0.120348
			},
			{
				"x": 0.637929,
				"y": 0.09995
			},
			{
				"x": 0.631589,
				"y": 0.08033
			},
			{
				"x": 0.621508,
				"y": 0.062147
			},
			{
				"x": 0.608294,
				"y": 0.045832
			},
			{
				"x": 0.592585,
				"y": 0.031608
			},
			{
				"x": 0.574912,
				"y": 0.019595
			},
			{
				"x": 0.555667,
				"y": 0.009958
			},
			{
				"x": 0.535136,
				"y": 0.003084
			},
			{
				"x": 0.513619,
				"y": 0
			},
			{
				"x": 0.492011,
				"y": 0.002384
			},
			{
				"x": 0.471319,
				"y": 0.008813
			},
			{
				"x": 0.451879,
				"y": 0.018095
			},
			{
				"x": 0.433965,
				"y": 0.029787
			},
			{
				"x": 0.417951,
				"y": 0.043708
			},
			{
				"x": 0.40435,
				"y": 0.059738
			},
			{
				"x": 0.393791,
				"y": 0.07768
			},
			{
				"x": 0.386896,
				"y": 0.097134
			},
			{
				"x": 0.384062,
				"y": 0.117468
			},
			{
				"x": 0.383988,
				"y": 0.138006
			},
			{
				"x": 0.383988,
				"y": 0.158545
			},
			{
				"x": 0.383988,
				"y": 0.179084
			},
			{
				"x": 0.383988,
				"y": 0.199624
			},
			{
				"x": 0.383988,
				"y": 0.220163
			},
			{
				"x": 0.383988,
				"y": 0.240702
			},
			{
				"x": 0.383988,
				"y": 0.261242
			},
			{
				"x": 0.383988,
				"y": 0.281781
			},
			{
				"x": 0.383988,
				"y": 0.30232
			},
			{
				"x": 0.383988,
				"y": 0.322859
			},
			{
				"x": 0.400661,
				"y": 0.325956
			},
			{
				"x": 0.422384,
				"y": 0.324085
			},
			{
				"x": 0.444136,
				"y": 0.322535
			},
			{
				"x": 0.465911,
				"y": 0.321314
			},
			{
				"x": 0.487705,
				"y": 0.320445
			},
			{
				"x": 0.509513,
				"y": 0.319965
			},
			{
				"x": 0.531327,
				"y": 0.31994
			},
			{
				"x": 0.553136,
				"y": 0.320374
			},
			{
				"x": 0.574932,
				"y": 0.321204
			},
			{
				"x": 0.596709,
				"y": 0.322389
			},
			{
				"x": 0.618464,
				"y": 0.323904
			}
		]
	},
	"stuck_out_tongue": {
		"lb": [
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			}
		],
		"rb": [
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			},
			{
				"x": 0.5,
				"y": 0.500456
			}
		],
		"le": [
			{
				"x": 0.742431,
				"y": 0.547515
			},
			{
				"x": 0.742105,
				"y": 0.540635
			},
			{
				"x": 0.741124,
				"y": 0.533811
			},
			{
				"x": 0.739484,
				"y": 0.5271
			},
			{
				"x": 0.737174,
				"y": 0.520567
			},
			{
				"x": 0.734183,
				"y": 0.514283
			},
			{
				"x": 0.7305,
				"y": 0.508335
			},
			{
				"x": 0.726118,
				"y": 0.502824
			},
			{
				"x": 0.72104,
				"y": 0.497872
			},
			{
				"x": 0.715292,
				"y": 0.493619
			},
			{
				"x": 0.708935,
				"y": 0.490223
			},
			{
				"x": 0.702078,
				"y": 0.487844
			},
			{
				"x": 0.694889,
				"y": 0.486614
			},
			{
				"x": 0.687583,
				"y": 0.486614
			},
			{
				"x": 0.680394,
				"y": 0.487844
			},
			{
				"x": 0.673537,
				"y": 0.490223
			},
			{
				"x": 0.66718,
				"y": 0.493619
			},
			{
				"x": 0.661432,
				"y": 0.497872
			},
			{
				"x": 0.656355,
				"y": 0.502824
			},
			{
				"x": 0.651972,
				"y": 0.508335
			},
			{
				"x": 0.648289,
				"y": 0.514283
			},
			{
				"x": 0.645298,
				"y": 0.520567
			},
			{
				"x": 0.642988,
				"y": 0.5271
			},
			{
				"x": 0.641348,
				"y": 0.533811
			},
			{
				"x": 0.640368,
				"y": 0.540635
			},
			{
				"x": 0.640041,
				"y": 0.547515
			},
			{
				"x": 0.640368,
				"y": 0.554395
			},
			{
				"x": 0.641348,
				"y": 0.561219
			},
			{
				"x": 0.642988,
				"y": 0.56793
			},
			{
				"x": 0.645298,
				"y": 0.574463
			},
			{
				"x": 0.648289,
				"y": 0.580747
			},
			{
				"x": 0.651972,
				"y": 0.586695
			},
			{
				"x": 0.656355,
				"y": 0.592206
			},
			{
				"x": 0.661432,
				"y": 0.597158
			},
			{
				"x": 0.66718,
				"y": 0.601411
			},
			{
				"x": 0.673537,
				"y": 0.604807
			},
			{
				"x": 0.680394,
				"y": 0.607187
			},
			{
				"x": 0.687583,
				"y": 0.608416
			},
			{
				"x": 0.694889,
				"y": 0.608416
			},
			{
				"x": 0.702078,
				"y": 0.607187
			},
			{
				"x": 0.708935,
				"y": 0.604807
			},
			{
				"x": 0.715292,
				"y": 0.601411
			},
			{
				"x": 0.72104,
				"y": 0.597158
			},
			{
				"x": 0.726118,
				"y": 0.592206
			},
			{
				"x": 0.7305,
				"y": 0.586695
			},
			{
				"x": 0.734183,
				"y": 0.580747
			},
			{
				"x": 0.737174,
				"y": 0.574463
			},
			{
				"x": 0.739484,
				"y": 0.56793
			},
			{
				"x": 0.741124,
				"y": 0.561219
			},
			{
				"x": 0.742105,
				"y": 0.554395
			}
		],
		"re": [
			{
				"x": 0.257569,
				"y": 0.547515
			},
			{
				"x": 0.257895,
				"y": 0.540635
			},
			{
				"x": 0.258876,
				"y": 0.533811
			},
			{
				"x": 0.260516,
				"y": 0.5271
			},
			{
				"x": 0.262826,
				"y": 0.520567
			},
			{
				"x": 0.265817,
				"y": 0.514283
			},
			{
				"x": 0.2695,
				"y": 0.508335
			},
			{
				"x": 0.273882,
				"y": 0.502824
			},
			{
				"x": 0.27896,
				"y": 0.497872
			},
			{
				"x": 0.284708,
				"y": 0.493619
			},
			{
				"x": 0.291065,
				"y": 0.490223
			},
			{
				"x": 0.297922,
				"y": 0.487844
			},
			{
				"x": 0.305111,
				"y": 0.486614
			},
			{
				"x": 0.312417,
				"y": 0.486614
			},
			{
				"x": 0.319606,
				"y": 0.487844
			},
			{
				"x": 0.326463,
				"y": 0.490223
			},
			{
				"x": 0.33282,
				"y": 0.493619
			},
			{
				"x": 0.338568,
				"y": 0.497872
			},
			{
				"x": 0.343645,
				"y": 0.502824
			},
			{
				"x": 0.348028,
				"y": 0.508335
			},
			{
				"x": 0.351711,
				"y": 0.514283
			},
			{
				"x": 0.354702,
				"y": 0.520567
			},
			{
				"x": 0.357012,
				"y": 0.5271
			},
			{
				"x": 0.358652,
				"y": 0.533811
			},
			{
				"x": 0.359632,
				"y": 0.540635
			},
			{
				"x": 0.359959,
				"y": 0.547515
			},
			{
				"x": 0.359632,
				"y": 0.554395
			},
			{
				"x": 0.358652,
				"y": 0.561219
			},
			{
				"x": 0.357012,
				"y": 0.56793
			},
			{
				"x": 0.354702,
				"y": 0.574463
			},
			{
				"x": 0.351711,
				"y": 0.580747
			},
			{
				"x": 0.348028,
				"y": 0.586695
			},
			{
				"x": 0.343645,
				"y": 0.592206
			},
			{
				"x": 0.338568,
				"y": 0.597158
			},
			{
				"x": 0.33282,
				"y": 0.601411
			},
			{
				"x": 0.326463,
				"y": 0.604807
			},
			{
				"x": 0.319606,
				"y": 0.607187
			},
			{
				"x": 0.312417,
				"y": 0.608416
			},
			{
				"x": 0.305111,
				"y": 0.608416
			},
			{
				"x": 0.297922,
				"y": 0.607187
			},
			{
				"x": 0.291065,
				"y": 0.604807
			},
			{
				"x": 0.284708,
				"y": 0.601411
			},
			{
				"x": 0.27896,
				"y": 0.597158
			},
			{
				"x": 0.273882,
				"y": 0.592206
			},
			{
				"x": 0.2695,
				"y": 0.586695
			},
			{
				"x": 0.265817,
				"y": 0.580747
			},
			{
				"x": 0.262826,
				"y": 0.574463
			},
			{
				"x": 0.260516,
				"y": 0.56793
			},
			{
				"x": 0.258876,
				"y": 0.561219
			},
			{
				"x": 0.257895,
				"y": 0.554395
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.530151
			},
			{
				"x": 0.996057,
				"y": 0.589155
			},
			{
				"x": 0.984292,
				"y": 0.647229
			},
			{
				"x": 0.964888,
				"y": 0.703456
			},
			{
				"x": 0.938153,
				"y": 0.75695
			},
			{
				"x": 0.904508,
				"y": 0.806867
			},
			{
				"x": 0.864484,
				"y": 0.852421
			},
			{
				"x": 0.818712,
				"y": 0.892892
			},
			{
				"x": 0.767913,
				"y": 0.927642
			},
			{
				"x": 0.71289,
				"y": 0.956124
			},
			{
				"x": 0.654508,
				"y": 0.977887
			},
			{
				"x": 0.593691,
				"y": 0.99259
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.99259
			},
			{
				"x": 0.345492,
				"y": 0.977887
			},
			{
				"x": 0.28711,
				"y": 0.956124
			},
			{
				"x": 0.232087,
				"y": 0.927642
			},
			{
				"x": 0.181288,
				"y": 0.892892
			},
			{
				"x": 0.135516,
				"y": 0.852421
			},
			{
				"x": 0.095492,
				"y": 0.806867
			},
			{
				"x": 0.061847,
				"y": 0.75695
			},
			{
				"x": 0.035112,
				"y": 0.703456
			},
			{
				"x": 0.015708,
				"y": 0.647229
			},
			{
				"x": 0.003943,
				"y": 0.589155
			},
			{
				"x": 0,
				"y": 0.530151
			},
			{
				"x": 0.003943,
				"y": 0.471147
			},
			{
				"x": 0.015708,
				"y": 0.413073
			},
			{
				"x": 0.035112,
				"y": 0.356846
			},
			{
				"x": 0.061847,
				"y": 0.303352
			},
			{
				"x": 0.095492,
				"y": 0.253434
			},
			{
				"x": 0.135516,
				"y": 0.207881
			},
			{
				"x": 0.181288,
				"y": 0.16741
			},
			{
				"x": 0.232087,
				"y": 0.13266
			},
			{
				"x": 0.28711,
				"y": 0.104178
			},
			{
				"x": 0.345492,
				"y": 0.082414
			},
			{
				"x": 0.406309,
				"y": 0.067711
			},
			{
				"x": 0.468605,
				"y": 0.060302
			},
			{
				"x": 0.531395,
				"y": 0.060302
			},
			{
				"x": 0.593691,
				"y": 0.067711
			},
			{
				"x": 0.654508,
				"y": 0.082414
			},
			{
				"x": 0.71289,
				"y": 0.104178
			},
			{
				"x": 0.767913,
				"y": 0.13266
			},
			{
				"x": 0.818712,
				"y": 0.16741
			},
			{
				"x": 0.864484,
				"y": 0.207881
			},
			{
				"x": 0.904508,
				"y": 0.253434
			},
			{
				"x": 0.938153,
				"y": 0.303352
			},
			{
				"x": 0.964888,
				"y": 0.356846
			},
			{
				"x": 0.984292,
				"y": 0.413073
			},
			{
				"x": 0.996057,
				"y": 0.471147
			}
		],
		"mouth": [
			{
				"x": 0.247984,
				"y": 0.378448
			},
			{
				"x": 0.250099,
				"y": 0.353733
			},
			{
				"x": 0.256326,
				"y": 0.32964
			},
			{
				"x": 0.266348,
				"y": 0.306707
			},
			{
				"x": 0.279719,
				"y": 0.285338
			},
			{
				"x": 0.295946,
				"y": 0.265798
			},
			{
				"x": 0.314551,
				"y": 0.248232
			},
			{
				"x": 0.335099,
				"y": 0.232702
			},
			{
				"x": 0.357218,
				"y": 0.219216
			},
			{
				"x": 0.380589,
				"y": 0.207752
			},
			{
				"x": 0.404945,
				"y": 0.198274
			},
			{
				"x": 0.430056,
				"y": 0.190743
			},
			{
				"x": 0.455727,
				"y": 0.185124
			},
			{
				"x": 0.481782,
				"y": 0.181386
			},
			{
				"x": 0.508062,
				"y": 0.179511
			},
			{
				"x": 0.534417,
				"y": 0.179486
			},
			{
				"x": 0.560702,
				"y": 0.181313
			},
			{
				"x": 0.586764,
				"y": 0.185001
			},
			{
				"x": 0.612447,
				"y": 0.190571
			},
			{
				"x": 0.637575,
				"y": 0.198051
			},
			{
				"x": 0.661954,
				"y": 0.207478
			},
			{
				"x": 0.685354,
				"y": 0.218889
			},
			{
				"x": 0.70751,
				"y": 0.232321
			},
			{
				"x": 0.728104,
				"y": 0.247797
			},
			{
				"x": 0.746765,
				"y": 0.26531
			},
			{
				"x": 0.763061,
				"y": 0.2848
			},
			{
				"x": 0.776513,
				"y": 0.306124
			},
			{
				"x": 0.786629,
				"y": 0.32902
			},
			{
				"x": 0.792961,
				"y": 0.353089
			},
			{
				"x": 0.795186,
				"y": 0.377795
			},
			{
				"x": 0.770479,
				"y": 0.371922
			},
			{
				"x": 0.744723,
				"y": 0.366642
			},
			{
				"x": 0.718776,
				"y": 0.362262
			},
			{
				"x": 0.692711,
				"y": 0.358554
			},
			{
				"x": 0.666563,
				"y": 0.355402
			},
			{
				"x": 0.640352,
				"y": 0.352749
			},
			{
				"x": 0.614093,
				"y": 0.350567
			},
			{
				"x": 0.587794,
				"y": 0.348856
			},
			{
				"x": 0.561465,
				"y": 0.34764
			},
			{
				"x": 0.535113,
				"y": 0.346977
			},
			{
				"x": 0.508752,
				"y": 0.346968
			},
			{
				"x": 0.4824,
				"y": 0.347615
			},
			{
				"x": 0.456069,
				"y": 0.348817
			},
			{
				"x": 0.42977,
				"y": 0.350516
			},
			{
				"x": 0.403509,
				"y": 0.352685
			},
			{
				"x": 0.377298,
				"y": 0.355326
			},
			{
				"x": 0.351148,
				"y": 0.358464
			},
			{
				"x": 0.32508,
				"y": 0.362157
			},
			{
				"x": 0.299129,
				"y": 0.366517
			},
			{
				"x": 0.273366,
				"y": 0.371769
			}
		],
		"tongue": [
			{
				"x": 0.64019,
				"y": 0.325741
			},
			{
				"x": 0.64019,
				"y": 0.305201
			},
			{
				"x": 0.64019,
				"y": 0.284662
			},
			{
				"x": 0.64019,
				"y": 0.264123
			},
			{
				"x": 0.64019,
				"y": 0.243584
			},
			{
				"x": 0.64019,
				"y": 0.223044
			},
			{
				"x": 0.64019,
				"y": 0.202505
			},
			{
				"x": 0.64019,
				"y": 0.181966
			},
			{
				"x": 0.64019,
				"y": 0.161427
			},
			{
				"x": 0.64019,
				"y": 0.140887
			},
			{
				"x": 0.640185,
				"y": 0.120348
			},
			{
				"x": 0.637929,
				"y": 0.09995
			},
			{
				"x": 0.631589,
				"y": 0.08033
			},
			{
				"x": 0.621508,
				"y": 0.062147
			},
			{
				"x": 0.608294,
				"y": 0.045832
			},
			{
				"x": 0.592585,
				"y": 0.031608
			},
			{
				"x": 0.574912,
				"y": 0.019595
			},
			{
				"x": 0.555667,
				"y": 0.009958
			},
			{
				"x": 0.535136,
				"y": 0.003084
			},
			{
				"x": 0.513619,
				"y": 0
			},
			{
				"x": 0.492011,
				"y": 0.002384
			},
			{
				"x": 0.471319,
				"y": 0.008813
			},
			{
				"x": 0.451879,
				"y": 0.018095
			},
			{
				"x": 0.433965,
				"y": 0.029787
			},
			{
				"x": 0.417951,
				"y": 0.043708
			},
			{
				"x": 0.40435,
				"y": 0.059738
			},
			{
				"x": 0.393791,
				"y": 0.07768
			},
			{
				"x": 0.386896,
				"y": 0.097134
			},
			{
				"x": 0.384062,
				"y": 0.117468
			},
			{
				"x": 0.383988,
				"y": 0.138006
			},
			{
				"x": 0.383988,
				"y": 0.158545
			},
			{
				"x": 0.383988,
				"y": 0.179084
			},
			{
				"x": 0.383988,
				"y": 0.199624
			},
			{
				"x": 0.383988,
				"y": 0.220163
			},
			{
				"x": 0.383988,
				"y": 0.240702
			},
			{
				"x": 0.383988,
				"y": 0.261242
			},
			{
				"x": 0.383988,
				"y": 0.281781
			},
			{
				"x": 0.383988,
				"y": 0.30232
			},
			{
				"x": 0.383988,
				"y": 0.322859
			},
			{
				"x": 0.400661,
				"y": 0.325956
			},
			{
				"x": 0.422384,
				"y": 0.324085
			},
			{
				"x": 0.444136,
				"y": 0.322535
			},
			{
				"x": 0.465911,
				"y": 0.321314
			},
			{
				"x": 0.487705,
				"y": 0.320445
			},
			{
				"x": 0.509513,
				"y": 0.319965
			},
			{
				"x": 0.531327,
				"y": 0.31994
			},
			{
				"x": 0.553136,
				"y": 0.320374
			},
			{
				"x": 0.574932,
				"y": 0.321204
			},
			{
				"x": 0.596709,
				"y": 0.322389
			},
			{
				"x": 0.618464,
				"y": 0.323904
			}
		]
	},
	"sunglasses": {
		"lb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"rb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"le": [
			{
				"x": 0.961654,
				"y": 0.693722
			},
			{
				"x": 0.95403,
				"y": 0.670663
			},
			{
				"x": 0.946032,
				"y": 0.647731
			},
			{
				"x": 0.937605,
				"y": 0.624955
			},
			{
				"x": 0.928677,
				"y": 0.60237
			},
			{
				"x": 0.919161,
				"y": 0.580029
			},
			{
				"x": 0.908943,
				"y": 0.558001
			},
			{
				"x": 0.897877,
				"y": 0.53639
			},
			{
				"x": 0.88577,
				"y": 0.515348
			},
			{
				"x": 0.872374,
				"y": 0.495107
			},
			{
				"x": 0.857379,
				"y": 0.476031
			},
			{
				"x": 0.840446,
				"y": 0.458666
			},
			{
				"x": 0.821337,
				"y": 0.443753
			},
			{
				"x": 0.800159,
				"y": 0.431982
			},
			{
				"x": 0.777336,
				"y": 0.423877
			},
			{
				"x": 0.75346,
				"y": 0.419836
			},
			{
				"x": 0.72924,
				"y": 0.419728
			},
			{
				"x": 0.705218,
				"y": 0.422903
			},
			{
				"x": 0.681602,
				"y": 0.428373
			},
			{
				"x": 0.658391,
				"y": 0.435369
			},
			{
				"x": 0.635893,
				"y": 0.444387
			},
			{
				"x": 0.614839,
				"y": 0.456375
			},
			{
				"x": 0.596527,
				"y": 0.472218
			},
			{
				"x": 0.582042,
				"y": 0.49165
			},
			{
				"x": 0.570585,
				"y": 0.513045
			},
			{
				"x": 0.560685,
				"y": 0.535218
			},
			{
				"x": 0.550616,
				"y": 0.557311
			},
			{
				"x": 0.53822,
				"y": 0.578154
			},
			{
				"x": 0.520866,
				"y": 0.594899
			},
			{
				"x": 0.5,
				"y": 0.603101
			},
			{
				"x": 0.5,
				"y": 0.627393
			},
			{
				"x": 0.503883,
				"y": 0.64784
			},
			{
				"x": 0.528042,
				"y": 0.649749
			},
			{
				"x": 0.552035,
				"y": 0.653225
			},
			{
				"x": 0.575946,
				"y": 0.657236
			},
			{
				"x": 0.599846,
				"y": 0.661311
			},
			{
				"x": 0.62377,
				"y": 0.665245
			},
			{
				"x": 0.647729,
				"y": 0.668952
			},
			{
				"x": 0.671727,
				"y": 0.672402
			},
			{
				"x": 0.69576,
				"y": 0.675602
			},
			{
				"x": 0.719823,
				"y": 0.678557
			},
			{
				"x": 0.743916,
				"y": 0.68127
			},
			{
				"x": 0.768034,
				"y": 0.683739
			},
			{
				"x": 0.792176,
				"y": 0.68596
			},
			{
				"x": 0.81634,
				"y": 0.687925
			},
			{
				"x": 0.840524,
				"y": 0.689626
			},
			{
				"x": 0.864726,
				"y": 0.691053
			},
			{
				"x": 0.888943,
				"y": 0.692192
			},
			{
				"x": 0.913173,
				"y": 0.693028
			},
			{
				"x": 0.937411,
				"y": 0.693545
			}
		],
		"re": [
			{
				"x": 0.038346,
				"y": 0.693722
			},
			{
				"x": 0.04597,
				"y": 0.670663
			},
			{
				"x": 0.053968,
				"y": 0.647731
			},
			{
				"x": 0.062395,
				"y": 0.624955
			},
			{
				"x": 0.071323,
				"y": 0.60237
			},
			{
				"x": 0.080839,
				"y": 0.580029
			},
			{
				"x": 0.091057,
				"y": 0.558001
			},
			{
				"x": 0.102123,
				"y": 0.53639
			},
			{
				"x": 0.11423,
				"y": 0.515348
			},
			{
				"x": 0.127626,
				"y": 0.495107
			},
			{
				"x": 0.142621,
				"y": 0.476031
			},
			{
				"x": 0.159554,
				"y": 0.458666
			},
			{
				"x": 0.178663,
				"y": 0.443753
			},
			{
				"x": 0.199841,
				"y": 0.431982
			},
			{
				"x": 0.222664,
				"y": 0.423877
			},
			{
				"x": 0.24654,
				"y": 0.419836
			},
			{
				"x": 0.27076,
				"y": 0.419728
			},
			{
				"x": 0.294782,
				"y": 0.422903
			},
			{
				"x": 0.318398,
				"y": 0.428373
			},
			{
				"x": 0.341609,
				"y": 0.435369
			},
			{
				"x": 0.364107,
				"y": 0.444387
			},
			{
				"x": 0.385161,
				"y": 0.456375
			},
			{
				"x": 0.403473,
				"y": 0.472218
			},
			{
				"x": 0.417958,
				"y": 0.49165
			},
			{
				"x": 0.429415,
				"y": 0.513045
			},
			{
				"x": 0.439315,
				"y": 0.535218
			},
			{
				"x": 0.449384,
				"y": 0.557311
			},
			{
				"x": 0.46178,
				"y": 0.578154
			},
			{
				"x": 0.479134,
				"y": 0.594899
			},
			{
				"x": 0.5,
				"y": 0.603101
			},
			{
				"x": 0.5,
				"y": 0.627393
			},
			{
				"x": 0.496117,
				"y": 0.64784
			},
			{
				"x": 0.471958,
				"y": 0.649749
			},
			{
				"x": 0.447965,
				"y": 0.653225
			},
			{
				"x": 0.424054,
				"y": 0.657236
			},
			{
				"x": 0.400154,
				"y": 0.661311
			},
			{
				"x": 0.37623,
				"y": 0.665245
			},
			{
				"x": 0.352271,
				"y": 0.668952
			},
			{
				"x": 0.328273,
				"y": 0.672402
			},
			{
				"x": 0.30424,
				"y": 0.675602
			},
			{
				"x": 0.280177,
				"y": 0.678557
			},
			{
				"x": 0.256084,
				"y": 0.68127
			},
			{
				"x": 0.231966,
				"y": 0.683739
			},
			{
				"x": 0.207824,
				"y": 0.68596
			},
			{
				"x": 0.18366,
				"y": 0.687925
			},
			{
				"x": 0.159476,
				"y": 0.689626
			},
			{
				"x": 0.135274,
				"y": 0.691053
			},
			{
				"x": 0.111057,
				"y": 0.692192
			},
			{
				"x": 0.086827,
				"y": 0.693028
			},
			{
				"x": 0.062589,
				"y": 0.693545
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.312763,
				"y": 0.337119
			},
			{
				"x": 0.316114,
				"y": 0.320601
			},
			{
				"x": 0.324841,
				"y": 0.306135
			},
			{
				"x": 0.336783,
				"y": 0.29415
			},
			{
				"x": 0.350547,
				"y": 0.284296
			},
			{
				"x": 0.365396,
				"y": 0.276165
			},
			{
				"x": 0.380935,
				"y": 0.269444
			},
			{
				"x": 0.396935,
				"y": 0.26391
			},
			{
				"x": 0.413255,
				"y": 0.259408
			},
			{
				"x": 0.429801,
				"y": 0.255826
			},
			{
				"x": 0.446506,
				"y": 0.253085
			},
			{
				"x": 0.463322,
				"y": 0.251129
			},
			{
				"x": 0.480207,
				"y": 0.249922
			},
			{
				"x": 0.497129,
				"y": 0.24944
			},
			{
				"x": 0.514056,
				"y": 0.249678
			},
			{
				"x": 0.530957,
				"y": 0.250637
			},
			{
				"x": 0.5478,
				"y": 0.252336
			},
			{
				"x": 0.564548,
				"y": 0.254806
			},
			{
				"x": 0.581154,
				"y": 0.258095
			},
			{
				"x": 0.59756,
				"y": 0.262274
			},
			{
				"x": 0.613682,
				"y": 0.267443
			},
			{
				"x": 0.629397,
				"y": 0.27374
			},
			{
				"x": 0.644514,
				"y": 0.281363
			},
			{
				"x": 0.658706,
				"y": 0.290591
			},
			{
				"x": 0.671382,
				"y": 0.301804
			},
			{
				"x": 0.68141,
				"y": 0.315413
			},
			{
				"x": 0.686836,
				"y": 0.331384
			},
			{
				"x": 0.678513,
				"y": 0.330108
			},
			{
				"x": 0.664398,
				"y": 0.320752
			},
			{
				"x": 0.649564,
				"y": 0.312585
			},
			{
				"x": 0.634235,
				"y": 0.305389
			},
			{
				"x": 0.61854,
				"y": 0.299035
			},
			{
				"x": 0.602557,
				"y": 0.293448
			},
			{
				"x": 0.586338,
				"y": 0.28859
			},
			{
				"x": 0.569922,
				"y": 0.284448
			},
			{
				"x": 0.553339,
				"y": 0.28104
			},
			{
				"x": 0.536615,
				"y": 0.27841
			},
			{
				"x": 0.51978,
				"y": 0.276639
			},
			{
				"x": 0.502871,
				"y": 0.275864
			},
			{
				"x": 0.485949,
				"y": 0.276255
			},
			{
				"x": 0.469084,
				"y": 0.277707
			},
			{
				"x": 0.452319,
				"y": 0.280058
			},
			{
				"x": 0.435686,
				"y": 0.283209
			},
			{
				"x": 0.41921,
				"y": 0.287104
			},
			{
				"x": 0.40292,
				"y": 0.29172
			},
			{
				"x": 0.386852,
				"y": 0.297057
			},
			{
				"x": 0.371052,
				"y": 0.303144
			},
			{
				"x": 0.355588,
				"y": 0.310044
			},
			{
				"x": 0.340567,
				"y": 0.317862
			},
			{
				"x": 0.326173,
				"y": 0.326782
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"smirk": {
		"lb": [
			{
				"x": 0.886607,
				"y": 0.552274
			},
			{
				"x": 0.880549,
				"y": 0.561022
			},
			{
				"x": 0.874565,
				"y": 0.569822
			},
			{
				"x": 0.868457,
				"y": 0.578536
			},
			{
				"x": 0.862137,
				"y": 0.587096
			},
			{
				"x": 0.855539,
				"y": 0.595443
			},
			{
				"x": 0.848603,
				"y": 0.603509
			},
			{
				"x": 0.841267,
				"y": 0.611211
			},
			{
				"x": 0.833463,
				"y": 0.618437
			},
			{
				"x": 0.825122,
				"y": 0.625029
			},
			{
				"x": 0.816178,
				"y": 0.630771
			},
			{
				"x": 0.806619,
				"y": 0.635409
			},
			{
				"x": 0.796584,
				"y": 0.638897
			},
			{
				"x": 0.786241,
				"y": 0.641327
			},
			{
				"x": 0.775723,
				"y": 0.642826
			},
			{
				"x": 0.765121,
				"y": 0.643535
			},
			{
				"x": 0.754495,
				"y": 0.643592
			},
			{
				"x": 0.743878,
				"y": 0.643134
			},
			{
				"x": 0.733284,
				"y": 0.642305
			},
			{
				"x": 0.722705,
				"y": 0.641286
			},
			{
				"x": 0.712116,
				"y": 0.640391
			},
			{
				"x": 0.701516,
				"y": 0.640641
			},
			{
				"x": 0.696024,
				"y": 0.647955
			},
			{
				"x": 0.701869,
				"y": 0.656729
			},
			{
				"x": 0.709974,
				"y": 0.663595
			},
			{
				"x": 0.718966,
				"y": 0.669259
			},
			{
				"x": 0.728519,
				"y": 0.673915
			},
			{
				"x": 0.738487,
				"y": 0.677594
			},
			{
				"x": 0.74877,
				"y": 0.680265
			},
			{
				"x": 0.759264,
				"y": 0.68192
			},
			{
				"x": 0.769867,
				"y": 0.682573
			},
			{
				"x": 0.780485,
				"y": 0.682219
			},
			{
				"x": 0.791019,
				"y": 0.680848
			},
			{
				"x": 0.801369,
				"y": 0.678448
			},
			{
				"x": 0.811424,
				"y": 0.675016
			},
			{
				"x": 0.821073,
				"y": 0.670565
			},
			{
				"x": 0.830206,
				"y": 0.665129
			},
			{
				"x": 0.838724,
				"y": 0.65877
			},
			{
				"x": 0.84655,
				"y": 0.651572
			},
			{
				"x": 0.853633,
				"y": 0.643639
			},
			{
				"x": 0.860009,
				"y": 0.635124
			},
			{
				"x": 0.865785,
				"y": 0.626188
			},
			{
				"x": 0.871045,
				"y": 0.616936
			},
			{
				"x": 0.875847,
				"y": 0.607438
			},
			{
				"x": 0.880229,
				"y": 0.597738
			},
			{
				"x": 0.884208,
				"y": 0.587865
			},
			{
				"x": 0.887774,
				"y": 0.577835
			},
			{
				"x": 0.890873,
				"y": 0.567651
			},
			{
				"x": 0.893323,
				"y": 0.557292
			},
			{
				"x": 0.893924,
				"y": 0.546742
			}
		],
		"rb": [
			{
				"x": 0.114958,
				"y": 0.55447
			},
			{
				"x": 0.120963,
				"y": 0.563255
			},
			{
				"x": 0.126967,
				"y": 0.572041
			},
			{
				"x": 0.133121,
				"y": 0.580722
			},
			{
				"x": 0.139506,
				"y": 0.589234
			},
			{
				"x": 0.146184,
				"y": 0.597516
			},
			{
				"x": 0.153216,
				"y": 0.605499
			},
			{
				"x": 0.160664,
				"y": 0.613093
			},
			{
				"x": 0.168597,
				"y": 0.620174
			},
			{
				"x": 0.177086,
				"y": 0.626575
			},
			{
				"x": 0.186189,
				"y": 0.632058
			},
			{
				"x": 0.195886,
				"y": 0.636399
			},
			{
				"x": 0.206014,
				"y": 0.639608
			},
			{
				"x": 0.216412,
				"y": 0.641789
			},
			{
				"x": 0.226959,
				"y": 0.643075
			},
			{
				"x": 0.237571,
				"y": 0.643605
			},
			{
				"x": 0.248197,
				"y": 0.643519
			},
			{
				"x": 0.258808,
				"y": 0.642953
			},
			{
				"x": 0.269398,
				"y": 0.642056
			},
			{
				"x": 0.279975,
				"y": 0.641028
			},
			{
				"x": 0.290574,
				"y": 0.640263
			},
			{
				"x": 0.301057,
				"y": 0.641417
			},
			{
				"x": 0.302948,
				"y": 0.650443
			},
			{
				"x": 0.296197,
				"y": 0.658605
			},
			{
				"x": 0.287813,
				"y": 0.665132
			},
			{
				"x": 0.278659,
				"y": 0.670531
			},
			{
				"x": 0.268991,
				"y": 0.67494
			},
			{
				"x": 0.258934,
				"y": 0.678368
			},
			{
				"x": 0.248587,
				"y": 0.680779
			},
			{
				"x": 0.238056,
				"y": 0.68218
			},
			{
				"x": 0.22744,
				"y": 0.682579
			},
			{
				"x": 0.216834,
				"y": 0.681969
			},
			{
				"x": 0.206336,
				"y": 0.680338
			},
			{
				"x": 0.196051,
				"y": 0.677676
			},
			{
				"x": 0.186088,
				"y": 0.673984
			},
			{
				"x": 0.17656,
				"y": 0.669279
			},
			{
				"x": 0.167574,
				"y": 0.663602
			},
			{
				"x": 0.159225,
				"y": 0.657022
			},
			{
				"x": 0.151584,
				"y": 0.649627
			},
			{
				"x": 0.144689,
				"y": 0.641529
			},
			{
				"x": 0.138474,
				"y": 0.632894
			},
			{
				"x": 0.132836,
				"y": 0.62387
			},
			{
				"x": 0.127697,
				"y": 0.614551
			},
			{
				"x": 0.123004,
				"y": 0.604998
			},
			{
				"x": 0.118725,
				"y": 0.595252
			},
			{
				"x": 0.114848,
				"y": 0.585338
			},
			{
				"x": 0.111392,
				"y": 0.575269
			},
			{
				"x": 0.108432,
				"y": 0.565044
			},
			{
				"x": 0.106222,
				"y": 0.554633
			},
			{
				"x": 0.10821,
				"y": 0.546289
			}
		],
		"le": [
			{
				"x": 0.839714,
				"y": 0.457489
			},
			{
				"x": 0.838428,
				"y": 0.446948
			},
			{
				"x": 0.834509,
				"y": 0.43708
			},
			{
				"x": 0.828409,
				"y": 0.428386
			},
			{
				"x": 0.820668,
				"y": 0.421116
			},
			{
				"x": 0.811708,
				"y": 0.415417
			},
			{
				"x": 0.801864,
				"y": 0.411446
			},
			{
				"x": 0.791455,
				"y": 0.409381
			},
			{
				"x": 0.780846,
				"y": 0.409361
			},
			{
				"x": 0.770487,
				"y": 0.411624
			},
			{
				"x": 0.76107,
				"y": 0.41648
			},
			{
				"x": 0.753604,
				"y": 0.423989
			},
			{
				"x": 0.748536,
				"y": 0.433326
			},
			{
				"x": 0.744822,
				"y": 0.443299
			},
			{
				"x": 0.741361,
				"y": 0.453366
			},
			{
				"x": 0.736919,
				"y": 0.463022
			},
			{
				"x": 0.729486,
				"y": 0.470445
			},
			{
				"x": 0.719266,
				"y": 0.47305
			},
			{
				"x": 0.708662,
				"y": 0.472623
			},
			{
				"x": 0.698168,
				"y": 0.470955
			},
			{
				"x": 0.687753,
				"y": 0.468838
			},
			{
				"x": 0.677348,
				"y": 0.466674
			},
			{
				"x": 0.66691,
				"y": 0.464674
			},
			{
				"x": 0.656429,
				"y": 0.462917
			},
			{
				"x": 0.645891,
				"y": 0.461548
			},
			{
				"x": 0.635285,
				"y": 0.460995
			},
			{
				"x": 0.627605,
				"y": 0.465407
			},
			{
				"x": 0.634864,
				"y": 0.47307
			},
			{
				"x": 0.643514,
				"y": 0.47925
			},
			{
				"x": 0.652542,
				"y": 0.484866
			},
			{
				"x": 0.661798,
				"y": 0.490096
			},
			{
				"x": 0.671246,
				"y": 0.494968
			},
			{
				"x": 0.680904,
				"y": 0.499409
			},
			{
				"x": 0.690797,
				"y": 0.503293
			},
			{
				"x": 0.700925,
				"y": 0.50651
			},
			{
				"x": 0.711248,
				"y": 0.509031
			},
			{
				"x": 0.721698,
				"y": 0.51096
			},
			{
				"x": 0.732221,
				"y": 0.512441
			},
			{
				"x": 0.742797,
				"y": 0.513481
			},
			{
				"x": 0.753408,
				"y": 0.514048
			},
			{
				"x": 0.764034,
				"y": 0.514104
			},
			{
				"x": 0.774648,
				"y": 0.513599
			},
			{
				"x": 0.785209,
				"y": 0.512436
			},
			{
				"x": 0.795631,
				"y": 0.510376
			},
			{
				"x": 0.805736,
				"y": 0.507109
			},
			{
				"x": 0.815204,
				"y": 0.502304
			},
			{
				"x": 0.823542,
				"y": 0.495734
			},
			{
				"x": 0.830297,
				"y": 0.487538
			},
			{
				"x": 0.835344,
				"y": 0.478186
			},
			{
				"x": 0.838564,
				"y": 0.468055
			}
		],
		"re": [
			{
				"x": 0.176752,
				"y": 0.463582
			},
			{
				"x": 0.186543,
				"y": 0.460986
			},
			{
				"x": 0.197139,
				"y": 0.46175
			},
			{
				"x": 0.207665,
				"y": 0.463204
			},
			{
				"x": 0.218138,
				"y": 0.465011
			},
			{
				"x": 0.228569,
				"y": 0.467047
			},
			{
				"x": 0.238972,
				"y": 0.469223
			},
			{
				"x": 0.249395,
				"y": 0.471297
			},
			{
				"x": 0.259909,
				"y": 0.472821
			},
			{
				"x": 0.270517,
				"y": 0.472885
			},
			{
				"x": 0.280473,
				"y": 0.469473
			},
			{
				"x": 0.287236,
				"y": 0.461394
			},
			{
				"x": 0.291386,
				"y": 0.451603
			},
			{
				"x": 0.294814,
				"y": 0.441524
			},
			{
				"x": 0.298683,
				"y": 0.431611
			},
			{
				"x": 0.304117,
				"y": 0.422492
			},
			{
				"x": 0.312004,
				"y": 0.415426
			},
			{
				"x": 0.321653,
				"y": 0.411046
			},
			{
				"x": 0.332097,
				"y": 0.409207
			},
			{
				"x": 0.3427,
				"y": 0.409601
			},
			{
				"x": 0.353035,
				"y": 0.412012
			},
			{
				"x": 0.362746,
				"y": 0.4163
			},
			{
				"x": 0.371516,
				"y": 0.422287
			},
			{
				"x": 0.379003,
				"y": 0.42982
			},
			{
				"x": 0.38476,
				"y": 0.438743
			},
			{
				"x": 0.388235,
				"y": 0.448775
			},
			{
				"x": 0.389062,
				"y": 0.459365
			},
			{
				"x": 0.387524,
				"y": 0.469882
			},
			{
				"x": 0.383968,
				"y": 0.479899
			},
			{
				"x": 0.378614,
				"y": 0.489079
			},
			{
				"x": 0.371565,
				"y": 0.497022
			},
			{
				"x": 0.362988,
				"y": 0.503275
			},
			{
				"x": 0.353376,
				"y": 0.507787
			},
			{
				"x": 0.343196,
				"y": 0.510817
			},
			{
				"x": 0.33274,
				"y": 0.512698
			},
			{
				"x": 0.322165,
				"y": 0.513731
			},
			{
				"x": 0.311547,
				"y": 0.514133
			},
			{
				"x": 0.300922,
				"y": 0.513984
			},
			{
				"x": 0.290316,
				"y": 0.513331
			},
			{
				"x": 0.279749,
				"y": 0.512212
			},
			{
				"x": 0.269237,
				"y": 0.510655
			},
			{
				"x": 0.258804,
				"y": 0.508634
			},
			{
				"x": 0.248511,
				"y": 0.505994
			},
			{
				"x": 0.238422,
				"y": 0.502654
			},
			{
				"x": 0.228571,
				"y": 0.498663
			},
			{
				"x": 0.218953,
				"y": 0.494138
			},
			{
				"x": 0.209538,
				"y": 0.4892
			},
			{
				"x": 0.200318,
				"y": 0.483906
			},
			{
				"x": 0.191341,
				"y": 0.478211
			},
			{
				"x": 0.182797,
				"y": 0.471886
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.36429,
				"y": 0.203893
			},
			{
				"x": 0.380089,
				"y": 0.201137
			},
			{
				"x": 0.396436,
				"y": 0.200651
			},
			{
				"x": 0.412791,
				"y": 0.200601
			},
			{
				"x": 0.429145,
				"y": 0.200772
			},
			{
				"x": 0.445498,
				"y": 0.201088
			},
			{
				"x": 0.461847,
				"y": 0.201516
			},
			{
				"x": 0.478194,
				"y": 0.202041
			},
			{
				"x": 0.494538,
				"y": 0.202658
			},
			{
				"x": 0.510878,
				"y": 0.203364
			},
			{
				"x": 0.527213,
				"y": 0.204166
			},
			{
				"x": 0.543543,
				"y": 0.205073
			},
			{
				"x": 0.559866,
				"y": 0.206106
			},
			{
				"x": 0.576178,
				"y": 0.207299
			},
			{
				"x": 0.592471,
				"y": 0.208722
			},
			{
				"x": 0.608729,
				"y": 0.210501
			},
			{
				"x": 0.624916,
				"y": 0.212837
			},
			{
				"x": 0.640948,
				"y": 0.216062
			},
			{
				"x": 0.65661,
				"y": 0.220749
			},
			{
				"x": 0.671327,
				"y": 0.227832
			},
			{
				"x": 0.683835,
				"y": 0.238305
			},
			{
				"x": 0.692881,
				"y": 0.251894
			},
			{
				"x": 0.698217,
				"y": 0.267347
			},
			{
				"x": 0.700394,
				"y": 0.283568
			},
			{
				"x": 0.700093,
				"y": 0.299941
			},
			{
				"x": 0.697742,
				"y": 0.316148
			},
			{
				"x": 0.693387,
				"y": 0.331931
			},
			{
				"x": 0.685342,
				"y": 0.345945
			},
			{
				"x": 0.673186,
				"y": 0.337484
			},
			{
				"x": 0.665264,
				"y": 0.323152
			},
			{
				"x": 0.657711,
				"y": 0.308617
			},
			{
				"x": 0.649762,
				"y": 0.294297
			},
			{
				"x": 0.640916,
				"y": 0.280519
			},
			{
				"x": 0.630538,
				"y": 0.267873
			},
			{
				"x": 0.618219,
				"y": 0.257127
			},
			{
				"x": 0.604246,
				"y": 0.248643
			},
			{
				"x": 0.589235,
				"y": 0.242159
			},
			{
				"x": 0.573685,
				"y": 0.237091
			},
			{
				"x": 0.557867,
				"y": 0.232932
			},
			{
				"x": 0.541898,
				"y": 0.229398
			},
			{
				"x": 0.525832,
				"y": 0.22633
			},
			{
				"x": 0.509701,
				"y": 0.223627
			},
			{
				"x": 0.493523,
				"y": 0.221221
			},
			{
				"x": 0.477311,
				"y": 0.219064
			},
			{
				"x": 0.461071,
				"y": 0.217117
			},
			{
				"x": 0.444814,
				"y": 0.215324
			},
			{
				"x": 0.428548,
				"y": 0.213621
			},
			{
				"x": 0.412279,
				"y": 0.21194
			},
			{
				"x": 0.396018,
				"y": 0.21018
			},
			{
				"x": 0.379794,
				"y": 0.208116
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"no_mouth": {
		"lb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"rb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"le": [
			{
				"x": 0.708191,
				"y": 0.6214
			},
			{
				"x": 0.707865,
				"y": 0.614079
			},
			{
				"x": 0.706885,
				"y": 0.606817
			},
			{
				"x": 0.705245,
				"y": 0.599675
			},
			{
				"x": 0.702935,
				"y": 0.592722
			},
			{
				"x": 0.699944,
				"y": 0.586036
			},
			{
				"x": 0.696261,
				"y": 0.579706
			},
			{
				"x": 0.691878,
				"y": 0.573841
			},
			{
				"x": 0.6868,
				"y": 0.568571
			},
			{
				"x": 0.681053,
				"y": 0.564045
			},
			{
				"x": 0.674695,
				"y": 0.560432
			},
			{
				"x": 0.667839,
				"y": 0.557899
			},
			{
				"x": 0.66065,
				"y": 0.556591
			},
			{
				"x": 0.653343,
				"y": 0.556591
			},
			{
				"x": 0.646154,
				"y": 0.557899
			},
			{
				"x": 0.639298,
				"y": 0.560432
			},
			{
				"x": 0.632941,
				"y": 0.564045
			},
			{
				"x": 0.627193,
				"y": 0.568571
			},
			{
				"x": 0.622115,
				"y": 0.573841
			},
			{
				"x": 0.617732,
				"y": 0.579706
			},
			{
				"x": 0.614049,
				"y": 0.586036
			},
			{
				"x": 0.611058,
				"y": 0.592722
			},
			{
				"x": 0.608748,
				"y": 0.599675
			},
			{
				"x": 0.607108,
				"y": 0.606817
			},
			{
				"x": 0.606128,
				"y": 0.614079
			},
			{
				"x": 0.605802,
				"y": 0.6214
			},
			{
				"x": 0.606128,
				"y": 0.628721
			},
			{
				"x": 0.607108,
				"y": 0.635983
			},
			{
				"x": 0.608748,
				"y": 0.643125
			},
			{
				"x": 0.611058,
				"y": 0.650077
			},
			{
				"x": 0.614049,
				"y": 0.656764
			},
			{
				"x": 0.617732,
				"y": 0.663094
			},
			{
				"x": 0.622115,
				"y": 0.668959
			},
			{
				"x": 0.627193,
				"y": 0.674229
			},
			{
				"x": 0.632941,
				"y": 0.678755
			},
			{
				"x": 0.639298,
				"y": 0.682368
			},
			{
				"x": 0.646154,
				"y": 0.684901
			},
			{
				"x": 0.653343,
				"y": 0.686209
			},
			{
				"x": 0.66065,
				"y": 0.686209
			},
			{
				"x": 0.667839,
				"y": 0.684901
			},
			{
				"x": 0.674695,
				"y": 0.682368
			},
			{
				"x": 0.681053,
				"y": 0.678755
			},
			{
				"x": 0.6868,
				"y": 0.674229
			},
			{
				"x": 0.691878,
				"y": 0.668959
			},
			{
				"x": 0.696261,
				"y": 0.663094
			},
			{
				"x": 0.699944,
				"y": 0.656764
			},
			{
				"x": 0.702935,
				"y": 0.650077
			},
			{
				"x": 0.705245,
				"y": 0.643125
			},
			{
				"x": 0.706885,
				"y": 0.635983
			},
			{
				"x": 0.707865,
				"y": 0.628721
			}
		],
		"re": [
			{
				"x": 0.291809,
				"y": 0.6214
			},
			{
				"x": 0.292135,
				"y": 0.614079
			},
			{
				"x": 0.293115,
				"y": 0.606817
			},
			{
				"x": 0.294755,
				"y": 0.599675
			},
			{
				"x": 0.297065,
				"y": 0.592722
			},
			{
				"x": 0.300056,
				"y": 0.586036
			},
			{
				"x": 0.303739,
				"y": 0.579706
			},
			{
				"x": 0.308122,
				"y": 0.573841
			},
			{
				"x": 0.3132,
				"y": 0.568571
			},
			{
				"x": 0.318947,
				"y": 0.564045
			},
			{
				"x": 0.325305,
				"y": 0.560432
			},
			{
				"x": 0.332161,
				"y": 0.557899
			},
			{
				"x": 0.33935,
				"y": 0.556591
			},
			{
				"x": 0.346657,
				"y": 0.556591
			},
			{
				"x": 0.353846,
				"y": 0.557899
			},
			{
				"x": 0.360702,
				"y": 0.560432
			},
			{
				"x": 0.367059,
				"y": 0.564045
			},
			{
				"x": 0.372807,
				"y": 0.568571
			},
			{
				"x": 0.377885,
				"y": 0.573841
			},
			{
				"x": 0.382268,
				"y": 0.579706
			},
			{
				"x": 0.385951,
				"y": 0.586036
			},
			{
				"x": 0.388942,
				"y": 0.592722
			},
			{
				"x": 0.391252,
				"y": 0.599675
			},
			{
				"x": 0.392892,
				"y": 0.606817
			},
			{
				"x": 0.393872,
				"y": 0.614079
			},
			{
				"x": 0.394198,
				"y": 0.6214
			},
			{
				"x": 0.393872,
				"y": 0.628721
			},
			{
				"x": 0.392892,
				"y": 0.635983
			},
			{
				"x": 0.391252,
				"y": 0.643125
			},
			{
				"x": 0.388942,
				"y": 0.650077
			},
			{
				"x": 0.385951,
				"y": 0.656764
			},
			{
				"x": 0.382268,
				"y": 0.663094
			},
			{
				"x": 0.377885,
				"y": 0.668959
			},
			{
				"x": 0.372807,
				"y": 0.674229
			},
			{
				"x": 0.367059,
				"y": 0.678755
			},
			{
				"x": 0.360702,
				"y": 0.682368
			},
			{
				"x": 0.353846,
				"y": 0.684901
			},
			{
				"x": 0.346657,
				"y": 0.686209
			},
			{
				"x": 0.33935,
				"y": 0.686209
			},
			{
				"x": 0.332161,
				"y": 0.684901
			},
			{
				"x": 0.325305,
				"y": 0.682368
			},
			{
				"x": 0.318947,
				"y": 0.678755
			},
			{
				"x": 0.3132,
				"y": 0.674229
			},
			{
				"x": 0.308122,
				"y": 0.668959
			},
			{
				"x": 0.303739,
				"y": 0.663094
			},
			{
				"x": 0.300056,
				"y": 0.656764
			},
			{
				"x": 0.297065,
				"y": 0.650077
			},
			{
				"x": 0.294755,
				"y": 0.643125
			},
			{
				"x": 0.293115,
				"y": 0.635983
			},
			{
				"x": 0.292135,
				"y": 0.628721
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.5,
				"y": 0.306681
			},
			{
				"x": 0.499851,
				"y": 0.306671
			},
			{
				"x": 0.499704,
				"y": 0.306643
			},
			{
				"x": 0.499562,
				"y": 0.306597
			},
			{
				"x": 0.499427,
				"y": 0.306533
			},
			{
				"x": 0.499301,
				"y": 0.306453
			},
			{
				"x": 0.499186,
				"y": 0.306358
			},
			{
				"x": 0.499083,
				"y": 0.306249
			},
			{
				"x": 0.498996,
				"y": 0.306127
			},
			{
				"x": 0.498924,
				"y": 0.305996
			},
			{
				"x": 0.498869,
				"y": 0.305857
			},
			{
				"x": 0.498831,
				"y": 0.305712
			},
			{
				"x": 0.498813,
				"y": 0.305564
			},
			{
				"x": 0.498813,
				"y": 0.305414
			},
			{
				"x": 0.498831,
				"y": 0.305265
			},
			{
				"x": 0.498869,
				"y": 0.30512
			},
			{
				"x": 0.498924,
				"y": 0.304981
			},
			{
				"x": 0.498996,
				"y": 0.30485
			},
			{
				"x": 0.499083,
				"y": 0.304729
			},
			{
				"x": 0.499186,
				"y": 0.30462
			},
			{
				"x": 0.499301,
				"y": 0.304524
			},
			{
				"x": 0.499427,
				"y": 0.304444
			},
			{
				"x": 0.499562,
				"y": 0.30438
			},
			{
				"x": 0.499704,
				"y": 0.304334
			},
			{
				"x": 0.499851,
				"y": 0.304306
			},
			{
				"x": 0.5,
				"y": 0.304297
			},
			{
				"x": 0.500149,
				"y": 0.304306
			},
			{
				"x": 0.500296,
				"y": 0.304334
			},
			{
				"x": 0.500438,
				"y": 0.30438
			},
			{
				"x": 0.500573,
				"y": 0.304444
			},
			{
				"x": 0.500699,
				"y": 0.304524
			},
			{
				"x": 0.500814,
				"y": 0.30462
			},
			{
				"x": 0.500917,
				"y": 0.304729
			},
			{
				"x": 0.501004,
				"y": 0.30485
			},
			{
				"x": 0.501076,
				"y": 0.304981
			},
			{
				"x": 0.501131,
				"y": 0.30512
			},
			{
				"x": 0.501169,
				"y": 0.305265
			},
			{
				"x": 0.501187,
				"y": 0.305414
			},
			{
				"x": 0.501187,
				"y": 0.305564
			},
			{
				"x": 0.501169,
				"y": 0.305712
			},
			{
				"x": 0.501131,
				"y": 0.305857
			},
			{
				"x": 0.501076,
				"y": 0.305996
			},
			{
				"x": 0.501004,
				"y": 0.306127
			},
			{
				"x": 0.500917,
				"y": 0.306249
			},
			{
				"x": 0.500814,
				"y": 0.306358
			},
			{
				"x": 0.500699,
				"y": 0.306453
			},
			{
				"x": 0.500573,
				"y": 0.306533
			},
			{
				"x": 0.500438,
				"y": 0.306597
			},
			{
				"x": 0.500296,
				"y": 0.306643
			},
			{
				"x": 0.500149,
				"y": 0.306671
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"neutral_face": {
		"lb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"rb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"le": [
			{
				"x": 0.708191,
				"y": 0.601682
			},
			{
				"x": 0.707923,
				"y": 0.593
			},
			{
				"x": 0.707113,
				"y": 0.584351
			},
			{
				"x": 0.705749,
				"y": 0.575773
			},
			{
				"x": 0.703807,
				"y": 0.567308
			},
			{
				"x": 0.701253,
				"y": 0.559008
			},
			{
				"x": 0.69804,
				"y": 0.550942
			},
			{
				"x": 0.694108,
				"y": 0.543203
			},
			{
				"x": 0.689378,
				"y": 0.535928
			},
			{
				"x": 0.683763,
				"y": 0.529317
			},
			{
				"x": 0.677188,
				"y": 0.523671
			},
			{
				"x": 0.669646,
				"y": 0.519421
			},
			{
				"x": 0.661318,
				"y": 0.517092
			},
			{
				"x": 0.652675,
				"y": 0.517092
			},
			{
				"x": 0.644348,
				"y": 0.519421
			},
			{
				"x": 0.636805,
				"y": 0.523671
			},
			{
				"x": 0.63023,
				"y": 0.529317
			},
			{
				"x": 0.624616,
				"y": 0.535928
			},
			{
				"x": 0.619886,
				"y": 0.543203
			},
			{
				"x": 0.615953,
				"y": 0.550942
			},
			{
				"x": 0.61274,
				"y": 0.559008
			},
			{
				"x": 0.610186,
				"y": 0.567308
			},
			{
				"x": 0.608244,
				"y": 0.575773
			},
			{
				"x": 0.60688,
				"y": 0.584351
			},
			{
				"x": 0.60607,
				"y": 0.593
			},
			{
				"x": 0.605802,
				"y": 0.601682
			},
			{
				"x": 0.60607,
				"y": 0.610364
			},
			{
				"x": 0.60688,
				"y": 0.619012
			},
			{
				"x": 0.608244,
				"y": 0.62759
			},
			{
				"x": 0.610186,
				"y": 0.636055
			},
			{
				"x": 0.61274,
				"y": 0.644355
			},
			{
				"x": 0.615953,
				"y": 0.652422
			},
			{
				"x": 0.619886,
				"y": 0.66016
			},
			{
				"x": 0.624616,
				"y": 0.667436
			},
			{
				"x": 0.63023,
				"y": 0.674047
			},
			{
				"x": 0.636805,
				"y": 0.679693
			},
			{
				"x": 0.644348,
				"y": 0.683943
			},
			{
				"x": 0.652675,
				"y": 0.686272
			},
			{
				"x": 0.661318,
				"y": 0.686272
			},
			{
				"x": 0.669646,
				"y": 0.683943
			},
			{
				"x": 0.677188,
				"y": 0.679693
			},
			{
				"x": 0.683763,
				"y": 0.674047
			},
			{
				"x": 0.689378,
				"y": 0.667436
			},
			{
				"x": 0.694108,
				"y": 0.66016
			},
			{
				"x": 0.69804,
				"y": 0.652422
			},
			{
				"x": 0.701253,
				"y": 0.644355
			},
			{
				"x": 0.703807,
				"y": 0.636055
			},
			{
				"x": 0.705749,
				"y": 0.62759
			},
			{
				"x": 0.707113,
				"y": 0.619012
			},
			{
				"x": 0.707923,
				"y": 0.610364
			}
		],
		"re": [
			{
				"x": 0.291809,
				"y": 0.601682
			},
			{
				"x": 0.292077,
				"y": 0.593
			},
			{
				"x": 0.292887,
				"y": 0.584351
			},
			{
				"x": 0.294251,
				"y": 0.575773
			},
			{
				"x": 0.296193,
				"y": 0.567308
			},
			{
				"x": 0.298747,
				"y": 0.559008
			},
			{
				"x": 0.30196,
				"y": 0.550942
			},
			{
				"x": 0.305892,
				"y": 0.543203
			},
			{
				"x": 0.310622,
				"y": 0.535928
			},
			{
				"x": 0.316237,
				"y": 0.529317
			},
			{
				"x": 0.322812,
				"y": 0.523671
			},
			{
				"x": 0.330354,
				"y": 0.519421
			},
			{
				"x": 0.338682,
				"y": 0.517092
			},
			{
				"x": 0.347325,
				"y": 0.517092
			},
			{
				"x": 0.355652,
				"y": 0.519421
			},
			{
				"x": 0.363195,
				"y": 0.523671
			},
			{
				"x": 0.36977,
				"y": 0.529317
			},
			{
				"x": 0.375384,
				"y": 0.535928
			},
			{
				"x": 0.380114,
				"y": 0.543203
			},
			{
				"x": 0.384047,
				"y": 0.550942
			},
			{
				"x": 0.38726,
				"y": 0.559008
			},
			{
				"x": 0.389814,
				"y": 0.567308
			},
			{
				"x": 0.391756,
				"y": 0.575773
			},
			{
				"x": 0.39312,
				"y": 0.584351
			},
			{
				"x": 0.39393,
				"y": 0.593
			},
			{
				"x": 0.394198,
				"y": 0.601682
			},
			{
				"x": 0.39393,
				"y": 0.610364
			},
			{
				"x": 0.39312,
				"y": 0.619012
			},
			{
				"x": 0.391756,
				"y": 0.62759
			},
			{
				"x": 0.389814,
				"y": 0.636055
			},
			{
				"x": 0.38726,
				"y": 0.644355
			},
			{
				"x": 0.384047,
				"y": 0.652422
			},
			{
				"x": 0.380114,
				"y": 0.66016
			},
			{
				"x": 0.375384,
				"y": 0.667436
			},
			{
				"x": 0.36977,
				"y": 0.674047
			},
			{
				"x": 0.363195,
				"y": 0.679693
			},
			{
				"x": 0.355652,
				"y": 0.683943
			},
			{
				"x": 0.347325,
				"y": 0.686272
			},
			{
				"x": 0.338682,
				"y": 0.686272
			},
			{
				"x": 0.330354,
				"y": 0.683943
			},
			{
				"x": 0.322812,
				"y": 0.679693
			},
			{
				"x": 0.316237,
				"y": 0.674047
			},
			{
				"x": 0.310622,
				"y": 0.667436
			},
			{
				"x": 0.305892,
				"y": 0.66016
			},
			{
				"x": 0.30196,
				"y": 0.652422
			},
			{
				"x": 0.298747,
				"y": 0.644355
			},
			{
				"x": 0.296193,
				"y": 0.636055
			},
			{
				"x": 0.294251,
				"y": 0.62759
			},
			{
				"x": 0.292887,
				"y": 0.619012
			},
			{
				"x": 0.292077,
				"y": 0.610364
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.238534,
				"y": 0.335905
			},
			{
				"x": 0.24958,
				"y": 0.317285
			},
			{
				"x": 0.270261,
				"y": 0.308977
			},
			{
				"x": 0.292659,
				"y": 0.307925
			},
			{
				"x": 0.31512,
				"y": 0.307925
			},
			{
				"x": 0.337581,
				"y": 0.307925
			},
			{
				"x": 0.360041,
				"y": 0.307925
			},
			{
				"x": 0.382502,
				"y": 0.307925
			},
			{
				"x": 0.404963,
				"y": 0.307925
			},
			{
				"x": 0.427423,
				"y": 0.307925
			},
			{
				"x": 0.449884,
				"y": 0.307925
			},
			{
				"x": 0.472345,
				"y": 0.307925
			},
			{
				"x": 0.494805,
				"y": 0.307925
			},
			{
				"x": 0.517266,
				"y": 0.307925
			},
			{
				"x": 0.539727,
				"y": 0.307925
			},
			{
				"x": 0.562187,
				"y": 0.307925
			},
			{
				"x": 0.584648,
				"y": 0.307925
			},
			{
				"x": 0.607109,
				"y": 0.307925
			},
			{
				"x": 0.629569,
				"y": 0.307925
			},
			{
				"x": 0.65203,
				"y": 0.307925
			},
			{
				"x": 0.674491,
				"y": 0.307925
			},
			{
				"x": 0.696951,
				"y": 0.307925
			},
			{
				"x": 0.719412,
				"y": 0.307942
			},
			{
				"x": 0.74132,
				"y": 0.312311
			},
			{
				"x": 0.758652,
				"y": 0.326013
			},
			{
				"x": 0.761466,
				"y": 0.348
			},
			{
				"x": 0.75042,
				"y": 0.366619
			},
			{
				"x": 0.729739,
				"y": 0.374927
			},
			{
				"x": 0.707341,
				"y": 0.37598
			},
			{
				"x": 0.68488,
				"y": 0.37598
			},
			{
				"x": 0.662419,
				"y": 0.37598
			},
			{
				"x": 0.639959,
				"y": 0.37598
			},
			{
				"x": 0.617498,
				"y": 0.37598
			},
			{
				"x": 0.595037,
				"y": 0.37598
			},
			{
				"x": 0.572577,
				"y": 0.37598
			},
			{
				"x": 0.550116,
				"y": 0.37598
			},
			{
				"x": 0.527655,
				"y": 0.37598
			},
			{
				"x": 0.505195,
				"y": 0.37598
			},
			{
				"x": 0.482734,
				"y": 0.37598
			},
			{
				"x": 0.460273,
				"y": 0.37598
			},
			{
				"x": 0.437813,
				"y": 0.37598
			},
			{
				"x": 0.415352,
				"y": 0.37598
			},
			{
				"x": 0.392891,
				"y": 0.37598
			},
			{
				"x": 0.370431,
				"y": 0.37598
			},
			{
				"x": 0.34797,
				"y": 0.37598
			},
			{
				"x": 0.325509,
				"y": 0.37598
			},
			{
				"x": 0.303049,
				"y": 0.37598
			},
			{
				"x": 0.280588,
				"y": 0.375963
			},
			{
				"x": 0.25868,
				"y": 0.371594
			},
			{
				"x": 0.241348,
				"y": 0.357892
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"expressionless": {
		"lb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"rb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"le": [
			{
				"x": 0.755963,
				"y": 0.59831
			},
			{
				"x": 0.754301,
				"y": 0.589148
			},
			{
				"x": 0.747377,
				"y": 0.58292
			},
			{
				"x": 0.73825,
				"y": 0.580823
			},
			{
				"x": 0.728809,
				"y": 0.580822
			},
			{
				"x": 0.719368,
				"y": 0.580822
			},
			{
				"x": 0.709927,
				"y": 0.580822
			},
			{
				"x": 0.700485,
				"y": 0.580822
			},
			{
				"x": 0.691044,
				"y": 0.580822
			},
			{
				"x": 0.681603,
				"y": 0.580822
			},
			{
				"x": 0.672162,
				"y": 0.580822
			},
			{
				"x": 0.662721,
				"y": 0.580822
			},
			{
				"x": 0.65328,
				"y": 0.580822
			},
			{
				"x": 0.643839,
				"y": 0.580822
			},
			{
				"x": 0.634397,
				"y": 0.580822
			},
			{
				"x": 0.624956,
				"y": 0.580822
			},
			{
				"x": 0.615515,
				"y": 0.580822
			},
			{
				"x": 0.606074,
				"y": 0.580822
			},
			{
				"x": 0.596633,
				"y": 0.580822
			},
			{
				"x": 0.587192,
				"y": 0.580822
			},
			{
				"x": 0.57775,
				"y": 0.580822
			},
			{
				"x": 0.568309,
				"y": 0.580822
			},
			{
				"x": 0.558868,
				"y": 0.580823
			},
			{
				"x": 0.549741,
				"y": 0.58292
			},
			{
				"x": 0.542818,
				"y": 0.589148
			},
			{
				"x": 0.541155,
				"y": 0.59831
			},
			{
				"x": 0.542818,
				"y": 0.607472
			},
			{
				"x": 0.549741,
				"y": 0.6137
			},
			{
				"x": 0.558868,
				"y": 0.615797
			},
			{
				"x": 0.568309,
				"y": 0.615798
			},
			{
				"x": 0.57775,
				"y": 0.615798
			},
			{
				"x": 0.587192,
				"y": 0.615798
			},
			{
				"x": 0.596633,
				"y": 0.615798
			},
			{
				"x": 0.606074,
				"y": 0.615798
			},
			{
				"x": 0.615515,
				"y": 0.615798
			},
			{
				"x": 0.624956,
				"y": 0.615798
			},
			{
				"x": 0.634397,
				"y": 0.615798
			},
			{
				"x": 0.643839,
				"y": 0.615798
			},
			{
				"x": 0.65328,
				"y": 0.615798
			},
			{
				"x": 0.662721,
				"y": 0.615798
			},
			{
				"x": 0.672162,
				"y": 0.615798
			},
			{
				"x": 0.681603,
				"y": 0.615798
			},
			{
				"x": 0.691044,
				"y": 0.615798
			},
			{
				"x": 0.700485,
				"y": 0.615798
			},
			{
				"x": 0.709927,
				"y": 0.615798
			},
			{
				"x": 0.719368,
				"y": 0.615798
			},
			{
				"x": 0.728809,
				"y": 0.615798
			},
			{
				"x": 0.73825,
				"y": 0.615797
			},
			{
				"x": 0.747377,
				"y": 0.6137
			},
			{
				"x": 0.754301,
				"y": 0.607472
			}
		],
		"re": [
			{
				"x": 0.244037,
				"y": 0.595202
			},
			{
				"x": 0.24754,
				"y": 0.586655
			},
			{
				"x": 0.255506,
				"y": 0.581781
			},
			{
				"x": 0.264852,
				"y": 0.580822
			},
			{
				"x": 0.274293,
				"y": 0.580822
			},
			{
				"x": 0.283734,
				"y": 0.580822
			},
			{
				"x": 0.293175,
				"y": 0.580822
			},
			{
				"x": 0.302617,
				"y": 0.580822
			},
			{
				"x": 0.312058,
				"y": 0.580822
			},
			{
				"x": 0.321499,
				"y": 0.580822
			},
			{
				"x": 0.33094,
				"y": 0.580822
			},
			{
				"x": 0.340381,
				"y": 0.580822
			},
			{
				"x": 0.349822,
				"y": 0.580822
			},
			{
				"x": 0.359263,
				"y": 0.580822
			},
			{
				"x": 0.368705,
				"y": 0.580822
			},
			{
				"x": 0.378146,
				"y": 0.580822
			},
			{
				"x": 0.387587,
				"y": 0.580822
			},
			{
				"x": 0.397028,
				"y": 0.580822
			},
			{
				"x": 0.406469,
				"y": 0.580822
			},
			{
				"x": 0.41591,
				"y": 0.580822
			},
			{
				"x": 0.425352,
				"y": 0.580822
			},
			{
				"x": 0.434793,
				"y": 0.580822
			},
			{
				"x": 0.444222,
				"y": 0.581064
			},
			{
				"x": 0.452919,
				"y": 0.584511
			},
			{
				"x": 0.458396,
				"y": 0.592
			},
			{
				"x": 0.458845,
				"y": 0.601418
			},
			{
				"x": 0.455341,
				"y": 0.609965
			},
			{
				"x": 0.447376,
				"y": 0.614839
			},
			{
				"x": 0.43803,
				"y": 0.615798
			},
			{
				"x": 0.428589,
				"y": 0.615798
			},
			{
				"x": 0.419148,
				"y": 0.615798
			},
			{
				"x": 0.409706,
				"y": 0.615798
			},
			{
				"x": 0.400265,
				"y": 0.615798
			},
			{
				"x": 0.390824,
				"y": 0.615798
			},
			{
				"x": 0.381383,
				"y": 0.615798
			},
			{
				"x": 0.371942,
				"y": 0.615798
			},
			{
				"x": 0.362501,
				"y": 0.615798
			},
			{
				"x": 0.353059,
				"y": 0.615798
			},
			{
				"x": 0.343618,
				"y": 0.615798
			},
			{
				"x": 0.334177,
				"y": 0.615798
			},
			{
				"x": 0.324736,
				"y": 0.615798
			},
			{
				"x": 0.315295,
				"y": 0.615798
			},
			{
				"x": 0.305854,
				"y": 0.615798
			},
			{
				"x": 0.296413,
				"y": 0.615798
			},
			{
				"x": 0.286971,
				"y": 0.615798
			},
			{
				"x": 0.27753,
				"y": 0.615798
			},
			{
				"x": 0.268089,
				"y": 0.615798
			},
			{
				"x": 0.25866,
				"y": 0.615556
			},
			{
				"x": 0.249963,
				"y": 0.612109
			},
			{
				"x": 0.244486,
				"y": 0.60462
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.238534,
				"y": 0.335905
			},
			{
				"x": 0.24958,
				"y": 0.317285
			},
			{
				"x": 0.270261,
				"y": 0.308977
			},
			{
				"x": 0.292659,
				"y": 0.307925
			},
			{
				"x": 0.31512,
				"y": 0.307925
			},
			{
				"x": 0.337581,
				"y": 0.307925
			},
			{
				"x": 0.360041,
				"y": 0.307925
			},
			{
				"x": 0.382502,
				"y": 0.307925
			},
			{
				"x": 0.404963,
				"y": 0.307925
			},
			{
				"x": 0.427423,
				"y": 0.307925
			},
			{
				"x": 0.449884,
				"y": 0.307925
			},
			{
				"x": 0.472345,
				"y": 0.307925
			},
			{
				"x": 0.494805,
				"y": 0.307925
			},
			{
				"x": 0.517266,
				"y": 0.307925
			},
			{
				"x": 0.539727,
				"y": 0.307925
			},
			{
				"x": 0.562187,
				"y": 0.307925
			},
			{
				"x": 0.584648,
				"y": 0.307925
			},
			{
				"x": 0.607109,
				"y": 0.307925
			},
			{
				"x": 0.629569,
				"y": 0.307925
			},
			{
				"x": 0.65203,
				"y": 0.307925
			},
			{
				"x": 0.674491,
				"y": 0.307925
			},
			{
				"x": 0.696951,
				"y": 0.307925
			},
			{
				"x": 0.719412,
				"y": 0.307942
			},
			{
				"x": 0.74132,
				"y": 0.312311
			},
			{
				"x": 0.758652,
				"y": 0.326013
			},
			{
				"x": 0.761466,
				"y": 0.348
			},
			{
				"x": 0.75042,
				"y": 0.366619
			},
			{
				"x": 0.729739,
				"y": 0.374927
			},
			{
				"x": 0.707341,
				"y": 0.37598
			},
			{
				"x": 0.68488,
				"y": 0.37598
			},
			{
				"x": 0.662419,
				"y": 0.37598
			},
			{
				"x": 0.639959,
				"y": 0.37598
			},
			{
				"x": 0.617498,
				"y": 0.37598
			},
			{
				"x": 0.595037,
				"y": 0.37598
			},
			{
				"x": 0.572577,
				"y": 0.37598
			},
			{
				"x": 0.550116,
				"y": 0.37598
			},
			{
				"x": 0.527655,
				"y": 0.37598
			},
			{
				"x": 0.505195,
				"y": 0.37598
			},
			{
				"x": 0.482734,
				"y": 0.37598
			},
			{
				"x": 0.460273,
				"y": 0.37598
			},
			{
				"x": 0.437813,
				"y": 0.37598
			},
			{
				"x": 0.415352,
				"y": 0.37598
			},
			{
				"x": 0.392891,
				"y": 0.37598
			},
			{
				"x": 0.370431,
				"y": 0.37598
			},
			{
				"x": 0.34797,
				"y": 0.37598
			},
			{
				"x": 0.325509,
				"y": 0.37598
			},
			{
				"x": 0.303049,
				"y": 0.37598
			},
			{
				"x": 0.280588,
				"y": 0.375963
			},
			{
				"x": 0.25868,
				"y": 0.371594
			},
			{
				"x": 0.241348,
				"y": 0.357892
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"disappointed": {
		"lb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"rb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"le": [
			{
				"x": 0.818289,
				"y": 0.383207
			},
			{
				"x": 0.810748,
				"y": 0.376125
			},
			{
				"x": 0.800687,
				"y": 0.373975
			},
			{
				"x": 0.791116,
				"y": 0.377728
			},
			{
				"x": 0.783064,
				"y": 0.384368
			},
			{
				"x": 0.774738,
				"y": 0.39066
			},
			{
				"x": 0.76616,
				"y": 0.396603
			},
			{
				"x": 0.757353,
				"y": 0.402199
			},
			{
				"x": 0.748337,
				"y": 0.407451
			},
			{
				"x": 0.739134,
				"y": 0.412367
			},
			{
				"x": 0.729764,
				"y": 0.416954
			},
			{
				"x": 0.720244,
				"y": 0.421222
			},
			{
				"x": 0.710592,
				"y": 0.42518
			},
			{
				"x": 0.700824,
				"y": 0.428841
			},
			{
				"x": 0.690954,
				"y": 0.432215
			},
			{
				"x": 0.680994,
				"y": 0.435315
			},
			{
				"x": 0.670956,
				"y": 0.438151
			},
			{
				"x": 0.660851,
				"y": 0.440736
			},
			{
				"x": 0.650687,
				"y": 0.44308
			},
			{
				"x": 0.640474,
				"y": 0.445195
			},
			{
				"x": 0.630218,
				"y": 0.447091
			},
			{
				"x": 0.61999,
				"y": 0.449069
			},
			{
				"x": 0.611718,
				"y": 0.455185
			},
			{
				"x": 0.608103,
				"y": 0.46484
			},
			{
				"x": 0.609116,
				"y": 0.475217
			},
			{
				"x": 0.612557,
				"y": 0.484955
			},
			{
				"x": 0.62061,
				"y": 0.491368
			},
			{
				"x": 0.630849,
				"y": 0.492254
			},
			{
				"x": 0.641101,
				"y": 0.490336
			},
			{
				"x": 0.651318,
				"y": 0.488241
			},
			{
				"x": 0.661497,
				"y": 0.485962
			},
			{
				"x": 0.67163,
				"y": 0.483492
			},
			{
				"x": 0.681714,
				"y": 0.480822
			},
			{
				"x": 0.69174,
				"y": 0.477946
			},
			{
				"x": 0.701702,
				"y": 0.474853
			},
			{
				"x": 0.711592,
				"y": 0.471535
			},
			{
				"x": 0.721401,
				"y": 0.467984
			},
			{
				"x": 0.731119,
				"y": 0.464192
			},
			{
				"x": 0.740735,
				"y": 0.460149
			},
			{
				"x": 0.75024,
				"y": 0.455846
			},
			{
				"x": 0.759619,
				"y": 0.451277
			},
			{
				"x": 0.76886,
				"y": 0.446433
			},
			{
				"x": 0.777948,
				"y": 0.441307
			},
			{
				"x": 0.786868,
				"y": 0.435893
			},
			{
				"x": 0.795605,
				"y": 0.430187
			},
			{
				"x": 0.804142,
				"y": 0.424184
			},
			{
				"x": 0.812461,
				"y": 0.417883
			},
			{
				"x": 0.820491,
				"y": 0.411222
			},
			{
				"x": 0.825195,
				"y": 0.402064
			},
			{
				"x": 0.824133,
				"y": 0.391808
			}
		],
		"re": [
			{
				"x": 0.181669,
				"y": 0.383259
			},
			{
				"x": 0.189193,
				"y": 0.376157
			},
			{
				"x": 0.199246,
				"y": 0.37397
			},
			{
				"x": 0.208831,
				"y": 0.377686
			},
			{
				"x": 0.216883,
				"y": 0.384327
			},
			{
				"x": 0.225208,
				"y": 0.390621
			},
			{
				"x": 0.233784,
				"y": 0.396566
			},
			{
				"x": 0.24259,
				"y": 0.402164
			},
			{
				"x": 0.251604,
				"y": 0.407419
			},
			{
				"x": 0.260806,
				"y": 0.412337
			},
			{
				"x": 0.270175,
				"y": 0.416926
			},
			{
				"x": 0.279694,
				"y": 0.421195
			},
			{
				"x": 0.289345,
				"y": 0.425156
			},
			{
				"x": 0.299113,
				"y": 0.428819
			},
			{
				"x": 0.308983,
				"y": 0.432194
			},
			{
				"x": 0.318942,
				"y": 0.435296
			},
			{
				"x": 0.328979,
				"y": 0.438133
			},
			{
				"x": 0.339084,
				"y": 0.44072
			},
			{
				"x": 0.349247,
				"y": 0.443066
			},
			{
				"x": 0.35946,
				"y": 0.445182
			},
			{
				"x": 0.369716,
				"y": 0.44708
			},
			{
				"x": 0.379947,
				"y": 0.449047
			},
			{
				"x": 0.388242,
				"y": 0.455132
			},
			{
				"x": 0.391892,
				"y": 0.464773
			},
			{
				"x": 0.390894,
				"y": 0.475151
			},
			{
				"x": 0.387481,
				"y": 0.4849
			},
			{
				"x": 0.379453,
				"y": 0.491343
			},
			{
				"x": 0.369217,
				"y": 0.492266
			},
			{
				"x": 0.358965,
				"y": 0.490348
			},
			{
				"x": 0.348747,
				"y": 0.488255
			},
			{
				"x": 0.338569,
				"y": 0.485977
			},
			{
				"x": 0.328434,
				"y": 0.483508
			},
			{
				"x": 0.318351,
				"y": 0.48084
			},
			{
				"x": 0.308324,
				"y": 0.477965
			},
			{
				"x": 0.298362,
				"y": 0.474873
			},
			{
				"x": 0.288471,
				"y": 0.471557
			},
			{
				"x": 0.278662,
				"y": 0.468008
			},
			{
				"x": 0.268943,
				"y": 0.464217
			},
			{
				"x": 0.259326,
				"y": 0.460175
			},
			{
				"x": 0.249821,
				"y": 0.455875
			},
			{
				"x": 0.240441,
				"y": 0.451307
			},
			{
				"x": 0.231199,
				"y": 0.446465
			},
			{
				"x": 0.22211,
				"y": 0.441341
			},
			{
				"x": 0.213188,
				"y": 0.435929
			},
			{
				"x": 0.20445,
				"y": 0.430225
			},
			{
				"x": 0.195913,
				"y": 0.424224
			},
			{
				"x": 0.187592,
				"y": 0.417925
			},
			{
				"x": 0.179556,
				"y": 0.41127
			},
			{
				"x": 0.174817,
				"y": 0.40213
			},
			{
				"x": 0.175842,
				"y": 0.391871
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.359368,
				"y": 0.167633
			},
			{
				"x": 0.369543,
				"y": 0.177251
			},
			{
				"x": 0.380707,
				"y": 0.185704
			},
			{
				"x": 0.39254,
				"y": 0.19319
			},
			{
				"x": 0.404868,
				"y": 0.199828
			},
			{
				"x": 0.417584,
				"y": 0.205687
			},
			{
				"x": 0.430616,
				"y": 0.2108
			},
			{
				"x": 0.443915,
				"y": 0.215171
			},
			{
				"x": 0.457441,
				"y": 0.218774
			},
			{
				"x": 0.47116,
				"y": 0.22155
			},
			{
				"x": 0.485033,
				"y": 0.223395
			},
			{
				"x": 0.499007,
				"y": 0.224133
			},
			{
				"x": 0.512989,
				"y": 0.223573
			},
			{
				"x": 0.52688,
				"y": 0.221872
			},
			{
				"x": 0.540623,
				"y": 0.21922
			},
			{
				"x": 0.554179,
				"y": 0.21573
			},
			{
				"x": 0.567512,
				"y": 0.211466
			},
			{
				"x": 0.580585,
				"y": 0.206458
			},
			{
				"x": 0.593349,
				"y": 0.200706
			},
			{
				"x": 0.605738,
				"y": 0.194182
			},
			{
				"x": 0.61765,
				"y": 0.186822
			},
			{
				"x": 0.628923,
				"y": 0.178516
			},
			{
				"x": 0.639267,
				"y": 0.169079
			},
			{
				"x": 0.63974,
				"y": 0.179624
			},
			{
				"x": 0.636513,
				"y": 0.193254
			},
			{
				"x": 0.631122,
				"y": 0.206183
			},
			{
				"x": 0.623851,
				"y": 0.218153
			},
			{
				"x": 0.615006,
				"y": 0.229011
			},
			{
				"x": 0.604879,
				"y": 0.238681
			},
			{
				"x": 0.593724,
				"y": 0.247143
			},
			{
				"x": 0.581756,
				"y": 0.254406
			},
			{
				"x": 0.569151,
				"y": 0.260495
			},
			{
				"x": 0.556057,
				"y": 0.26544
			},
			{
				"x": 0.542595,
				"y": 0.26927
			},
			{
				"x": 0.52887,
				"y": 0.272008
			},
			{
				"x": 0.514975,
				"y": 0.273673
			},
			{
				"x": 0.500993,
				"y": 0.274276
			},
			{
				"x": 0.487006,
				"y": 0.273823
			},
			{
				"x": 0.473093,
				"y": 0.272309
			},
			{
				"x": 0.459339,
				"y": 0.269724
			},
			{
				"x": 0.445834,
				"y": 0.266051
			},
			{
				"x": 0.43268,
				"y": 0.261266
			},
			{
				"x": 0.419998,
				"y": 0.255341
			},
			{
				"x": 0.407929,
				"y": 0.248246
			},
			{
				"x": 0.396647,
				"y": 0.239956
			},
			{
				"x": 0.386359,
				"y": 0.230456
			},
			{
				"x": 0.377315,
				"y": 0.219764
			},
			{
				"x": 0.369802,
				"y": 0.207944
			},
			{
				"x": 0.364126,
				"y": 0.195139
			},
			{
				"x": 0.360578,
				"y": 0.181588
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"worried": {
		"lb": [
			{
				"x": 0.841084,
				"y": 0.665623
			},
			{
				"x": 0.834425,
				"y": 0.672666
			},
			{
				"x": 0.827528,
				"y": 0.679475
			},
			{
				"x": 0.820405,
				"y": 0.686047
			},
			{
				"x": 0.813068,
				"y": 0.692377
			},
			{
				"x": 0.805527,
				"y": 0.698463
			},
			{
				"x": 0.797793,
				"y": 0.704299
			},
			{
				"x": 0.789875,
				"y": 0.709883
			},
			{
				"x": 0.781782,
				"y": 0.715209
			},
			{
				"x": 0.773524,
				"y": 0.720275
			},
			{
				"x": 0.76511,
				"y": 0.725075
			},
			{
				"x": 0.756548,
				"y": 0.729605
			},
			{
				"x": 0.747846,
				"y": 0.73386
			},
			{
				"x": 0.739013,
				"y": 0.737834
			},
			{
				"x": 0.730057,
				"y": 0.741522
			},
			{
				"x": 0.720987,
				"y": 0.744917
			},
			{
				"x": 0.711811,
				"y": 0.748013
			},
			{
				"x": 0.702537,
				"y": 0.750803
			},
			{
				"x": 0.693176,
				"y": 0.753279
			},
			{
				"x": 0.683735,
				"y": 0.755434
			},
			{
				"x": 0.674225,
				"y": 0.757259
			},
			{
				"x": 0.664657,
				"y": 0.758745
			},
			{
				"x": 0.655042,
				"y": 0.759882
			},
			{
				"x": 0.64539,
				"y": 0.760659
			},
			{
				"x": 0.647298,
				"y": 0.764004
			},
			{
				"x": 0.65599,
				"y": 0.768272
			},
			{
				"x": 0.665024,
				"y": 0.771754
			},
			{
				"x": 0.674321,
				"y": 0.774457
			},
			{
				"x": 0.683806,
				"y": 0.776392
			},
			{
				"x": 0.693414,
				"y": 0.777578
			},
			{
				"x": 0.703085,
				"y": 0.778032
			},
			{
				"x": 0.712762,
				"y": 0.777777
			},
			{
				"x": 0.722397,
				"y": 0.776834
			},
			{
				"x": 0.731944,
				"y": 0.775223
			},
			{
				"x": 0.741359,
				"y": 0.772967
			},
			{
				"x": 0.750603,
				"y": 0.770085
			},
			{
				"x": 0.759637,
				"y": 0.766597
			},
			{
				"x": 0.768422,
				"y": 0.762521
			},
			{
				"x": 0.776921,
				"y": 0.757876
			},
			{
				"x": 0.785096,
				"y": 0.752679
			},
			{
				"x": 0.792907,
				"y": 0.746948
			},
			{
				"x": 0.800315,
				"y": 0.740703
			},
			{
				"x": 0.807276,
				"y": 0.733963
			},
			{
				"x": 0.813748,
				"y": 0.726748
			},
			{
				"x": 0.819682,
				"y": 0.719084
			},
			{
				"x": 0.825029,
				"y": 0.710998
			},
			{
				"x": 0.829737,
				"y": 0.702523
			},
			{
				"x": 0.833752,
				"y": 0.693697
			},
			{
				"x": 0.837018,
				"y": 0.684567
			},
			{
				"x": 0.839479,
				"y": 0.675187
			}
		],
		"rb": [
			{
				"x": 0.158916,
				"y": 0.665623
			},
			{
				"x": 0.165575,
				"y": 0.672666
			},
			{
				"x": 0.172472,
				"y": 0.679475
			},
			{
				"x": 0.179595,
				"y": 0.686047
			},
			{
				"x": 0.186932,
				"y": 0.692377
			},
			{
				"x": 0.194473,
				"y": 0.698463
			},
			{
				"x": 0.202207,
				"y": 0.704299
			},
			{
				"x": 0.210125,
				"y": 0.709883
			},
			{
				"x": 0.218218,
				"y": 0.715209
			},
			{
				"x": 0.226476,
				"y": 0.720275
			},
			{
				"x": 0.23489,
				"y": 0.725075
			},
			{
				"x": 0.243452,
				"y": 0.729605
			},
			{
				"x": 0.252154,
				"y": 0.73386
			},
			{
				"x": 0.260987,
				"y": 0.737834
			},
			{
				"x": 0.269943,
				"y": 0.741522
			},
			{
				"x": 0.279013,
				"y": 0.744917
			},
			{
				"x": 0.288189,
				"y": 0.748013
			},
			{
				"x": 0.297463,
				"y": 0.750803
			},
			{
				"x": 0.306824,
				"y": 0.753279
			},
			{
				"x": 0.316265,
				"y": 0.755434
			},
			{
				"x": 0.325775,
				"y": 0.757259
			},
			{
				"x": 0.335343,
				"y": 0.758745
			},
			{
				"x": 0.344958,
				"y": 0.759882
			},
			{
				"x": 0.35461,
				"y": 0.760659
			},
			{
				"x": 0.352702,
				"y": 0.764004
			},
			{
				"x": 0.34401,
				"y": 0.768272
			},
			{
				"x": 0.334976,
				"y": 0.771754
			},
			{
				"x": 0.325679,
				"y": 0.774457
			},
			{
				"x": 0.316194,
				"y": 0.776392
			},
			{
				"x": 0.306586,
				"y": 0.777578
			},
			{
				"x": 0.296915,
				"y": 0.778032
			},
			{
				"x": 0.287238,
				"y": 0.777777
			},
			{
				"x": 0.277603,
				"y": 0.776834
			},
			{
				"x": 0.268056,
				"y": 0.775223
			},
			{
				"x": 0.258641,
				"y": 0.772967
			},
			{
				"x": 0.249397,
				"y": 0.770085
			},
			{
				"x": 0.240363,
				"y": 0.766597
			},
			{
				"x": 0.231578,
				"y": 0.762521
			},
			{
				"x": 0.223079,
				"y": 0.757876
			},
			{
				"x": 0.214904,
				"y": 0.752679
			},
			{
				"x": 0.207093,
				"y": 0.746948
			},
			{
				"x": 0.199685,
				"y": 0.740703
			},
			{
				"x": 0.192724,
				"y": 0.733963
			},
			{
				"x": 0.186252,
				"y": 0.726748
			},
			{
				"x": 0.180318,
				"y": 0.719084
			},
			{
				"x": 0.174971,
				"y": 0.710998
			},
			{
				"x": 0.170263,
				"y": 0.702523
			},
			{
				"x": 0.166248,
				"y": 0.693697
			},
			{
				"x": 0.162982,
				"y": 0.684567
			},
			{
				"x": 0.160521,
				"y": 0.675187
			}
		],
		"le": [
			{
				"x": 0.742431,
				"y": 0.518479
			},
			{
				"x": 0.742105,
				"y": 0.511157
			},
			{
				"x": 0.741124,
				"y": 0.503895
			},
			{
				"x": 0.739484,
				"y": 0.496754
			},
			{
				"x": 0.737174,
				"y": 0.489801
			},
			{
				"x": 0.734183,
				"y": 0.483114
			},
			{
				"x": 0.7305,
				"y": 0.476785
			},
			{
				"x": 0.726118,
				"y": 0.47092
			},
			{
				"x": 0.72104,
				"y": 0.46565
			},
			{
				"x": 0.715292,
				"y": 0.461124
			},
			{
				"x": 0.708935,
				"y": 0.45751
			},
			{
				"x": 0.702078,
				"y": 0.454978
			},
			{
				"x": 0.694889,
				"y": 0.45367
			},
			{
				"x": 0.687583,
				"y": 0.45367
			},
			{
				"x": 0.680394,
				"y": 0.454978
			},
			{
				"x": 0.673537,
				"y": 0.45751
			},
			{
				"x": 0.66718,
				"y": 0.461124
			},
			{
				"x": 0.661432,
				"y": 0.46565
			},
			{
				"x": 0.656355,
				"y": 0.47092
			},
			{
				"x": 0.651972,
				"y": 0.476785
			},
			{
				"x": 0.648289,
				"y": 0.483114
			},
			{
				"x": 0.645298,
				"y": 0.489801
			},
			{
				"x": 0.642988,
				"y": 0.496754
			},
			{
				"x": 0.641348,
				"y": 0.503895
			},
			{
				"x": 0.640368,
				"y": 0.511157
			},
			{
				"x": 0.640041,
				"y": 0.518479
			},
			{
				"x": 0.640368,
				"y": 0.5258
			},
			{
				"x": 0.641348,
				"y": 0.533062
			},
			{
				"x": 0.642988,
				"y": 0.540203
			},
			{
				"x": 0.645298,
				"y": 0.547156
			},
			{
				"x": 0.648289,
				"y": 0.553843
			},
			{
				"x": 0.651972,
				"y": 0.560172
			},
			{
				"x": 0.656355,
				"y": 0.566037
			},
			{
				"x": 0.661432,
				"y": 0.571307
			},
			{
				"x": 0.66718,
				"y": 0.575833
			},
			{
				"x": 0.673537,
				"y": 0.579447
			},
			{
				"x": 0.680394,
				"y": 0.581979
			},
			{
				"x": 0.687583,
				"y": 0.583288
			},
			{
				"x": 0.694889,
				"y": 0.583288
			},
			{
				"x": 0.702078,
				"y": 0.581979
			},
			{
				"x": 0.708935,
				"y": 0.579447
			},
			{
				"x": 0.715292,
				"y": 0.575833
			},
			{
				"x": 0.72104,
				"y": 0.571307
			},
			{
				"x": 0.726118,
				"y": 0.566037
			},
			{
				"x": 0.7305,
				"y": 0.560172
			},
			{
				"x": 0.734183,
				"y": 0.553843
			},
			{
				"x": 0.737174,
				"y": 0.547156
			},
			{
				"x": 0.739484,
				"y": 0.540203
			},
			{
				"x": 0.741124,
				"y": 0.533062
			},
			{
				"x": 0.742105,
				"y": 0.5258
			}
		],
		"re": [
			{
				"x": 0.257569,
				"y": 0.518479
			},
			{
				"x": 0.257895,
				"y": 0.511157
			},
			{
				"x": 0.258876,
				"y": 0.503895
			},
			{
				"x": 0.260516,
				"y": 0.496754
			},
			{
				"x": 0.262826,
				"y": 0.489801
			},
			{
				"x": 0.265817,
				"y": 0.483114
			},
			{
				"x": 0.2695,
				"y": 0.476785
			},
			{
				"x": 0.273882,
				"y": 0.47092
			},
			{
				"x": 0.27896,
				"y": 0.46565
			},
			{
				"x": 0.284708,
				"y": 0.461124
			},
			{
				"x": 0.291065,
				"y": 0.45751
			},
			{
				"x": 0.297922,
				"y": 0.454978
			},
			{
				"x": 0.305111,
				"y": 0.45367
			},
			{
				"x": 0.312417,
				"y": 0.45367
			},
			{
				"x": 0.319606,
				"y": 0.454978
			},
			{
				"x": 0.326463,
				"y": 0.45751
			},
			{
				"x": 0.33282,
				"y": 0.461124
			},
			{
				"x": 0.338568,
				"y": 0.46565
			},
			{
				"x": 0.343645,
				"y": 0.47092
			},
			{
				"x": 0.348028,
				"y": 0.476785
			},
			{
				"x": 0.351711,
				"y": 0.483114
			},
			{
				"x": 0.354702,
				"y": 0.489801
			},
			{
				"x": 0.357012,
				"y": 0.496754
			},
			{
				"x": 0.358652,
				"y": 0.503895
			},
			{
				"x": 0.359632,
				"y": 0.511157
			},
			{
				"x": 0.359959,
				"y": 0.518479
			},
			{
				"x": 0.359632,
				"y": 0.5258
			},
			{
				"x": 0.358652,
				"y": 0.533062
			},
			{
				"x": 0.357012,
				"y": 0.540203
			},
			{
				"x": 0.354702,
				"y": 0.547156
			},
			{
				"x": 0.351711,
				"y": 0.553843
			},
			{
				"x": 0.348028,
				"y": 0.560172
			},
			{
				"x": 0.343645,
				"y": 0.566037
			},
			{
				"x": 0.338568,
				"y": 0.571307
			},
			{
				"x": 0.33282,
				"y": 0.575833
			},
			{
				"x": 0.326463,
				"y": 0.579447
			},
			{
				"x": 0.319606,
				"y": 0.581979
			},
			{
				"x": 0.312417,
				"y": 0.583288
			},
			{
				"x": 0.305111,
				"y": 0.583288
			},
			{
				"x": 0.297922,
				"y": 0.581979
			},
			{
				"x": 0.291065,
				"y": 0.579447
			},
			{
				"x": 0.284708,
				"y": 0.575833
			},
			{
				"x": 0.27896,
				"y": 0.571307
			},
			{
				"x": 0.273882,
				"y": 0.566037
			},
			{
				"x": 0.2695,
				"y": 0.560172
			},
			{
				"x": 0.265817,
				"y": 0.553843
			},
			{
				"x": 0.262826,
				"y": 0.547156
			},
			{
				"x": 0.260516,
				"y": 0.540203
			},
			{
				"x": 0.258876,
				"y": 0.533062
			},
			{
				"x": 0.257895,
				"y": 0.5258
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.30693,
				"y": 0.211633
			},
			{
				"x": 0.320899,
				"y": 0.224838
			},
			{
				"x": 0.336224,
				"y": 0.236443
			},
			{
				"x": 0.35247,
				"y": 0.246721
			},
			{
				"x": 0.369395,
				"y": 0.255834
			},
			{
				"x": 0.386852,
				"y": 0.263877
			},
			{
				"x": 0.404744,
				"y": 0.270897
			},
			{
				"x": 0.423002,
				"y": 0.276898
			},
			{
				"x": 0.441572,
				"y": 0.281844
			},
			{
				"x": 0.460406,
				"y": 0.285656
			},
			{
				"x": 0.479452,
				"y": 0.288188
			},
			{
				"x": 0.498636,
				"y": 0.289202
			},
			{
				"x": 0.517832,
				"y": 0.288432
			},
			{
				"x": 0.536903,
				"y": 0.286097
			},
			{
				"x": 0.555771,
				"y": 0.282457
			},
			{
				"x": 0.574381,
				"y": 0.277665
			},
			{
				"x": 0.592686,
				"y": 0.271811
			},
			{
				"x": 0.610633,
				"y": 0.264935
			},
			{
				"x": 0.628157,
				"y": 0.257039
			},
			{
				"x": 0.645165,
				"y": 0.248082
			},
			{
				"x": 0.661519,
				"y": 0.237978
			},
			{
				"x": 0.676996,
				"y": 0.226574
			},
			{
				"x": 0.691197,
				"y": 0.213618
			},
			{
				"x": 0.691846,
				"y": 0.228095
			},
			{
				"x": 0.687416,
				"y": 0.246809
			},
			{
				"x": 0.680015,
				"y": 0.264557
			},
			{
				"x": 0.670032,
				"y": 0.280991
			},
			{
				"x": 0.657889,
				"y": 0.295898
			},
			{
				"x": 0.643986,
				"y": 0.309174
			},
			{
				"x": 0.628672,
				"y": 0.320791
			},
			{
				"x": 0.612241,
				"y": 0.330763
			},
			{
				"x": 0.594937,
				"y": 0.339122
			},
			{
				"x": 0.57696,
				"y": 0.345911
			},
			{
				"x": 0.558478,
				"y": 0.351168
			},
			{
				"x": 0.539635,
				"y": 0.354927
			},
			{
				"x": 0.520559,
				"y": 0.357213
			},
			{
				"x": 0.501363,
				"y": 0.358042
			},
			{
				"x": 0.482161,
				"y": 0.357419
			},
			{
				"x": 0.46306,
				"y": 0.355341
			},
			{
				"x": 0.444177,
				"y": 0.351792
			},
			{
				"x": 0.425636,
				"y": 0.34675
			},
			{
				"x": 0.407578,
				"y": 0.34018
			},
			{
				"x": 0.390167,
				"y": 0.332046
			},
			{
				"x": 0.373598,
				"y": 0.322306
			},
			{
				"x": 0.358109,
				"y": 0.310923
			},
			{
				"x": 0.343985,
				"y": 0.297882
			},
			{
				"x": 0.331569,
				"y": 0.283203
			},
			{
				"x": 0.321254,
				"y": 0.266976
			},
			{
				"x": 0.313462,
				"y": 0.249396
			},
			{
				"x": 0.30859,
				"y": 0.230792
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"pensive": {
		"lb": [
			{
				"x": 0.874248,
				"y": 0.585271
			},
			{
				"x": 0.866553,
				"y": 0.5808
			},
			{
				"x": 0.857679,
				"y": 0.576925
			},
			{
				"x": 0.848501,
				"y": 0.573841
			},
			{
				"x": 0.839098,
				"y": 0.571536
			},
			{
				"x": 0.82954,
				"y": 0.569997
			},
			{
				"x": 0.819892,
				"y": 0.569203
			},
			{
				"x": 0.810212,
				"y": 0.569135
			},
			{
				"x": 0.800552,
				"y": 0.569769
			},
			{
				"x": 0.79096,
				"y": 0.571083
			},
			{
				"x": 0.781481,
				"y": 0.573057
			},
			{
				"x": 0.772157,
				"y": 0.575667
			},
			{
				"x": 0.763027,
				"y": 0.578893
			},
			{
				"x": 0.75413,
				"y": 0.582716
			},
			{
				"x": 0.745502,
				"y": 0.587117
			},
			{
				"x": 0.737182,
				"y": 0.592076
			},
			{
				"x": 0.729207,
				"y": 0.597576
			},
			{
				"x": 0.721617,
				"y": 0.603597
			},
			{
				"x": 0.714451,
				"y": 0.61012
			},
			{
				"x": 0.707754,
				"y": 0.617124
			},
			{
				"x": 0.701568,
				"y": 0.624586
			},
			{
				"x": 0.695943,
				"y": 0.63248
			},
			{
				"x": 0.690927,
				"y": 0.640776
			},
			{
				"x": 0.686574,
				"y": 0.64944
			},
			{
				"x": 0.682936,
				"y": 0.658428
			},
			{
				"x": 0.68007,
				"y": 0.667692
			},
			{
				"x": 0.678028,
				"y": 0.677173
			},
			{
				"x": 0.679155,
				"y": 0.681505
			},
			{
				"x": 0.685773,
				"y": 0.674423
			},
			{
				"x": 0.692629,
				"y": 0.667573
			},
			{
				"x": 0.699711,
				"y": 0.660958
			},
			{
				"x": 0.707009,
				"y": 0.654581
			},
			{
				"x": 0.714511,
				"y": 0.648448
			},
			{
				"x": 0.722207,
				"y": 0.642561
			},
			{
				"x": 0.730089,
				"y": 0.636925
			},
			{
				"x": 0.738146,
				"y": 0.631545
			},
			{
				"x": 0.74637,
				"y": 0.626425
			},
			{
				"x": 0.754752,
				"y": 0.621568
			},
			{
				"x": 0.763284,
				"y": 0.616981
			},
			{
				"x": 0.771957,
				"y": 0.612669
			},
			{
				"x": 0.780764,
				"y": 0.608637
			},
			{
				"x": 0.789696,
				"y": 0.604891
			},
			{
				"x": 0.798744,
				"y": 0.601438
			},
			{
				"x": 0.807901,
				"y": 0.598284
			},
			{
				"x": 0.817157,
				"y": 0.595437
			},
			{
				"x": 0.826504,
				"y": 0.592904
			},
			{
				"x": 0.835932,
				"y": 0.590695
			},
			{
				"x": 0.845431,
				"y": 0.588817
			},
			{
				"x": 0.854991,
				"y": 0.58728
			},
			{
				"x": 0.864601,
				"y": 0.586095
			}
		],
		"rb": [
			{
				"x": 0.125752,
				"y": 0.585271
			},
			{
				"x": 0.133447,
				"y": 0.5808
			},
			{
				"x": 0.142321,
				"y": 0.576925
			},
			{
				"x": 0.151499,
				"y": 0.573841
			},
			{
				"x": 0.160902,
				"y": 0.571536
			},
			{
				"x": 0.17046,
				"y": 0.569997
			},
			{
				"x": 0.180108,
				"y": 0.569203
			},
			{
				"x": 0.189788,
				"y": 0.569135
			},
			{
				"x": 0.199448,
				"y": 0.569769
			},
			{
				"x": 0.20904,
				"y": 0.571083
			},
			{
				"x": 0.218519,
				"y": 0.573057
			},
			{
				"x": 0.227843,
				"y": 0.575667
			},
			{
				"x": 0.236973,
				"y": 0.578893
			},
			{
				"x": 0.24587,
				"y": 0.582716
			},
			{
				"x": 0.254498,
				"y": 0.587117
			},
			{
				"x": 0.262818,
				"y": 0.592076
			},
			{
				"x": 0.270793,
				"y": 0.597576
			},
			{
				"x": 0.278383,
				"y": 0.603597
			},
			{
				"x": 0.285549,
				"y": 0.61012
			},
			{
				"x": 0.292246,
				"y": 0.617124
			},
			{
				"x": 0.298432,
				"y": 0.624586
			},
			{
				"x": 0.304057,
				"y": 0.63248
			},
			{
				"x": 0.309073,
				"y": 0.640776
			},
			{
				"x": 0.313426,
				"y": 0.64944
			},
			{
				"x": 0.317064,
				"y": 0.658428
			},
			{
				"x": 0.31993,
				"y": 0.667692
			},
			{
				"x": 0.321972,
				"y": 0.677173
			},
			{
				"x": 0.320845,
				"y": 0.681505
			},
			{
				"x": 0.314227,
				"y": 0.674423
			},
			{
				"x": 0.307371,
				"y": 0.667573
			},
			{
				"x": 0.300289,
				"y": 0.660958
			},
			{
				"x": 0.292991,
				"y": 0.654581
			},
			{
				"x": 0.285489,
				"y": 0.648448
			},
			{
				"x": 0.277793,
				"y": 0.642561
			},
			{
				"x": 0.269911,
				"y": 0.636925
			},
			{
				"x": 0.261854,
				"y": 0.631545
			},
			{
				"x": 0.25363,
				"y": 0.626425
			},
			{
				"x": 0.245248,
				"y": 0.621568
			},
			{
				"x": 0.236716,
				"y": 0.616981
			},
			{
				"x": 0.228043,
				"y": 0.612669
			},
			{
				"x": 0.219236,
				"y": 0.608637
			},
			{
				"x": 0.210304,
				"y": 0.604891
			},
			{
				"x": 0.201256,
				"y": 0.601438
			},
			{
				"x": 0.192099,
				"y": 0.598284
			},
			{
				"x": 0.182843,
				"y": 0.595437
			},
			{
				"x": 0.173496,
				"y": 0.592904
			},
			{
				"x": 0.164068,
				"y": 0.590695
			},
			{
				"x": 0.154569,
				"y": 0.588817
			},
			{
				"x": 0.145009,
				"y": 0.58728
			},
			{
				"x": 0.135399,
				"y": 0.586095
			}
		],
		"le": [
			{
				"x": 0.828773,
				"y": 0.458518
			},
			{
				"x": 0.82726,
				"y": 0.446139
			},
			{
				"x": 0.823377,
				"y": 0.434287
			},
			{
				"x": 0.817449,
				"y": 0.423313
			},
			{
				"x": 0.809866,
				"y": 0.413412
			},
			{
				"x": 0.800992,
				"y": 0.404649
			},
			{
				"x": 0.79113,
				"y": 0.397016
			},
			{
				"x": 0.780517,
				"y": 0.39047
			},
			{
				"x": 0.769334,
				"y": 0.384955
			},
			{
				"x": 0.757722,
				"y": 0.380416
			},
			{
				"x": 0.745789,
				"y": 0.376805
			},
			{
				"x": 0.733624,
				"y": 0.374083
			},
			{
				"x": 0.721298,
				"y": 0.372219
			},
			{
				"x": 0.708874,
				"y": 0.371192
			},
			{
				"x": 0.69641,
				"y": 0.370989
			},
			{
				"x": 0.68396,
				"y": 0.371605
			},
			{
				"x": 0.671577,
				"y": 0.373045
			},
			{
				"x": 0.65932,
				"y": 0.37532
			},
			{
				"x": 0.647253,
				"y": 0.378453
			},
			{
				"x": 0.635452,
				"y": 0.382472
			},
			{
				"x": 0.624005,
				"y": 0.387416
			},
			{
				"x": 0.613029,
				"y": 0.393331
			},
			{
				"x": 0.602666,
				"y": 0.400269
			},
			{
				"x": 0.593108,
				"y": 0.408279
			},
			{
				"x": 0.584598,
				"y": 0.417398
			},
			{
				"x": 0.577448,
				"y": 0.427618
			},
			{
				"x": 0.572027,
				"y": 0.43885
			},
			{
				"x": 0.568717,
				"y": 0.450875
			},
			{
				"x": 0.568414,
				"y": 0.46156
			},
			{
				"x": 0.577981,
				"y": 0.453622
			},
			{
				"x": 0.588982,
				"y": 0.447764
			},
			{
				"x": 0.60055,
				"y": 0.443114
			},
			{
				"x": 0.612421,
				"y": 0.439303
			},
			{
				"x": 0.624483,
				"y": 0.436146
			},
			{
				"x": 0.636675,
				"y": 0.433535
			},
			{
				"x": 0.64896,
				"y": 0.431408
			},
			{
				"x": 0.661315,
				"y": 0.429731
			},
			{
				"x": 0.67372,
				"y": 0.428487
			},
			{
				"x": 0.686161,
				"y": 0.427676
			},
			{
				"x": 0.698623,
				"y": 0.427314
			},
			{
				"x": 0.71109,
				"y": 0.427417
			},
			{
				"x": 0.723545,
				"y": 0.427968
			},
			{
				"x": 0.735973,
				"y": 0.428951
			},
			{
				"x": 0.74836,
				"y": 0.43037
			},
			{
				"x": 0.760686,
				"y": 0.432243
			},
			{
				"x": 0.772928,
				"y": 0.434608
			},
			{
				"x": 0.785048,
				"y": 0.437534
			},
			{
				"x": 0.796985,
				"y": 0.441133
			},
			{
				"x": 0.808619,
				"y": 0.445613
			},
			{
				"x": 0.819664,
				"y": 0.451384
			}
		],
		"re": [
			{
				"x": 0.171227,
				"y": 0.458518
			},
			{
				"x": 0.17274,
				"y": 0.446139
			},
			{
				"x": 0.176623,
				"y": 0.434287
			},
			{
				"x": 0.182551,
				"y": 0.423313
			},
			{
				"x": 0.190134,
				"y": 0.413412
			},
			{
				"x": 0.199008,
				"y": 0.404649
			},
			{
				"x": 0.20887,
				"y": 0.397016
			},
			{
				"x": 0.219483,
				"y": 0.39047
			},
			{
				"x": 0.230666,
				"y": 0.384955
			},
			{
				"x": 0.242278,
				"y": 0.380416
			},
			{
				"x": 0.254211,
				"y": 0.376805
			},
			{
				"x": 0.266376,
				"y": 0.374083
			},
			{
				"x": 0.278702,
				"y": 0.372219
			},
			{
				"x": 0.291126,
				"y": 0.371192
			},
			{
				"x": 0.30359,
				"y": 0.370989
			},
			{
				"x": 0.31604,
				"y": 0.371605
			},
			{
				"x": 0.328423,
				"y": 0.373045
			},
			{
				"x": 0.34068,
				"y": 0.37532
			},
			{
				"x": 0.352747,
				"y": 0.378453
			},
			{
				"x": 0.364548,
				"y": 0.382472
			},
			{
				"x": 0.375995,
				"y": 0.387416
			},
			{
				"x": 0.386971,
				"y": 0.393331
			},
			{
				"x": 0.397334,
				"y": 0.400269
			},
			{
				"x": 0.406892,
				"y": 0.408279
			},
			{
				"x": 0.415402,
				"y": 0.417398
			},
			{
				"x": 0.422552,
				"y": 0.427618
			},
			{
				"x": 0.427973,
				"y": 0.43885
			},
			{
				"x": 0.431283,
				"y": 0.450875
			},
			{
				"x": 0.431586,
				"y": 0.46156
			},
			{
				"x": 0.422019,
				"y": 0.453622
			},
			{
				"x": 0.411018,
				"y": 0.447764
			},
			{
				"x": 0.39945,
				"y": 0.443114
			},
			{
				"x": 0.387579,
				"y": 0.439303
			},
			{
				"x": 0.375517,
				"y": 0.436146
			},
			{
				"x": 0.363325,
				"y": 0.433535
			},
			{
				"x": 0.35104,
				"y": 0.431408
			},
			{
				"x": 0.338685,
				"y": 0.429731
			},
			{
				"x": 0.32628,
				"y": 0.428487
			},
			{
				"x": 0.313839,
				"y": 0.427676
			},
			{
				"x": 0.301377,
				"y": 0.427314
			},
			{
				"x": 0.28891,
				"y": 0.427417
			},
			{
				"x": 0.276455,
				"y": 0.427968
			},
			{
				"x": 0.264027,
				"y": 0.428951
			},
			{
				"x": 0.25164,
				"y": 0.43037
			},
			{
				"x": 0.239314,
				"y": 0.432243
			},
			{
				"x": 0.227072,
				"y": 0.434608
			},
			{
				"x": 0.214952,
				"y": 0.437534
			},
			{
				"x": 0.203015,
				"y": 0.441133
			},
			{
				"x": 0.191381,
				"y": 0.445613
			},
			{
				"x": 0.180336,
				"y": 0.451384
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.390762,
				"y": 0.196801
			},
			{
				"x": 0.394858,
				"y": 0.19609
			},
			{
				"x": 0.403863,
				"y": 0.200954
			},
			{
				"x": 0.41322,
				"y": 0.205103
			},
			{
				"x": 0.422802,
				"y": 0.208699
			},
			{
				"x": 0.432546,
				"y": 0.211831
			},
			{
				"x": 0.442414,
				"y": 0.214546
			},
			{
				"x": 0.45238,
				"y": 0.216872
			},
			{
				"x": 0.462428,
				"y": 0.218816
			},
			{
				"x": 0.472543,
				"y": 0.220369
			},
			{
				"x": 0.482713,
				"y": 0.221505
			},
			{
				"x": 0.492924,
				"y": 0.222174
			},
			{
				"x": 0.503156,
				"y": 0.22229
			},
			{
				"x": 0.513378,
				"y": 0.22182
			},
			{
				"x": 0.523565,
				"y": 0.220856
			},
			{
				"x": 0.533703,
				"y": 0.219458
			},
			{
				"x": 0.543778,
				"y": 0.217662
			},
			{
				"x": 0.553777,
				"y": 0.215483
			},
			{
				"x": 0.563685,
				"y": 0.212918
			},
			{
				"x": 0.57348,
				"y": 0.209951
			},
			{
				"x": 0.583131,
				"y": 0.206541
			},
			{
				"x": 0.592584,
				"y": 0.202617
			},
			{
				"x": 0.601745,
				"y": 0.198054
			},
			{
				"x": 0.610163,
				"y": 0.192984
			},
			{
				"x": 0.607215,
				"y": 0.202789
			},
			{
				"x": 0.602708,
				"y": 0.211984
			},
			{
				"x": 0.596939,
				"y": 0.220445
			},
			{
				"x": 0.590165,
				"y": 0.228123
			},
			{
				"x": 0.582591,
				"y": 0.235012
			},
			{
				"x": 0.574377,
				"y": 0.241123
			},
			{
				"x": 0.565651,
				"y": 0.246472
			},
			{
				"x": 0.55651,
				"y": 0.251078
			},
			{
				"x": 0.547037,
				"y": 0.25495
			},
			{
				"x": 0.537299,
				"y": 0.258097
			},
			{
				"x": 0.527356,
				"y": 0.260515
			},
			{
				"x": 0.517264,
				"y": 0.262198
			},
			{
				"x": 0.507074,
				"y": 0.263128
			},
			{
				"x": 0.496844,
				"y": 0.26328
			},
			{
				"x": 0.486633,
				"y": 0.262645
			},
			{
				"x": 0.476496,
				"y": 0.261248
			},
			{
				"x": 0.46649,
				"y": 0.25911
			},
			{
				"x": 0.456667,
				"y": 0.256242
			},
			{
				"x": 0.447085,
				"y": 0.252648
			},
			{
				"x": 0.437808,
				"y": 0.248324
			},
			{
				"x": 0.428912,
				"y": 0.243262
			},
			{
				"x": 0.420489,
				"y": 0.237444
			},
			{
				"x": 0.412653,
				"y": 0.230856
			},
			{
				"x": 0.40555,
				"y": 0.223481
			},
			{
				"x": 0.399368,
				"y": 0.215317
			},
			{
				"x": 0.394344,
				"y": 0.206394
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"confused": {
		"lb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"rb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"le": [
			{
				"x": 0.708191,
				"y": 0.6214
			},
			{
				"x": 0.707865,
				"y": 0.614079
			},
			{
				"x": 0.706885,
				"y": 0.606817
			},
			{
				"x": 0.705245,
				"y": 0.599675
			},
			{
				"x": 0.702935,
				"y": 0.592722
			},
			{
				"x": 0.699944,
				"y": 0.586036
			},
			{
				"x": 0.696261,
				"y": 0.579706
			},
			{
				"x": 0.691878,
				"y": 0.573841
			},
			{
				"x": 0.6868,
				"y": 0.568571
			},
			{
				"x": 0.681053,
				"y": 0.564045
			},
			{
				"x": 0.674695,
				"y": 0.560432
			},
			{
				"x": 0.667839,
				"y": 0.557899
			},
			{
				"x": 0.66065,
				"y": 0.556591
			},
			{
				"x": 0.653343,
				"y": 0.556591
			},
			{
				"x": 0.646154,
				"y": 0.557899
			},
			{
				"x": 0.639298,
				"y": 0.560432
			},
			{
				"x": 0.632941,
				"y": 0.564045
			},
			{
				"x": 0.627193,
				"y": 0.568571
			},
			{
				"x": 0.622115,
				"y": 0.573841
			},
			{
				"x": 0.617732,
				"y": 0.579706
			},
			{
				"x": 0.614049,
				"y": 0.586036
			},
			{
				"x": 0.611058,
				"y": 0.592722
			},
			{
				"x": 0.608748,
				"y": 0.599675
			},
			{
				"x": 0.607108,
				"y": 0.606817
			},
			{
				"x": 0.606128,
				"y": 0.614079
			},
			{
				"x": 0.605802,
				"y": 0.6214
			},
			{
				"x": 0.606128,
				"y": 0.628721
			},
			{
				"x": 0.607108,
				"y": 0.635983
			},
			{
				"x": 0.608748,
				"y": 0.643125
			},
			{
				"x": 0.611058,
				"y": 0.650077
			},
			{
				"x": 0.614049,
				"y": 0.656764
			},
			{
				"x": 0.617732,
				"y": 0.663094
			},
			{
				"x": 0.622115,
				"y": 0.668959
			},
			{
				"x": 0.627193,
				"y": 0.674229
			},
			{
				"x": 0.632941,
				"y": 0.678755
			},
			{
				"x": 0.639298,
				"y": 0.682368
			},
			{
				"x": 0.646154,
				"y": 0.684901
			},
			{
				"x": 0.653343,
				"y": 0.686209
			},
			{
				"x": 0.66065,
				"y": 0.686209
			},
			{
				"x": 0.667839,
				"y": 0.684901
			},
			{
				"x": 0.674695,
				"y": 0.682368
			},
			{
				"x": 0.681053,
				"y": 0.678755
			},
			{
				"x": 0.6868,
				"y": 0.674229
			},
			{
				"x": 0.691878,
				"y": 0.668959
			},
			{
				"x": 0.696261,
				"y": 0.663094
			},
			{
				"x": 0.699944,
				"y": 0.656764
			},
			{
				"x": 0.702935,
				"y": 0.650077
			},
			{
				"x": 0.705245,
				"y": 0.643125
			},
			{
				"x": 0.706885,
				"y": 0.635983
			},
			{
				"x": 0.707865,
				"y": 0.628721
			}
		],
		"re": [
			{
				"x": 0.291809,
				"y": 0.6214
			},
			{
				"x": 0.292135,
				"y": 0.614079
			},
			{
				"x": 0.293115,
				"y": 0.606817
			},
			{
				"x": 0.294755,
				"y": 0.599675
			},
			{
				"x": 0.297065,
				"y": 0.592722
			},
			{
				"x": 0.300056,
				"y": 0.586036
			},
			{
				"x": 0.303739,
				"y": 0.579706
			},
			{
				"x": 0.308122,
				"y": 0.573841
			},
			{
				"x": 0.3132,
				"y": 0.568571
			},
			{
				"x": 0.318947,
				"y": 0.564045
			},
			{
				"x": 0.325305,
				"y": 0.560432
			},
			{
				"x": 0.332161,
				"y": 0.557899
			},
			{
				"x": 0.33935,
				"y": 0.556591
			},
			{
				"x": 0.346657,
				"y": 0.556591
			},
			{
				"x": 0.353846,
				"y": 0.557899
			},
			{
				"x": 0.360702,
				"y": 0.560432
			},
			{
				"x": 0.367059,
				"y": 0.564045
			},
			{
				"x": 0.372807,
				"y": 0.568571
			},
			{
				"x": 0.377885,
				"y": 0.573841
			},
			{
				"x": 0.382268,
				"y": 0.579706
			},
			{
				"x": 0.385951,
				"y": 0.586036
			},
			{
				"x": 0.388942,
				"y": 0.592722
			},
			{
				"x": 0.391252,
				"y": 0.599675
			},
			{
				"x": 0.392892,
				"y": 0.606817
			},
			{
				"x": 0.393872,
				"y": 0.614079
			},
			{
				"x": 0.394198,
				"y": 0.6214
			},
			{
				"x": 0.393872,
				"y": 0.628721
			},
			{
				"x": 0.392892,
				"y": 0.635983
			},
			{
				"x": 0.391252,
				"y": 0.643125
			},
			{
				"x": 0.388942,
				"y": 0.650077
			},
			{
				"x": 0.385951,
				"y": 0.656764
			},
			{
				"x": 0.382268,
				"y": 0.663094
			},
			{
				"x": 0.377885,
				"y": 0.668959
			},
			{
				"x": 0.372807,
				"y": 0.674229
			},
			{
				"x": 0.367059,
				"y": 0.678755
			},
			{
				"x": 0.360702,
				"y": 0.682368
			},
			{
				"x": 0.353846,
				"y": 0.684901
			},
			{
				"x": 0.346657,
				"y": 0.686209
			},
			{
				"x": 0.33935,
				"y": 0.686209
			},
			{
				"x": 0.332161,
				"y": 0.684901
			},
			{
				"x": 0.325305,
				"y": 0.682368
			},
			{
				"x": 0.318947,
				"y": 0.678755
			},
			{
				"x": 0.3132,
				"y": 0.674229
			},
			{
				"x": 0.308122,
				"y": 0.668959
			},
			{
				"x": 0.303739,
				"y": 0.663094
			},
			{
				"x": 0.300056,
				"y": 0.656764
			},
			{
				"x": 0.297065,
				"y": 0.650077
			},
			{
				"x": 0.294755,
				"y": 0.643125
			},
			{
				"x": 0.293115,
				"y": 0.635983
			},
			{
				"x": 0.292135,
				"y": 0.628721
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.302761,
				"y": 0.253558
			},
			{
				"x": 0.315825,
				"y": 0.266717
			},
			{
				"x": 0.33012,
				"y": 0.278532
			},
			{
				"x": 0.34521,
				"y": 0.289312
			},
			{
				"x": 0.360876,
				"y": 0.299235
			},
			{
				"x": 0.376995,
				"y": 0.308401
			},
			{
				"x": 0.39349,
				"y": 0.316869
			},
			{
				"x": 0.410311,
				"y": 0.324668
			},
			{
				"x": 0.427425,
				"y": 0.331798
			},
			{
				"x": 0.44481,
				"y": 0.338238
			},
			{
				"x": 0.46245,
				"y": 0.343934
			},
			{
				"x": 0.480337,
				"y": 0.348798
			},
			{
				"x": 0.498461,
				"y": 0.352678
			},
			{
				"x": 0.516787,
				"y": 0.355446
			},
			{
				"x": 0.535234,
				"y": 0.357241
			},
			{
				"x": 0.553744,
				"y": 0.358189
			},
			{
				"x": 0.572278,
				"y": 0.358363
			},
			{
				"x": 0.590804,
				"y": 0.357798
			},
			{
				"x": 0.609293,
				"y": 0.356504
			},
			{
				"x": 0.627715,
				"y": 0.354462
			},
			{
				"x": 0.646031,
				"y": 0.35162
			},
			{
				"x": 0.664187,
				"y": 0.34789
			},
			{
				"x": 0.682096,
				"y": 0.343115
			},
			{
				"x": 0.699601,
				"y": 0.337026
			},
			{
				"x": 0.712596,
				"y": 0.334043
			},
			{
				"x": 0.70364,
				"y": 0.350133
			},
			{
				"x": 0.689567,
				"y": 0.362128
			},
			{
				"x": 0.673171,
				"y": 0.370739
			},
			{
				"x": 0.655695,
				"y": 0.376898
			},
			{
				"x": 0.637677,
				"y": 0.381228
			},
			{
				"x": 0.619372,
				"y": 0.384123
			},
			{
				"x": 0.600918,
				"y": 0.385838
			},
			{
				"x": 0.582397,
				"y": 0.386543
			},
			{
				"x": 0.563864,
				"y": 0.386357
			},
			{
				"x": 0.545357,
				"y": 0.385363
			},
			{
				"x": 0.526904,
				"y": 0.383619
			},
			{
				"x": 0.508532,
				"y": 0.381162
			},
			{
				"x": 0.490266,
				"y": 0.378016
			},
			{
				"x": 0.472129,
				"y": 0.37419
			},
			{
				"x": 0.454148,
				"y": 0.369683
			},
			{
				"x": 0.436356,
				"y": 0.364479
			},
			{
				"x": 0.418792,
				"y": 0.358549
			},
			{
				"x": 0.401508,
				"y": 0.351846
			},
			{
				"x": 0.384572,
				"y": 0.344304
			},
			{
				"x": 0.368084,
				"y": 0.335824
			},
			{
				"x": 0.352194,
				"y": 0.326269
			},
			{
				"x": 0.337146,
				"y": 0.315437
			},
			{
				"x": 0.323364,
				"y": 0.303037
			},
			{
				"x": 0.311671,
				"y": 0.288661
			},
			{
				"x": 0.303782,
				"y": 0.271935
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"slightly_frowning_face": {
		"lb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"rb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"le": [
			{
				"x": 0.708191,
				"y": 0.6214
			},
			{
				"x": 0.707865,
				"y": 0.614079
			},
			{
				"x": 0.706885,
				"y": 0.606817
			},
			{
				"x": 0.705245,
				"y": 0.599675
			},
			{
				"x": 0.702935,
				"y": 0.592722
			},
			{
				"x": 0.699944,
				"y": 0.586036
			},
			{
				"x": 0.696261,
				"y": 0.579706
			},
			{
				"x": 0.691878,
				"y": 0.573841
			},
			{
				"x": 0.6868,
				"y": 0.568571
			},
			{
				"x": 0.681053,
				"y": 0.564045
			},
			{
				"x": 0.674695,
				"y": 0.560432
			},
			{
				"x": 0.667839,
				"y": 0.557899
			},
			{
				"x": 0.66065,
				"y": 0.556591
			},
			{
				"x": 0.653343,
				"y": 0.556591
			},
			{
				"x": 0.646154,
				"y": 0.557899
			},
			{
				"x": 0.639298,
				"y": 0.560432
			},
			{
				"x": 0.632941,
				"y": 0.564045
			},
			{
				"x": 0.627193,
				"y": 0.568571
			},
			{
				"x": 0.622115,
				"y": 0.573841
			},
			{
				"x": 0.617732,
				"y": 0.579706
			},
			{
				"x": 0.614049,
				"y": 0.586036
			},
			{
				"x": 0.611058,
				"y": 0.592722
			},
			{
				"x": 0.608748,
				"y": 0.599675
			},
			{
				"x": 0.607108,
				"y": 0.606817
			},
			{
				"x": 0.606128,
				"y": 0.614079
			},
			{
				"x": 0.605802,
				"y": 0.6214
			},
			{
				"x": 0.606128,
				"y": 0.628721
			},
			{
				"x": 0.607108,
				"y": 0.635983
			},
			{
				"x": 0.608748,
				"y": 0.643125
			},
			{
				"x": 0.611058,
				"y": 0.650077
			},
			{
				"x": 0.614049,
				"y": 0.656764
			},
			{
				"x": 0.617732,
				"y": 0.663094
			},
			{
				"x": 0.622115,
				"y": 0.668959
			},
			{
				"x": 0.627193,
				"y": 0.674229
			},
			{
				"x": 0.632941,
				"y": 0.678755
			},
			{
				"x": 0.639298,
				"y": 0.682368
			},
			{
				"x": 0.646154,
				"y": 0.684901
			},
			{
				"x": 0.653343,
				"y": 0.686209
			},
			{
				"x": 0.66065,
				"y": 0.686209
			},
			{
				"x": 0.667839,
				"y": 0.684901
			},
			{
				"x": 0.674695,
				"y": 0.682368
			},
			{
				"x": 0.681053,
				"y": 0.678755
			},
			{
				"x": 0.6868,
				"y": 0.674229
			},
			{
				"x": 0.691878,
				"y": 0.668959
			},
			{
				"x": 0.696261,
				"y": 0.663094
			},
			{
				"x": 0.699944,
				"y": 0.656764
			},
			{
				"x": 0.702935,
				"y": 0.650077
			},
			{
				"x": 0.705245,
				"y": 0.643125
			},
			{
				"x": 0.706885,
				"y": 0.635983
			},
			{
				"x": 0.707865,
				"y": 0.628721
			}
		],
		"re": [
			{
				"x": 0.291809,
				"y": 0.6214
			},
			{
				"x": 0.292135,
				"y": 0.614079
			},
			{
				"x": 0.293115,
				"y": 0.606817
			},
			{
				"x": 0.294755,
				"y": 0.599675
			},
			{
				"x": 0.297065,
				"y": 0.592722
			},
			{
				"x": 0.300056,
				"y": 0.586036
			},
			{
				"x": 0.303739,
				"y": 0.579706
			},
			{
				"x": 0.308122,
				"y": 0.573841
			},
			{
				"x": 0.3132,
				"y": 0.568571
			},
			{
				"x": 0.318947,
				"y": 0.564045
			},
			{
				"x": 0.325305,
				"y": 0.560432
			},
			{
				"x": 0.332161,
				"y": 0.557899
			},
			{
				"x": 0.33935,
				"y": 0.556591
			},
			{
				"x": 0.346657,
				"y": 0.556591
			},
			{
				"x": 0.353846,
				"y": 0.557899
			},
			{
				"x": 0.360702,
				"y": 0.560432
			},
			{
				"x": 0.367059,
				"y": 0.564045
			},
			{
				"x": 0.372807,
				"y": 0.568571
			},
			{
				"x": 0.377885,
				"y": 0.573841
			},
			{
				"x": 0.382268,
				"y": 0.579706
			},
			{
				"x": 0.385951,
				"y": 0.586036
			},
			{
				"x": 0.388942,
				"y": 0.592722
			},
			{
				"x": 0.391252,
				"y": 0.599675
			},
			{
				"x": 0.392892,
				"y": 0.606817
			},
			{
				"x": 0.393872,
				"y": 0.614079
			},
			{
				"x": 0.394198,
				"y": 0.6214
			},
			{
				"x": 0.393872,
				"y": 0.628721
			},
			{
				"x": 0.392892,
				"y": 0.635983
			},
			{
				"x": 0.391252,
				"y": 0.643125
			},
			{
				"x": 0.388942,
				"y": 0.650077
			},
			{
				"x": 0.385951,
				"y": 0.656764
			},
			{
				"x": 0.382268,
				"y": 0.663094
			},
			{
				"x": 0.377885,
				"y": 0.668959
			},
			{
				"x": 0.372807,
				"y": 0.674229
			},
			{
				"x": 0.367059,
				"y": 0.678755
			},
			{
				"x": 0.360702,
				"y": 0.682368
			},
			{
				"x": 0.353846,
				"y": 0.684901
			},
			{
				"x": 0.346657,
				"y": 0.686209
			},
			{
				"x": 0.33935,
				"y": 0.686209
			},
			{
				"x": 0.332161,
				"y": 0.684901
			},
			{
				"x": 0.325305,
				"y": 0.682368
			},
			{
				"x": 0.318947,
				"y": 0.678755
			},
			{
				"x": 0.3132,
				"y": 0.674229
			},
			{
				"x": 0.308122,
				"y": 0.668959
			},
			{
				"x": 0.303739,
				"y": 0.663094
			},
			{
				"x": 0.300056,
				"y": 0.656764
			},
			{
				"x": 0.297065,
				"y": 0.650077
			},
			{
				"x": 0.294755,
				"y": 0.643125
			},
			{
				"x": 0.293115,
				"y": 0.635983
			},
			{
				"x": 0.292135,
				"y": 0.628721
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.312763,
				"y": 0.24943
			},
			{
				"x": 0.326173,
				"y": 0.259767
			},
			{
				"x": 0.340567,
				"y": 0.268686
			},
			{
				"x": 0.355588,
				"y": 0.276505
			},
			{
				"x": 0.371052,
				"y": 0.283405
			},
			{
				"x": 0.386852,
				"y": 0.289492
			},
			{
				"x": 0.40292,
				"y": 0.294829
			},
			{
				"x": 0.41921,
				"y": 0.299445
			},
			{
				"x": 0.435686,
				"y": 0.30334
			},
			{
				"x": 0.452319,
				"y": 0.306491
			},
			{
				"x": 0.469084,
				"y": 0.308841
			},
			{
				"x": 0.485949,
				"y": 0.310294
			},
			{
				"x": 0.502871,
				"y": 0.310685
			},
			{
				"x": 0.51978,
				"y": 0.30991
			},
			{
				"x": 0.536615,
				"y": 0.308139
			},
			{
				"x": 0.553339,
				"y": 0.305508
			},
			{
				"x": 0.569922,
				"y": 0.3021
			},
			{
				"x": 0.586338,
				"y": 0.297959
			},
			{
				"x": 0.602557,
				"y": 0.293101
			},
			{
				"x": 0.61854,
				"y": 0.287514
			},
			{
				"x": 0.634235,
				"y": 0.28116
			},
			{
				"x": 0.649564,
				"y": 0.273963
			},
			{
				"x": 0.664398,
				"y": 0.265797
			},
			{
				"x": 0.678513,
				"y": 0.256441
			},
			{
				"x": 0.686836,
				"y": 0.255165
			},
			{
				"x": 0.68141,
				"y": 0.271136
			},
			{
				"x": 0.671382,
				"y": 0.284745
			},
			{
				"x": 0.658706,
				"y": 0.295958
			},
			{
				"x": 0.644514,
				"y": 0.305186
			},
			{
				"x": 0.629397,
				"y": 0.312809
			},
			{
				"x": 0.613682,
				"y": 0.319106
			},
			{
				"x": 0.59756,
				"y": 0.324275
			},
			{
				"x": 0.581154,
				"y": 0.328454
			},
			{
				"x": 0.564548,
				"y": 0.331743
			},
			{
				"x": 0.5478,
				"y": 0.334213
			},
			{
				"x": 0.530957,
				"y": 0.335912
			},
			{
				"x": 0.514056,
				"y": 0.336871
			},
			{
				"x": 0.497129,
				"y": 0.337108
			},
			{
				"x": 0.480207,
				"y": 0.336627
			},
			{
				"x": 0.463322,
				"y": 0.33542
			},
			{
				"x": 0.446506,
				"y": 0.333464
			},
			{
				"x": 0.429801,
				"y": 0.330722
			},
			{
				"x": 0.413255,
				"y": 0.32714
			},
			{
				"x": 0.396935,
				"y": 0.322638
			},
			{
				"x": 0.380935,
				"y": 0.317105
			},
			{
				"x": 0.365396,
				"y": 0.310384
			},
			{
				"x": 0.350547,
				"y": 0.302253
			},
			{
				"x": 0.336783,
				"y": 0.292399
			},
			{
				"x": 0.324841,
				"y": 0.280414
			},
			{
				"x": 0.316114,
				"y": 0.265947
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"white_frowning_face": {
		"lb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"rb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"le": [
			{
				"x": 0.708191,
				"y": 0.6214
			},
			{
				"x": 0.707865,
				"y": 0.614079
			},
			{
				"x": 0.706885,
				"y": 0.606817
			},
			{
				"x": 0.705245,
				"y": 0.599675
			},
			{
				"x": 0.702935,
				"y": 0.592722
			},
			{
				"x": 0.699944,
				"y": 0.586036
			},
			{
				"x": 0.696261,
				"y": 0.579706
			},
			{
				"x": 0.691878,
				"y": 0.573841
			},
			{
				"x": 0.6868,
				"y": 0.568571
			},
			{
				"x": 0.681053,
				"y": 0.564045
			},
			{
				"x": 0.674695,
				"y": 0.560432
			},
			{
				"x": 0.667839,
				"y": 0.557899
			},
			{
				"x": 0.66065,
				"y": 0.556591
			},
			{
				"x": 0.653343,
				"y": 0.556591
			},
			{
				"x": 0.646154,
				"y": 0.557899
			},
			{
				"x": 0.639298,
				"y": 0.560432
			},
			{
				"x": 0.632941,
				"y": 0.564045
			},
			{
				"x": 0.627193,
				"y": 0.568571
			},
			{
				"x": 0.622115,
				"y": 0.573841
			},
			{
				"x": 0.617732,
				"y": 0.579706
			},
			{
				"x": 0.614049,
				"y": 0.586036
			},
			{
				"x": 0.611058,
				"y": 0.592722
			},
			{
				"x": 0.608748,
				"y": 0.599675
			},
			{
				"x": 0.607108,
				"y": 0.606817
			},
			{
				"x": 0.606128,
				"y": 0.614079
			},
			{
				"x": 0.605802,
				"y": 0.6214
			},
			{
				"x": 0.606128,
				"y": 0.628721
			},
			{
				"x": 0.607108,
				"y": 0.635983
			},
			{
				"x": 0.608748,
				"y": 0.643125
			},
			{
				"x": 0.611058,
				"y": 0.650077
			},
			{
				"x": 0.614049,
				"y": 0.656764
			},
			{
				"x": 0.617732,
				"y": 0.663094
			},
			{
				"x": 0.622115,
				"y": 0.668959
			},
			{
				"x": 0.627193,
				"y": 0.674229
			},
			{
				"x": 0.632941,
				"y": 0.678755
			},
			{
				"x": 0.639298,
				"y": 0.682368
			},
			{
				"x": 0.646154,
				"y": 0.684901
			},
			{
				"x": 0.653343,
				"y": 0.686209
			},
			{
				"x": 0.66065,
				"y": 0.686209
			},
			{
				"x": 0.667839,
				"y": 0.684901
			},
			{
				"x": 0.674695,
				"y": 0.682368
			},
			{
				"x": 0.681053,
				"y": 0.678755
			},
			{
				"x": 0.6868,
				"y": 0.674229
			},
			{
				"x": 0.691878,
				"y": 0.668959
			},
			{
				"x": 0.696261,
				"y": 0.663094
			},
			{
				"x": 0.699944,
				"y": 0.656764
			},
			{
				"x": 0.702935,
				"y": 0.650077
			},
			{
				"x": 0.705245,
				"y": 0.643125
			},
			{
				"x": 0.706885,
				"y": 0.635983
			},
			{
				"x": 0.707865,
				"y": 0.628721
			}
		],
		"re": [
			{
				"x": 0.291809,
				"y": 0.6214
			},
			{
				"x": 0.292135,
				"y": 0.614079
			},
			{
				"x": 0.293115,
				"y": 0.606817
			},
			{
				"x": 0.294755,
				"y": 0.599675
			},
			{
				"x": 0.297065,
				"y": 0.592722
			},
			{
				"x": 0.300056,
				"y": 0.586036
			},
			{
				"x": 0.303739,
				"y": 0.579706
			},
			{
				"x": 0.308122,
				"y": 0.573841
			},
			{
				"x": 0.3132,
				"y": 0.568571
			},
			{
				"x": 0.318947,
				"y": 0.564045
			},
			{
				"x": 0.325305,
				"y": 0.560432
			},
			{
				"x": 0.332161,
				"y": 0.557899
			},
			{
				"x": 0.33935,
				"y": 0.556591
			},
			{
				"x": 0.346657,
				"y": 0.556591
			},
			{
				"x": 0.353846,
				"y": 0.557899
			},
			{
				"x": 0.360702,
				"y": 0.560432
			},
			{
				"x": 0.367059,
				"y": 0.564045
			},
			{
				"x": 0.372807,
				"y": 0.568571
			},
			{
				"x": 0.377885,
				"y": 0.573841
			},
			{
				"x": 0.382268,
				"y": 0.579706
			},
			{
				"x": 0.385951,
				"y": 0.586036
			},
			{
				"x": 0.388942,
				"y": 0.592722
			},
			{
				"x": 0.391252,
				"y": 0.599675
			},
			{
				"x": 0.392892,
				"y": 0.606817
			},
			{
				"x": 0.393872,
				"y": 0.614079
			},
			{
				"x": 0.394198,
				"y": 0.6214
			},
			{
				"x": 0.393872,
				"y": 0.628721
			},
			{
				"x": 0.392892,
				"y": 0.635983
			},
			{
				"x": 0.391252,
				"y": 0.643125
			},
			{
				"x": 0.388942,
				"y": 0.650077
			},
			{
				"x": 0.385951,
				"y": 0.656764
			},
			{
				"x": 0.382268,
				"y": 0.663094
			},
			{
				"x": 0.377885,
				"y": 0.668959
			},
			{
				"x": 0.372807,
				"y": 0.674229
			},
			{
				"x": 0.367059,
				"y": 0.678755
			},
			{
				"x": 0.360702,
				"y": 0.682368
			},
			{
				"x": 0.353846,
				"y": 0.684901
			},
			{
				"x": 0.346657,
				"y": 0.686209
			},
			{
				"x": 0.33935,
				"y": 0.686209
			},
			{
				"x": 0.332161,
				"y": 0.684901
			},
			{
				"x": 0.325305,
				"y": 0.682368
			},
			{
				"x": 0.318947,
				"y": 0.678755
			},
			{
				"x": 0.3132,
				"y": 0.674229
			},
			{
				"x": 0.308122,
				"y": 0.668959
			},
			{
				"x": 0.303739,
				"y": 0.663094
			},
			{
				"x": 0.300056,
				"y": 0.656764
			},
			{
				"x": 0.297065,
				"y": 0.650077
			},
			{
				"x": 0.294755,
				"y": 0.643125
			},
			{
				"x": 0.293115,
				"y": 0.635983
			},
			{
				"x": 0.292135,
				"y": 0.628721
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.282142,
				"y": 0.257888
			},
			{
				"x": 0.295756,
				"y": 0.275978
			},
			{
				"x": 0.311093,
				"y": 0.29263
			},
			{
				"x": 0.327783,
				"y": 0.307924
			},
			{
				"x": 0.345583,
				"y": 0.321906
			},
			{
				"x": 0.364326,
				"y": 0.334591
			},
			{
				"x": 0.383893,
				"y": 0.345958
			},
			{
				"x": 0.404196,
				"y": 0.355946
			},
			{
				"x": 0.425163,
				"y": 0.364446
			},
			{
				"x": 0.446725,
				"y": 0.371285
			},
			{
				"x": 0.468802,
				"y": 0.376195
			},
			{
				"x": 0.491266,
				"y": 0.378764
			},
			{
				"x": 0.513868,
				"y": 0.378415
			},
			{
				"x": 0.53626,
				"y": 0.375266
			},
			{
				"x": 0.558228,
				"y": 0.369887
			},
			{
				"x": 0.579661,
				"y": 0.362651
			},
			{
				"x": 0.600482,
				"y": 0.3538
			},
			{
				"x": 0.620625,
				"y": 0.343491
			},
			{
				"x": 0.640014,
				"y": 0.33182
			},
			{
				"x": 0.658554,
				"y": 0.318839
			},
			{
				"x": 0.676118,
				"y": 0.304561
			},
			{
				"x": 0.692525,
				"y": 0.288964
			},
			{
				"x": 0.707509,
				"y": 0.271993
			},
			{
				"x": 0.717761,
				"y": 0.263043
			},
			{
				"x": 0.715071,
				"y": 0.285524
			},
			{
				"x": 0.708823,
				"y": 0.307286
			},
			{
				"x": 0.699329,
				"y": 0.327837
			},
			{
				"x": 0.686996,
				"y": 0.346819
			},
			{
				"x": 0.672261,
				"y": 0.363999
			},
			{
				"x": 0.655542,
				"y": 0.379249
			},
			{
				"x": 0.637213,
				"y": 0.392517
			},
			{
				"x": 0.6176,
				"y": 0.403794
			},
			{
				"x": 0.596979,
				"y": 0.413095
			},
			{
				"x": 0.575588,
				"y": 0.420449
			},
			{
				"x": 0.553632,
				"y": 0.425881
			},
			{
				"x": 0.531293,
				"y": 0.429418
			},
			{
				"x": 0.508737,
				"y": 0.431076
			},
			{
				"x": 0.486122,
				"y": 0.430863
			},
			{
				"x": 0.463601,
				"y": 0.428779
			},
			{
				"x": 0.441334,
				"y": 0.424813
			},
			{
				"x": 0.41949,
				"y": 0.418946
			},
			{
				"x": 0.398255,
				"y": 0.411152
			},
			{
				"x": 0.377841,
				"y": 0.401403
			},
			{
				"x": 0.358494,
				"y": 0.389675
			},
			{
				"x": 0.340501,
				"y": 0.375954
			},
			{
				"x": 0.324198,
				"y": 0.360257
			},
			{
				"x": 0.309972,
				"y": 0.342653
			},
			{
				"x": 0.298247,
				"y": 0.32329
			},
			{
				"x": 0.289457,
				"y": 0.302426
			},
			{
				"x": 0.283996,
				"y": 0.280454
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"persevere": {
		"lb": [
			{
				"x": 0.87138,
				"y": 0.636056
			},
			{
				"x": 0.86286,
				"y": 0.631454
			},
			{
				"x": 0.853958,
				"y": 0.627643
			},
			{
				"x": 0.84476,
				"y": 0.624622
			},
			{
				"x": 0.835342,
				"y": 0.622379
			},
			{
				"x": 0.825775,
				"y": 0.6209
			},
			{
				"x": 0.816122,
				"y": 0.620166
			},
			{
				"x": 0.806441,
				"y": 0.620155
			},
			{
				"x": 0.796785,
				"y": 0.620844
			},
			{
				"x": 0.787201,
				"y": 0.622213
			},
			{
				"x": 0.777733,
				"y": 0.624237
			},
			{
				"x": 0.768423,
				"y": 0.626898
			},
			{
				"x": 0.75931,
				"y": 0.630173
			},
			{
				"x": 0.750433,
				"y": 0.634043
			},
			{
				"x": 0.741829,
				"y": 0.638489
			},
			{
				"x": 0.733535,
				"y": 0.643493
			},
			{
				"x": 0.725589,
				"y": 0.649035
			},
			{
				"x": 0.718031,
				"y": 0.655097
			},
			{
				"x": 0.710902,
				"y": 0.661659
			},
			{
				"x": 0.704244,
				"y": 0.668701
			},
			{
				"x": 0.698102,
				"y": 0.676199
			},
			{
				"x": 0.692524,
				"y": 0.684126
			},
			{
				"x": 0.687559,
				"y": 0.692453
			},
			{
				"x": 0.683261,
				"y": 0.701144
			},
			{
				"x": 0.679683,
				"y": 0.710157
			},
			{
				"x": 0.676881,
				"y": 0.719441
			},
			{
				"x": 0.674908,
				"y": 0.728936
			},
			{
				"x": 0.676683,
				"y": 0.731923
			},
			{
				"x": 0.683321,
				"y": 0.72486
			},
			{
				"x": 0.690195,
				"y": 0.718028
			},
			{
				"x": 0.697295,
				"y": 0.711432
			},
			{
				"x": 0.70461,
				"y": 0.705074
			},
			{
				"x": 0.712128,
				"y": 0.698961
			},
			{
				"x": 0.719839,
				"y": 0.693094
			},
			{
				"x": 0.727735,
				"y": 0.687479
			},
			{
				"x": 0.735806,
				"y": 0.682119
			},
			{
				"x": 0.744043,
				"y": 0.67702
			},
			{
				"x": 0.752438,
				"y": 0.672185
			},
			{
				"x": 0.760981,
				"y": 0.66762
			},
			{
				"x": 0.769666,
				"y": 0.66333
			},
			{
				"x": 0.778483,
				"y": 0.65932
			},
			{
				"x": 0.787424,
				"y": 0.655598
			},
			{
				"x": 0.796481,
				"y": 0.652168
			},
			{
				"x": 0.805646,
				"y": 0.649039
			},
			{
				"x": 0.81491,
				"y": 0.646217
			},
			{
				"x": 0.824264,
				"y": 0.64371
			},
			{
				"x": 0.833698,
				"y": 0.641526
			},
			{
				"x": 0.843202,
				"y": 0.639675
			},
			{
				"x": 0.852767,
				"y": 0.638166
			},
			{
				"x": 0.86238,
				"y": 0.63701
			}
		],
		"rb": [
			{
				"x": 0.12832,
				"y": 0.636238
			},
			{
				"x": 0.136825,
				"y": 0.631607
			},
			{
				"x": 0.145714,
				"y": 0.627767
			},
			{
				"x": 0.154903,
				"y": 0.624717
			},
			{
				"x": 0.164314,
				"y": 0.622447
			},
			{
				"x": 0.173877,
				"y": 0.620941
			},
			{
				"x": 0.183528,
				"y": 0.62018
			},
			{
				"x": 0.193208,
				"y": 0.620143
			},
			{
				"x": 0.202866,
				"y": 0.620807
			},
			{
				"x": 0.212454,
				"y": 0.622151
			},
			{
				"x": 0.221927,
				"y": 0.624153
			},
			{
				"x": 0.231243,
				"y": 0.626791
			},
			{
				"x": 0.240364,
				"y": 0.630044
			},
			{
				"x": 0.24925,
				"y": 0.633893
			},
			{
				"x": 0.257865,
				"y": 0.638318
			},
			{
				"x": 0.266171,
				"y": 0.643302
			},
			{
				"x": 0.27413,
				"y": 0.648825
			},
			{
				"x": 0.281702,
				"y": 0.654869
			},
			{
				"x": 0.288848,
				"y": 0.661413
			},
			{
				"x": 0.295524,
				"y": 0.668438
			},
			{
				"x": 0.301685,
				"y": 0.67592
			},
			{
				"x": 0.307285,
				"y": 0.683832
			},
			{
				"x": 0.312272,
				"y": 0.692145
			},
			{
				"x": 0.316596,
				"y": 0.700824
			},
			{
				"x": 0.3202,
				"y": 0.709826
			},
			{
				"x": 0.323032,
				"y": 0.7191
			},
			{
				"x": 0.325036,
				"y": 0.728589
			},
			{
				"x": 0.323553,
				"y": 0.732183
			},
			{
				"x": 0.316924,
				"y": 0.725111
			},
			{
				"x": 0.310057,
				"y": 0.718271
			},
			{
				"x": 0.302965,
				"y": 0.711666
			},
			{
				"x": 0.295659,
				"y": 0.7053
			},
			{
				"x": 0.288148,
				"y": 0.699178
			},
			{
				"x": 0.280443,
				"y": 0.693302
			},
			{
				"x": 0.272554,
				"y": 0.687678
			},
			{
				"x": 0.264489,
				"y": 0.682309
			},
			{
				"x": 0.256258,
				"y": 0.6772
			},
			{
				"x": 0.247869,
				"y": 0.672355
			},
			{
				"x": 0.239331,
				"y": 0.66778
			},
			{
				"x": 0.230651,
				"y": 0.66348
			},
			{
				"x": 0.221839,
				"y": 0.659461
			},
			{
				"x": 0.212902,
				"y": 0.655728
			},
			{
				"x": 0.203848,
				"y": 0.652287
			},
			{
				"x": 0.194687,
				"y": 0.649147
			},
			{
				"x": 0.185427,
				"y": 0.646313
			},
			{
				"x": 0.176076,
				"y": 0.643795
			},
			{
				"x": 0.166645,
				"y": 0.6416
			},
			{
				"x": 0.157143,
				"y": 0.639737
			},
			{
				"x": 0.14758,
				"y": 0.638215
			},
			{
				"x": 0.137968,
				"y": 0.637045
			}
		],
		"le": [
			{
				"x": 0.742417,
				"y": 0.361638
			},
			{
				"x": 0.733497,
				"y": 0.352297
			},
			{
				"x": 0.719736,
				"y": 0.351124
			},
			{
				"x": 0.706177,
				"y": 0.353963
			},
			{
				"x": 0.69355,
				"y": 0.359712
			},
			{
				"x": 0.681831,
				"y": 0.367167
			},
			{
				"x": 0.670695,
				"y": 0.375481
			},
			{
				"x": 0.65983,
				"y": 0.384147
			},
			{
				"x": 0.648979,
				"y": 0.392832
			},
			{
				"x": 0.63794,
				"y": 0.401275
			},
			{
				"x": 0.626692,
				"y": 0.409437
			},
			{
				"x": 0.615372,
				"y": 0.417498
			},
			{
				"x": 0.604137,
				"y": 0.425678
			},
			{
				"x": 0.593264,
				"y": 0.434331
			},
			{
				"x": 0.583686,
				"y": 0.44436
			},
			{
				"x": 0.581571,
				"y": 0.457468
			},
			{
				"x": 0.590403,
				"y": 0.46805
			},
			{
				"x": 0.601399,
				"y": 0.476544
			},
			{
				"x": 0.612668,
				"y": 0.484677
			},
			{
				"x": 0.624097,
				"y": 0.492582
			},
			{
				"x": 0.635698,
				"y": 0.500232
			},
			{
				"x": 0.647473,
				"y": 0.50761
			},
			{
				"x": 0.65942,
				"y": 0.514704
			},
			{
				"x": 0.671537,
				"y": 0.521502
			},
			{
				"x": 0.68383,
				"y": 0.527978
			},
			{
				"x": 0.696321,
				"y": 0.534059
			},
			{
				"x": 0.70906,
				"y": 0.539596
			},
			{
				"x": 0.722142,
				"y": 0.544254
			},
			{
				"x": 0.735726,
				"y": 0.547007
			},
			{
				"x": 0.748157,
				"y": 0.542537
			},
			{
				"x": 0.746338,
				"y": 0.52937
			},
			{
				"x": 0.737537,
				"y": 0.518663
			},
			{
				"x": 0.726788,
				"y": 0.509869
			},
			{
				"x": 0.71525,
				"y": 0.502128
			},
			{
				"x": 0.703358,
				"y": 0.494943
			},
			{
				"x": 0.691282,
				"y": 0.488071
			},
			{
				"x": 0.67912,
				"y": 0.481351
			},
			{
				"x": 0.666956,
				"y": 0.474636
			},
			{
				"x": 0.654915,
				"y": 0.467704
			},
			{
				"x": 0.643401,
				"y": 0.459942
			},
			{
				"x": 0.636968,
				"y": 0.448436
			},
			{
				"x": 0.645452,
				"y": 0.437711
			},
			{
				"x": 0.656667,
				"y": 0.429511
			},
			{
				"x": 0.668288,
				"y": 0.421892
			},
			{
				"x": 0.680005,
				"y": 0.414422
			},
			{
				"x": 0.691711,
				"y": 0.406935
			},
			{
				"x": 0.703332,
				"y": 0.399315
			},
			{
				"x": 0.714775,
				"y": 0.39143
			},
			{
				"x": 0.72587,
				"y": 0.383064
			},
			{
				"x": 0.736135,
				"y": 0.37371
			}
		],
		"re": [
			{
				"x": 0.250774,
				"y": 0.367467
			},
			{
				"x": 0.259885,
				"y": 0.358869
			},
			{
				"x": 0.273621,
				"y": 0.360359
			},
			{
				"x": 0.286842,
				"y": 0.364595
			},
			{
				"x": 0.299677,
				"y": 0.369905
			},
			{
				"x": 0.31224,
				"y": 0.375835
			},
			{
				"x": 0.324591,
				"y": 0.382196
			},
			{
				"x": 0.336763,
				"y": 0.388897
			},
			{
				"x": 0.348764,
				"y": 0.395899
			},
			{
				"x": 0.360594,
				"y": 0.403188
			},
			{
				"x": 0.37225,
				"y": 0.410753
			},
			{
				"x": 0.383733,
				"y": 0.41858
			},
			{
				"x": 0.39505,
				"y": 0.426645
			},
			{
				"x": 0.406189,
				"y": 0.434955
			},
			{
				"x": 0.416221,
				"y": 0.444521
			},
			{
				"x": 0.418425,
				"y": 0.457573
			},
			{
				"x": 0.410002,
				"y": 0.468507
			},
			{
				"x": 0.399364,
				"y": 0.477444
			},
			{
				"x": 0.388203,
				"y": 0.485723
			},
			{
				"x": 0.37689,
				"y": 0.493795
			},
			{
				"x": 0.365604,
				"y": 0.501905
			},
			{
				"x": 0.354488,
				"y": 0.510245
			},
			{
				"x": 0.343596,
				"y": 0.518878
			},
			{
				"x": 0.33276,
				"y": 0.527582
			},
			{
				"x": 0.321741,
				"y": 0.536051
			},
			{
				"x": 0.310243,
				"y": 0.543849
			},
			{
				"x": 0.297932,
				"y": 0.55026
			},
			{
				"x": 0.284627,
				"y": 0.554132
			},
			{
				"x": 0.270794,
				"y": 0.554428
			},
			{
				"x": 0.258766,
				"y": 0.548329
			},
			{
				"x": 0.261055,
				"y": 0.53546
			},
			{
				"x": 0.270747,
				"y": 0.525534
			},
			{
				"x": 0.281664,
				"y": 0.516937
			},
			{
				"x": 0.293021,
				"y": 0.50893
			},
			{
				"x": 0.304597,
				"y": 0.501242
			},
			{
				"x": 0.316285,
				"y": 0.493726
			},
			{
				"x": 0.328008,
				"y": 0.486264
			},
			{
				"x": 0.339676,
				"y": 0.478718
			},
			{
				"x": 0.351086,
				"y": 0.470789
			},
			{
				"x": 0.361187,
				"y": 0.461317
			},
			{
				"x": 0.35984,
				"y": 0.448815
			},
			{
				"x": 0.348829,
				"y": 0.440391
			},
			{
				"x": 0.336877,
				"y": 0.433306
			},
			{
				"x": 0.324734,
				"y": 0.426552
			},
			{
				"x": 0.312563,
				"y": 0.419851
			},
			{
				"x": 0.30045,
				"y": 0.413043
			},
			{
				"x": 0.288486,
				"y": 0.405978
			},
			{
				"x": 0.276808,
				"y": 0.398449
			},
			{
				"x": 0.265728,
				"y": 0.39007
			},
			{
				"x": 0.256107,
				"y": 0.380073
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.390762,
				"y": 0.196801
			},
			{
				"x": 0.394858,
				"y": 0.19609
			},
			{
				"x": 0.403863,
				"y": 0.200954
			},
			{
				"x": 0.41322,
				"y": 0.205103
			},
			{
				"x": 0.422802,
				"y": 0.208699
			},
			{
				"x": 0.432546,
				"y": 0.211831
			},
			{
				"x": 0.442414,
				"y": 0.214546
			},
			{
				"x": 0.45238,
				"y": 0.216872
			},
			{
				"x": 0.462428,
				"y": 0.218816
			},
			{
				"x": 0.472543,
				"y": 0.220369
			},
			{
				"x": 0.482713,
				"y": 0.221505
			},
			{
				"x": 0.492924,
				"y": 0.222174
			},
			{
				"x": 0.503156,
				"y": 0.22229
			},
			{
				"x": 0.513378,
				"y": 0.22182
			},
			{
				"x": 0.523565,
				"y": 0.220856
			},
			{
				"x": 0.533703,
				"y": 0.219458
			},
			{
				"x": 0.543778,
				"y": 0.217662
			},
			{
				"x": 0.553777,
				"y": 0.215483
			},
			{
				"x": 0.563685,
				"y": 0.212918
			},
			{
				"x": 0.57348,
				"y": 0.209951
			},
			{
				"x": 0.583131,
				"y": 0.206541
			},
			{
				"x": 0.592584,
				"y": 0.202617
			},
			{
				"x": 0.601745,
				"y": 0.198054
			},
			{
				"x": 0.610163,
				"y": 0.192984
			},
			{
				"x": 0.607215,
				"y": 0.202789
			},
			{
				"x": 0.602708,
				"y": 0.211984
			},
			{
				"x": 0.596939,
				"y": 0.220445
			},
			{
				"x": 0.590165,
				"y": 0.228123
			},
			{
				"x": 0.582591,
				"y": 0.235012
			},
			{
				"x": 0.574377,
				"y": 0.241123
			},
			{
				"x": 0.565651,
				"y": 0.246472
			},
			{
				"x": 0.55651,
				"y": 0.251078
			},
			{
				"x": 0.547037,
				"y": 0.25495
			},
			{
				"x": 0.537299,
				"y": 0.258097
			},
			{
				"x": 0.527356,
				"y": 0.260515
			},
			{
				"x": 0.517264,
				"y": 0.262198
			},
			{
				"x": 0.507074,
				"y": 0.263128
			},
			{
				"x": 0.496844,
				"y": 0.26328
			},
			{
				"x": 0.486633,
				"y": 0.262645
			},
			{
				"x": 0.476496,
				"y": 0.261248
			},
			{
				"x": 0.46649,
				"y": 0.25911
			},
			{
				"x": 0.456667,
				"y": 0.256242
			},
			{
				"x": 0.447085,
				"y": 0.252648
			},
			{
				"x": 0.437808,
				"y": 0.248324
			},
			{
				"x": 0.428912,
				"y": 0.243262
			},
			{
				"x": 0.420489,
				"y": 0.237444
			},
			{
				"x": 0.412653,
				"y": 0.230856
			},
			{
				"x": 0.40555,
				"y": 0.223481
			},
			{
				"x": 0.399368,
				"y": 0.215317
			},
			{
				"x": 0.394344,
				"y": 0.206394
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"tired_face": {
		"lb": [
			{
				"x": 0.797736,
				"y": 0.813282
			},
			{
				"x": 0.79004,
				"y": 0.80881
			},
			{
				"x": 0.781166,
				"y": 0.804936
			},
			{
				"x": 0.771989,
				"y": 0.801852
			},
			{
				"x": 0.762586,
				"y": 0.799547
			},
			{
				"x": 0.753028,
				"y": 0.798008
			},
			{
				"x": 0.74338,
				"y": 0.797214
			},
			{
				"x": 0.733699,
				"y": 0.797146
			},
			{
				"x": 0.724039,
				"y": 0.79778
			},
			{
				"x": 0.714447,
				"y": 0.799094
			},
			{
				"x": 0.704969,
				"y": 0.801067
			},
			{
				"x": 0.695645,
				"y": 0.803678
			},
			{
				"x": 0.686515,
				"y": 0.806904
			},
			{
				"x": 0.677617,
				"y": 0.810727
			},
			{
				"x": 0.668989,
				"y": 0.815128
			},
			{
				"x": 0.660669,
				"y": 0.820087
			},
			{
				"x": 0.652694,
				"y": 0.825587
			},
			{
				"x": 0.645104,
				"y": 0.831608
			},
			{
				"x": 0.637939,
				"y": 0.838131
			},
			{
				"x": 0.631241,
				"y": 0.845135
			},
			{
				"x": 0.625056,
				"y": 0.852597
			},
			{
				"x": 0.61943,
				"y": 0.860491
			},
			{
				"x": 0.614415,
				"y": 0.868787
			},
			{
				"x": 0.610061,
				"y": 0.877451
			},
			{
				"x": 0.606424,
				"y": 0.886439
			},
			{
				"x": 0.603557,
				"y": 0.895703
			},
			{
				"x": 0.601516,
				"y": 0.905184
			},
			{
				"x": 0.602642,
				"y": 0.909516
			},
			{
				"x": 0.60926,
				"y": 0.902434
			},
			{
				"x": 0.616116,
				"y": 0.895584
			},
			{
				"x": 0.623199,
				"y": 0.888969
			},
			{
				"x": 0.630496,
				"y": 0.882592
			},
			{
				"x": 0.637998,
				"y": 0.876459
			},
			{
				"x": 0.645695,
				"y": 0.870572
			},
			{
				"x": 0.653576,
				"y": 0.864936
			},
			{
				"x": 0.661633,
				"y": 0.859556
			},
			{
				"x": 0.669857,
				"y": 0.854435
			},
			{
				"x": 0.678239,
				"y": 0.849579
			},
			{
				"x": 0.686771,
				"y": 0.844992
			},
			{
				"x": 0.695445,
				"y": 0.84068
			},
			{
				"x": 0.704252,
				"y": 0.836648
			},
			{
				"x": 0.713183,
				"y": 0.832902
			},
			{
				"x": 0.722232,
				"y": 0.829449
			},
			{
				"x": 0.731388,
				"y": 0.826295
			},
			{
				"x": 0.740644,
				"y": 0.823448
			},
			{
				"x": 0.749991,
				"y": 0.820915
			},
			{
				"x": 0.759419,
				"y": 0.818706
			},
			{
				"x": 0.768918,
				"y": 0.816828
			},
			{
				"x": 0.778479,
				"y": 0.815291
			},
			{
				"x": 0.788088,
				"y": 0.814105
			}
		],
		"rb": [
			{
				"x": 0.202264,
				"y": 0.813282
			},
			{
				"x": 0.20996,
				"y": 0.80881
			},
			{
				"x": 0.218834,
				"y": 0.804936
			},
			{
				"x": 0.228011,
				"y": 0.801852
			},
			{
				"x": 0.237414,
				"y": 0.799547
			},
			{
				"x": 0.246972,
				"y": 0.798008
			},
			{
				"x": 0.25662,
				"y": 0.797214
			},
			{
				"x": 0.266301,
				"y": 0.797146
			},
			{
				"x": 0.275961,
				"y": 0.79778
			},
			{
				"x": 0.285553,
				"y": 0.799094
			},
			{
				"x": 0.295031,
				"y": 0.801067
			},
			{
				"x": 0.304355,
				"y": 0.803678
			},
			{
				"x": 0.313485,
				"y": 0.806904
			},
			{
				"x": 0.322383,
				"y": 0.810727
			},
			{
				"x": 0.331011,
				"y": 0.815128
			},
			{
				"x": 0.339331,
				"y": 0.820087
			},
			{
				"x": 0.347306,
				"y": 0.825587
			},
			{
				"x": 0.354896,
				"y": 0.831608
			},
			{
				"x": 0.362061,
				"y": 0.838131
			},
			{
				"x": 0.368759,
				"y": 0.845135
			},
			{
				"x": 0.374944,
				"y": 0.852597
			},
			{
				"x": 0.38057,
				"y": 0.860491
			},
			{
				"x": 0.385585,
				"y": 0.868787
			},
			{
				"x": 0.389939,
				"y": 0.877451
			},
			{
				"x": 0.393576,
				"y": 0.886439
			},
			{
				"x": 0.396443,
				"y": 0.895703
			},
			{
				"x": 0.398484,
				"y": 0.905184
			},
			{
				"x": 0.397358,
				"y": 0.909516
			},
			{
				"x": 0.39074,
				"y": 0.902434
			},
			{
				"x": 0.383884,
				"y": 0.895584
			},
			{
				"x": 0.376801,
				"y": 0.888969
			},
			{
				"x": 0.369504,
				"y": 0.882592
			},
			{
				"x": 0.362002,
				"y": 0.876459
			},
			{
				"x": 0.354305,
				"y": 0.870572
			},
			{
				"x": 0.346424,
				"y": 0.864936
			},
			{
				"x": 0.338367,
				"y": 0.859556
			},
			{
				"x": 0.330143,
				"y": 0.854435
			},
			{
				"x": 0.321761,
				"y": 0.849579
			},
			{
				"x": 0.313229,
				"y": 0.844992
			},
			{
				"x": 0.304555,
				"y": 0.84068
			},
			{
				"x": 0.295748,
				"y": 0.836648
			},
			{
				"x": 0.286817,
				"y": 0.832902
			},
			{
				"x": 0.277768,
				"y": 0.829449
			},
			{
				"x": 0.268612,
				"y": 0.826295
			},
			{
				"x": 0.259356,
				"y": 0.823448
			},
			{
				"x": 0.250009,
				"y": 0.820915
			},
			{
				"x": 0.240581,
				"y": 0.818706
			},
			{
				"x": 0.231082,
				"y": 0.816828
			},
			{
				"x": 0.221521,
				"y": 0.815291
			},
			{
				"x": 0.211912,
				"y": 0.814105
			}
		],
		"le": [
			{
				"x": 0.742417,
				"y": 0.543066
			},
			{
				"x": 0.733497,
				"y": 0.533724
			},
			{
				"x": 0.719736,
				"y": 0.532552
			},
			{
				"x": 0.706177,
				"y": 0.53539
			},
			{
				"x": 0.69355,
				"y": 0.54114
			},
			{
				"x": 0.681831,
				"y": 0.548595
			},
			{
				"x": 0.670695,
				"y": 0.556908
			},
			{
				"x": 0.65983,
				"y": 0.565575
			},
			{
				"x": 0.648979,
				"y": 0.57426
			},
			{
				"x": 0.63794,
				"y": 0.582703
			},
			{
				"x": 0.626692,
				"y": 0.590865
			},
			{
				"x": 0.615372,
				"y": 0.598926
			},
			{
				"x": 0.604137,
				"y": 0.607106
			},
			{
				"x": 0.593264,
				"y": 0.615759
			},
			{
				"x": 0.583686,
				"y": 0.625788
			},
			{
				"x": 0.581571,
				"y": 0.638896
			},
			{
				"x": 0.590403,
				"y": 0.649477
			},
			{
				"x": 0.601399,
				"y": 0.657972
			},
			{
				"x": 0.612668,
				"y": 0.666105
			},
			{
				"x": 0.624097,
				"y": 0.67401
			},
			{
				"x": 0.635698,
				"y": 0.68166
			},
			{
				"x": 0.647473,
				"y": 0.689038
			},
			{
				"x": 0.65942,
				"y": 0.696132
			},
			{
				"x": 0.671537,
				"y": 0.70293
			},
			{
				"x": 0.68383,
				"y": 0.709406
			},
			{
				"x": 0.696321,
				"y": 0.715487
			},
			{
				"x": 0.70906,
				"y": 0.721023
			},
			{
				"x": 0.722142,
				"y": 0.725682
			},
			{
				"x": 0.735726,
				"y": 0.728435
			},
			{
				"x": 0.748157,
				"y": 0.723965
			},
			{
				"x": 0.746338,
				"y": 0.710798
			},
			{
				"x": 0.737537,
				"y": 0.700091
			},
			{
				"x": 0.726788,
				"y": 0.691296
			},
			{
				"x": 0.71525,
				"y": 0.683555
			},
			{
				"x": 0.703358,
				"y": 0.676371
			},
			{
				"x": 0.691282,
				"y": 0.669498
			},
			{
				"x": 0.67912,
				"y": 0.662779
			},
			{
				"x": 0.666956,
				"y": 0.656063
			},
			{
				"x": 0.654915,
				"y": 0.649132
			},
			{
				"x": 0.643401,
				"y": 0.64137
			},
			{
				"x": 0.636968,
				"y": 0.629864
			},
			{
				"x": 0.645452,
				"y": 0.619139
			},
			{
				"x": 0.656667,
				"y": 0.610939
			},
			{
				"x": 0.668288,
				"y": 0.60332
			},
			{
				"x": 0.680005,
				"y": 0.59585
			},
			{
				"x": 0.691711,
				"y": 0.588363
			},
			{
				"x": 0.703332,
				"y": 0.580743
			},
			{
				"x": 0.714775,
				"y": 0.572858
			},
			{
				"x": 0.72587,
				"y": 0.564492
			},
			{
				"x": 0.736135,
				"y": 0.555137
			}
		],
		"re": [
			{
				"x": 0.250774,
				"y": 0.548895
			},
			{
				"x": 0.259885,
				"y": 0.540296
			},
			{
				"x": 0.273621,
				"y": 0.541787
			},
			{
				"x": 0.286842,
				"y": 0.546023
			},
			{
				"x": 0.299677,
				"y": 0.551333
			},
			{
				"x": 0.31224,
				"y": 0.557263
			},
			{
				"x": 0.324591,
				"y": 0.563624
			},
			{
				"x": 0.336763,
				"y": 0.570325
			},
			{
				"x": 0.348764,
				"y": 0.577327
			},
			{
				"x": 0.360594,
				"y": 0.584616
			},
			{
				"x": 0.37225,
				"y": 0.592181
			},
			{
				"x": 0.383733,
				"y": 0.600007
			},
			{
				"x": 0.39505,
				"y": 0.608073
			},
			{
				"x": 0.406189,
				"y": 0.616383
			},
			{
				"x": 0.416221,
				"y": 0.625949
			},
			{
				"x": 0.418425,
				"y": 0.639
			},
			{
				"x": 0.410002,
				"y": 0.649935
			},
			{
				"x": 0.399364,
				"y": 0.658872
			},
			{
				"x": 0.388203,
				"y": 0.667151
			},
			{
				"x": 0.37689,
				"y": 0.675223
			},
			{
				"x": 0.365604,
				"y": 0.683333
			},
			{
				"x": 0.354488,
				"y": 0.691673
			},
			{
				"x": 0.343596,
				"y": 0.700306
			},
			{
				"x": 0.33276,
				"y": 0.70901
			},
			{
				"x": 0.321741,
				"y": 0.717478
			},
			{
				"x": 0.310243,
				"y": 0.725276
			},
			{
				"x": 0.297932,
				"y": 0.731688
			},
			{
				"x": 0.284627,
				"y": 0.73556
			},
			{
				"x": 0.270794,
				"y": 0.735856
			},
			{
				"x": 0.258766,
				"y": 0.729757
			},
			{
				"x": 0.261055,
				"y": 0.716888
			},
			{
				"x": 0.270747,
				"y": 0.706962
			},
			{
				"x": 0.281664,
				"y": 0.698364
			},
			{
				"x": 0.293021,
				"y": 0.690357
			},
			{
				"x": 0.304597,
				"y": 0.68267
			},
			{
				"x": 0.316285,
				"y": 0.675154
			},
			{
				"x": 0.328008,
				"y": 0.667692
			},
			{
				"x": 0.339676,
				"y": 0.660146
			},
			{
				"x": 0.351086,
				"y": 0.652217
			},
			{
				"x": 0.361187,
				"y": 0.642744
			},
			{
				"x": 0.35984,
				"y": 0.630242
			},
			{
				"x": 0.348829,
				"y": 0.621819
			},
			{
				"x": 0.336877,
				"y": 0.614733
			},
			{
				"x": 0.324734,
				"y": 0.60798
			},
			{
				"x": 0.312563,
				"y": 0.601279
			},
			{
				"x": 0.30045,
				"y": 0.594471
			},
			{
				"x": 0.288486,
				"y": 0.587406
			},
			{
				"x": 0.276808,
				"y": 0.579877
			},
			{
				"x": 0.265728,
				"y": 0.571498
			},
			{
				"x": 0.256107,
				"y": 0.561501
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.217437,
				"y": 0.209984
			},
			{
				"x": 0.24475,
				"y": 0.219461
			},
			{
				"x": 0.27269,
				"y": 0.226911
			},
			{
				"x": 0.300941,
				"y": 0.233078
			},
			{
				"x": 0.329388,
				"y": 0.238273
			},
			{
				"x": 0.357971,
				"y": 0.242648
			},
			{
				"x": 0.386658,
				"y": 0.24628
			},
			{
				"x": 0.415427,
				"y": 0.249195
			},
			{
				"x": 0.44426,
				"y": 0.251375
			},
			{
				"x": 0.473142,
				"y": 0.252758
			},
			{
				"x": 0.502053,
				"y": 0.253211
			},
			{
				"x": 0.530961,
				"y": 0.252614
			},
			{
				"x": 0.559838,
				"y": 0.251112
			},
			{
				"x": 0.588663,
				"y": 0.248825
			},
			{
				"x": 0.617421,
				"y": 0.245808
			},
			{
				"x": 0.646095,
				"y": 0.242073
			},
			{
				"x": 0.674661,
				"y": 0.237587
			},
			{
				"x": 0.703084,
				"y": 0.232267
			},
			{
				"x": 0.731301,
				"y": 0.225942
			},
			{
				"x": 0.759179,
				"y": 0.218266
			},
			{
				"x": 0.782531,
				"y": 0.214098
			},
			{
				"x": 0.780488,
				"y": 0.242984
			},
			{
				"x": 0.775292,
				"y": 0.271471
			},
			{
				"x": 0.767018,
				"y": 0.299218
			},
			{
				"x": 0.755785,
				"y": 0.3259
			},
			{
				"x": 0.741748,
				"y": 0.351214
			},
			{
				"x": 0.725095,
				"y": 0.374884
			},
			{
				"x": 0.706043,
				"y": 0.396661
			},
			{
				"x": 0.684827,
				"y": 0.416328
			},
			{
				"x": 0.661699,
				"y": 0.433697
			},
			{
				"x": 0.636924,
				"y": 0.448612
			},
			{
				"x": 0.610771,
				"y": 0.460945
			},
			{
				"x": 0.583518,
				"y": 0.470592
			},
			{
				"x": 0.555443,
				"y": 0.477478
			},
			{
				"x": 0.526825,
				"y": 0.481548
			},
			{
				"x": 0.497947,
				"y": 0.482773
			},
			{
				"x": 0.469089,
				"y": 0.481143
			},
			{
				"x": 0.440531,
				"y": 0.47667
			},
			{
				"x": 0.412555,
				"y": 0.469389
			},
			{
				"x": 0.385442,
				"y": 0.459355
			},
			{
				"x": 0.359468,
				"y": 0.446649
			},
			{
				"x": 0.33491,
				"y": 0.431377
			},
			{
				"x": 0.312038,
				"y": 0.413671
			},
			{
				"x": 0.291114,
				"y": 0.393692
			},
			{
				"x": 0.272388,
				"y": 0.371633
			},
			{
				"x": 0.256095,
				"y": 0.347714
			},
			{
				"x": 0.242445,
				"y": 0.322187
			},
			{
				"x": 0.231623,
				"y": 0.295335
			},
			{
				"x": 0.223781,
				"y": 0.267463
			},
			{
				"x": 0.219029,
				"y": 0.238898
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"weary": {
		"lb": [
			{
				"x": 0.788689,
				"y": 0.742911
			},
			{
				"x": 0.777843,
				"y": 0.747113
			},
			{
				"x": 0.767161,
				"y": 0.751718
			},
			{
				"x": 0.756654,
				"y": 0.756712
			},
			{
				"x": 0.746331,
				"y": 0.762079
			},
			{
				"x": 0.736203,
				"y": 0.767804
			},
			{
				"x": 0.726276,
				"y": 0.773874
			},
			{
				"x": 0.716559,
				"y": 0.780276
			},
			{
				"x": 0.707061,
				"y": 0.786998
			},
			{
				"x": 0.697787,
				"y": 0.794029
			},
			{
				"x": 0.688746,
				"y": 0.801358
			},
			{
				"x": 0.679945,
				"y": 0.808975
			},
			{
				"x": 0.671392,
				"y": 0.81687
			},
			{
				"x": 0.663095,
				"y": 0.825033
			},
			{
				"x": 0.65506,
				"y": 0.833457
			},
			{
				"x": 0.647296,
				"y": 0.842133
			},
			{
				"x": 0.639812,
				"y": 0.851052
			},
			{
				"x": 0.632617,
				"y": 0.860205
			},
			{
				"x": 0.625718,
				"y": 0.869586
			},
			{
				"x": 0.619127,
				"y": 0.879186
			},
			{
				"x": 0.612854,
				"y": 0.888997
			},
			{
				"x": 0.606908,
				"y": 0.899012
			},
			{
				"x": 0.601302,
				"y": 0.90922
			},
			{
				"x": 0.596049,
				"y": 0.919616
			},
			{
				"x": 0.593295,
				"y": 0.915003
			},
			{
				"x": 0.592467,
				"y": 0.903384
			},
			{
				"x": 0.592662,
				"y": 0.891736
			},
			{
				"x": 0.593839,
				"y": 0.880147
			},
			{
				"x": 0.595951,
				"y": 0.868691
			},
			{
				"x": 0.598949,
				"y": 0.857435
			},
			{
				"x": 0.602785,
				"y": 0.846438
			},
			{
				"x": 0.607412,
				"y": 0.835749
			},
			{
				"x": 0.612784,
				"y": 0.825417
			},
			{
				"x": 0.618856,
				"y": 0.815481
			},
			{
				"x": 0.625587,
				"y": 0.805981
			},
			{
				"x": 0.632936,
				"y": 0.796953
			},
			{
				"x": 0.640865,
				"y": 0.788431
			},
			{
				"x": 0.649335,
				"y": 0.78045
			},
			{
				"x": 0.658311,
				"y": 0.773043
			},
			{
				"x": 0.667755,
				"y": 0.766246
			},
			{
				"x": 0.677629,
				"y": 0.760095
			},
			{
				"x": 0.687896,
				"y": 0.754625
			},
			{
				"x": 0.698514,
				"y": 0.749877
			},
			{
				"x": 0.709439,
				"y": 0.74589
			},
			{
				"x": 0.720624,
				"y": 0.742707
			},
			{
				"x": 0.732014,
				"y": 0.74037
			},
			{
				"x": 0.743551,
				"y": 0.738924
			},
			{
				"x": 0.755166,
				"y": 0.738411
			},
			{
				"x": 0.766783,
				"y": 0.738874
			},
			{
				"x": 0.778315,
				"y": 0.74035
			}
		],
		"rb": [
			{
				"x": 0.211311,
				"y": 0.742911
			},
			{
				"x": 0.222157,
				"y": 0.747113
			},
			{
				"x": 0.232839,
				"y": 0.751718
			},
			{
				"x": 0.243346,
				"y": 0.756712
			},
			{
				"x": 0.253669,
				"y": 0.762079
			},
			{
				"x": 0.263797,
				"y": 0.767804
			},
			{
				"x": 0.273724,
				"y": 0.773874
			},
			{
				"x": 0.283441,
				"y": 0.780276
			},
			{
				"x": 0.292939,
				"y": 0.786998
			},
			{
				"x": 0.302213,
				"y": 0.794029
			},
			{
				"x": 0.311254,
				"y": 0.801358
			},
			{
				"x": 0.320055,
				"y": 0.808975
			},
			{
				"x": 0.328608,
				"y": 0.81687
			},
			{
				"x": 0.336905,
				"y": 0.825033
			},
			{
				"x": 0.34494,
				"y": 0.833457
			},
			{
				"x": 0.352704,
				"y": 0.842133
			},
			{
				"x": 0.360188,
				"y": 0.851052
			},
			{
				"x": 0.367383,
				"y": 0.860205
			},
			{
				"x": 0.374282,
				"y": 0.869586
			},
			{
				"x": 0.380873,
				"y": 0.879186
			},
			{
				"x": 0.387146,
				"y": 0.888997
			},
			{
				"x": 0.393092,
				"y": 0.899012
			},
			{
				"x": 0.398698,
				"y": 0.90922
			},
			{
				"x": 0.403951,
				"y": 0.919616
			},
			{
				"x": 0.406705,
				"y": 0.915003
			},
			{
				"x": 0.407533,
				"y": 0.903384
			},
			{
				"x": 0.407338,
				"y": 0.891736
			},
			{
				"x": 0.406161,
				"y": 0.880147
			},
			{
				"x": 0.404049,
				"y": 0.868691
			},
			{
				"x": 0.401051,
				"y": 0.857435
			},
			{
				"x": 0.397215,
				"y": 0.846438
			},
			{
				"x": 0.392588,
				"y": 0.835749
			},
			{
				"x": 0.387216,
				"y": 0.825417
			},
			{
				"x": 0.381144,
				"y": 0.815481
			},
			{
				"x": 0.374413,
				"y": 0.805981
			},
			{
				"x": 0.367064,
				"y": 0.796953
			},
			{
				"x": 0.359135,
				"y": 0.788431
			},
			{
				"x": 0.350665,
				"y": 0.78045
			},
			{
				"x": 0.341689,
				"y": 0.773043
			},
			{
				"x": 0.332245,
				"y": 0.766246
			},
			{
				"x": 0.322371,
				"y": 0.760095
			},
			{
				"x": 0.312104,
				"y": 0.754625
			},
			{
				"x": 0.301486,
				"y": 0.749877
			},
			{
				"x": 0.290561,
				"y": 0.74589
			},
			{
				"x": 0.279376,
				"y": 0.742707
			},
			{
				"x": 0.267986,
				"y": 0.74037
			},
			{
				"x": 0.256449,
				"y": 0.738924
			},
			{
				"x": 0.244834,
				"y": 0.738411
			},
			{
				"x": 0.233217,
				"y": 0.738874
			},
			{
				"x": 0.221685,
				"y": 0.74035
			}
		],
		"le": [
			{
				"x": 0.801975,
				"y": 0.622889
			},
			{
				"x": 0.795827,
				"y": 0.612045
			},
			{
				"x": 0.78769,
				"y": 0.602604
			},
			{
				"x": 0.777996,
				"y": 0.594771
			},
			{
				"x": 0.767183,
				"y": 0.588577
			},
			{
				"x": 0.755614,
				"y": 0.583941
			},
			{
				"x": 0.743569,
				"y": 0.580739
			},
			{
				"x": 0.731252,
				"y": 0.578837
			},
			{
				"x": 0.718809,
				"y": 0.578112
			},
			{
				"x": 0.70635,
				"y": 0.578458
			},
			{
				"x": 0.693956,
				"y": 0.579788
			},
			{
				"x": 0.681693,
				"y": 0.582028
			},
			{
				"x": 0.669616,
				"y": 0.585124
			},
			{
				"x": 0.657775,
				"y": 0.589029
			},
			{
				"x": 0.646218,
				"y": 0.593709
			},
			{
				"x": 0.634991,
				"y": 0.599138
			},
			{
				"x": 0.624147,
				"y": 0.605299
			},
			{
				"x": 0.613744,
				"y": 0.612179
			},
			{
				"x": 0.603848,
				"y": 0.619774
			},
			{
				"x": 0.594538,
				"y": 0.628079
			},
			{
				"x": 0.585914,
				"y": 0.637096
			},
			{
				"x": 0.578096,
				"y": 0.646822
			},
			{
				"x": 0.571236,
				"y": 0.657248
			},
			{
				"x": 0.565527,
				"y": 0.668346
			},
			{
				"x": 0.561205,
				"y": 0.680054
			},
			{
				"x": 0.558552,
				"y": 0.692249
			},
			{
				"x": 0.557874,
				"y": 0.704708
			},
			{
				"x": 0.559439,
				"y": 0.717083
			},
			{
				"x": 0.563313,
				"y": 0.728041
			},
			{
				"x": 0.568858,
				"y": 0.716909
			},
			{
				"x": 0.576627,
				"y": 0.707151
			},
			{
				"x": 0.585416,
				"y": 0.698296
			},
			{
				"x": 0.594824,
				"y": 0.690101
			},
			{
				"x": 0.604667,
				"y": 0.682435
			},
			{
				"x": 0.614847,
				"y": 0.675224
			},
			{
				"x": 0.625304,
				"y": 0.668423
			},
			{
				"x": 0.636003,
				"y": 0.662009
			},
			{
				"x": 0.646918,
				"y": 0.655973
			},
			{
				"x": 0.658036,
				"y": 0.650321
			},
			{
				"x": 0.669349,
				"y": 0.645072
			},
			{
				"x": 0.68085,
				"y": 0.64025
			},
			{
				"x": 0.692516,
				"y": 0.635844
			},
			{
				"x": 0.704328,
				"y": 0.631846
			},
			{
				"x": 0.716272,
				"y": 0.628265
			},
			{
				"x": 0.728339,
				"y": 0.625124
			},
			{
				"x": 0.74052,
				"y": 0.622467
			},
			{
				"x": 0.75281,
				"y": 0.620369
			},
			{
				"x": 0.765196,
				"y": 0.618956
			},
			{
				"x": 0.77765,
				"y": 0.618458
			},
			{
				"x": 0.790075,
				"y": 0.619349
			}
		],
		"re": [
			{
				"x": 0.198025,
				"y": 0.622889
			},
			{
				"x": 0.204173,
				"y": 0.612045
			},
			{
				"x": 0.21231,
				"y": 0.602604
			},
			{
				"x": 0.222004,
				"y": 0.594771
			},
			{
				"x": 0.232817,
				"y": 0.588577
			},
			{
				"x": 0.244386,
				"y": 0.583941
			},
			{
				"x": 0.256431,
				"y": 0.580739
			},
			{
				"x": 0.268748,
				"y": 0.578837
			},
			{
				"x": 0.281191,
				"y": 0.578112
			},
			{
				"x": 0.29365,
				"y": 0.578458
			},
			{
				"x": 0.306044,
				"y": 0.579788
			},
			{
				"x": 0.318307,
				"y": 0.582028
			},
			{
				"x": 0.330384,
				"y": 0.585124
			},
			{
				"x": 0.342225,
				"y": 0.589029
			},
			{
				"x": 0.353782,
				"y": 0.593709
			},
			{
				"x": 0.365009,
				"y": 0.599138
			},
			{
				"x": 0.375853,
				"y": 0.605299
			},
			{
				"x": 0.386256,
				"y": 0.612179
			},
			{
				"x": 0.396152,
				"y": 0.619774
			},
			{
				"x": 0.405462,
				"y": 0.628079
			},
			{
				"x": 0.414086,
				"y": 0.637096
			},
			{
				"x": 0.421904,
				"y": 0.646822
			},
			{
				"x": 0.428764,
				"y": 0.657248
			},
			{
				"x": 0.434473,
				"y": 0.668346
			},
			{
				"x": 0.438795,
				"y": 0.680054
			},
			{
				"x": 0.441448,
				"y": 0.692249
			},
			{
				"x": 0.442126,
				"y": 0.704708
			},
			{
				"x": 0.440561,
				"y": 0.717083
			},
			{
				"x": 0.436687,
				"y": 0.728041
			},
			{
				"x": 0.431142,
				"y": 0.716909
			},
			{
				"x": 0.423373,
				"y": 0.707151
			},
			{
				"x": 0.414584,
				"y": 0.698296
			},
			{
				"x": 0.405176,
				"y": 0.690101
			},
			{
				"x": 0.395333,
				"y": 0.682435
			},
			{
				"x": 0.385153,
				"y": 0.675224
			},
			{
				"x": 0.374696,
				"y": 0.668423
			},
			{
				"x": 0.363997,
				"y": 0.662009
			},
			{
				"x": 0.353082,
				"y": 0.655973
			},
			{
				"x": 0.341964,
				"y": 0.650321
			},
			{
				"x": 0.330651,
				"y": 0.645072
			},
			{
				"x": 0.31915,
				"y": 0.64025
			},
			{
				"x": 0.307484,
				"y": 0.635844
			},
			{
				"x": 0.295672,
				"y": 0.631846
			},
			{
				"x": 0.283728,
				"y": 0.628265
			},
			{
				"x": 0.271661,
				"y": 0.625124
			},
			{
				"x": 0.25948,
				"y": 0.622467
			},
			{
				"x": 0.24719,
				"y": 0.620369
			},
			{
				"x": 0.234804,
				"y": 0.618956
			},
			{
				"x": 0.22235,
				"y": 0.618458
			},
			{
				"x": 0.209925,
				"y": 0.619349
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.217437,
				"y": 0.209984
			},
			{
				"x": 0.24475,
				"y": 0.219461
			},
			{
				"x": 0.27269,
				"y": 0.226911
			},
			{
				"x": 0.300941,
				"y": 0.233078
			},
			{
				"x": 0.329388,
				"y": 0.238273
			},
			{
				"x": 0.357971,
				"y": 0.242648
			},
			{
				"x": 0.386658,
				"y": 0.24628
			},
			{
				"x": 0.415427,
				"y": 0.249195
			},
			{
				"x": 0.44426,
				"y": 0.251375
			},
			{
				"x": 0.473142,
				"y": 0.252758
			},
			{
				"x": 0.502053,
				"y": 0.253211
			},
			{
				"x": 0.530961,
				"y": 0.252614
			},
			{
				"x": 0.559838,
				"y": 0.251112
			},
			{
				"x": 0.588663,
				"y": 0.248825
			},
			{
				"x": 0.617421,
				"y": 0.245808
			},
			{
				"x": 0.646095,
				"y": 0.242073
			},
			{
				"x": 0.674661,
				"y": 0.237587
			},
			{
				"x": 0.703084,
				"y": 0.232267
			},
			{
				"x": 0.731301,
				"y": 0.225942
			},
			{
				"x": 0.759179,
				"y": 0.218266
			},
			{
				"x": 0.782531,
				"y": 0.214098
			},
			{
				"x": 0.780488,
				"y": 0.242984
			},
			{
				"x": 0.775292,
				"y": 0.271471
			},
			{
				"x": 0.767018,
				"y": 0.299218
			},
			{
				"x": 0.755785,
				"y": 0.3259
			},
			{
				"x": 0.741748,
				"y": 0.351214
			},
			{
				"x": 0.725095,
				"y": 0.374884
			},
			{
				"x": 0.706043,
				"y": 0.396661
			},
			{
				"x": 0.684827,
				"y": 0.416328
			},
			{
				"x": 0.661699,
				"y": 0.433697
			},
			{
				"x": 0.636924,
				"y": 0.448612
			},
			{
				"x": 0.610771,
				"y": 0.460945
			},
			{
				"x": 0.583518,
				"y": 0.470592
			},
			{
				"x": 0.555443,
				"y": 0.477478
			},
			{
				"x": 0.526825,
				"y": 0.481548
			},
			{
				"x": 0.497947,
				"y": 0.482773
			},
			{
				"x": 0.469089,
				"y": 0.481143
			},
			{
				"x": 0.440531,
				"y": 0.47667
			},
			{
				"x": 0.412555,
				"y": 0.469389
			},
			{
				"x": 0.385442,
				"y": 0.459355
			},
			{
				"x": 0.359468,
				"y": 0.446649
			},
			{
				"x": 0.33491,
				"y": 0.431377
			},
			{
				"x": 0.312038,
				"y": 0.413671
			},
			{
				"x": 0.291114,
				"y": 0.393692
			},
			{
				"x": 0.272388,
				"y": 0.371633
			},
			{
				"x": 0.256095,
				"y": 0.347714
			},
			{
				"x": 0.242445,
				"y": 0.322187
			},
			{
				"x": 0.231623,
				"y": 0.295335
			},
			{
				"x": 0.223781,
				"y": 0.267463
			},
			{
				"x": 0.219029,
				"y": 0.238898
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"open_mouth": {
		"lb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"rb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"le": [
			{
				"x": 0.708191,
				"y": 0.6214
			},
			{
				"x": 0.707865,
				"y": 0.614079
			},
			{
				"x": 0.706885,
				"y": 0.606817
			},
			{
				"x": 0.705245,
				"y": 0.599675
			},
			{
				"x": 0.702935,
				"y": 0.592722
			},
			{
				"x": 0.699944,
				"y": 0.586036
			},
			{
				"x": 0.696261,
				"y": 0.579706
			},
			{
				"x": 0.691878,
				"y": 0.573841
			},
			{
				"x": 0.6868,
				"y": 0.568571
			},
			{
				"x": 0.681053,
				"y": 0.564045
			},
			{
				"x": 0.674695,
				"y": 0.560432
			},
			{
				"x": 0.667839,
				"y": 0.557899
			},
			{
				"x": 0.66065,
				"y": 0.556591
			},
			{
				"x": 0.653343,
				"y": 0.556591
			},
			{
				"x": 0.646154,
				"y": 0.557899
			},
			{
				"x": 0.639298,
				"y": 0.560432
			},
			{
				"x": 0.632941,
				"y": 0.564045
			},
			{
				"x": 0.627193,
				"y": 0.568571
			},
			{
				"x": 0.622115,
				"y": 0.573841
			},
			{
				"x": 0.617732,
				"y": 0.579706
			},
			{
				"x": 0.614049,
				"y": 0.586036
			},
			{
				"x": 0.611058,
				"y": 0.592722
			},
			{
				"x": 0.608748,
				"y": 0.599675
			},
			{
				"x": 0.607108,
				"y": 0.606817
			},
			{
				"x": 0.606128,
				"y": 0.614079
			},
			{
				"x": 0.605802,
				"y": 0.6214
			},
			{
				"x": 0.606128,
				"y": 0.628721
			},
			{
				"x": 0.607108,
				"y": 0.635983
			},
			{
				"x": 0.608748,
				"y": 0.643125
			},
			{
				"x": 0.611058,
				"y": 0.650077
			},
			{
				"x": 0.614049,
				"y": 0.656764
			},
			{
				"x": 0.617732,
				"y": 0.663094
			},
			{
				"x": 0.622115,
				"y": 0.668959
			},
			{
				"x": 0.627193,
				"y": 0.674229
			},
			{
				"x": 0.632941,
				"y": 0.678755
			},
			{
				"x": 0.639298,
				"y": 0.682368
			},
			{
				"x": 0.646154,
				"y": 0.684901
			},
			{
				"x": 0.653343,
				"y": 0.686209
			},
			{
				"x": 0.66065,
				"y": 0.686209
			},
			{
				"x": 0.667839,
				"y": 0.684901
			},
			{
				"x": 0.674695,
				"y": 0.682368
			},
			{
				"x": 0.681053,
				"y": 0.678755
			},
			{
				"x": 0.6868,
				"y": 0.674229
			},
			{
				"x": 0.691878,
				"y": 0.668959
			},
			{
				"x": 0.696261,
				"y": 0.663094
			},
			{
				"x": 0.699944,
				"y": 0.656764
			},
			{
				"x": 0.702935,
				"y": 0.650077
			},
			{
				"x": 0.705245,
				"y": 0.643125
			},
			{
				"x": 0.706885,
				"y": 0.635983
			},
			{
				"x": 0.707865,
				"y": 0.628721
			}
		],
		"re": [
			{
				"x": 0.291809,
				"y": 0.6214
			},
			{
				"x": 0.292135,
				"y": 0.614079
			},
			{
				"x": 0.293115,
				"y": 0.606817
			},
			{
				"x": 0.294755,
				"y": 0.599675
			},
			{
				"x": 0.297065,
				"y": 0.592722
			},
			{
				"x": 0.300056,
				"y": 0.586036
			},
			{
				"x": 0.303739,
				"y": 0.579706
			},
			{
				"x": 0.308122,
				"y": 0.573841
			},
			{
				"x": 0.3132,
				"y": 0.568571
			},
			{
				"x": 0.318947,
				"y": 0.564045
			},
			{
				"x": 0.325305,
				"y": 0.560432
			},
			{
				"x": 0.332161,
				"y": 0.557899
			},
			{
				"x": 0.33935,
				"y": 0.556591
			},
			{
				"x": 0.346657,
				"y": 0.556591
			},
			{
				"x": 0.353846,
				"y": 0.557899
			},
			{
				"x": 0.360702,
				"y": 0.560432
			},
			{
				"x": 0.367059,
				"y": 0.564045
			},
			{
				"x": 0.372807,
				"y": 0.568571
			},
			{
				"x": 0.377885,
				"y": 0.573841
			},
			{
				"x": 0.382268,
				"y": 0.579706
			},
			{
				"x": 0.385951,
				"y": 0.586036
			},
			{
				"x": 0.388942,
				"y": 0.592722
			},
			{
				"x": 0.391252,
				"y": 0.599675
			},
			{
				"x": 0.392892,
				"y": 0.606817
			},
			{
				"x": 0.393872,
				"y": 0.614079
			},
			{
				"x": 0.394198,
				"y": 0.6214
			},
			{
				"x": 0.393872,
				"y": 0.628721
			},
			{
				"x": 0.392892,
				"y": 0.635983
			},
			{
				"x": 0.391252,
				"y": 0.643125
			},
			{
				"x": 0.388942,
				"y": 0.650077
			},
			{
				"x": 0.385951,
				"y": 0.656764
			},
			{
				"x": 0.382268,
				"y": 0.663094
			},
			{
				"x": 0.377885,
				"y": 0.668959
			},
			{
				"x": 0.372807,
				"y": 0.674229
			},
			{
				"x": 0.367059,
				"y": 0.678755
			},
			{
				"x": 0.360702,
				"y": 0.682368
			},
			{
				"x": 0.353846,
				"y": 0.684901
			},
			{
				"x": 0.346657,
				"y": 0.686209
			},
			{
				"x": 0.33935,
				"y": 0.686209
			},
			{
				"x": 0.332161,
				"y": 0.684901
			},
			{
				"x": 0.325305,
				"y": 0.682368
			},
			{
				"x": 0.318947,
				"y": 0.678755
			},
			{
				"x": 0.3132,
				"y": 0.674229
			},
			{
				"x": 0.308122,
				"y": 0.668959
			},
			{
				"x": 0.303739,
				"y": 0.663094
			},
			{
				"x": 0.300056,
				"y": 0.656764
			},
			{
				"x": 0.297065,
				"y": 0.650077
			},
			{
				"x": 0.294755,
				"y": 0.643125
			},
			{
				"x": 0.293115,
				"y": 0.635983
			},
			{
				"x": 0.292135,
				"y": 0.628721
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.393082,
				"y": 0.300992
			},
			{
				"x": 0.393955,
				"y": 0.287796
			},
			{
				"x": 0.396555,
				"y": 0.27483
			},
			{
				"x": 0.400828,
				"y": 0.262317
			},
			{
				"x": 0.40669,
				"y": 0.250467
			},
			{
				"x": 0.414024,
				"y": 0.239472
			},
			{
				"x": 0.422695,
				"y": 0.229499
			},
			{
				"x": 0.432546,
				"y": 0.220697
			},
			{
				"x": 0.443411,
				"y": 0.213185
			},
			{
				"x": 0.455113,
				"y": 0.207064
			},
			{
				"x": 0.467468,
				"y": 0.202408
			},
			{
				"x": 0.480293,
				"y": 0.199275
			},
			{
				"x": 0.4934,
				"y": 0.197699
			},
			{
				"x": 0.5066,
				"y": 0.197699
			},
			{
				"x": 0.519707,
				"y": 0.199275
			},
			{
				"x": 0.532532,
				"y": 0.202408
			},
			{
				"x": 0.544887,
				"y": 0.207064
			},
			{
				"x": 0.556589,
				"y": 0.213185
			},
			{
				"x": 0.567454,
				"y": 0.220697
			},
			{
				"x": 0.577305,
				"y": 0.229499
			},
			{
				"x": 0.585976,
				"y": 0.239472
			},
			{
				"x": 0.59331,
				"y": 0.250467
			},
			{
				"x": 0.599172,
				"y": 0.262317
			},
			{
				"x": 0.603445,
				"y": 0.27483
			},
			{
				"x": 0.606045,
				"y": 0.287796
			},
			{
				"x": 0.606918,
				"y": 0.300992
			},
			{
				"x": 0.606045,
				"y": 0.314188
			},
			{
				"x": 0.603445,
				"y": 0.327154
			},
			{
				"x": 0.599172,
				"y": 0.339667
			},
			{
				"x": 0.59331,
				"y": 0.351517
			},
			{
				"x": 0.585976,
				"y": 0.362512
			},
			{
				"x": 0.577305,
				"y": 0.372485
			},
			{
				"x": 0.567454,
				"y": 0.381287
			},
			{
				"x": 0.556589,
				"y": 0.388799
			},
			{
				"x": 0.544887,
				"y": 0.39492
			},
			{
				"x": 0.532532,
				"y": 0.399576
			},
			{
				"x": 0.519707,
				"y": 0.402709
			},
			{
				"x": 0.5066,
				"y": 0.404285
			},
			{
				"x": 0.4934,
				"y": 0.404285
			},
			{
				"x": 0.480293,
				"y": 0.402709
			},
			{
				"x": 0.467468,
				"y": 0.399576
			},
			{
				"x": 0.455113,
				"y": 0.39492
			},
			{
				"x": 0.443411,
				"y": 0.388799
			},
			{
				"x": 0.432546,
				"y": 0.381287
			},
			{
				"x": 0.422695,
				"y": 0.372485
			},
			{
				"x": 0.414024,
				"y": 0.362512
			},
			{
				"x": 0.40669,
				"y": 0.351517
			},
			{
				"x": 0.400828,
				"y": 0.339667
			},
			{
				"x": 0.396555,
				"y": 0.327154
			},
			{
				"x": 0.393955,
				"y": 0.314188
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"hushed": {
		"lb": [
			{
				"x": 0.841084,
				"y": 0.665623
			},
			{
				"x": 0.834425,
				"y": 0.672666
			},
			{
				"x": 0.827528,
				"y": 0.679475
			},
			{
				"x": 0.820405,
				"y": 0.686047
			},
			{
				"x": 0.813068,
				"y": 0.692377
			},
			{
				"x": 0.805527,
				"y": 0.698463
			},
			{
				"x": 0.797793,
				"y": 0.704299
			},
			{
				"x": 0.789875,
				"y": 0.709883
			},
			{
				"x": 0.781782,
				"y": 0.715209
			},
			{
				"x": 0.773524,
				"y": 0.720275
			},
			{
				"x": 0.76511,
				"y": 0.725075
			},
			{
				"x": 0.756548,
				"y": 0.729605
			},
			{
				"x": 0.747846,
				"y": 0.73386
			},
			{
				"x": 0.739013,
				"y": 0.737834
			},
			{
				"x": 0.730057,
				"y": 0.741522
			},
			{
				"x": 0.720987,
				"y": 0.744917
			},
			{
				"x": 0.711811,
				"y": 0.748013
			},
			{
				"x": 0.702537,
				"y": 0.750803
			},
			{
				"x": 0.693176,
				"y": 0.753279
			},
			{
				"x": 0.683735,
				"y": 0.755434
			},
			{
				"x": 0.674225,
				"y": 0.757259
			},
			{
				"x": 0.664657,
				"y": 0.758745
			},
			{
				"x": 0.655042,
				"y": 0.759882
			},
			{
				"x": 0.64539,
				"y": 0.760659
			},
			{
				"x": 0.647298,
				"y": 0.764004
			},
			{
				"x": 0.65599,
				"y": 0.768272
			},
			{
				"x": 0.665024,
				"y": 0.771754
			},
			{
				"x": 0.674321,
				"y": 0.774457
			},
			{
				"x": 0.683806,
				"y": 0.776392
			},
			{
				"x": 0.693414,
				"y": 0.777578
			},
			{
				"x": 0.703085,
				"y": 0.778032
			},
			{
				"x": 0.712762,
				"y": 0.777777
			},
			{
				"x": 0.722397,
				"y": 0.776834
			},
			{
				"x": 0.731944,
				"y": 0.775223
			},
			{
				"x": 0.741359,
				"y": 0.772967
			},
			{
				"x": 0.750603,
				"y": 0.770085
			},
			{
				"x": 0.759637,
				"y": 0.766597
			},
			{
				"x": 0.768422,
				"y": 0.762521
			},
			{
				"x": 0.776921,
				"y": 0.757876
			},
			{
				"x": 0.785096,
				"y": 0.752679
			},
			{
				"x": 0.792907,
				"y": 0.746948
			},
			{
				"x": 0.800315,
				"y": 0.740703
			},
			{
				"x": 0.807276,
				"y": 0.733963
			},
			{
				"x": 0.813748,
				"y": 0.726748
			},
			{
				"x": 0.819682,
				"y": 0.719084
			},
			{
				"x": 0.825029,
				"y": 0.710998
			},
			{
				"x": 0.829737,
				"y": 0.702523
			},
			{
				"x": 0.833752,
				"y": 0.693697
			},
			{
				"x": 0.837018,
				"y": 0.684567
			},
			{
				"x": 0.839479,
				"y": 0.675187
			}
		],
		"rb": [
			{
				"x": 0.158916,
				"y": 0.665623
			},
			{
				"x": 0.165575,
				"y": 0.672666
			},
			{
				"x": 0.172472,
				"y": 0.679475
			},
			{
				"x": 0.179595,
				"y": 0.686047
			},
			{
				"x": 0.186932,
				"y": 0.692377
			},
			{
				"x": 0.194473,
				"y": 0.698463
			},
			{
				"x": 0.202207,
				"y": 0.704299
			},
			{
				"x": 0.210125,
				"y": 0.709883
			},
			{
				"x": 0.218218,
				"y": 0.715209
			},
			{
				"x": 0.226476,
				"y": 0.720275
			},
			{
				"x": 0.23489,
				"y": 0.725075
			},
			{
				"x": 0.243452,
				"y": 0.729605
			},
			{
				"x": 0.252154,
				"y": 0.73386
			},
			{
				"x": 0.260987,
				"y": 0.737834
			},
			{
				"x": 0.269943,
				"y": 0.741522
			},
			{
				"x": 0.279013,
				"y": 0.744917
			},
			{
				"x": 0.288189,
				"y": 0.748013
			},
			{
				"x": 0.297463,
				"y": 0.750803
			},
			{
				"x": 0.306824,
				"y": 0.753279
			},
			{
				"x": 0.316265,
				"y": 0.755434
			},
			{
				"x": 0.325775,
				"y": 0.757259
			},
			{
				"x": 0.335343,
				"y": 0.758745
			},
			{
				"x": 0.344958,
				"y": 0.759882
			},
			{
				"x": 0.35461,
				"y": 0.760659
			},
			{
				"x": 0.352702,
				"y": 0.764004
			},
			{
				"x": 0.34401,
				"y": 0.768272
			},
			{
				"x": 0.334976,
				"y": 0.771754
			},
			{
				"x": 0.325679,
				"y": 0.774457
			},
			{
				"x": 0.316194,
				"y": 0.776392
			},
			{
				"x": 0.306586,
				"y": 0.777578
			},
			{
				"x": 0.296915,
				"y": 0.778032
			},
			{
				"x": 0.287238,
				"y": 0.777777
			},
			{
				"x": 0.277603,
				"y": 0.776834
			},
			{
				"x": 0.268056,
				"y": 0.775223
			},
			{
				"x": 0.258641,
				"y": 0.772967
			},
			{
				"x": 0.249397,
				"y": 0.770085
			},
			{
				"x": 0.240363,
				"y": 0.766597
			},
			{
				"x": 0.231578,
				"y": 0.762521
			},
			{
				"x": 0.223079,
				"y": 0.757876
			},
			{
				"x": 0.214904,
				"y": 0.752679
			},
			{
				"x": 0.207093,
				"y": 0.746948
			},
			{
				"x": 0.199685,
				"y": 0.740703
			},
			{
				"x": 0.192724,
				"y": 0.733963
			},
			{
				"x": 0.186252,
				"y": 0.726748
			},
			{
				"x": 0.180318,
				"y": 0.719084
			},
			{
				"x": 0.174971,
				"y": 0.710998
			},
			{
				"x": 0.170263,
				"y": 0.702523
			},
			{
				"x": 0.166248,
				"y": 0.693697
			},
			{
				"x": 0.162982,
				"y": 0.684567
			},
			{
				"x": 0.160521,
				"y": 0.675187
			}
		],
		"le": [
			{
				"x": 0.742431,
				"y": 0.518479
			},
			{
				"x": 0.742105,
				"y": 0.511157
			},
			{
				"x": 0.741124,
				"y": 0.503895
			},
			{
				"x": 0.739484,
				"y": 0.496754
			},
			{
				"x": 0.737174,
				"y": 0.489801
			},
			{
				"x": 0.734183,
				"y": 0.483114
			},
			{
				"x": 0.7305,
				"y": 0.476785
			},
			{
				"x": 0.726118,
				"y": 0.47092
			},
			{
				"x": 0.72104,
				"y": 0.46565
			},
			{
				"x": 0.715292,
				"y": 0.461124
			},
			{
				"x": 0.708935,
				"y": 0.45751
			},
			{
				"x": 0.702078,
				"y": 0.454978
			},
			{
				"x": 0.694889,
				"y": 0.45367
			},
			{
				"x": 0.687583,
				"y": 0.45367
			},
			{
				"x": 0.680394,
				"y": 0.454978
			},
			{
				"x": 0.673537,
				"y": 0.45751
			},
			{
				"x": 0.66718,
				"y": 0.461124
			},
			{
				"x": 0.661432,
				"y": 0.46565
			},
			{
				"x": 0.656355,
				"y": 0.47092
			},
			{
				"x": 0.651972,
				"y": 0.476785
			},
			{
				"x": 0.648289,
				"y": 0.483114
			},
			{
				"x": 0.645298,
				"y": 0.489801
			},
			{
				"x": 0.642988,
				"y": 0.496754
			},
			{
				"x": 0.641348,
				"y": 0.503895
			},
			{
				"x": 0.640368,
				"y": 0.511157
			},
			{
				"x": 0.640041,
				"y": 0.518479
			},
			{
				"x": 0.640368,
				"y": 0.5258
			},
			{
				"x": 0.641348,
				"y": 0.533062
			},
			{
				"x": 0.642988,
				"y": 0.540203
			},
			{
				"x": 0.645298,
				"y": 0.547156
			},
			{
				"x": 0.648289,
				"y": 0.553843
			},
			{
				"x": 0.651972,
				"y": 0.560172
			},
			{
				"x": 0.656355,
				"y": 0.566037
			},
			{
				"x": 0.661432,
				"y": 0.571307
			},
			{
				"x": 0.66718,
				"y": 0.575833
			},
			{
				"x": 0.673537,
				"y": 0.579447
			},
			{
				"x": 0.680394,
				"y": 0.581979
			},
			{
				"x": 0.687583,
				"y": 0.583288
			},
			{
				"x": 0.694889,
				"y": 0.583288
			},
			{
				"x": 0.702078,
				"y": 0.581979
			},
			{
				"x": 0.708935,
				"y": 0.579447
			},
			{
				"x": 0.715292,
				"y": 0.575833
			},
			{
				"x": 0.72104,
				"y": 0.571307
			},
			{
				"x": 0.726118,
				"y": 0.566037
			},
			{
				"x": 0.7305,
				"y": 0.560172
			},
			{
				"x": 0.734183,
				"y": 0.553843
			},
			{
				"x": 0.737174,
				"y": 0.547156
			},
			{
				"x": 0.739484,
				"y": 0.540203
			},
			{
				"x": 0.741124,
				"y": 0.533062
			},
			{
				"x": 0.742105,
				"y": 0.5258
			}
		],
		"re": [
			{
				"x": 0.257569,
				"y": 0.518479
			},
			{
				"x": 0.257895,
				"y": 0.511157
			},
			{
				"x": 0.258876,
				"y": 0.503895
			},
			{
				"x": 0.260516,
				"y": 0.496754
			},
			{
				"x": 0.262826,
				"y": 0.489801
			},
			{
				"x": 0.265817,
				"y": 0.483114
			},
			{
				"x": 0.2695,
				"y": 0.476785
			},
			{
				"x": 0.273882,
				"y": 0.47092
			},
			{
				"x": 0.27896,
				"y": 0.46565
			},
			{
				"x": 0.284708,
				"y": 0.461124
			},
			{
				"x": 0.291065,
				"y": 0.45751
			},
			{
				"x": 0.297922,
				"y": 0.454978
			},
			{
				"x": 0.305111,
				"y": 0.45367
			},
			{
				"x": 0.312417,
				"y": 0.45367
			},
			{
				"x": 0.319606,
				"y": 0.454978
			},
			{
				"x": 0.326463,
				"y": 0.45751
			},
			{
				"x": 0.33282,
				"y": 0.461124
			},
			{
				"x": 0.338568,
				"y": 0.46565
			},
			{
				"x": 0.343645,
				"y": 0.47092
			},
			{
				"x": 0.348028,
				"y": 0.476785
			},
			{
				"x": 0.351711,
				"y": 0.483114
			},
			{
				"x": 0.354702,
				"y": 0.489801
			},
			{
				"x": 0.357012,
				"y": 0.496754
			},
			{
				"x": 0.358652,
				"y": 0.503895
			},
			{
				"x": 0.359632,
				"y": 0.511157
			},
			{
				"x": 0.359959,
				"y": 0.518479
			},
			{
				"x": 0.359632,
				"y": 0.5258
			},
			{
				"x": 0.358652,
				"y": 0.533062
			},
			{
				"x": 0.357012,
				"y": 0.540203
			},
			{
				"x": 0.354702,
				"y": 0.547156
			},
			{
				"x": 0.351711,
				"y": 0.553843
			},
			{
				"x": 0.348028,
				"y": 0.560172
			},
			{
				"x": 0.343645,
				"y": 0.566037
			},
			{
				"x": 0.338568,
				"y": 0.571307
			},
			{
				"x": 0.33282,
				"y": 0.575833
			},
			{
				"x": 0.326463,
				"y": 0.579447
			},
			{
				"x": 0.319606,
				"y": 0.581979
			},
			{
				"x": 0.312417,
				"y": 0.583288
			},
			{
				"x": 0.305111,
				"y": 0.583288
			},
			{
				"x": 0.297922,
				"y": 0.581979
			},
			{
				"x": 0.291065,
				"y": 0.579447
			},
			{
				"x": 0.284708,
				"y": 0.575833
			},
			{
				"x": 0.27896,
				"y": 0.571307
			},
			{
				"x": 0.273882,
				"y": 0.566037
			},
			{
				"x": 0.2695,
				"y": 0.560172
			},
			{
				"x": 0.265817,
				"y": 0.553843
			},
			{
				"x": 0.262826,
				"y": 0.547156
			},
			{
				"x": 0.260516,
				"y": 0.540203
			},
			{
				"x": 0.258876,
				"y": 0.533062
			},
			{
				"x": 0.257895,
				"y": 0.5258
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.411641,
				"y": 0.255964
			},
			{
				"x": 0.412362,
				"y": 0.245058
			},
			{
				"x": 0.414511,
				"y": 0.234343
			},
			{
				"x": 0.418043,
				"y": 0.224002
			},
			{
				"x": 0.422886,
				"y": 0.214209
			},
			{
				"x": 0.428948,
				"y": 0.205122
			},
			{
				"x": 0.436113,
				"y": 0.196881
			},
			{
				"x": 0.444255,
				"y": 0.189606
			},
			{
				"x": 0.453234,
				"y": 0.183399
			},
			{
				"x": 0.462904,
				"y": 0.17834
			},
			{
				"x": 0.473115,
				"y": 0.174492
			},
			{
				"x": 0.483714,
				"y": 0.171903
			},
			{
				"x": 0.494545,
				"y": 0.1706
			},
			{
				"x": 0.505455,
				"y": 0.1706
			},
			{
				"x": 0.516286,
				"y": 0.171903
			},
			{
				"x": 0.526885,
				"y": 0.174492
			},
			{
				"x": 0.537096,
				"y": 0.17834
			},
			{
				"x": 0.546766,
				"y": 0.183399
			},
			{
				"x": 0.555745,
				"y": 0.189606
			},
			{
				"x": 0.563887,
				"y": 0.196881
			},
			{
				"x": 0.571052,
				"y": 0.205122
			},
			{
				"x": 0.577114,
				"y": 0.214209
			},
			{
				"x": 0.581957,
				"y": 0.224002
			},
			{
				"x": 0.585489,
				"y": 0.234343
			},
			{
				"x": 0.587638,
				"y": 0.245058
			},
			{
				"x": 0.588359,
				"y": 0.255964
			},
			{
				"x": 0.587638,
				"y": 0.266869
			},
			{
				"x": 0.585489,
				"y": 0.277585
			},
			{
				"x": 0.581957,
				"y": 0.287925
			},
			{
				"x": 0.577114,
				"y": 0.297718
			},
			{
				"x": 0.571052,
				"y": 0.306805
			},
			{
				"x": 0.563887,
				"y": 0.315047
			},
			{
				"x": 0.555745,
				"y": 0.322321
			},
			{
				"x": 0.546766,
				"y": 0.328529
			},
			{
				"x": 0.537096,
				"y": 0.333588
			},
			{
				"x": 0.526885,
				"y": 0.337435
			},
			{
				"x": 0.516286,
				"y": 0.340025
			},
			{
				"x": 0.505455,
				"y": 0.341327
			},
			{
				"x": 0.494545,
				"y": 0.341327
			},
			{
				"x": 0.483714,
				"y": 0.340025
			},
			{
				"x": 0.473115,
				"y": 0.337435
			},
			{
				"x": 0.462904,
				"y": 0.333588
			},
			{
				"x": 0.453234,
				"y": 0.328529
			},
			{
				"x": 0.444255,
				"y": 0.322321
			},
			{
				"x": 0.436113,
				"y": 0.315047
			},
			{
				"x": 0.428948,
				"y": 0.306805
			},
			{
				"x": 0.422886,
				"y": 0.297718
			},
			{
				"x": 0.418043,
				"y": 0.287925
			},
			{
				"x": 0.414511,
				"y": 0.277585
			},
			{
				"x": 0.412362,
				"y": 0.266869
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"frowning": {
		"lb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"rb": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		],
		"le": [
			{
				"x": 0.742431,
				"y": 0.518479
			},
			{
				"x": 0.742105,
				"y": 0.511157
			},
			{
				"x": 0.741124,
				"y": 0.503895
			},
			{
				"x": 0.739484,
				"y": 0.496754
			},
			{
				"x": 0.737174,
				"y": 0.489801
			},
			{
				"x": 0.734183,
				"y": 0.483114
			},
			{
				"x": 0.7305,
				"y": 0.476785
			},
			{
				"x": 0.726118,
				"y": 0.47092
			},
			{
				"x": 0.72104,
				"y": 0.46565
			},
			{
				"x": 0.715292,
				"y": 0.461124
			},
			{
				"x": 0.708935,
				"y": 0.45751
			},
			{
				"x": 0.702078,
				"y": 0.454978
			},
			{
				"x": 0.694889,
				"y": 0.45367
			},
			{
				"x": 0.687583,
				"y": 0.45367
			},
			{
				"x": 0.680394,
				"y": 0.454978
			},
			{
				"x": 0.673537,
				"y": 0.45751
			},
			{
				"x": 0.66718,
				"y": 0.461124
			},
			{
				"x": 0.661432,
				"y": 0.46565
			},
			{
				"x": 0.656355,
				"y": 0.47092
			},
			{
				"x": 0.651972,
				"y": 0.476785
			},
			{
				"x": 0.648289,
				"y": 0.483114
			},
			{
				"x": 0.645298,
				"y": 0.489801
			},
			{
				"x": 0.642988,
				"y": 0.496754
			},
			{
				"x": 0.641348,
				"y": 0.503895
			},
			{
				"x": 0.640368,
				"y": 0.511157
			},
			{
				"x": 0.640041,
				"y": 0.518479
			},
			{
				"x": 0.640368,
				"y": 0.5258
			},
			{
				"x": 0.641348,
				"y": 0.533062
			},
			{
				"x": 0.642988,
				"y": 0.540203
			},
			{
				"x": 0.645298,
				"y": 0.547156
			},
			{
				"x": 0.648289,
				"y": 0.553843
			},
			{
				"x": 0.651972,
				"y": 0.560172
			},
			{
				"x": 0.656355,
				"y": 0.566037
			},
			{
				"x": 0.661432,
				"y": 0.571307
			},
			{
				"x": 0.66718,
				"y": 0.575833
			},
			{
				"x": 0.673537,
				"y": 0.579447
			},
			{
				"x": 0.680394,
				"y": 0.581979
			},
			{
				"x": 0.687583,
				"y": 0.583288
			},
			{
				"x": 0.694889,
				"y": 0.583288
			},
			{
				"x": 0.702078,
				"y": 0.581979
			},
			{
				"x": 0.708935,
				"y": 0.579447
			},
			{
				"x": 0.715292,
				"y": 0.575833
			},
			{
				"x": 0.72104,
				"y": 0.571307
			},
			{
				"x": 0.726118,
				"y": 0.566037
			},
			{
				"x": 0.7305,
				"y": 0.560172
			},
			{
				"x": 0.734183,
				"y": 0.553843
			},
			{
				"x": 0.737174,
				"y": 0.547156
			},
			{
				"x": 0.739484,
				"y": 0.540203
			},
			{
				"x": 0.741124,
				"y": 0.533062
			},
			{
				"x": 0.742105,
				"y": 0.5258
			}
		],
		"re": [
			{
				"x": 0.257569,
				"y": 0.518479
			},
			{
				"x": 0.257895,
				"y": 0.511157
			},
			{
				"x": 0.258876,
				"y": 0.503895
			},
			{
				"x": 0.260516,
				"y": 0.496754
			},
			{
				"x": 0.262826,
				"y": 0.489801
			},
			{
				"x": 0.265817,
				"y": 0.483114
			},
			{
				"x": 0.2695,
				"y": 0.476785
			},
			{
				"x": 0.273882,
				"y": 0.47092
			},
			{
				"x": 0.27896,
				"y": 0.46565
			},
			{
				"x": 0.284708,
				"y": 0.461124
			},
			{
				"x": 0.291065,
				"y": 0.45751
			},
			{
				"x": 0.297922,
				"y": 0.454978
			},
			{
				"x": 0.305111,
				"y": 0.45367
			},
			{
				"x": 0.312417,
				"y": 0.45367
			},
			{
				"x": 0.319606,
				"y": 0.454978
			},
			{
				"x": 0.326463,
				"y": 0.45751
			},
			{
				"x": 0.33282,
				"y": 0.461124
			},
			{
				"x": 0.338568,
				"y": 0.46565
			},
			{
				"x": 0.343645,
				"y": 0.47092
			},
			{
				"x": 0.348028,
				"y": 0.476785
			},
			{
				"x": 0.351711,
				"y": 0.483114
			},
			{
				"x": 0.354702,
				"y": 0.489801
			},
			{
				"x": 0.357012,
				"y": 0.496754
			},
			{
				"x": 0.358652,
				"y": 0.503895
			},
			{
				"x": 0.359632,
				"y": 0.511157
			},
			{
				"x": 0.359959,
				"y": 0.518479
			},
			{
				"x": 0.359632,
				"y": 0.5258
			},
			{
				"x": 0.358652,
				"y": 0.533062
			},
			{
				"x": 0.357012,
				"y": 0.540203
			},
			{
				"x": 0.354702,
				"y": 0.547156
			},
			{
				"x": 0.351711,
				"y": 0.553843
			},
			{
				"x": 0.348028,
				"y": 0.560172
			},
			{
				"x": 0.343645,
				"y": 0.566037
			},
			{
				"x": 0.338568,
				"y": 0.571307
			},
			{
				"x": 0.33282,
				"y": 0.575833
			},
			{
				"x": 0.326463,
				"y": 0.579447
			},
			{
				"x": 0.319606,
				"y": 0.581979
			},
			{
				"x": 0.312417,
				"y": 0.583288
			},
			{
				"x": 0.305111,
				"y": 0.583288
			},
			{
				"x": 0.297922,
				"y": 0.581979
			},
			{
				"x": 0.291065,
				"y": 0.579447
			},
			{
				"x": 0.284708,
				"y": 0.575833
			},
			{
				"x": 0.27896,
				"y": 0.571307
			},
			{
				"x": 0.273882,
				"y": 0.566037
			},
			{
				"x": 0.2695,
				"y": 0.560172
			},
			{
				"x": 0.265817,
				"y": 0.553843
			},
			{
				"x": 0.262826,
				"y": 0.547156
			},
			{
				"x": 0.260516,
				"y": 0.540203
			},
			{
				"x": 0.258876,
				"y": 0.533062
			},
			{
				"x": 0.257895,
				"y": 0.5258
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.364222,
				"y": 0.266079
			},
			{
				"x": 0.356036,
				"y": 0.252957
			},
			{
				"x": 0.350177,
				"y": 0.238652
			},
			{
				"x": 0.347724,
				"y": 0.223404
			},
			{
				"x": 0.349488,
				"y": 0.208071
			},
			{
				"x": 0.355779,
				"y": 0.194
			},
			{
				"x": 0.366523,
				"y": 0.182993
			},
			{
				"x": 0.380618,
				"y": 0.176875
			},
			{
				"x": 0.395993,
				"y": 0.176073
			},
			{
				"x": 0.411216,
				"y": 0.178681
			},
			{
				"x": 0.426137,
				"y": 0.182719
			},
			{
				"x": 0.440936,
				"y": 0.187192
			},
			{
				"x": 0.455783,
				"y": 0.1915
			},
			{
				"x": 0.470801,
				"y": 0.195154
			},
			{
				"x": 0.486049,
				"y": 0.197664
			},
			{
				"x": 0.501474,
				"y": 0.198487
			},
			{
				"x": 0.516876,
				"y": 0.197298
			},
			{
				"x": 0.53208,
				"y": 0.194529
			},
			{
				"x": 0.547059,
				"y": 0.190714
			},
			{
				"x": 0.561886,
				"y": 0.186336
			},
			{
				"x": 0.576693,
				"y": 0.181893
			},
			{
				"x": 0.59166,
				"y": 0.178031
			},
			{
				"x": 0.606949,
				"y": 0.175879
			},
			{
				"x": 0.622235,
				"y": 0.177614
			},
			{
				"x": 0.635837,
				"y": 0.184762
			},
			{
				"x": 0.645776,
				"y": 0.196508
			},
			{
				"x": 0.651191,
				"y": 0.210945
			},
			{
				"x": 0.65212,
				"y": 0.226354
			},
			{
				"x": 0.648931,
				"y": 0.241467
			},
			{
				"x": 0.642556,
				"y": 0.255552
			},
			{
				"x": 0.634016,
				"y": 0.268447
			},
			{
				"x": 0.623943,
				"y": 0.280184
			},
			{
				"x": 0.612705,
				"y": 0.290809
			},
			{
				"x": 0.600515,
				"y": 0.300323
			},
			{
				"x": 0.587493,
				"y": 0.308657
			},
			{
				"x": 0.57373,
				"y": 0.315694
			},
			{
				"x": 0.559353,
				"y": 0.321368
			},
			{
				"x": 0.544508,
				"y": 0.325662
			},
			{
				"x": 0.529337,
				"y": 0.328606
			},
			{
				"x": 0.513973,
				"y": 0.330266
			},
			{
				"x": 0.498526,
				"y": 0.330727
			},
			{
				"x": 0.483087,
				"y": 0.330044
			},
			{
				"x": 0.467751,
				"y": 0.328146
			},
			{
				"x": 0.452631,
				"y": 0.324949
			},
			{
				"x": 0.437864,
				"y": 0.320392
			},
			{
				"x": 0.423594,
				"y": 0.314456
			},
			{
				"x": 0.409963,
				"y": 0.307164
			},
			{
				"x": 0.397094,
				"y": 0.298596
			},
			{
				"x": 0.385073,
				"y": 0.288867
			},
			{
				"x": 0.374037,
				"y": 0.278032
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"anguished": {
		"lb": [
			{
				"x": 0.841084,
				"y": 0.665623
			},
			{
				"x": 0.834425,
				"y": 0.672666
			},
			{
				"x": 0.827528,
				"y": 0.679475
			},
			{
				"x": 0.820405,
				"y": 0.686047
			},
			{
				"x": 0.813068,
				"y": 0.692377
			},
			{
				"x": 0.805527,
				"y": 0.698463
			},
			{
				"x": 0.797793,
				"y": 0.704299
			},
			{
				"x": 0.789875,
				"y": 0.709883
			},
			{
				"x": 0.781782,
				"y": 0.715209
			},
			{
				"x": 0.773524,
				"y": 0.720275
			},
			{
				"x": 0.76511,
				"y": 0.725075
			},
			{
				"x": 0.756548,
				"y": 0.729605
			},
			{
				"x": 0.747846,
				"y": 0.73386
			},
			{
				"x": 0.739013,
				"y": 0.737834
			},
			{
				"x": 0.730057,
				"y": 0.741522
			},
			{
				"x": 0.720987,
				"y": 0.744917
			},
			{
				"x": 0.711811,
				"y": 0.748013
			},
			{
				"x": 0.702537,
				"y": 0.750803
			},
			{
				"x": 0.693176,
				"y": 0.753279
			},
			{
				"x": 0.683735,
				"y": 0.755434
			},
			{
				"x": 0.674225,
				"y": 0.757259
			},
			{
				"x": 0.664657,
				"y": 0.758745
			},
			{
				"x": 0.655042,
				"y": 0.759882
			},
			{
				"x": 0.64539,
				"y": 0.760659
			},
			{
				"x": 0.647298,
				"y": 0.764004
			},
			{
				"x": 0.65599,
				"y": 0.768272
			},
			{
				"x": 0.665024,
				"y": 0.771754
			},
			{
				"x": 0.674321,
				"y": 0.774457
			},
			{
				"x": 0.683806,
				"y": 0.776392
			},
			{
				"x": 0.693414,
				"y": 0.777578
			},
			{
				"x": 0.703085,
				"y": 0.778032
			},
			{
				"x": 0.712762,
				"y": 0.777777
			},
			{
				"x": 0.722397,
				"y": 0.776834
			},
			{
				"x": 0.731944,
				"y": 0.775223
			},
			{
				"x": 0.741359,
				"y": 0.772967
			},
			{
				"x": 0.750603,
				"y": 0.770085
			},
			{
				"x": 0.759637,
				"y": 0.766597
			},
			{
				"x": 0.768422,
				"y": 0.762521
			},
			{
				"x": 0.776921,
				"y": 0.757876
			},
			{
				"x": 0.785096,
				"y": 0.752679
			},
			{
				"x": 0.792907,
				"y": 0.746948
			},
			{
				"x": 0.800315,
				"y": 0.740703
			},
			{
				"x": 0.807276,
				"y": 0.733963
			},
			{
				"x": 0.813748,
				"y": 0.726748
			},
			{
				"x": 0.819682,
				"y": 0.719084
			},
			{
				"x": 0.825029,
				"y": 0.710998
			},
			{
				"x": 0.829737,
				"y": 0.702523
			},
			{
				"x": 0.833752,
				"y": 0.693697
			},
			{
				"x": 0.837018,
				"y": 0.684567
			},
			{
				"x": 0.839479,
				"y": 0.675187
			}
		],
		"rb": [
			{
				"x": 0.158916,
				"y": 0.665623
			},
			{
				"x": 0.165575,
				"y": 0.672666
			},
			{
				"x": 0.172472,
				"y": 0.679475
			},
			{
				"x": 0.179595,
				"y": 0.686047
			},
			{
				"x": 0.186932,
				"y": 0.692377
			},
			{
				"x": 0.194473,
				"y": 0.698463
			},
			{
				"x": 0.202207,
				"y": 0.704299
			},
			{
				"x": 0.210125,
				"y": 0.709883
			},
			{
				"x": 0.218218,
				"y": 0.715209
			},
			{
				"x": 0.226476,
				"y": 0.720275
			},
			{
				"x": 0.23489,
				"y": 0.725075
			},
			{
				"x": 0.243452,
				"y": 0.729605
			},
			{
				"x": 0.252154,
				"y": 0.73386
			},
			{
				"x": 0.260987,
				"y": 0.737834
			},
			{
				"x": 0.269943,
				"y": 0.741522
			},
			{
				"x": 0.279013,
				"y": 0.744917
			},
			{
				"x": 0.288189,
				"y": 0.748013
			},
			{
				"x": 0.297463,
				"y": 0.750803
			},
			{
				"x": 0.306824,
				"y": 0.753279
			},
			{
				"x": 0.316265,
				"y": 0.755434
			},
			{
				"x": 0.325775,
				"y": 0.757259
			},
			{
				"x": 0.335343,
				"y": 0.758745
			},
			{
				"x": 0.344958,
				"y": 0.759882
			},
			{
				"x": 0.35461,
				"y": 0.760659
			},
			{
				"x": 0.352702,
				"y": 0.764004
			},
			{
				"x": 0.34401,
				"y": 0.768272
			},
			{
				"x": 0.334976,
				"y": 0.771754
			},
			{
				"x": 0.325679,
				"y": 0.774457
			},
			{
				"x": 0.316194,
				"y": 0.776392
			},
			{
				"x": 0.306586,
				"y": 0.777578
			},
			{
				"x": 0.296915,
				"y": 0.778032
			},
			{
				"x": 0.287238,
				"y": 0.777777
			},
			{
				"x": 0.277603,
				"y": 0.776834
			},
			{
				"x": 0.268056,
				"y": 0.775223
			},
			{
				"x": 0.258641,
				"y": 0.772967
			},
			{
				"x": 0.249397,
				"y": 0.770085
			},
			{
				"x": 0.240363,
				"y": 0.766597
			},
			{
				"x": 0.231578,
				"y": 0.762521
			},
			{
				"x": 0.223079,
				"y": 0.757876
			},
			{
				"x": 0.214904,
				"y": 0.752679
			},
			{
				"x": 0.207093,
				"y": 0.746948
			},
			{
				"x": 0.199685,
				"y": 0.740703
			},
			{
				"x": 0.192724,
				"y": 0.733963
			},
			{
				"x": 0.186252,
				"y": 0.726748
			},
			{
				"x": 0.180318,
				"y": 0.719084
			},
			{
				"x": 0.174971,
				"y": 0.710998
			},
			{
				"x": 0.170263,
				"y": 0.702523
			},
			{
				"x": 0.166248,
				"y": 0.693697
			},
			{
				"x": 0.162982,
				"y": 0.684567
			},
			{
				"x": 0.160521,
				"y": 0.675187
			}
		],
		"le": [
			{
				"x": 0.742431,
				"y": 0.518479
			},
			{
				"x": 0.742105,
				"y": 0.511157
			},
			{
				"x": 0.741124,
				"y": 0.503895
			},
			{
				"x": 0.739484,
				"y": 0.496754
			},
			{
				"x": 0.737174,
				"y": 0.489801
			},
			{
				"x": 0.734183,
				"y": 0.483114
			},
			{
				"x": 0.7305,
				"y": 0.476785
			},
			{
				"x": 0.726118,
				"y": 0.47092
			},
			{
				"x": 0.72104,
				"y": 0.46565
			},
			{
				"x": 0.715292,
				"y": 0.461124
			},
			{
				"x": 0.708935,
				"y": 0.45751
			},
			{
				"x": 0.702078,
				"y": 0.454978
			},
			{
				"x": 0.694889,
				"y": 0.45367
			},
			{
				"x": 0.687583,
				"y": 0.45367
			},
			{
				"x": 0.680394,
				"y": 0.454978
			},
			{
				"x": 0.673537,
				"y": 0.45751
			},
			{
				"x": 0.66718,
				"y": 0.461124
			},
			{
				"x": 0.661432,
				"y": 0.46565
			},
			{
				"x": 0.656355,
				"y": 0.47092
			},
			{
				"x": 0.651972,
				"y": 0.476785
			},
			{
				"x": 0.648289,
				"y": 0.483114
			},
			{
				"x": 0.645298,
				"y": 0.489801
			},
			{
				"x": 0.642988,
				"y": 0.496754
			},
			{
				"x": 0.641348,
				"y": 0.503895
			},
			{
				"x": 0.640368,
				"y": 0.511157
			},
			{
				"x": 0.640041,
				"y": 0.518479
			},
			{
				"x": 0.640368,
				"y": 0.5258
			},
			{
				"x": 0.641348,
				"y": 0.533062
			},
			{
				"x": 0.642988,
				"y": 0.540203
			},
			{
				"x": 0.645298,
				"y": 0.547156
			},
			{
				"x": 0.648289,
				"y": 0.553843
			},
			{
				"x": 0.651972,
				"y": 0.560172
			},
			{
				"x": 0.656355,
				"y": 0.566037
			},
			{
				"x": 0.661432,
				"y": 0.571307
			},
			{
				"x": 0.66718,
				"y": 0.575833
			},
			{
				"x": 0.673537,
				"y": 0.579447
			},
			{
				"x": 0.680394,
				"y": 0.581979
			},
			{
				"x": 0.687583,
				"y": 0.583288
			},
			{
				"x": 0.694889,
				"y": 0.583288
			},
			{
				"x": 0.702078,
				"y": 0.581979
			},
			{
				"x": 0.708935,
				"y": 0.579447
			},
			{
				"x": 0.715292,
				"y": 0.575833
			},
			{
				"x": 0.72104,
				"y": 0.571307
			},
			{
				"x": 0.726118,
				"y": 0.566037
			},
			{
				"x": 0.7305,
				"y": 0.560172
			},
			{
				"x": 0.734183,
				"y": 0.553843
			},
			{
				"x": 0.737174,
				"y": 0.547156
			},
			{
				"x": 0.739484,
				"y": 0.540203
			},
			{
				"x": 0.741124,
				"y": 0.533062
			},
			{
				"x": 0.742105,
				"y": 0.5258
			}
		],
		"re": [
			{
				"x": 0.257569,
				"y": 0.518479
			},
			{
				"x": 0.257895,
				"y": 0.511157
			},
			{
				"x": 0.258876,
				"y": 0.503895
			},
			{
				"x": 0.260516,
				"y": 0.496754
			},
			{
				"x": 0.262826,
				"y": 0.489801
			},
			{
				"x": 0.265817,
				"y": 0.483114
			},
			{
				"x": 0.2695,
				"y": 0.476785
			},
			{
				"x": 0.273882,
				"y": 0.47092
			},
			{
				"x": 0.27896,
				"y": 0.46565
			},
			{
				"x": 0.284708,
				"y": 0.461124
			},
			{
				"x": 0.291065,
				"y": 0.45751
			},
			{
				"x": 0.297922,
				"y": 0.454978
			},
			{
				"x": 0.305111,
				"y": 0.45367
			},
			{
				"x": 0.312417,
				"y": 0.45367
			},
			{
				"x": 0.319606,
				"y": 0.454978
			},
			{
				"x": 0.326463,
				"y": 0.45751
			},
			{
				"x": 0.33282,
				"y": 0.461124
			},
			{
				"x": 0.338568,
				"y": 0.46565
			},
			{
				"x": 0.343645,
				"y": 0.47092
			},
			{
				"x": 0.348028,
				"y": 0.476785
			},
			{
				"x": 0.351711,
				"y": 0.483114
			},
			{
				"x": 0.354702,
				"y": 0.489801
			},
			{
				"x": 0.357012,
				"y": 0.496754
			},
			{
				"x": 0.358652,
				"y": 0.503895
			},
			{
				"x": 0.359632,
				"y": 0.511157
			},
			{
				"x": 0.359959,
				"y": 0.518479
			},
			{
				"x": 0.359632,
				"y": 0.5258
			},
			{
				"x": 0.358652,
				"y": 0.533062
			},
			{
				"x": 0.357012,
				"y": 0.540203
			},
			{
				"x": 0.354702,
				"y": 0.547156
			},
			{
				"x": 0.351711,
				"y": 0.553843
			},
			{
				"x": 0.348028,
				"y": 0.560172
			},
			{
				"x": 0.343645,
				"y": 0.566037
			},
			{
				"x": 0.338568,
				"y": 0.571307
			},
			{
				"x": 0.33282,
				"y": 0.575833
			},
			{
				"x": 0.326463,
				"y": 0.579447
			},
			{
				"x": 0.319606,
				"y": 0.581979
			},
			{
				"x": 0.312417,
				"y": 0.583288
			},
			{
				"x": 0.305111,
				"y": 0.583288
			},
			{
				"x": 0.297922,
				"y": 0.581979
			},
			{
				"x": 0.291065,
				"y": 0.579447
			},
			{
				"x": 0.284708,
				"y": 0.575833
			},
			{
				"x": 0.27896,
				"y": 0.571307
			},
			{
				"x": 0.273882,
				"y": 0.566037
			},
			{
				"x": 0.2695,
				"y": 0.560172
			},
			{
				"x": 0.265817,
				"y": 0.553843
			},
			{
				"x": 0.262826,
				"y": 0.547156
			},
			{
				"x": 0.260516,
				"y": 0.540203
			},
			{
				"x": 0.258876,
				"y": 0.533062
			},
			{
				"x": 0.257895,
				"y": 0.5258
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.364222,
				"y": 0.266079
			},
			{
				"x": 0.356036,
				"y": 0.252957
			},
			{
				"x": 0.350177,
				"y": 0.238652
			},
			{
				"x": 0.347724,
				"y": 0.223404
			},
			{
				"x": 0.349488,
				"y": 0.208071
			},
			{
				"x": 0.355779,
				"y": 0.194
			},
			{
				"x": 0.366523,
				"y": 0.182993
			},
			{
				"x": 0.380618,
				"y": 0.176875
			},
			{
				"x": 0.395993,
				"y": 0.176073
			},
			{
				"x": 0.411216,
				"y": 0.178681
			},
			{
				"x": 0.426137,
				"y": 0.182719
			},
			{
				"x": 0.440936,
				"y": 0.187192
			},
			{
				"x": 0.455783,
				"y": 0.1915
			},
			{
				"x": 0.470801,
				"y": 0.195154
			},
			{
				"x": 0.486049,
				"y": 0.197664
			},
			{
				"x": 0.501474,
				"y": 0.198487
			},
			{
				"x": 0.516876,
				"y": 0.197298
			},
			{
				"x": 0.53208,
				"y": 0.194529
			},
			{
				"x": 0.547059,
				"y": 0.190714
			},
			{
				"x": 0.561886,
				"y": 0.186336
			},
			{
				"x": 0.576693,
				"y": 0.181893
			},
			{
				"x": 0.59166,
				"y": 0.178031
			},
			{
				"x": 0.606949,
				"y": 0.175879
			},
			{
				"x": 0.622235,
				"y": 0.177614
			},
			{
				"x": 0.635837,
				"y": 0.184762
			},
			{
				"x": 0.645776,
				"y": 0.196508
			},
			{
				"x": 0.651191,
				"y": 0.210945
			},
			{
				"x": 0.65212,
				"y": 0.226354
			},
			{
				"x": 0.648931,
				"y": 0.241467
			},
			{
				"x": 0.642556,
				"y": 0.255552
			},
			{
				"x": 0.634016,
				"y": 0.268447
			},
			{
				"x": 0.623943,
				"y": 0.280184
			},
			{
				"x": 0.612705,
				"y": 0.290809
			},
			{
				"x": 0.600515,
				"y": 0.300323
			},
			{
				"x": 0.587493,
				"y": 0.308657
			},
			{
				"x": 0.57373,
				"y": 0.315694
			},
			{
				"x": 0.559353,
				"y": 0.321368
			},
			{
				"x": 0.544508,
				"y": 0.325662
			},
			{
				"x": 0.529337,
				"y": 0.328606
			},
			{
				"x": 0.513973,
				"y": 0.330266
			},
			{
				"x": 0.498526,
				"y": 0.330727
			},
			{
				"x": 0.483087,
				"y": 0.330044
			},
			{
				"x": 0.467751,
				"y": 0.328146
			},
			{
				"x": 0.452631,
				"y": 0.324949
			},
			{
				"x": 0.437864,
				"y": 0.320392
			},
			{
				"x": 0.423594,
				"y": 0.314456
			},
			{
				"x": 0.409963,
				"y": 0.307164
			},
			{
				"x": 0.397094,
				"y": 0.298596
			},
			{
				"x": 0.385073,
				"y": 0.288867
			},
			{
				"x": 0.374037,
				"y": 0.278032
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	},
	"dizzy_face": {
		"lb": [
			{
				"x": 0.827877,
				"y": 0.755618
			},
			{
				"x": 0.820405,
				"y": 0.761788
			},
			{
				"x": 0.812725,
				"y": 0.767696
			},
			{
				"x": 0.80485,
				"y": 0.773341
			},
			{
				"x": 0.796792,
				"y": 0.77872
			},
			{
				"x": 0.788562,
				"y": 0.783831
			},
			{
				"x": 0.78017,
				"y": 0.78867
			},
			{
				"x": 0.771627,
				"y": 0.793237
			},
			{
				"x": 0.762943,
				"y": 0.797527
			},
			{
				"x": 0.754126,
				"y": 0.801537
			},
			{
				"x": 0.745187,
				"y": 0.805265
			},
			{
				"x": 0.736134,
				"y": 0.808706
			},
			{
				"x": 0.726976,
				"y": 0.811857
			},
			{
				"x": 0.717723,
				"y": 0.814713
			},
			{
				"x": 0.708383,
				"y": 0.81727
			},
			{
				"x": 0.698965,
				"y": 0.819522
			},
			{
				"x": 0.689478,
				"y": 0.821465
			},
			{
				"x": 0.679933,
				"y": 0.823092
			},
			{
				"x": 0.670338,
				"y": 0.824397
			},
			{
				"x": 0.660705,
				"y": 0.825373
			},
			{
				"x": 0.651044,
				"y": 0.826013
			},
			{
				"x": 0.641366,
				"y": 0.826309
			},
			{
				"x": 0.631684,
				"y": 0.826253
			},
			{
				"x": 0.62201,
				"y": 0.825836
			},
			{
				"x": 0.623493,
				"y": 0.82939
			},
			{
				"x": 0.631595,
				"y": 0.834696
			},
			{
				"x": 0.640134,
				"y": 0.839265
			},
			{
				"x": 0.649029,
				"y": 0.843092
			},
			{
				"x": 0.658205,
				"y": 0.846181
			},
			{
				"x": 0.667595,
				"y": 0.84854
			},
			{
				"x": 0.677136,
				"y": 0.850182
			},
			{
				"x": 0.686771,
				"y": 0.85112
			},
			{
				"x": 0.696449,
				"y": 0.851371
			},
			{
				"x": 0.706121,
				"y": 0.850948
			},
			{
				"x": 0.715742,
				"y": 0.849869
			},
			{
				"x": 0.725269,
				"y": 0.848147
			},
			{
				"x": 0.734662,
				"y": 0.845797
			},
			{
				"x": 0.743881,
				"y": 0.842834
			},
			{
				"x": 0.752885,
				"y": 0.839271
			},
			{
				"x": 0.761635,
				"y": 0.83512
			},
			{
				"x": 0.77009,
				"y": 0.830395
			},
			{
				"x": 0.778208,
				"y": 0.825109
			},
			{
				"x": 0.785943,
				"y": 0.819277
			},
			{
				"x": 0.793251,
				"y": 0.812914
			},
			{
				"x": 0.80008,
				"y": 0.806039
			},
			{
				"x": 0.806378,
				"y": 0.798673
			},
			{
				"x": 0.81209,
				"y": 0.790842
			},
			{
				"x": 0.817157,
				"y": 0.782577
			},
			{
				"x": 0.821518,
				"y": 0.773918
			},
			{
				"x": 0.825112,
				"y": 0.764912
			}
		],
		"rb": [
			{
				"x": 0.172123,
				"y": 0.755618
			},
			{
				"x": 0.179595,
				"y": 0.761788
			},
			{
				"x": 0.187275,
				"y": 0.767696
			},
			{
				"x": 0.19515,
				"y": 0.773341
			},
			{
				"x": 0.203208,
				"y": 0.77872
			},
			{
				"x": 0.211438,
				"y": 0.783831
			},
			{
				"x": 0.21983,
				"y": 0.78867
			},
			{
				"x": 0.228373,
				"y": 0.793237
			},
			{
				"x": 0.237057,
				"y": 0.797527
			},
			{
				"x": 0.245874,
				"y": 0.801537
			},
			{
				"x": 0.254813,
				"y": 0.805265
			},
			{
				"x": 0.263866,
				"y": 0.808706
			},
			{
				"x": 0.273024,
				"y": 0.811857
			},
			{
				"x": 0.282277,
				"y": 0.814713
			},
			{
				"x": 0.291617,
				"y": 0.81727
			},
			{
				"x": 0.301035,
				"y": 0.819522
			},
			{
				"x": 0.310522,
				"y": 0.821465
			},
			{
				"x": 0.320067,
				"y": 0.823092
			},
			{
				"x": 0.329662,
				"y": 0.824397
			},
			{
				"x": 0.339295,
				"y": 0.825373
			},
			{
				"x": 0.348956,
				"y": 0.826013
			},
			{
				"x": 0.358634,
				"y": 0.826309
			},
			{
				"x": 0.368316,
				"y": 0.826253
			},
			{
				"x": 0.37799,
				"y": 0.825836
			},
			{
				"x": 0.376507,
				"y": 0.82939
			},
			{
				"x": 0.368405,
				"y": 0.834696
			},
			{
				"x": 0.359866,
				"y": 0.839265
			},
			{
				"x": 0.350971,
				"y": 0.843092
			},
			{
				"x": 0.341795,
				"y": 0.846181
			},
			{
				"x": 0.332405,
				"y": 0.84854
			},
			{
				"x": 0.322864,
				"y": 0.850182
			},
			{
				"x": 0.313229,
				"y": 0.85112
			},
			{
				"x": 0.303551,
				"y": 0.851371
			},
			{
				"x": 0.293879,
				"y": 0.850948
			},
			{
				"x": 0.284258,
				"y": 0.849869
			},
			{
				"x": 0.274731,
				"y": 0.848147
			},
			{
				"x": 0.265338,
				"y": 0.845797
			},
			{
				"x": 0.256119,
				"y": 0.842834
			},
			{
				"x": 0.247115,
				"y": 0.839271
			},
			{
				"x": 0.238365,
				"y": 0.83512
			},
			{
				"x": 0.22991,
				"y": 0.830395
			},
			{
				"x": 0.221792,
				"y": 0.825109
			},
			{
				"x": 0.214057,
				"y": 0.819277
			},
			{
				"x": 0.206749,
				"y": 0.812914
			},
			{
				"x": 0.19992,
				"y": 0.806039
			},
			{
				"x": 0.193622,
				"y": 0.798673
			},
			{
				"x": 0.18791,
				"y": 0.790842
			},
			{
				"x": 0.182843,
				"y": 0.782577
			},
			{
				"x": 0.178482,
				"y": 0.773918
			},
			{
				"x": 0.174888,
				"y": 0.764912
			}
		],
		"le": [
			{
				"x": 0.756852,
				"y": 0.486857
			},
			{
				"x": 0.742382,
				"y": 0.476199
			},
			{
				"x": 0.723672,
				"y": 0.483189
			},
			{
				"x": 0.708534,
				"y": 0.496633
			},
			{
				"x": 0.6948,
				"y": 0.511553
			},
			{
				"x": 0.680965,
				"y": 0.526378
			},
			{
				"x": 0.666554,
				"y": 0.540642
			},
			{
				"x": 0.652155,
				"y": 0.542478
			},
			{
				"x": 0.637712,
				"y": 0.528245
			},
			{
				"x": 0.623795,
				"y": 0.513498
			},
			{
				"x": 0.610117,
				"y": 0.498526
			},
			{
				"x": 0.59528,
				"y": 0.484736
			},
			{
				"x": 0.577064,
				"y": 0.476411
			},
			{
				"x": 0.560294,
				"y": 0.484257
			},
			{
				"x": 0.567243,
				"y": 0.502628
			},
			{
				"x": 0.580983,
				"y": 0.517523
			},
			{
				"x": 0.595878,
				"y": 0.531279
			},
			{
				"x": 0.611112,
				"y": 0.544658
			},
			{
				"x": 0.626102,
				"y": 0.558308
			},
			{
				"x": 0.63682,
				"y": 0.575005
			},
			{
				"x": 0.625687,
				"y": 0.591217
			},
			{
				"x": 0.609769,
				"y": 0.603766
			},
			{
				"x": 0.59364,
				"y": 0.616048
			},
			{
				"x": 0.577979,
				"y": 0.628918
			},
			{
				"x": 0.563881,
				"y": 0.643455
			},
			{
				"x": 0.555162,
				"y": 0.661529
			},
			{
				"x": 0.567869,
				"y": 0.671771
			},
			{
				"x": 0.586363,
				"y": 0.663653
			},
			{
				"x": 0.603393,
				"y": 0.652673
			},
			{
				"x": 0.619625,
				"y": 0.640533
			},
			{
				"x": 0.635221,
				"y": 0.627581
			},
			{
				"x": 0.650207,
				"y": 0.613926
			},
			{
				"x": 0.664733,
				"y": 0.612114
			},
			{
				"x": 0.679643,
				"y": 0.625852
			},
			{
				"x": 0.695158,
				"y": 0.638901
			},
			{
				"x": 0.711305,
				"y": 0.651155
			},
			{
				"x": 0.728211,
				"y": 0.662328
			},
			{
				"x": 0.746438,
				"y": 0.671086
			},
			{
				"x": 0.761794,
				"y": 0.664148
			},
			{
				"x": 0.75452,
				"y": 0.645559
			},
			{
				"x": 0.740807,
				"y": 0.630671
			},
			{
				"x": 0.725261,
				"y": 0.617663
			},
			{
				"x": 0.709159,
				"y": 0.605347
			},
			{
				"x": 0.693154,
				"y": 0.592906
			},
			{
				"x": 0.680301,
				"y": 0.577607
			},
			{
				"x": 0.688886,
				"y": 0.560169
			},
			{
				"x": 0.703754,
				"y": 0.546389
			},
			{
				"x": 0.718996,
				"y": 0.533019
			},
			{
				"x": 0.733965,
				"y": 0.519344
			},
			{
				"x": 0.747948,
				"y": 0.504671
			}
		],
		"re": [
			{
				"x": 0.243148,
				"y": 0.486857
			},
			{
				"x": 0.257618,
				"y": 0.476199
			},
			{
				"x": 0.276328,
				"y": 0.483189
			},
			{
				"x": 0.291466,
				"y": 0.496633
			},
			{
				"x": 0.3052,
				"y": 0.511553
			},
			{
				"x": 0.319035,
				"y": 0.526378
			},
			{
				"x": 0.333446,
				"y": 0.540642
			},
			{
				"x": 0.347845,
				"y": 0.542478
			},
			{
				"x": 0.362288,
				"y": 0.528245
			},
			{
				"x": 0.376205,
				"y": 0.513498
			},
			{
				"x": 0.389883,
				"y": 0.498526
			},
			{
				"x": 0.40472,
				"y": 0.484736
			},
			{
				"x": 0.422936,
				"y": 0.476411
			},
			{
				"x": 0.439706,
				"y": 0.484257
			},
			{
				"x": 0.432757,
				"y": 0.502628
			},
			{
				"x": 0.419017,
				"y": 0.517523
			},
			{
				"x": 0.404122,
				"y": 0.531279
			},
			{
				"x": 0.388888,
				"y": 0.544658
			},
			{
				"x": 0.373898,
				"y": 0.558308
			},
			{
				"x": 0.36318,
				"y": 0.575005
			},
			{
				"x": 0.374313,
				"y": 0.591217
			},
			{
				"x": 0.390231,
				"y": 0.603766
			},
			{
				"x": 0.40636,
				"y": 0.616048
			},
			{
				"x": 0.422021,
				"y": 0.628918
			},
			{
				"x": 0.436119,
				"y": 0.643455
			},
			{
				"x": 0.444838,
				"y": 0.661529
			},
			{
				"x": 0.432131,
				"y": 0.671771
			},
			{
				"x": 0.413637,
				"y": 0.663653
			},
			{
				"x": 0.396607,
				"y": 0.652673
			},
			{
				"x": 0.380375,
				"y": 0.640533
			},
			{
				"x": 0.364779,
				"y": 0.627581
			},
			{
				"x": 0.349793,
				"y": 0.613926
			},
			{
				"x": 0.335267,
				"y": 0.612114
			},
			{
				"x": 0.320357,
				"y": 0.625852
			},
			{
				"x": 0.304842,
				"y": 0.638901
			},
			{
				"x": 0.288695,
				"y": 0.651155
			},
			{
				"x": 0.271789,
				"y": 0.662328
			},
			{
				"x": 0.253562,
				"y": 0.671086
			},
			{
				"x": 0.238206,
				"y": 0.664148
			},
			{
				"x": 0.24548,
				"y": 0.645559
			},
			{
				"x": 0.259193,
				"y": 0.630671
			},
			{
				"x": 0.274739,
				"y": 0.617663
			},
			{
				"x": 0.290841,
				"y": 0.605347
			},
			{
				"x": 0.306846,
				"y": 0.592906
			},
			{
				"x": 0.319699,
				"y": 0.577607
			},
			{
				"x": 0.311114,
				"y": 0.560169
			},
			{
				"x": 0.296246,
				"y": 0.546389
			},
			{
				"x": 0.281004,
				"y": 0.533019
			},
			{
				"x": 0.266035,
				"y": 0.519344
			},
			{
				"x": 0.252052,
				"y": 0.504671
			}
		],
		"head": [
			{
				"x": 1,
				"y": 0.5
			},
			{
				"x": 0.996057,
				"y": 0.562791
			},
			{
				"x": 0.984292,
				"y": 0.624591
			},
			{
				"x": 0.964888,
				"y": 0.684426
			},
			{
				"x": 0.938153,
				"y": 0.741353
			},
			{
				"x": 0.904508,
				"y": 0.794474
			},
			{
				"x": 0.864484,
				"y": 0.84295
			},
			{
				"x": 0.818712,
				"y": 0.886018
			},
			{
				"x": 0.767913,
				"y": 0.922999
			},
			{
				"x": 0.71289,
				"y": 0.953308
			},
			{
				"x": 0.654508,
				"y": 0.976468
			},
			{
				"x": 0.593691,
				"y": 0.992115
			},
			{
				"x": 0.531395,
				"y": 1
			},
			{
				"x": 0.468605,
				"y": 1
			},
			{
				"x": 0.406309,
				"y": 0.992115
			},
			{
				"x": 0.345492,
				"y": 0.976468
			},
			{
				"x": 0.28711,
				"y": 0.953308
			},
			{
				"x": 0.232087,
				"y": 0.922999
			},
			{
				"x": 0.181288,
				"y": 0.886018
			},
			{
				"x": 0.135516,
				"y": 0.84295
			},
			{
				"x": 0.095492,
				"y": 0.794474
			},
			{
				"x": 0.061847,
				"y": 0.741353
			},
			{
				"x": 0.035112,
				"y": 0.684426
			},
			{
				"x": 0.015708,
				"y": 0.624591
			},
			{
				"x": 0.003943,
				"y": 0.562791
			},
			{
				"x": 0,
				"y": 0.5
			},
			{
				"x": 0.003943,
				"y": 0.437209
			},
			{
				"x": 0.015708,
				"y": 0.375409
			},
			{
				"x": 0.035112,
				"y": 0.315574
			},
			{
				"x": 0.061847,
				"y": 0.258647
			},
			{
				"x": 0.095492,
				"y": 0.205526
			},
			{
				"x": 0.135516,
				"y": 0.15705
			},
			{
				"x": 0.181288,
				"y": 0.113982
			},
			{
				"x": 0.232087,
				"y": 0.077001
			},
			{
				"x": 0.28711,
				"y": 0.046692
			},
			{
				"x": 0.345492,
				"y": 0.023532
			},
			{
				"x": 0.406309,
				"y": 0.007885
			},
			{
				"x": 0.468605,
				"y": 0
			},
			{
				"x": 0.531395,
				"y": 3.4834e-10
			},
			{
				"x": 0.593691,
				"y": 0.007885
			},
			{
				"x": 0.654508,
				"y": 0.023532
			},
			{
				"x": 0.71289,
				"y": 0.046692
			},
			{
				"x": 0.767913,
				"y": 0.077001
			},
			{
				"x": 0.818712,
				"y": 0.113982
			},
			{
				"x": 0.864484,
				"y": 0.15705
			},
			{
				"x": 0.904508,
				"y": 0.205526
			},
			{
				"x": 0.938153,
				"y": 0.258647
			},
			{
				"x": 0.964888,
				"y": 0.315574
			},
			{
				"x": 0.984292,
				"y": 0.375409
			},
			{
				"x": 0.996057,
				"y": 0.437209
			}
		],
		"mouth": [
			{
				"x": 0.345081,
				"y": 0.254813
			},
			{
				"x": 0.346346,
				"y": 0.235693
			},
			{
				"x": 0.350113,
				"y": 0.216906
			},
			{
				"x": 0.356305,
				"y": 0.198776
			},
			{
				"x": 0.364798,
				"y": 0.181606
			},
			{
				"x": 0.375425,
				"y": 0.165674
			},
			{
				"x": 0.387989,
				"y": 0.151224
			},
			{
				"x": 0.402263,
				"y": 0.13847
			},
			{
				"x": 0.418006,
				"y": 0.127586
			},
			{
				"x": 0.43496,
				"y": 0.118716
			},
			{
				"x": 0.452863,
				"y": 0.111971
			},
			{
				"x": 0.471446,
				"y": 0.10743
			},
			{
				"x": 0.490436,
				"y": 0.105147
			},
			{
				"x": 0.509564,
				"y": 0.105147
			},
			{
				"x": 0.528554,
				"y": 0.10743
			},
			{
				"x": 0.547137,
				"y": 0.111971
			},
			{
				"x": 0.56504,
				"y": 0.118716
			},
			{
				"x": 0.581994,
				"y": 0.127586
			},
			{
				"x": 0.597737,
				"y": 0.13847
			},
			{
				"x": 0.612011,
				"y": 0.151224
			},
			{
				"x": 0.624575,
				"y": 0.165674
			},
			{
				"x": 0.635202,
				"y": 0.181606
			},
			{
				"x": 0.643695,
				"y": 0.198776
			},
			{
				"x": 0.649887,
				"y": 0.216906
			},
			{
				"x": 0.653654,
				"y": 0.235693
			},
			{
				"x": 0.654919,
				"y": 0.254813
			},
			{
				"x": 0.653654,
				"y": 0.273934
			},
			{
				"x": 0.649887,
				"y": 0.292721
			},
			{
				"x": 0.643695,
				"y": 0.310851
			},
			{
				"x": 0.635202,
				"y": 0.328021
			},
			{
				"x": 0.624575,
				"y": 0.343953
			},
			{
				"x": 0.612011,
				"y": 0.358402
			},
			{
				"x": 0.597737,
				"y": 0.371157
			},
			{
				"x": 0.581994,
				"y": 0.382041
			},
			{
				"x": 0.56504,
				"y": 0.390911
			},
			{
				"x": 0.547137,
				"y": 0.397656
			},
			{
				"x": 0.528554,
				"y": 0.402197
			},
			{
				"x": 0.509564,
				"y": 0.40448
			},
			{
				"x": 0.490436,
				"y": 0.40448
			},
			{
				"x": 0.471446,
				"y": 0.402197
			},
			{
				"x": 0.452863,
				"y": 0.397656
			},
			{
				"x": 0.43496,
				"y": 0.390911
			},
			{
				"x": 0.418006,
				"y": 0.382041
			},
			{
				"x": 0.402263,
				"y": 0.371157
			},
			{
				"x": 0.387989,
				"y": 0.358402
			},
			{
				"x": 0.375425,
				"y": 0.343953
			},
			{
				"x": 0.364798,
				"y": 0.328021
			},
			{
				"x": 0.356305,
				"y": 0.310851
			},
			{
				"x": 0.350113,
				"y": 0.292721
			},
			{
				"x": 0.346346,
				"y": 0.273934
			}
		],
		"tongue": [
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			},
			{
				"x": 0.5,
				"y": 0.5
			}
		]
	}
};

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(160);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */],null),document.getElementById('root'));

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(312).enable();
  window.Promise = __webpack_require__(311);
}

// fetch() polyfill for making API calls.
__webpack_require__(339);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(3);


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88)))

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hover_css__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hover_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__hover_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Emojimation_Emojimation__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_emotions_json__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_emotions_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__util_emotions_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_codemirror__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_codemirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_codemirror__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_codemirror_theme_neo_css__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_codemirror_theme_neo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_codemirror_theme_neo_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_codemirror_lib_codemirror_css__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_codemirror_lib_codemirror_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_codemirror_lib_codemirror_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_codemirror_mode_htmlmixed_htmlmixed__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_codemirror_mode_htmlmixed_htmlmixed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_codemirror_mode_htmlmixed_htmlmixed__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//code mirror theme
//css install for code editor
var emos=[{name:'joy',headColor:'yellow',class:'yellowbg'},{name:'fear',headColor:'darkorange',class:'orangebg'},{name:'anger',headColor:'red',class:'redbg',eyeColor:'yellow',mouthColor:'rgb(255,255,0)',browColor:'yellow'},{name:'disgust',headColor:'yellowgreen',class:'greenbg',eyeColor:'brown',mouthColor:'brown',browColor:'brown'},{name:'sadness',headColor:'slateblue',class:'bluebg'},{name:'grimacing',headColor:'orange',class:'orangebg',eyeColor:'lightgrey',mouthColor:'lightgrey',browColor:'lightgrey'},{name:'grin',headColor:'gold',class:'yellowbg'},{name:'smiley',headColor:'yellow',class:'yellowbg'},{name:'smile',headColor:'khaki',class:'yellowbg'},{name:'laughing',headColor:'yellow',class:'yellowbg',eyeColor:'cyan',mouthColor:'cyan',browColor:'cyan'},{name:'wink',headColor:'lightsalmon',class:'yellowbg'},{name:'slightly_smiling_face',headColor:'khaki',class:'yellowbg'},{name:'upside_down_face',headColor:'khaki',class:'yellowbg'},{name:'relaxed',headColor:'peachpuff',class:'yellowbg'},{name:'blush',headColor:'tomato',class:'yellowbg'},{name:'yum',headColor:'orange',class:'yellowbg'},{name:'relieved',headColor:'navajowhite',class:'yellowbg',eyeColor:'purple',mouthColor:'purple',browColor:'purple'},{name:'heart_eyes',headColor:'yellow',class:'yellowbg',eyeColor:'red'},{name:'kissing_heart',headColor:'yellow',class:'yellowbg'},{name:'kissing',headColor:'yellow',class:'yellowbg'},{name:'kissing_smiling_eyes',headColor:'yellow',class:'yellowbg'},{name:'kissing_closed_eyes',headColor:'yellow',class:'yellowbg'},{name:'stuck_out_tongue_winking_eye',headColor:'orange',class:'orangebg'},{name:'stuck_out_tongue_closed_eyes',headColor:'orange',class:'orangebg'},{name:'stuck_out_tongue',headColor:'orange',class:'orangebg'},{name:'sunglasses',headColor:'yellow',class:'yellowbg'},{name:'smirk',headColor:'green',class:'greenbg'},{name:'no_mouth',headColor:'dimgray',class:'greenbg',eyeColor:'rgb(255,255,255)'},{name:'neutral_face',headColor:'cadetblue',class:'greenbg',eyeColor:'white',mouthColor:'white',browColor:'white'},{name:'expressionless',headColor:'yellow',class:'greenbg'},{name:'disappointed',headColor:'midnightblue',class:'bluebg'},{name:'worried',headColor:'midnightblue',class:'bluebg',eyeColor:'white',mouthColor:'rgb(255,255,255)',browColor:'white'},{name:'pensive',headColor:'slateblue',class:'bluebg'},{name:'confused',headColor:'darkslateblue',class:'bluebg'},{name:'slightly_frowning_face',headColor:'darkslateblue',class:'bluebg'},{name:'white_frowning_face',headColor:'darkslateblue',class:'bluebg'},{name:'persevere',headColor:'darkslategray',class:'bluebg',eyeColor:'cyan',mouthColor:'rgb(255,255,0)',browColor:'magenta'},{name:'tired_face',headColor:'darkslategray',class:'bluebg',eyeColor:'white',mouthColor:'white',browColor:'white'},{name:'weary',headColor:'teal',class:'orangebg'},{name:'open_mouth',headColor:'orange',class:'orangebg'},{name:'hushed',headColor:'orange',class:'orangebg'},{name:'frowning',headColor:'chocolate',class:'orangebg'},{name:'anguished',headColor:'maroon',class:'orangebg',eyeColor:'yellow',mouthColor:'yellow',browColor:'yellow'},{name:'dizzy_face',headColor:'darkorange',class:'orangebg'}];var App=function(_React$Component){_inherits(App,_React$Component);function App(){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this));_this.state={emotion:'joy',code:'<Emojimation\nemotion="joy" duration={800}\nwidth="30vh" height="30vh" style={{margin:\'20px\'}}\nheadColor="yellow"\n/>',headColor:'yellow',tongueColor:'red',eyeColor:'black',mouthColor:'black',browColor:'black'};return _this;}_createClass(App,[{key:'_mouseOver',value:function _mouseOver(emotion){var em=emos[emos.map(function(emo){return emo.name;}).indexOf(emotion)];var headColor=em.headColor;var eyeColor=em.eyeColor;var browColor=em.browColor;var mouthColor=em.mouthColor;var code='<Emojimation\nemotion="'+emotion+'" duration={800}\nwidth="30vh" height="30vh" style={{margin:\'20px\'}}\nheadColor="'+headColor+'" '+(eyeColor?'eyeColor="'+eyeColor+'"':'')+' '+(browColor?'browColor="'+browColor+'"':'')+' '+(mouthColor?'mouthColor="'+mouthColor+'"':'')+'\n/>';this.setState({emotion:emotion,code:code,headColor:headColor,eyeColor:eyeColor,browColor:browColor,mouthColor:mouthColor});}},{key:'render',value:function render(){var _this2=this;var options={lineNumbers:false,readOnly:true,mode:'htmlmixed',theme:'material',lineWrapping:true};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Emojimation_Emojimation__["a" /* default */],{emotion:this.state.emotion,width:'30vh',height:'30vh',style:{position:'fixed',marginLeft:'calc(calc(100% - 30vh) / 2)',marginTop:'20px',zIndex:10},headColor:this.state.headColor,tongueColor:this.state.tongueColor,eyeColor:this.state.eyeColor,browColor:this.state.browColor,mouthColor:this.state.mouthColor,duration:800}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'30vh',paddingTop:'40px',position:'absolute'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{style:{textAlign:'center'}},'Emojimation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'npmjs.com/emoijimation',target:'_blank'},'npm'),' | ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://github.com/ekatzenstein/emojimation',target:'_blank'},'github')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',width:'80%',margin:'0 auto'}},Object.keys(__WEBPACK_IMPORTED_MODULE_5__util_emotions_json___default.a).map(function(key){var emo=emos[emos.map(function(emo){return emo.name;}).indexOf(key)];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:key,className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()({"emoButton":true,"yellowbg":emo.class==='yellowbg',"greenbg":emo.class==='greenbg',"bluebg":emo.class==='bluebg',"orangebg":emo.class==='orangebg',"redbg":emo.class==='redbg',"hvr-wobble-skew":emo.class==='orangebg',"hvr-buzz-out":emo.class==='redbg',"hvr-hang":emo.class==='bluebg',"hvr-wobble-top":emo.class==='greenbg',"hvr-wobble-vertical":emo.class==='yellowbg',"hvr-shadow":true,"enter":_this2.state.emotion===key}),style:{backgroundColor:_this2.state.emotion===key?emo.headColor:'lightgray'},onMouseOver:function onMouseOver(){return _this2._mouseOver(key);}},key);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'attHeader'},'Code Sample'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'emoButton',style:{padding:'10px',height:'auto',overflow:'none',margin:'0 auto',width:'50%',marginLeft:'25%',marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_codemirror___default.a,{key:this.state.emotion,value:this.state.code,options:options,viewportMargin:Infinity})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'attributes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'attHeader'},'React Attributes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Default'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Description'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'emotion'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'string'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'joy'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'render the emoji emotion')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'width'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'string'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'200px'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'set responsive width, using css units (px, %, vh, etc.)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'height'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'string'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'200px'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'set responsive height, using css units (px, %, vh, etc.)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'duration'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'800'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'duration of transition')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'headColor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'color'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'yellow'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'set css color for head')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'mouthColor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'color'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'black'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'set css color for mouth')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'eyeColor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'color'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'black'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'set css color for eyes')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'browColor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'color'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'black'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'set css color for eyebrows')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'tongueColor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'color'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'black'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'set css color for tongue (or other attributes, like kisses)')))))));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_resonance__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_emotions_json__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_emotions_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__util_emotions_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Tweener=function(_Component){_inherits(Tweener,_Component);function Tweener(){_classCallCheck(this,Tweener);return _possibleConstructorReturn(this,(Tweener.__proto__||Object.getPrototypeOf(Tweener)).apply(this,arguments));}_createClass(Tweener,[{key:'componentWillMount',value:function componentWillMount(){//define d3 drawing functions
var x=__WEBPACK_IMPORTED_MODULE_2_d3__["scaleLinear"]().rangeRound([0,1000]);var y=__WEBPACK_IMPORTED_MODULE_2_d3__["scaleLinear"]().rangeRound([0,1000]);this.line=__WEBPACK_IMPORTED_MODULE_2_d3__["line"]().curve(__WEBPACK_IMPORTED_MODULE_2_d3__["curveBasisClosed"]).x(function(d){return x(+d.x);}).y(function(d){return y(1-+d.y);});//create svg shading def
this.svgShading=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('pattern',{id:'image0',x:'0%',y:'0%',height:'100%',width:'100%',viewBox:'0 0 512 512',preserveAspectRatio:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('image',{x:'0%',y:'0%',width:'512',height:'512',xlinkHref:'img/EmojiBackground.png'})));}},{key:'render',value:function render(){var _this2=this;var emotion=this.props.emotion==='upside_down_face'?'slightly_smiling_face':this.props.emotion;var _emotions$emotion=__WEBPACK_IMPORTED_MODULE_4__util_emotions_json___default.a[emotion],le=_emotions$emotion.le,re=_emotions$emotion.re,lb=_emotions$emotion.lb,rb=_emotions$emotion.rb,mouth=_emotions$emotion.mouth,head=_emotions$emotion.head,tongue=_emotions$emotion.tongue;var headColor=this.props.headColor;var tongueColor=this.props.tongueColor;var eyeColor=this.props.eyeColor;var browColor=this.props.browColor;var mouthColor=this.props.mouthColor;var dataArray=[{key:"head",data:head,fill:headColor},{key:"headImg",data:head,fill:"url(#image0)"},{key:"le",data:le,fill:eyeColor},{key:"re",data:re,fill:eyeColor},{key:"lb",data:lb,fill:browColor},{key:"rb",data:rb,fill:browColor},{key:"mouth",data:mouth,fill:mouthColor},{key:"tongue",data:tongue,fill:tongueColor}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:Object.assign({width:this.props.width,height:this.props.height,position:'relative'},this.props.style)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{viewBox:'0 0 1000 1000',preserveAspectRatio:'none',style:{position:'absolute',left:0,top:0,width:'100%',height:'100%'}},this.svgShading,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_resonance__["a" /* NodeGroup */],{data:dataArray,keyAccessor:function keyAccessor(d,i){return d.key;},start:function start(data){return{opacity:1,fill:[data.fill],d:[_this2.line(data.data)]};},update:function update(data,i){return{opacity:[1],fill:[data.fill],transform:[_this2.props.emotion==="upside_down_face"?"rotate(180, 500, 500)":"rotate(0, 500, 500)"],d:[_this2.line(data.data)],timing:{duration:_this2.props.duration}};}},function(nodes){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,nodes.map(function(_ref){var key=_ref.key,data=_ref.data,state=_ref.state;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',Object.assign({key:key},state));}));})));}}]);return Tweener;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Tweener.propTypes={width:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,height:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,emotion:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,responsive:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,headColor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tongueColor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,eyeColor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,mouthColor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,browColor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,duration:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};Tweener.defaultProps={width:'200px',height:'200px',emotion:'joy',responsive:true,headColor:'yellow',tongueColor:'red',eyeColor:'black',mouthColor:'black',browColor:'black',duration:800};/* harmony default export */ __webpack_exports__["a"] = (Tweener);

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(167), __esModule: true };

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(168), __esModule: true };

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(172), __esModule: true };

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(173), __esModule: true };

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(174), __esModule: true };

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(193);
module.exports = __webpack_require__(8).Object.assign;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(194);
var $Object = __webpack_require__(8).Object;
module.exports = function create(P, D){
  return $Object.create(P, D);
};

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(195);
var $Object = __webpack_require__(8).Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(196);
module.exports = __webpack_require__(8).Object.getPrototypeOf;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(197);
module.exports = __webpack_require__(8).Object.keys;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(198);
module.exports = __webpack_require__(8).Object.setPrototypeOf;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(201);
__webpack_require__(199);
__webpack_require__(202);
__webpack_require__(203);
module.exports = __webpack_require__(8).Symbol;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(200);
__webpack_require__(204);
module.exports = __webpack_require__(64).f('iterator');

/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 176 */
/***/ (function(module, exports) {

module.exports = function(){ /* empty */ };

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(17)
  , toLength  = __webpack_require__(191)
  , toIndex   = __webpack_require__(190);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(23)
  , gOPS    = __webpack_require__(57)
  , pIE     = __webpack_require__(39);
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(12).document && document.documentElement;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(97);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create         = __webpack_require__(56)
  , descriptor     = __webpack_require__(40)
  , setToStringTag = __webpack_require__(58)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(22)(IteratorPrototype, __webpack_require__(24)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(23)
  , toIObject = __webpack_require__(17);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var META     = __webpack_require__(42)('meta')
  , isObject = __webpack_require__(31)
  , has      = __webpack_require__(15)
  , setDesc  = __webpack_require__(16).f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !__webpack_require__(21)(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = __webpack_require__(23)
  , gOPS     = __webpack_require__(57)
  , pIE      = __webpack_require__(39)
  , toObject = __webpack_require__(41)
  , IObject  = __webpack_require__(101)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(21)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var dP       = __webpack_require__(16)
  , anObject = __webpack_require__(30)
  , getKeys  = __webpack_require__(23);

module.exports = __webpack_require__(13) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(17)
  , gOPN      = __webpack_require__(104).f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(31)
  , anObject = __webpack_require__(30);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = __webpack_require__(98)(Function.call, __webpack_require__(103).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(61)
  , defined   = __webpack_require__(52);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(61)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(61)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(176)
  , step             = __webpack_require__(182)
  , Iterators        = __webpack_require__(54)
  , toIObject        = __webpack_require__(17);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(102)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(14);

$export($export.S + $export.F, 'Object', {assign: __webpack_require__(185)});

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(14)
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: __webpack_require__(56)});

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(14);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(13), 'Object', {defineProperty: __webpack_require__(16).f});

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject        = __webpack_require__(41)
  , $getPrototypeOf = __webpack_require__(105);

__webpack_require__(107)('getPrototypeOf', function(){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(41)
  , $keys    = __webpack_require__(23);

__webpack_require__(107)('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(14);
$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(188).set});

/***/ }),
/* 199 */
/***/ (function(module, exports) {



/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at  = __webpack_require__(189)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(102)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global         = __webpack_require__(12)
  , has            = __webpack_require__(15)
  , DESCRIPTORS    = __webpack_require__(13)
  , $export        = __webpack_require__(14)
  , redefine       = __webpack_require__(108)
  , META           = __webpack_require__(184).KEY
  , $fails         = __webpack_require__(21)
  , shared         = __webpack_require__(60)
  , setToStringTag = __webpack_require__(58)
  , uid            = __webpack_require__(42)
  , wks            = __webpack_require__(24)
  , wksExt         = __webpack_require__(64)
  , wksDefine      = __webpack_require__(63)
  , keyOf          = __webpack_require__(183)
  , enumKeys       = __webpack_require__(178)
  , isArray        = __webpack_require__(180)
  , anObject       = __webpack_require__(30)
  , toIObject      = __webpack_require__(17)
  , toPrimitive    = __webpack_require__(62)
  , createDesc     = __webpack_require__(40)
  , _create        = __webpack_require__(56)
  , gOPNExt        = __webpack_require__(187)
  , $GOPD          = __webpack_require__(103)
  , $DP            = __webpack_require__(16)
  , $keys          = __webpack_require__(23)
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  __webpack_require__(104).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(39).f  = $propertyIsEnumerable;
  __webpack_require__(57).f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !__webpack_require__(55)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(22)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(63)('asyncIterator');

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(63)('observable');

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(192);
var global        = __webpack_require__(12)
  , hide          = __webpack_require__(22)
  , Iterators     = __webpack_require__(54)
  , TO_STRING_TAG = __webpack_require__(24)('toStringTag');

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype;
  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: http://codemirror.net/LICENSE

(function(mod) {
  if (true) // CommonJS
    mod(__webpack_require__(32));
  else if (typeof define == "function" && define.amd) // AMD
    define(["../../lib/codemirror"], mod);
  else // Plain browser env
    mod(CodeMirror);
})(function(CodeMirror) {
"use strict";

CodeMirror.defineMode("css", function(config, parserConfig) {
  var inline = parserConfig.inline
  if (!parserConfig.propertyKeywords) parserConfig = CodeMirror.resolveMode("text/css");

  var indentUnit = config.indentUnit,
      tokenHooks = parserConfig.tokenHooks,
      documentTypes = parserConfig.documentTypes || {},
      mediaTypes = parserConfig.mediaTypes || {},
      mediaFeatures = parserConfig.mediaFeatures || {},
      mediaValueKeywords = parserConfig.mediaValueKeywords || {},
      propertyKeywords = parserConfig.propertyKeywords || {},
      nonStandardPropertyKeywords = parserConfig.nonStandardPropertyKeywords || {},
      fontProperties = parserConfig.fontProperties || {},
      counterDescriptors = parserConfig.counterDescriptors || {},
      colorKeywords = parserConfig.colorKeywords || {},
      valueKeywords = parserConfig.valueKeywords || {},
      allowNested = parserConfig.allowNested,
      lineComment = parserConfig.lineComment,
      supportsAtComponent = parserConfig.supportsAtComponent === true;

  var type, override;
  function ret(style, tp) { type = tp; return style; }

  // Tokenizers

  function tokenBase(stream, state) {
    var ch = stream.next();
    if (tokenHooks[ch]) {
      var result = tokenHooks[ch](stream, state);
      if (result !== false) return result;
    }
    if (ch == "@") {
      stream.eatWhile(/[\w\\\-]/);
      return ret("def", stream.current());
    } else if (ch == "=" || (ch == "~" || ch == "|") && stream.eat("=")) {
      return ret(null, "compare");
    } else if (ch == "\"" || ch == "'") {
      state.tokenize = tokenString(ch);
      return state.tokenize(stream, state);
    } else if (ch == "#") {
      stream.eatWhile(/[\w\\\-]/);
      return ret("atom", "hash");
    } else if (ch == "!") {
      stream.match(/^\s*\w*/);
      return ret("keyword", "important");
    } else if (/\d/.test(ch) || ch == "." && stream.eat(/\d/)) {
      stream.eatWhile(/[\w.%]/);
      return ret("number", "unit");
    } else if (ch === "-") {
      if (/[\d.]/.test(stream.peek())) {
        stream.eatWhile(/[\w.%]/);
        return ret("number", "unit");
      } else if (stream.match(/^-[\w\\\-]+/)) {
        stream.eatWhile(/[\w\\\-]/);
        if (stream.match(/^\s*:/, false))
          return ret("variable-2", "variable-definition");
        return ret("variable-2", "variable");
      } else if (stream.match(/^\w+-/)) {
        return ret("meta", "meta");
      }
    } else if (/[,+>*\/]/.test(ch)) {
      return ret(null, "select-op");
    } else if (ch == "." && stream.match(/^-?[_a-z][_a-z0-9-]*/i)) {
      return ret("qualifier", "qualifier");
    } else if (/[:;{}\[\]\(\)]/.test(ch)) {
      return ret(null, ch);
    } else if ((ch == "u" && stream.match(/rl(-prefix)?\(/)) ||
               (ch == "d" && stream.match("omain(")) ||
               (ch == "r" && stream.match("egexp("))) {
      stream.backUp(1);
      state.tokenize = tokenParenthesized;
      return ret("property", "word");
    } else if (/[\w\\\-]/.test(ch)) {
      stream.eatWhile(/[\w\\\-]/);
      return ret("property", "word");
    } else {
      return ret(null, null);
    }
  }

  function tokenString(quote) {
    return function(stream, state) {
      var escaped = false, ch;
      while ((ch = stream.next()) != null) {
        if (ch == quote && !escaped) {
          if (quote == ")") stream.backUp(1);
          break;
        }
        escaped = !escaped && ch == "\\";
      }
      if (ch == quote || !escaped && quote != ")") state.tokenize = null;
      return ret("string", "string");
    };
  }

  function tokenParenthesized(stream, state) {
    stream.next(); // Must be '('
    if (!stream.match(/\s*[\"\')]/, false))
      state.tokenize = tokenString(")");
    else
      state.tokenize = null;
    return ret(null, "(");
  }

  // Context management

  function Context(type, indent, prev) {
    this.type = type;
    this.indent = indent;
    this.prev = prev;
  }

  function pushContext(state, stream, type, indent) {
    state.context = new Context(type, stream.indentation() + (indent === false ? 0 : indentUnit), state.context);
    return type;
  }

  function popContext(state) {
    if (state.context.prev)
      state.context = state.context.prev;
    return state.context.type;
  }

  function pass(type, stream, state) {
    return states[state.context.type](type, stream, state);
  }
  function popAndPass(type, stream, state, n) {
    for (var i = n || 1; i > 0; i--)
      state.context = state.context.prev;
    return pass(type, stream, state);
  }

  // Parser

  function wordAsValue(stream) {
    var word = stream.current().toLowerCase();
    if (valueKeywords.hasOwnProperty(word))
      override = "atom";
    else if (colorKeywords.hasOwnProperty(word))
      override = "keyword";
    else
      override = "variable";
  }

  var states = {};

  states.top = function(type, stream, state) {
    if (type == "{") {
      return pushContext(state, stream, "block");
    } else if (type == "}" && state.context.prev) {
      return popContext(state);
    } else if (supportsAtComponent && /@component/.test(type)) {
      return pushContext(state, stream, "atComponentBlock");
    } else if (/^@(-moz-)?document$/.test(type)) {
      return pushContext(state, stream, "documentTypes");
    } else if (/^@(media|supports|(-moz-)?document|import)$/.test(type)) {
      return pushContext(state, stream, "atBlock");
    } else if (/^@(font-face|counter-style)/.test(type)) {
      state.stateArg = type;
      return "restricted_atBlock_before";
    } else if (/^@(-(moz|ms|o|webkit)-)?keyframes$/.test(type)) {
      return "keyframes";
    } else if (type && type.charAt(0) == "@") {
      return pushContext(state, stream, "at");
    } else if (type == "hash") {
      override = "builtin";
    } else if (type == "word") {
      override = "tag";
    } else if (type == "variable-definition") {
      return "maybeprop";
    } else if (type == "interpolation") {
      return pushContext(state, stream, "interpolation");
    } else if (type == ":") {
      return "pseudo";
    } else if (allowNested && type == "(") {
      return pushContext(state, stream, "parens");
    }
    return state.context.type;
  };

  states.block = function(type, stream, state) {
    if (type == "word") {
      var word = stream.current().toLowerCase();
      if (propertyKeywords.hasOwnProperty(word)) {
        override = "property";
        return "maybeprop";
      } else if (nonStandardPropertyKeywords.hasOwnProperty(word)) {
        override = "string-2";
        return "maybeprop";
      } else if (allowNested) {
        override = stream.match(/^\s*:(?:\s|$)/, false) ? "property" : "tag";
        return "block";
      } else {
        override += " error";
        return "maybeprop";
      }
    } else if (type == "meta") {
      return "block";
    } else if (!allowNested && (type == "hash" || type == "qualifier")) {
      override = "error";
      return "block";
    } else {
      return states.top(type, stream, state);
    }
  };

  states.maybeprop = function(type, stream, state) {
    if (type == ":") return pushContext(state, stream, "prop");
    return pass(type, stream, state);
  };

  states.prop = function(type, stream, state) {
    if (type == ";") return popContext(state);
    if (type == "{" && allowNested) return pushContext(state, stream, "propBlock");
    if (type == "}" || type == "{") return popAndPass(type, stream, state);
    if (type == "(") return pushContext(state, stream, "parens");

    if (type == "hash" && !/^#([0-9a-fA-f]{3,4}|[0-9a-fA-f]{6}|[0-9a-fA-f]{8})$/.test(stream.current())) {
      override += " error";
    } else if (type == "word") {
      wordAsValue(stream);
    } else if (type == "interpolation") {
      return pushContext(state, stream, "interpolation");
    }
    return "prop";
  };

  states.propBlock = function(type, _stream, state) {
    if (type == "}") return popContext(state);
    if (type == "word") { override = "property"; return "maybeprop"; }
    return state.context.type;
  };

  states.parens = function(type, stream, state) {
    if (type == "{" || type == "}") return popAndPass(type, stream, state);
    if (type == ")") return popContext(state);
    if (type == "(") return pushContext(state, stream, "parens");
    if (type == "interpolation") return pushContext(state, stream, "interpolation");
    if (type == "word") wordAsValue(stream);
    return "parens";
  };

  states.pseudo = function(type, stream, state) {
    if (type == "meta") return "pseudo";

    if (type == "word") {
      override = "variable-3";
      return state.context.type;
    }
    return pass(type, stream, state);
  };

  states.documentTypes = function(type, stream, state) {
    if (type == "word" && documentTypes.hasOwnProperty(stream.current())) {
      override = "tag";
      return state.context.type;
    } else {
      return states.atBlock(type, stream, state);
    }
  };

  states.atBlock = function(type, stream, state) {
    if (type == "(") return pushContext(state, stream, "atBlock_parens");
    if (type == "}" || type == ";") return popAndPass(type, stream, state);
    if (type == "{") return popContext(state) && pushContext(state, stream, allowNested ? "block" : "top");

    if (type == "interpolation") return pushContext(state, stream, "interpolation");

    if (type == "word") {
      var word = stream.current().toLowerCase();
      if (word == "only" || word == "not" || word == "and" || word == "or")
        override = "keyword";
      else if (mediaTypes.hasOwnProperty(word))
        override = "attribute";
      else if (mediaFeatures.hasOwnProperty(word))
        override = "property";
      else if (mediaValueKeywords.hasOwnProperty(word))
        override = "keyword";
      else if (propertyKeywords.hasOwnProperty(word))
        override = "property";
      else if (nonStandardPropertyKeywords.hasOwnProperty(word))
        override = "string-2";
      else if (valueKeywords.hasOwnProperty(word))
        override = "atom";
      else if (colorKeywords.hasOwnProperty(word))
        override = "keyword";
      else
        override = "error";
    }
    return state.context.type;
  };

  states.atComponentBlock = function(type, stream, state) {
    if (type == "}")
      return popAndPass(type, stream, state);
    if (type == "{")
      return popContext(state) && pushContext(state, stream, allowNested ? "block" : "top", false);
    if (type == "word")
      override = "error";
    return state.context.type;
  };

  states.atBlock_parens = function(type, stream, state) {
    if (type == ")") return popContext(state);
    if (type == "{" || type == "}") return popAndPass(type, stream, state, 2);
    return states.atBlock(type, stream, state);
  };

  states.restricted_atBlock_before = function(type, stream, state) {
    if (type == "{")
      return pushContext(state, stream, "restricted_atBlock");
    if (type == "word" && state.stateArg == "@counter-style") {
      override = "variable";
      return "restricted_atBlock_before";
    }
    return pass(type, stream, state);
  };

  states.restricted_atBlock = function(type, stream, state) {
    if (type == "}") {
      state.stateArg = null;
      return popContext(state);
    }
    if (type == "word") {
      if ((state.stateArg == "@font-face" && !fontProperties.hasOwnProperty(stream.current().toLowerCase())) ||
          (state.stateArg == "@counter-style" && !counterDescriptors.hasOwnProperty(stream.current().toLowerCase())))
        override = "error";
      else
        override = "property";
      return "maybeprop";
    }
    return "restricted_atBlock";
  };

  states.keyframes = function(type, stream, state) {
    if (type == "word") { override = "variable"; return "keyframes"; }
    if (type == "{") return pushContext(state, stream, "top");
    return pass(type, stream, state);
  };

  states.at = function(type, stream, state) {
    if (type == ";") return popContext(state);
    if (type == "{" || type == "}") return popAndPass(type, stream, state);
    if (type == "word") override = "tag";
    else if (type == "hash") override = "builtin";
    return "at";
  };

  states.interpolation = function(type, stream, state) {
    if (type == "}") return popContext(state);
    if (type == "{" || type == ";") return popAndPass(type, stream, state);
    if (type == "word") override = "variable";
    else if (type != "variable" && type != "(" && type != ")") override = "error";
    return "interpolation";
  };

  return {
    startState: function(base) {
      return {tokenize: null,
              state: inline ? "block" : "top",
              stateArg: null,
              context: new Context(inline ? "block" : "top", base || 0, null)};
    },

    token: function(stream, state) {
      if (!state.tokenize && stream.eatSpace()) return null;
      var style = (state.tokenize || tokenBase)(stream, state);
      if (style && typeof style == "object") {
        type = style[1];
        style = style[0];
      }
      override = style;
      state.state = states[state.state](type, stream, state);
      return override;
    },

    indent: function(state, textAfter) {
      var cx = state.context, ch = textAfter && textAfter.charAt(0);
      var indent = cx.indent;
      if (cx.type == "prop" && (ch == "}" || ch == ")")) cx = cx.prev;
      if (cx.prev) {
        if (ch == "}" && (cx.type == "block" || cx.type == "top" ||
                          cx.type == "interpolation" || cx.type == "restricted_atBlock")) {
          // Resume indentation from parent context.
          cx = cx.prev;
          indent = cx.indent;
        } else if (ch == ")" && (cx.type == "parens" || cx.type == "atBlock_parens") ||
            ch == "{" && (cx.type == "at" || cx.type == "atBlock")) {
          // Dedent relative to current context.
          indent = Math.max(0, cx.indent - indentUnit);
        }
      }
      return indent;
    },

    electricChars: "}",
    blockCommentStart: "/*",
    blockCommentEnd: "*/",
    lineComment: lineComment,
    fold: "brace"
  };
});

  function keySet(array) {
    var keys = {};
    for (var i = 0; i < array.length; ++i) {
      keys[array[i].toLowerCase()] = true;
    }
    return keys;
  }

  var documentTypes_ = [
    "domain", "regexp", "url", "url-prefix"
  ], documentTypes = keySet(documentTypes_);

  var mediaTypes_ = [
    "all", "aural", "braille", "handheld", "print", "projection", "screen",
    "tty", "tv", "embossed"
  ], mediaTypes = keySet(mediaTypes_);

  var mediaFeatures_ = [
    "width", "min-width", "max-width", "height", "min-height", "max-height",
    "device-width", "min-device-width", "max-device-width", "device-height",
    "min-device-height", "max-device-height", "aspect-ratio",
    "min-aspect-ratio", "max-aspect-ratio", "device-aspect-ratio",
    "min-device-aspect-ratio", "max-device-aspect-ratio", "color", "min-color",
    "max-color", "color-index", "min-color-index", "max-color-index",
    "monochrome", "min-monochrome", "max-monochrome", "resolution",
    "min-resolution", "max-resolution", "scan", "grid", "orientation",
    "device-pixel-ratio", "min-device-pixel-ratio", "max-device-pixel-ratio",
    "pointer", "any-pointer", "hover", "any-hover"
  ], mediaFeatures = keySet(mediaFeatures_);

  var mediaValueKeywords_ = [
    "landscape", "portrait", "none", "coarse", "fine", "on-demand", "hover",
    "interlace", "progressive"
  ], mediaValueKeywords = keySet(mediaValueKeywords_);

  var propertyKeywords_ = [
    "align-content", "align-items", "align-self", "alignment-adjust",
    "alignment-baseline", "anchor-point", "animation", "animation-delay",
    "animation-direction", "animation-duration", "animation-fill-mode",
    "animation-iteration-count", "animation-name", "animation-play-state",
    "animation-timing-function", "appearance", "azimuth", "backface-visibility",
    "background", "background-attachment", "background-blend-mode", "background-clip",
    "background-color", "background-image", "background-origin", "background-position",
    "background-repeat", "background-size", "baseline-shift", "binding",
    "bleed", "bookmark-label", "bookmark-level", "bookmark-state",
    "bookmark-target", "border", "border-bottom", "border-bottom-color",
    "border-bottom-left-radius", "border-bottom-right-radius",
    "border-bottom-style", "border-bottom-width", "border-collapse",
    "border-color", "border-image", "border-image-outset",
    "border-image-repeat", "border-image-slice", "border-image-source",
    "border-image-width", "border-left", "border-left-color",
    "border-left-style", "border-left-width", "border-radius", "border-right",
    "border-right-color", "border-right-style", "border-right-width",
    "border-spacing", "border-style", "border-top", "border-top-color",
    "border-top-left-radius", "border-top-right-radius", "border-top-style",
    "border-top-width", "border-width", "bottom", "box-decoration-break",
    "box-shadow", "box-sizing", "break-after", "break-before", "break-inside",
    "caption-side", "caret-color", "clear", "clip", "color", "color-profile", "column-count",
    "column-fill", "column-gap", "column-rule", "column-rule-color",
    "column-rule-style", "column-rule-width", "column-span", "column-width",
    "columns", "content", "counter-increment", "counter-reset", "crop", "cue",
    "cue-after", "cue-before", "cursor", "direction", "display",
    "dominant-baseline", "drop-initial-after-adjust",
    "drop-initial-after-align", "drop-initial-before-adjust",
    "drop-initial-before-align", "drop-initial-size", "drop-initial-value",
    "elevation", "empty-cells", "fit", "fit-position", "flex", "flex-basis",
    "flex-direction", "flex-flow", "flex-grow", "flex-shrink", "flex-wrap",
    "float", "float-offset", "flow-from", "flow-into", "font", "font-feature-settings",
    "font-family", "font-kerning", "font-language-override", "font-size", "font-size-adjust",
    "font-stretch", "font-style", "font-synthesis", "font-variant",
    "font-variant-alternates", "font-variant-caps", "font-variant-east-asian",
    "font-variant-ligatures", "font-variant-numeric", "font-variant-position",
    "font-weight", "grid", "grid-area", "grid-auto-columns", "grid-auto-flow",
    "grid-auto-rows", "grid-column", "grid-column-end", "grid-column-gap",
    "grid-column-start", "grid-gap", "grid-row", "grid-row-end", "grid-row-gap",
    "grid-row-start", "grid-template", "grid-template-areas", "grid-template-columns",
    "grid-template-rows", "hanging-punctuation", "height", "hyphens",
    "icon", "image-orientation", "image-rendering", "image-resolution",
    "inline-box-align", "justify-content", "justify-items", "justify-self", "left", "letter-spacing",
    "line-break", "line-height", "line-stacking", "line-stacking-ruby",
    "line-stacking-shift", "line-stacking-strategy", "list-style",
    "list-style-image", "list-style-position", "list-style-type", "margin",
    "margin-bottom", "margin-left", "margin-right", "margin-top",
    "marks", "marquee-direction", "marquee-loop",
    "marquee-play-count", "marquee-speed", "marquee-style", "max-height",
    "max-width", "min-height", "min-width", "move-to", "nav-down", "nav-index",
    "nav-left", "nav-right", "nav-up", "object-fit", "object-position",
    "opacity", "order", "orphans", "outline",
    "outline-color", "outline-offset", "outline-style", "outline-width",
    "overflow", "overflow-style", "overflow-wrap", "overflow-x", "overflow-y",
    "padding", "padding-bottom", "padding-left", "padding-right", "padding-top",
    "page", "page-break-after", "page-break-before", "page-break-inside",
    "page-policy", "pause", "pause-after", "pause-before", "perspective",
    "perspective-origin", "pitch", "pitch-range", "place-content", "place-items", "place-self", "play-during", "position",
    "presentation-level", "punctuation-trim", "quotes", "region-break-after",
    "region-break-before", "region-break-inside", "region-fragment",
    "rendering-intent", "resize", "rest", "rest-after", "rest-before", "richness",
    "right", "rotation", "rotation-point", "ruby-align", "ruby-overhang",
    "ruby-position", "ruby-span", "shape-image-threshold", "shape-inside", "shape-margin",
    "shape-outside", "size", "speak", "speak-as", "speak-header",
    "speak-numeral", "speak-punctuation", "speech-rate", "stress", "string-set",
    "tab-size", "table-layout", "target", "target-name", "target-new",
    "target-position", "text-align", "text-align-last", "text-decoration",
    "text-decoration-color", "text-decoration-line", "text-decoration-skip",
    "text-decoration-style", "text-emphasis", "text-emphasis-color",
    "text-emphasis-position", "text-emphasis-style", "text-height",
    "text-indent", "text-justify", "text-outline", "text-overflow", "text-shadow",
    "text-size-adjust", "text-space-collapse", "text-transform", "text-underline-position",
    "text-wrap", "top", "transform", "transform-origin", "transform-style",
    "transition", "transition-delay", "transition-duration",
    "transition-property", "transition-timing-function", "unicode-bidi",
    "user-select", "vertical-align", "visibility", "voice-balance", "voice-duration",
    "voice-family", "voice-pitch", "voice-range", "voice-rate", "voice-stress",
    "voice-volume", "volume", "white-space", "widows", "width", "will-change", "word-break",
    "word-spacing", "word-wrap", "z-index",
    // SVG-specific
    "clip-path", "clip-rule", "mask", "enable-background", "filter", "flood-color",
    "flood-opacity", "lighting-color", "stop-color", "stop-opacity", "pointer-events",
    "color-interpolation", "color-interpolation-filters",
    "color-rendering", "fill", "fill-opacity", "fill-rule", "image-rendering",
    "marker", "marker-end", "marker-mid", "marker-start", "shape-rendering", "stroke",
    "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin",
    "stroke-miterlimit", "stroke-opacity", "stroke-width", "text-rendering",
    "baseline-shift", "dominant-baseline", "glyph-orientation-horizontal",
    "glyph-orientation-vertical", "text-anchor", "writing-mode"
  ], propertyKeywords = keySet(propertyKeywords_);

  var nonStandardPropertyKeywords_ = [
    "scrollbar-arrow-color", "scrollbar-base-color", "scrollbar-dark-shadow-color",
    "scrollbar-face-color", "scrollbar-highlight-color", "scrollbar-shadow-color",
    "scrollbar-3d-light-color", "scrollbar-track-color", "shape-inside",
    "searchfield-cancel-button", "searchfield-decoration", "searchfield-results-button",
    "searchfield-results-decoration", "zoom"
  ], nonStandardPropertyKeywords = keySet(nonStandardPropertyKeywords_);

  var fontProperties_ = [
    "font-family", "src", "unicode-range", "font-variant", "font-feature-settings",
    "font-stretch", "font-weight", "font-style"
  ], fontProperties = keySet(fontProperties_);

  var counterDescriptors_ = [
    "additive-symbols", "fallback", "negative", "pad", "prefix", "range",
    "speak-as", "suffix", "symbols", "system"
  ], counterDescriptors = keySet(counterDescriptors_);

  var colorKeywords_ = [
    "aliceblue", "antiquewhite", "aqua", "aquamarine", "azure", "beige",
    "bisque", "black", "blanchedalmond", "blue", "blueviolet", "brown",
    "burlywood", "cadetblue", "chartreuse", "chocolate", "coral", "cornflowerblue",
    "cornsilk", "crimson", "cyan", "darkblue", "darkcyan", "darkgoldenrod",
    "darkgray", "darkgreen", "darkkhaki", "darkmagenta", "darkolivegreen",
    "darkorange", "darkorchid", "darkred", "darksalmon", "darkseagreen",
    "darkslateblue", "darkslategray", "darkturquoise", "darkviolet",
    "deeppink", "deepskyblue", "dimgray", "dodgerblue", "firebrick",
    "floralwhite", "forestgreen", "fuchsia", "gainsboro", "ghostwhite",
    "gold", "goldenrod", "gray", "grey", "green", "greenyellow", "honeydew",
    "hotpink", "indianred", "indigo", "ivory", "khaki", "lavender",
    "lavenderblush", "lawngreen", "lemonchiffon", "lightblue", "lightcoral",
    "lightcyan", "lightgoldenrodyellow", "lightgray", "lightgreen", "lightpink",
    "lightsalmon", "lightseagreen", "lightskyblue", "lightslategray",
    "lightsteelblue", "lightyellow", "lime", "limegreen", "linen", "magenta",
    "maroon", "mediumaquamarine", "mediumblue", "mediumorchid", "mediumpurple",
    "mediumseagreen", "mediumslateblue", "mediumspringgreen", "mediumturquoise",
    "mediumvioletred", "midnightblue", "mintcream", "mistyrose", "moccasin",
    "navajowhite", "navy", "oldlace", "olive", "olivedrab", "orange", "orangered",
    "orchid", "palegoldenrod", "palegreen", "paleturquoise", "palevioletred",
    "papayawhip", "peachpuff", "peru", "pink", "plum", "powderblue",
    "purple", "rebeccapurple", "red", "rosybrown", "royalblue", "saddlebrown",
    "salmon", "sandybrown", "seagreen", "seashell", "sienna", "silver", "skyblue",
    "slateblue", "slategray", "snow", "springgreen", "steelblue", "tan",
    "teal", "thistle", "tomato", "turquoise", "violet", "wheat", "white",
    "whitesmoke", "yellow", "yellowgreen"
  ], colorKeywords = keySet(colorKeywords_);

  var valueKeywords_ = [
    "above", "absolute", "activeborder", "additive", "activecaption", "afar",
    "after-white-space", "ahead", "alias", "all", "all-scroll", "alphabetic", "alternate",
    "always", "amharic", "amharic-abegede", "antialiased", "appworkspace",
    "arabic-indic", "armenian", "asterisks", "attr", "auto", "auto-flow", "avoid", "avoid-column", "avoid-page",
    "avoid-region", "background", "backwards", "baseline", "below", "bidi-override", "binary",
    "bengali", "blink", "block", "block-axis", "bold", "bolder", "border", "border-box",
    "both", "bottom", "break", "break-all", "break-word", "bullets", "button", "button-bevel",
    "buttonface", "buttonhighlight", "buttonshadow", "buttontext", "calc", "cambodian",
    "capitalize", "caps-lock-indicator", "caption", "captiontext", "caret",
    "cell", "center", "checkbox", "circle", "cjk-decimal", "cjk-earthly-branch",
    "cjk-heavenly-stem", "cjk-ideographic", "clear", "clip", "close-quote",
    "col-resize", "collapse", "color", "color-burn", "color-dodge", "column", "column-reverse",
    "compact", "condensed", "contain", "content", "contents",
    "content-box", "context-menu", "continuous", "copy", "counter", "counters", "cover", "crop",
    "cross", "crosshair", "currentcolor", "cursive", "cyclic", "darken", "dashed", "decimal",
    "decimal-leading-zero", "default", "default-button", "dense", "destination-atop",
    "destination-in", "destination-out", "destination-over", "devanagari", "difference",
    "disc", "discard", "disclosure-closed", "disclosure-open", "document",
    "dot-dash", "dot-dot-dash",
    "dotted", "double", "down", "e-resize", "ease", "ease-in", "ease-in-out", "ease-out",
    "element", "ellipse", "ellipsis", "embed", "end", "ethiopic", "ethiopic-abegede",
    "ethiopic-abegede-am-et", "ethiopic-abegede-gez", "ethiopic-abegede-ti-er",
    "ethiopic-abegede-ti-et", "ethiopic-halehame-aa-er",
    "ethiopic-halehame-aa-et", "ethiopic-halehame-am-et",
    "ethiopic-halehame-gez", "ethiopic-halehame-om-et",
    "ethiopic-halehame-sid-et", "ethiopic-halehame-so-et",
    "ethiopic-halehame-ti-er", "ethiopic-halehame-ti-et", "ethiopic-halehame-tig",
    "ethiopic-numeric", "ew-resize", "exclusion", "expanded", "extends", "extra-condensed",
    "extra-expanded", "fantasy", "fast", "fill", "fixed", "flat", "flex", "flex-end", "flex-start", "footnotes",
    "forwards", "from", "geometricPrecision", "georgian", "graytext", "grid", "groove",
    "gujarati", "gurmukhi", "hand", "hangul", "hangul-consonant", "hard-light", "hebrew",
    "help", "hidden", "hide", "higher", "highlight", "highlighttext",
    "hiragana", "hiragana-iroha", "horizontal", "hsl", "hsla", "hue", "icon", "ignore",
    "inactiveborder", "inactivecaption", "inactivecaptiontext", "infinite",
    "infobackground", "infotext", "inherit", "initial", "inline", "inline-axis",
    "inline-block", "inline-flex", "inline-grid", "inline-table", "inset", "inside", "intrinsic", "invert",
    "italic", "japanese-formal", "japanese-informal", "justify", "kannada",
    "katakana", "katakana-iroha", "keep-all", "khmer",
    "korean-hangul-formal", "korean-hanja-formal", "korean-hanja-informal",
    "landscape", "lao", "large", "larger", "left", "level", "lighter", "lighten",
    "line-through", "linear", "linear-gradient", "lines", "list-item", "listbox", "listitem",
    "local", "logical", "loud", "lower", "lower-alpha", "lower-armenian",
    "lower-greek", "lower-hexadecimal", "lower-latin", "lower-norwegian",
    "lower-roman", "lowercase", "ltr", "luminosity", "malayalam", "match", "matrix", "matrix3d",
    "media-controls-background", "media-current-time-display",
    "media-fullscreen-button", "media-mute-button", "media-play-button",
    "media-return-to-realtime-button", "media-rewind-button",
    "media-seek-back-button", "media-seek-forward-button", "media-slider",
    "media-sliderthumb", "media-time-remaining-display", "media-volume-slider",
    "media-volume-slider-container", "media-volume-sliderthumb", "medium",
    "menu", "menulist", "menulist-button", "menulist-text",
    "menulist-textfield", "menutext", "message-box", "middle", "min-intrinsic",
    "mix", "mongolian", "monospace", "move", "multiple", "multiply", "myanmar", "n-resize",
    "narrower", "ne-resize", "nesw-resize", "no-close-quote", "no-drop",
    "no-open-quote", "no-repeat", "none", "normal", "not-allowed", "nowrap",
    "ns-resize", "numbers", "numeric", "nw-resize", "nwse-resize", "oblique", "octal", "opacity", "open-quote",
    "optimizeLegibility", "optimizeSpeed", "oriya", "oromo", "outset",
    "outside", "outside-shape", "overlay", "overline", "padding", "padding-box",
    "painted", "page", "paused", "persian", "perspective", "plus-darker", "plus-lighter",
    "pointer", "polygon", "portrait", "pre", "pre-line", "pre-wrap", "preserve-3d",
    "progress", "push-button", "radial-gradient", "radio", "read-only",
    "read-write", "read-write-plaintext-only", "rectangle", "region",
    "relative", "repeat", "repeating-linear-gradient",
    "repeating-radial-gradient", "repeat-x", "repeat-y", "reset", "reverse",
    "rgb", "rgba", "ridge", "right", "rotate", "rotate3d", "rotateX", "rotateY",
    "rotateZ", "round", "row", "row-resize", "row-reverse", "rtl", "run-in", "running",
    "s-resize", "sans-serif", "saturation", "scale", "scale3d", "scaleX", "scaleY", "scaleZ", "screen",
    "scroll", "scrollbar", "scroll-position", "se-resize", "searchfield",
    "searchfield-cancel-button", "searchfield-decoration",
    "searchfield-results-button", "searchfield-results-decoration", "self-start", "self-end",
    "semi-condensed", "semi-expanded", "separate", "serif", "show", "sidama",
    "simp-chinese-formal", "simp-chinese-informal", "single",
    "skew", "skewX", "skewY", "skip-white-space", "slide", "slider-horizontal",
    "slider-vertical", "sliderthumb-horizontal", "sliderthumb-vertical", "slow",
    "small", "small-caps", "small-caption", "smaller", "soft-light", "solid", "somali",
    "source-atop", "source-in", "source-out", "source-over", "space", "space-around", "space-between", "space-evenly", "spell-out", "square",
    "square-button", "start", "static", "status-bar", "stretch", "stroke", "sub",
    "subpixel-antialiased", "super", "sw-resize", "symbolic", "symbols", "system-ui", "table",
    "table-caption", "table-cell", "table-column", "table-column-group",
    "table-footer-group", "table-header-group", "table-row", "table-row-group",
    "tamil",
    "telugu", "text", "text-bottom", "text-top", "textarea", "textfield", "thai",
    "thick", "thin", "threeddarkshadow", "threedface", "threedhighlight",
    "threedlightshadow", "threedshadow", "tibetan", "tigre", "tigrinya-er",
    "tigrinya-er-abegede", "tigrinya-et", "tigrinya-et-abegede", "to", "top",
    "trad-chinese-formal", "trad-chinese-informal", "transform",
    "translate", "translate3d", "translateX", "translateY", "translateZ",
    "transparent", "ultra-condensed", "ultra-expanded", "underline", "unset", "up",
    "upper-alpha", "upper-armenian", "upper-greek", "upper-hexadecimal",
    "upper-latin", "upper-norwegian", "upper-roman", "uppercase", "urdu", "url",
    "var", "vertical", "vertical-text", "visible", "visibleFill", "visiblePainted",
    "visibleStroke", "visual", "w-resize", "wait", "wave", "wider",
    "window", "windowframe", "windowtext", "words", "wrap", "wrap-reverse", "x-large", "x-small", "xor",
    "xx-large", "xx-small"
  ], valueKeywords = keySet(valueKeywords_);

  var allWords = documentTypes_.concat(mediaTypes_).concat(mediaFeatures_).concat(mediaValueKeywords_)
    .concat(propertyKeywords_).concat(nonStandardPropertyKeywords_).concat(colorKeywords_)
    .concat(valueKeywords_);
  CodeMirror.registerHelper("hintWords", "css", allWords);

  function tokenCComment(stream, state) {
    var maybeEnd = false, ch;
    while ((ch = stream.next()) != null) {
      if (maybeEnd && ch == "/") {
        state.tokenize = null;
        break;
      }
      maybeEnd = (ch == "*");
    }
    return ["comment", "comment"];
  }

  CodeMirror.defineMIME("text/css", {
    documentTypes: documentTypes,
    mediaTypes: mediaTypes,
    mediaFeatures: mediaFeatures,
    mediaValueKeywords: mediaValueKeywords,
    propertyKeywords: propertyKeywords,
    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
    fontProperties: fontProperties,
    counterDescriptors: counterDescriptors,
    colorKeywords: colorKeywords,
    valueKeywords: valueKeywords,
    tokenHooks: {
      "/": function(stream, state) {
        if (!stream.eat("*")) return false;
        state.tokenize = tokenCComment;
        return tokenCComment(stream, state);
      }
    },
    name: "css"
  });

  CodeMirror.defineMIME("text/x-scss", {
    mediaTypes: mediaTypes,
    mediaFeatures: mediaFeatures,
    mediaValueKeywords: mediaValueKeywords,
    propertyKeywords: propertyKeywords,
    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
    colorKeywords: colorKeywords,
    valueKeywords: valueKeywords,
    fontProperties: fontProperties,
    allowNested: true,
    lineComment: "//",
    tokenHooks: {
      "/": function(stream, state) {
        if (stream.eat("/")) {
          stream.skipToEnd();
          return ["comment", "comment"];
        } else if (stream.eat("*")) {
          state.tokenize = tokenCComment;
          return tokenCComment(stream, state);
        } else {
          return ["operator", "operator"];
        }
      },
      ":": function(stream) {
        if (stream.match(/\s*\{/, false))
          return [null, null]
        return false;
      },
      "$": function(stream) {
        stream.match(/^[\w-]+/);
        if (stream.match(/^\s*:/, false))
          return ["variable-2", "variable-definition"];
        return ["variable-2", "variable"];
      },
      "#": function(stream) {
        if (!stream.eat("{")) return false;
        return [null, "interpolation"];
      }
    },
    name: "css",
    helperType: "scss"
  });

  CodeMirror.defineMIME("text/x-less", {
    mediaTypes: mediaTypes,
    mediaFeatures: mediaFeatures,
    mediaValueKeywords: mediaValueKeywords,
    propertyKeywords: propertyKeywords,
    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
    colorKeywords: colorKeywords,
    valueKeywords: valueKeywords,
    fontProperties: fontProperties,
    allowNested: true,
    lineComment: "//",
    tokenHooks: {
      "/": function(stream, state) {
        if (stream.eat("/")) {
          stream.skipToEnd();
          return ["comment", "comment"];
        } else if (stream.eat("*")) {
          state.tokenize = tokenCComment;
          return tokenCComment(stream, state);
        } else {
          return ["operator", "operator"];
        }
      },
      "@": function(stream) {
        if (stream.eat("{")) return [null, "interpolation"];
        if (stream.match(/^(charset|document|font-face|import|(-(moz|ms|o|webkit)-)?keyframes|media|namespace|page|supports)\b/, false)) return false;
        stream.eatWhile(/[\w\\\-]/);
        if (stream.match(/^\s*:/, false))
          return ["variable-2", "variable-definition"];
        return ["variable-2", "variable"];
      },
      "&": function() {
        return ["atom", "atom"];
      }
    },
    name: "css",
    helperType: "less"
  });

  CodeMirror.defineMIME("text/x-gss", {
    documentTypes: documentTypes,
    mediaTypes: mediaTypes,
    mediaFeatures: mediaFeatures,
    propertyKeywords: propertyKeywords,
    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
    fontProperties: fontProperties,
    counterDescriptors: counterDescriptors,
    colorKeywords: colorKeywords,
    valueKeywords: valueKeywords,
    supportsAtComponent: true,
    tokenHooks: {
      "/": function(stream, state) {
        if (!stream.eat("*")) return false;
        state.tokenize = tokenCComment;
        return tokenCComment(stream, state);
      }
    },
    name: "css",
    helperType: "gss"
  });

});


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: http://codemirror.net/LICENSE

(function(mod) {
  if (true) // CommonJS
    mod(__webpack_require__(32), __webpack_require__(208), __webpack_require__(207), __webpack_require__(205));
  else if (typeof define == "function" && define.amd) // AMD
    define(["../../lib/codemirror", "../xml/xml", "../javascript/javascript", "../css/css"], mod);
  else // Plain browser env
    mod(CodeMirror);
})(function(CodeMirror) {
  "use strict";

  var defaultTags = {
    script: [
      ["lang", /(javascript|babel)/i, "javascript"],
      ["type", /^(?:text|application)\/(?:x-)?(?:java|ecma)script$|^module$|^$/i, "javascript"],
      ["type", /./, "text/plain"],
      [null, null, "javascript"]
    ],
    style:  [
      ["lang", /^css$/i, "css"],
      ["type", /^(text\/)?(x-)?(stylesheet|css)$/i, "css"],
      ["type", /./, "text/plain"],
      [null, null, "css"]
    ]
  };

  function maybeBackup(stream, pat, style) {
    var cur = stream.current(), close = cur.search(pat);
    if (close > -1) {
      stream.backUp(cur.length - close);
    } else if (cur.match(/<\/?$/)) {
      stream.backUp(cur.length);
      if (!stream.match(pat, false)) stream.match(cur);
    }
    return style;
  }

  var attrRegexpCache = {};
  function getAttrRegexp(attr) {
    var regexp = attrRegexpCache[attr];
    if (regexp) return regexp;
    return attrRegexpCache[attr] = new RegExp("\\s+" + attr + "\\s*=\\s*('|\")?([^'\"]+)('|\")?\\s*");
  }

  function getAttrValue(text, attr) {
    var match = text.match(getAttrRegexp(attr))
    return match ? /^\s*(.*?)\s*$/.exec(match[2])[1] : ""
  }

  function getTagRegexp(tagName, anchored) {
    return new RegExp((anchored ? "^" : "") + "<\/\s*" + tagName + "\s*>", "i");
  }

  function addTags(from, to) {
    for (var tag in from) {
      var dest = to[tag] || (to[tag] = []);
      var source = from[tag];
      for (var i = source.length - 1; i >= 0; i--)
        dest.unshift(source[i])
    }
  }

  function findMatchingMode(tagInfo, tagText) {
    for (var i = 0; i < tagInfo.length; i++) {
      var spec = tagInfo[i];
      if (!spec[0] || spec[1].test(getAttrValue(tagText, spec[0]))) return spec[2];
    }
  }

  CodeMirror.defineMode("htmlmixed", function (config, parserConfig) {
    var htmlMode = CodeMirror.getMode(config, {
      name: "xml",
      htmlMode: true,
      multilineTagIndentFactor: parserConfig.multilineTagIndentFactor,
      multilineTagIndentPastTag: parserConfig.multilineTagIndentPastTag
    });

    var tags = {};
    var configTags = parserConfig && parserConfig.tags, configScript = parserConfig && parserConfig.scriptTypes;
    addTags(defaultTags, tags);
    if (configTags) addTags(configTags, tags);
    if (configScript) for (var i = configScript.length - 1; i >= 0; i--)
      tags.script.unshift(["type", configScript[i].matches, configScript[i].mode])

    function html(stream, state) {
      var style = htmlMode.token(stream, state.htmlState), tag = /\btag\b/.test(style), tagName
      if (tag && !/[<>\s\/]/.test(stream.current()) &&
          (tagName = state.htmlState.tagName && state.htmlState.tagName.toLowerCase()) &&
          tags.hasOwnProperty(tagName)) {
        state.inTag = tagName + " "
      } else if (state.inTag && tag && />$/.test(stream.current())) {
        var inTag = /^([\S]+) (.*)/.exec(state.inTag)
        state.inTag = null
        var modeSpec = stream.current() == ">" && findMatchingMode(tags[inTag[1]], inTag[2])
        var mode = CodeMirror.getMode(config, modeSpec)
        var endTagA = getTagRegexp(inTag[1], true), endTag = getTagRegexp(inTag[1], false);
        state.token = function (stream, state) {
          if (stream.match(endTagA, false)) {
            state.token = html;
            state.localState = state.localMode = null;
            return null;
          }
          return maybeBackup(stream, endTag, state.localMode.token(stream, state.localState));
        };
        state.localMode = mode;
        state.localState = CodeMirror.startState(mode, htmlMode.indent(state.htmlState, ""));
      } else if (state.inTag) {
        state.inTag += stream.current()
        if (stream.eol()) state.inTag += " "
      }
      return style;
    };

    return {
      startState: function () {
        var state = CodeMirror.startState(htmlMode);
        return {token: html, inTag: null, localMode: null, localState: null, htmlState: state};
      },

      copyState: function (state) {
        var local;
        if (state.localState) {
          local = CodeMirror.copyState(state.localMode, state.localState);
        }
        return {token: state.token, inTag: state.inTag,
                localMode: state.localMode, localState: local,
                htmlState: CodeMirror.copyState(htmlMode, state.htmlState)};
      },

      token: function (stream, state) {
        return state.token(stream, state);
      },

      indent: function (state, textAfter, line) {
        if (!state.localMode || /^\s*<\//.test(textAfter))
          return htmlMode.indent(state.htmlState, textAfter);
        else if (state.localMode.indent)
          return state.localMode.indent(state.localState, textAfter, line);
        else
          return CodeMirror.Pass;
      },

      innerMode: function (state) {
        return {state: state.localState || state.htmlState, mode: state.localMode || htmlMode};
      }
    };
  }, "xml", "javascript", "css");

  CodeMirror.defineMIME("text/html", "htmlmixed");
});


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: http://codemirror.net/LICENSE

(function(mod) {
  if (true) // CommonJS
    mod(__webpack_require__(32));
  else if (typeof define == "function" && define.amd) // AMD
    define(["../../lib/codemirror"], mod);
  else // Plain browser env
    mod(CodeMirror);
})(function(CodeMirror) {
"use strict";

function expressionAllowed(stream, state, backUp) {
  return /^(?:operator|sof|keyword c|case|new|export|default|[\[{}\(,;:]|=>)$/.test(state.lastType) ||
    (state.lastType == "quasi" && /\{\s*$/.test(stream.string.slice(0, stream.pos - (backUp || 0))))
}

CodeMirror.defineMode("javascript", function(config, parserConfig) {
  var indentUnit = config.indentUnit;
  var statementIndent = parserConfig.statementIndent;
  var jsonldMode = parserConfig.jsonld;
  var jsonMode = parserConfig.json || jsonldMode;
  var isTS = parserConfig.typescript;
  var wordRE = parserConfig.wordCharacters || /[\w$\xa1-\uffff]/;

  // Tokenizer

  var keywords = function(){
    function kw(type) {return {type: type, style: "keyword"};}
    var A = kw("keyword a"), B = kw("keyword b"), C = kw("keyword c");
    var operator = kw("operator"), atom = {type: "atom", style: "atom"};

    var jsKeywords = {
      "if": kw("if"), "while": A, "with": A, "else": B, "do": B, "try": B, "finally": B,
      "return": C, "break": C, "continue": C, "new": kw("new"), "delete": C, "throw": C, "debugger": C,
      "var": kw("var"), "const": kw("var"), "let": kw("var"),
      "function": kw("function"), "catch": kw("catch"),
      "for": kw("for"), "switch": kw("switch"), "case": kw("case"), "default": kw("default"),
      "in": operator, "typeof": operator, "instanceof": operator,
      "true": atom, "false": atom, "null": atom, "undefined": atom, "NaN": atom, "Infinity": atom,
      "this": kw("this"), "class": kw("class"), "super": kw("atom"),
      "yield": C, "export": kw("export"), "import": kw("import"), "extends": C,
      "await": C
    };

    // Extend the 'normal' keywords with the TypeScript language extensions
    if (isTS) {
      var type = {type: "variable", style: "type"};
      var tsKeywords = {
        // object-like things
        "interface": kw("class"),
        "implements": C,
        "namespace": C,
        "module": kw("module"),
        "enum": kw("module"),

        // scope modifiers
        "public": kw("modifier"),
        "private": kw("modifier"),
        "protected": kw("modifier"),
        "abstract": kw("modifier"),

        // types
        "string": type, "number": type, "boolean": type, "any": type
      };

      for (var attr in tsKeywords) {
        jsKeywords[attr] = tsKeywords[attr];
      }
    }

    return jsKeywords;
  }();

  var isOperatorChar = /[+\-*&%=<>!?|~^@]/;
  var isJsonldKeyword = /^@(context|id|value|language|type|container|list|set|reverse|index|base|vocab|graph)"/;

  function readRegexp(stream) {
    var escaped = false, next, inSet = false;
    while ((next = stream.next()) != null) {
      if (!escaped) {
        if (next == "/" && !inSet) return;
        if (next == "[") inSet = true;
        else if (inSet && next == "]") inSet = false;
      }
      escaped = !escaped && next == "\\";
    }
  }

  // Used as scratch variables to communicate multiple values without
  // consing up tons of objects.
  var type, content;
  function ret(tp, style, cont) {
    type = tp; content = cont;
    return style;
  }
  function tokenBase(stream, state) {
    var ch = stream.next();
    if (ch == '"' || ch == "'") {
      state.tokenize = tokenString(ch);
      return state.tokenize(stream, state);
    } else if (ch == "." && stream.match(/^\d+(?:[eE][+\-]?\d+)?/)) {
      return ret("number", "number");
    } else if (ch == "." && stream.match("..")) {
      return ret("spread", "meta");
    } else if (/[\[\]{}\(\),;\:\.]/.test(ch)) {
      return ret(ch);
    } else if (ch == "=" && stream.eat(">")) {
      return ret("=>", "operator");
    } else if (ch == "0" && stream.eat(/x/i)) {
      stream.eatWhile(/[\da-f]/i);
      return ret("number", "number");
    } else if (ch == "0" && stream.eat(/o/i)) {
      stream.eatWhile(/[0-7]/i);
      return ret("number", "number");
    } else if (ch == "0" && stream.eat(/b/i)) {
      stream.eatWhile(/[01]/i);
      return ret("number", "number");
    } else if (/\d/.test(ch)) {
      stream.match(/^\d*(?:\.\d*)?(?:[eE][+\-]?\d+)?/);
      return ret("number", "number");
    } else if (ch == "/") {
      if (stream.eat("*")) {
        state.tokenize = tokenComment;
        return tokenComment(stream, state);
      } else if (stream.eat("/")) {
        stream.skipToEnd();
        return ret("comment", "comment");
      } else if (expressionAllowed(stream, state, 1)) {
        readRegexp(stream);
        stream.match(/^\b(([gimyu])(?![gimyu]*\2))+\b/);
        return ret("regexp", "string-2");
      } else {
        stream.eatWhile(isOperatorChar);
        return ret("operator", "operator", stream.current());
      }
    } else if (ch == "`") {
      state.tokenize = tokenQuasi;
      return tokenQuasi(stream, state);
    } else if (ch == "#") {
      stream.skipToEnd();
      return ret("error", "error");
    } else if (isOperatorChar.test(ch)) {
      if (ch != ">" || !state.lexical || state.lexical.type != ">")
        stream.eatWhile(isOperatorChar);
      return ret("operator", "operator", stream.current());
    } else if (wordRE.test(ch)) {
      stream.eatWhile(wordRE);
      var word = stream.current()
      if (state.lastType != ".") {
        if (keywords.propertyIsEnumerable(word)) {
          var kw = keywords[word]
          return ret(kw.type, kw.style, word)
        }
        if (word == "async" && stream.match(/^\s*[\(\w]/, false))
          return ret("async", "keyword", word)
      }
      return ret("variable", "variable", word)
    }
  }

  function tokenString(quote) {
    return function(stream, state) {
      var escaped = false, next;
      if (jsonldMode && stream.peek() == "@" && stream.match(isJsonldKeyword)){
        state.tokenize = tokenBase;
        return ret("jsonld-keyword", "meta");
      }
      while ((next = stream.next()) != null) {
        if (next == quote && !escaped) break;
        escaped = !escaped && next == "\\";
      }
      if (!escaped) state.tokenize = tokenBase;
      return ret("string", "string");
    };
  }

  function tokenComment(stream, state) {
    var maybeEnd = false, ch;
    while (ch = stream.next()) {
      if (ch == "/" && maybeEnd) {
        state.tokenize = tokenBase;
        break;
      }
      maybeEnd = (ch == "*");
    }
    return ret("comment", "comment");
  }

  function tokenQuasi(stream, state) {
    var escaped = false, next;
    while ((next = stream.next()) != null) {
      if (!escaped && (next == "`" || next == "$" && stream.eat("{"))) {
        state.tokenize = tokenBase;
        break;
      }
      escaped = !escaped && next == "\\";
    }
    return ret("quasi", "string-2", stream.current());
  }

  var brackets = "([{}])";
  // This is a crude lookahead trick to try and notice that we're
  // parsing the argument patterns for a fat-arrow function before we
  // actually hit the arrow token. It only works if the arrow is on
  // the same line as the arguments and there's no strange noise
  // (comments) in between. Fallback is to only notice when we hit the
  // arrow, and not declare the arguments as locals for the arrow
  // body.
  function findFatArrow(stream, state) {
    if (state.fatArrowAt) state.fatArrowAt = null;
    var arrow = stream.string.indexOf("=>", stream.start);
    if (arrow < 0) return;

    if (isTS) { // Try to skip TypeScript return type declarations after the arguments
      var m = /:\s*(?:\w+(?:<[^>]*>|\[\])?|\{[^}]*\})\s*$/.exec(stream.string.slice(stream.start, arrow))
      if (m) arrow = m.index
    }

    var depth = 0, sawSomething = false;
    for (var pos = arrow - 1; pos >= 0; --pos) {
      var ch = stream.string.charAt(pos);
      var bracket = brackets.indexOf(ch);
      if (bracket >= 0 && bracket < 3) {
        if (!depth) { ++pos; break; }
        if (--depth == 0) { if (ch == "(") sawSomething = true; break; }
      } else if (bracket >= 3 && bracket < 6) {
        ++depth;
      } else if (wordRE.test(ch)) {
        sawSomething = true;
      } else if (/["'\/]/.test(ch)) {
        return;
      } else if (sawSomething && !depth) {
        ++pos;
        break;
      }
    }
    if (sawSomething && !depth) state.fatArrowAt = pos;
  }

  // Parser

  var atomicTypes = {"atom": true, "number": true, "variable": true, "string": true, "regexp": true, "this": true, "jsonld-keyword": true};

  function JSLexical(indented, column, type, align, prev, info) {
    this.indented = indented;
    this.column = column;
    this.type = type;
    this.prev = prev;
    this.info = info;
    if (align != null) this.align = align;
  }

  function inScope(state, varname) {
    for (var v = state.localVars; v; v = v.next)
      if (v.name == varname) return true;
    for (var cx = state.context; cx; cx = cx.prev) {
      for (var v = cx.vars; v; v = v.next)
        if (v.name == varname) return true;
    }
  }

  function parseJS(state, style, type, content, stream) {
    var cc = state.cc;
    // Communicate our context to the combinators.
    // (Less wasteful than consing up a hundred closures on every call.)
    cx.state = state; cx.stream = stream; cx.marked = null, cx.cc = cc; cx.style = style;

    if (!state.lexical.hasOwnProperty("align"))
      state.lexical.align = true;

    while(true) {
      var combinator = cc.length ? cc.pop() : jsonMode ? expression : statement;
      if (combinator(type, content)) {
        while(cc.length && cc[cc.length - 1].lex)
          cc.pop()();
        if (cx.marked) return cx.marked;
        if (type == "variable" && inScope(state, content)) return "variable-2";
        return style;
      }
    }
  }

  // Combinator utils

  var cx = {state: null, column: null, marked: null, cc: null};
  function pass() {
    for (var i = arguments.length - 1; i >= 0; i--) cx.cc.push(arguments[i]);
  }
  function cont() {
    pass.apply(null, arguments);
    return true;
  }
  function register(varname) {
    function inList(list) {
      for (var v = list; v; v = v.next)
        if (v.name == varname) return true;
      return false;
    }
    var state = cx.state;
    cx.marked = "def";
    if (state.context) {
      if (inList(state.localVars)) return;
      state.localVars = {name: varname, next: state.localVars};
    } else {
      if (inList(state.globalVars)) return;
      if (parserConfig.globalVars)
        state.globalVars = {name: varname, next: state.globalVars};
    }
  }

  // Combinators

  var defaultVars = {name: "this", next: {name: "arguments"}};
  function pushcontext() {
    cx.state.context = {prev: cx.state.context, vars: cx.state.localVars};
    cx.state.localVars = defaultVars;
  }
  function popcontext() {
    cx.state.localVars = cx.state.context.vars;
    cx.state.context = cx.state.context.prev;
  }
  function pushlex(type, info) {
    var result = function() {
      var state = cx.state, indent = state.indented;
      if (state.lexical.type == "stat") indent = state.lexical.indented;
      else for (var outer = state.lexical; outer && outer.type == ")" && outer.align; outer = outer.prev)
        indent = outer.indented;
      state.lexical = new JSLexical(indent, cx.stream.column(), type, null, state.lexical, info);
    };
    result.lex = true;
    return result;
  }
  function poplex() {
    var state = cx.state;
    if (state.lexical.prev) {
      if (state.lexical.type == ")")
        state.indented = state.lexical.indented;
      state.lexical = state.lexical.prev;
    }
  }
  poplex.lex = true;

  function expect(wanted) {
    function exp(type) {
      if (type == wanted) return cont();
      else if (wanted == ";") return pass();
      else return cont(exp);
    };
    return exp;
  }

  function statement(type, value) {
    if (type == "var") return cont(pushlex("vardef", value.length), vardef, expect(";"), poplex);
    if (type == "keyword a") return cont(pushlex("form"), parenExpr, statement, poplex);
    if (type == "keyword b") return cont(pushlex("form"), statement, poplex);
    if (type == "{") return cont(pushlex("}"), block, poplex);
    if (type == ";") return cont();
    if (type == "if") {
      if (cx.state.lexical.info == "else" && cx.state.cc[cx.state.cc.length - 1] == poplex)
        cx.state.cc.pop()();
      return cont(pushlex("form"), parenExpr, statement, poplex, maybeelse);
    }
    if (type == "function") return cont(functiondef);
    if (type == "for") return cont(pushlex("form"), forspec, statement, poplex);
    if (type == "variable") {
      if (isTS && value == "type") {
        cx.marked = "keyword"
        return cont(typeexpr, expect("operator"), typeexpr, expect(";"));
      } else {
        return cont(pushlex("stat"), maybelabel);
      }
    }
    if (type == "switch") return cont(pushlex("form"), parenExpr, expect("{"), pushlex("}", "switch"),
                                      block, poplex, poplex);
    if (type == "case") return cont(expression, expect(":"));
    if (type == "default") return cont(expect(":"));
    if (type == "catch") return cont(pushlex("form"), pushcontext, expect("("), funarg, expect(")"),
                                     statement, poplex, popcontext);
    if (type == "class") return cont(pushlex("form"), className, poplex);
    if (type == "export") return cont(pushlex("stat"), afterExport, poplex);
    if (type == "import") return cont(pushlex("stat"), afterImport, poplex);
    if (type == "module") return cont(pushlex("form"), pattern, expect("{"), pushlex("}"), block, poplex, poplex)
    if (type == "async") return cont(statement)
    if (value == "@") return cont(expression, statement)
    return pass(pushlex("stat"), expression, expect(";"), poplex);
  }
  function expression(type) {
    return expressionInner(type, false);
  }
  function expressionNoComma(type) {
    return expressionInner(type, true);
  }
  function parenExpr(type) {
    if (type != "(") return pass()
    return cont(pushlex(")"), expression, expect(")"), poplex)
  }
  function expressionInner(type, noComma) {
    if (cx.state.fatArrowAt == cx.stream.start) {
      var body = noComma ? arrowBodyNoComma : arrowBody;
      if (type == "(") return cont(pushcontext, pushlex(")"), commasep(pattern, ")"), poplex, expect("=>"), body, popcontext);
      else if (type == "variable") return pass(pushcontext, pattern, expect("=>"), body, popcontext);
    }

    var maybeop = noComma ? maybeoperatorNoComma : maybeoperatorComma;
    if (atomicTypes.hasOwnProperty(type)) return cont(maybeop);
    if (type == "function") return cont(functiondef, maybeop);
    if (type == "class") return cont(pushlex("form"), classExpression, poplex);
    if (type == "keyword c" || type == "async") return cont(noComma ? maybeexpressionNoComma : maybeexpression);
    if (type == "(") return cont(pushlex(")"), maybeexpression, expect(")"), poplex, maybeop);
    if (type == "operator" || type == "spread") return cont(noComma ? expressionNoComma : expression);
    if (type == "[") return cont(pushlex("]"), arrayLiteral, poplex, maybeop);
    if (type == "{") return contCommasep(objprop, "}", null, maybeop);
    if (type == "quasi") return pass(quasi, maybeop);
    if (type == "new") return cont(maybeTarget(noComma));
    return cont();
  }
  function maybeexpression(type) {
    if (type.match(/[;\}\)\],]/)) return pass();
    return pass(expression);
  }
  function maybeexpressionNoComma(type) {
    if (type.match(/[;\}\)\],]/)) return pass();
    return pass(expressionNoComma);
  }

  function maybeoperatorComma(type, value) {
    if (type == ",") return cont(expression);
    return maybeoperatorNoComma(type, value, false);
  }
  function maybeoperatorNoComma(type, value, noComma) {
    var me = noComma == false ? maybeoperatorComma : maybeoperatorNoComma;
    var expr = noComma == false ? expression : expressionNoComma;
    if (type == "=>") return cont(pushcontext, noComma ? arrowBodyNoComma : arrowBody, popcontext);
    if (type == "operator") {
      if (/\+\+|--/.test(value)) return cont(me);
      if (value == "?") return cont(expression, expect(":"), expr);
      return cont(expr);
    }
    if (type == "quasi") { return pass(quasi, me); }
    if (type == ";") return;
    if (type == "(") return contCommasep(expressionNoComma, ")", "call", me);
    if (type == ".") return cont(property, me);
    if (type == "[") return cont(pushlex("]"), maybeexpression, expect("]"), poplex, me);
    if (isTS && value == "as") { cx.marked = "keyword"; return cont(typeexpr, me) }
  }
  function quasi(type, value) {
    if (type != "quasi") return pass();
    if (value.slice(value.length - 2) != "${") return cont(quasi);
    return cont(expression, continueQuasi);
  }
  function continueQuasi(type) {
    if (type == "}") {
      cx.marked = "string-2";
      cx.state.tokenize = tokenQuasi;
      return cont(quasi);
    }
  }
  function arrowBody(type) {
    findFatArrow(cx.stream, cx.state);
    return pass(type == "{" ? statement : expression);
  }
  function arrowBodyNoComma(type) {
    findFatArrow(cx.stream, cx.state);
    return pass(type == "{" ? statement : expressionNoComma);
  }
  function maybeTarget(noComma) {
    return function(type) {
      if (type == ".") return cont(noComma ? targetNoComma : target);
      else return pass(noComma ? expressionNoComma : expression);
    };
  }
  function target(_, value) {
    if (value == "target") { cx.marked = "keyword"; return cont(maybeoperatorComma); }
  }
  function targetNoComma(_, value) {
    if (value == "target") { cx.marked = "keyword"; return cont(maybeoperatorNoComma); }
  }
  function maybelabel(type) {
    if (type == ":") return cont(poplex, statement);
    return pass(maybeoperatorComma, expect(";"), poplex);
  }
  function property(type) {
    if (type == "variable") {cx.marked = "property"; return cont();}
  }
  function objprop(type, value) {
    if (type == "async") {
      cx.marked = "property";
      return cont(objprop);
    } else if (type == "variable" || cx.style == "keyword") {
      cx.marked = "property";
      if (value == "get" || value == "set") return cont(getterSetter);
      return cont(afterprop);
    } else if (type == "number" || type == "string") {
      cx.marked = jsonldMode ? "property" : (cx.style + " property");
      return cont(afterprop);
    } else if (type == "jsonld-keyword") {
      return cont(afterprop);
    } else if (type == "modifier") {
      return cont(objprop)
    } else if (type == "[") {
      return cont(expression, expect("]"), afterprop);
    } else if (type == "spread") {
      return cont(expression, afterprop);
    } else if (type == ":") {
      return pass(afterprop)
    }
  }
  function getterSetter(type) {
    if (type != "variable") return pass(afterprop);
    cx.marked = "property";
    return cont(functiondef);
  }
  function afterprop(type) {
    if (type == ":") return cont(expressionNoComma);
    if (type == "(") return pass(functiondef);
  }
  function commasep(what, end, sep) {
    function proceed(type, value) {
      if (sep ? sep.indexOf(type) > -1 : type == ",") {
        var lex = cx.state.lexical;
        if (lex.info == "call") lex.pos = (lex.pos || 0) + 1;
        return cont(function(type, value) {
          if (type == end || value == end) return pass()
          return pass(what)
        }, proceed);
      }
      if (type == end || value == end) return cont();
      return cont(expect(end));
    }
    return function(type, value) {
      if (type == end || value == end) return cont();
      return pass(what, proceed);
    };
  }
  function contCommasep(what, end, info) {
    for (var i = 3; i < arguments.length; i++)
      cx.cc.push(arguments[i]);
    return cont(pushlex(end, info), commasep(what, end), poplex);
  }
  function block(type) {
    if (type == "}") return cont();
    return pass(statement, block);
  }
  function maybetype(type, value) {
    if (isTS) {
      if (type == ":") return cont(typeexpr);
      if (value == "?") return cont(maybetype);
    }
  }
  function typeexpr(type) {
    if (type == "variable") {cx.marked = "type"; return cont(afterType);}
    if (type == "string" || type == "number" || type == "atom") return cont(afterType);
    if (type == "{") return cont(pushlex("}"), commasep(typeprop, "}", ",;"), poplex, afterType)
    if (type == "(") return cont(commasep(typearg, ")"), maybeReturnType)
  }
  function maybeReturnType(type) {
    if (type == "=>") return cont(typeexpr)
  }
  function typeprop(type, value) {
    if (type == "variable" || cx.style == "keyword") {
      cx.marked = "property"
      return cont(typeprop)
    } else if (value == "?") {
      return cont(typeprop)
    } else if (type == ":") {
      return cont(typeexpr)
    } else if (type == "[") {
      return cont(expression, maybetype, expect("]"), typeprop)
    }
  }
  function typearg(type) {
    if (type == "variable") return cont(typearg)
    else if (type == ":") return cont(typeexpr)
  }
  function afterType(type, value) {
    if (value == "<") return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, afterType)
    if (value == "|" || type == ".") return cont(typeexpr)
    if (type == "[") return cont(expect("]"), afterType)
    if (value == "extends") return cont(typeexpr)
  }
  function vardef() {
    return pass(pattern, maybetype, maybeAssign, vardefCont);
  }
  function pattern(type, value) {
    if (type == "modifier") return cont(pattern)
    if (type == "variable") { register(value); return cont(); }
    if (type == "spread") return cont(pattern);
    if (type == "[") return contCommasep(pattern, "]");
    if (type == "{") return contCommasep(proppattern, "}");
  }
  function proppattern(type, value) {
    if (type == "variable" && !cx.stream.match(/^\s*:/, false)) {
      register(value);
      return cont(maybeAssign);
    }
    if (type == "variable") cx.marked = "property";
    if (type == "spread") return cont(pattern);
    if (type == "}") return pass();
    return cont(expect(":"), pattern, maybeAssign);
  }
  function maybeAssign(_type, value) {
    if (value == "=") return cont(expressionNoComma);
  }
  function vardefCont(type) {
    if (type == ",") return cont(vardef);
  }
  function maybeelse(type, value) {
    if (type == "keyword b" && value == "else") return cont(pushlex("form", "else"), statement, poplex);
  }
  function forspec(type) {
    if (type == "(") return cont(pushlex(")"), forspec1, expect(")"), poplex);
  }
  function forspec1(type) {
    if (type == "var") return cont(vardef, expect(";"), forspec2);
    if (type == ";") return cont(forspec2);
    if (type == "variable") return cont(formaybeinof);
    return pass(expression, expect(";"), forspec2);
  }
  function formaybeinof(_type, value) {
    if (value == "in" || value == "of") { cx.marked = "keyword"; return cont(expression); }
    return cont(maybeoperatorComma, forspec2);
  }
  function forspec2(type, value) {
    if (type == ";") return cont(forspec3);
    if (value == "in" || value == "of") { cx.marked = "keyword"; return cont(expression); }
    return pass(expression, expect(";"), forspec3);
  }
  function forspec3(type) {
    if (type != ")") cont(expression);
  }
  function functiondef(type, value) {
    if (value == "*") {cx.marked = "keyword"; return cont(functiondef);}
    if (type == "variable") {register(value); return cont(functiondef);}
    if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, maybetype, statement, popcontext);
    if (isTS && value == "<") return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, functiondef)
  }
  function funarg(type) {
    if (type == "spread") return cont(funarg);
    return pass(pattern, maybetype, maybeAssign);
  }
  function classExpression(type, value) {
    // Class expressions may have an optional name.
    if (type == "variable") return className(type, value);
    return classNameAfter(type, value);
  }
  function className(type, value) {
    if (type == "variable") {register(value); return cont(classNameAfter);}
  }
  function classNameAfter(type, value) {
    if (value == "<") return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, classNameAfter)
    if (value == "extends" || value == "implements" || (isTS && type == ","))
      return cont(isTS ? typeexpr : expression, classNameAfter);
    if (type == "{") return cont(pushlex("}"), classBody, poplex);
  }
  function classBody(type, value) {
    if (type == "variable" || cx.style == "keyword") {
      if ((value == "async" || value == "static" || value == "get" || value == "set" ||
           (isTS && (value == "public" || value == "private" || value == "protected" || value == "readonly" || value == "abstract"))) &&
          cx.stream.match(/^\s+[\w$\xa1-\uffff]/, false)) {
        cx.marked = "keyword";
        return cont(classBody);
      }
      cx.marked = "property";
      return cont(isTS ? classfield : functiondef, classBody);
    }
    if (type == "[")
      return cont(expression, expect("]"), isTS ? classfield : functiondef, classBody)
    if (value == "*") {
      cx.marked = "keyword";
      return cont(classBody);
    }
    if (type == ";") return cont(classBody);
    if (type == "}") return cont();
    if (value == "@") return cont(expression, classBody)
  }
  function classfield(type, value) {
    if (value == "?") return cont(classfield)
    if (type == ":") return cont(typeexpr, maybeAssign)
    if (value == "=") return cont(expressionNoComma)
    return pass(functiondef)
  }
  function afterExport(type, value) {
    if (value == "*") { cx.marked = "keyword"; return cont(maybeFrom, expect(";")); }
    if (value == "default") { cx.marked = "keyword"; return cont(expression, expect(";")); }
    if (type == "{") return cont(commasep(exportField, "}"), maybeFrom, expect(";"));
    return pass(statement);
  }
  function exportField(type, value) {
    if (value == "as") { cx.marked = "keyword"; return cont(expect("variable")); }
    if (type == "variable") return pass(expressionNoComma, exportField);
  }
  function afterImport(type) {
    if (type == "string") return cont();
    return pass(importSpec, maybeMoreImports, maybeFrom);
  }
  function importSpec(type, value) {
    if (type == "{") return contCommasep(importSpec, "}");
    if (type == "variable") register(value);
    if (value == "*") cx.marked = "keyword";
    return cont(maybeAs);
  }
  function maybeMoreImports(type) {
    if (type == ",") return cont(importSpec, maybeMoreImports)
  }
  function maybeAs(_type, value) {
    if (value == "as") { cx.marked = "keyword"; return cont(importSpec); }
  }
  function maybeFrom(_type, value) {
    if (value == "from") { cx.marked = "keyword"; return cont(expression); }
  }
  function arrayLiteral(type) {
    if (type == "]") return cont();
    return pass(commasep(expressionNoComma, "]"));
  }

  function isContinuedStatement(state, textAfter) {
    return state.lastType == "operator" || state.lastType == "," ||
      isOperatorChar.test(textAfter.charAt(0)) ||
      /[,.]/.test(textAfter.charAt(0));
  }

  // Interface

  return {
    startState: function(basecolumn) {
      var state = {
        tokenize: tokenBase,
        lastType: "sof",
        cc: [],
        lexical: new JSLexical((basecolumn || 0) - indentUnit, 0, "block", false),
        localVars: parserConfig.localVars,
        context: parserConfig.localVars && {vars: parserConfig.localVars},
        indented: basecolumn || 0
      };
      if (parserConfig.globalVars && typeof parserConfig.globalVars == "object")
        state.globalVars = parserConfig.globalVars;
      return state;
    },

    token: function(stream, state) {
      if (stream.sol()) {
        if (!state.lexical.hasOwnProperty("align"))
          state.lexical.align = false;
        state.indented = stream.indentation();
        findFatArrow(stream, state);
      }
      if (state.tokenize != tokenComment && stream.eatSpace()) return null;
      var style = state.tokenize(stream, state);
      if (type == "comment") return style;
      state.lastType = type == "operator" && (content == "++" || content == "--") ? "incdec" : type;
      return parseJS(state, style, type, content, stream);
    },

    indent: function(state, textAfter) {
      if (state.tokenize == tokenComment) return CodeMirror.Pass;
      if (state.tokenize != tokenBase) return 0;
      var firstChar = textAfter && textAfter.charAt(0), lexical = state.lexical, top
      // Kludge to prevent 'maybelse' from blocking lexical scope pops
      if (!/^\s*else\b/.test(textAfter)) for (var i = state.cc.length - 1; i >= 0; --i) {
        var c = state.cc[i];
        if (c == poplex) lexical = lexical.prev;
        else if (c != maybeelse) break;
      }
      while ((lexical.type == "stat" || lexical.type == "form") &&
             (firstChar == "}" || ((top = state.cc[state.cc.length - 1]) &&
                                   (top == maybeoperatorComma || top == maybeoperatorNoComma) &&
                                   !/^[,\.=+\-*:?[\(]/.test(textAfter))))
        lexical = lexical.prev;
      if (statementIndent && lexical.type == ")" && lexical.prev.type == "stat")
        lexical = lexical.prev;
      var type = lexical.type, closing = firstChar == type;

      if (type == "vardef") return lexical.indented + (state.lastType == "operator" || state.lastType == "," ? lexical.info + 1 : 0);
      else if (type == "form" && firstChar == "{") return lexical.indented;
      else if (type == "form") return lexical.indented + indentUnit;
      else if (type == "stat")
        return lexical.indented + (isContinuedStatement(state, textAfter) ? statementIndent || indentUnit : 0);
      else if (lexical.info == "switch" && !closing && parserConfig.doubleIndentSwitch != false)
        return lexical.indented + (/^(?:case|default)\b/.test(textAfter) ? indentUnit : 2 * indentUnit);
      else if (lexical.align) return lexical.column + (closing ? 0 : 1);
      else return lexical.indented + (closing ? 0 : indentUnit);
    },

    electricInput: /^\s*(?:case .*?:|default:|\{|\})$/,
    blockCommentStart: jsonMode ? null : "/*",
    blockCommentEnd: jsonMode ? null : "*/",
    lineComment: jsonMode ? null : "//",
    fold: "brace",
    closeBrackets: "()[]{}''\"\"``",

    helperType: jsonMode ? "json" : "javascript",
    jsonldMode: jsonldMode,
    jsonMode: jsonMode,

    expressionAllowed: expressionAllowed,
    skipExpression: function(state) {
      var top = state.cc[state.cc.length - 1]
      if (top == expression || top == expressionNoComma) state.cc.pop()
    }
  };
});

CodeMirror.registerHelper("wordChars", "javascript", /[\w$]/);

CodeMirror.defineMIME("text/javascript", "javascript");
CodeMirror.defineMIME("text/ecmascript", "javascript");
CodeMirror.defineMIME("application/javascript", "javascript");
CodeMirror.defineMIME("application/x-javascript", "javascript");
CodeMirror.defineMIME("application/ecmascript", "javascript");
CodeMirror.defineMIME("application/json", {name: "javascript", json: true});
CodeMirror.defineMIME("application/x-json", {name: "javascript", json: true});
CodeMirror.defineMIME("application/ld+json", {name: "javascript", jsonld: true});
CodeMirror.defineMIME("text/typescript", { name: "javascript", typescript: true });
CodeMirror.defineMIME("application/typescript", { name: "javascript", typescript: true });

});


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: http://codemirror.net/LICENSE

(function(mod) {
  if (true) // CommonJS
    mod(__webpack_require__(32));
  else if (typeof define == "function" && define.amd) // AMD
    define(["../../lib/codemirror"], mod);
  else // Plain browser env
    mod(CodeMirror);
})(function(CodeMirror) {
"use strict";

var htmlConfig = {
  autoSelfClosers: {'area': true, 'base': true, 'br': true, 'col': true, 'command': true,
                    'embed': true, 'frame': true, 'hr': true, 'img': true, 'input': true,
                    'keygen': true, 'link': true, 'meta': true, 'param': true, 'source': true,
                    'track': true, 'wbr': true, 'menuitem': true},
  implicitlyClosed: {'dd': true, 'li': true, 'optgroup': true, 'option': true, 'p': true,
                     'rp': true, 'rt': true, 'tbody': true, 'td': true, 'tfoot': true,
                     'th': true, 'tr': true},
  contextGrabbers: {
    'dd': {'dd': true, 'dt': true},
    'dt': {'dd': true, 'dt': true},
    'li': {'li': true},
    'option': {'option': true, 'optgroup': true},
    'optgroup': {'optgroup': true},
    'p': {'address': true, 'article': true, 'aside': true, 'blockquote': true, 'dir': true,
          'div': true, 'dl': true, 'fieldset': true, 'footer': true, 'form': true,
          'h1': true, 'h2': true, 'h3': true, 'h4': true, 'h5': true, 'h6': true,
          'header': true, 'hgroup': true, 'hr': true, 'menu': true, 'nav': true, 'ol': true,
          'p': true, 'pre': true, 'section': true, 'table': true, 'ul': true},
    'rp': {'rp': true, 'rt': true},
    'rt': {'rp': true, 'rt': true},
    'tbody': {'tbody': true, 'tfoot': true},
    'td': {'td': true, 'th': true},
    'tfoot': {'tbody': true},
    'th': {'td': true, 'th': true},
    'thead': {'tbody': true, 'tfoot': true},
    'tr': {'tr': true}
  },
  doNotIndent: {"pre": true},
  allowUnquoted: true,
  allowMissing: true,
  caseFold: true
}

var xmlConfig = {
  autoSelfClosers: {},
  implicitlyClosed: {},
  contextGrabbers: {},
  doNotIndent: {},
  allowUnquoted: false,
  allowMissing: false,
  caseFold: false
}

CodeMirror.defineMode("xml", function(editorConf, config_) {
  var indentUnit = editorConf.indentUnit
  var config = {}
  var defaults = config_.htmlMode ? htmlConfig : xmlConfig
  for (var prop in defaults) config[prop] = defaults[prop]
  for (var prop in config_) config[prop] = config_[prop]

  // Return variables for tokenizers
  var type, setStyle;

  function inText(stream, state) {
    function chain(parser) {
      state.tokenize = parser;
      return parser(stream, state);
    }

    var ch = stream.next();
    if (ch == "<") {
      if (stream.eat("!")) {
        if (stream.eat("[")) {
          if (stream.match("CDATA[")) return chain(inBlock("atom", "]]>"));
          else return null;
        } else if (stream.match("--")) {
          return chain(inBlock("comment", "-->"));
        } else if (stream.match("DOCTYPE", true, true)) {
          stream.eatWhile(/[\w\._\-]/);
          return chain(doctype(1));
        } else {
          return null;
        }
      } else if (stream.eat("?")) {
        stream.eatWhile(/[\w\._\-]/);
        state.tokenize = inBlock("meta", "?>");
        return "meta";
      } else {
        type = stream.eat("/") ? "closeTag" : "openTag";
        state.tokenize = inTag;
        return "tag bracket";
      }
    } else if (ch == "&") {
      var ok;
      if (stream.eat("#")) {
        if (stream.eat("x")) {
          ok = stream.eatWhile(/[a-fA-F\d]/) && stream.eat(";");
        } else {
          ok = stream.eatWhile(/[\d]/) && stream.eat(";");
        }
      } else {
        ok = stream.eatWhile(/[\w\.\-:]/) && stream.eat(";");
      }
      return ok ? "atom" : "error";
    } else {
      stream.eatWhile(/[^&<]/);
      return null;
    }
  }
  inText.isInText = true;

  function inTag(stream, state) {
    var ch = stream.next();
    if (ch == ">" || (ch == "/" && stream.eat(">"))) {
      state.tokenize = inText;
      type = ch == ">" ? "endTag" : "selfcloseTag";
      return "tag bracket";
    } else if (ch == "=") {
      type = "equals";
      return null;
    } else if (ch == "<") {
      state.tokenize = inText;
      state.state = baseState;
      state.tagName = state.tagStart = null;
      var next = state.tokenize(stream, state);
      return next ? next + " tag error" : "tag error";
    } else if (/[\'\"]/.test(ch)) {
      state.tokenize = inAttribute(ch);
      state.stringStartCol = stream.column();
      return state.tokenize(stream, state);
    } else {
      stream.match(/^[^\s\u00a0=<>\"\']*[^\s\u00a0=<>\"\'\/]/);
      return "word";
    }
  }

  function inAttribute(quote) {
    var closure = function(stream, state) {
      while (!stream.eol()) {
        if (stream.next() == quote) {
          state.tokenize = inTag;
          break;
        }
      }
      return "string";
    };
    closure.isInAttribute = true;
    return closure;
  }

  function inBlock(style, terminator) {
    return function(stream, state) {
      while (!stream.eol()) {
        if (stream.match(terminator)) {
          state.tokenize = inText;
          break;
        }
        stream.next();
      }
      return style;
    };
  }
  function doctype(depth) {
    return function(stream, state) {
      var ch;
      while ((ch = stream.next()) != null) {
        if (ch == "<") {
          state.tokenize = doctype(depth + 1);
          return state.tokenize(stream, state);
        } else if (ch == ">") {
          if (depth == 1) {
            state.tokenize = inText;
            break;
          } else {
            state.tokenize = doctype(depth - 1);
            return state.tokenize(stream, state);
          }
        }
      }
      return "meta";
    };
  }

  function Context(state, tagName, startOfLine) {
    this.prev = state.context;
    this.tagName = tagName;
    this.indent = state.indented;
    this.startOfLine = startOfLine;
    if (config.doNotIndent.hasOwnProperty(tagName) || (state.context && state.context.noIndent))
      this.noIndent = true;
  }
  function popContext(state) {
    if (state.context) state.context = state.context.prev;
  }
  function maybePopContext(state, nextTagName) {
    var parentTagName;
    while (true) {
      if (!state.context) {
        return;
      }
      parentTagName = state.context.tagName;
      if (!config.contextGrabbers.hasOwnProperty(parentTagName) ||
          !config.contextGrabbers[parentTagName].hasOwnProperty(nextTagName)) {
        return;
      }
      popContext(state);
    }
  }

  function baseState(type, stream, state) {
    if (type == "openTag") {
      state.tagStart = stream.column();
      return tagNameState;
    } else if (type == "closeTag") {
      return closeTagNameState;
    } else {
      return baseState;
    }
  }
  function tagNameState(type, stream, state) {
    if (type == "word") {
      state.tagName = stream.current();
      setStyle = "tag";
      return attrState;
    } else {
      setStyle = "error";
      return tagNameState;
    }
  }
  function closeTagNameState(type, stream, state) {
    if (type == "word") {
      var tagName = stream.current();
      if (state.context && state.context.tagName != tagName &&
          config.implicitlyClosed.hasOwnProperty(state.context.tagName))
        popContext(state);
      if ((state.context && state.context.tagName == tagName) || config.matchClosing === false) {
        setStyle = "tag";
        return closeState;
      } else {
        setStyle = "tag error";
        return closeStateErr;
      }
    } else {
      setStyle = "error";
      return closeStateErr;
    }
  }

  function closeState(type, _stream, state) {
    if (type != "endTag") {
      setStyle = "error";
      return closeState;
    }
    popContext(state);
    return baseState;
  }
  function closeStateErr(type, stream, state) {
    setStyle = "error";
    return closeState(type, stream, state);
  }

  function attrState(type, _stream, state) {
    if (type == "word") {
      setStyle = "attribute";
      return attrEqState;
    } else if (type == "endTag" || type == "selfcloseTag") {
      var tagName = state.tagName, tagStart = state.tagStart;
      state.tagName = state.tagStart = null;
      if (type == "selfcloseTag" ||
          config.autoSelfClosers.hasOwnProperty(tagName)) {
        maybePopContext(state, tagName);
      } else {
        maybePopContext(state, tagName);
        state.context = new Context(state, tagName, tagStart == state.indented);
      }
      return baseState;
    }
    setStyle = "error";
    return attrState;
  }
  function attrEqState(type, stream, state) {
    if (type == "equals") return attrValueState;
    if (!config.allowMissing) setStyle = "error";
    return attrState(type, stream, state);
  }
  function attrValueState(type, stream, state) {
    if (type == "string") return attrContinuedState;
    if (type == "word" && config.allowUnquoted) {setStyle = "string"; return attrState;}
    setStyle = "error";
    return attrState(type, stream, state);
  }
  function attrContinuedState(type, stream, state) {
    if (type == "string") return attrContinuedState;
    return attrState(type, stream, state);
  }

  return {
    startState: function(baseIndent) {
      var state = {tokenize: inText,
                   state: baseState,
                   indented: baseIndent || 0,
                   tagName: null, tagStart: null,
                   context: null}
      if (baseIndent != null) state.baseIndent = baseIndent
      return state
    },

    token: function(stream, state) {
      if (!state.tagName && stream.sol())
        state.indented = stream.indentation();

      if (stream.eatSpace()) return null;
      type = null;
      var style = state.tokenize(stream, state);
      if ((style || type) && style != "comment") {
        setStyle = null;
        state.state = state.state(type || style, stream, state);
        if (setStyle)
          style = setStyle == "error" ? style + " error" : setStyle;
      }
      return style;
    },

    indent: function(state, textAfter, fullLine) {
      var context = state.context;
      // Indent multi-line strings (e.g. css).
      if (state.tokenize.isInAttribute) {
        if (state.tagStart == state.indented)
          return state.stringStartCol + 1;
        else
          return state.indented + indentUnit;
      }
      if (context && context.noIndent) return CodeMirror.Pass;
      if (state.tokenize != inTag && state.tokenize != inText)
        return fullLine ? fullLine.match(/^(\s*)/)[0].length : 0;
      // Indent the starts of attribute names.
      if (state.tagName) {
        if (config.multilineTagIndentPastTag !== false)
          return state.tagStart + state.tagName.length + 2;
        else
          return state.tagStart + indentUnit * (config.multilineTagIndentFactor || 1);
      }
      if (config.alignCDATA && /<!\[CDATA\[/.test(textAfter)) return 0;
      var tagAfter = textAfter && /^<(\/)?([\w_:\.-]*)/.exec(textAfter);
      if (tagAfter && tagAfter[1]) { // Closing tag spotted
        while (context) {
          if (context.tagName == tagAfter[2]) {
            context = context.prev;
            break;
          } else if (config.implicitlyClosed.hasOwnProperty(context.tagName)) {
            context = context.prev;
          } else {
            break;
          }
        }
      } else if (tagAfter) { // Opening tag spotted
        while (context) {
          var grabbers = config.contextGrabbers[context.tagName];
          if (grabbers && grabbers.hasOwnProperty(tagAfter[2]))
            context = context.prev;
          else
            break;
        }
      }
      while (context && context.prev && !context.startOfLine)
        context = context.prev;
      if (context) return context.indent + indentUnit;
      else return state.baseIndent || 0;
    },

    electricInput: /<\/[\s\w:]+>$/,
    blockCommentStart: "<!--",
    blockCommentEnd: "-->",

    configuration: config.htmlMode ? "html" : "xml",
    helperType: config.htmlMode ? "html" : "xml",

    skipAttribute: function(state) {
      if (state.state == attrValueState)
        state.state = attrState
    }
  };
});

CodeMirror.defineMIME("text/xml", "xml");
CodeMirror.defineMIME("application/xml", "xml");
if (!CodeMirror.mimeModes.hasOwnProperty("text/html"))
  CodeMirror.defineMIME("text/html", {name: "xml", htmlMode: true});

});


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var React = __webpack_require__(20);
var factory = __webpack_require__(110);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubehelix;
/* unused harmony export Cubehelix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(111);




var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["d" /* Rgb */])) o = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["e" /* rgbConvert */])(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* rad2deg */] - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Cubehelix, cubehelix, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["f" /* Color */], {
  brighter: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["g" /* brighter */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["g" /* brighter */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["h" /* darker */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["h" /* darker */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* deg2rad */],
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["d" /* Rgb */](
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lab;
/* unused harmony export Lab */
/* harmony export (immutable) */ __webpack_exports__["b"] = hcl;
/* unused harmony export Hcl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(111);




var Kn = 18,
    Xn = 0.950470, // D65 standard referent
    Yn = 1,
    Zn = 1.088830,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) {
    var h = o.h * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* deg2rad */];
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
  }
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["d" /* Rgb */])) o = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["e" /* rgbConvert */])(o);
  var b = rgb2xyz(o.r),
      a = rgb2xyz(o.g),
      l = rgb2xyz(o.b),
      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Lab, lab, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["f" /* Color */], {
  brighter: function(k) {
    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    y = Yn * lab2xyz(y);
    x = Xn * lab2xyz(x);
    z = Zn * lab2xyz(z);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["d" /* Rgb */](
      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function xyz2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2xyz(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  var h = Math.atan2(o.b, o.a) * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* rad2deg */];
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hcl, hcl, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["f" /* Color */], {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return labConvert(this).rgb();
  }
}));


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_value__ = __webpack_require__(68);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolate", function() { return __WEBPACK_IMPORTED_MODULE_0__src_value__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_array__ = __webpack_require__(112);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateArray", function() { return __WEBPACK_IMPORTED_MODULE_1__src_array__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_basis__ = __webpack_require__(67);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateBasis", function() { return __WEBPACK_IMPORTED_MODULE_2__src_basis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_basisClosed__ = __webpack_require__(113);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_3__src_basisClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_date__ = __webpack_require__(115);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateDate", function() { return __WEBPACK_IMPORTED_MODULE_4__src_date__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_number__ = __webpack_require__(43);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateNumber", function() { return __WEBPACK_IMPORTED_MODULE_5__src_number__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_object__ = __webpack_require__(116);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateObject", function() { return __WEBPACK_IMPORTED_MODULE_6__src_object__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_round__ = __webpack_require__(218);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRound", function() { return __WEBPACK_IMPORTED_MODULE_7__src_round__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_string__ = __webpack_require__(118);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateString", function() { return __WEBPACK_IMPORTED_MODULE_8__src_string__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_transform_index__ = __webpack_require__(220);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateTransformCss", function() { return __WEBPACK_IMPORTED_MODULE_9__src_transform_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateTransformSvg", function() { return __WEBPACK_IMPORTED_MODULE_9__src_transform_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_zoom__ = __webpack_require__(222);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateZoom", function() { return __WEBPACK_IMPORTED_MODULE_10__src_zoom__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_rgb__ = __webpack_require__(117);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRgb", function() { return __WEBPACK_IMPORTED_MODULE_11__src_rgb__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRgbBasis", function() { return __WEBPACK_IMPORTED_MODULE_11__src_rgb__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRgbBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_11__src_rgb__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_hsl__ = __webpack_require__(215);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHsl", function() { return __WEBPACK_IMPORTED_MODULE_12__src_hsl__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHslLong", function() { return __WEBPACK_IMPORTED_MODULE_12__src_hsl__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_lab__ = __webpack_require__(216);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateLab", function() { return __WEBPACK_IMPORTED_MODULE_13__src_lab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_hcl__ = __webpack_require__(214);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHcl", function() { return __WEBPACK_IMPORTED_MODULE_14__src_hcl__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHclLong", function() { return __WEBPACK_IMPORTED_MODULE_14__src_hcl__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(213);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCubehelix", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCubehelixLong", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_quantize__ = __webpack_require__(217);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "quantize", function() { return __WEBPACK_IMPORTED_MODULE_16__src_quantize__["a"]; });



















/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cubehelixLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(33);



function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(end)).h),
          s = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
          l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
          opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

/* harmony default export */ __webpack_exports__["a"] = (cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* hue */]));
var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hclLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(33);



function hcl(hue) {
  return function(start, end) {
    var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["hcl"])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["hcl"])(end)).h),
        c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.c, end.c),
        l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (hcl(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* hue */]));
var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hslLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(33);



function hsl(hue) {
  return function(start, end) {
    var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["hsl"])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["hsl"])(end)).h),
        s = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
        l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (hsl(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* hue */]));
var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lab;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(33);



function lab(start, end) {
  var l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["lab"])(start)).l, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["lab"])(end)).l),
      a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.a, end.a),
      b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.b, end.b),
      opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}


/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
});


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
});


/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return identity; });
var degrees = 180 / Math.PI;

var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ __webpack_exports__["b"] = (function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return interpolateTransformCss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return interpolateTransformSvg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(221);



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["a" /* parseCss */], "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["b" /* parseSvg */], ", ", ")", ")");


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCss;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decompose__ = __webpack_require__(219);


var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return __WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* identity */];
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* default */])(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* identity */];
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* identity */];
  value = value.matrix;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* default */])(value.a, value.b, value.c, value.d, value.e, value.f);
}


/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
/* harmony default export */ __webpack_exports__["a"] = (function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    }
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    }
  }

  i.duration = S * 1000;

  return i;
});


/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__(70);


/* harmony default export */ __webpack_exports__["a"] = (function(callback, delay, time) {
  var t = new __WEBPACK_IMPORTED_MODULE_0__timer__["d" /* Timer */], total = delay;
  if (delay == null) return t.restart(callback, delay, time), t;
  delay = +delay, time = time == null ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__timer__["a" /* now */])() : +time;
  t.restart(function tick(elapsed) {
    elapsed += total;
    t.restart(tick, total += delay, time);
    callback(elapsed);
  }, delay, time);
  return t;
});


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__(70);


/* harmony default export */ __webpack_exports__["a"] = (function(callback, delay, time) {
  var t = new __WEBPACK_IMPORTED_MODULE_0__timer__["d" /* Timer */];
  delay = delay == null ? 0 : +delay;
  t.restart(function(elapsed) {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
});


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

// https://d3js.org Version 4.9.1. Copyright 2017 Mike Bostock.
(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
}(this, (function (exports) { 'use strict';

var version = "4.9.1";

var ascending = function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
};

var bisector = function(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
};

function ascendingComparator(f) {
  return function(d, x) {
    return ascending(f(d), x);
  };
}

var ascendingBisect = bisector(ascending);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;

var pairs = function(array, f) {
  if (f == null) f = pair;
  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
  while (i < n) pairs[i] = f(p, p = array[++i]);
  return pairs;
};

function pair(a, b) {
  return [a, b];
}

var cross = function(values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = pair;

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
};

var descending = function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
};

var number = function(x) {
  return x === null ? NaN : +x;
};

var variance = function(values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = number(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = number(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
};

var deviation = function(array, f) {
  var v = variance(array, f);
  return v ? Math.sqrt(v) : v;
};

var extent = function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
};

var array = Array.prototype;

var slice = array.slice;
var map = array.map;

var constant = function(x) {
  return function() {
    return x;
  };
};

var identity = function(x) {
  return x;
};

var sequence = function(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
};

var e10 = Math.sqrt(50);
var e5 = Math.sqrt(10);
var e2 = Math.sqrt(2);

var ticks = function(start, stop, count) {
  var reverse = stop < start,
      i = -1,
      n,
      ticks,
      step;

  if (reverse) n = start, start = stop, stop = n;

  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
};

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}

var sturges = function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
};

var histogram = function() {
  var value = identity,
      domain = extent,
      threshold = sturges;

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = tickStep(x0, x1, tz);
      tz = sequence(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[bisectRight(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
  };

  return histogram;
};

var threshold = function(values, p, valueof) {
  if (valueof == null) valueof = number;
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
};

var freedmanDiaconis = function(values, min, max) {
  values = map.call(values, number).sort(ascending);
  return Math.ceil((max - min) / (2 * (threshold(values, 0.75) - threshold(values, 0.25)) * Math.pow(values.length, -1 / 3)));
};

var scott = function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
};

var max = function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
};

var mean = function(values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = number(values[i]))) sum += value;
      else --m;
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
      else --m;
    }
  }

  if (m) return sum / m;
};

var median = function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = number(values[i]))) {
        numbers.push(value);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = number(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return threshold(numbers.sort(ascending), 0.5);
};

var merge = function(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
};

var min = function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
};

var permute = function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
};

var scan = function(values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = ascending;

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
};

var shuffle = function(array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
};

var sum = function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  }

  else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
};

var transpose = function(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
};

function length(d) {
  return d.length;
}

var zip = function() {
  return transpose(arguments);
};

var slice$1 = Array.prototype.slice;

var identity$1 = function(x) {
  return x;
};

var top = 1;
var right = 2;
var bottom = 3;
var left = 4;
var epsilon = 1e-6;

function translateX(x) {
  return "translate(" + (x + 0.5) + ",0)";
}

function translateY(y) {
  return "translate(0," + (y + 0.5) + ")";
}

function center(scale) {
  var offset = Math.max(0, scale.bandwidth() - 1) / 2; // Adjust for 0.5px offset.
  if (scale.round()) offset = Math.round(offset);
  return function(d) {
    return scale(d) + offset;
  };
}

function entering() {
  return !this.__axis;
}

function axis(orient, scale) {
  var tickArguments = [],
      tickValues = null,
      tickFormat = null,
      tickSizeInner = 6,
      tickSizeOuter = 6,
      tickPadding = 3,
      k = orient === top || orient === left ? -1 : 1,
      x = orient === left || orient === right ? "x" : "y",
      transform = orient === top || orient === bottom ? translateX : translateY;

  function axis(context) {
    var values = tickValues == null ? (scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain()) : tickValues,
        format = tickFormat == null ? (scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity$1) : tickFormat,
        spacing = Math.max(tickSizeInner, 0) + tickPadding,
        range = scale.range(),
        range0 = range[0] + 0.5,
        range1 = range[range.length - 1] + 0.5,
        position = (scale.bandwidth ? center : identity$1)(scale.copy()),
        selection = context.selection ? context.selection() : context,
        path = selection.selectAll(".domain").data([null]),
        tick = selection.selectAll(".tick").data(values, scale).order(),
        tickExit = tick.exit(),
        tickEnter = tick.enter().append("g").attr("class", "tick"),
        line = tick.select("line"),
        text = tick.select("text");

    path = path.merge(path.enter().insert("path", ".tick")
        .attr("class", "domain")
        .attr("stroke", "#000"));

    tick = tick.merge(tickEnter);

    line = line.merge(tickEnter.append("line")
        .attr("stroke", "#000")
        .attr(x + "2", k * tickSizeInner));

    text = text.merge(tickEnter.append("text")
        .attr("fill", "#000")
        .attr(x, k * spacing)
        .attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));

    if (context !== selection) {
      path = path.transition(context);
      tick = tick.transition(context);
      line = line.transition(context);
      text = text.transition(context);

      tickExit = tickExit.transition(context)
          .attr("opacity", epsilon)
          .attr("transform", function(d) { return isFinite(d = position(d)) ? transform(d) : this.getAttribute("transform"); });

      tickEnter
          .attr("opacity", epsilon)
          .attr("transform", function(d) { var p = this.parentNode.__axis; return transform(p && isFinite(p = p(d)) ? p : position(d)); });
    }

    tickExit.remove();

    path
        .attr("d", orient === left || orient == right
            ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter
            : "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter);

    tick
        .attr("opacity", 1)
        .attr("transform", function(d) { return transform(position(d)); });

    line
        .attr(x + "2", k * tickSizeInner);

    text
        .attr(x, k * spacing)
        .text(format);

    selection.filter(entering)
        .attr("fill", "none")
        .attr("font-size", 10)
        .attr("font-family", "sans-serif")
        .attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");

    selection
        .each(function() { this.__axis = position; });
  }

  axis.scale = function(_) {
    return arguments.length ? (scale = _, axis) : scale;
  };

  axis.ticks = function() {
    return tickArguments = slice$1.call(arguments), axis;
  };

  axis.tickArguments = function(_) {
    return arguments.length ? (tickArguments = _ == null ? [] : slice$1.call(_), axis) : tickArguments.slice();
  };

  axis.tickValues = function(_) {
    return arguments.length ? (tickValues = _ == null ? null : slice$1.call(_), axis) : tickValues && tickValues.slice();
  };

  axis.tickFormat = function(_) {
    return arguments.length ? (tickFormat = _, axis) : tickFormat;
  };

  axis.tickSize = function(_) {
    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
  };

  axis.tickSizeInner = function(_) {
    return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
  };

  axis.tickSizeOuter = function(_) {
    return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
  };

  axis.tickPadding = function(_) {
    return arguments.length ? (tickPadding = +_, axis) : tickPadding;
  };

  return axis;
}

function axisTop(scale) {
  return axis(top, scale);
}

function axisRight(scale) {
  return axis(right, scale);
}

function axisBottom(scale) {
  return axis(bottom, scale);
}

function axisLeft(scale) {
  return axis(left, scale);
}

var noop = {value: function() {}};

function dispatch() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || (t in _)) throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch(_);
}

function Dispatch(_) {
  this._ = _;
}

function parseTypenames(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    return {type: t, name: name};
  });
}

Dispatch.prototype = dispatch.prototype = {
  constructor: Dispatch,
  on: function(typename, callback) {
    var _ = this._,
        T = parseTypenames(typename + "", _),
        t,
        i = -1,
        n = T.length;

    // If no callback was specified, return the callback of the given type and name.
    if (arguments.length < 2) {
      while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
      return;
    }

    // If a type was specified, set the callback for the given type and name.
    // Otherwise, if a null callback was specified, remove callbacks of the given name.
    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
      else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
    }

    return this;
  },
  copy: function() {
    var copy = {}, _ = this._;
    for (var t in _) copy[t] = _[t].slice();
    return new Dispatch(copy);
  },
  call: function(type, that) {
    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  },
  apply: function(type, that, args) {
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  }
};

function get(type, name) {
  for (var i = 0, n = type.length, c; i < n; ++i) {
    if ((c = type[i]).name === name) {
      return c.value;
    }
  }
}

function set(type, name, callback) {
  for (var i = 0, n = type.length; i < n; ++i) {
    if (type[i].name === name) {
      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
      break;
    }
  }
  if (callback != null) type.push({name: name, value: callback});
  return type;
}

var xhtml = "http://www.w3.org/1999/xhtml";

var namespaces = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};

var namespace = function(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return namespaces.hasOwnProperty(prefix) ? {space: namespaces[prefix], local: name} : name;
};

function creatorInherit(name) {
  return function() {
    var document = this.ownerDocument,
        uri = this.namespaceURI;
    return uri === xhtml && document.documentElement.namespaceURI === xhtml
        ? document.createElement(name)
        : document.createElementNS(uri, name);
  };
}

function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}

var creator = function(name) {
  var fullname = namespace(name);
  return (fullname.local
      ? creatorFixed
      : creatorInherit)(fullname);
};

var nextId = 0;

function local$1() {
  return new Local;
}

function Local() {
  this._ = "@" + (++nextId).toString(36);
}

Local.prototype = local$1.prototype = {
  constructor: Local,
  get: function(node) {
    var id = this._;
    while (!(id in node)) if (!(node = node.parentNode)) return;
    return node[id];
  },
  set: function(node, value) {
    return node[this._] = value;
  },
  remove: function(node) {
    return this._ in node && delete node[this._];
  },
  toString: function() {
    return this._;
  }
};

var matcher = function(selector) {
  return function() {
    return this.matches(selector);
  };
};

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!element.matches) {
    var vendorMatches = element.webkitMatchesSelector
        || element.msMatchesSelector
        || element.mozMatchesSelector
        || element.oMatchesSelector;
    matcher = function(selector) {
      return function() {
        return vendorMatches.call(this, selector);
      };
    };
  }
}

var matcher$1 = matcher;

var filterEvents = {};

exports.event = null;

if (typeof document !== "undefined") {
  var element$1 = document.documentElement;
  if (!("onmouseenter" in element$1)) {
    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
  }
}

function filterContextListener(listener, index, group) {
  listener = contextListener(listener, index, group);
  return function(event) {
    var related = event.relatedTarget;
    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
      listener.call(this, event);
    }
  };
}

function contextListener(listener, index, group) {
  return function(event1) {
    var event0 = exports.event; // Events can be reentrant (e.g., focus).
    exports.event = event1;
    try {
      listener.call(this, this.__data__, index, group);
    } finally {
      exports.event = event0;
    }
  };
}

function parseTypenames$1(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return {type: t, name: name};
  });
}

function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on) return;
    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
      } else {
        on[++i] = o;
      }
    }
    if (++i) on.length = i;
    else delete this.__on;
  };
}

function onAdd(typename, value, capture) {
  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
  return function(d, i, group) {
    var on = this.__on, o, listener = wrap(value, i, group);
    if (on) for (var j = 0, m = on.length; j < m; ++j) {
      if ((o = on[j]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, capture);
    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
    if (!on) this.__on = [o];
    else on.push(o);
  };
}

var selection_on = function(typename, value, capture) {
  var typenames = parseTypenames$1(typename + ""), i, n = typenames.length, t;

  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
      for (i = 0, o = on[j]; i < n; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }

  on = value ? onAdd : onRemove;
  if (capture == null) capture = false;
  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
  return this;
};

function customEvent(event1, listener, that, args) {
  var event0 = exports.event;
  event1.sourceEvent = exports.event;
  exports.event = event1;
  try {
    return listener.apply(that, args);
  } finally {
    exports.event = event0;
  }
}

var sourceEvent = function() {
  var current = exports.event, source;
  while (source = current.sourceEvent) current = source;
  return current;
};

var point = function(node, event) {
  var svg = node.ownerSVGElement || node;

  if (svg.createSVGPoint) {
    var point = svg.createSVGPoint();
    point.x = event.clientX, point.y = event.clientY;
    point = point.matrixTransform(node.getScreenCTM().inverse());
    return [point.x, point.y];
  }

  var rect = node.getBoundingClientRect();
  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
};

var mouse = function(node) {
  var event = sourceEvent();
  if (event.changedTouches) event = event.changedTouches[0];
  return point(node, event);
};

function none() {}

var selector = function(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
};

var selection_select = function(select) {
  if (typeof select !== "function") select = selector(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }

  return new Selection(subgroups, this._parents);
};

function empty$1() {
  return [];
}

var selectorAll = function(selector) {
  return selector == null ? empty$1 : function() {
    return this.querySelectorAll(selector);
  };
};

var selection_selectAll = function(select) {
  if (typeof select !== "function") select = selectorAll(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        subgroups.push(select.call(node, node.__data__, i, group));
        parents.push(node);
      }
    }
  }

  return new Selection(subgroups, parents);
};

var selection_filter = function(match) {
  if (typeof match !== "function") match = matcher$1(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new Selection(subgroups, this._parents);
};

var sparse = function(update) {
  return new Array(update.length);
};

var selection_enter = function() {
  return new Selection(this._enter || this._groups.map(sparse), this._parents);
};

function EnterNode(parent, datum) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum;
}

EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
  querySelector: function(selector) { return this._parent.querySelector(selector); },
  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
};

var constant$1 = function(x) {
  return function() {
    return x;
  };
};

var keyPrefix = "$"; // Protect against keys like “__proto__”.

function bindIndex(parent, group, enter, update, exit, data) {
  var i = 0,
      node,
      groupLength = group.length,
      dataLength = data.length;

  // Put any non-null nodes that fit into update.
  // Put any null nodes into enter.
  // Put any remaining data into enter.
  for (; i < dataLength; ++i) {
    if (node = group[i]) {
      node.__data__ = data[i];
      update[i] = node;
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }

  // Put any non-null nodes that don’t fit into exit.
  for (; i < groupLength; ++i) {
    if (node = group[i]) {
      exit[i] = node;
    }
  }
}

function bindKey(parent, group, enter, update, exit, data, key) {
  var i,
      node,
      nodeByKeyValue = {},
      groupLength = group.length,
      dataLength = data.length,
      keyValues = new Array(groupLength),
      keyValue;

  // Compute the key for each node.
  // If multiple nodes have the same key, the duplicates are added to exit.
  for (i = 0; i < groupLength; ++i) {
    if (node = group[i]) {
      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
      if (keyValue in nodeByKeyValue) {
        exit[i] = node;
      } else {
        nodeByKeyValue[keyValue] = node;
      }
    }
  }

  // Compute the key for each datum.
  // If there a node associated with this key, join and add it to update.
  // If there is not (or the key is a duplicate), add it to enter.
  for (i = 0; i < dataLength; ++i) {
    keyValue = keyPrefix + key.call(parent, data[i], i, data);
    if (node = nodeByKeyValue[keyValue]) {
      update[i] = node;
      node.__data__ = data[i];
      nodeByKeyValue[keyValue] = null;
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }

  // Add any remaining nodes that were not bound to data to exit.
  for (i = 0; i < groupLength; ++i) {
    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
      exit[i] = node;
    }
  }
}

var selection_data = function(value, key) {
  if (!value) {
    data = new Array(this.size()), j = -1;
    this.each(function(d) { data[++j] = d; });
    return data;
  }

  var bind = key ? bindKey : bindIndex,
      parents = this._parents,
      groups = this._groups;

  if (typeof value !== "function") value = constant$1(value);

  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j],
        group = groups[j],
        groupLength = group.length,
        data = value.call(parent, parent && parent.__data__, j, parents),
        dataLength = data.length,
        enterGroup = enter[j] = new Array(dataLength),
        updateGroup = update[j] = new Array(dataLength),
        exitGroup = exit[j] = new Array(groupLength);

    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);

    // Now connect the enter nodes to their following update node, such that
    // appendChild can insert the materialized enter node before this node,
    // rather than at the end of the parent node.
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
        previous._next = next || null;
      }
    }
  }

  update = new Selection(update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
};

var selection_exit = function() {
  return new Selection(this._exit || this._groups.map(sparse), this._parents);
};

var selection_merge = function(selection) {

  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new Selection(merges, this._parents);
};

var selection_order = function() {

  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
      if (node = group[i]) {
        if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }

  return this;
};

var selection_sort = function(compare) {
  if (!compare) compare = ascending$1;

  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }

  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }

  return new Selection(sortgroups, this._parents).order();
};

function ascending$1(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

var selection_call = function() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
};

var selection_nodes = function() {
  var nodes = new Array(this.size()), i = -1;
  this.each(function() { nodes[++i] = this; });
  return nodes;
};

var selection_node = function() {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
      var node = group[i];
      if (node) return node;
    }
  }

  return null;
};

var selection_size = function() {
  var size = 0;
  this.each(function() { ++size; });
  return size;
};

var selection_empty = function() {
  return !this.node();
};

var selection_each = function(callback) {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
  }

  return this;
};

function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}

function attrConstantNS(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}

function attrFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttribute(name);
    else this.setAttribute(name, v);
  };
}

function attrFunctionNS(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v);
  };
}

var selection_attr = function(name, value) {
  var fullname = namespace(name);

  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local
        ? node.getAttributeNS(fullname.space, fullname.local)
        : node.getAttribute(fullname);
  }

  return this.each((value == null
      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)
      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
};

var defaultView = function(node) {
  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
      || (node.document && node) // node is a Window
      || node.defaultView; // node is a Document
};

function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}

function styleFunction(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v, priority);
  };
}

var selection_style = function(name, value, priority) {
  return arguments.length > 1
      ? this.each((value == null
            ? styleRemove : typeof value === "function"
            ? styleFunction
            : styleConstant)(name, value, priority == null ? "" : priority))
      : styleValue(this.node(), name);
};

function styleValue(node, name) {
  return node.style.getPropertyValue(name)
      || defaultView(node).getComputedStyle(node, null).getPropertyValue(name);
}

function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}

function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}

function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) delete this[name];
    else this[name] = v;
  };
}

var selection_property = function(name, value) {
  return arguments.length > 1
      ? this.each((value == null
          ? propertyRemove : typeof value === "function"
          ? propertyFunction
          : propertyConstant)(name, value))
      : this.node()[name];
};

function classArray(string) {
  return string.trim().split(/^|\s+/);
}

function classList(node) {
  return node.classList || new ClassList(node);
}

function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}

ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};

function classedAdd(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.add(names[i]);
}

function classedRemove(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.remove(names[i]);
}

function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}

function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}

function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}

var selection_classed = function(name, value) {
  var names = classArray(name + "");

  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n = names.length;
    while (++i < n) if (!list.contains(names[i])) return false;
    return true;
  }

  return this.each((typeof value === "function"
      ? classedFunction : value
      ? classedTrue
      : classedFalse)(names, value));
};

function textRemove() {
  this.textContent = "";
}

function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}

var selection_text = function(value) {
  return arguments.length
      ? this.each(value == null
          ? textRemove : (typeof value === "function"
          ? textFunction
          : textConstant)(value))
      : this.node().textContent;
};

function htmlRemove() {
  this.innerHTML = "";
}

function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}

function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}

var selection_html = function(value) {
  return arguments.length
      ? this.each(value == null
          ? htmlRemove : (typeof value === "function"
          ? htmlFunction
          : htmlConstant)(value))
      : this.node().innerHTML;
};

function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

var selection_raise = function() {
  return this.each(raise);
};

function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

var selection_lower = function() {
  return this.each(lower);
};

var selection_append = function(name) {
  var create = typeof name === "function" ? name : creator(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
};

function constantNull() {
  return null;
}

var selection_insert = function(name, before) {
  var create = typeof name === "function" ? name : creator(name),
      select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
  return this.select(function() {
    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
  });
};

function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

var selection_remove = function() {
  return this.each(remove);
};

var selection_datum = function(value) {
  return arguments.length
      ? this.property("__data__", value)
      : this.node().__data__;
};

function dispatchEvent(node, type, params) {
  var window = defaultView(node),
      event = window.CustomEvent;

  if (typeof event === "function") {
    event = new event(type, params);
  } else {
    event = window.document.createEvent("Event");
    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type, false, false);
  }

  node.dispatchEvent(event);
}

function dispatchConstant(type, params) {
  return function() {
    return dispatchEvent(this, type, params);
  };
}

function dispatchFunction(type, params) {
  return function() {
    return dispatchEvent(this, type, params.apply(this, arguments));
  };
}

var selection_dispatch = function(type, params) {
  return this.each((typeof params === "function"
      ? dispatchFunction
      : dispatchConstant)(type, params));
};

var root = [null];

function Selection(groups, parents) {
  this._groups = groups;
  this._parents = parents;
}

function selection() {
  return new Selection([[document.documentElement]], root);
}

Selection.prototype = selection.prototype = {
  constructor: Selection,
  select: selection_select,
  selectAll: selection_selectAll,
  filter: selection_filter,
  data: selection_data,
  enter: selection_enter,
  exit: selection_exit,
  merge: selection_merge,
  order: selection_order,
  sort: selection_sort,
  call: selection_call,
  nodes: selection_nodes,
  node: selection_node,
  size: selection_size,
  empty: selection_empty,
  each: selection_each,
  attr: selection_attr,
  style: selection_style,
  property: selection_property,
  classed: selection_classed,
  text: selection_text,
  html: selection_html,
  raise: selection_raise,
  lower: selection_lower,
  append: selection_append,
  insert: selection_insert,
  remove: selection_remove,
  datum: selection_datum,
  on: selection_on,
  dispatch: selection_dispatch
};

var select = function(selector) {
  return typeof selector === "string"
      ? new Selection([[document.querySelector(selector)]], [document.documentElement])
      : new Selection([[selector]], root);
};

var selectAll = function(selector) {
  return typeof selector === "string"
      ? new Selection([document.querySelectorAll(selector)], [document.documentElement])
      : new Selection([selector == null ? [] : selector], root);
};

var touch = function(node, touches, identifier) {
  if (arguments.length < 3) identifier = touches, touches = sourceEvent().changedTouches;

  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
    if ((touch = touches[i]).identifier === identifier) {
      return point(node, touch);
    }
  }

  return null;
};

var touches = function(node, touches) {
  if (touches == null) touches = sourceEvent().touches;

  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
    points[i] = point(node, touches[i]);
  }

  return points;
};

function nopropagation() {
  exports.event.stopImmediatePropagation();
}

var noevent = function() {
  exports.event.preventDefault();
  exports.event.stopImmediatePropagation();
};

var dragDisable = function(view) {
  var root = view.document.documentElement,
      selection$$1 = select(view).on("dragstart.drag", noevent, true);
  if ("onselectstart" in root) {
    selection$$1.on("selectstart.drag", noevent, true);
  } else {
    root.__noselect = root.style.MozUserSelect;
    root.style.MozUserSelect = "none";
  }
};

function yesdrag(view, noclick) {
  var root = view.document.documentElement,
      selection$$1 = select(view).on("dragstart.drag", null);
  if (noclick) {
    selection$$1.on("click.drag", noevent, true);
    setTimeout(function() { selection$$1.on("click.drag", null); }, 0);
  }
  if ("onselectstart" in root) {
    selection$$1.on("selectstart.drag", null);
  } else {
    root.style.MozUserSelect = root.__noselect;
    delete root.__noselect;
  }
}

var constant$2 = function(x) {
  return function() {
    return x;
  };
};

function DragEvent(target, type, subject, id, active, x, y, dx, dy, dispatch) {
  this.target = target;
  this.type = type;
  this.subject = subject;
  this.identifier = id;
  this.active = active;
  this.x = x;
  this.y = y;
  this.dx = dx;
  this.dy = dy;
  this._ = dispatch;
}

DragEvent.prototype.on = function() {
  var value = this._.on.apply(this._, arguments);
  return value === this._ ? this : value;
};

// Ignore right-click, since that should open the context menu.
function defaultFilter$1() {
  return !exports.event.button;
}

function defaultContainer() {
  return this.parentNode;
}

function defaultSubject(d) {
  return d == null ? {x: exports.event.x, y: exports.event.y} : d;
}

var drag = function() {
  var filter = defaultFilter$1,
      container = defaultContainer,
      subject = defaultSubject,
      gestures = {},
      listeners = dispatch("start", "drag", "end"),
      active = 0,
      mousedownx,
      mousedowny,
      mousemoving,
      touchending,
      clickDistance2 = 0;

  function drag(selection$$1) {
    selection$$1
        .on("mousedown.drag", mousedowned)
        .on("touchstart.drag", touchstarted)
        .on("touchmove.drag", touchmoved)
        .on("touchend.drag touchcancel.drag", touchended)
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }

  function mousedowned() {
    if (touchending || !filter.apply(this, arguments)) return;
    var gesture = beforestart("mouse", container.apply(this, arguments), mouse, this, arguments);
    if (!gesture) return;
    select(exports.event.view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
    dragDisable(exports.event.view);
    nopropagation();
    mousemoving = false;
    mousedownx = exports.event.clientX;
    mousedowny = exports.event.clientY;
    gesture("start");
  }

  function mousemoved() {
    noevent();
    if (!mousemoving) {
      var dx = exports.event.clientX - mousedownx, dy = exports.event.clientY - mousedowny;
      mousemoving = dx * dx + dy * dy > clickDistance2;
    }
    gestures.mouse("drag");
  }

  function mouseupped() {
    select(exports.event.view).on("mousemove.drag mouseup.drag", null);
    yesdrag(exports.event.view, mousemoving);
    noevent();
    gestures.mouse("end");
  }

  function touchstarted() {
    if (!filter.apply(this, arguments)) return;
    var touches$$1 = exports.event.changedTouches,
        c = container.apply(this, arguments),
        n = touches$$1.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = beforestart(touches$$1[i].identifier, c, touch, this, arguments)) {
        nopropagation();
        gesture("start");
      }
    }
  }

  function touchmoved() {
    var touches$$1 = exports.event.changedTouches,
        n = touches$$1.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches$$1[i].identifier]) {
        noevent();
        gesture("drag");
      }
    }
  }

  function touchended() {
    var touches$$1 = exports.event.changedTouches,
        n = touches$$1.length, i, gesture;

    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches$$1[i].identifier]) {
        nopropagation();
        gesture("end");
      }
    }
  }

  function beforestart(id, container, point, that, args) {
    var p = point(container, id), s, dx, dy,
        sublisteners = listeners.copy();

    if (!customEvent(new DragEvent(drag, "beforestart", s, id, active, p[0], p[1], 0, 0, sublisteners), function() {
      if ((exports.event.subject = s = subject.apply(that, args)) == null) return false;
      dx = s.x - p[0] || 0;
      dy = s.y - p[1] || 0;
      return true;
    })) return;

    return function gesture(type) {
      var p0 = p, n;
      switch (type) {
        case "start": gestures[id] = gesture, n = active++; break;
        case "end": delete gestures[id], --active; // nobreak
        case "drag": p = point(container, id), n = active; break;
      }
      customEvent(new DragEvent(drag, type, s, id, n, p[0] + dx, p[1] + dy, p[0] - p0[0], p[1] - p0[1], sublisteners), sublisteners.apply, sublisteners, [type, that, args]);
    };
  }

  drag.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : constant$2(!!_), drag) : filter;
  };

  drag.container = function(_) {
    return arguments.length ? (container = typeof _ === "function" ? _ : constant$2(_), drag) : container;
  };

  drag.subject = function(_) {
    return arguments.length ? (subject = typeof _ === "function" ? _ : constant$2(_), drag) : subject;
  };

  drag.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? drag : value;
  };

  drag.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
  };

  return drag;
};

var define = function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
};

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}

function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*";
var reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*";
var reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*";
var reHex3 = /^#([0-9a-f]{3})$/;
var reHex6 = /^#([0-9a-f]{6})$/;
var reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$");
var reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$");
var reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$");
var reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$");
var reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$");
var reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

define(Color, color, {
  displayable: function() {
    return this.rgb().displayable();
  },
  toString: function() {
    return this.rgb() + "";
  }
});

function color(format) {
  var m;
  format = (format + "").trim().toLowerCase();
  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format])
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

define(Rgb, rgb, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (0 <= this.r && this.r <= 255)
        && (0 <= this.g && this.g <= 255)
        && (0 <= this.b && this.b <= 255)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  toString: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(")
        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define(Hsl, hsl, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}

var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;

var Kn = 18;
var Xn = 0.950470;
var Yn = 1;
var Zn = 1.088830;
var t0 = 4 / 29;
var t1 = 6 / 29;
var t2 = 3 * t1 * t1;
var t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) {
    var h = o.h * deg2rad;
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
  }
  if (!(o instanceof Rgb)) o = rgbConvert(o);
  var b = rgb2xyz(o.r),
      a = rgb2xyz(o.g),
      l = rgb2xyz(o.b),
      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

define(Lab, lab, extend(Color, {
  brighter: function(k) {
    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    y = Yn * lab2xyz(y);
    x = Xn * lab2xyz(x);
    z = Zn * lab2xyz(z);
    return new Rgb(
      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function xyz2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2xyz(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  var h = Math.atan2(o.b, o.a) * rad2deg;
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

define(Hcl, hcl, extend(Color, {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return labConvert(this).rgb();
  }
}));

var A = -0.14861;
var B = +1.78277;
var C = -0.29227;
var D = -0.90649;
var E = +1.97294;
var ED = E * D;
var EB = E * B;
var BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Rgb)) o = rgbConvert(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define(Cubehelix, cubehelix, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new Rgb(
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));

function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

var basis$1 = function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
};

var basisClosed = function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
};

var constant$3 = function(x) {
  return function() {
    return x;
  };
};

function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant$3(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : constant$3(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : constant$3(isNaN(a) ? b : a);
}

var interpolateRgb = ((function rgbGamma(y) {
  var color$$1 = gamma(y);

  function rgb$$1(start, end) {
    var r = color$$1((start = rgb(start)).r, (end = rgb(end)).r),
        g = color$$1(start.g, end.g),
        b = color$$1(start.b, end.b),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb$$1.gamma = rgbGamma;

  return rgb$$1;
}))(1);

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color$$1;
    for (i = 0; i < n; ++i) {
      color$$1 = rgb(colors[i]);
      r[i] = color$$1.r || 0;
      g[i] = color$$1.g || 0;
      b[i] = color$$1.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color$$1.opacity = 1;
    return function(t) {
      color$$1.r = r(t);
      color$$1.g = g(t);
      color$$1.b = b(t);
      return color$$1 + "";
    };
  };
}

var rgbBasis = rgbSpline(basis$1);
var rgbBasisClosed = rgbSpline(basisClosed);

var array$1 = function(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(nb),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = interpolateValue(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
};

var date = function(a, b) {
  var d = new Date;
  return a = +a, b -= a, function(t) {
    return d.setTime(a + b * t), d;
  };
};

var reinterpolate = function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
};

var object = function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = interpolateValue(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
};

var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
var reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

var interpolateString = function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: reinterpolate(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
};

var interpolateValue = function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? constant$3(b)
      : (t === "number" ? reinterpolate
      : t === "string" ? ((c = color(b)) ? (b = c, interpolateRgb) : interpolateString)
      : b instanceof color ? interpolateRgb
      : b instanceof Date ? date
      : Array.isArray(b) ? array$1
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
      : reinterpolate)(a, b);
};

var interpolateRound = function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
};

var degrees = 180 / Math.PI;

var identity$2 = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

var decompose = function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
};

var cssNode;
var cssRoot;
var cssView;
var svgNode;

function parseCss(value) {
  if (value === "none") return identity$2;
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return identity$2;
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return identity$2;
  value = value.matrix;
  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
}

function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: reinterpolate(xa, xb)}, {i: i - 2, x: reinterpolate(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: reinterpolate(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: reinterpolate(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: reinterpolate(xa, xb)}, {i: i - 2, x: reinterpolate(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");

var rho = Math.SQRT2;
var rho2 = 2;
var rho4 = 4;
var epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
var interpolateZoom = function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    };
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    };
  }

  i.duration = S * 1000;

  return i;
};

function hsl$1(hue$$1) {
  return function(start, end) {
    var h = hue$$1((start = hsl(start)).h, (end = hsl(end)).h),
        s = nogamma(start.s, end.s),
        l = nogamma(start.l, end.l),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

var hsl$2 = hsl$1(hue);
var hslLong = hsl$1(nogamma);

function lab$1(start, end) {
  var l = nogamma((start = lab(start)).l, (end = lab(end)).l),
      a = nogamma(start.a, end.a),
      b = nogamma(start.b, end.b),
      opacity = nogamma(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}

function hcl$1(hue$$1) {
  return function(start, end) {
    var h = hue$$1((start = hcl(start)).h, (end = hcl(end)).h),
        c = nogamma(start.c, end.c),
        l = nogamma(start.l, end.l),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

var hcl$2 = hcl$1(hue);
var hclLong = hcl$1(nogamma);

function cubehelix$1(hue$$1) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix$$1(start, end) {
      var h = hue$$1((start = cubehelix(start)).h, (end = cubehelix(end)).h),
          s = nogamma(start.s, end.s),
          l = nogamma(start.l, end.l),
          opacity = nogamma(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix$$1.gamma = cubehelixGamma;

    return cubehelix$$1;
  })(1);
}

var cubehelix$2 = cubehelix$1(hue);
var cubehelixLong = cubehelix$1(nogamma);

var quantize = function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
};

var frame = 0;
var timeout = 0;
var interval = 0;
var pokeDelay = 1000;
var taskHead;
var taskTail;
var clockLast = 0;
var clockNow = 0;
var clockSkew = 0;
var clock = typeof performance === "object" && performance.now ? performance : Date;
var setFrame = typeof requestAnimationFrame === "function" ? requestAnimationFrame : function(f) { setTimeout(f, 17); };

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call =
  this._time =
  this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer;
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now(); // Get the current time, if not already set.
  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(), delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (frame) return; // Soonest alarm already set, or will be.
  if (timeout) timeout = clearTimeout(timeout);
  var delay = time - clockNow;
  if (delay > 24) {
    if (time < Infinity) timeout = setTimeout(wake, delay);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clockNow, interval = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}

var timeout$1 = function(callback, delay, time) {
  var t = new Timer;
  delay = delay == null ? 0 : +delay;
  t.restart(function(elapsed) {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
};

var interval$1 = function(callback, delay, time) {
  var t = new Timer, total = delay;
  if (delay == null) return t.restart(callback, delay, time), t;
  delay = +delay, time = time == null ? now() : +time;
  t.restart(function tick(elapsed) {
    elapsed += total;
    t.restart(tick, total += delay, time);
    callback(elapsed);
  }, delay, time);
  return t;
};

var emptyOn = dispatch("start", "end", "interrupt");
var emptyTween = [];

var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;

var schedule = function(node, name, id, index, group, timing) {
  var schedules = node.__transition;
  if (!schedules) node.__transition = {};
  else if (id in schedules) return;
  create(node, id, {
    name: name,
    index: index, // For context during callback.
    group: group, // For context during callback.
    on: emptyOn,
    tween: emptyTween,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED
  });
};

function init(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id]) || schedule.state > CREATED) throw new Error("too late");
  return schedule;
}

function set$1(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id]) || schedule.state > STARTING) throw new Error("too late");
  return schedule;
}

function get$1(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id])) throw new Error("too late");
  return schedule;
}

function create(node, id, self) {
  var schedules = node.__transition,
      tween;

  // Initialize the self timer when the transition is created.
  // Note the actual delay is not known until the first callback!
  schedules[id] = self;
  self.timer = timer(schedule, 0, self.time);

  function schedule(elapsed) {
    self.state = SCHEDULED;
    self.timer.restart(start, self.delay, self.time);

    // If the elapsed delay is less than our first sleep, start immediately.
    if (self.delay <= elapsed) start(elapsed - self.delay);
  }

  function start(elapsed) {
    var i, j, n, o;

    // If the state is not SCHEDULED, then we previously errored on start.
    if (self.state !== SCHEDULED) return stop();

    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self.name) continue;

      // While this element already has a starting transition during this frame,
      // defer starting an interrupting transition until that transition has a
      // chance to tick (and possibly end); see d3/d3-transition#54!
      if (o.state === STARTED) return timeout$1(start);

      // Interrupt the active transition, if any.
      // Dispatch the interrupt event.
      if (o.state === RUNNING) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("interrupt", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }

      // Cancel any pre-empted transitions. No interrupt event is dispatched
      // because the cancelled transitions never started. Note that this also
      // removes this transition from the pending list!
      else if (+i < id) {
        o.state = ENDED;
        o.timer.stop();
        delete schedules[i];
      }
    }

    // Defer the first tick to end of the current frame; see d3/d3#1576.
    // Note the transition may be canceled after start and before the first tick!
    // Note this must be scheduled before the start event; see d3/d3-transition#16!
    // Assuming this is successful, subsequent callbacks go straight to tick.
    timeout$1(function() {
      if (self.state === STARTED) {
        self.state = RUNNING;
        self.timer.restart(tick, self.delay, self.time);
        tick(elapsed);
      }
    });

    // Dispatch the start event.
    // Note this must be done before the tween are initialized.
    self.state = STARTING;
    self.on.call("start", node, node.__data__, self.index, self.group);
    if (self.state !== STARTING) return; // interrupted
    self.state = STARTED;

    // Initialize the tween, deleting null tween.
    tween = new Array(n = self.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }

  function tick(elapsed) {
    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
        i = -1,
        n = tween.length;

    while (++i < n) {
      tween[i].call(null, t);
    }

    // Dispatch the end event.
    if (self.state === ENDING) {
      self.on.call("end", node, node.__data__, self.index, self.group);
      stop();
    }
  }

  function stop() {
    self.state = ENDED;
    self.timer.stop();
    delete schedules[id];
    for (var i in schedules) return; // eslint-disable-line no-unused-vars
    delete node.__transition;
  }
}

var interrupt = function(node, name) {
  var schedules = node.__transition,
      schedule,
      active,
      empty = true,
      i;

  if (!schedules) return;

  name = name == null ? null : name + "";

  for (i in schedules) {
    if ((schedule = schedules[i]).name !== name) { empty = false; continue; }
    active = schedule.state > STARTING && schedule.state < ENDING;
    schedule.state = ENDED;
    schedule.timer.stop();
    if (active) schedule.on.call("interrupt", node, node.__data__, schedule.index, schedule.group);
    delete schedules[i];
  }

  if (empty) delete node.__transition;
};

var selection_interrupt = function(name) {
  return this.each(function() {
    interrupt(this, name);
  });
};

function tweenRemove(id, name) {
  var tween0, tween1;
  return function() {
    var schedule = set$1(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }

    schedule.tween = tween1;
  };
}

function tweenFunction(id, name, value) {
  var tween0, tween1;
  if (typeof value !== "function") throw new Error;
  return function() {
    var schedule = set$1(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = {name: name, value: value}, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n) tween1.push(t);
    }

    schedule.tween = tween1;
  };
}

var transition_tween = function(name, value) {
  var id = this._id;

  name += "";

  if (arguments.length < 2) {
    var tween = get$1(this.node(), id).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }

  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
};

function tweenValue(transition, name, value) {
  var id = transition._id;

  transition.each(function() {
    var schedule = set$1(this, id);
    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
  });

  return function(node) {
    return get$1(node, id).value[name];
  };
}

var interpolate$$1 = function(a, b) {
  var c;
  return (typeof b === "number" ? reinterpolate
      : b instanceof color ? interpolateRgb
      : (c = color(b)) ? (b = c, interpolateRgb)
      : interpolateString)(a, b);
};

function attrRemove$1(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS$1(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant$1(name, interpolate$$1, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate$$1(value00 = value0, value1);
  };
}

function attrConstantNS$1(fullname, interpolate$$1, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate$$1(value00 = value0, value1);
  };
}

function attrFunction$1(name, interpolate$$1, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttribute(name);
    value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
  };
}

function attrFunctionNS$1(fullname, interpolate$$1, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
    value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
  };
}

var transition_attr = function(name, value) {
  var fullname = namespace(name), i = fullname === "transform" ? interpolateTransformSvg : interpolate$$1;
  return this.attrTween(name, typeof value === "function"
      ? (fullname.local ? attrFunctionNS$1 : attrFunction$1)(fullname, i, tweenValue(this, "attr." + name, value))
      : value == null ? (fullname.local ? attrRemoveNS$1 : attrRemove$1)(fullname)
      : (fullname.local ? attrConstantNS$1 : attrConstant$1)(fullname, i, value + ""));
};

function attrTweenNS(fullname, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttributeNS(fullname.space, fullname.local, i(t));
    };
  }
  tween._value = value;
  return tween;
}

function attrTween(name, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttribute(name, i(t));
    };
  }
  tween._value = value;
  return tween;
}

var transition_attrTween = function(name, value) {
  var key = "attr." + name;
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  var fullname = namespace(name);
  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
};

function delayFunction(id, value) {
  return function() {
    init(this, id).delay = +value.apply(this, arguments);
  };
}

function delayConstant(id, value) {
  return value = +value, function() {
    init(this, id).delay = value;
  };
}

var transition_delay = function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? delayFunction
          : delayConstant)(id, value))
      : get$1(this.node(), id).delay;
};

function durationFunction(id, value) {
  return function() {
    set$1(this, id).duration = +value.apply(this, arguments);
  };
}

function durationConstant(id, value) {
  return value = +value, function() {
    set$1(this, id).duration = value;
  };
}

var transition_duration = function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? durationFunction
          : durationConstant)(id, value))
      : get$1(this.node(), id).duration;
};

function easeConstant(id, value) {
  if (typeof value !== "function") throw new Error;
  return function() {
    set$1(this, id).ease = value;
  };
}

var transition_ease = function(value) {
  var id = this._id;

  return arguments.length
      ? this.each(easeConstant(id, value))
      : get$1(this.node(), id).ease;
};

var transition_filter = function(match) {
  if (typeof match !== "function") match = matcher$1(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new Transition(subgroups, this._parents, this._name, this._id);
};

var transition_merge = function(transition) {
  if (transition._id !== this._id) throw new Error;

  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new Transition(merges, this._parents, this._name, this._id);
};

function start(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    if (i >= 0) t = t.slice(0, i);
    return !t || t === "start";
  });
}

function onFunction(id, name, listener) {
  var on0, on1, sit = start(name) ? init : set$1;
  return function() {
    var schedule = sit(this, id),
        on = schedule.on;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);

    schedule.on = on1;
  };
}

var transition_on = function(name, listener) {
  var id = this._id;

  return arguments.length < 2
      ? get$1(this.node(), id).on.on(name)
      : this.each(onFunction(id, name, listener));
};

function removeFunction(id) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition) if (+i !== id) return;
    if (parent) parent.removeChild(this);
  };
}

var transition_remove = function() {
  return this.on("end.remove", removeFunction(this._id));
};

var transition_select = function(select$$1) {
  var name = this._name,
      id = this._id;

  if (typeof select$$1 !== "function") select$$1 = selector(select$$1);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select$$1.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
        schedule(subgroup[i], name, id, i, subgroup, get$1(node, id));
      }
    }
  }

  return new Transition(subgroups, this._parents, name, id);
};

var transition_selectAll = function(select$$1) {
  var name = this._name,
      id = this._id;

  if (typeof select$$1 !== "function") select$$1 = selectorAll(select$$1);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        for (var children = select$$1.call(node, node.__data__, i, group), child, inherit = get$1(node, id), k = 0, l = children.length; k < l; ++k) {
          if (child = children[k]) {
            schedule(child, name, id, k, children, inherit);
          }
        }
        subgroups.push(children);
        parents.push(node);
      }
    }
  }

  return new Transition(subgroups, parents, name, id);
};

var Selection$1 = selection.prototype.constructor;

var transition_selection = function() {
  return new Selection$1(this._groups, this._parents);
};

function styleRemove$1(name, interpolate$$2) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0 = styleValue(this, name),
        value1 = (this.style.removeProperty(name), styleValue(this, name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate$$2(value00 = value0, value10 = value1);
  };
}

function styleRemoveEnd(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant$1(name, interpolate$$2, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = styleValue(this, name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate$$2(value00 = value0, value1);
  };
}

function styleFunction$1(name, interpolate$$2, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0 = styleValue(this, name),
        value1 = value(this);
    if (value1 == null) value1 = (this.style.removeProperty(name), styleValue(this, name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate$$2(value00 = value0, value10 = value1);
  };
}

var transition_style = function(name, value, priority) {
  var i = (name += "") === "transform" ? interpolateTransformCss : interpolate$$1;
  return value == null ? this
          .styleTween(name, styleRemove$1(name, i))
          .on("end.style." + name, styleRemoveEnd(name))
      : this.styleTween(name, typeof value === "function"
          ? styleFunction$1(name, i, tweenValue(this, "style." + name, value))
          : styleConstant$1(name, i, value + ""), priority);
};

function styleTween(name, value, priority) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.style.setProperty(name, i(t), priority);
    };
  }
  tween._value = value;
  return tween;
}

var transition_styleTween = function(name, value, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
};

function textConstant$1(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction$1(value) {
  return function() {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}

var transition_text = function(value) {
  return this.tween("text", typeof value === "function"
      ? textFunction$1(tweenValue(this, "text", value))
      : textConstant$1(value == null ? "" : value + ""));
};

var transition_transition = function() {
  var name = this._name,
      id0 = this._id,
      id1 = newId();

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        var inherit = get$1(node, id0);
        schedule(node, name, id1, i, group, {
          time: inherit.time + inherit.delay + inherit.duration,
          delay: 0,
          duration: inherit.duration,
          ease: inherit.ease
        });
      }
    }
  }

  return new Transition(groups, this._parents, name, id1);
};

var id = 0;

function Transition(groups, parents, name, id) {
  this._groups = groups;
  this._parents = parents;
  this._name = name;
  this._id = id;
}

function transition(name) {
  return selection().transition(name);
}

function newId() {
  return ++id;
}

var selection_prototype = selection.prototype;

Transition.prototype = transition.prototype = {
  constructor: Transition,
  select: transition_select,
  selectAll: transition_selectAll,
  filter: transition_filter,
  merge: transition_merge,
  selection: transition_selection,
  transition: transition_transition,
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: transition_on,
  attr: transition_attr,
  attrTween: transition_attrTween,
  style: transition_style,
  styleTween: transition_styleTween,
  text: transition_text,
  remove: transition_remove,
  tween: transition_tween,
  delay: transition_delay,
  duration: transition_duration,
  ease: transition_ease
};

function linear$1(t) {
  return +t;
}

function quadIn(t) {
  return t * t;
}

function quadOut(t) {
  return t * (2 - t);
}

function quadInOut(t) {
  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}

function cubicIn(t) {
  return t * t * t;
}

function cubicOut(t) {
  return --t * t * t + 1;
}

function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

var exponent = 3;

var polyIn = (function custom(e) {
  e = +e;

  function polyIn(t) {
    return Math.pow(t, e);
  }

  polyIn.exponent = custom;

  return polyIn;
})(exponent);

var polyOut = (function custom(e) {
  e = +e;

  function polyOut(t) {
    return 1 - Math.pow(1 - t, e);
  }

  polyOut.exponent = custom;

  return polyOut;
})(exponent);

var polyInOut = (function custom(e) {
  e = +e;

  function polyInOut(t) {
    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
  }

  polyInOut.exponent = custom;

  return polyInOut;
})(exponent);

var pi = Math.PI;
var halfPi = pi / 2;

function sinIn(t) {
  return 1 - Math.cos(t * halfPi);
}

function sinOut(t) {
  return Math.sin(t * halfPi);
}

function sinInOut(t) {
  return (1 - Math.cos(pi * t)) / 2;
}

function expIn(t) {
  return Math.pow(2, 10 * t - 10);
}

function expOut(t) {
  return 1 - Math.pow(2, -10 * t);
}

function expInOut(t) {
  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
}

function circleIn(t) {
  return 1 - Math.sqrt(1 - t * t);
}

function circleOut(t) {
  return Math.sqrt(1 - --t * t);
}

function circleInOut(t) {
  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}

var b1 = 4 / 11;
var b2 = 6 / 11;
var b3 = 8 / 11;
var b4 = 3 / 4;
var b5 = 9 / 11;
var b6 = 10 / 11;
var b7 = 15 / 16;
var b8 = 21 / 22;
var b9 = 63 / 64;
var b0 = 1 / b1 / b1;

function bounceIn(t) {
  return 1 - bounceOut(1 - t);
}

function bounceOut(t) {
  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
}

function bounceInOut(t) {
  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
}

var overshoot = 1.70158;

var backIn = (function custom(s) {
  s = +s;

  function backIn(t) {
    return t * t * ((s + 1) * t - s);
  }

  backIn.overshoot = custom;

  return backIn;
})(overshoot);

var backOut = (function custom(s) {
  s = +s;

  function backOut(t) {
    return --t * t * ((s + 1) * t + s) + 1;
  }

  backOut.overshoot = custom;

  return backOut;
})(overshoot);

var backInOut = (function custom(s) {
  s = +s;

  function backInOut(t) {
    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
  }

  backInOut.overshoot = custom;

  return backInOut;
})(overshoot);

var tau = 2 * Math.PI;
var amplitude = 1;
var period = 0.3;

var elasticIn = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticIn(t) {
    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
  }

  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
  elasticIn.period = function(p) { return custom(a, p); };

  return elasticIn;
})(amplitude, period);

var elasticOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticOut(t) {
    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
  }

  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticOut.period = function(p) { return custom(a, p); };

  return elasticOut;
})(amplitude, period);

var elasticInOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticInOut(t) {
    return ((t = t * 2 - 1) < 0
        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
  }

  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticInOut.period = function(p) { return custom(a, p); };

  return elasticInOut;
})(amplitude, period);

var defaultTiming = {
  time: null, // Set on use.
  delay: 0,
  duration: 250,
  ease: cubicInOut
};

function inherit(node, id) {
  var timing;
  while (!(timing = node.__transition) || !(timing = timing[id])) {
    if (!(node = node.parentNode)) {
      return defaultTiming.time = now(), defaultTiming;
    }
  }
  return timing;
}

var selection_transition = function(name) {
  var id,
      timing;

  if (name instanceof Transition) {
    id = name._id, name = name._name;
  } else {
    id = newId(), (timing = defaultTiming).time = now(), name = name == null ? null : name + "";
  }

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        schedule(node, name, id, i, group, timing || inherit(node, id));
      }
    }
  }

  return new Transition(groups, this._parents, name, id);
};

selection.prototype.interrupt = selection_interrupt;
selection.prototype.transition = selection_transition;

var root$1 = [null];

var active = function(node, name) {
  var schedules = node.__transition,
      schedule,
      i;

  if (schedules) {
    name = name == null ? null : name + "";
    for (i in schedules) {
      if ((schedule = schedules[i]).state > SCHEDULED && schedule.name === name) {
        return new Transition([[node]], root$1, name, +i);
      }
    }
  }

  return null;
};

var constant$4 = function(x) {
  return function() {
    return x;
  };
};

var BrushEvent = function(target, type, selection) {
  this.target = target;
  this.type = type;
  this.selection = selection;
};

function nopropagation$1() {
  exports.event.stopImmediatePropagation();
}

var noevent$1 = function() {
  exports.event.preventDefault();
  exports.event.stopImmediatePropagation();
};

var MODE_DRAG = {name: "drag"};
var MODE_SPACE = {name: "space"};
var MODE_HANDLE = {name: "handle"};
var MODE_CENTER = {name: "center"};

var X = {
  name: "x",
  handles: ["e", "w"].map(type),
  input: function(x, e) { return x && [[x[0], e[0][1]], [x[1], e[1][1]]]; },
  output: function(xy) { return xy && [xy[0][0], xy[1][0]]; }
};

var Y = {
  name: "y",
  handles: ["n", "s"].map(type),
  input: function(y, e) { return y && [[e[0][0], y[0]], [e[1][0], y[1]]]; },
  output: function(xy) { return xy && [xy[0][1], xy[1][1]]; }
};

var XY = {
  name: "xy",
  handles: ["n", "e", "s", "w", "nw", "ne", "se", "sw"].map(type),
  input: function(xy) { return xy; },
  output: function(xy) { return xy; }
};

var cursors = {
  overlay: "crosshair",
  selection: "move",
  n: "ns-resize",
  e: "ew-resize",
  s: "ns-resize",
  w: "ew-resize",
  nw: "nwse-resize",
  ne: "nesw-resize",
  se: "nwse-resize",
  sw: "nesw-resize"
};

var flipX = {
  e: "w",
  w: "e",
  nw: "ne",
  ne: "nw",
  se: "sw",
  sw: "se"
};

var flipY = {
  n: "s",
  s: "n",
  nw: "sw",
  ne: "se",
  se: "ne",
  sw: "nw"
};

var signsX = {
  overlay: +1,
  selection: +1,
  n: null,
  e: +1,
  s: null,
  w: -1,
  nw: -1,
  ne: +1,
  se: +1,
  sw: -1
};

var signsY = {
  overlay: +1,
  selection: +1,
  n: -1,
  e: null,
  s: +1,
  w: null,
  nw: -1,
  ne: -1,
  se: +1,
  sw: +1
};

function type(t) {
  return {type: t};
}

// Ignore right-click, since that should open the context menu.
function defaultFilter() {
  return !exports.event.button;
}

function defaultExtent() {
  var svg = this.ownerSVGElement || this;
  return [[0, 0], [svg.width.baseVal.value, svg.height.baseVal.value]];
}

// Like d3.local, but with the name “__brush” rather than auto-generated.
function local$$1(node) {
  while (!node.__brush) if (!(node = node.parentNode)) return;
  return node.__brush;
}

function empty(extent) {
  return extent[0][0] === extent[1][0]
      || extent[0][1] === extent[1][1];
}

function brushSelection(node) {
  var state = node.__brush;
  return state ? state.dim.output(state.selection) : null;
}

function brushX() {
  return brush$1(X);
}

function brushY() {
  return brush$1(Y);
}

var brush = function() {
  return brush$1(XY);
};

function brush$1(dim) {
  var extent = defaultExtent,
      filter = defaultFilter,
      listeners = dispatch(brush, "start", "brush", "end"),
      handleSize = 6,
      touchending;

  function brush(group) {
    var overlay = group
        .property("__brush", initialize)
      .selectAll(".overlay")
      .data([type("overlay")]);

    overlay.enter().append("rect")
        .attr("class", "overlay")
        .attr("pointer-events", "all")
        .attr("cursor", cursors.overlay)
      .merge(overlay)
        .each(function() {
          var extent = local$$1(this).extent;
          select(this)
              .attr("x", extent[0][0])
              .attr("y", extent[0][1])
              .attr("width", extent[1][0] - extent[0][0])
              .attr("height", extent[1][1] - extent[0][1]);
        });

    group.selectAll(".selection")
      .data([type("selection")])
      .enter().append("rect")
        .attr("class", "selection")
        .attr("cursor", cursors.selection)
        .attr("fill", "#777")
        .attr("fill-opacity", 0.3)
        .attr("stroke", "#fff")
        .attr("shape-rendering", "crispEdges");

    var handle = group.selectAll(".handle")
      .data(dim.handles, function(d) { return d.type; });

    handle.exit().remove();

    handle.enter().append("rect")
        .attr("class", function(d) { return "handle handle--" + d.type; })
        .attr("cursor", function(d) { return cursors[d.type]; });

    group
        .each(redraw)
        .attr("fill", "none")
        .attr("pointer-events", "all")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)")
        .on("mousedown.brush touchstart.brush", started);
  }

  brush.move = function(group, selection$$1) {
    if (group.selection) {
      group
          .on("start.brush", function() { emitter(this, arguments).beforestart().start(); })
          .on("interrupt.brush end.brush", function() { emitter(this, arguments).end(); })
          .tween("brush", function() {
            var that = this,
                state = that.__brush,
                emit = emitter(that, arguments),
                selection0 = state.selection,
                selection1 = dim.input(typeof selection$$1 === "function" ? selection$$1.apply(this, arguments) : selection$$1, state.extent),
                i = interpolateValue(selection0, selection1);

            function tween(t) {
              state.selection = t === 1 && empty(selection1) ? null : i(t);
              redraw.call(that);
              emit.brush();
            }

            return selection0 && selection1 ? tween : tween(1);
          });
    } else {
      group
          .each(function() {
            var that = this,
                args = arguments,
                state = that.__brush,
                selection1 = dim.input(typeof selection$$1 === "function" ? selection$$1.apply(that, args) : selection$$1, state.extent),
                emit = emitter(that, args).beforestart();

            interrupt(that);
            state.selection = selection1 == null || empty(selection1) ? null : selection1;
            redraw.call(that);
            emit.start().brush().end();
          });
    }
  };

  function redraw() {
    var group = select(this),
        selection$$1 = local$$1(this).selection;

    if (selection$$1) {
      group.selectAll(".selection")
          .style("display", null)
          .attr("x", selection$$1[0][0])
          .attr("y", selection$$1[0][1])
          .attr("width", selection$$1[1][0] - selection$$1[0][0])
          .attr("height", selection$$1[1][1] - selection$$1[0][1]);

      group.selectAll(".handle")
          .style("display", null)
          .attr("x", function(d) { return d.type[d.type.length - 1] === "e" ? selection$$1[1][0] - handleSize / 2 : selection$$1[0][0] - handleSize / 2; })
          .attr("y", function(d) { return d.type[0] === "s" ? selection$$1[1][1] - handleSize / 2 : selection$$1[0][1] - handleSize / 2; })
          .attr("width", function(d) { return d.type === "n" || d.type === "s" ? selection$$1[1][0] - selection$$1[0][0] + handleSize : handleSize; })
          .attr("height", function(d) { return d.type === "e" || d.type === "w" ? selection$$1[1][1] - selection$$1[0][1] + handleSize : handleSize; });
    }

    else {
      group.selectAll(".selection,.handle")
          .style("display", "none")
          .attr("x", null)
          .attr("y", null)
          .attr("width", null)
          .attr("height", null);
    }
  }

  function emitter(that, args) {
    return that.__brush.emitter || new Emitter(that, args);
  }

  function Emitter(that, args) {
    this.that = that;
    this.args = args;
    this.state = that.__brush;
    this.active = 0;
  }

  Emitter.prototype = {
    beforestart: function() {
      if (++this.active === 1) this.state.emitter = this, this.starting = true;
      return this;
    },
    start: function() {
      if (this.starting) this.starting = false, this.emit("start");
      return this;
    },
    brush: function() {
      this.emit("brush");
      return this;
    },
    end: function() {
      if (--this.active === 0) delete this.state.emitter, this.emit("end");
      return this;
    },
    emit: function(type) {
      customEvent(new BrushEvent(brush, type, dim.output(this.state.selection)), listeners.apply, listeners, [type, this.that, this.args]);
    }
  };

  function started() {
    if (exports.event.touches) { if (exports.event.changedTouches.length < exports.event.touches.length) return noevent$1(); }
    else if (touchending) return;
    if (!filter.apply(this, arguments)) return;

    var that = this,
        type = exports.event.target.__data__.type,
        mode = (exports.event.metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : (exports.event.altKey ? MODE_CENTER : MODE_HANDLE),
        signX = dim === Y ? null : signsX[type],
        signY = dim === X ? null : signsY[type],
        state = local$$1(that),
        extent = state.extent,
        selection$$1 = state.selection,
        W = extent[0][0], w0, w1,
        N = extent[0][1], n0, n1,
        E = extent[1][0], e0, e1,
        S = extent[1][1], s0, s1,
        dx,
        dy,
        moving,
        shifting = signX && signY && exports.event.shiftKey,
        lockX,
        lockY,
        point0 = mouse(that),
        point = point0,
        emit = emitter(that, arguments).beforestart();

    if (type === "overlay") {
      state.selection = selection$$1 = [
        [w0 = dim === Y ? W : point0[0], n0 = dim === X ? N : point0[1]],
        [e0 = dim === Y ? E : w0, s0 = dim === X ? S : n0]
      ];
    } else {
      w0 = selection$$1[0][0];
      n0 = selection$$1[0][1];
      e0 = selection$$1[1][0];
      s0 = selection$$1[1][1];
    }

    w1 = w0;
    n1 = n0;
    e1 = e0;
    s1 = s0;

    var group = select(that)
        .attr("pointer-events", "none");

    var overlay = group.selectAll(".overlay")
        .attr("cursor", cursors[type]);

    if (exports.event.touches) {
      group
          .on("touchmove.brush", moved, true)
          .on("touchend.brush touchcancel.brush", ended, true);
    } else {
      var view = select(exports.event.view)
          .on("keydown.brush", keydowned, true)
          .on("keyup.brush", keyupped, true)
          .on("mousemove.brush", moved, true)
          .on("mouseup.brush", ended, true);

      dragDisable(exports.event.view);
    }

    nopropagation$1();
    interrupt(that);
    redraw.call(that);
    emit.start();

    function moved() {
      var point1 = mouse(that);
      if (shifting && !lockX && !lockY) {
        if (Math.abs(point1[0] - point[0]) > Math.abs(point1[1] - point[1])) lockY = true;
        else lockX = true;
      }
      point = point1;
      moving = true;
      noevent$1();
      move();
    }

    function move() {
      var t;

      dx = point[0] - point0[0];
      dy = point[1] - point0[1];

      switch (mode) {
        case MODE_SPACE:
        case MODE_DRAG: {
          if (signX) dx = Math.max(W - w0, Math.min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
          if (signY) dy = Math.max(N - n0, Math.min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
          break;
        }
        case MODE_HANDLE: {
          if (signX < 0) dx = Math.max(W - w0, Math.min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
          else if (signX > 0) dx = Math.max(W - e0, Math.min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
          if (signY < 0) dy = Math.max(N - n0, Math.min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
          else if (signY > 0) dy = Math.max(N - s0, Math.min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
          break;
        }
        case MODE_CENTER: {
          if (signX) w1 = Math.max(W, Math.min(E, w0 - dx * signX)), e1 = Math.max(W, Math.min(E, e0 + dx * signX));
          if (signY) n1 = Math.max(N, Math.min(S, n0 - dy * signY)), s1 = Math.max(N, Math.min(S, s0 + dy * signY));
          break;
        }
      }

      if (e1 < w1) {
        signX *= -1;
        t = w0, w0 = e0, e0 = t;
        t = w1, w1 = e1, e1 = t;
        if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
      }

      if (s1 < n1) {
        signY *= -1;
        t = n0, n0 = s0, s0 = t;
        t = n1, n1 = s1, s1 = t;
        if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
      }

      if (state.selection) selection$$1 = state.selection; // May be set by brush.move!
      if (lockX) w1 = selection$$1[0][0], e1 = selection$$1[1][0];
      if (lockY) n1 = selection$$1[0][1], s1 = selection$$1[1][1];

      if (selection$$1[0][0] !== w1
          || selection$$1[0][1] !== n1
          || selection$$1[1][0] !== e1
          || selection$$1[1][1] !== s1) {
        state.selection = [[w1, n1], [e1, s1]];
        redraw.call(that);
        emit.brush();
      }
    }

    function ended() {
      nopropagation$1();
      if (exports.event.touches) {
        if (exports.event.touches.length) return;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
        group.on("touchmove.brush touchend.brush touchcancel.brush", null);
      } else {
        yesdrag(exports.event.view, moving);
        view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
      }
      group.attr("pointer-events", "all");
      overlay.attr("cursor", cursors.overlay);
      if (state.selection) selection$$1 = state.selection; // May be set by brush.move (on start)!
      if (empty(selection$$1)) state.selection = null, redraw.call(that);
      emit.end();
    }

    function keydowned() {
      switch (exports.event.keyCode) {
        case 16: { // SHIFT
          shifting = signX && signY;
          break;
        }
        case 18: { // ALT
          if (mode === MODE_HANDLE) {
            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
            mode = MODE_CENTER;
            move();
          }
          break;
        }
        case 32: { // SPACE; takes priority over ALT
          if (mode === MODE_HANDLE || mode === MODE_CENTER) {
            if (signX < 0) e0 = e1 - dx; else if (signX > 0) w0 = w1 - dx;
            if (signY < 0) s0 = s1 - dy; else if (signY > 0) n0 = n1 - dy;
            mode = MODE_SPACE;
            overlay.attr("cursor", cursors.selection);
            move();
          }
          break;
        }
        default: return;
      }
      noevent$1();
    }

    function keyupped() {
      switch (exports.event.keyCode) {
        case 16: { // SHIFT
          if (shifting) {
            lockX = lockY = shifting = false;
            move();
          }
          break;
        }
        case 18: { // ALT
          if (mode === MODE_CENTER) {
            if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
            if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
            mode = MODE_HANDLE;
            move();
          }
          break;
        }
        case 32: { // SPACE
          if (mode === MODE_SPACE) {
            if (exports.event.altKey) {
              if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
              if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
              mode = MODE_CENTER;
            } else {
              if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
              if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
              mode = MODE_HANDLE;
            }
            overlay.attr("cursor", cursors[type]);
            move();
          }
          break;
        }
        default: return;
      }
      noevent$1();
    }
  }

  function initialize() {
    var state = this.__brush || {selection: null};
    state.extent = extent.apply(this, arguments);
    state.dim = dim;
    return state;
  }

  brush.extent = function(_) {
    return arguments.length ? (extent = typeof _ === "function" ? _ : constant$4([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), brush) : extent;
  };

  brush.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : constant$4(!!_), brush) : filter;
  };

  brush.handleSize = function(_) {
    return arguments.length ? (handleSize = +_, brush) : handleSize;
  };

  brush.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? brush : value;
  };

  return brush;
}

var cos = Math.cos;
var sin = Math.sin;
var pi$1 = Math.PI;
var halfPi$1 = pi$1 / 2;
var tau$1 = pi$1 * 2;
var max$1 = Math.max;

function compareValue(compare) {
  return function(a, b) {
    return compare(
      a.source.value + a.target.value,
      b.source.value + b.target.value
    );
  };
}

var chord = function() {
  var padAngle = 0,
      sortGroups = null,
      sortSubgroups = null,
      sortChords = null;

  function chord(matrix) {
    var n = matrix.length,
        groupSums = [],
        groupIndex = sequence(n),
        subgroupIndex = [],
        chords = [],
        groups = chords.groups = new Array(n),
        subgroups = new Array(n * n),
        k,
        x,
        x0,
        dx,
        i,
        j;

    // Compute the sum.
    k = 0, i = -1; while (++i < n) {
      x = 0, j = -1; while (++j < n) {
        x += matrix[i][j];
      }
      groupSums.push(x);
      subgroupIndex.push(sequence(n));
      k += x;
    }

    // Sort groups…
    if (sortGroups) groupIndex.sort(function(a, b) {
      return sortGroups(groupSums[a], groupSums[b]);
    });

    // Sort subgroups…
    if (sortSubgroups) subgroupIndex.forEach(function(d, i) {
      d.sort(function(a, b) {
        return sortSubgroups(matrix[i][a], matrix[i][b]);
      });
    });

    // Convert the sum to scaling factor for [0, 2pi].
    // TODO Allow start and end angle to be specified?
    // TODO Allow padding to be specified as percentage?
    k = max$1(0, tau$1 - padAngle * n) / k;
    dx = k ? padAngle : tau$1 / n;

    // Compute the start and end angle for each group and subgroup.
    // Note: Opera has a bug reordering object literal properties!
    x = 0, i = -1; while (++i < n) {
      x0 = x, j = -1; while (++j < n) {
        var di = groupIndex[i],
            dj = subgroupIndex[di][j],
            v = matrix[di][dj],
            a0 = x,
            a1 = x += v * k;
        subgroups[dj * n + di] = {
          index: di,
          subindex: dj,
          startAngle: a0,
          endAngle: a1,
          value: v
        };
      }
      groups[di] = {
        index: di,
        startAngle: x0,
        endAngle: x,
        value: groupSums[di]
      };
      x += dx;
    }

    // Generate chords for each (non-empty) subgroup-subgroup link.
    i = -1; while (++i < n) {
      j = i - 1; while (++j < n) {
        var source = subgroups[j * n + i],
            target = subgroups[i * n + j];
        if (source.value || target.value) {
          chords.push(source.value < target.value
              ? {source: target, target: source}
              : {source: source, target: target});
        }
      }
    }

    return sortChords ? chords.sort(sortChords) : chords;
  }

  chord.padAngle = function(_) {
    return arguments.length ? (padAngle = max$1(0, _), chord) : padAngle;
  };

  chord.sortGroups = function(_) {
    return arguments.length ? (sortGroups = _, chord) : sortGroups;
  };

  chord.sortSubgroups = function(_) {
    return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
  };

  chord.sortChords = function(_) {
    return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
  };

  return chord;
};

var slice$2 = Array.prototype.slice;

var constant$5 = function(x) {
  return function() {
    return x;
  };
};

var pi$2 = Math.PI;
var tau$2 = 2 * pi$2;
var epsilon$1 = 1e-6;
var tauEpsilon = tau$2 - epsilon$1;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path;
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon$1)) {}

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon$1) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi$2 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon$1) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon$1 || Math.abs(this._y1 - y0) > epsilon$1) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau$2 + tau$2;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon$1) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi$2)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

function defaultSource(d) {
  return d.source;
}

function defaultTarget(d) {
  return d.target;
}

function defaultRadius(d) {
  return d.radius;
}

function defaultStartAngle(d) {
  return d.startAngle;
}

function defaultEndAngle(d) {
  return d.endAngle;
}

var ribbon = function() {
  var source = defaultSource,
      target = defaultTarget,
      radius = defaultRadius,
      startAngle = defaultStartAngle,
      endAngle = defaultEndAngle,
      context = null;

  function ribbon() {
    var buffer,
        argv = slice$2.call(arguments),
        s = source.apply(this, argv),
        t = target.apply(this, argv),
        sr = +radius.apply(this, (argv[0] = s, argv)),
        sa0 = startAngle.apply(this, argv) - halfPi$1,
        sa1 = endAngle.apply(this, argv) - halfPi$1,
        sx0 = sr * cos(sa0),
        sy0 = sr * sin(sa0),
        tr = +radius.apply(this, (argv[0] = t, argv)),
        ta0 = startAngle.apply(this, argv) - halfPi$1,
        ta1 = endAngle.apply(this, argv) - halfPi$1;

    if (!context) context = buffer = path();

    context.moveTo(sx0, sy0);
    context.arc(0, 0, sr, sa0, sa1);
    if (sa0 !== ta0 || sa1 !== ta1) { // TODO sr !== tr?
      context.quadraticCurveTo(0, 0, tr * cos(ta0), tr * sin(ta0));
      context.arc(0, 0, tr, ta0, ta1);
    }
    context.quadraticCurveTo(0, 0, sx0, sy0);
    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  ribbon.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$5(+_), ribbon) : radius;
  };

  ribbon.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$5(+_), ribbon) : startAngle;
  };

  ribbon.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$5(+_), ribbon) : endAngle;
  };

  ribbon.source = function(_) {
    return arguments.length ? (source = _, ribbon) : source;
  };

  ribbon.target = function(_) {
    return arguments.length ? (target = _, ribbon) : target;
  };

  ribbon.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), ribbon) : context;
  };

  return ribbon;
};

var prefix = "$";

function Map() {}

Map.prototype = map$1.prototype = {
  constructor: Map,
  has: function(key) {
    return (prefix + key) in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this) if (property[0] === prefix) delete this[property];
  },
  keys: function() {
    var keys = [];
    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
    return keys;
  },
  values: function() {
    var values = [];
    for (var property in this) if (property[0] === prefix) values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property in this) if (property[0] === prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property in this) if (property[0] === prefix) return false;
    return true;
  },
  each: function(f) {
    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
  }
};

function map$1(object, f) {
  var map = new Map;

  // Copy constructor.
  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
    var i = -1,
        n = object.length,
        o;

    if (f == null) while (++i < n) map.set(i, object[i]);
    else while (++i < n) map.set(f(o = object[i], i, object), o);
  }

  // Convert object to map.
  else if (object) for (var key in object) map.set(key, object[key]);

  return map;
}

var nest = function() {
  var keys = [],
      sortKeys = [],
      sortValues,
      rollup,
      nest;

  function apply(array, depth, createResult, setResult) {
    if (depth >= keys.length) return rollup != null
        ? rollup(array) : (sortValues != null
        ? array.sort(sortValues)
        : array);

    var i = -1,
        n = array.length,
        key = keys[depth++],
        keyValue,
        value,
        valuesByKey = map$1(),
        values,
        result = createResult();

    while (++i < n) {
      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
        values.push(value);
      } else {
        valuesByKey.set(keyValue, [value]);
      }
    }

    valuesByKey.each(function(values, key) {
      setResult(result, key, apply(values, depth, createResult, setResult));
    });

    return result;
  }

  function entries(map, depth) {
    if (++depth > keys.length) return map;
    var array, sortKey = sortKeys[depth - 1];
    if (rollup != null && depth >= keys.length) array = map.entries();
    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
  }

  return nest = {
    object: function(array) { return apply(array, 0, createObject, setObject); },
    map: function(array) { return apply(array, 0, createMap, setMap); },
    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
    key: function(d) { keys.push(d); return nest; },
    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
    sortValues: function(order) { sortValues = order; return nest; },
    rollup: function(f) { rollup = f; return nest; }
  };
};

function createObject() {
  return {};
}

function setObject(object, key, value) {
  object[key] = value;
}

function createMap() {
  return map$1();
}

function setMap(map, key, value) {
  map.set(key, value);
}

function Set() {}

var proto = map$1.prototype;

Set.prototype = set$2.prototype = {
  constructor: Set,
  has: proto.has,
  add: function(value) {
    value += "";
    this[prefix + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function set$2(object, f) {
  var set = new Set;

  // Copy constructor.
  if (object instanceof Set) object.each(function(value) { set.add(value); });

  // Otherwise, assume it’s an array.
  else if (object) {
    var i = -1, n = object.length;
    if (f == null) while (++i < n) set.add(object[i]);
    else while (++i < n) set.add(f(object[i], i, object));
  }

  return set;
}

var keys = function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
};

var values = function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
};

var entries = function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
};

function objectConverter(columns) {
  return new Function("d", "return {" + columns.map(function(name, i) {
    return JSON.stringify(name) + ": d[" + i + "]";
  }).join(",") + "}");
}

function customConverter(columns, f) {
  var object = objectConverter(columns);
  return function(row, i) {
    return f(object(row), i, columns);
  };
}

// Compute unique columns in order of discovery.
function inferColumns(rows) {
  var columnSet = Object.create(null),
      columns = [];

  rows.forEach(function(row) {
    for (var column in row) {
      if (!(column in columnSet)) {
        columns.push(columnSet[column] = column);
      }
    }
  });

  return columns;
}

var dsv = function(delimiter) {
  var reFormat = new RegExp("[\"" + delimiter + "\n\r]"),
      delimiterCode = delimiter.charCodeAt(0);

  function parse(text, f) {
    var convert, columns, rows = parseRows(text, function(row, i) {
      if (convert) return convert(row, i - 1);
      columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
    });
    rows.columns = columns;
    return rows;
  }

  function parseRows(text, f) {
    var EOL = {}, // sentinel value for end-of-line
        EOF = {}, // sentinel value for end-of-file
        rows = [], // output rows
        N = text.length,
        I = 0, // current character index
        n = 0, // the current line number
        t, // the current token
        eol; // is the current token followed by EOL?

    function token() {
      if (I >= N) return EOF; // special case: end of file
      if (eol) return eol = false, EOL; // special case: end of line

      // special case: quotes
      var j = I, c;
      if (text.charCodeAt(j) === 34) {
        var i = j;
        while (i++ < N) {
          if (text.charCodeAt(i) === 34) {
            if (text.charCodeAt(i + 1) !== 34) break;
            ++i;
          }
        }
        I = i + 2;
        c = text.charCodeAt(i + 1);
        if (c === 13) {
          eol = true;
          if (text.charCodeAt(i + 2) === 10) ++I;
        } else if (c === 10) {
          eol = true;
        }
        return text.slice(j + 1, i).replace(/""/g, "\"");
      }

      // common case: find next delimiter or newline
      while (I < N) {
        var k = 1;
        c = text.charCodeAt(I++);
        if (c === 10) eol = true; // \n
        else if (c === 13) { eol = true; if (text.charCodeAt(I) === 10) ++I, ++k; } // \r|\r\n
        else if (c !== delimiterCode) continue;
        return text.slice(j, I - k);
      }

      // special case: last token before EOF
      return text.slice(j);
    }

    while ((t = token()) !== EOF) {
      var a = [];
      while (t !== EOL && t !== EOF) {
        a.push(t);
        t = token();
      }
      if (f && (a = f(a, n++)) == null) continue;
      rows.push(a);
    }

    return rows;
  }

  function format(rows, columns) {
    if (columns == null) columns = inferColumns(rows);
    return [columns.map(formatValue).join(delimiter)].concat(rows.map(function(row) {
      return columns.map(function(column) {
        return formatValue(row[column]);
      }).join(delimiter);
    })).join("\n");
  }

  function formatRows(rows) {
    return rows.map(formatRow).join("\n");
  }

  function formatRow(row) {
    return row.map(formatValue).join(delimiter);
  }

  function formatValue(text) {
    return text == null ? ""
        : reFormat.test(text += "") ? "\"" + text.replace(/\"/g, "\"\"") + "\""
        : text;
  }

  return {
    parse: parse,
    parseRows: parseRows,
    format: format,
    formatRows: formatRows
  };
};

var csv = dsv(",");

var csvParse = csv.parse;
var csvParseRows = csv.parseRows;
var csvFormat = csv.format;
var csvFormatRows = csv.formatRows;

var tsv = dsv("\t");

var tsvParse = tsv.parse;
var tsvParseRows = tsv.parseRows;
var tsvFormat = tsv.format;
var tsvFormatRows = tsv.formatRows;

var center$1 = function(x, y) {
  var nodes;

  if (x == null) x = 0;
  if (y == null) y = 0;

  function force() {
    var i,
        n = nodes.length,
        node,
        sx = 0,
        sy = 0;

    for (i = 0; i < n; ++i) {
      node = nodes[i], sx += node.x, sy += node.y;
    }

    for (sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i) {
      node = nodes[i], node.x -= sx, node.y -= sy;
    }
  }

  force.initialize = function(_) {
    nodes = _;
  };

  force.x = function(_) {
    return arguments.length ? (x = +_, force) : x;
  };

  force.y = function(_) {
    return arguments.length ? (y = +_, force) : y;
  };

  return force;
};

var constant$6 = function(x) {
  return function() {
    return x;
  };
};

var jiggle = function() {
  return (Math.random() - 0.5) * 1e-6;
};

var tree_add = function(d) {
  var x = +this._x.call(null, d),
      y = +this._y.call(null, d);
  return add(this.cover(x, y), x, y, d);
};

function add(tree, x, y, d) {
  if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points

  var parent,
      node = tree._root,
      leaf = {data: d},
      x0 = tree._x0,
      y0 = tree._y0,
      x1 = tree._x1,
      y1 = tree._y1,
      xm,
      ym,
      xp,
      yp,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return tree._root = leaf, tree;

  // Find the existing leaf for the new point, or add it.
  while (node.length) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
  }

  // Is the new point is exactly coincident with the existing point?
  xp = +tree._x.call(null, node.data);
  yp = +tree._y.call(null, node.data);
  if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;

  // Otherwise, split the leaf node until the old and new point are separated.
  do {
    parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
  } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | (xp >= xm)));
  return parent[j] = node, parent[i] = leaf, tree;
}

function addAll(data) {
  var d, i, n = data.length,
      x,
      y,
      xz = new Array(n),
      yz = new Array(n),
      x0 = Infinity,
      y0 = Infinity,
      x1 = -Infinity,
      y1 = -Infinity;

  // Compute the points and their extent.
  for (i = 0; i < n; ++i) {
    if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
    xz[i] = x;
    yz[i] = y;
    if (x < x0) x0 = x;
    if (x > x1) x1 = x;
    if (y < y0) y0 = y;
    if (y > y1) y1 = y;
  }

  // If there were no (valid) points, inherit the existing extent.
  if (x1 < x0) x0 = this._x0, x1 = this._x1;
  if (y1 < y0) y0 = this._y0, y1 = this._y1;

  // Expand the tree to cover the new points.
  this.cover(x0, y0).cover(x1, y1);

  // Add the new points.
  for (i = 0; i < n; ++i) {
    add(this, xz[i], yz[i], data[i]);
  }

  return this;
}

var tree_cover = function(x, y) {
  if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points

  var x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1;

  // If the quadtree has no extent, initialize them.
  // Integer extent are necessary so that if we later double the extent,
  // the existing quadrant boundaries don’t change due to floating point error!
  if (isNaN(x0)) {
    x1 = (x0 = Math.floor(x)) + 1;
    y1 = (y0 = Math.floor(y)) + 1;
  }

  // Otherwise, double repeatedly to cover.
  else if (x0 > x || x > x1 || y0 > y || y > y1) {
    var z = x1 - x0,
        node = this._root,
        parent,
        i;

    switch (i = (y < (y0 + y1) / 2) << 1 | (x < (x0 + x1) / 2)) {
      case 0: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x1 = x0 + z, y1 = y0 + z, x > x1 || y > y1);
        break;
      }
      case 1: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x0 = x1 - z, y1 = y0 + z, x0 > x || y > y1);
        break;
      }
      case 2: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x1 = x0 + z, y0 = y1 - z, x > x1 || y0 > y);
        break;
      }
      case 3: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x0 = x1 - z, y0 = y1 - z, x0 > x || y0 > y);
        break;
      }
    }

    if (this._root && this._root.length) this._root = node;
  }

  // If the quadtree covers the point already, just return.
  else return this;

  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  return this;
};

var tree_data = function() {
  var data = [];
  this.visit(function(node) {
    if (!node.length) do data.push(node.data); while (node = node.next)
  });
  return data;
};

var tree_extent = function(_) {
  return arguments.length
      ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1])
      : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
};

var Quad = function(node, x0, y0, x1, y1) {
  this.node = node;
  this.x0 = x0;
  this.y0 = y0;
  this.x1 = x1;
  this.y1 = y1;
};

var tree_find = function(x, y, radius) {
  var data,
      x0 = this._x0,
      y0 = this._y0,
      x1,
      y1,
      x2,
      y2,
      x3 = this._x1,
      y3 = this._y1,
      quads = [],
      node = this._root,
      q,
      i;

  if (node) quads.push(new Quad(node, x0, y0, x3, y3));
  if (radius == null) radius = Infinity;
  else {
    x0 = x - radius, y0 = y - radius;
    x3 = x + radius, y3 = y + radius;
    radius *= radius;
  }

  while (q = quads.pop()) {

    // Stop searching if this quadrant can’t contain a closer node.
    if (!(node = q.node)
        || (x1 = q.x0) > x3
        || (y1 = q.y0) > y3
        || (x2 = q.x1) < x0
        || (y2 = q.y1) < y0) continue;

    // Bisect the current quadrant.
    if (node.length) {
      var xm = (x1 + x2) / 2,
          ym = (y1 + y2) / 2;

      quads.push(
        new Quad(node[3], xm, ym, x2, y2),
        new Quad(node[2], x1, ym, xm, y2),
        new Quad(node[1], xm, y1, x2, ym),
        new Quad(node[0], x1, y1, xm, ym)
      );

      // Visit the closest quadrant first.
      if (i = (y >= ym) << 1 | (x >= xm)) {
        q = quads[quads.length - 1];
        quads[quads.length - 1] = quads[quads.length - 1 - i];
        quads[quads.length - 1 - i] = q;
      }
    }

    // Visit this point. (Visiting coincident points isn’t necessary!)
    else {
      var dx = x - +this._x.call(null, node.data),
          dy = y - +this._y.call(null, node.data),
          d2 = dx * dx + dy * dy;
      if (d2 < radius) {
        var d = Math.sqrt(radius = d2);
        x0 = x - d, y0 = y - d;
        x3 = x + d, y3 = y + d;
        data = node.data;
      }
    }
  }

  return data;
};

var tree_remove = function(d) {
  if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points

  var parent,
      node = this._root,
      retainer,
      previous,
      next,
      x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1,
      x,
      y,
      xm,
      ym,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return this;

  // Find the leaf node for the point.
  // While descending, also retain the deepest parent with a non-removed sibling.
  if (node.length) while (true) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
    if (!node.length) break;
    if (parent[(i + 1) & 3] || parent[(i + 2) & 3] || parent[(i + 3) & 3]) retainer = parent, j = i;
  }

  // Find the point to remove.
  while (node.data !== d) if (!(previous = node, node = node.next)) return this;
  if (next = node.next) delete node.next;

  // If there are multiple coincident points, remove just the point.
  if (previous) return (next ? previous.next = next : delete previous.next), this;

  // If this is the root point, remove it.
  if (!parent) return this._root = next, this;

  // Remove this leaf.
  next ? parent[i] = next : delete parent[i];

  // If the parent now contains exactly one leaf, collapse superfluous parents.
  if ((node = parent[0] || parent[1] || parent[2] || parent[3])
      && node === (parent[3] || parent[2] || parent[1] || parent[0])
      && !node.length) {
    if (retainer) retainer[j] = node;
    else this._root = node;
  }

  return this;
};

function removeAll(data) {
  for (var i = 0, n = data.length; i < n; ++i) this.remove(data[i]);
  return this;
}

var tree_root = function() {
  return this._root;
};

var tree_size = function() {
  var size = 0;
  this.visit(function(node) {
    if (!node.length) do ++size; while (node = node.next)
  });
  return size;
};

var tree_visit = function(callback) {
  var quads = [], q, node = this._root, child, x0, y0, x1, y1;
  if (node) quads.push(new Quad(node, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
      var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
      if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
      if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
      if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
    }
  }
  return this;
};

var tree_visitAfter = function(callback) {
  var quads = [], next = [], q;
  if (this._root) quads.push(new Quad(this._root, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    var node = q.node;
    if (node.length) {
      var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
      if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
      if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
      if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
    }
    next.push(q);
  }
  while (q = next.pop()) {
    callback(q.node, q.x0, q.y0, q.x1, q.y1);
  }
  return this;
};

function defaultX(d) {
  return d[0];
}

var tree_x = function(_) {
  return arguments.length ? (this._x = _, this) : this._x;
};

function defaultY(d) {
  return d[1];
}

var tree_y = function(_) {
  return arguments.length ? (this._y = _, this) : this._y;
};

function quadtree(nodes, x, y) {
  var tree = new Quadtree(x == null ? defaultX : x, y == null ? defaultY : y, NaN, NaN, NaN, NaN);
  return nodes == null ? tree : tree.addAll(nodes);
}

function Quadtree(x, y, x0, y0, x1, y1) {
  this._x = x;
  this._y = y;
  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  this._root = undefined;
}

function leaf_copy(leaf) {
  var copy = {data: leaf.data}, next = copy;
  while (leaf = leaf.next) next = next.next = {data: leaf.data};
  return copy;
}

var treeProto = quadtree.prototype = Quadtree.prototype;

treeProto.copy = function() {
  var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
      node = this._root,
      nodes,
      child;

  if (!node) return copy;

  if (!node.length) return copy._root = leaf_copy(node), copy;

  nodes = [{source: node, target: copy._root = new Array(4)}];
  while (node = nodes.pop()) {
    for (var i = 0; i < 4; ++i) {
      if (child = node.source[i]) {
        if (child.length) nodes.push({source: child, target: node.target[i] = new Array(4)});
        else node.target[i] = leaf_copy(child);
      }
    }
  }

  return copy;
};

treeProto.add = tree_add;
treeProto.addAll = addAll;
treeProto.cover = tree_cover;
treeProto.data = tree_data;
treeProto.extent = tree_extent;
treeProto.find = tree_find;
treeProto.remove = tree_remove;
treeProto.removeAll = removeAll;
treeProto.root = tree_root;
treeProto.size = tree_size;
treeProto.visit = tree_visit;
treeProto.visitAfter = tree_visitAfter;
treeProto.x = tree_x;
treeProto.y = tree_y;

function x(d) {
  return d.x + d.vx;
}

function y(d) {
  return d.y + d.vy;
}

var collide = function(radius) {
  var nodes,
      radii,
      strength = 1,
      iterations = 1;

  if (typeof radius !== "function") radius = constant$6(radius == null ? 1 : +radius);

  function force() {
    var i, n = nodes.length,
        tree,
        node,
        xi,
        yi,
        ri,
        ri2;

    for (var k = 0; k < iterations; ++k) {
      tree = quadtree(nodes, x, y).visitAfter(prepare);
      for (i = 0; i < n; ++i) {
        node = nodes[i];
        ri = radii[node.index], ri2 = ri * ri;
        xi = node.x + node.vx;
        yi = node.y + node.vy;
        tree.visit(apply);
      }
    }

    function apply(quad, x0, y0, x1, y1) {
      var data = quad.data, rj = quad.r, r = ri + rj;
      if (data) {
        if (data.index > node.index) {
          var x = xi - data.x - data.vx,
              y = yi - data.y - data.vy,
              l = x * x + y * y;
          if (l < r * r) {
            if (x === 0) x = jiggle(), l += x * x;
            if (y === 0) y = jiggle(), l += y * y;
            l = (r - (l = Math.sqrt(l))) / l * strength;
            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
            node.vy += (y *= l) * r;
            data.vx -= x * (r = 1 - r);
            data.vy -= y * r;
          }
        }
        return;
      }
      return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
    }
  }

  function prepare(quad) {
    if (quad.data) return quad.r = radii[quad.data.index];
    for (var i = quad.r = 0; i < 4; ++i) {
      if (quad[i] && quad[i].r > quad.r) {
        quad.r = quad[i].r;
      }
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    radii = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], radii[node.index] = +radius(node, i, nodes);
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = +_, force) : strength;
  };

  force.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : radius;
  };

  return force;
};

function index(d) {
  return d.index;
}

function find(nodeById, nodeId) {
  var node = nodeById.get(nodeId);
  if (!node) throw new Error("missing: " + nodeId);
  return node;
}

var link = function(links) {
  var id = index,
      strength = defaultStrength,
      strengths,
      distance = constant$6(30),
      distances,
      nodes,
      count,
      bias,
      iterations = 1;

  if (links == null) links = [];

  function defaultStrength(link) {
    return 1 / Math.min(count[link.source.index], count[link.target.index]);
  }

  function force(alpha) {
    for (var k = 0, n = links.length; k < iterations; ++k) {
      for (var i = 0, link, source, target, x, y, l, b; i < n; ++i) {
        link = links[i], source = link.source, target = link.target;
        x = target.x + target.vx - source.x - source.vx || jiggle();
        y = target.y + target.vy - source.y - source.vy || jiggle();
        l = Math.sqrt(x * x + y * y);
        l = (l - distances[i]) / l * alpha * strengths[i];
        x *= l, y *= l;
        target.vx -= x * (b = bias[i]);
        target.vy -= y * b;
        source.vx += x * (b = 1 - b);
        source.vy += y * b;
      }
    }
  }

  function initialize() {
    if (!nodes) return;

    var i,
        n = nodes.length,
        m = links.length,
        nodeById = map$1(nodes, id),
        link;

    for (i = 0, count = new Array(n); i < m; ++i) {
      link = links[i], link.index = i;
      if (typeof link.source !== "object") link.source = find(nodeById, link.source);
      if (typeof link.target !== "object") link.target = find(nodeById, link.target);
      count[link.source.index] = (count[link.source.index] || 0) + 1;
      count[link.target.index] = (count[link.target.index] || 0) + 1;
    }

    for (i = 0, bias = new Array(m); i < m; ++i) {
      link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
    }

    strengths = new Array(m), initializeStrength();
    distances = new Array(m), initializeDistance();
  }

  function initializeStrength() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      strengths[i] = +strength(links[i], i, links);
    }
  }

  function initializeDistance() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      distances[i] = +distance(links[i], i, links);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.links = function(_) {
    return arguments.length ? (links = _, initialize(), force) : links;
  };

  force.id = function(_) {
    return arguments.length ? (id = _, force) : id;
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$6(+_), initializeStrength(), force) : strength;
  };

  force.distance = function(_) {
    return arguments.length ? (distance = typeof _ === "function" ? _ : constant$6(+_), initializeDistance(), force) : distance;
  };

  return force;
};

function x$1(d) {
  return d.x;
}

function y$1(d) {
  return d.y;
}

var initialRadius = 10;
var initialAngle = Math.PI * (3 - Math.sqrt(5));

var simulation = function(nodes) {
  var simulation,
      alpha = 1,
      alphaMin = 0.001,
      alphaDecay = 1 - Math.pow(alphaMin, 1 / 300),
      alphaTarget = 0,
      velocityDecay = 0.6,
      forces = map$1(),
      stepper = timer(step),
      event = dispatch("tick", "end");

  if (nodes == null) nodes = [];

  function step() {
    tick();
    event.call("tick", simulation);
    if (alpha < alphaMin) {
      stepper.stop();
      event.call("end", simulation);
    }
  }

  function tick() {
    var i, n = nodes.length, node;

    alpha += (alphaTarget - alpha) * alphaDecay;

    forces.each(function(force) {
      force(alpha);
    });

    for (i = 0; i < n; ++i) {
      node = nodes[i];
      if (node.fx == null) node.x += node.vx *= velocityDecay;
      else node.x = node.fx, node.vx = 0;
      if (node.fy == null) node.y += node.vy *= velocityDecay;
      else node.y = node.fy, node.vy = 0;
    }
  }

  function initializeNodes() {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.index = i;
      if (isNaN(node.x) || isNaN(node.y)) {
        var radius = initialRadius * Math.sqrt(i), angle = i * initialAngle;
        node.x = radius * Math.cos(angle);
        node.y = radius * Math.sin(angle);
      }
      if (isNaN(node.vx) || isNaN(node.vy)) {
        node.vx = node.vy = 0;
      }
    }
  }

  function initializeForce(force) {
    if (force.initialize) force.initialize(nodes);
    return force;
  }

  initializeNodes();

  return simulation = {
    tick: tick,

    restart: function() {
      return stepper.restart(step), simulation;
    },

    stop: function() {
      return stepper.stop(), simulation;
    },

    nodes: function(_) {
      return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : nodes;
    },

    alpha: function(_) {
      return arguments.length ? (alpha = +_, simulation) : alpha;
    },

    alphaMin: function(_) {
      return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
    },

    alphaDecay: function(_) {
      return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
    },

    alphaTarget: function(_) {
      return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
    },

    velocityDecay: function(_) {
      return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
    },

    force: function(name, _) {
      return arguments.length > 1 ? ((_ == null ? forces.remove(name) : forces.set(name, initializeForce(_))), simulation) : forces.get(name);
    },

    find: function(x, y, radius) {
      var i = 0,
          n = nodes.length,
          dx,
          dy,
          d2,
          node,
          closest;

      if (radius == null) radius = Infinity;
      else radius *= radius;

      for (i = 0; i < n; ++i) {
        node = nodes[i];
        dx = x - node.x;
        dy = y - node.y;
        d2 = dx * dx + dy * dy;
        if (d2 < radius) closest = node, radius = d2;
      }

      return closest;
    },

    on: function(name, _) {
      return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
    }
  };
};

var manyBody = function() {
  var nodes,
      node,
      alpha,
      strength = constant$6(-30),
      strengths,
      distanceMin2 = 1,
      distanceMax2 = Infinity,
      theta2 = 0.81;

  function force(_) {
    var i, n = nodes.length, tree = quadtree(nodes, x$1, y$1).visitAfter(accumulate);
    for (alpha = _, i = 0; i < n; ++i) node = nodes[i], tree.visit(apply);
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    strengths = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
  }

  function accumulate(quad) {
    var strength = 0, q, c, x$$1, y$$1, i;

    // For internal nodes, accumulate forces from child quadrants.
    if (quad.length) {
      for (x$$1 = y$$1 = i = 0; i < 4; ++i) {
        if ((q = quad[i]) && (c = q.value)) {
          strength += c, x$$1 += c * q.x, y$$1 += c * q.y;
        }
      }
      quad.x = x$$1 / strength;
      quad.y = y$$1 / strength;
    }

    // For leaf nodes, accumulate forces from coincident quadrants.
    else {
      q = quad;
      q.x = q.data.x;
      q.y = q.data.y;
      do strength += strengths[q.data.index];
      while (q = q.next);
    }

    quad.value = strength;
  }

  function apply(quad, x1, _, x2) {
    if (!quad.value) return true;

    var x$$1 = quad.x - node.x,
        y$$1 = quad.y - node.y,
        w = x2 - x1,
        l = x$$1 * x$$1 + y$$1 * y$$1;

    // Apply the Barnes-Hut approximation if possible.
    // Limit forces for very close nodes; randomize direction if coincident.
    if (w * w / theta2 < l) {
      if (l < distanceMax2) {
        if (x$$1 === 0) x$$1 = jiggle(), l += x$$1 * x$$1;
        if (y$$1 === 0) y$$1 = jiggle(), l += y$$1 * y$$1;
        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        node.vx += x$$1 * quad.value * alpha / l;
        node.vy += y$$1 * quad.value * alpha / l;
      }
      return true;
    }

    // Otherwise, process points directly.
    else if (quad.length || l >= distanceMax2) return;

    // Limit forces for very close nodes; randomize direction if coincident.
    if (quad.data !== node || quad.next) {
      if (x$$1 === 0) x$$1 = jiggle(), l += x$$1 * x$$1;
      if (y$$1 === 0) y$$1 = jiggle(), l += y$$1 * y$$1;
      if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
    }

    do if (quad.data !== node) {
      w = strengths[quad.data.index] * alpha / l;
      node.vx += x$$1 * w;
      node.vy += y$$1 * w;
    } while (quad = quad.next);
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : strength;
  };

  force.distanceMin = function(_) {
    return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
  };

  force.distanceMax = function(_) {
    return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
  };

  force.theta = function(_) {
    return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
  };

  return force;
};

var x$2 = function(x) {
  var strength = constant$6(0.1),
      nodes,
      strengths,
      xz;

  if (typeof x !== "function") x = constant$6(x == null ? 0 : +x);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    xz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : strength;
  };

  force.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : x;
  };

  return force;
};

var y$2 = function(y) {
  var strength = constant$6(0.1),
      nodes,
      strengths,
      yz;

  if (typeof y !== "function") y = constant$6(y == null ? 0 : +y);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    yz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : strength;
  };

  force.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : y;
  };

  return force;
};

// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimal(1.23) returns ["123", 0].
var formatDecimal = function(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
};

var exponent$1 = function(x) {
  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
};

var formatGroup = function(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
};

var formatNumerals = function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
};

var formatDefault = function(x, p) {
  x = x.toPrecision(p);

  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (x[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      case "e": break out;
      default: if (i0 > 0) i0 = 0; break;
    }
  }

  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
};

var prefixExponent;

var formatPrefixAuto = function(x, p) {
  var d = formatDecimal(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
};

var formatRounded = function(x, p) {
  var d = formatDecimal(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
};

var formatTypes = {
  "": formatDefault,
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": function(x) { return Math.round(x).toString(10); },
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return formatRounded(x * 100, p); },
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
};

// [[fill]align][sign][symbol][0][width][,][.precision][type]
var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  return new FormatSpecifier(specifier);
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);

  var match,
      fill = match[1] || " ",
      align = match[2] || ">",
      sign = match[3] || "-",
      symbol = match[4] || "",
      zero = !!match[5],
      width = match[6] && +match[6],
      comma = !!match[7],
      precision = match[8] && +match[8].slice(1),
      type = match[9] || "";

  // The "n" type is an alias for ",g".
  if (type === "n") comma = true, type = "g";

  // Map invalid types to the default format.
  else if (!formatTypes[type]) type = "";

  // If zero fill is specified, padding goes after sign and before digits.
  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

  this.fill = fill;
  this.align = align;
  this.sign = sign;
  this.symbol = symbol;
  this.zero = zero;
  this.width = width;
  this.comma = comma;
  this.precision = precision;
  this.type = type;
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width == null ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
      + this.type;
};

var identity$3 = function(x) {
  return x;
};

var prefixes = ["y","z","a","f","p","n","\xB5","m","","k","M","G","T","P","E","Z","Y"];

var formatLocale = function(locale) {
  var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity$3,
      currency = locale.currency,
      decimal = locale.decimal,
      numerals = locale.numerals ? formatNumerals(locale.numerals) : identity$3,
      percent = locale.percent || "%";

  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        type = specifier.type;

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = formatTypes[type],
        maybeSuffix = !type || /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision == null ? (type ? 6 : 12)
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Perform the initial formatting.
        var valueNegative = value < 0;
        value = formatType(Math.abs(value), precision);

        // If a negative value rounds to zero during formatting, treat as positive.
        if (valueNegative && +value === 0) valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = valueSuffix + (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(exponent$1(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
};

var locale$1;



defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale$1 = formatLocale(definition);
  exports.format = locale$1.format;
  exports.formatPrefix = locale$1.formatPrefix;
  return locale$1;
}

var precisionFixed = function(step) {
  return Math.max(0, -exponent$1(Math.abs(step)));
};

var precisionPrefix = function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent$1(value) / 3))) * 3 - exponent$1(Math.abs(step)));
};

var precisionRound = function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, exponent$1(max) - exponent$1(step)) + 1;
};

// Adds floating point numbers with twice the normal precision.
// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
// 305–363 (1997).
// Code adapted from GeographicLib by Charles F. F. Karney,
// http://geographiclib.sourceforge.net/

var adder = function() {
  return new Adder;
};

function Adder() {
  this.reset();
}

Adder.prototype = {
  constructor: Adder,
  reset: function() {
    this.s = // rounded value
    this.t = 0; // exact error
  },
  add: function(y) {
    add$1(temp, y, this.t);
    add$1(this, temp.s, this.s);
    if (this.s) this.t += temp.t;
    else this.s = temp.t;
  },
  valueOf: function() {
    return this.s;
  }
};

var temp = new Adder;

function add$1(adder, a, b) {
  var x = adder.s = a + b,
      bv = x - a,
      av = x - bv;
  adder.t = (a - av) + (b - bv);
}

var epsilon$2 = 1e-6;
var epsilon2$1 = 1e-12;
var pi$3 = Math.PI;
var halfPi$2 = pi$3 / 2;
var quarterPi = pi$3 / 4;
var tau$3 = pi$3 * 2;

var degrees$1 = 180 / pi$3;
var radians = pi$3 / 180;

var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos$1 = Math.cos;
var ceil = Math.ceil;
var exp = Math.exp;

var log = Math.log;
var pow = Math.pow;
var sin$1 = Math.sin;
var sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
var sqrt = Math.sqrt;
var tan = Math.tan;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi$3 : Math.acos(x);
}

function asin(x) {
  return x > 1 ? halfPi$2 : x < -1 ? -halfPi$2 : Math.asin(x);
}

function haversin(x) {
  return (x = sin$1(x / 2)) * x;
}

function noop$1() {}

function streamGeometry(geometry, stream) {
  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
    streamGeometryType[geometry.type](geometry, stream);
  }
}

var streamObjectType = {
  Feature: function(object, stream) {
    streamGeometry(object.geometry, stream);
  },
  FeatureCollection: function(object, stream) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) streamGeometry(features[i].geometry, stream);
  }
};

var streamGeometryType = {
  Sphere: function(object, stream) {
    stream.sphere();
  },
  Point: function(object, stream) {
    object = object.coordinates;
    stream.point(object[0], object[1], object[2]);
  },
  MultiPoint: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
  },
  LineString: function(object, stream) {
    streamLine(object.coordinates, stream, 0);
  },
  MultiLineString: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamLine(coordinates[i], stream, 0);
  },
  Polygon: function(object, stream) {
    streamPolygon(object.coordinates, stream);
  },
  MultiPolygon: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamPolygon(coordinates[i], stream);
  },
  GeometryCollection: function(object, stream) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) streamGeometry(geometries[i], stream);
  }
};

function streamLine(coordinates, stream, closed) {
  var i = -1, n = coordinates.length - closed, coordinate;
  stream.lineStart();
  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
  stream.lineEnd();
}

function streamPolygon(coordinates, stream) {
  var i = -1, n = coordinates.length;
  stream.polygonStart();
  while (++i < n) streamLine(coordinates[i], stream, 1);
  stream.polygonEnd();
}

var geoStream = function(object, stream) {
  if (object && streamObjectType.hasOwnProperty(object.type)) {
    streamObjectType[object.type](object, stream);
  } else {
    streamGeometry(object, stream);
  }
};

var areaRingSum = adder();

var areaSum = adder();
var lambda00;
var phi00;
var lambda0;
var cosPhi0;
var sinPhi0;

var areaStream = {
  point: noop$1,
  lineStart: noop$1,
  lineEnd: noop$1,
  polygonStart: function() {
    areaRingSum.reset();
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    var areaRing = +areaRingSum;
    areaSum.add(areaRing < 0 ? tau$3 + areaRing : areaRing);
    this.lineStart = this.lineEnd = this.point = noop$1;
  },
  sphere: function() {
    areaSum.add(tau$3);
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaRingEnd() {
  areaPoint(lambda00, phi00);
}

function areaPointFirst(lambda, phi) {
  areaStream.point = areaPoint;
  lambda00 = lambda, phi00 = phi;
  lambda *= radians, phi *= radians;
  lambda0 = lambda, cosPhi0 = cos$1(phi = phi / 2 + quarterPi), sinPhi0 = sin$1(phi);
}

function areaPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  phi = phi / 2 + quarterPi; // half the angular distance from south pole

  // Spherical excess E for a spherical triangle with vertices: south pole,
  // previous point, current point.  Uses a formula derived from Cagnoli’s
  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
  var dLambda = lambda - lambda0,
      sdLambda = dLambda >= 0 ? 1 : -1,
      adLambda = sdLambda * dLambda,
      cosPhi = cos$1(phi),
      sinPhi = sin$1(phi),
      k = sinPhi0 * sinPhi,
      u = cosPhi0 * cosPhi + k * cos$1(adLambda),
      v = k * sdLambda * sin$1(adLambda);
  areaRingSum.add(atan2(v, u));

  // Advance the previous points.
  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
}

var area = function(object) {
  areaSum.reset();
  geoStream(object, areaStream);
  return areaSum * 2;
};

function spherical(cartesian) {
  return [atan2(cartesian[1], cartesian[0]), asin(cartesian[2])];
}

function cartesian(spherical) {
  var lambda = spherical[0], phi = spherical[1], cosPhi = cos$1(phi);
  return [cosPhi * cos$1(lambda), cosPhi * sin$1(lambda), sin$1(phi)];
}

function cartesianDot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}

function cartesianCross(a, b) {
  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
}

// TODO return a
function cartesianAddInPlace(a, b) {
  a[0] += b[0], a[1] += b[1], a[2] += b[2];
}

function cartesianScale(vector, k) {
  return [vector[0] * k, vector[1] * k, vector[2] * k];
}

// TODO return d
function cartesianNormalizeInPlace(d) {
  var l = sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
  d[0] /= l, d[1] /= l, d[2] /= l;
}

var lambda0$1;
var phi0;
var lambda1;
var phi1;
var lambda2;
var lambda00$1;
var phi00$1;
var p0;
var deltaSum = adder();
var ranges;
var range;

var boundsStream = {
  point: boundsPoint,
  lineStart: boundsLineStart,
  lineEnd: boundsLineEnd,
  polygonStart: function() {
    boundsStream.point = boundsRingPoint;
    boundsStream.lineStart = boundsRingStart;
    boundsStream.lineEnd = boundsRingEnd;
    deltaSum.reset();
    areaStream.polygonStart();
  },
  polygonEnd: function() {
    areaStream.polygonEnd();
    boundsStream.point = boundsPoint;
    boundsStream.lineStart = boundsLineStart;
    boundsStream.lineEnd = boundsLineEnd;
    if (areaRingSum < 0) lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
    else if (deltaSum > epsilon$2) phi1 = 90;
    else if (deltaSum < -epsilon$2) phi0 = -90;
    range[0] = lambda0$1, range[1] = lambda1;
  }
};

function boundsPoint(lambda, phi) {
  ranges.push(range = [lambda0$1 = lambda, lambda1 = lambda]);
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
}

function linePoint(lambda, phi) {
  var p = cartesian([lambda * radians, phi * radians]);
  if (p0) {
    var normal = cartesianCross(p0, p),
        equatorial = [normal[1], -normal[0], 0],
        inflection = cartesianCross(equatorial, normal);
    cartesianNormalizeInPlace(inflection);
    inflection = spherical(inflection);
    var delta = lambda - lambda2,
        sign$$1 = delta > 0 ? 1 : -1,
        lambdai = inflection[0] * degrees$1 * sign$$1,
        phii,
        antimeridian = abs(delta) > 180;
    if (antimeridian ^ (sign$$1 * lambda2 < lambdai && lambdai < sign$$1 * lambda)) {
      phii = inflection[1] * degrees$1;
      if (phii > phi1) phi1 = phii;
    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign$$1 * lambda2 < lambdai && lambdai < sign$$1 * lambda)) {
      phii = -inflection[1] * degrees$1;
      if (phii < phi0) phi0 = phii;
    } else {
      if (phi < phi0) phi0 = phi;
      if (phi > phi1) phi1 = phi;
    }
    if (antimeridian) {
      if (lambda < lambda2) {
        if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
      } else {
        if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
      }
    } else {
      if (lambda1 >= lambda0$1) {
        if (lambda < lambda0$1) lambda0$1 = lambda;
        if (lambda > lambda1) lambda1 = lambda;
      } else {
        if (lambda > lambda2) {
          if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
        } else {
          if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
        }
      }
    }
  } else {
    ranges.push(range = [lambda0$1 = lambda, lambda1 = lambda]);
  }
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
  p0 = p, lambda2 = lambda;
}

function boundsLineStart() {
  boundsStream.point = linePoint;
}

function boundsLineEnd() {
  range[0] = lambda0$1, range[1] = lambda1;
  boundsStream.point = boundsPoint;
  p0 = null;
}

function boundsRingPoint(lambda, phi) {
  if (p0) {
    var delta = lambda - lambda2;
    deltaSum.add(abs(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
  } else {
    lambda00$1 = lambda, phi00$1 = phi;
  }
  areaStream.point(lambda, phi);
  linePoint(lambda, phi);
}

function boundsRingStart() {
  areaStream.lineStart();
}

function boundsRingEnd() {
  boundsRingPoint(lambda00$1, phi00$1);
  areaStream.lineEnd();
  if (abs(deltaSum) > epsilon$2) lambda0$1 = -(lambda1 = 180);
  range[0] = lambda0$1, range[1] = lambda1;
  p0 = null;
}

// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function angle(lambda0, lambda1) {
  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}

function rangeCompare(a, b) {
  return a[0] - b[0];
}

function rangeContains(range, x) {
  return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}

var bounds = function(feature) {
  var i, n, a, b, merged, deltaMax, delta;

  phi1 = lambda1 = -(lambda0$1 = phi0 = Infinity);
  ranges = [];
  geoStream(feature, boundsStream);

  // First, sort ranges by their minimum longitudes.
  if (n = ranges.length) {
    ranges.sort(rangeCompare);

    // Then, merge any ranges that overlap.
    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
      b = ranges[i];
      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
      } else {
        merged.push(a = b);
      }
    }

    // Finally, find the largest gap between the merged ranges.
    // The final bounding box will be the inverse of this gap.
    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
      b = merged[i];
      if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0$1 = b[0], lambda1 = a[1];
    }
  }

  ranges = range = null;

  return lambda0$1 === Infinity || phi0 === Infinity
      ? [[NaN, NaN], [NaN, NaN]]
      : [[lambda0$1, phi0], [lambda1, phi1]];
};

var W0;
var W1;
var X0;
var Y0;
var Z0;
var X1;
var Y1;
var Z1;
var X2;
var Y2;
var Z2;
var lambda00$2;
var phi00$2;
var x0;
var y0;
var z0; // previous point

var centroidStream = {
  sphere: noop$1,
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  }
};

// Arithmetic mean of Cartesian vectors.
function centroidPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos$1(phi);
  centroidPointCartesian(cosPhi * cos$1(lambda), cosPhi * sin$1(lambda), sin$1(phi));
}

function centroidPointCartesian(x, y, z) {
  ++W0;
  X0 += (x - X0) / W0;
  Y0 += (y - Y0) / W0;
  Z0 += (z - Z0) / W0;
}

function centroidLineStart() {
  centroidStream.point = centroidLinePointFirst;
}

function centroidLinePointFirst(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos$1(phi);
  x0 = cosPhi * cos$1(lambda);
  y0 = cosPhi * sin$1(lambda);
  z0 = sin$1(phi);
  centroidStream.point = centroidLinePoint;
  centroidPointCartesian(x0, y0, z0);
}

function centroidLinePoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos$1(phi),
      x = cosPhi * cos$1(lambda),
      y = cosPhi * sin$1(lambda),
      z = sin$1(phi),
      w = atan2(sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function centroidRingStart() {
  centroidStream.point = centroidRingPointFirst;
}

function centroidRingEnd() {
  centroidRingPoint(lambda00$2, phi00$2);
  centroidStream.point = centroidPoint;
}

function centroidRingPointFirst(lambda, phi) {
  lambda00$2 = lambda, phi00$2 = phi;
  lambda *= radians, phi *= radians;
  centroidStream.point = centroidRingPoint;
  var cosPhi = cos$1(phi);
  x0 = cosPhi * cos$1(lambda);
  y0 = cosPhi * sin$1(lambda);
  z0 = sin$1(phi);
  centroidPointCartesian(x0, y0, z0);
}

function centroidRingPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos$1(phi),
      x = cosPhi * cos$1(lambda),
      y = cosPhi * sin$1(lambda),
      z = sin$1(phi),
      cx = y0 * z - z0 * y,
      cy = z0 * x - x0 * z,
      cz = x0 * y - y0 * x,
      m = sqrt(cx * cx + cy * cy + cz * cz),
      w = asin(m), // line weight = angle
      v = m && -w / m; // area weight multiplier
  X2 += v * cx;
  Y2 += v * cy;
  Z2 += v * cz;
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

var centroid = function(object) {
  W0 = W1 =
  X0 = Y0 = Z0 =
  X1 = Y1 = Z1 =
  X2 = Y2 = Z2 = 0;
  geoStream(object, centroidStream);

  var x = X2,
      y = Y2,
      z = Z2,
      m = x * x + y * y + z * z;

  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
  if (m < epsilon2$1) {
    x = X1, y = Y1, z = Z1;
    // If the feature has zero length, fall back to arithmetic mean of point vectors.
    if (W1 < epsilon$2) x = X0, y = Y0, z = Z0;
    m = x * x + y * y + z * z;
    // If the feature still has an undefined ccentroid, then return.
    if (m < epsilon2$1) return [NaN, NaN];
  }

  return [atan2(y, x) * degrees$1, asin(z / sqrt(m)) * degrees$1];
};

var constant$7 = function(x) {
  return function() {
    return x;
  };
};

var compose = function(a, b) {

  function compose(x, y) {
    return x = a(x, y), b(x[0], x[1]);
  }

  if (a.invert && b.invert) compose.invert = function(x, y) {
    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
  };

  return compose;
};

function rotationIdentity(lambda, phi) {
  return [lambda > pi$3 ? lambda - tau$3 : lambda < -pi$3 ? lambda + tau$3 : lambda, phi];
}

rotationIdentity.invert = rotationIdentity;

function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
  return (deltaLambda %= tau$3) ? (deltaPhi || deltaGamma ? compose(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma))
    : rotationLambda(deltaLambda))
    : (deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma)
    : rotationIdentity);
}

function forwardRotationLambda(deltaLambda) {
  return function(lambda, phi) {
    return lambda += deltaLambda, [lambda > pi$3 ? lambda - tau$3 : lambda < -pi$3 ? lambda + tau$3 : lambda, phi];
  };
}

function rotationLambda(deltaLambda) {
  var rotation = forwardRotationLambda(deltaLambda);
  rotation.invert = forwardRotationLambda(-deltaLambda);
  return rotation;
}

function rotationPhiGamma(deltaPhi, deltaGamma) {
  var cosDeltaPhi = cos$1(deltaPhi),
      sinDeltaPhi = sin$1(deltaPhi),
      cosDeltaGamma = cos$1(deltaGamma),
      sinDeltaGamma = sin$1(deltaGamma);

  function rotation(lambda, phi) {
    var cosPhi = cos$1(phi),
        x = cos$1(lambda) * cosPhi,
        y = sin$1(lambda) * cosPhi,
        z = sin$1(phi),
        k = z * cosDeltaPhi + x * sinDeltaPhi;
    return [
      atan2(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
      asin(k * cosDeltaGamma + y * sinDeltaGamma)
    ];
  }

  rotation.invert = function(lambda, phi) {
    var cosPhi = cos$1(phi),
        x = cos$1(lambda) * cosPhi,
        y = sin$1(lambda) * cosPhi,
        z = sin$1(phi),
        k = z * cosDeltaGamma - y * sinDeltaGamma;
    return [
      atan2(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
      asin(k * cosDeltaPhi - x * sinDeltaPhi)
    ];
  };

  return rotation;
}

var rotation = function(rotate) {
  rotate = rotateRadians(rotate[0] * radians, rotate[1] * radians, rotate.length > 2 ? rotate[2] * radians : 0);

  function forward(coordinates) {
    coordinates = rotate(coordinates[0] * radians, coordinates[1] * radians);
    return coordinates[0] *= degrees$1, coordinates[1] *= degrees$1, coordinates;
  }

  forward.invert = function(coordinates) {
    coordinates = rotate.invert(coordinates[0] * radians, coordinates[1] * radians);
    return coordinates[0] *= degrees$1, coordinates[1] *= degrees$1, coordinates;
  };

  return forward;
};

// Generates a circle centered at [0°, 0°], with a given radius and precision.
function circleStream(stream, radius, delta, direction, t0, t1) {
  if (!delta) return;
  var cosRadius = cos$1(radius),
      sinRadius = sin$1(radius),
      step = direction * delta;
  if (t0 == null) {
    t0 = radius + direction * tau$3;
    t1 = radius - step / 2;
  } else {
    t0 = circleRadius(cosRadius, t0);
    t1 = circleRadius(cosRadius, t1);
    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * tau$3;
  }
  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
    point = spherical([cosRadius, -sinRadius * cos$1(t), -sinRadius * sin$1(t)]);
    stream.point(point[0], point[1]);
  }
}

// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function circleRadius(cosRadius, point) {
  point = cartesian(point), point[0] -= cosRadius;
  cartesianNormalizeInPlace(point);
  var radius = acos(-point[1]);
  return ((-point[2] < 0 ? -radius : radius) + tau$3 - epsilon$2) % tau$3;
}

var circle = function() {
  var center = constant$7([0, 0]),
      radius = constant$7(90),
      precision = constant$7(6),
      ring,
      rotate,
      stream = {point: point};

  function point(x, y) {
    ring.push(x = rotate(x, y));
    x[0] *= degrees$1, x[1] *= degrees$1;
  }

  function circle() {
    var c = center.apply(this, arguments),
        r = radius.apply(this, arguments) * radians,
        p = precision.apply(this, arguments) * radians;
    ring = [];
    rotate = rotateRadians(-c[0] * radians, -c[1] * radians, 0).invert;
    circleStream(stream, r, p, 1);
    c = {type: "Polygon", coordinates: [ring]};
    ring = rotate = null;
    return c;
  }

  circle.center = function(_) {
    return arguments.length ? (center = typeof _ === "function" ? _ : constant$7([+_[0], +_[1]]), circle) : center;
  };

  circle.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$7(+_), circle) : radius;
  };

  circle.precision = function(_) {
    return arguments.length ? (precision = typeof _ === "function" ? _ : constant$7(+_), circle) : precision;
  };

  return circle;
};

var clipBuffer = function() {
  var lines = [],
      line;
  return {
    point: function(x, y) {
      line.push([x, y]);
    },
    lineStart: function() {
      lines.push(line = []);
    },
    lineEnd: noop$1,
    rejoin: function() {
      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
    },
    result: function() {
      var result = lines;
      lines = [];
      line = null;
      return result;
    }
  };
};

var clipLine = function(a, b, x0, y0, x1, y1) {
  var ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
  return true;
};

var pointEqual = function(a, b) {
  return abs(a[0] - b[0]) < epsilon$2 && abs(a[1] - b[1]) < epsilon$2;
};

function Intersection(point, points, other, entry) {
  this.x = point;
  this.z = points;
  this.o = other; // another intersection
  this.e = entry; // is an entry?
  this.v = false; // visited
  this.n = this.p = null; // next & previous
}

// A generalized polygon clipping algorithm: given a polygon that has been cut
// into its visible line segments, and rejoins the segments by interpolating
// along the clip edge.
var clipPolygon = function(segments, compareIntersection, startInside, interpolate, stream) {
  var subject = [],
      clip = [],
      i,
      n;

  segments.forEach(function(segment) {
    if ((n = segment.length - 1) <= 0) return;
    var n, p0 = segment[0], p1 = segment[n], x;

    // If the first and last points of a segment are coincident, then treat as a
    // closed ring. TODO if all rings are closed, then the winding order of the
    // exterior ring should be checked.
    if (pointEqual(p0, p1)) {
      stream.lineStart();
      for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
      stream.lineEnd();
      return;
    }

    subject.push(x = new Intersection(p0, segment, null, true));
    clip.push(x.o = new Intersection(p0, null, x, false));
    subject.push(x = new Intersection(p1, segment, null, false));
    clip.push(x.o = new Intersection(p1, null, x, true));
  });

  if (!subject.length) return;

  clip.sort(compareIntersection);
  link$1(subject);
  link$1(clip);

  for (i = 0, n = clip.length; i < n; ++i) {
    clip[i].e = startInside = !startInside;
  }

  var start = subject[0],
      points,
      point;

  while (1) {
    // Find first unvisited intersection.
    var current = start,
        isSubject = true;
    while (current.v) if ((current = current.n) === start) return;
    points = current.z;
    stream.lineStart();
    do {
      current.v = current.o.v = true;
      if (current.e) {
        if (isSubject) {
          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.n.x, 1, stream);
        }
        current = current.n;
      } else {
        if (isSubject) {
          points = current.p.z;
          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.p.x, -1, stream);
        }
        current = current.p;
      }
      current = current.o;
      points = current.z;
      isSubject = !isSubject;
    } while (!current.v);
    stream.lineEnd();
  }
};

function link$1(array) {
  if (!(n = array.length)) return;
  var n,
      i = 0,
      a = array[0],
      b;
  while (++i < n) {
    a.n = b = array[i];
    b.p = a;
    a = b;
  }
  a.n = b = array[0];
  b.p = a;
}

var clipMax = 1e9;
var clipMin = -clipMax;

// TODO Use d3-polygon’s polygonContains here for the ring check?
// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?

function clipExtent(x0, y0, x1, y1) {

  function visible(x, y) {
    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
  }

  function interpolate(from, to, direction, stream) {
    var a = 0, a1 = 0;
    if (from == null
        || (a = corner(from, direction)) !== (a1 = corner(to, direction))
        || comparePoint(from, to) < 0 ^ direction > 0) {
      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
      while ((a = (a + direction + 4) % 4) !== a1);
    } else {
      stream.point(to[0], to[1]);
    }
  }

  function corner(p, direction) {
    return abs(p[0] - x0) < epsilon$2 ? direction > 0 ? 0 : 3
        : abs(p[0] - x1) < epsilon$2 ? direction > 0 ? 2 : 1
        : abs(p[1] - y0) < epsilon$2 ? direction > 0 ? 1 : 0
        : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
  }

  function compareIntersection(a, b) {
    return comparePoint(a.x, b.x);
  }

  function comparePoint(a, b) {
    var ca = corner(a, 1),
        cb = corner(b, 1);
    return ca !== cb ? ca - cb
        : ca === 0 ? b[1] - a[1]
        : ca === 1 ? a[0] - b[0]
        : ca === 2 ? a[1] - b[1]
        : b[0] - a[0];
  }

  return function(stream) {
    var activeStream = stream,
        bufferStream = clipBuffer(),
        segments,
        polygon,
        ring,
        x__, y__, v__, // first point
        x_, y_, v_, // previous point
        first,
        clean;

    var clipStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: polygonStart,
      polygonEnd: polygonEnd
    };

    function point(x, y) {
      if (visible(x, y)) activeStream.point(x, y);
    }

    function polygonInside() {
      var winding = 0;

      for (var i = 0, n = polygon.length; i < n; ++i) {
        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
          if (a1 <= y1) { if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding; }
          else { if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding; }
        }
      }

      return winding;
    }

    // Buffer geometry within a polygon and then clip it en masse.
    function polygonStart() {
      activeStream = bufferStream, segments = [], polygon = [], clean = true;
    }

    function polygonEnd() {
      var startInside = polygonInside(),
          cleanInside = clean && startInside,
          visible = (segments = merge(segments)).length;
      if (cleanInside || visible) {
        stream.polygonStart();
        if (cleanInside) {
          stream.lineStart();
          interpolate(null, null, 1, stream);
          stream.lineEnd();
        }
        if (visible) {
          clipPolygon(segments, compareIntersection, startInside, interpolate, stream);
        }
        stream.polygonEnd();
      }
      activeStream = stream, segments = polygon = ring = null;
    }

    function lineStart() {
      clipStream.point = linePoint;
      if (polygon) polygon.push(ring = []);
      first = true;
      v_ = false;
      x_ = y_ = NaN;
    }

    // TODO rather than special-case polygons, simply handle them separately.
    // Ideally, coincident intersection points should be jittered to avoid
    // clipping issues.
    function lineEnd() {
      if (segments) {
        linePoint(x__, y__);
        if (v__ && v_) bufferStream.rejoin();
        segments.push(bufferStream.result());
      }
      clipStream.point = point;
      if (v_) activeStream.lineEnd();
    }

    function linePoint(x, y) {
      var v = visible(x, y);
      if (polygon) ring.push([x, y]);
      if (first) {
        x__ = x, y__ = y, v__ = v;
        first = false;
        if (v) {
          activeStream.lineStart();
          activeStream.point(x, y);
        }
      } else {
        if (v && v_) activeStream.point(x, y);
        else {
          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
          if (clipLine(a, b, x0, y0, x1, y1)) {
            if (!v_) {
              activeStream.lineStart();
              activeStream.point(a[0], a[1]);
            }
            activeStream.point(b[0], b[1]);
            if (!v) activeStream.lineEnd();
            clean = false;
          } else if (v) {
            activeStream.lineStart();
            activeStream.point(x, y);
            clean = false;
          }
        }
      }
      x_ = x, y_ = y, v_ = v;
    }

    return clipStream;
  };
}

var extent$1 = function() {
  var x0 = 0,
      y0 = 0,
      x1 = 960,
      y1 = 500,
      cache,
      cacheStream,
      clip;

  return clip = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = clipExtent(x0, y0, x1, y1)(cacheStream = stream);
    },
    extent: function(_) {
      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
    }
  };
};

var sum$1 = adder();

var polygonContains = function(polygon, point) {
  var lambda = point[0],
      phi = point[1],
      normal = [sin$1(lambda), -cos$1(lambda), 0],
      angle = 0,
      winding = 0;

  sum$1.reset();

  for (var i = 0, n = polygon.length; i < n; ++i) {
    if (!(m = (ring = polygon[i]).length)) continue;
    var ring,
        m,
        point0 = ring[m - 1],
        lambda0 = point0[0],
        phi0 = point0[1] / 2 + quarterPi,
        sinPhi0 = sin$1(phi0),
        cosPhi0 = cos$1(phi0);

    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
      var point1 = ring[j],
          lambda1 = point1[0],
          phi1 = point1[1] / 2 + quarterPi,
          sinPhi1 = sin$1(phi1),
          cosPhi1 = cos$1(phi1),
          delta = lambda1 - lambda0,
          sign$$1 = delta >= 0 ? 1 : -1,
          absDelta = sign$$1 * delta,
          antimeridian = absDelta > pi$3,
          k = sinPhi0 * sinPhi1;

      sum$1.add(atan2(k * sign$$1 * sin$1(absDelta), cosPhi0 * cosPhi1 + k * cos$1(absDelta)));
      angle += antimeridian ? delta + sign$$1 * tau$3 : delta;

      // Are the longitudes either side of the point’s meridian (lambda),
      // and are the latitudes smaller than the parallel (phi)?
      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
        var arc = cartesianCross(cartesian(point0), cartesian(point1));
        cartesianNormalizeInPlace(arc);
        var intersection = cartesianCross(normal, arc);
        cartesianNormalizeInPlace(intersection);
        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * asin(intersection[2]);
        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
          winding += antimeridian ^ delta >= 0 ? 1 : -1;
        }
      }
    }
  }

  // First, determine whether the South pole is inside or outside:
  //
  // It is inside if:
  // * the polygon winds around it in a clockwise direction.
  // * the polygon does not (cumulatively) wind around it, but has a negative
  //   (counter-clockwise) area.
  //
  // Second, count the (signed) number of times a segment crosses a lambda
  // from the point to the South pole.  If it is zero, then the point is the
  // same side as the South pole.

  return (angle < -epsilon$2 || angle < epsilon$2 && sum$1 < -epsilon$2) ^ (winding & 1);
};

var lengthSum = adder();
var lambda0$2;
var sinPhi0$1;
var cosPhi0$1;

var lengthStream = {
  sphere: noop$1,
  point: noop$1,
  lineStart: lengthLineStart,
  lineEnd: noop$1,
  polygonStart: noop$1,
  polygonEnd: noop$1
};

function lengthLineStart() {
  lengthStream.point = lengthPointFirst;
  lengthStream.lineEnd = lengthLineEnd;
}

function lengthLineEnd() {
  lengthStream.point = lengthStream.lineEnd = noop$1;
}

function lengthPointFirst(lambda, phi) {
  lambda *= radians, phi *= radians;
  lambda0$2 = lambda, sinPhi0$1 = sin$1(phi), cosPhi0$1 = cos$1(phi);
  lengthStream.point = lengthPoint;
}

function lengthPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var sinPhi = sin$1(phi),
      cosPhi = cos$1(phi),
      delta = abs(lambda - lambda0$2),
      cosDelta = cos$1(delta),
      sinDelta = sin$1(delta),
      x = cosPhi * sinDelta,
      y = cosPhi0$1 * sinPhi - sinPhi0$1 * cosPhi * cosDelta,
      z = sinPhi0$1 * sinPhi + cosPhi0$1 * cosPhi * cosDelta;
  lengthSum.add(atan2(sqrt(x * x + y * y), z));
  lambda0$2 = lambda, sinPhi0$1 = sinPhi, cosPhi0$1 = cosPhi;
}

var length$1 = function(object) {
  lengthSum.reset();
  geoStream(object, lengthStream);
  return +lengthSum;
};

var coordinates = [null, null];
var object$1 = {type: "LineString", coordinates: coordinates};

var distance = function(a, b) {
  coordinates[0] = a;
  coordinates[1] = b;
  return length$1(object$1);
};

var containsObjectType = {
  Feature: function(object, point) {
    return containsGeometry(object.geometry, point);
  },
  FeatureCollection: function(object, point) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) if (containsGeometry(features[i].geometry, point)) return true;
    return false;
  }
};

var containsGeometryType = {
  Sphere: function() {
    return true;
  },
  Point: function(object, point) {
    return containsPoint(object.coordinates, point);
  },
  MultiPoint: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPoint(coordinates[i], point)) return true;
    return false;
  },
  LineString: function(object, point) {
    return containsLine(object.coordinates, point);
  },
  MultiLineString: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsLine(coordinates[i], point)) return true;
    return false;
  },
  Polygon: function(object, point) {
    return containsPolygon(object.coordinates, point);
  },
  MultiPolygon: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPolygon(coordinates[i], point)) return true;
    return false;
  },
  GeometryCollection: function(object, point) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) if (containsGeometry(geometries[i], point)) return true;
    return false;
  }
};

function containsGeometry(geometry, point) {
  return geometry && containsGeometryType.hasOwnProperty(geometry.type)
      ? containsGeometryType[geometry.type](geometry, point)
      : false;
}

function containsPoint(coordinates, point) {
  return distance(coordinates, point) === 0;
}

function containsLine(coordinates, point) {
  var ab = distance(coordinates[0], coordinates[1]),
      ao = distance(coordinates[0], point),
      ob = distance(point, coordinates[1]);
  return ao + ob <= ab + epsilon$2;
}

function containsPolygon(coordinates, point) {
  return !!polygonContains(coordinates.map(ringRadians), pointRadians(point));
}

function ringRadians(ring) {
  return ring = ring.map(pointRadians), ring.pop(), ring;
}

function pointRadians(point) {
  return [point[0] * radians, point[1] * radians];
}

var contains = function(object, point) {
  return (object && containsObjectType.hasOwnProperty(object.type)
      ? containsObjectType[object.type]
      : containsGeometry)(object, point);
};

function graticuleX(y0, y1, dy) {
  var y = sequence(y0, y1 - epsilon$2, dy).concat(y1);
  return function(x) { return y.map(function(y) { return [x, y]; }); };
}

function graticuleY(x0, x1, dx) {
  var x = sequence(x0, x1 - epsilon$2, dx).concat(x1);
  return function(y) { return x.map(function(x) { return [x, y]; }); };
}

function graticule() {
  var x1, x0, X1, X0,
      y1, y0, Y1, Y0,
      dx = 10, dy = dx, DX = 90, DY = 360,
      x, y, X, Y,
      precision = 2.5;

  function graticule() {
    return {type: "MultiLineString", coordinates: lines()};
  }

  function lines() {
    return sequence(ceil(X0 / DX) * DX, X1, DX).map(X)
        .concat(sequence(ceil(Y0 / DY) * DY, Y1, DY).map(Y))
        .concat(sequence(ceil(x0 / dx) * dx, x1, dx).filter(function(x) { return abs(x % DX) > epsilon$2; }).map(x))
        .concat(sequence(ceil(y0 / dy) * dy, y1, dy).filter(function(y) { return abs(y % DY) > epsilon$2; }).map(y));
  }

  graticule.lines = function() {
    return lines().map(function(coordinates) { return {type: "LineString", coordinates: coordinates}; });
  };

  graticule.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        X(X0).concat(
        Y(Y1).slice(1),
        X(X1).reverse().slice(1),
        Y(Y0).reverse().slice(1))
      ]
    };
  };

  graticule.extent = function(_) {
    if (!arguments.length) return graticule.extentMinor();
    return graticule.extentMajor(_).extentMinor(_);
  };

  graticule.extentMajor = function(_) {
    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
    X0 = +_[0][0], X1 = +_[1][0];
    Y0 = +_[0][1], Y1 = +_[1][1];
    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
    return graticule.precision(precision);
  };

  graticule.extentMinor = function(_) {
    if (!arguments.length) return [[x0, y0], [x1, y1]];
    x0 = +_[0][0], x1 = +_[1][0];
    y0 = +_[0][1], y1 = +_[1][1];
    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
    return graticule.precision(precision);
  };

  graticule.step = function(_) {
    if (!arguments.length) return graticule.stepMinor();
    return graticule.stepMajor(_).stepMinor(_);
  };

  graticule.stepMajor = function(_) {
    if (!arguments.length) return [DX, DY];
    DX = +_[0], DY = +_[1];
    return graticule;
  };

  graticule.stepMinor = function(_) {
    if (!arguments.length) return [dx, dy];
    dx = +_[0], dy = +_[1];
    return graticule;
  };

  graticule.precision = function(_) {
    if (!arguments.length) return precision;
    precision = +_;
    x = graticuleX(y0, y1, 90);
    y = graticuleY(x0, x1, precision);
    X = graticuleX(Y0, Y1, 90);
    Y = graticuleY(X0, X1, precision);
    return graticule;
  };

  return graticule
      .extentMajor([[-180, -90 + epsilon$2], [180, 90 - epsilon$2]])
      .extentMinor([[-180, -80 - epsilon$2], [180, 80 + epsilon$2]]);
}

function graticule10() {
  return graticule()();
}

var interpolate$1 = function(a, b) {
  var x0 = a[0] * radians,
      y0 = a[1] * radians,
      x1 = b[0] * radians,
      y1 = b[1] * radians,
      cy0 = cos$1(y0),
      sy0 = sin$1(y0),
      cy1 = cos$1(y1),
      sy1 = sin$1(y1),
      kx0 = cy0 * cos$1(x0),
      ky0 = cy0 * sin$1(x0),
      kx1 = cy1 * cos$1(x1),
      ky1 = cy1 * sin$1(x1),
      d = 2 * asin(sqrt(haversin(y1 - y0) + cy0 * cy1 * haversin(x1 - x0))),
      k = sin$1(d);

  var interpolate = d ? function(t) {
    var B = sin$1(t *= d) / k,
        A = sin$1(d - t) / k,
        x = A * kx0 + B * kx1,
        y = A * ky0 + B * ky1,
        z = A * sy0 + B * sy1;
    return [
      atan2(y, x) * degrees$1,
      atan2(z, sqrt(x * x + y * y)) * degrees$1
    ];
  } : function() {
    return [x0 * degrees$1, y0 * degrees$1];
  };

  interpolate.distance = d;

  return interpolate;
};

var identity$4 = function(x) {
  return x;
};

var areaSum$1 = adder();
var areaRingSum$1 = adder();
var x00;
var y00;
var x0$1;
var y0$1;

var areaStream$1 = {
  point: noop$1,
  lineStart: noop$1,
  lineEnd: noop$1,
  polygonStart: function() {
    areaStream$1.lineStart = areaRingStart$1;
    areaStream$1.lineEnd = areaRingEnd$1;
  },
  polygonEnd: function() {
    areaStream$1.lineStart = areaStream$1.lineEnd = areaStream$1.point = noop$1;
    areaSum$1.add(abs(areaRingSum$1));
    areaRingSum$1.reset();
  },
  result: function() {
    var area = areaSum$1 / 2;
    areaSum$1.reset();
    return area;
  }
};

function areaRingStart$1() {
  areaStream$1.point = areaPointFirst$1;
}

function areaPointFirst$1(x, y) {
  areaStream$1.point = areaPoint$1;
  x00 = x0$1 = x, y00 = y0$1 = y;
}

function areaPoint$1(x, y) {
  areaRingSum$1.add(y0$1 * x - x0$1 * y);
  x0$1 = x, y0$1 = y;
}

function areaRingEnd$1() {
  areaPoint$1(x00, y00);
}

var x0$2 = Infinity;
var y0$2 = x0$2;
var x1 = -x0$2;
var y1 = x1;

var boundsStream$1 = {
  point: boundsPoint$1,
  lineStart: noop$1,
  lineEnd: noop$1,
  polygonStart: noop$1,
  polygonEnd: noop$1,
  result: function() {
    var bounds = [[x0$2, y0$2], [x1, y1]];
    x1 = y1 = -(y0$2 = x0$2 = Infinity);
    return bounds;
  }
};

function boundsPoint$1(x, y) {
  if (x < x0$2) x0$2 = x;
  if (x > x1) x1 = x;
  if (y < y0$2) y0$2 = y;
  if (y > y1) y1 = y;
}

// TODO Enforce positive area for exterior, negative area for interior?

var X0$1 = 0;
var Y0$1 = 0;
var Z0$1 = 0;
var X1$1 = 0;
var Y1$1 = 0;
var Z1$1 = 0;
var X2$1 = 0;
var Y2$1 = 0;
var Z2$1 = 0;
var x00$1;
var y00$1;
var x0$3;
var y0$3;

var centroidStream$1 = {
  point: centroidPoint$1,
  lineStart: centroidLineStart$1,
  lineEnd: centroidLineEnd$1,
  polygonStart: function() {
    centroidStream$1.lineStart = centroidRingStart$1;
    centroidStream$1.lineEnd = centroidRingEnd$1;
  },
  polygonEnd: function() {
    centroidStream$1.point = centroidPoint$1;
    centroidStream$1.lineStart = centroidLineStart$1;
    centroidStream$1.lineEnd = centroidLineEnd$1;
  },
  result: function() {
    var centroid = Z2$1 ? [X2$1 / Z2$1, Y2$1 / Z2$1]
        : Z1$1 ? [X1$1 / Z1$1, Y1$1 / Z1$1]
        : Z0$1 ? [X0$1 / Z0$1, Y0$1 / Z0$1]
        : [NaN, NaN];
    X0$1 = Y0$1 = Z0$1 =
    X1$1 = Y1$1 = Z1$1 =
    X2$1 = Y2$1 = Z2$1 = 0;
    return centroid;
  }
};

function centroidPoint$1(x, y) {
  X0$1 += x;
  Y0$1 += y;
  ++Z0$1;
}

function centroidLineStart$1() {
  centroidStream$1.point = centroidPointFirstLine;
}

function centroidPointFirstLine(x, y) {
  centroidStream$1.point = centroidPointLine;
  centroidPoint$1(x0$3 = x, y0$3 = y);
}

function centroidPointLine(x, y) {
  var dx = x - x0$3, dy = y - y0$3, z = sqrt(dx * dx + dy * dy);
  X1$1 += z * (x0$3 + x) / 2;
  Y1$1 += z * (y0$3 + y) / 2;
  Z1$1 += z;
  centroidPoint$1(x0$3 = x, y0$3 = y);
}

function centroidLineEnd$1() {
  centroidStream$1.point = centroidPoint$1;
}

function centroidRingStart$1() {
  centroidStream$1.point = centroidPointFirstRing;
}

function centroidRingEnd$1() {
  centroidPointRing(x00$1, y00$1);
}

function centroidPointFirstRing(x, y) {
  centroidStream$1.point = centroidPointRing;
  centroidPoint$1(x00$1 = x0$3 = x, y00$1 = y0$3 = y);
}

function centroidPointRing(x, y) {
  var dx = x - x0$3,
      dy = y - y0$3,
      z = sqrt(dx * dx + dy * dy);

  X1$1 += z * (x0$3 + x) / 2;
  Y1$1 += z * (y0$3 + y) / 2;
  Z1$1 += z;

  z = y0$3 * x - x0$3 * y;
  X2$1 += z * (x0$3 + x);
  Y2$1 += z * (y0$3 + y);
  Z2$1 += z * 3;
  centroidPoint$1(x0$3 = x, y0$3 = y);
}

function PathContext(context) {
  this._context = context;
}

PathContext.prototype = {
  _radius: 4.5,
  pointRadius: function(_) {
    return this._radius = _, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._context.closePath();
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(x, y);
        this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(x, y);
        break;
      }
      default: {
        this._context.moveTo(x + this._radius, y);
        this._context.arc(x, y, this._radius, 0, tau$3);
        break;
      }
    }
  },
  result: noop$1
};

var lengthSum$1 = adder();
var lengthRing;
var x00$2;
var y00$2;
var x0$4;
var y0$4;

var lengthStream$1 = {
  point: noop$1,
  lineStart: function() {
    lengthStream$1.point = lengthPointFirst$1;
  },
  lineEnd: function() {
    if (lengthRing) lengthPoint$1(x00$2, y00$2);
    lengthStream$1.point = noop$1;
  },
  polygonStart: function() {
    lengthRing = true;
  },
  polygonEnd: function() {
    lengthRing = null;
  },
  result: function() {
    var length = +lengthSum$1;
    lengthSum$1.reset();
    return length;
  }
};

function lengthPointFirst$1(x, y) {
  lengthStream$1.point = lengthPoint$1;
  x00$2 = x0$4 = x, y00$2 = y0$4 = y;
}

function lengthPoint$1(x, y) {
  x0$4 -= x, y0$4 -= y;
  lengthSum$1.add(sqrt(x0$4 * x0$4 + y0$4 * y0$4));
  x0$4 = x, y0$4 = y;
}

function PathString() {
  this._string = [];
}

PathString.prototype = {
  _radius: 4.5,
  _circle: circle$1(4.5),
  pointRadius: function(_) {
    if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
    return this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._string.push("Z");
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._string.push("M", x, ",", y);
        this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", x, ",", y);
        break;
      }
      default: {
        if (this._circle == null) this._circle = circle$1(this._radius);
        this._string.push("M", x, ",", y, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var result = this._string.join("");
      this._string = [];
      return result;
    } else {
      return null;
    }
  }
};

function circle$1(radius) {
  return "m0," + radius
      + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius
      + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius
      + "z";
}

var index$1 = function(projection, context) {
  var pointRadius = 4.5,
      projectionStream,
      contextStream;

  function path(object) {
    if (object) {
      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
      geoStream(object, projectionStream(contextStream));
    }
    return contextStream.result();
  }

  path.area = function(object) {
    geoStream(object, projectionStream(areaStream$1));
    return areaStream$1.result();
  };

  path.measure = function(object) {
    geoStream(object, projectionStream(lengthStream$1));
    return lengthStream$1.result();
  };

  path.bounds = function(object) {
    geoStream(object, projectionStream(boundsStream$1));
    return boundsStream$1.result();
  };

  path.centroid = function(object) {
    geoStream(object, projectionStream(centroidStream$1));
    return centroidStream$1.result();
  };

  path.projection = function(_) {
    return arguments.length ? (projectionStream = _ == null ? (projection = null, identity$4) : (projection = _).stream, path) : projection;
  };

  path.context = function(_) {
    if (!arguments.length) return context;
    contextStream = _ == null ? (context = null, new PathString) : new PathContext(context = _);
    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
    return path;
  };

  path.pointRadius = function(_) {
    if (!arguments.length) return pointRadius;
    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
    return path;
  };

  return path.projection(projection).context(context);
};

var clip = function(pointVisible, clipLine, interpolate, start) {
  return function(rotate, sink) {
    var line = clipLine(sink),
        rotatedStart = rotate.invert(start[0], start[1]),
        ringBuffer = clipBuffer(),
        ringSink = clipLine(ringBuffer),
        polygonStarted = false,
        polygon,
        segments,
        ring;

    var clip = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() {
        clip.point = pointRing;
        clip.lineStart = ringStart;
        clip.lineEnd = ringEnd;
        segments = [];
        polygon = [];
      },
      polygonEnd: function() {
        clip.point = point;
        clip.lineStart = lineStart;
        clip.lineEnd = lineEnd;
        segments = merge(segments);
        var startInside = polygonContains(polygon, rotatedStart);
        if (segments.length) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          clipPolygon(segments, compareIntersection, startInside, interpolate, sink);
        } else if (startInside) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          interpolate(null, null, 1, sink);
          sink.lineEnd();
        }
        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
        segments = polygon = null;
      },
      sphere: function() {
        sink.polygonStart();
        sink.lineStart();
        interpolate(null, null, 1, sink);
        sink.lineEnd();
        sink.polygonEnd();
      }
    };

    function point(lambda, phi) {
      var point = rotate(lambda, phi);
      if (pointVisible(lambda = point[0], phi = point[1])) sink.point(lambda, phi);
    }

    function pointLine(lambda, phi) {
      var point = rotate(lambda, phi);
      line.point(point[0], point[1]);
    }

    function lineStart() {
      clip.point = pointLine;
      line.lineStart();
    }

    function lineEnd() {
      clip.point = point;
      line.lineEnd();
    }

    function pointRing(lambda, phi) {
      ring.push([lambda, phi]);
      var point = rotate(lambda, phi);
      ringSink.point(point[0], point[1]);
    }

    function ringStart() {
      ringSink.lineStart();
      ring = [];
    }

    function ringEnd() {
      pointRing(ring[0][0], ring[0][1]);
      ringSink.lineEnd();

      var clean = ringSink.clean(),
          ringSegments = ringBuffer.result(),
          i, n = ringSegments.length, m,
          segment,
          point;

      ring.pop();
      polygon.push(ring);
      ring = null;

      if (!n) return;

      // No intersections.
      if (clean & 1) {
        segment = ringSegments[0];
        if ((m = segment.length - 1) > 0) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
          sink.lineEnd();
        }
        return;
      }

      // Rejoin connected segments.
      // TODO reuse ringBuffer.rejoin()?
      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));

      segments.push(ringSegments.filter(validSegment));
    }

    return clip;
  };
};

function validSegment(segment) {
  return segment.length > 1;
}

// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function compareIntersection(a, b) {
  return ((a = a.x)[0] < 0 ? a[1] - halfPi$2 - epsilon$2 : halfPi$2 - a[1])
       - ((b = b.x)[0] < 0 ? b[1] - halfPi$2 - epsilon$2 : halfPi$2 - b[1]);
}

var clipAntimeridian = clip(
  function() { return true; },
  clipAntimeridianLine,
  clipAntimeridianInterpolate,
  [-pi$3, -halfPi$2]
);

// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function clipAntimeridianLine(stream) {
  var lambda0 = NaN,
      phi0 = NaN,
      sign0 = NaN,
      clean; // no intersections

  return {
    lineStart: function() {
      stream.lineStart();
      clean = 1;
    },
    point: function(lambda1, phi1) {
      var sign1 = lambda1 > 0 ? pi$3 : -pi$3,
          delta = abs(lambda1 - lambda0);
      if (abs(delta - pi$3) < epsilon$2) { // line crosses a pole
        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? halfPi$2 : -halfPi$2);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        stream.point(lambda1, phi0);
        clean = 0;
      } else if (sign0 !== sign1 && delta >= pi$3) { // line crosses antimeridian
        if (abs(lambda0 - sign0) < epsilon$2) lambda0 -= sign0 * epsilon$2; // handle degeneracies
        if (abs(lambda1 - sign1) < epsilon$2) lambda1 -= sign1 * epsilon$2;
        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        clean = 0;
      }
      stream.point(lambda0 = lambda1, phi0 = phi1);
      sign0 = sign1;
    },
    lineEnd: function() {
      stream.lineEnd();
      lambda0 = phi0 = NaN;
    },
    clean: function() {
      return 2 - clean; // if intersections, rejoin first and last segments
    }
  };
}

function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
  var cosPhi0,
      cosPhi1,
      sinLambda0Lambda1 = sin$1(lambda0 - lambda1);
  return abs(sinLambda0Lambda1) > epsilon$2
      ? atan((sin$1(phi0) * (cosPhi1 = cos$1(phi1)) * sin$1(lambda1)
          - sin$1(phi1) * (cosPhi0 = cos$1(phi0)) * sin$1(lambda0))
          / (cosPhi0 * cosPhi1 * sinLambda0Lambda1))
      : (phi0 + phi1) / 2;
}

function clipAntimeridianInterpolate(from, to, direction, stream) {
  var phi;
  if (from == null) {
    phi = direction * halfPi$2;
    stream.point(-pi$3, phi);
    stream.point(0, phi);
    stream.point(pi$3, phi);
    stream.point(pi$3, 0);
    stream.point(pi$3, -phi);
    stream.point(0, -phi);
    stream.point(-pi$3, -phi);
    stream.point(-pi$3, 0);
    stream.point(-pi$3, phi);
  } else if (abs(from[0] - to[0]) > epsilon$2) {
    var lambda = from[0] < to[0] ? pi$3 : -pi$3;
    phi = direction * lambda / 2;
    stream.point(-lambda, phi);
    stream.point(0, phi);
    stream.point(lambda, phi);
  } else {
    stream.point(to[0], to[1]);
  }
}

var clipCircle = function(radius, delta) {
  var cr = cos$1(radius),
      smallRadius = cr > 0,
      notHemisphere = abs(cr) > epsilon$2; // TODO optimise for this common case

  function interpolate(from, to, direction, stream) {
    circleStream(stream, radius, delta, direction, from, to);
  }

  function visible(lambda, phi) {
    return cos$1(lambda) * cos$1(phi) > cr;
  }

  // Takes a line and cuts into visible segments. Return values used for polygon
  // clipping: 0 - there were intersections or the line was empty; 1 - no
  // intersections 2 - there were intersections, and the first and last segments
  // should be rejoined.
  function clipLine(stream) {
    var point0, // previous point
        c0, // code for previous point
        v0, // visibility of previous point
        v00, // visibility of first point
        clean; // no intersections
    return {
      lineStart: function() {
        v00 = v0 = false;
        clean = 1;
      },
      point: function(lambda, phi) {
        var point1 = [lambda, phi],
            point2,
            v = visible(lambda, phi),
            c = smallRadius
              ? v ? 0 : code(lambda, phi)
              : v ? code(lambda + (lambda < 0 ? pi$3 : -pi$3), phi) : 0;
        if (!point0 && (v00 = v0 = v)) stream.lineStart();
        // Handle degeneracies.
        // TODO ignore if not clipping polygons.
        if (v !== v0) {
          point2 = intersect(point0, point1);
          if (!point2 || pointEqual(point0, point2) || pointEqual(point1, point2)) {
            point1[0] += epsilon$2;
            point1[1] += epsilon$2;
            v = visible(point1[0], point1[1]);
          }
        }
        if (v !== v0) {
          clean = 0;
          if (v) {
            // outside going in
            stream.lineStart();
            point2 = intersect(point1, point0);
            stream.point(point2[0], point2[1]);
          } else {
            // inside going out
            point2 = intersect(point0, point1);
            stream.point(point2[0], point2[1]);
            stream.lineEnd();
          }
          point0 = point2;
        } else if (notHemisphere && point0 && smallRadius ^ v) {
          var t;
          // If the codes for two points are different, or are both zero,
          // and there this segment intersects with the small circle.
          if (!(c & c0) && (t = intersect(point1, point0, true))) {
            clean = 0;
            if (smallRadius) {
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
            } else {
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
            }
          }
        }
        if (v && (!point0 || !pointEqual(point0, point1))) {
          stream.point(point1[0], point1[1]);
        }
        point0 = point1, v0 = v, c0 = c;
      },
      lineEnd: function() {
        if (v0) stream.lineEnd();
        point0 = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return clean | ((v00 && v0) << 1);
      }
    };
  }

  // Intersects the great circle between a and b with the clip circle.
  function intersect(a, b, two) {
    var pa = cartesian(a),
        pb = cartesian(b);

    // We have two planes, n1.p = d1 and n2.p = d2.
    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
    var n1 = [1, 0, 0], // normal
        n2 = cartesianCross(pa, pb),
        n2n2 = cartesianDot(n2, n2),
        n1n2 = n2[0], // cartesianDot(n1, n2),
        determinant = n2n2 - n1n2 * n1n2;

    // Two polar points.
    if (!determinant) return !two && a;

    var c1 =  cr * n2n2 / determinant,
        c2 = -cr * n1n2 / determinant,
        n1xn2 = cartesianCross(n1, n2),
        A = cartesianScale(n1, c1),
        B = cartesianScale(n2, c2);
    cartesianAddInPlace(A, B);

    // Solve |p(t)|^2 = 1.
    var u = n1xn2,
        w = cartesianDot(A, u),
        uu = cartesianDot(u, u),
        t2 = w * w - uu * (cartesianDot(A, A) - 1);

    if (t2 < 0) return;

    var t = sqrt(t2),
        q = cartesianScale(u, (-w - t) / uu);
    cartesianAddInPlace(q, A);
    q = spherical(q);

    if (!two) return q;

    // Two intersection points.
    var lambda0 = a[0],
        lambda1 = b[0],
        phi0 = a[1],
        phi1 = b[1],
        z;

    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;

    var delta = lambda1 - lambda0,
        polar = abs(delta - pi$3) < epsilon$2,
        meridian = polar || delta < epsilon$2;

    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;

    // Check that the first point is between a and b.
    if (meridian
        ? polar
          ? phi0 + phi1 > 0 ^ q[1] < (abs(q[0] - lambda0) < epsilon$2 ? phi0 : phi1)
          : phi0 <= q[1] && q[1] <= phi1
        : delta > pi$3 ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
      var q1 = cartesianScale(u, (-w + t) / uu);
      cartesianAddInPlace(q1, A);
      return [q, spherical(q1)];
    }
  }

  // Generates a 4-bit vector representing the location of a point relative to
  // the small circle's bounding box.
  function code(lambda, phi) {
    var r = smallRadius ? radius : pi$3 - radius,
        code = 0;
    if (lambda < -r) code |= 1; // left
    else if (lambda > r) code |= 2; // right
    if (phi < -r) code |= 4; // below
    else if (phi > r) code |= 8; // above
    return code;
  }

  return clip(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-pi$3, radius - pi$3]);
};

var transform = function(methods) {
  return {
    stream: transformer(methods)
  };
};

function transformer(methods) {
  return function(stream) {
    var s = new TransformStream;
    for (var key in methods) s[key] = methods[key];
    s.stream = stream;
    return s;
  };
}

function TransformStream() {}

TransformStream.prototype = {
  constructor: TransformStream,
  point: function(x, y) { this.stream.point(x, y); },
  sphere: function() { this.stream.sphere(); },
  lineStart: function() { this.stream.lineStart(); },
  lineEnd: function() { this.stream.lineEnd(); },
  polygonStart: function() { this.stream.polygonStart(); },
  polygonEnd: function() { this.stream.polygonEnd(); }
};

function fitExtent(projection, extent, object) {
  var w = extent[1][0] - extent[0][0],
      h = extent[1][1] - extent[0][1],
      clip = projection.clipExtent && projection.clipExtent();

  projection
      .scale(150)
      .translate([0, 0]);

  if (clip != null) projection.clipExtent(null);

  geoStream(object, projection.stream(boundsStream$1));

  var b = boundsStream$1.result(),
      k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
      x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
      y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;

  if (clip != null) projection.clipExtent(clip);

  return projection
      .scale(k * 150)
      .translate([x, y]);
}

function fitSize(projection, size, object) {
  return fitExtent(projection, [[0, 0], size], object);
}

var maxDepth = 16;
var cosMinDistance = cos$1(30 * radians); // cos(minimum angular distance)

var resample = function(project, delta2) {
  return +delta2 ? resample$1(project, delta2) : resampleNone(project);
};

function resampleNone(project) {
  return transformer({
    point: function(x, y) {
      x = project(x, y);
      this.stream.point(x[0], x[1]);
    }
  });
}

function resample$1(project, delta2) {

  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
    var dx = x1 - x0,
        dy = y1 - y0,
        d2 = dx * dx + dy * dy;
    if (d2 > 4 * delta2 && depth--) {
      var a = a0 + a1,
          b = b0 + b1,
          c = c0 + c1,
          m = sqrt(a * a + b * b + c * c),
          phi2 = asin(c /= m),
          lambda2 = abs(abs(c) - 1) < epsilon$2 || abs(lambda0 - lambda1) < epsilon$2 ? (lambda0 + lambda1) / 2 : atan2(b, a),
          p = project(lambda2, phi2),
          x2 = p[0],
          y2 = p[1],
          dx2 = x2 - x0,
          dy2 = y2 - y0,
          dz = dy * dx2 - dx * dy2;
      if (dz * dz / d2 > delta2 // perpendicular projected distance
          || abs((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
          || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) { // angular distance
        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
        stream.point(x2, y2);
        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
      }
    }
  }
  return function(stream) {
    var lambda00, x00, y00, a00, b00, c00, // first point
        lambda0, x0, y0, a0, b0, c0; // previous point

    var resampleStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() { stream.polygonStart(); resampleStream.lineStart = ringStart; },
      polygonEnd: function() { stream.polygonEnd(); resampleStream.lineStart = lineStart; }
    };

    function point(x, y) {
      x = project(x, y);
      stream.point(x[0], x[1]);
    }

    function lineStart() {
      x0 = NaN;
      resampleStream.point = linePoint;
      stream.lineStart();
    }

    function linePoint(lambda, phi) {
      var c = cartesian([lambda, phi]), p = project(lambda, phi);
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
      stream.point(x0, y0);
    }

    function lineEnd() {
      resampleStream.point = point;
      stream.lineEnd();
    }

    function ringStart() {
      lineStart();
      resampleStream.point = ringPoint;
      resampleStream.lineEnd = ringEnd;
    }

    function ringPoint(lambda, phi) {
      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
      resampleStream.point = linePoint;
    }

    function ringEnd() {
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
      resampleStream.lineEnd = lineEnd;
      lineEnd();
    }

    return resampleStream;
  };
}

var transformRadians = transformer({
  point: function(x, y) {
    this.stream.point(x * radians, y * radians);
  }
});

function projection(project) {
  return projectionMutator(function() { return project; })();
}

function projectionMutator(projectAt) {
  var project,
      k = 150, // scale
      x = 480, y = 250, // translate
      dx, dy, lambda = 0, phi = 0, // center
      deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, projectRotate, // rotate
      theta = null, preclip = clipAntimeridian, // clip angle
      x0 = null, y0, x1, y1, postclip = identity$4, // clip extent
      delta2 = 0.5, projectResample = resample(projectTransform, delta2), // precision
      cache,
      cacheStream;

  function projection(point) {
    point = projectRotate(point[0] * radians, point[1] * radians);
    return [point[0] * k + dx, dy - point[1] * k];
  }

  function invert(point) {
    point = projectRotate.invert((point[0] - dx) / k, (dy - point[1]) / k);
    return point && [point[0] * degrees$1, point[1] * degrees$1];
  }

  function projectTransform(x, y) {
    return x = project(x, y), [x[0] * k + dx, dy - x[1] * k];
  }

  projection.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = transformRadians(preclip(rotate, projectResample(postclip(cacheStream = stream))));
  };

  projection.clipAngle = function(_) {
    return arguments.length ? (preclip = +_ ? clipCircle(theta = _ * radians, 6 * radians) : (theta = null, clipAntimeridian), reset()) : theta * degrees$1;
  };

  projection.clipExtent = function(_) {
    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity$4) : clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  projection.scale = function(_) {
    return arguments.length ? (k = +_, recenter()) : k;
  };

  projection.translate = function(_) {
    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
  };

  projection.center = function(_) {
    return arguments.length ? (lambda = _[0] % 360 * radians, phi = _[1] % 360 * radians, recenter()) : [lambda * degrees$1, phi * degrees$1];
  };

  projection.rotate = function(_) {
    return arguments.length ? (deltaLambda = _[0] % 360 * radians, deltaPhi = _[1] % 360 * radians, deltaGamma = _.length > 2 ? _[2] % 360 * radians : 0, recenter()) : [deltaLambda * degrees$1, deltaPhi * degrees$1, deltaGamma * degrees$1];
  };

  projection.precision = function(_) {
    return arguments.length ? (projectResample = resample(projectTransform, delta2 = _ * _), reset()) : sqrt(delta2);
  };

  projection.fitExtent = function(extent, object) {
    return fitExtent(projection, extent, object);
  };

  projection.fitSize = function(size, object) {
    return fitSize(projection, size, object);
  };

  function recenter() {
    projectRotate = compose(rotate = rotateRadians(deltaLambda, deltaPhi, deltaGamma), project);
    var center = project(lambda, phi);
    dx = x - center[0] * k;
    dy = y + center[1] * k;
    return reset();
  }

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return function() {
    project = projectAt.apply(this, arguments);
    projection.invert = project.invert && invert;
    return recenter();
  };
}

function conicProjection(projectAt) {
  var phi0 = 0,
      phi1 = pi$3 / 3,
      m = projectionMutator(projectAt),
      p = m(phi0, phi1);

  p.parallels = function(_) {
    return arguments.length ? m(phi0 = _[0] * radians, phi1 = _[1] * radians) : [phi0 * degrees$1, phi1 * degrees$1];
  };

  return p;
}

function cylindricalEqualAreaRaw(phi0) {
  var cosPhi0 = cos$1(phi0);

  function forward(lambda, phi) {
    return [lambda * cosPhi0, sin$1(phi) / cosPhi0];
  }

  forward.invert = function(x, y) {
    return [x / cosPhi0, asin(y * cosPhi0)];
  };

  return forward;
}

function conicEqualAreaRaw(y0, y1) {
  var sy0 = sin$1(y0), n = (sy0 + sin$1(y1)) / 2;

  // Are the parallels symmetrical around the Equator?
  if (abs(n) < epsilon$2) return cylindricalEqualAreaRaw(y0);

  var c = 1 + sy0 * (2 * n - sy0), r0 = sqrt(c) / n;

  function project(x, y) {
    var r = sqrt(c - 2 * n * sin$1(y)) / n;
    return [r * sin$1(x *= n), r0 - r * cos$1(x)];
  }

  project.invert = function(x, y) {
    var r0y = r0 - y;
    return [atan2(x, abs(r0y)) / n * sign(r0y), asin((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
  };

  return project;
}

var conicEqualArea = function() {
  return conicProjection(conicEqualAreaRaw)
      .scale(155.424)
      .center([0, 33.6442]);
};

var albers = function() {
  return conicEqualArea()
      .parallels([29.5, 45.5])
      .scale(1070)
      .translate([480, 250])
      .rotate([96, 0])
      .center([-0.6, 38.7]);
};

// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function multiplex(streams) {
  var n = streams.length;
  return {
    point: function(x, y) { var i = -1; while (++i < n) streams[i].point(x, y); },
    sphere: function() { var i = -1; while (++i < n) streams[i].sphere(); },
    lineStart: function() { var i = -1; while (++i < n) streams[i].lineStart(); },
    lineEnd: function() { var i = -1; while (++i < n) streams[i].lineEnd(); },
    polygonStart: function() { var i = -1; while (++i < n) streams[i].polygonStart(); },
    polygonEnd: function() { var i = -1; while (++i < n) streams[i].polygonEnd(); }
  };
}

// A composite projection for the United States, configured by default for
// 960×500. The projection also works quite well at 960×600 if you change the
// scale to 1285 and adjust the translate accordingly. The set of standard
// parallels for each region comes from USGS, which is published here:
// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
var albersUsa = function() {
  var cache,
      cacheStream,
      lower48 = albers(), lower48Point,
      alaska = conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, // EPSG:3338
      hawaii = conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, // ESRI:102007
      point, pointStream = {point: function(x, y) { point = [x, y]; }};

  function albersUsa(coordinates) {
    var x = coordinates[0], y = coordinates[1];
    return point = null,
        (lower48Point.point(x, y), point)
        || (alaskaPoint.point(x, y), point)
        || (hawaiiPoint.point(x, y), point);
  }

  albersUsa.invert = function(coordinates) {
    var k = lower48.scale(),
        t = lower48.translate(),
        x = (coordinates[0] - t[0]) / k,
        y = (coordinates[1] - t[1]) / k;
    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
        : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
        : lower48).invert(coordinates);
  };

  albersUsa.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
  };

  albersUsa.precision = function(_) {
    if (!arguments.length) return lower48.precision();
    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
    return reset();
  };

  albersUsa.scale = function(_) {
    if (!arguments.length) return lower48.scale();
    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
    return albersUsa.translate(lower48.translate());
  };

  albersUsa.translate = function(_) {
    if (!arguments.length) return lower48.translate();
    var k = lower48.scale(), x = +_[0], y = +_[1];

    lower48Point = lower48
        .translate(_)
        .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
        .stream(pointStream);

    alaskaPoint = alaska
        .translate([x - 0.307 * k, y + 0.201 * k])
        .clipExtent([[x - 0.425 * k + epsilon$2, y + 0.120 * k + epsilon$2], [x - 0.214 * k - epsilon$2, y + 0.234 * k - epsilon$2]])
        .stream(pointStream);

    hawaiiPoint = hawaii
        .translate([x - 0.205 * k, y + 0.212 * k])
        .clipExtent([[x - 0.214 * k + epsilon$2, y + 0.166 * k + epsilon$2], [x - 0.115 * k - epsilon$2, y + 0.234 * k - epsilon$2]])
        .stream(pointStream);

    return reset();
  };

  albersUsa.fitExtent = function(extent, object) {
    return fitExtent(albersUsa, extent, object);
  };

  albersUsa.fitSize = function(size, object) {
    return fitSize(albersUsa, size, object);
  };

  function reset() {
    cache = cacheStream = null;
    return albersUsa;
  }

  return albersUsa.scale(1070);
};

function azimuthalRaw(scale) {
  return function(x, y) {
    var cx = cos$1(x),
        cy = cos$1(y),
        k = scale(cx * cy);
    return [
      k * cy * sin$1(x),
      k * sin$1(y)
    ];
  }
}

function azimuthalInvert(angle) {
  return function(x, y) {
    var z = sqrt(x * x + y * y),
        c = angle(z),
        sc = sin$1(c),
        cc = cos$1(c);
    return [
      atan2(x * sc, z * cc),
      asin(z && y * sc / z)
    ];
  }
}

var azimuthalEqualAreaRaw = azimuthalRaw(function(cxcy) {
  return sqrt(2 / (1 + cxcy));
});

azimuthalEqualAreaRaw.invert = azimuthalInvert(function(z) {
  return 2 * asin(z / 2);
});

var azimuthalEqualArea = function() {
  return projection(azimuthalEqualAreaRaw)
      .scale(124.75)
      .clipAngle(180 - 1e-3);
};

var azimuthalEquidistantRaw = azimuthalRaw(function(c) {
  return (c = acos(c)) && c / sin$1(c);
});

azimuthalEquidistantRaw.invert = azimuthalInvert(function(z) {
  return z;
});

var azimuthalEquidistant = function() {
  return projection(azimuthalEquidistantRaw)
      .scale(79.4188)
      .clipAngle(180 - 1e-3);
};

function mercatorRaw(lambda, phi) {
  return [lambda, log(tan((halfPi$2 + phi) / 2))];
}

mercatorRaw.invert = function(x, y) {
  return [x, 2 * atan(exp(y)) - halfPi$2];
};

var mercator = function() {
  return mercatorProjection(mercatorRaw)
      .scale(961 / tau$3);
};

function mercatorProjection(project) {
  var m = projection(project),
      center = m.center,
      scale = m.scale,
      translate = m.translate,
      clipExtent = m.clipExtent,
      x0 = null, y0, x1, y1; // clip extent

  m.scale = function(_) {
    return arguments.length ? (scale(_), reclip()) : scale();
  };

  m.translate = function(_) {
    return arguments.length ? (translate(_), reclip()) : translate();
  };

  m.center = function(_) {
    return arguments.length ? (center(_), reclip()) : center();
  };

  m.clipExtent = function(_) {
    return arguments.length ? ((_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1])), reclip()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  function reclip() {
    var k = pi$3 * scale(),
        t = m(rotation(m.rotate()).invert([0, 0]));
    return clipExtent(x0 == null
        ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw
        ? [[Math.max(t[0] - k, x0), y0], [Math.min(t[0] + k, x1), y1]]
        : [[x0, Math.max(t[1] - k, y0)], [x1, Math.min(t[1] + k, y1)]]);
  }

  return reclip();
}

function tany(y) {
  return tan((halfPi$2 + y) / 2);
}

function conicConformalRaw(y0, y1) {
  var cy0 = cos$1(y0),
      n = y0 === y1 ? sin$1(y0) : log(cy0 / cos$1(y1)) / log(tany(y1) / tany(y0)),
      f = cy0 * pow(tany(y0), n) / n;

  if (!n) return mercatorRaw;

  function project(x, y) {
    if (f > 0) { if (y < -halfPi$2 + epsilon$2) y = -halfPi$2 + epsilon$2; }
    else { if (y > halfPi$2 - epsilon$2) y = halfPi$2 - epsilon$2; }
    var r = f / pow(tany(y), n);
    return [r * sin$1(n * x), f - r * cos$1(n * x)];
  }

  project.invert = function(x, y) {
    var fy = f - y, r = sign(n) * sqrt(x * x + fy * fy);
    return [atan2(x, abs(fy)) / n * sign(fy), 2 * atan(pow(f / r, 1 / n)) - halfPi$2];
  };

  return project;
}

var conicConformal = function() {
  return conicProjection(conicConformalRaw)
      .scale(109.5)
      .parallels([30, 30]);
};

function equirectangularRaw(lambda, phi) {
  return [lambda, phi];
}

equirectangularRaw.invert = equirectangularRaw;

var equirectangular = function() {
  return projection(equirectangularRaw)
      .scale(152.63);
};

function conicEquidistantRaw(y0, y1) {
  var cy0 = cos$1(y0),
      n = y0 === y1 ? sin$1(y0) : (cy0 - cos$1(y1)) / (y1 - y0),
      g = cy0 / n + y0;

  if (abs(n) < epsilon$2) return equirectangularRaw;

  function project(x, y) {
    var gy = g - y, nx = n * x;
    return [gy * sin$1(nx), g - gy * cos$1(nx)];
  }

  project.invert = function(x, y) {
    var gy = g - y;
    return [atan2(x, abs(gy)) / n * sign(gy), g - sign(n) * sqrt(x * x + gy * gy)];
  };

  return project;
}

var conicEquidistant = function() {
  return conicProjection(conicEquidistantRaw)
      .scale(131.154)
      .center([0, 13.9389]);
};

function gnomonicRaw(x, y) {
  var cy = cos$1(y), k = cos$1(x) * cy;
  return [cy * sin$1(x) / k, sin$1(y) / k];
}

gnomonicRaw.invert = azimuthalInvert(atan);

var gnomonic = function() {
  return projection(gnomonicRaw)
      .scale(144.049)
      .clipAngle(60);
};

function scaleTranslate(kx, ky, tx, ty) {
  return kx === 1 && ky === 1 && tx === 0 && ty === 0 ? identity$4 : transformer({
    point: function(x, y) {
      this.stream.point(x * kx + tx, y * ky + ty);
    }
  });
}

var identity$5 = function() {
  var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, transform = identity$4, // scale, translate and reflect
      x0 = null, y0, x1, y1, clip = identity$4, // clip extent
      cache,
      cacheStream,
      projection;

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return projection = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = transform(clip(cacheStream = stream));
    },
    clipExtent: function(_) {
      return arguments.length ? (clip = _ == null ? (x0 = y0 = x1 = y1 = null, identity$4) : clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
    },
    scale: function(_) {
      return arguments.length ? (transform = scaleTranslate((k = +_) * sx, k * sy, tx, ty), reset()) : k;
    },
    translate: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * sx, k * sy, tx = +_[0], ty = +_[1]), reset()) : [tx, ty];
    },
    reflectX: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * (sx = _ ? -1 : 1), k * sy, tx, ty), reset()) : sx < 0;
    },
    reflectY: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * sx, k * (sy = _ ? -1 : 1), tx, ty), reset()) : sy < 0;
    },
    fitExtent: function(extent, object) {
      return fitExtent(projection, extent, object);
    },
    fitSize: function(size, object) {
      return fitSize(projection, size, object);
    }
  };
};

function orthographicRaw(x, y) {
  return [cos$1(y) * sin$1(x), sin$1(y)];
}

orthographicRaw.invert = azimuthalInvert(asin);

var orthographic = function() {
  return projection(orthographicRaw)
      .scale(249.5)
      .clipAngle(90 + epsilon$2);
};

function stereographicRaw(x, y) {
  var cy = cos$1(y), k = 1 + cos$1(x) * cy;
  return [cy * sin$1(x) / k, sin$1(y) / k];
}

stereographicRaw.invert = azimuthalInvert(function(z) {
  return 2 * atan(z);
});

var stereographic = function() {
  return projection(stereographicRaw)
      .scale(250)
      .clipAngle(142);
};

function transverseMercatorRaw(lambda, phi) {
  return [log(tan((halfPi$2 + phi) / 2)), -lambda];
}

transverseMercatorRaw.invert = function(x, y) {
  return [-y, 2 * atan(exp(x)) - halfPi$2];
};

var transverseMercator = function() {
  var m = mercatorProjection(transverseMercatorRaw),
      center = m.center,
      rotate = m.rotate;

  m.center = function(_) {
    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
  };

  m.rotate = function(_) {
    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
  };

  return rotate([0, 0, 90])
      .scale(159.155);
};

function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

function meanX(children) {
  return children.reduce(meanXReduce, 0) / children.length;
}

function meanXReduce(x, c) {
  return x + c.x;
}

function maxY(children) {
  return 1 + children.reduce(maxYReduce, 0);
}

function maxYReduce(y, c) {
  return Math.max(y, c.y);
}

function leafLeft(node) {
  var children;
  while (children = node.children) node = children[0];
  return node;
}

function leafRight(node) {
  var children;
  while (children = node.children) node = children[children.length - 1];
  return node;
}

var cluster = function() {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = false;

  function cluster(root) {
    var previousNode,
        x = 0;

    // First walk, computing the initial x & y values.
    root.eachAfter(function(node) {
      var children = node.children;
      if (children) {
        node.x = meanX(children);
        node.y = maxY(children);
      } else {
        node.x = previousNode ? x += separation(node, previousNode) : 0;
        node.y = 0;
        previousNode = node;
      }
    });

    var left = leafLeft(root),
        right = leafRight(root),
        x0 = left.x - separation(left, right) / 2,
        x1 = right.x + separation(right, left) / 2;

    // Second walk, normalizing x & y to the desired size.
    return root.eachAfter(nodeSize ? function(node) {
      node.x = (node.x - root.x) * dx;
      node.y = (root.y - node.y) * dy;
    } : function(node) {
      node.x = (node.x - x0) / (x1 - x0) * dx;
      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
    });
  }

  cluster.separation = function(x) {
    return arguments.length ? (separation = x, cluster) : separation;
  };

  cluster.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
  };

  cluster.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
  };

  return cluster;
};

function count(node) {
  var sum = 0,
      children = node.children,
      i = children && children.length;
  if (!i) sum = 1;
  else while (--i >= 0) sum += children[i].value;
  node.value = sum;
}

var node_count = function() {
  return this.eachAfter(count);
};

var node_each = function(callback) {
  var node = this, current, next = [node], children, i, n;
  do {
    current = next.reverse(), next = [];
    while (node = current.pop()) {
      callback(node), children = node.children;
      if (children) for (i = 0, n = children.length; i < n; ++i) {
        next.push(children[i]);
      }
    }
  } while (next.length);
  return this;
};

var node_eachBefore = function(callback) {
  var node = this, nodes = [node], children, i;
  while (node = nodes.pop()) {
    callback(node), children = node.children;
    if (children) for (i = children.length - 1; i >= 0; --i) {
      nodes.push(children[i]);
    }
  }
  return this;
};

var node_eachAfter = function(callback) {
  var node = this, nodes = [node], next = [], children, i, n;
  while (node = nodes.pop()) {
    next.push(node), children = node.children;
    if (children) for (i = 0, n = children.length; i < n; ++i) {
      nodes.push(children[i]);
    }
  }
  while (node = next.pop()) {
    callback(node);
  }
  return this;
};

var node_sum = function(value) {
  return this.eachAfter(function(node) {
    var sum = +value(node.data) || 0,
        children = node.children,
        i = children && children.length;
    while (--i >= 0) sum += children[i].value;
    node.value = sum;
  });
};

var node_sort = function(compare) {
  return this.eachBefore(function(node) {
    if (node.children) {
      node.children.sort(compare);
    }
  });
};

var node_path = function(end) {
  var start = this,
      ancestor = leastCommonAncestor(start, end),
      nodes = [start];
  while (start !== ancestor) {
    start = start.parent;
    nodes.push(start);
  }
  var k = nodes.length;
  while (end !== ancestor) {
    nodes.splice(k, 0, end);
    end = end.parent;
  }
  return nodes;
};

function leastCommonAncestor(a, b) {
  if (a === b) return a;
  var aNodes = a.ancestors(),
      bNodes = b.ancestors(),
      c = null;
  a = aNodes.pop();
  b = bNodes.pop();
  while (a === b) {
    c = a;
    a = aNodes.pop();
    b = bNodes.pop();
  }
  return c;
}

var node_ancestors = function() {
  var node = this, nodes = [node];
  while (node = node.parent) {
    nodes.push(node);
  }
  return nodes;
};

var node_descendants = function() {
  var nodes = [];
  this.each(function(node) {
    nodes.push(node);
  });
  return nodes;
};

var node_leaves = function() {
  var leaves = [];
  this.eachBefore(function(node) {
    if (!node.children) {
      leaves.push(node);
    }
  });
  return leaves;
};

var node_links = function() {
  var root = this, links = [];
  root.each(function(node) {
    if (node !== root) { // Don’t include the root’s parent, if any.
      links.push({source: node.parent, target: node});
    }
  });
  return links;
};

function hierarchy(data, children) {
  var root = new Node(data),
      valued = +data.value && (root.value = data.value),
      node,
      nodes = [root],
      child,
      childs,
      i,
      n;

  if (children == null) children = defaultChildren;

  while (node = nodes.pop()) {
    if (valued) node.value = +node.data.value;
    if ((childs = children(node.data)) && (n = childs.length)) {
      node.children = new Array(n);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new Node(childs[i]));
        child.parent = node;
        child.depth = node.depth + 1;
      }
    }
  }

  return root.eachBefore(computeHeight);
}

function node_copy() {
  return hierarchy(this).eachBefore(copyData);
}

function defaultChildren(d) {
  return d.children;
}

function copyData(node) {
  node.data = node.data.data;
}

function computeHeight(node) {
  var height = 0;
  do node.height = height;
  while ((node = node.parent) && (node.height < ++height));
}

function Node(data) {
  this.data = data;
  this.depth =
  this.height = 0;
  this.parent = null;
}

Node.prototype = hierarchy.prototype = {
  constructor: Node,
  count: node_count,
  each: node_each,
  eachAfter: node_eachAfter,
  eachBefore: node_eachBefore,
  sum: node_sum,
  sort: node_sort,
  path: node_path,
  ancestors: node_ancestors,
  descendants: node_descendants,
  leaves: node_leaves,
  links: node_links,
  copy: node_copy
};

function Node$2(value) {
  this._ = value;
  this.next = null;
}

var shuffle$1 = function(array) {
  var i,
      n = (array = array.slice()).length,
      head = null,
      node = head;

  while (n) {
    var next = new Node$2(array[n - 1]);
    if (node) node = node.next = next;
    else node = head = next;
    array[i] = array[--n];
  }

  return {
    head: head,
    tail: node
  };
};

var enclose = function(circles) {
  return encloseN(shuffle$1(circles), []);
};

function encloses(a, b) {
  var dx = b.x - a.x,
      dy = b.y - a.y,
      dr = a.r - b.r;
  return dr * dr + 1e-6 > dx * dx + dy * dy;
}

// Returns the smallest circle that contains circles L and intersects circles B.
function encloseN(L, B) {
  var circle,
      l0 = null,
      l1 = L.head,
      l2,
      p1;

  switch (B.length) {
    case 1: circle = enclose1(B[0]); break;
    case 2: circle = enclose2(B[0], B[1]); break;
    case 3: circle = enclose3(B[0], B[1], B[2]); break;
  }

  while (l1) {
    p1 = l1._, l2 = l1.next;
    if (!circle || !encloses(circle, p1)) {

      // Temporarily truncate L before l1.
      if (l0) L.tail = l0, l0.next = null;
      else L.head = L.tail = null;

      B.push(p1);
      circle = encloseN(L, B); // Note: reorders L!
      B.pop();

      // Move l1 to the front of L and reconnect the truncated list L.
      if (L.head) l1.next = L.head, L.head = l1;
      else l1.next = null, L.head = L.tail = l1;
      l0 = L.tail, l0.next = l2;

    } else {
      l0 = l1;
    }
    l1 = l2;
  }

  L.tail = l0;
  return circle;
}

function enclose1(a) {
  return {
    x: a.x,
    y: a.y,
    r: a.r
  };
}

function enclose2(a, b) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
      l = Math.sqrt(x21 * x21 + y21 * y21);
  return {
    x: (x1 + x2 + x21 / l * r21) / 2,
    y: (y1 + y2 + y21 / l * r21) / 2,
    r: (l + r1 + r2) / 2
  };
}

function enclose3(a, b, c) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x3 = c.x, y3 = c.y, r3 = c.r,
      a2 = 2 * (x1 - x2),
      b2 = 2 * (y1 - y2),
      c2 = 2 * (r2 - r1),
      d2 = x1 * x1 + y1 * y1 - r1 * r1 - x2 * x2 - y2 * y2 + r2 * r2,
      a3 = 2 * (x1 - x3),
      b3 = 2 * (y1 - y3),
      c3 = 2 * (r3 - r1),
      d3 = x1 * x1 + y1 * y1 - r1 * r1 - x3 * x3 - y3 * y3 + r3 * r3,
      ab = a3 * b2 - a2 * b3,
      xa = (b2 * d3 - b3 * d2) / ab - x1,
      xb = (b3 * c2 - b2 * c3) / ab,
      ya = (a3 * d2 - a2 * d3) / ab - y1,
      yb = (a2 * c3 - a3 * c2) / ab,
      A = xb * xb + yb * yb - 1,
      B = 2 * (xa * xb + ya * yb + r1),
      C = xa * xa + ya * ya - r1 * r1,
      r = (-B - Math.sqrt(B * B - 4 * A * C)) / (2 * A);
  return {
    x: xa + xb * r + x1,
    y: ya + yb * r + y1,
    r: r
  };
}

function place(a, b, c) {
  var ax = a.x,
      ay = a.y,
      da = b.r + c.r,
      db = a.r + c.r,
      dx = b.x - ax,
      dy = b.y - ay,
      dc = dx * dx + dy * dy;
  if (dc) {
    var x = 0.5 + ((db *= db) - (da *= da)) / (2 * dc),
        y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
    c.x = ax + x * dx + y * dy;
    c.y = ay + x * dy - y * dx;
  } else {
    c.x = ax + db;
    c.y = ay;
  }
}

function intersects(a, b) {
  var dx = b.x - a.x,
      dy = b.y - a.y,
      dr = a.r + b.r;
  return dr * dr - 1e-6 > dx * dx + dy * dy;
}

function distance2(node, x, y) {
  var a = node._,
      b = node.next._,
      ab = a.r + b.r,
      dx = (a.x * b.r + b.x * a.r) / ab - x,
      dy = (a.y * b.r + b.y * a.r) / ab - y;
  return dx * dx + dy * dy;
}

function Node$1(circle) {
  this._ = circle;
  this.next = null;
  this.previous = null;
}

function packEnclose(circles) {
  if (!(n = circles.length)) return 0;

  var a, b, c, n;

  // Place the first circle.
  a = circles[0], a.x = 0, a.y = 0;
  if (!(n > 1)) return a.r;

  // Place the second circle.
  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
  if (!(n > 2)) return a.r + b.r;

  // Place the third circle.
  place(b, a, c = circles[2]);

  // Initialize the weighted centroid.
  var aa = a.r * a.r,
      ba = b.r * b.r,
      ca = c.r * c.r,
      oa = aa + ba + ca,
      ox = aa * a.x + ba * b.x + ca * c.x,
      oy = aa * a.y + ba * b.y + ca * c.y,
      cx, cy, i, j, k, sj, sk;

  // Initialize the front-chain using the first three circles a, b and c.
  a = new Node$1(a), b = new Node$1(b), c = new Node$1(c);
  a.next = c.previous = b;
  b.next = a.previous = c;
  c.next = b.previous = a;

  // Attempt to place each remaining circle…
  pack: for (i = 3; i < n; ++i) {
    place(a._, b._, c = circles[i]), c = new Node$1(c);

    // Find the closest intersecting circle on the front-chain, if any.
    // “Closeness” is determined by linear distance along the front-chain.
    // “Ahead” or “behind” is likewise determined by linear distance.
    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
    do {
      if (sj <= sk) {
        if (intersects(j._, c._)) {
          b = j, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sj += j._.r, j = j.next;
      } else {
        if (intersects(k._, c._)) {
          a = k, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sk += k._.r, k = k.previous;
      }
    } while (j !== k.next);

    // Success! Insert the new circle c between a and b.
    c.previous = a, c.next = b, a.next = b.previous = b = c;

    // Update the weighted centroid.
    oa += ca = c._.r * c._.r;
    ox += ca * c._.x;
    oy += ca * c._.y;

    // Compute the new closest circle pair to the centroid.
    aa = distance2(a, cx = ox / oa, cy = oy / oa);
    while ((c = c.next) !== b) {
      if ((ca = distance2(c, cx, cy)) < aa) {
        a = c, aa = ca;
      }
    }
    b = a.next;
  }

  // Compute the enclosing circle of the front chain.
  a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = enclose(a);

  // Translate the circles to put the enclosing circle around the origin.
  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;

  return c.r;
}

var siblings = function(circles) {
  packEnclose(circles);
  return circles;
};

function optional(f) {
  return f == null ? null : required(f);
}

function required(f) {
  if (typeof f !== "function") throw new Error;
  return f;
}

function constantZero() {
  return 0;
}

var constant$8 = function(x) {
  return function() {
    return x;
  };
};

function defaultRadius$1(d) {
  return Math.sqrt(d.value);
}

var index$2 = function() {
  var radius = null,
      dx = 1,
      dy = 1,
      padding = constantZero;

  function pack(root) {
    root.x = dx / 2, root.y = dy / 2;
    if (radius) {
      root.eachBefore(radiusLeaf(radius))
          .eachAfter(packChildren(padding, 0.5))
          .eachBefore(translateChild(1));
    } else {
      root.eachBefore(radiusLeaf(defaultRadius$1))
          .eachAfter(packChildren(constantZero, 1))
          .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
          .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
    }
    return root;
  }

  pack.radius = function(x) {
    return arguments.length ? (radius = optional(x), pack) : radius;
  };

  pack.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
  };

  pack.padding = function(x) {
    return arguments.length ? (padding = typeof x === "function" ? x : constant$8(+x), pack) : padding;
  };

  return pack;
};

function radiusLeaf(radius) {
  return function(node) {
    if (!node.children) {
      node.r = Math.max(0, +radius(node) || 0);
    }
  };
}

function packChildren(padding, k) {
  return function(node) {
    if (children = node.children) {
      var children,
          i,
          n = children.length,
          r = padding(node) * k || 0,
          e;

      if (r) for (i = 0; i < n; ++i) children[i].r += r;
      e = packEnclose(children);
      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
      node.r = e + r;
    }
  };
}

function translateChild(k) {
  return function(node) {
    var parent = node.parent;
    node.r *= k;
    if (parent) {
      node.x = parent.x + k * node.x;
      node.y = parent.y + k * node.y;
    }
  };
}

var roundNode = function(node) {
  node.x0 = Math.round(node.x0);
  node.y0 = Math.round(node.y0);
  node.x1 = Math.round(node.x1);
  node.y1 = Math.round(node.y1);
};

var treemapDice = function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (x1 - x0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.y0 = y0, node.y1 = y1;
    node.x0 = x0, node.x1 = x0 += node.value * k;
  }
};

var partition = function() {
  var dx = 1,
      dy = 1,
      padding = 0,
      round = false;

  function partition(root) {
    var n = root.height + 1;
    root.x0 =
    root.y0 = padding;
    root.x1 = dx;
    root.y1 = dy / n;
    root.eachBefore(positionNode(dy, n));
    if (round) root.eachBefore(roundNode);
    return root;
  }

  function positionNode(dy, n) {
    return function(node) {
      if (node.children) {
        treemapDice(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
      }
      var x0 = node.x0,
          y0 = node.y0,
          x1 = node.x1 - padding,
          y1 = node.y1 - padding;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      node.x0 = x0;
      node.y0 = y0;
      node.x1 = x1;
      node.y1 = y1;
    };
  }

  partition.round = function(x) {
    return arguments.length ? (round = !!x, partition) : round;
  };

  partition.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
  };

  partition.padding = function(x) {
    return arguments.length ? (padding = +x, partition) : padding;
  };

  return partition;
};

var keyPrefix$1 = "$";
var preroot = {depth: -1};
var ambiguous = {};

function defaultId(d) {
  return d.id;
}

function defaultParentId(d) {
  return d.parentId;
}

var stratify = function() {
  var id = defaultId,
      parentId = defaultParentId;

  function stratify(data) {
    var d,
        i,
        n = data.length,
        root,
        parent,
        node,
        nodes = new Array(n),
        nodeId,
        nodeKey,
        nodeByKey = {};

    for (i = 0; i < n; ++i) {
      d = data[i], node = nodes[i] = new Node(d);
      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
        nodeKey = keyPrefix$1 + (node.id = nodeId);
        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
      }
    }

    for (i = 0; i < n; ++i) {
      node = nodes[i], nodeId = parentId(data[i], i, data);
      if (nodeId == null || !(nodeId += "")) {
        if (root) throw new Error("multiple roots");
        root = node;
      } else {
        parent = nodeByKey[keyPrefix$1 + nodeId];
        if (!parent) throw new Error("missing: " + nodeId);
        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
        if (parent.children) parent.children.push(node);
        else parent.children = [node];
        node.parent = parent;
      }
    }

    if (!root) throw new Error("no root");
    root.parent = preroot;
    root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(computeHeight);
    root.parent = null;
    if (n > 0) throw new Error("cycle");

    return root;
  }

  stratify.id = function(x) {
    return arguments.length ? (id = required(x), stratify) : id;
  };

  stratify.parentId = function(x) {
    return arguments.length ? (parentId = required(x), stratify) : parentId;
  };

  return stratify;
};

function defaultSeparation$1(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }

// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function nextLeft(v) {
  var children = v.children;
  return children ? children[0] : v.t;
}

// This function works analogously to nextLeft.
function nextRight(v) {
  var children = v.children;
  return children ? children[children.length - 1] : v.t;
}

// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function moveSubtree(wm, wp, shift) {
  var change = shift / (wp.i - wm.i);
  wp.c -= change;
  wp.s += shift;
  wm.c += change;
  wp.z += shift;
  wp.m += shift;
}

// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function executeShifts(v) {
  var shift = 0,
      change = 0,
      children = v.children,
      i = children.length,
      w;
  while (--i >= 0) {
    w = children[i];
    w.z += shift;
    w.m += shift;
    shift += w.s + (change += w.c);
  }
}

// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function nextAncestor(vim, v, ancestor) {
  return vim.a.parent === v.parent ? vim.a : ancestor;
}

function TreeNode(node, i) {
  this._ = node;
  this.parent = null;
  this.children = null;
  this.A = null; // default ancestor
  this.a = this; // ancestor
  this.z = 0; // prelim
  this.m = 0; // mod
  this.c = 0; // change
  this.s = 0; // shift
  this.t = null; // thread
  this.i = i; // number
}

TreeNode.prototype = Object.create(Node.prototype);

function treeRoot(root) {
  var tree = new TreeNode(root, 0),
      node,
      nodes = [tree],
      child,
      children,
      i,
      n;

  while (node = nodes.pop()) {
    if (children = node._.children) {
      node.children = new Array(n = children.length);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
        child.parent = node;
      }
    }
  }

  (tree.parent = new TreeNode(null, 0)).children = [tree];
  return tree;
}

// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
var tree = function() {
  var separation = defaultSeparation$1,
      dx = 1,
      dy = 1,
      nodeSize = null;

  function tree(root) {
    var t = treeRoot(root);

    // Compute the layout using Buchheim et al.’s algorithm.
    t.eachAfter(firstWalk), t.parent.m = -t.z;
    t.eachBefore(secondWalk);

    // If a fixed node size is specified, scale x and y.
    if (nodeSize) root.eachBefore(sizeNode);

    // If a fixed tree size is specified, scale x and y based on the extent.
    // Compute the left-most, right-most, and depth-most nodes for extents.
    else {
      var left = root,
          right = root,
          bottom = root;
      root.eachBefore(function(node) {
        if (node.x < left.x) left = node;
        if (node.x > right.x) right = node;
        if (node.depth > bottom.depth) bottom = node;
      });
      var s = left === right ? 1 : separation(left, right) / 2,
          tx = s - left.x,
          kx = dx / (right.x + s + tx),
          ky = dy / (bottom.depth || 1);
      root.eachBefore(function(node) {
        node.x = (node.x + tx) * kx;
        node.y = node.depth * ky;
      });
    }

    return root;
  }

  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
  // applied recursively to the children of v, as well as the function
  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
  // node v is placed to the midpoint of its outermost children.
  function firstWalk(v) {
    var children = v.children,
        siblings = v.parent.children,
        w = v.i ? siblings[v.i - 1] : null;
    if (children) {
      executeShifts(v);
      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
      if (w) {
        v.z = w.z + separation(v._, w._);
        v.m = v.z - midpoint;
      } else {
        v.z = midpoint;
      }
    } else if (w) {
      v.z = w.z + separation(v._, w._);
    }
    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
  }

  // Computes all real x-coordinates by summing up the modifiers recursively.
  function secondWalk(v) {
    v._.x = v.z + v.parent.m;
    v.m += v.parent.m;
  }

  // The core of the algorithm. Here, a new subtree is combined with the
  // previous subtrees. Threads are used to traverse the inside and outside
  // contours of the left and right subtree up to the highest common level. The
  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
  // superscript o means outside and i means inside, the subscript - means left
  // subtree and + means right subtree. For summing up the modifiers along the
  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
  // nodes of the inside contours conflict, we compute the left one of the
  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
  // Finally, we add a new thread (if necessary).
  function apportion(v, w, ancestor) {
    if (w) {
      var vip = v,
          vop = v,
          vim = w,
          vom = vip.parent.children[0],
          sip = vip.m,
          sop = vop.m,
          sim = vim.m,
          som = vom.m,
          shift;
      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
        vom = nextLeft(vom);
        vop = nextRight(vop);
        vop.a = v;
        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
        if (shift > 0) {
          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
          sip += shift;
          sop += shift;
        }
        sim += vim.m;
        sip += vip.m;
        som += vom.m;
        sop += vop.m;
      }
      if (vim && !nextRight(vop)) {
        vop.t = vim;
        vop.m += sim - sop;
      }
      if (vip && !nextLeft(vom)) {
        vom.t = vip;
        vom.m += sip - som;
        ancestor = v;
      }
    }
    return ancestor;
  }

  function sizeNode(node) {
    node.x *= dx;
    node.y = node.depth * dy;
  }

  tree.separation = function(x) {
    return arguments.length ? (separation = x, tree) : separation;
  };

  tree.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
  };

  tree.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
  };

  return tree;
};

var treemapSlice = function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (y1 - y0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.x0 = x0, node.x1 = x1;
    node.y0 = y0, node.y1 = y0 += node.value * k;
  }
};

var phi = (1 + Math.sqrt(5)) / 2;

function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
  var rows = [],
      nodes = parent.children,
      row,
      nodeValue,
      i0 = 0,
      i1 = 0,
      n = nodes.length,
      dx, dy,
      value = parent.value,
      sumValue,
      minValue,
      maxValue,
      newRatio,
      minRatio,
      alpha,
      beta;

  while (i0 < n) {
    dx = x1 - x0, dy = y1 - y0;

    // Find the next non-empty node.
    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
    minValue = maxValue = sumValue;
    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
    beta = sumValue * sumValue * alpha;
    minRatio = Math.max(maxValue / beta, beta / minValue);

    // Keep adding nodes while the aspect ratio maintains or improves.
    for (; i1 < n; ++i1) {
      sumValue += nodeValue = nodes[i1].value;
      if (nodeValue < minValue) minValue = nodeValue;
      if (nodeValue > maxValue) maxValue = nodeValue;
      beta = sumValue * sumValue * alpha;
      newRatio = Math.max(maxValue / beta, beta / minValue);
      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
      minRatio = newRatio;
    }

    // Position and record the row orientation.
    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
    if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
    else treemapSlice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
    value -= sumValue, i0 = i1;
  }

  return rows;
}

var squarify = ((function custom(ratio) {

  function squarify(parent, x0, y0, x1, y1) {
    squarifyRatio(ratio, parent, x0, y0, x1, y1);
  }

  squarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return squarify;
}))(phi);

var index$3 = function() {
  var tile = squarify,
      round = false,
      dx = 1,
      dy = 1,
      paddingStack = [0],
      paddingInner = constantZero,
      paddingTop = constantZero,
      paddingRight = constantZero,
      paddingBottom = constantZero,
      paddingLeft = constantZero;

  function treemap(root) {
    root.x0 =
    root.y0 = 0;
    root.x1 = dx;
    root.y1 = dy;
    root.eachBefore(positionNode);
    paddingStack = [0];
    if (round) root.eachBefore(roundNode);
    return root;
  }

  function positionNode(node) {
    var p = paddingStack[node.depth],
        x0 = node.x0 + p,
        y0 = node.y0 + p,
        x1 = node.x1 - p,
        y1 = node.y1 - p;
    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
    node.x0 = x0;
    node.y0 = y0;
    node.x1 = x1;
    node.y1 = y1;
    if (node.children) {
      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
      x0 += paddingLeft(node) - p;
      y0 += paddingTop(node) - p;
      x1 -= paddingRight(node) - p;
      y1 -= paddingBottom(node) - p;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      tile(node, x0, y0, x1, y1);
    }
  }

  treemap.round = function(x) {
    return arguments.length ? (round = !!x, treemap) : round;
  };

  treemap.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
  };

  treemap.tile = function(x) {
    return arguments.length ? (tile = required(x), treemap) : tile;
  };

  treemap.padding = function(x) {
    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
  };

  treemap.paddingInner = function(x) {
    return arguments.length ? (paddingInner = typeof x === "function" ? x : constant$8(+x), treemap) : paddingInner;
  };

  treemap.paddingOuter = function(x) {
    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
  };

  treemap.paddingTop = function(x) {
    return arguments.length ? (paddingTop = typeof x === "function" ? x : constant$8(+x), treemap) : paddingTop;
  };

  treemap.paddingRight = function(x) {
    return arguments.length ? (paddingRight = typeof x === "function" ? x : constant$8(+x), treemap) : paddingRight;
  };

  treemap.paddingBottom = function(x) {
    return arguments.length ? (paddingBottom = typeof x === "function" ? x : constant$8(+x), treemap) : paddingBottom;
  };

  treemap.paddingLeft = function(x) {
    return arguments.length ? (paddingLeft = typeof x === "function" ? x : constant$8(+x), treemap) : paddingLeft;
  };

  return treemap;
};

var binary = function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      i, n = nodes.length,
      sum, sums = new Array(n + 1);

  for (sums[0] = sum = i = 0; i < n; ++i) {
    sums[i + 1] = sum += nodes[i].value;
  }

  partition(0, n, parent.value, x0, y0, x1, y1);

  function partition(i, j, value, x0, y0, x1, y1) {
    if (i >= j - 1) {
      var node = nodes[i];
      node.x0 = x0, node.y0 = y0;
      node.x1 = x1, node.y1 = y1;
      return;
    }

    var valueOffset = sums[i],
        valueTarget = (value / 2) + valueOffset,
        k = i + 1,
        hi = j - 1;

    while (k < hi) {
      var mid = k + hi >>> 1;
      if (sums[mid] < valueTarget) k = mid + 1;
      else hi = mid;
    }

    if ((valueTarget - sums[k - 1]) < (sums[k] - valueTarget) && i + 1 < k) --k;

    var valueLeft = sums[k] - valueOffset,
        valueRight = value - valueLeft;

    if ((x1 - x0) > (y1 - y0)) {
      var xk = (x0 * valueRight + x1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, xk, y1);
      partition(k, j, valueRight, xk, y0, x1, y1);
    } else {
      var yk = (y0 * valueRight + y1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, x1, yk);
      partition(k, j, valueRight, x0, yk, x1, y1);
    }
  }
};

var sliceDice = function(parent, x0, y0, x1, y1) {
  (parent.depth & 1 ? treemapSlice : treemapDice)(parent, x0, y0, x1, y1);
};

var resquarify = ((function custom(ratio) {

  function resquarify(parent, x0, y0, x1, y1) {
    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
      var rows,
          row,
          nodes,
          i,
          j = -1,
          n,
          m = rows.length,
          value = parent.value;

      while (++j < m) {
        row = rows[j], nodes = row.children;
        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
        if (row.dice) treemapDice(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
        else treemapSlice(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
        value -= row.value;
      }
    } else {
      parent._squarify = rows = squarifyRatio(ratio, parent, x0, y0, x1, y1);
      rows.ratio = ratio;
    }
  }

  resquarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return resquarify;
}))(phi);

var area$1 = function(polygon) {
  var i = -1,
      n = polygon.length,
      a,
      b = polygon[n - 1],
      area = 0;

  while (++i < n) {
    a = b;
    b = polygon[i];
    area += a[1] * b[0] - a[0] * b[1];
  }

  return area / 2;
};

var centroid$1 = function(polygon) {
  var i = -1,
      n = polygon.length,
      x = 0,
      y = 0,
      a,
      b = polygon[n - 1],
      c,
      k = 0;

  while (++i < n) {
    a = b;
    b = polygon[i];
    k += c = a[0] * b[1] - b[0] * a[1];
    x += (a[0] + b[0]) * c;
    y += (a[1] + b[1]) * c;
  }

  return k *= 3, [x / k, y / k];
};

// Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
// the 3D cross product in a quadrant I Cartesian coordinate system (+x is
// right, +y is up). Returns a positive value if ABC is counter-clockwise,
// negative if clockwise, and zero if the points are collinear.
var cross$1 = function(a, b, c) {
  return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
};

function lexicographicOrder(a, b) {
  return a[0] - b[0] || a[1] - b[1];
}

// Computes the upper convex hull per the monotone chain algorithm.
// Assumes points.length >= 3, is sorted by x, unique in y.
// Returns an array of indices into points in left-to-right order.
function computeUpperHullIndexes(points) {
  var n = points.length,
      indexes = [0, 1],
      size = 2;

  for (var i = 2; i < n; ++i) {
    while (size > 1 && cross$1(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0) --size;
    indexes[size++] = i;
  }

  return indexes.slice(0, size); // remove popped points
}

var hull = function(points) {
  if ((n = points.length) < 3) return null;

  var i,
      n,
      sortedPoints = new Array(n),
      flippedPoints = new Array(n);

  for (i = 0; i < n; ++i) sortedPoints[i] = [+points[i][0], +points[i][1], i];
  sortedPoints.sort(lexicographicOrder);
  for (i = 0; i < n; ++i) flippedPoints[i] = [sortedPoints[i][0], -sortedPoints[i][1]];

  var upperIndexes = computeUpperHullIndexes(sortedPoints),
      lowerIndexes = computeUpperHullIndexes(flippedPoints);

  // Construct the hull polygon, removing possible duplicate endpoints.
  var skipLeft = lowerIndexes[0] === upperIndexes[0],
      skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1],
      hull = [];

  // Add upper hull in right-to-l order.
  // Then add lower hull in left-to-right order.
  for (i = upperIndexes.length - 1; i >= 0; --i) hull.push(points[sortedPoints[upperIndexes[i]][2]]);
  for (i = +skipLeft; i < lowerIndexes.length - skipRight; ++i) hull.push(points[sortedPoints[lowerIndexes[i]][2]]);

  return hull;
};

var contains$1 = function(polygon, point) {
  var n = polygon.length,
      p = polygon[n - 1],
      x = point[0], y = point[1],
      x0 = p[0], y0 = p[1],
      x1, y1,
      inside = false;

  for (var i = 0; i < n; ++i) {
    p = polygon[i], x1 = p[0], y1 = p[1];
    if (((y1 > y) !== (y0 > y)) && (x < (x0 - x1) * (y - y1) / (y0 - y1) + x1)) inside = !inside;
    x0 = x1, y0 = y1;
  }

  return inside;
};

var length$2 = function(polygon) {
  var i = -1,
      n = polygon.length,
      b = polygon[n - 1],
      xa,
      ya,
      xb = b[0],
      yb = b[1],
      perimeter = 0;

  while (++i < n) {
    xa = xb;
    ya = yb;
    b = polygon[i];
    xb = b[0];
    yb = b[1];
    xa -= xb;
    ya -= yb;
    perimeter += Math.sqrt(xa * xa + ya * ya);
  }

  return perimeter;
};

var slice$3 = [].slice;

var noabort = {};

function Queue(size) {
  this._size = size;
  this._call =
  this._error = null;
  this._tasks = [];
  this._data = [];
  this._waiting =
  this._active =
  this._ended =
  this._start = 0; // inside a synchronous task callback?
}

Queue.prototype = queue.prototype = {
  constructor: Queue,
  defer: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("defer after await");
    if (this._error != null) return this;
    var t = slice$3.call(arguments, 1);
    t.push(callback);
    ++this._waiting, this._tasks.push(t);
    poke$1(this);
    return this;
  },
  abort: function() {
    if (this._error == null) abort(this, new Error("abort"));
    return this;
  },
  await: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("multiple await");
    this._call = function(error, results) { callback.apply(null, [error].concat(results)); };
    maybeNotify(this);
    return this;
  },
  awaitAll: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("multiple await");
    this._call = callback;
    maybeNotify(this);
    return this;
  }
};

function poke$1(q) {
  if (!q._start) {
    try { start$1(q); } // let the current task complete
    catch (e) {
      if (q._tasks[q._ended + q._active - 1]) abort(q, e); // task errored synchronously
      else if (!q._data) throw e; // await callback errored synchronously
    }
  }
}

function start$1(q) {
  while (q._start = q._waiting && q._active < q._size) {
    var i = q._ended + q._active,
        t = q._tasks[i],
        j = t.length - 1,
        c = t[j];
    t[j] = end(q, i);
    --q._waiting, ++q._active;
    t = c.apply(null, t);
    if (!q._tasks[i]) continue; // task finished synchronously
    q._tasks[i] = t || noabort;
  }
}

function end(q, i) {
  return function(e, r) {
    if (!q._tasks[i]) return; // ignore multiple callbacks
    --q._active, ++q._ended;
    q._tasks[i] = null;
    if (q._error != null) return; // ignore secondary errors
    if (e != null) {
      abort(q, e);
    } else {
      q._data[i] = r;
      if (q._waiting) poke$1(q);
      else maybeNotify(q);
    }
  };
}

function abort(q, e) {
  var i = q._tasks.length, t;
  q._error = e; // ignore active callbacks
  q._data = undefined; // allow gc
  q._waiting = NaN; // prevent starting

  while (--i >= 0) {
    if (t = q._tasks[i]) {
      q._tasks[i] = null;
      if (t.abort) {
        try { t.abort(); }
        catch (e) { /* ignore */ }
      }
    }
  }

  q._active = NaN; // allow notification
  maybeNotify(q);
}

function maybeNotify(q) {
  if (!q._active && q._call) {
    var d = q._data;
    q._data = undefined; // allow gc
    q._call(q._error, d);
  }
}

function queue(concurrency) {
  if (concurrency == null) concurrency = Infinity;
  else if (!((concurrency = +concurrency) >= 1)) throw new Error("invalid concurrency");
  return new Queue(concurrency);
}

var defaultSource$1 = function() {
  return Math.random();
};

var uniform = ((function sourceRandomUniform(source) {
  function randomUniform(min, max) {
    min = min == null ? 0 : +min;
    max = max == null ? 1 : +max;
    if (arguments.length === 1) max = min, min = 0;
    else max -= min;
    return function() {
      return source() * max + min;
    };
  }

  randomUniform.source = sourceRandomUniform;

  return randomUniform;
}))(defaultSource$1);

var normal = ((function sourceRandomNormal(source) {
  function randomNormal(mu, sigma) {
    var x, r;
    mu = mu == null ? 0 : +mu;
    sigma = sigma == null ? 1 : +sigma;
    return function() {
      var y;

      // If available, use the second previously-generated uniform random.
      if (x != null) y = x, x = null;

      // Otherwise, generate a new x and y.
      else do {
        x = source() * 2 - 1;
        y = source() * 2 - 1;
        r = x * x + y * y;
      } while (!r || r > 1);

      return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
    };
  }

  randomNormal.source = sourceRandomNormal;

  return randomNormal;
}))(defaultSource$1);

var logNormal = ((function sourceRandomLogNormal(source) {
  function randomLogNormal() {
    var randomNormal = normal.source(source).apply(this, arguments);
    return function() {
      return Math.exp(randomNormal());
    };
  }

  randomLogNormal.source = sourceRandomLogNormal;

  return randomLogNormal;
}))(defaultSource$1);

var irwinHall = ((function sourceRandomIrwinHall(source) {
  function randomIrwinHall(n) {
    return function() {
      for (var sum = 0, i = 0; i < n; ++i) sum += source();
      return sum;
    };
  }

  randomIrwinHall.source = sourceRandomIrwinHall;

  return randomIrwinHall;
}))(defaultSource$1);

var bates = ((function sourceRandomBates(source) {
  function randomBates(n) {
    var randomIrwinHall = irwinHall.source(source)(n);
    return function() {
      return randomIrwinHall() / n;
    };
  }

  randomBates.source = sourceRandomBates;

  return randomBates;
}))(defaultSource$1);

var exponential$1 = ((function sourceRandomExponential(source) {
  function randomExponential(lambda) {
    return function() {
      return -Math.log(1 - source()) / lambda;
    };
  }

  randomExponential.source = sourceRandomExponential;

  return randomExponential;
}))(defaultSource$1);

var request = function(url, callback) {
  var request,
      event = dispatch("beforesend", "progress", "load", "error"),
      mimeType,
      headers = map$1(),
      xhr = new XMLHttpRequest,
      user = null,
      password = null,
      response,
      responseType,
      timeout = 0;

  // If IE does not support CORS, use XDomainRequest.
  if (typeof XDomainRequest !== "undefined"
      && !("withCredentials" in xhr)
      && /^(http(s)?:)?\/\//.test(url)) xhr = new XDomainRequest;

  "onload" in xhr
      ? xhr.onload = xhr.onerror = xhr.ontimeout = respond
      : xhr.onreadystatechange = function(o) { xhr.readyState > 3 && respond(o); };

  function respond(o) {
    var status = xhr.status, result;
    if (!status && hasResponse(xhr)
        || status >= 200 && status < 300
        || status === 304) {
      if (response) {
        try {
          result = response.call(request, xhr);
        } catch (e) {
          event.call("error", request, e);
          return;
        }
      } else {
        result = xhr;
      }
      event.call("load", request, result);
    } else {
      event.call("error", request, o);
    }
  }

  xhr.onprogress = function(e) {
    event.call("progress", request, e);
  };

  request = {
    header: function(name, value) {
      name = (name + "").toLowerCase();
      if (arguments.length < 2) return headers.get(name);
      if (value == null) headers.remove(name);
      else headers.set(name, value + "");
      return request;
    },

    // If mimeType is non-null and no Accept header is set, a default is used.
    mimeType: function(value) {
      if (!arguments.length) return mimeType;
      mimeType = value == null ? null : value + "";
      return request;
    },

    // Specifies what type the response value should take;
    // for instance, arraybuffer, blob, document, or text.
    responseType: function(value) {
      if (!arguments.length) return responseType;
      responseType = value;
      return request;
    },

    timeout: function(value) {
      if (!arguments.length) return timeout;
      timeout = +value;
      return request;
    },

    user: function(value) {
      return arguments.length < 1 ? user : (user = value == null ? null : value + "", request);
    },

    password: function(value) {
      return arguments.length < 1 ? password : (password = value == null ? null : value + "", request);
    },

    // Specify how to convert the response content to a specific type;
    // changes the callback value on "load" events.
    response: function(value) {
      response = value;
      return request;
    },

    // Alias for send("GET", …).
    get: function(data, callback) {
      return request.send("GET", data, callback);
    },

    // Alias for send("POST", …).
    post: function(data, callback) {
      return request.send("POST", data, callback);
    },

    // If callback is non-null, it will be used for error and load events.
    send: function(method, data, callback) {
      xhr.open(method, url, true, user, password);
      if (mimeType != null && !headers.has("accept")) headers.set("accept", mimeType + ",*/*");
      if (xhr.setRequestHeader) headers.each(function(value, name) { xhr.setRequestHeader(name, value); });
      if (mimeType != null && xhr.overrideMimeType) xhr.overrideMimeType(mimeType);
      if (responseType != null) xhr.responseType = responseType;
      if (timeout > 0) xhr.timeout = timeout;
      if (callback == null && typeof data === "function") callback = data, data = null;
      if (callback != null && callback.length === 1) callback = fixCallback(callback);
      if (callback != null) request.on("error", callback).on("load", function(xhr) { callback(null, xhr); });
      event.call("beforesend", request, xhr);
      xhr.send(data == null ? null : data);
      return request;
    },

    abort: function() {
      xhr.abort();
      return request;
    },

    on: function() {
      var value = event.on.apply(event, arguments);
      return value === event ? request : value;
    }
  };

  if (callback != null) {
    if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
    return request.get(callback);
  }

  return request;
};

function fixCallback(callback) {
  return function(error, xhr) {
    callback(error == null ? xhr : null);
  };
}

function hasResponse(xhr) {
  var type = xhr.responseType;
  return type && type !== "text"
      ? xhr.response // null on error
      : xhr.responseText; // "" on error
}

var type$1 = function(defaultMimeType, response) {
  return function(url, callback) {
    var r = request(url).mimeType(defaultMimeType).response(response);
    if (callback != null) {
      if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
      return r.get(callback);
    }
    return r;
  };
};

var html = type$1("text/html", function(xhr) {
  return document.createRange().createContextualFragment(xhr.responseText);
});

var json = type$1("application/json", function(xhr) {
  return JSON.parse(xhr.responseText);
});

var text = type$1("text/plain", function(xhr) {
  return xhr.responseText;
});

var xml = type$1("application/xml", function(xhr) {
  var xml = xhr.responseXML;
  if (!xml) throw new Error("parse error");
  return xml;
});

var dsv$1 = function(defaultMimeType, parse) {
  return function(url, row, callback) {
    if (arguments.length < 3) callback = row, row = null;
    var r = request(url).mimeType(defaultMimeType);
    r.row = function(_) { return arguments.length ? r.response(responseOf(parse, row = _)) : row; };
    r.row(row);
    return callback ? r.get(callback) : r;
  };
};

function responseOf(parse, row) {
  return function(request$$1) {
    return parse(request$$1.responseText, row);
  };
}

var csv$1 = dsv$1("text/csv", csvParse);

var tsv$1 = dsv$1("text/tab-separated-values", tsvParse);

var array$2 = Array.prototype;

var map$3 = array$2.map;
var slice$4 = array$2.slice;

var implicit = {name: "implicit"};

function ordinal(range) {
  var index = map$1(),
      domain = [],
      unknown = implicit;

  range = range == null ? [] : slice$4.call(range);

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = map$1();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = slice$4.call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return scale;
}

function band() {
  var scale = ordinal().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range$$1 = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range$$1[1] < range$$1[0],
        start = range$$1[reverse - 0],
        stop = range$$1[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = sequence(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range$$1 = [+_[0], +_[1]], rescale()) : range$$1.slice();
  };

  scale.rangeRound = function(_) {
    return range$$1 = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band()
        .domain(domain())
        .range(range$$1)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return rescale();
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point$1() {
  return pointish(band().paddingInner(1));
}

var constant$9 = function(x) {
  return function() {
    return x;
  };
};

var number$1 = function(x) {
  return +x;
};

var unit = [0, 1];

function deinterpolateLinear(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : constant$9(b);
}

function deinterpolateClamp(deinterpolate) {
  return function(a, b) {
    var d = deinterpolate(a = +a, b = +b);
    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
  };
}

function reinterpolateClamp(reinterpolate) {
  return function(a, b) {
    var r = reinterpolate(a = +a, b = +b);
    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
  };
}

function bimap(domain, range$$1, deinterpolate, reinterpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range$$1[0], r1 = range$$1[1];
  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range$$1, deinterpolate, reinterpolate) {
  var j = Math.min(domain.length, range$$1.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range$$1 = range$$1.slice().reverse();
  }

  while (++i < j) {
    d[i] = deinterpolate(domain[i], domain[i + 1]);
    r[i] = reinterpolate(range$$1[i], range$$1[i + 1]);
  }

  return function(x) {
    var i = bisectRight(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp());
}

// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
function continuous(deinterpolate, reinterpolate) {
  var domain = unit,
      range$$1 = unit,
      interpolate$$1 = interpolateValue,
      clamp = false,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range$$1.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return (output || (output = piecewise(domain, range$$1, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate$$1)))(+x);
  }

  scale.invert = function(y) {
    return (input || (input = piecewise(range$$1, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = map$3.call(_, number$1), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range$$1 = slice$4.call(_), rescale()) : range$$1.slice();
  };

  scale.rangeRound = function(_) {
    return range$$1 = slice$4.call(_), interpolate$$1 = interpolateRound, rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, rescale()) : clamp;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate$$1 = _, rescale()) : interpolate$$1;
  };

  return rescale();
}

var tickFormat = function(domain, count, specifier) {
  var start = domain[0],
      stop = domain[domain.length - 1],
      step = tickStep(start, stop, count == null ? 10 : count),
      precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
      return exports.formatPrefix(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return exports.format(specifier);
};

function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    return tickFormat(domain(), count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = tickIncrement(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = tickIncrement(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = tickIncrement(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear$2() {
  var scale = continuous(deinterpolateLinear, reinterpolate);

  scale.copy = function() {
    return copy(scale, linear$2());
  };

  return linearish(scale);
}

function identity$6() {
  var domain = [0, 1];

  function scale(x) {
    return +x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = map$3.call(_, number$1), scale) : domain.slice();
  };

  scale.copy = function() {
    return identity$6().domain(domain);
  };

  return linearish(scale);
}

var nice = function(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
};

function deinterpolate(a, b) {
  return (b = Math.log(b / a))
      ? function(x) { return Math.log(x / a) / b; }
      : constant$9(b);
}

function reinterpolate$1(a, b) {
  return a < 0
      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function log$1() {
  var scale = continuous(deinterpolate, reinterpolate$1).domain([1, 10]),
      domain = scale.domain,
      base = 10,
      logs = logp(10),
      pows = powp(10);

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = ticks(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = exports.format(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(nice(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  scale.copy = function() {
    return copy(scale, log$1().base(base));
  };

  return scale;
}

function raise$1(x, exponent) {
  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}

function pow$1() {
  var exponent = 1,
      scale = continuous(deinterpolate, reinterpolate),
      domain = scale.domain;

  function deinterpolate(a, b) {
    return (b = raise$1(b, exponent) - (a = raise$1(a, exponent)))
        ? function(x) { return (raise$1(x, exponent) - a) / b; }
        : constant$9(b);
  }

  function reinterpolate(a, b) {
    b = raise$1(b, exponent) - (a = raise$1(a, exponent));
    return function(t) { return raise$1(a + b * t, 1 / exponent); };
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
  };

  scale.copy = function() {
    return copy(scale, pow$1().exponent(exponent));
  };

  return linearish(scale);
}

function sqrt$1() {
  return pow$1().exponent(0.5);
}

function quantile$$1() {
  var domain = [],
      range$$1 = [],
      thresholds = [];

  function rescale() {
    var i = 0, n = Math.max(1, range$$1.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = threshold(domain, i / n);
    return scale;
  }

  function scale(x) {
    if (!isNaN(x = +x)) return range$$1[bisectRight(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range$$1.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(ascending);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range$$1 = slice$4.call(_), rescale()) : range$$1.slice();
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile$$1()
        .domain(domain)
        .range(range$$1);
  };

  return scale;
}

function quantize$1() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range$$1 = [0, 1];

  function scale(x) {
    if (x <= x) return range$$1[bisectRight(domain, x, 0, n)];
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range$$1 = slice$4.call(_)).length - 1, rescale()) : range$$1.slice();
  };

  scale.invertExtent = function(y) {
    var i = range$$1.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return quantize$1()
        .domain([x0, x1])
        .range(range$$1);
  };

  return linearish(scale);
}

function threshold$1() {
  var domain = [0.5],
      range$$1 = [0, 1],
      n = 1;

  function scale(x) {
    if (x <= x) return range$$1[bisectRight(domain, x, 0, n)];
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = slice$4.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range$$1 = slice$4.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : range$$1.slice();
  };

  scale.invertExtent = function(y) {
    var i = range$$1.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return threshold$1()
        .domain(domain)
        .range(range$$1);
  };

  return scale;
}

var t0$1 = new Date;
var t1$1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = new Date(+date)), date;
  }

  interval.floor = interval;

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [];
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(new Date(+start)); while (offseti(start, step), floori(start), start < stop)
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) while (--step >= 0) while (offseti(date, 1), !test(date)) {} // eslint-disable-line no-empty
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0$1.setTime(+start), t1$1.setTime(+end);
      floori(t0$1), floori(t1$1);
      return Math.floor(count(t0$1, t1$1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}

var millisecond = newInterval(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return newInterval(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

var milliseconds = millisecond.range;

var durationSecond$1 = 1e3;
var durationMinute$1 = 6e4;
var durationHour$1 = 36e5;
var durationDay$1 = 864e5;
var durationWeek$1 = 6048e5;

var second = newInterval(function(date) {
  date.setTime(Math.floor(date / durationSecond$1) * durationSecond$1);
}, function(date, step) {
  date.setTime(+date + step * durationSecond$1);
}, function(start, end) {
  return (end - start) / durationSecond$1;
}, function(date) {
  return date.getUTCSeconds();
});

var seconds = second.range;

var minute = newInterval(function(date) {
  date.setTime(Math.floor(date / durationMinute$1) * durationMinute$1);
}, function(date, step) {
  date.setTime(+date + step * durationMinute$1);
}, function(start, end) {
  return (end - start) / durationMinute$1;
}, function(date) {
  return date.getMinutes();
});

var minutes = minute.range;

var hour = newInterval(function(date) {
  var offset = date.getTimezoneOffset() * durationMinute$1 % durationHour$1;
  if (offset < 0) offset += durationHour$1;
  date.setTime(Math.floor((+date - offset) / durationHour$1) * durationHour$1 + offset);
}, function(date, step) {
  date.setTime(+date + step * durationHour$1);
}, function(start, end) {
  return (end - start) / durationHour$1;
}, function(date) {
  return date.getHours();
});

var hours = hour.range;

var day = newInterval(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute$1) / durationDay$1;
}, function(date) {
  return date.getDate() - 1;
});

var days = day.range;

function weekday(i) {
  return newInterval(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute$1) / durationWeek$1;
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;

var month = newInterval(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

var months = month.range;

var year = newInterval(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

var years = year.range;

var utcMinute = newInterval(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * durationMinute$1);
}, function(start, end) {
  return (end - start) / durationMinute$1;
}, function(date) {
  return date.getUTCMinutes();
});

var utcMinutes = utcMinute.range;

var utcHour = newInterval(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * durationHour$1);
}, function(start, end) {
  return (end - start) / durationHour$1;
}, function(date) {
  return date.getUTCHours();
});

var utcHours = utcHour.range;

var utcDay = newInterval(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / durationDay$1;
}, function(date) {
  return date.getUTCDate() - 1;
});

var utcDays = utcDay.range;

function utcWeekday(i) {
  return newInterval(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / durationWeek$1;
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;

var utcMonth = newInterval(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

var utcMonths = utcMonth.range;

var utcYear = newInterval(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

var utcYears = utcYear.range;

function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newYear(y) {
  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale$1(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "S": formatSeconds,
    "U": formatWeekNumberSunday,
    "w": formatWeekdayNumber,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "S": formatUTCSeconds,
    "U": formatUTCWeekNumberSunday,
    "w": formatUTCWeekdayNumber,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "S": parseSeconds,
    "U": parseWeekNumberSunday,
    "w": parseWeekdayNumber,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, newDate) {
    return function(string) {
      var d = newYear(1900),
          i = parseSpecifier(d, specifier, string += "", 0);
      if (i != string.length) return null;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "W" in d ? 1 : 0;
        var day$$1 = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day$$1 + 5) % 7 : d.w + d.U * 7 - (day$$1 + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return newDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", localDate);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier, utcDate);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"};
var numberRe = /^\s*\d+/;
var percentRe = /^%/;
var requoteRe = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + day.count(year(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekNumberSunday(d, p) {
  return pad(sunday.count(year(d), d), p, 2);
}

function formatWeekdayNumber(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(monday.count(year(d), d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + utcDay.count(utcYear(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(utcSunday.count(utcYear(d), d), p, 2);
}

function formatUTCWeekdayNumber(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(utcMonday.count(utcYear(d), d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

var locale$2;





defaultLocale$1({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale$1(definition) {
  locale$2 = formatLocale$1(definition);
  exports.timeFormat = locale$2.format;
  exports.timeParse = locale$2.parse;
  exports.utcFormat = locale$2.utcFormat;
  exports.utcParse = locale$2.utcParse;
  return locale$2;
}

var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString
    ? formatIsoNative
    : exports.utcFormat(isoSpecifier);

function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z")
    ? parseIsoNative
    : exports.utcParse(isoSpecifier);

var durationSecond = 1000;
var durationMinute = durationSecond * 60;
var durationHour = durationMinute * 60;
var durationDay = durationHour * 24;
var durationWeek = durationDay * 7;
var durationMonth = durationDay * 30;
var durationYear = durationDay * 365;

function date$1(t) {
  return new Date(t);
}

function number$2(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year$$1, month$$1, week, day$$1, hour$$1, minute$$1, second$$1, millisecond$$1, format) {
  var scale = continuous(deinterpolateLinear, reinterpolate),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second$$1,  1,      durationSecond],
    [second$$1,  5,  5 * durationSecond],
    [second$$1, 15, 15 * durationSecond],
    [second$$1, 30, 30 * durationSecond],
    [minute$$1,  1,      durationMinute],
    [minute$$1,  5,  5 * durationMinute],
    [minute$$1, 15, 15 * durationMinute],
    [minute$$1, 30, 30 * durationMinute],
    [  hour$$1,  1,      durationHour  ],
    [  hour$$1,  3,  3 * durationHour  ],
    [  hour$$1,  6,  6 * durationHour  ],
    [  hour$$1, 12, 12 * durationHour  ],
    [   day$$1,  1,      durationDay   ],
    [   day$$1,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month$$1,  1,      durationMonth ],
    [ month$$1,  3,  3 * durationMonth ],
    [  year$$1,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second$$1(date) < date ? formatMillisecond
        : minute$$1(date) < date ? formatSecond
        : hour$$1(date) < date ? formatMinute
        : day$$1(date) < date ? formatHour
        : month$$1(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year$$1(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = bisector(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = tickStep(start / durationYear, stop / durationYear, interval);
        interval = year$$1;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = tickStep(start, stop, interval);
        interval = millisecond$$1;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(map$3.call(_, number$2)) : domain().map(date$1);
  };

  scale.ticks = function(interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
        ? domain(nice(d, interval))
        : scale;
  };

  scale.copy = function() {
    return copy(scale, calendar(year$$1, month$$1, week, day$$1, hour$$1, minute$$1, second$$1, millisecond$$1, format));
  };

  return scale;
}

var time = function() {
  return calendar(year, month, sunday, day, hour, minute, second, millisecond, exports.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
};

var utcTime = function() {
  return calendar(utcYear, utcMonth, utcSunday, utcDay, utcHour, utcMinute, second, millisecond, exports.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
};

var colors = function(s) {
  return s.match(/.{6}/g).map(function(x) {
    return "#" + x;
  });
};

var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

var category20b = colors("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");

var category20c = colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");

var category20 = colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");

var cubehelix$3 = cubehelixLong(cubehelix(300, 0.5, 0.0), cubehelix(-240, 0.5, 1.0));

var warm = cubehelixLong(cubehelix(-100, 0.75, 0.35), cubehelix(80, 1.50, 0.8));

var cool = cubehelixLong(cubehelix(260, 0.75, 0.35), cubehelix(80, 1.50, 0.8));

var rainbow = cubehelix();

var rainbow$1 = function(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  rainbow.h = 360 * t - 100;
  rainbow.s = 1.5 - 1.5 * ts;
  rainbow.l = 0.8 - 0.9 * ts;
  return rainbow + "";
};

function ramp(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));

var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

function sequential(interpolator) {
  var x0 = 0,
      x1 = 1,
      clamp = false;

  function scale(x) {
    var t = (x - x0) / (x1 - x0);
    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
  };

  return linearish(scale);
}

var constant$10 = function(x) {
  return function constant() {
    return x;
  };
};

var abs$1 = Math.abs;
var atan2$1 = Math.atan2;
var cos$2 = Math.cos;
var max$2 = Math.max;
var min$1 = Math.min;
var sin$2 = Math.sin;
var sqrt$2 = Math.sqrt;

var epsilon$3 = 1e-12;
var pi$4 = Math.PI;
var halfPi$3 = pi$4 / 2;
var tau$4 = 2 * pi$4;

function acos$1(x) {
  return x > 1 ? 0 : x < -1 ? pi$4 : Math.acos(x);
}

function asin$1(x) {
  return x >= 1 ? halfPi$3 : x <= -1 ? -halfPi$3 : Math.asin(x);
}

function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / sqrt$2(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * sqrt$2(max$2(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

var arc = function() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = constant$10(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - halfPi$3,
        a1 = endAngle.apply(this, arguments) - halfPi$3,
        da = abs$1(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = path();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > epsilon$3)) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > tau$4 - epsilon$3) {
      context.moveTo(r1 * cos$2(a0), r1 * sin$2(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > epsilon$3) {
        context.moveTo(r0 * cos$2(a1), r0 * sin$2(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > epsilon$3) && (padRadius ? +padRadius.apply(this, arguments) : sqrt$2(r0 * r0 + r1 * r1)),
          rc = min$1(abs$1(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > epsilon$3) {
        var p0 = asin$1(rp / r0 * sin$2(ap)),
            p1 = asin$1(rp / r1 * sin$2(ap));
        if ((da0 -= p0 * 2) > epsilon$3) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > epsilon$3) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * cos$2(a01),
          y01 = r1 * sin$2(a01),
          x10 = r0 * cos$2(a10),
          y10 = r0 * sin$2(a10);

      // Apply rounded corners?
      if (rc > epsilon$3) {
        var x11 = r1 * cos$2(a11),
            y11 = r1 * sin$2(a11),
            x00 = r0 * cos$2(a00),
            y00 = r0 * sin$2(a00);

        // Restrict the corner radius according to the sector angle.
        if (da < pi$4) {
          var oc = da0 > epsilon$3 ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
              ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / sin$2(acos$1((ax * bx + ay * by) / (sqrt$2(ax * ax + ay * ay) * sqrt$2(bx * bx + by * by))) / 2),
              lc = sqrt$2(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = min$1(rc, (r0 - lc) / (kc - 1));
          rc1 = min$1(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > epsilon$3)) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > epsilon$3) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2$1(t0.y01, t0.x01), atan2$1(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, atan2$1(t0.y01, t0.x01), atan2$1(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, atan2$1(t0.cy + t0.y11, t0.cx + t0.x11), atan2$1(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, atan2$1(t1.y11, t1.x11), atan2$1(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > epsilon$3) || !(da0 > epsilon$3)) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > epsilon$3) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2$1(t0.y01, t0.x01), atan2$1(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, atan2$1(t0.y01, t0.x01), atan2$1(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, atan2$1(t0.cy + t0.y11, t0.cx + t0.x11), atan2$1(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, atan2$1(t1.y11, t1.x11), atan2$1(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi$4 / 2;
    return [cos$2(a) * r, sin$2(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant$10(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant$10(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant$10(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant$10(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$10(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$10(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$10(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
};

function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

var curveLinear = function(context) {
  return new Linear(context);
};

function x$3(p) {
  return p[0];
}

function y$3(p) {
  return p[1];
}

var line = function() {
  var x$$1 = x$3,
      y$$1 = y$3,
      defined = constant$10(true),
      context = null,
      curve = curveLinear,
      output = null;

  function line(data) {
    var i,
        n = data.length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = path());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x$$1(d, i, data), +y$$1(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant$10(+_), line) : x$$1;
  };

  line.y = function(_) {
    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant$10(+_), line) : y$$1;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$10(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
};

var area$2 = function() {
  var x0 = x$3,
      x1 = null,
      y0 = constant$10(0),
      y1 = y$3,
      defined = constant$10(true),
      context = null,
      curve = curveLinear,
      output = null;

  function area(data) {
    var i,
        j,
        k,
        n = data.length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = path());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return line().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$10(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$10(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant$10(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$10(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$10(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant$10(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$10(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
};

var descending$1 = function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
};

var identity$7 = function(d) {
  return d;
};

var pie = function() {
  var value = identity$7,
      sortValues = descending$1,
      sort = null,
      startAngle = constant$10(0),
      endAngle = constant$10(tau$4),
      padAngle = constant$10(0);

  function pie(data) {
    var i,
        n = data.length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(tau$4, Math.max(-tau$4, endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant$10(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$10(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$10(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$10(+_), pie) : padAngle;
  };

  return pie;
};

var curveRadialLinear = curveRadial(curveLinear);

function Radial(curve) {
  this._curve = curve;
}

Radial.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a, r) {
    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
  }
};

function curveRadial(curve) {

  function radial(context) {
    return new Radial(curve(context));
  }

  radial._curve = curve;

  return radial;
}

function radialLine(l) {
  var c = l.curve;

  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;

  l.curve = function(_) {
    return arguments.length ? c(curveRadial(_)) : c()._curve;
  };

  return l;
}

var radialLine$1 = function() {
  return radialLine(line().curve(curveRadialLinear));
};

var radialArea = function() {
  var a = area$2().curve(curveRadialLinear),
      c = a.curve,
      x0 = a.lineX0,
      x1 = a.lineX1,
      y0 = a.lineY0,
      y1 = a.lineY1;

  a.angle = a.x, delete a.x;
  a.startAngle = a.x0, delete a.x0;
  a.endAngle = a.x1, delete a.x1;
  a.radius = a.y, delete a.y;
  a.innerRadius = a.y0, delete a.y0;
  a.outerRadius = a.y1, delete a.y1;
  a.lineStartAngle = function() { return radialLine(x0()); }, delete a.lineX0;
  a.lineEndAngle = function() { return radialLine(x1()); }, delete a.lineX1;
  a.lineInnerRadius = function() { return radialLine(y0()); }, delete a.lineY0;
  a.lineOuterRadius = function() { return radialLine(y1()); }, delete a.lineY1;

  a.curve = function(_) {
    return arguments.length ? c(curveRadial(_)) : c()._curve;
  };

  return a;
};

var slice$5 = Array.prototype.slice;

var radialPoint = function(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
};

function linkSource(d) {
  return d.source;
}

function linkTarget(d) {
  return d.target;
}

function link$2(curve) {
  var source = linkSource,
      target = linkTarget,
      x$$1 = x$3,
      y$$1 = y$3,
      context = null;

  function link() {
    var buffer, argv = slice$5.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
    if (!context) context = buffer = path();
    curve(context, +x$$1.apply(this, (argv[0] = s, argv)), +y$$1.apply(this, argv), +x$$1.apply(this, (argv[0] = t, argv)), +y$$1.apply(this, argv));
    if (buffer) return context = null, buffer + "" || null;
  }

  link.source = function(_) {
    return arguments.length ? (source = _, link) : source;
  };

  link.target = function(_) {
    return arguments.length ? (target = _, link) : target;
  };

  link.x = function(_) {
    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant$10(+_), link) : x$$1;
  };

  link.y = function(_) {
    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant$10(+_), link) : y$$1;
  };

  link.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), link) : context;
  };

  return link;
}

function curveHorizontal(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}

function curveVertical(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}

function curveRadial$1(context, x0, y0, x1, y1) {
  var p0 = radialPoint(x0, y0),
      p1 = radialPoint(x0, y0 = (y0 + y1) / 2),
      p2 = radialPoint(x1, y0),
      p3 = radialPoint(x1, y1);
  context.moveTo(p0[0], p0[1]);
  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}

function linkHorizontal() {
  return link$2(curveHorizontal);
}

function linkVertical() {
  return link$2(curveVertical);
}

function linkRadial() {
  var l = link$2(curveRadial$1);
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  return l;
}

var circle$2 = {
  draw: function(context, size) {
    var r = Math.sqrt(size / pi$4);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, tau$4);
  }
};

var cross$2 = {
  draw: function(context, size) {
    var r = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
};

var tan30 = Math.sqrt(1 / 3);
var tan30_2 = tan30 * 2;

var diamond = {
  draw: function(context, size) {
    var y = Math.sqrt(size / tan30_2),
        x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
};

var ka = 0.89081309152928522810;
var kr = Math.sin(pi$4 / 10) / Math.sin(7 * pi$4 / 10);
var kx = Math.sin(tau$4 / 10) * kr;
var ky = -Math.cos(tau$4 / 10) * kr;

var star = {
  draw: function(context, size) {
    var r = Math.sqrt(size * ka),
        x = kx * r,
        y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (var i = 1; i < 5; ++i) {
      var a = tau$4 * i / 5,
          c = Math.cos(a),
          s = Math.sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  }
};

var square = {
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
};

var sqrt3 = Math.sqrt(3);

var triangle = {
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
};

var c = -0.5;
var s = Math.sqrt(3) / 2;
var k = 1 / Math.sqrt(12);
var a = (k / 2 + 1) * 3;

var wye = {
  draw: function(context, size) {
    var r = Math.sqrt(size / a),
        x0 = r / 2,
        y0 = r * k,
        x1 = x0,
        y1 = r * k + r,
        x2 = -x1,
        y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
    context.closePath();
  }
};

var symbols = [
  circle$2,
  cross$2,
  diamond,
  square,
  star,
  triangle,
  wye
];

var symbol = function() {
  var type = constant$10(circle$2),
      size = constant$10(64),
      context = null;

  function symbol() {
    var buffer;
    if (!context) context = buffer = path();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : constant$10(_), symbol) : type;
  };

  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : constant$10(+_), symbol) : size;
  };

  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
};

var noop$2 = function() {};

function point$2(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3: point$2(this, this._x1, this._y1); // proceed
      case 2: this._context.lineTo(this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default: point$2(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

var basis$2 = function(context) {
  return new Basis(context);
};

function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: noop$2,
  areaEnd: noop$2,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
      default: point$2(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

var basisClosed$1 = function(context) {
  return new BasisClosed(context);
};

function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
      case 3: this._point = 4; // proceed
      default: point$2(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

var basisOpen = function(context) {
  return new BasisOpen(context);
};

function Bundle(context, beta) {
  this._basis = new Basis(context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
          y0 = y[0],
          dx = x[j] - x0,
          dy = y[j] - y0,
          i = -1,
          t;

      while (++i <= j) {
        t = i / j;
        this._basis.point(
          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
        );
      }
    }

    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

var bundle = ((function custom(beta) {

  function bundle(context) {
    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
  }

  bundle.beta = function(beta) {
    return custom(+beta);
  };

  return bundle;
}))(0.85);

function point$3(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: point$3(this, this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
      case 2: this._point = 3; // proceed
      default: point$3(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var cardinal = ((function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
}))(0);

function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: noop$2,
  areaEnd: noop$2,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: point$3(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var cardinalClosed = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
}))(0);

function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: point$3(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var cardinalOpen = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
}))(0);

function point$4(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > epsilon$3) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > epsilon$3) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: this.point(this._x2, this._y2); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; // proceed
      default: point$4(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var catmullRom = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
}))(0.5);

function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: noop$2,
  areaEnd: noop$2,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: point$4(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var catmullRomClosed = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
}))(0.5);

function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: point$4(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var catmullRomOpen = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
}))(0.5);

function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: noop$2,
  areaEnd: noop$2,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);
    else this._point = 1, this._context.moveTo(x, y);
  }
};

var linearClosed = function(context) {
  return new LinearClosed(context);
};

function sign$1(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign$1(s0) + sign$1(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point$5(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: point$5(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; point$5(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: point$5(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
};

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}

function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

var natural = function(context) {
  return new Natural(context);
};

function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
};

var step = function(context) {
  return new Step(context, 0.5);
};

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}

var none$1 = function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
};

var none$2 = function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
};

function stackValue(d, key) {
  return d[key];
}

var stack = function() {
  var keys = constant$10([]),
      order = none$2,
      offset = none$1,
      value = stackValue;

  function stack(data) {
    var kz = keys.apply(this, arguments),
        i,
        m = data.length,
        n = kz.length,
        sz = new Array(n),
        oz;

    for (i = 0; i < n; ++i) {
      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
        si[j] = sij = [0, +value(data[j], ki, j, data)];
        sij.data = data[j];
      }
      si.key = ki;
    }

    for (i = 0, oz = order(sz); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : constant$10(slice$5.call(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant$10(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? none$2 : typeof _ === "function" ? _ : constant$10(slice$5.call(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? none$1 : _, stack) : offset;
  };

  return stack;
};

var expand = function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  none$1(series, order);
};

var diverging = function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
    for (yp = yn = 0, i = 0; i < n; ++i) {
      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
        d[0] = yp, d[1] = yp += dy;
      } else if (dy < 0) {
        d[1] = yn, d[0] = yn += dy;
      } else {
        d[0] = yp;
      }
    }
  }
};

var silhouette = function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  none$1(series, order);
};

var wiggle = function(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  none$1(series, order);
};

var ascending$2 = function(series) {
  var sums = series.map(sum$2);
  return none$2(series).sort(function(a, b) { return sums[a] - sums[b]; });
};

function sum$2(series) {
  var s = 0, i = -1, n = series.length, v;
  while (++i < n) if (v = +series[i][1]) s += v;
  return s;
}

var descending$2 = function(series) {
  return ascending$2(series).reverse();
};

var insideOut = function(series) {
  var n = series.length,
      i,
      j,
      sums = series.map(sum$2),
      order = none$2(series).sort(function(a, b) { return sums[b] - sums[a]; }),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
};

var reverse = function(series) {
  return none$2(series).reverse();
};

var constant$11 = function(x) {
  return function() {
    return x;
  };
};

function x$4(d) {
  return d[0];
}

function y$4(d) {
  return d[1];
}

function RedBlackTree() {
  this._ = null; // root node
}

function RedBlackNode(node) {
  node.U = // parent node
  node.C = // color - true for red, false for black
  node.L = // left node
  node.R = // right node
  node.P = // previous node
  node.N = null; // next node
}

RedBlackTree.prototype = {
  constructor: RedBlackTree,

  insert: function(after, node) {
    var parent, grandpa, uncle;

    if (after) {
      node.P = after;
      node.N = after.N;
      if (after.N) after.N.P = node;
      after.N = node;
      if (after.R) {
        after = after.R;
        while (after.L) after = after.L;
        after.L = node;
      } else {
        after.R = node;
      }
      parent = after;
    } else if (this._) {
      after = RedBlackFirst(this._);
      node.P = null;
      node.N = after;
      after.P = after.L = node;
      parent = after;
    } else {
      node.P = node.N = null;
      this._ = node;
      parent = null;
    }
    node.L = node.R = null;
    node.U = parent;
    node.C = true;

    after = node;
    while (parent && parent.C) {
      grandpa = parent.U;
      if (parent === grandpa.L) {
        uncle = grandpa.R;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.R) {
            RedBlackRotateLeft(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateRight(this, grandpa);
        }
      } else {
        uncle = grandpa.L;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.L) {
            RedBlackRotateRight(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateLeft(this, grandpa);
        }
      }
      parent = after.U;
    }
    this._.C = false;
  },

  remove: function(node) {
    if (node.N) node.N.P = node.P;
    if (node.P) node.P.N = node.N;
    node.N = node.P = null;

    var parent = node.U,
        sibling,
        left = node.L,
        right = node.R,
        next,
        red;

    if (!left) next = right;
    else if (!right) next = left;
    else next = RedBlackFirst(right);

    if (parent) {
      if (parent.L === node) parent.L = next;
      else parent.R = next;
    } else {
      this._ = next;
    }

    if (left && right) {
      red = next.C;
      next.C = node.C;
      next.L = left;
      left.U = next;
      if (next !== right) {
        parent = next.U;
        next.U = node.U;
        node = next.R;
        parent.L = node;
        next.R = right;
        right.U = next;
      } else {
        next.U = parent;
        parent = next;
        node = next.R;
      }
    } else {
      red = node.C;
      node = next;
    }

    if (node) node.U = parent;
    if (red) return;
    if (node && node.C) { node.C = false; return; }

    do {
      if (node === this._) break;
      if (node === parent.L) {
        sibling = parent.R;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateLeft(this, parent);
          sibling = parent.R;
        }
        if ((sibling.L && sibling.L.C)
            || (sibling.R && sibling.R.C)) {
          if (!sibling.R || !sibling.R.C) {
            sibling.L.C = false;
            sibling.C = true;
            RedBlackRotateRight(this, sibling);
            sibling = parent.R;
          }
          sibling.C = parent.C;
          parent.C = sibling.R.C = false;
          RedBlackRotateLeft(this, parent);
          node = this._;
          break;
        }
      } else {
        sibling = parent.L;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateRight(this, parent);
          sibling = parent.L;
        }
        if ((sibling.L && sibling.L.C)
          || (sibling.R && sibling.R.C)) {
          if (!sibling.L || !sibling.L.C) {
            sibling.R.C = false;
            sibling.C = true;
            RedBlackRotateLeft(this, sibling);
            sibling = parent.L;
          }
          sibling.C = parent.C;
          parent.C = sibling.L.C = false;
          RedBlackRotateRight(this, parent);
          node = this._;
          break;
        }
      }
      sibling.C = true;
      node = parent;
      parent = parent.U;
    } while (!node.C);

    if (node) node.C = false;
  }
};

function RedBlackRotateLeft(tree, node) {
  var p = node,
      q = node.R,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.R = q.L;
  if (p.R) p.R.U = p;
  q.L = p;
}

function RedBlackRotateRight(tree, node) {
  var p = node,
      q = node.L,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.L = q.R;
  if (p.L) p.L.U = p;
  q.R = p;
}

function RedBlackFirst(node) {
  while (node.L) node = node.L;
  return node;
}

function createEdge(left, right, v0, v1) {
  var edge = [null, null],
      index = edges.push(edge) - 1;
  edge.left = left;
  edge.right = right;
  if (v0) setEdgeEnd(edge, left, right, v0);
  if (v1) setEdgeEnd(edge, right, left, v1);
  cells[left.index].halfedges.push(index);
  cells[right.index].halfedges.push(index);
  return edge;
}

function createBorderEdge(left, v0, v1) {
  var edge = [v0, v1];
  edge.left = left;
  return edge;
}

function setEdgeEnd(edge, left, right, vertex) {
  if (!edge[0] && !edge[1]) {
    edge[0] = vertex;
    edge.left = left;
    edge.right = right;
  } else if (edge.left === right) {
    edge[1] = vertex;
  } else {
    edge[0] = vertex;
  }
}

// Liang–Barsky line clipping.
function clipEdge(edge, x0, y0, x1, y1) {
  var a = edge[0],
      b = edge[1],
      ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?

  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
  return true;
}

function connectEdge(edge, x0, y0, x1, y1) {
  var v1 = edge[1];
  if (v1) return true;

  var v0 = edge[0],
      left = edge.left,
      right = edge.right,
      lx = left[0],
      ly = left[1],
      rx = right[0],
      ry = right[1],
      fx = (lx + rx) / 2,
      fy = (ly + ry) / 2,
      fm,
      fb;

  if (ry === ly) {
    if (fx < x0 || fx >= x1) return;
    if (lx > rx) {
      if (!v0) v0 = [fx, y0];
      else if (v0[1] >= y1) return;
      v1 = [fx, y1];
    } else {
      if (!v0) v0 = [fx, y1];
      else if (v0[1] < y0) return;
      v1 = [fx, y0];
    }
  } else {
    fm = (lx - rx) / (ry - ly);
    fb = fy - fm * fx;
    if (fm < -1 || fm > 1) {
      if (lx > rx) {
        if (!v0) v0 = [(y0 - fb) / fm, y0];
        else if (v0[1] >= y1) return;
        v1 = [(y1 - fb) / fm, y1];
      } else {
        if (!v0) v0 = [(y1 - fb) / fm, y1];
        else if (v0[1] < y0) return;
        v1 = [(y0 - fb) / fm, y0];
      }
    } else {
      if (ly < ry) {
        if (!v0) v0 = [x0, fm * x0 + fb];
        else if (v0[0] >= x1) return;
        v1 = [x1, fm * x1 + fb];
      } else {
        if (!v0) v0 = [x1, fm * x1 + fb];
        else if (v0[0] < x0) return;
        v1 = [x0, fm * x0 + fb];
      }
    }
  }

  edge[0] = v0;
  edge[1] = v1;
  return true;
}

function clipEdges(x0, y0, x1, y1) {
  var i = edges.length,
      edge;

  while (i--) {
    if (!connectEdge(edge = edges[i], x0, y0, x1, y1)
        || !clipEdge(edge, x0, y0, x1, y1)
        || !(Math.abs(edge[0][0] - edge[1][0]) > epsilon$4
            || Math.abs(edge[0][1] - edge[1][1]) > epsilon$4)) {
      delete edges[i];
    }
  }
}

function createCell(site) {
  return cells[site.index] = {
    site: site,
    halfedges: []
  };
}

function cellHalfedgeAngle(cell, edge) {
  var site = cell.site,
      va = edge.left,
      vb = edge.right;
  if (site === vb) vb = va, va = site;
  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
  if (site === va) va = edge[1], vb = edge[0];
  else va = edge[0], vb = edge[1];
  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
}

function cellHalfedgeStart(cell, edge) {
  return edge[+(edge.left !== cell.site)];
}

function cellHalfedgeEnd(cell, edge) {
  return edge[+(edge.left === cell.site)];
}

function sortCellHalfedges() {
  for (var i = 0, n = cells.length, cell, halfedges, j, m; i < n; ++i) {
    if ((cell = cells[i]) && (m = (halfedges = cell.halfedges).length)) {
      var index = new Array(m),
          array = new Array(m);
      for (j = 0; j < m; ++j) index[j] = j, array[j] = cellHalfedgeAngle(cell, edges[halfedges[j]]);
      index.sort(function(i, j) { return array[j] - array[i]; });
      for (j = 0; j < m; ++j) array[j] = halfedges[index[j]];
      for (j = 0; j < m; ++j) halfedges[j] = array[j];
    }
  }
}

function clipCells(x0, y0, x1, y1) {
  var nCells = cells.length,
      iCell,
      cell,
      site,
      iHalfedge,
      halfedges,
      nHalfedges,
      start,
      startX,
      startY,
      end,
      endX,
      endY,
      cover = true;

  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = cells[iCell]) {
      site = cell.site;
      halfedges = cell.halfedges;
      iHalfedge = halfedges.length;

      // Remove any dangling clipped edges.
      while (iHalfedge--) {
        if (!edges[halfedges[iHalfedge]]) {
          halfedges.splice(iHalfedge, 1);
        }
      }

      // Insert any border edges as necessary.
      iHalfedge = 0, nHalfedges = halfedges.length;
      while (iHalfedge < nHalfedges) {
        end = cellHalfedgeEnd(cell, edges[halfedges[iHalfedge]]), endX = end[0], endY = end[1];
        start = cellHalfedgeStart(cell, edges[halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
        if (Math.abs(endX - startX) > epsilon$4 || Math.abs(endY - startY) > epsilon$4) {
          halfedges.splice(iHalfedge, 0, edges.push(createBorderEdge(site, end,
              Math.abs(endX - x0) < epsilon$4 && y1 - endY > epsilon$4 ? [x0, Math.abs(startX - x0) < epsilon$4 ? startY : y1]
              : Math.abs(endY - y1) < epsilon$4 && x1 - endX > epsilon$4 ? [Math.abs(startY - y1) < epsilon$4 ? startX : x1, y1]
              : Math.abs(endX - x1) < epsilon$4 && endY - y0 > epsilon$4 ? [x1, Math.abs(startX - x1) < epsilon$4 ? startY : y0]
              : Math.abs(endY - y0) < epsilon$4 && endX - x0 > epsilon$4 ? [Math.abs(startY - y0) < epsilon$4 ? startX : x0, y0]
              : null)) - 1);
          ++nHalfedges;
        }
      }

      if (nHalfedges) cover = false;
    }
  }

  // If there weren’t any edges, have the closest site cover the extent.
  // It doesn’t matter which corner of the extent we measure!
  if (cover) {
    var dx, dy, d2, dc = Infinity;

    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
      if (cell = cells[iCell]) {
        site = cell.site;
        dx = site[0] - x0;
        dy = site[1] - y0;
        d2 = dx * dx + dy * dy;
        if (d2 < dc) dc = d2, cover = cell;
      }
    }

    if (cover) {
      var v00 = [x0, y0], v01 = [x0, y1], v11 = [x1, y1], v10 = [x1, y0];
      cover.halfedges.push(
        edges.push(createBorderEdge(site = cover.site, v00, v01)) - 1,
        edges.push(createBorderEdge(site, v01, v11)) - 1,
        edges.push(createBorderEdge(site, v11, v10)) - 1,
        edges.push(createBorderEdge(site, v10, v00)) - 1
      );
    }
  }

  // Lastly delete any cells with no edges; these were entirely clipped.
  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = cells[iCell]) {
      if (!cell.halfedges.length) {
        delete cells[iCell];
      }
    }
  }
}

var circlePool = [];

var firstCircle;

function Circle() {
  RedBlackNode(this);
  this.x =
  this.y =
  this.arc =
  this.site =
  this.cy = null;
}

function attachCircle(arc) {
  var lArc = arc.P,
      rArc = arc.N;

  if (!lArc || !rArc) return;

  var lSite = lArc.site,
      cSite = arc.site,
      rSite = rArc.site;

  if (lSite === rSite) return;

  var bx = cSite[0],
      by = cSite[1],
      ax = lSite[0] - bx,
      ay = lSite[1] - by,
      cx = rSite[0] - bx,
      cy = rSite[1] - by;

  var d = 2 * (ax * cy - ay * cx);
  if (d >= -epsilon2$2) return;

  var ha = ax * ax + ay * ay,
      hc = cx * cx + cy * cy,
      x = (cy * ha - ay * hc) / d,
      y = (ax * hc - cx * ha) / d;

  var circle = circlePool.pop() || new Circle;
  circle.arc = arc;
  circle.site = cSite;
  circle.x = x + bx;
  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom

  arc.circle = circle;

  var before = null,
      node = circles._;

  while (node) {
    if (circle.y < node.y || (circle.y === node.y && circle.x <= node.x)) {
      if (node.L) node = node.L;
      else { before = node.P; break; }
    } else {
      if (node.R) node = node.R;
      else { before = node; break; }
    }
  }

  circles.insert(before, circle);
  if (!before) firstCircle = circle;
}

function detachCircle(arc) {
  var circle = arc.circle;
  if (circle) {
    if (!circle.P) firstCircle = circle.N;
    circles.remove(circle);
    circlePool.push(circle);
    RedBlackNode(circle);
    arc.circle = null;
  }
}

var beachPool = [];

function Beach() {
  RedBlackNode(this);
  this.edge =
  this.site =
  this.circle = null;
}

function createBeach(site) {
  var beach = beachPool.pop() || new Beach;
  beach.site = site;
  return beach;
}

function detachBeach(beach) {
  detachCircle(beach);
  beaches.remove(beach);
  beachPool.push(beach);
  RedBlackNode(beach);
}

function removeBeach(beach) {
  var circle = beach.circle,
      x = circle.x,
      y = circle.cy,
      vertex = [x, y],
      previous = beach.P,
      next = beach.N,
      disappearing = [beach];

  detachBeach(beach);

  var lArc = previous;
  while (lArc.circle
      && Math.abs(x - lArc.circle.x) < epsilon$4
      && Math.abs(y - lArc.circle.cy) < epsilon$4) {
    previous = lArc.P;
    disappearing.unshift(lArc);
    detachBeach(lArc);
    lArc = previous;
  }

  disappearing.unshift(lArc);
  detachCircle(lArc);

  var rArc = next;
  while (rArc.circle
      && Math.abs(x - rArc.circle.x) < epsilon$4
      && Math.abs(y - rArc.circle.cy) < epsilon$4) {
    next = rArc.N;
    disappearing.push(rArc);
    detachBeach(rArc);
    rArc = next;
  }

  disappearing.push(rArc);
  detachCircle(rArc);

  var nArcs = disappearing.length,
      iArc;
  for (iArc = 1; iArc < nArcs; ++iArc) {
    rArc = disappearing[iArc];
    lArc = disappearing[iArc - 1];
    setEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
  }

  lArc = disappearing[0];
  rArc = disappearing[nArcs - 1];
  rArc.edge = createEdge(lArc.site, rArc.site, null, vertex);

  attachCircle(lArc);
  attachCircle(rArc);
}

function addBeach(site) {
  var x = site[0],
      directrix = site[1],
      lArc,
      rArc,
      dxl,
      dxr,
      node = beaches._;

  while (node) {
    dxl = leftBreakPoint(node, directrix) - x;
    if (dxl > epsilon$4) node = node.L; else {
      dxr = x - rightBreakPoint(node, directrix);
      if (dxr > epsilon$4) {
        if (!node.R) {
          lArc = node;
          break;
        }
        node = node.R;
      } else {
        if (dxl > -epsilon$4) {
          lArc = node.P;
          rArc = node;
        } else if (dxr > -epsilon$4) {
          lArc = node;
          rArc = node.N;
        } else {
          lArc = rArc = node;
        }
        break;
      }
    }
  }

  createCell(site);
  var newArc = createBeach(site);
  beaches.insert(lArc, newArc);

  if (!lArc && !rArc) return;

  if (lArc === rArc) {
    detachCircle(lArc);
    rArc = createBeach(lArc.site);
    beaches.insert(newArc, rArc);
    newArc.edge = rArc.edge = createEdge(lArc.site, newArc.site);
    attachCircle(lArc);
    attachCircle(rArc);
    return;
  }

  if (!rArc) { // && lArc
    newArc.edge = createEdge(lArc.site, newArc.site);
    return;
  }

  // else lArc !== rArc
  detachCircle(lArc);
  detachCircle(rArc);

  var lSite = lArc.site,
      ax = lSite[0],
      ay = lSite[1],
      bx = site[0] - ax,
      by = site[1] - ay,
      rSite = rArc.site,
      cx = rSite[0] - ax,
      cy = rSite[1] - ay,
      d = 2 * (bx * cy - by * cx),
      hb = bx * bx + by * by,
      hc = cx * cx + cy * cy,
      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];

  setEdgeEnd(rArc.edge, lSite, rSite, vertex);
  newArc.edge = createEdge(lSite, site, null, vertex);
  rArc.edge = createEdge(site, rSite, null, vertex);
  attachCircle(lArc);
  attachCircle(rArc);
}

function leftBreakPoint(arc, directrix) {
  var site = arc.site,
      rfocx = site[0],
      rfocy = site[1],
      pby2 = rfocy - directrix;

  if (!pby2) return rfocx;

  var lArc = arc.P;
  if (!lArc) return -Infinity;

  site = lArc.site;
  var lfocx = site[0],
      lfocy = site[1],
      plby2 = lfocy - directrix;

  if (!plby2) return lfocx;

  var hl = lfocx - rfocx,
      aby2 = 1 / pby2 - 1 / plby2,
      b = hl / plby2;

  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;

  return (rfocx + lfocx) / 2;
}

function rightBreakPoint(arc, directrix) {
  var rArc = arc.N;
  if (rArc) return leftBreakPoint(rArc, directrix);
  var site = arc.site;
  return site[1] === directrix ? site[0] : Infinity;
}

var epsilon$4 = 1e-6;
var epsilon2$2 = 1e-12;
var beaches;
var cells;
var circles;
var edges;

function triangleArea(a, b, c) {
  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
}

function lexicographic(a, b) {
  return b[1] - a[1]
      || b[0] - a[0];
}

function Diagram(sites, extent) {
  var site = sites.sort(lexicographic).pop(),
      x,
      y,
      circle;

  edges = [];
  cells = new Array(sites.length);
  beaches = new RedBlackTree;
  circles = new RedBlackTree;

  while (true) {
    circle = firstCircle;
    if (site && (!circle || site[1] < circle.y || (site[1] === circle.y && site[0] < circle.x))) {
      if (site[0] !== x || site[1] !== y) {
        addBeach(site);
        x = site[0], y = site[1];
      }
      site = sites.pop();
    } else if (circle) {
      removeBeach(circle.arc);
    } else {
      break;
    }
  }

  sortCellHalfedges();

  if (extent) {
    var x0 = +extent[0][0],
        y0 = +extent[0][1],
        x1 = +extent[1][0],
        y1 = +extent[1][1];
    clipEdges(x0, y0, x1, y1);
    clipCells(x0, y0, x1, y1);
  }

  this.edges = edges;
  this.cells = cells;

  beaches =
  circles =
  edges =
  cells = null;
}

Diagram.prototype = {
  constructor: Diagram,

  polygons: function() {
    var edges = this.edges;

    return this.cells.map(function(cell) {
      var polygon = cell.halfedges.map(function(i) { return cellHalfedgeStart(cell, edges[i]); });
      polygon.data = cell.site.data;
      return polygon;
    });
  },

  triangles: function() {
    var triangles = [],
        edges = this.edges;

    this.cells.forEach(function(cell, i) {
      if (!(m = (halfedges = cell.halfedges).length)) return;
      var site = cell.site,
          halfedges,
          j = -1,
          m,
          s0,
          e1 = edges[halfedges[m - 1]],
          s1 = e1.left === site ? e1.right : e1.left;

      while (++j < m) {
        s0 = s1;
        e1 = edges[halfedges[j]];
        s1 = e1.left === site ? e1.right : e1.left;
        if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
          triangles.push([site.data, s0.data, s1.data]);
        }
      }
    });

    return triangles;
  },

  links: function() {
    return this.edges.filter(function(edge) {
      return edge.right;
    }).map(function(edge) {
      return {
        source: edge.left.data,
        target: edge.right.data
      };
    });
  },

  find: function(x, y, radius) {
    var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;

    // Use the previously-found cell, or start with an arbitrary one.
    while (!(cell = that.cells[i1])) if (++i1 >= n) return null;
    var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;

    // Traverse the half-edges to find a closer cell, if any.
    do {
      cell = that.cells[i0 = i1], i1 = null;
      cell.halfedges.forEach(function(e) {
        var edge = that.edges[e], v = edge.left;
        if ((v === cell.site || !v) && !(v = edge.right)) return;
        var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
        if (v2 < d2) d2 = v2, i1 = v.index;
      });
    } while (i1 !== null);

    that._found = i0;

    return radius == null || d2 <= radius * radius ? cell.site : null;
  }
};

var voronoi = function() {
  var x$$1 = x$4,
      y$$1 = y$4,
      extent = null;

  function voronoi(data) {
    return new Diagram(data.map(function(d, i) {
      var s = [Math.round(x$$1(d, i, data) / epsilon$4) * epsilon$4, Math.round(y$$1(d, i, data) / epsilon$4) * epsilon$4];
      s.index = i;
      s.data = d;
      return s;
    }), extent);
  }

  voronoi.polygons = function(data) {
    return voronoi(data).polygons();
  };

  voronoi.links = function(data) {
    return voronoi(data).links();
  };

  voronoi.triangles = function(data) {
    return voronoi(data).triangles();
  };

  voronoi.x = function(_) {
    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant$11(+_), voronoi) : x$$1;
  };

  voronoi.y = function(_) {
    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant$11(+_), voronoi) : y$$1;
  };

  voronoi.extent = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]], voronoi) : extent && [[extent[0][0], extent[0][1]], [extent[1][0], extent[1][1]]];
  };

  voronoi.size = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[0, 0], [+_[0], +_[1]]], voronoi) : extent && [extent[1][0] - extent[0][0], extent[1][1] - extent[0][1]];
  };

  return voronoi;
};

var constant$12 = function(x) {
  return function() {
    return x;
  };
};

function ZoomEvent(target, type, transform) {
  this.target = target;
  this.type = type;
  this.transform = transform;
}

function Transform(k, x, y) {
  this.k = k;
  this.x = x;
  this.y = y;
}

Transform.prototype = {
  constructor: Transform,
  scale: function(k) {
    return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
  },
  translate: function(x, y) {
    return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
  },
  apply: function(point) {
    return [point[0] * this.k + this.x, point[1] * this.k + this.y];
  },
  applyX: function(x) {
    return x * this.k + this.x;
  },
  applyY: function(y) {
    return y * this.k + this.y;
  },
  invert: function(location) {
    return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
  },
  invertX: function(x) {
    return (x - this.x) / this.k;
  },
  invertY: function(y) {
    return (y - this.y) / this.k;
  },
  rescaleX: function(x) {
    return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
  },
  rescaleY: function(y) {
    return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};

var identity$8 = new Transform(1, 0, 0);

transform$1.prototype = Transform.prototype;

function transform$1(node) {
  return node.__zoom || identity$8;
}

function nopropagation$2() {
  exports.event.stopImmediatePropagation();
}

var noevent$2 = function() {
  exports.event.preventDefault();
  exports.event.stopImmediatePropagation();
};

// Ignore right-click, since that should open the context menu.
function defaultFilter$2() {
  return !exports.event.button;
}

function defaultExtent$1() {
  var e = this, w, h;
  if (e instanceof SVGElement) {
    e = e.ownerSVGElement || e;
    w = e.width.baseVal.value;
    h = e.height.baseVal.value;
  } else {
    w = e.clientWidth;
    h = e.clientHeight;
  }
  return [[0, 0], [w, h]];
}

function defaultTransform() {
  return this.__zoom || identity$8;
}

var zoom = function() {
  var filter = defaultFilter$2,
      extent = defaultExtent$1,
      k0 = 0,
      k1 = Infinity,
      x0 = -k1,
      x1 = k1,
      y0 = x0,
      y1 = x1,
      duration = 250,
      interpolate$$1 = interpolateZoom,
      gestures = [],
      listeners = dispatch("start", "zoom", "end"),
      touchstarting,
      touchending,
      touchDelay = 500,
      wheelDelay = 150,
      clickDistance2 = 0;

  function zoom(selection$$1) {
    selection$$1
        .on("wheel.zoom", wheeled)
        .on("mousedown.zoom", mousedowned)
        .on("dblclick.zoom", dblclicked)
        .on("touchstart.zoom", touchstarted)
        .on("touchmove.zoom", touchmoved)
        .on("touchend.zoom touchcancel.zoom", touchended)
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)")
        .property("__zoom", defaultTransform);
  }

  zoom.transform = function(collection, transform) {
    var selection$$1 = collection.selection ? collection.selection() : collection;
    selection$$1.property("__zoom", defaultTransform);
    if (collection !== selection$$1) {
      schedule(collection, transform);
    } else {
      selection$$1.interrupt().each(function() {
        gesture(this, arguments)
            .start()
            .zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform)
            .end();
      });
    }
  };

  zoom.scaleBy = function(selection$$1, k) {
    zoom.scaleTo(selection$$1, function() {
      var k0 = this.__zoom.k,
          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return k0 * k1;
    });
  };

  zoom.scaleTo = function(selection$$1, k) {
    zoom.transform(selection$$1, function() {
      var e = extent.apply(this, arguments),
          t0 = this.__zoom,
          p0 = centroid(e),
          p1 = t0.invert(p0),
          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return constrain(translate(scale(t0, k1), p0, p1), e);
    });
  };

  zoom.translateBy = function(selection$$1, x, y) {
    zoom.transform(selection$$1, function() {
      return constrain(this.__zoom.translate(
        typeof x === "function" ? x.apply(this, arguments) : x,
        typeof y === "function" ? y.apply(this, arguments) : y
      ), extent.apply(this, arguments));
    });
  };

  function scale(transform, k) {
    k = Math.max(k0, Math.min(k1, k));
    return k === transform.k ? transform : new Transform(k, transform.x, transform.y);
  }

  function translate(transform, p0, p1) {
    var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
    return x === transform.x && y === transform.y ? transform : new Transform(transform.k, x, y);
  }

  function constrain(transform, extent) {
    var dx0 = transform.invertX(extent[0][0]) - x0,
        dx1 = transform.invertX(extent[1][0]) - x1,
        dy0 = transform.invertY(extent[0][1]) - y0,
        dy1 = transform.invertY(extent[1][1]) - y1;
    return transform.translate(
      dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1),
      dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1)
    );
  }

  function centroid(extent) {
    return [(+extent[0][0] + +extent[1][0]) / 2, (+extent[0][1] + +extent[1][1]) / 2];
  }

  function schedule(transition$$1, transform, center) {
    transition$$1
        .on("start.zoom", function() { gesture(this, arguments).start(); })
        .on("interrupt.zoom end.zoom", function() { gesture(this, arguments).end(); })
        .tween("zoom", function() {
          var that = this,
              args = arguments,
              g = gesture(that, args),
              e = extent.apply(that, args),
              p = center || centroid(e),
              w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]),
              a = that.__zoom,
              b = typeof transform === "function" ? transform.apply(that, args) : transform,
              i = interpolate$$1(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
          return function(t) {
            if (t === 1) t = b; // Avoid rounding error on end.
            else { var l = i(t), k = w / l[2]; t = new Transform(k, p[0] - l[0] * k, p[1] - l[1] * k); }
            g.zoom(null, t);
          };
        });
  }

  function gesture(that, args) {
    for (var i = 0, n = gestures.length, g; i < n; ++i) {
      if ((g = gestures[i]).that === that) {
        return g;
      }
    }
    return new Gesture(that, args);
  }

  function Gesture(that, args) {
    this.that = that;
    this.args = args;
    this.index = -1;
    this.active = 0;
    this.extent = extent.apply(that, args);
  }

  Gesture.prototype = {
    start: function() {
      if (++this.active === 1) {
        this.index = gestures.push(this) - 1;
        this.emit("start");
      }
      return this;
    },
    zoom: function(key, transform) {
      if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
      if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
      if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
      this.that.__zoom = transform;
      this.emit("zoom");
      return this;
    },
    end: function() {
      if (--this.active === 0) {
        gestures.splice(this.index, 1);
        this.index = -1;
        this.emit("end");
      }
      return this;
    },
    emit: function(type) {
      customEvent(new ZoomEvent(zoom, type, this.that.__zoom), listeners.apply, listeners, [type, this.that, this.args]);
    }
  };

  function wheeled() {
    if (!filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        t = this.__zoom,
        k = Math.max(k0, Math.min(k1, t.k * Math.pow(2, -exports.event.deltaY * (exports.event.deltaMode ? 120 : 1) / 500))),
        p = mouse(this);

    // If the mouse is in the same location as before, reuse it.
    // If there were recent wheel events, reset the wheel idle timeout.
    if (g.wheel) {
      if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) {
        g.mouse[1] = t.invert(g.mouse[0] = p);
      }
      clearTimeout(g.wheel);
    }

    // If this wheel event won’t trigger a transform change, ignore it.
    else if (t.k === k) return;

    // Otherwise, capture the mouse point and location at the start.
    else {
      g.mouse = [p, t.invert(p)];
      interrupt(this);
      g.start();
    }

    noevent$2();
    g.wheel = setTimeout(wheelidled, wheelDelay);
    g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent));

    function wheelidled() {
      g.wheel = null;
      g.end();
    }
  }

  function mousedowned() {
    if (touchending || !filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        v = select(exports.event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true),
        p = mouse(this),
        x0 = exports.event.clientX,
        y0 = exports.event.clientY;

    dragDisable(exports.event.view);
    nopropagation$2();
    g.mouse = [p, this.__zoom.invert(p)];
    interrupt(this);
    g.start();

    function mousemoved() {
      noevent$2();
      if (!g.moved) {
        var dx = exports.event.clientX - x0, dy = exports.event.clientY - y0;
        g.moved = dx * dx + dy * dy > clickDistance2;
      }
      g.zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = mouse(g.that), g.mouse[1]), g.extent));
    }

    function mouseupped() {
      v.on("mousemove.zoom mouseup.zoom", null);
      yesdrag(exports.event.view, g.moved);
      noevent$2();
      g.end();
    }
  }

  function dblclicked() {
    if (!filter.apply(this, arguments)) return;
    var t0 = this.__zoom,
        p0 = mouse(this),
        p1 = t0.invert(p0),
        k1 = t0.k * (exports.event.shiftKey ? 0.5 : 2),
        t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, arguments));

    noevent$2();
    if (duration > 0) select(this).transition().duration(duration).call(schedule, t1, p0);
    else select(this).call(zoom.transform, t1);
  }

  function touchstarted() {
    if (!filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        touches$$1 = exports.event.changedTouches,
        started,
        n = touches$$1.length, i, t, p;

    nopropagation$2();
    for (i = 0; i < n; ++i) {
      t = touches$$1[i], p = touch(this, touches$$1, t.identifier);
      p = [p, this.__zoom.invert(p), t.identifier];
      if (!g.touch0) g.touch0 = p, started = true;
      else if (!g.touch1) g.touch1 = p;
    }

    // If this is a dbltap, reroute to the (optional) dblclick.zoom handler.
    if (touchstarting) {
      touchstarting = clearTimeout(touchstarting);
      if (!g.touch1) {
        g.end();
        p = select(this).on("dblclick.zoom");
        if (p) p.apply(this, arguments);
        return;
      }
    }

    if (started) {
      touchstarting = setTimeout(function() { touchstarting = null; }, touchDelay);
      interrupt(this);
      g.start();
    }
  }

  function touchmoved() {
    var g = gesture(this, arguments),
        touches$$1 = exports.event.changedTouches,
        n = touches$$1.length, i, t, p, l;

    noevent$2();
    if (touchstarting) touchstarting = clearTimeout(touchstarting);
    for (i = 0; i < n; ++i) {
      t = touches$$1[i], p = touch(this, touches$$1, t.identifier);
      if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
      else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
    }
    t = g.that.__zoom;
    if (g.touch1) {
      var p0 = g.touch0[0], l0 = g.touch0[1],
          p1 = g.touch1[0], l1 = g.touch1[1],
          dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp,
          dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
      t = scale(t, Math.sqrt(dp / dl));
      p = [(p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2];
      l = [(l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2];
    }
    else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
    else return;
    g.zoom("touch", constrain(translate(t, p, l), g.extent));
  }

  function touchended() {
    var g = gesture(this, arguments),
        touches$$1 = exports.event.changedTouches,
        n = touches$$1.length, i, t;

    nopropagation$2();
    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() { touchending = null; }, touchDelay);
    for (i = 0; i < n; ++i) {
      t = touches$$1[i];
      if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
      else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
    }
    if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
    if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
    else g.end();
  }

  zoom.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : constant$12(!!_), zoom) : filter;
  };

  zoom.extent = function(_) {
    return arguments.length ? (extent = typeof _ === "function" ? _ : constant$12([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), zoom) : extent;
  };

  zoom.scaleExtent = function(_) {
    return arguments.length ? (k0 = +_[0], k1 = +_[1], zoom) : [k0, k1];
  };

  zoom.translateExtent = function(_) {
    return arguments.length ? (x0 = +_[0][0], x1 = +_[1][0], y0 = +_[0][1], y1 = +_[1][1], zoom) : [[x0, y0], [x1, y1]];
  };

  zoom.duration = function(_) {
    return arguments.length ? (duration = +_, zoom) : duration;
  };

  zoom.interpolate = function(_) {
    return arguments.length ? (interpolate$$1 = _, zoom) : interpolate$$1;
  };

  zoom.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? zoom : value;
  };

  zoom.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
  };
    
  return zoom;
};

exports.version = version;
exports.bisect = bisectRight;
exports.bisectRight = bisectRight;
exports.bisectLeft = bisectLeft;
exports.ascending = ascending;
exports.bisector = bisector;
exports.cross = cross;
exports.descending = descending;
exports.deviation = deviation;
exports.extent = extent;
exports.histogram = histogram;
exports.thresholdFreedmanDiaconis = freedmanDiaconis;
exports.thresholdScott = scott;
exports.thresholdSturges = sturges;
exports.max = max;
exports.mean = mean;
exports.median = median;
exports.merge = merge;
exports.min = min;
exports.pairs = pairs;
exports.permute = permute;
exports.quantile = threshold;
exports.range = sequence;
exports.scan = scan;
exports.shuffle = shuffle;
exports.sum = sum;
exports.ticks = ticks;
exports.tickIncrement = tickIncrement;
exports.tickStep = tickStep;
exports.transpose = transpose;
exports.variance = variance;
exports.zip = zip;
exports.axisTop = axisTop;
exports.axisRight = axisRight;
exports.axisBottom = axisBottom;
exports.axisLeft = axisLeft;
exports.brush = brush;
exports.brushX = brushX;
exports.brushY = brushY;
exports.brushSelection = brushSelection;
exports.chord = chord;
exports.ribbon = ribbon;
exports.nest = nest;
exports.set = set$2;
exports.map = map$1;
exports.keys = keys;
exports.values = values;
exports.entries = entries;
exports.color = color;
exports.rgb = rgb;
exports.hsl = hsl;
exports.lab = lab;
exports.hcl = hcl;
exports.cubehelix = cubehelix;
exports.dispatch = dispatch;
exports.drag = drag;
exports.dragDisable = dragDisable;
exports.dragEnable = yesdrag;
exports.dsvFormat = dsv;
exports.csvParse = csvParse;
exports.csvParseRows = csvParseRows;
exports.csvFormat = csvFormat;
exports.csvFormatRows = csvFormatRows;
exports.tsvParse = tsvParse;
exports.tsvParseRows = tsvParseRows;
exports.tsvFormat = tsvFormat;
exports.tsvFormatRows = tsvFormatRows;
exports.easeLinear = linear$1;
exports.easeQuad = quadInOut;
exports.easeQuadIn = quadIn;
exports.easeQuadOut = quadOut;
exports.easeQuadInOut = quadInOut;
exports.easeCubic = cubicInOut;
exports.easeCubicIn = cubicIn;
exports.easeCubicOut = cubicOut;
exports.easeCubicInOut = cubicInOut;
exports.easePoly = polyInOut;
exports.easePolyIn = polyIn;
exports.easePolyOut = polyOut;
exports.easePolyInOut = polyInOut;
exports.easeSin = sinInOut;
exports.easeSinIn = sinIn;
exports.easeSinOut = sinOut;
exports.easeSinInOut = sinInOut;
exports.easeExp = expInOut;
exports.easeExpIn = expIn;
exports.easeExpOut = expOut;
exports.easeExpInOut = expInOut;
exports.easeCircle = circleInOut;
exports.easeCircleIn = circleIn;
exports.easeCircleOut = circleOut;
exports.easeCircleInOut = circleInOut;
exports.easeBounce = bounceOut;
exports.easeBounceIn = bounceIn;
exports.easeBounceOut = bounceOut;
exports.easeBounceInOut = bounceInOut;
exports.easeBack = backInOut;
exports.easeBackIn = backIn;
exports.easeBackOut = backOut;
exports.easeBackInOut = backInOut;
exports.easeElastic = elasticOut;
exports.easeElasticIn = elasticIn;
exports.easeElasticOut = elasticOut;
exports.easeElasticInOut = elasticInOut;
exports.forceCenter = center$1;
exports.forceCollide = collide;
exports.forceLink = link;
exports.forceManyBody = manyBody;
exports.forceSimulation = simulation;
exports.forceX = x$2;
exports.forceY = y$2;
exports.formatDefaultLocale = defaultLocale;
exports.formatLocale = formatLocale;
exports.formatSpecifier = formatSpecifier;
exports.precisionFixed = precisionFixed;
exports.precisionPrefix = precisionPrefix;
exports.precisionRound = precisionRound;
exports.geoArea = area;
exports.geoBounds = bounds;
exports.geoCentroid = centroid;
exports.geoCircle = circle;
exports.geoClipExtent = extent$1;
exports.geoContains = contains;
exports.geoDistance = distance;
exports.geoGraticule = graticule;
exports.geoGraticule10 = graticule10;
exports.geoInterpolate = interpolate$1;
exports.geoLength = length$1;
exports.geoPath = index$1;
exports.geoAlbers = albers;
exports.geoAlbersUsa = albersUsa;
exports.geoAzimuthalEqualArea = azimuthalEqualArea;
exports.geoAzimuthalEqualAreaRaw = azimuthalEqualAreaRaw;
exports.geoAzimuthalEquidistant = azimuthalEquidistant;
exports.geoAzimuthalEquidistantRaw = azimuthalEquidistantRaw;
exports.geoConicConformal = conicConformal;
exports.geoConicConformalRaw = conicConformalRaw;
exports.geoConicEqualArea = conicEqualArea;
exports.geoConicEqualAreaRaw = conicEqualAreaRaw;
exports.geoConicEquidistant = conicEquidistant;
exports.geoConicEquidistantRaw = conicEquidistantRaw;
exports.geoEquirectangular = equirectangular;
exports.geoEquirectangularRaw = equirectangularRaw;
exports.geoGnomonic = gnomonic;
exports.geoGnomonicRaw = gnomonicRaw;
exports.geoIdentity = identity$5;
exports.geoProjection = projection;
exports.geoProjectionMutator = projectionMutator;
exports.geoMercator = mercator;
exports.geoMercatorRaw = mercatorRaw;
exports.geoOrthographic = orthographic;
exports.geoOrthographicRaw = orthographicRaw;
exports.geoStereographic = stereographic;
exports.geoStereographicRaw = stereographicRaw;
exports.geoTransverseMercator = transverseMercator;
exports.geoTransverseMercatorRaw = transverseMercatorRaw;
exports.geoRotation = rotation;
exports.geoStream = geoStream;
exports.geoTransform = transform;
exports.cluster = cluster;
exports.hierarchy = hierarchy;
exports.pack = index$2;
exports.packSiblings = siblings;
exports.packEnclose = enclose;
exports.partition = partition;
exports.stratify = stratify;
exports.tree = tree;
exports.treemap = index$3;
exports.treemapBinary = binary;
exports.treemapDice = treemapDice;
exports.treemapSlice = treemapSlice;
exports.treemapSliceDice = sliceDice;
exports.treemapSquarify = squarify;
exports.treemapResquarify = resquarify;
exports.interpolate = interpolateValue;
exports.interpolateArray = array$1;
exports.interpolateBasis = basis$1;
exports.interpolateBasisClosed = basisClosed;
exports.interpolateDate = date;
exports.interpolateNumber = reinterpolate;
exports.interpolateObject = object;
exports.interpolateRound = interpolateRound;
exports.interpolateString = interpolateString;
exports.interpolateTransformCss = interpolateTransformCss;
exports.interpolateTransformSvg = interpolateTransformSvg;
exports.interpolateZoom = interpolateZoom;
exports.interpolateRgb = interpolateRgb;
exports.interpolateRgbBasis = rgbBasis;
exports.interpolateRgbBasisClosed = rgbBasisClosed;
exports.interpolateHsl = hsl$2;
exports.interpolateHslLong = hslLong;
exports.interpolateLab = lab$1;
exports.interpolateHcl = hcl$2;
exports.interpolateHclLong = hclLong;
exports.interpolateCubehelix = cubehelix$2;
exports.interpolateCubehelixLong = cubehelixLong;
exports.quantize = quantize;
exports.path = path;
exports.polygonArea = area$1;
exports.polygonCentroid = centroid$1;
exports.polygonHull = hull;
exports.polygonContains = contains$1;
exports.polygonLength = length$2;
exports.quadtree = quadtree;
exports.queue = queue;
exports.randomUniform = uniform;
exports.randomNormal = normal;
exports.randomLogNormal = logNormal;
exports.randomBates = bates;
exports.randomIrwinHall = irwinHall;
exports.randomExponential = exponential$1;
exports.request = request;
exports.html = html;
exports.json = json;
exports.text = text;
exports.xml = xml;
exports.csv = csv$1;
exports.tsv = tsv$1;
exports.scaleBand = band;
exports.scalePoint = point$1;
exports.scaleIdentity = identity$6;
exports.scaleLinear = linear$2;
exports.scaleLog = log$1;
exports.scaleOrdinal = ordinal;
exports.scaleImplicit = implicit;
exports.scalePow = pow$1;
exports.scaleSqrt = sqrt$1;
exports.scaleQuantile = quantile$$1;
exports.scaleQuantize = quantize$1;
exports.scaleThreshold = threshold$1;
exports.scaleTime = time;
exports.scaleUtc = utcTime;
exports.schemeCategory10 = category10;
exports.schemeCategory20b = category20b;
exports.schemeCategory20c = category20c;
exports.schemeCategory20 = category20;
exports.interpolateCubehelixDefault = cubehelix$3;
exports.interpolateRainbow = rainbow$1;
exports.interpolateWarm = warm;
exports.interpolateCool = cool;
exports.interpolateViridis = viridis;
exports.interpolateMagma = magma;
exports.interpolateInferno = inferno;
exports.interpolatePlasma = plasma;
exports.scaleSequential = sequential;
exports.creator = creator;
exports.local = local$1;
exports.matcher = matcher$1;
exports.mouse = mouse;
exports.namespace = namespace;
exports.namespaces = namespaces;
exports.select = select;
exports.selectAll = selectAll;
exports.selection = selection;
exports.selector = selector;
exports.selectorAll = selectorAll;
exports.style = styleValue;
exports.touch = touch;
exports.touches = touches;
exports.window = defaultView;
exports.customEvent = customEvent;
exports.arc = arc;
exports.area = area$2;
exports.line = line;
exports.pie = pie;
exports.radialArea = radialArea;
exports.radialLine = radialLine$1;
exports.linkHorizontal = linkHorizontal;
exports.linkVertical = linkVertical;
exports.linkRadial = linkRadial;
exports.symbol = symbol;
exports.symbols = symbols;
exports.symbolCircle = circle$2;
exports.symbolCross = cross$2;
exports.symbolDiamond = diamond;
exports.symbolSquare = square;
exports.symbolStar = star;
exports.symbolTriangle = triangle;
exports.symbolWye = wye;
exports.curveBasisClosed = basisClosed$1;
exports.curveBasisOpen = basisOpen;
exports.curveBasis = basis$2;
exports.curveBundle = bundle;
exports.curveCardinalClosed = cardinalClosed;
exports.curveCardinalOpen = cardinalOpen;
exports.curveCardinal = cardinal;
exports.curveCatmullRomClosed = catmullRomClosed;
exports.curveCatmullRomOpen = catmullRomOpen;
exports.curveCatmullRom = catmullRom;
exports.curveLinearClosed = linearClosed;
exports.curveLinear = curveLinear;
exports.curveMonotoneX = monotoneX;
exports.curveMonotoneY = monotoneY;
exports.curveNatural = natural;
exports.curveStep = step;
exports.curveStepAfter = stepAfter;
exports.curveStepBefore = stepBefore;
exports.stack = stack;
exports.stackOffsetExpand = expand;
exports.stackOffsetDiverging = diverging;
exports.stackOffsetNone = none$1;
exports.stackOffsetSilhouette = silhouette;
exports.stackOffsetWiggle = wiggle;
exports.stackOrderAscending = ascending$2;
exports.stackOrderDescending = descending$2;
exports.stackOrderInsideOut = insideOut;
exports.stackOrderNone = none$2;
exports.stackOrderReverse = reverse;
exports.timeInterval = newInterval;
exports.timeMillisecond = millisecond;
exports.timeMilliseconds = milliseconds;
exports.utcMillisecond = millisecond;
exports.utcMilliseconds = milliseconds;
exports.timeSecond = second;
exports.timeSeconds = seconds;
exports.utcSecond = second;
exports.utcSeconds = seconds;
exports.timeMinute = minute;
exports.timeMinutes = minutes;
exports.timeHour = hour;
exports.timeHours = hours;
exports.timeDay = day;
exports.timeDays = days;
exports.timeWeek = sunday;
exports.timeWeeks = sundays;
exports.timeSunday = sunday;
exports.timeSundays = sundays;
exports.timeMonday = monday;
exports.timeMondays = mondays;
exports.timeTuesday = tuesday;
exports.timeTuesdays = tuesdays;
exports.timeWednesday = wednesday;
exports.timeWednesdays = wednesdays;
exports.timeThursday = thursday;
exports.timeThursdays = thursdays;
exports.timeFriday = friday;
exports.timeFridays = fridays;
exports.timeSaturday = saturday;
exports.timeSaturdays = saturdays;
exports.timeMonth = month;
exports.timeMonths = months;
exports.timeYear = year;
exports.timeYears = years;
exports.utcMinute = utcMinute;
exports.utcMinutes = utcMinutes;
exports.utcHour = utcHour;
exports.utcHours = utcHours;
exports.utcDay = utcDay;
exports.utcDays = utcDays;
exports.utcWeek = utcSunday;
exports.utcWeeks = utcSundays;
exports.utcSunday = utcSunday;
exports.utcSundays = utcSundays;
exports.utcMonday = utcMonday;
exports.utcMondays = utcMondays;
exports.utcTuesday = utcTuesday;
exports.utcTuesdays = utcTuesdays;
exports.utcWednesday = utcWednesday;
exports.utcWednesdays = utcWednesdays;
exports.utcThursday = utcThursday;
exports.utcThursdays = utcThursdays;
exports.utcFriday = utcFriday;
exports.utcFridays = utcFridays;
exports.utcSaturday = utcSaturday;
exports.utcSaturdays = utcSaturdays;
exports.utcMonth = utcMonth;
exports.utcMonths = utcMonths;
exports.utcYear = utcYear;
exports.utcYears = utcYears;
exports.timeFormatDefaultLocale = defaultLocale$1;
exports.timeFormatLocale = formatLocale$1;
exports.isoFormat = formatIso;
exports.isoParse = parseIso;
exports.now = now;
exports.timer = timer;
exports.timerFlush = timerFlush;
exports.timeout = timeout$1;
exports.interval = interval$1;
exports.transition = transition;
exports.active = active;
exports.interrupt = interrupt;
exports.voronoi = voronoi;
exports.zoom = zoom;
exports.zoomTransform = transform$1;
exports.zoomIdentity = identity$8;

Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var camelize = __webpack_require__(229);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

var isTextNode = __webpack_require__(239);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var invariant = __webpack_require__(0);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(5);

var createArrayFromMixed = __webpack_require__(232);
var getMarkupWrap = __webpack_require__(234);
var invariant = __webpack_require__(0);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(5);

var invariant = __webpack_require__(0);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(236);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var isNode = __webpack_require__(238);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88)))

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEqual;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88), __webpack_require__(338)(module)))

/***/ }),
/* 243 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */
function before(n, func) {
  var result;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  n = toInteger(n);
  return function() {
    if (--n > 0) {
      result = func.apply(this, arguments);
    }
    if (n <= 1) {
      func = undefined;
    }
    return result;
  };
}

/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */
function once(func) {
  return before(2, func);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = once;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(6);
var invariant = __webpack_require__(0);
var ReactPropTypesSecret = __webpack_require__(126);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(6);
var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

var ReactPropTypesSecret = __webpack_require__(126);
var checkPropTypes = __webpack_require__(244);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(20);
var ReactDOM = __webpack_require__(127);
var PropTypes = __webpack_require__(125);
var className = __webpack_require__(109);
var debounce = __webpack_require__(241);
var isEqual = __webpack_require__(242);
var createReactClass = __webpack_require__(209);

function normalizeLineEndings(str) {
	if (!str) return str;
	return str.replace(/\r\n|\r/g, '\n');
}

var CodeMirror = createReactClass({
	propTypes: {
		autoFocus: PropTypes.bool,
		className: PropTypes.any,
		codeMirrorInstance: PropTypes.func,
		defaultValue: PropTypes.string,
		name: PropTypes.string,
		onChange: PropTypes.func,
		onCursorActivity: PropTypes.func,
		onFocusChange: PropTypes.func,
		onScroll: PropTypes.func,
		options: PropTypes.object,
		path: PropTypes.string,
		value: PropTypes.string,
		preserveScrollPosition: PropTypes.bool
	},
	getDefaultProps: function getDefaultProps() {
		return {
			preserveScrollPosition: false
		};
	},
	getCodeMirrorInstance: function getCodeMirrorInstance() {
		return this.props.codeMirrorInstance || __webpack_require__(32);
	},
	getInitialState: function getInitialState() {
		return {
			isFocused: false
		};
	},
	componentWillMount: function componentWillMount() {
		this.componentWillReceiveProps = debounce(this.componentWillReceiveProps, 0);
		if (this.props.path) {
			console.error('Warning: react-codemirror: the `path` prop has been changed to `name`');
		}
	},
	componentDidMount: function componentDidMount() {
		var codeMirrorInstance = this.getCodeMirrorInstance();
		this.codeMirror = codeMirrorInstance.fromTextArea(this.textareaNode, this.props.options);
		this.codeMirror.on('change', this.codemirrorValueChanged);
		this.codeMirror.on('cursorActivity', this.cursorActivity);
		this.codeMirror.on('focus', this.focusChanged.bind(this, true));
		this.codeMirror.on('blur', this.focusChanged.bind(this, false));
		this.codeMirror.on('scroll', this.scrollChanged);
		this.codeMirror.setValue(this.props.defaultValue || this.props.value || '');
	},
	componentWillUnmount: function componentWillUnmount() {
		// is there a lighter-weight way to remove the cm instance?
		if (this.codeMirror) {
			this.codeMirror.toTextArea();
		}
	},
	componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		if (this.codeMirror && nextProps.value !== undefined && nextProps.value !== this.props.value && normalizeLineEndings(this.codeMirror.getValue()) !== normalizeLineEndings(nextProps.value)) {
			if (this.props.preserveScrollPosition) {
				var prevScrollPosition = this.codeMirror.getScrollInfo();
				this.codeMirror.setValue(nextProps.value);
				this.codeMirror.scrollTo(prevScrollPosition.left, prevScrollPosition.top);
			} else {
				this.codeMirror.setValue(nextProps.value);
			}
		}
		if (typeof nextProps.options === 'object') {
			for (var optionName in nextProps.options) {
				if (nextProps.options.hasOwnProperty(optionName)) {
					this.setOptionIfChanged(optionName, nextProps.options[optionName]);
				}
			}
		}
	},
	setOptionIfChanged: function setOptionIfChanged(optionName, newValue) {
		var oldValue = this.codeMirror.getOption(optionName);
		if (!isEqual(oldValue, newValue)) {
			this.codeMirror.setOption(optionName, newValue);
		}
	},
	getCodeMirror: function getCodeMirror() {
		return this.codeMirror;
	},
	focus: function focus() {
		if (this.codeMirror) {
			this.codeMirror.focus();
		}
	},
	focusChanged: function focusChanged(focused) {
		this.setState({
			isFocused: focused
		});
		this.props.onFocusChange && this.props.onFocusChange(focused);
	},
	cursorActivity: function cursorActivity(cm) {
		this.props.onCursorActivity && this.props.onCursorActivity(cm);
	},
	scrollChanged: function scrollChanged(cm) {
		this.props.onScroll && this.props.onScroll(cm.getScrollInfo());
	},
	codemirrorValueChanged: function codemirrorValueChanged(doc, change) {
		if (this.props.onChange && change.origin !== 'setValue') {
			this.props.onChange(doc.getValue(), change);
		}
	},
	render: function render() {
		var _this = this;

		var editorClassName = className('ReactCodeMirror', this.state.isFocused ? 'ReactCodeMirror--focused' : null, this.props.className);
		return React.createElement(
			'div',
			{ className: editorClassName },
			React.createElement('textarea', {
				ref: function (ref) {
					return _this.textareaNode = ref;
				},
				name: this.props.name || this.props.path,
				defaultValue: this.props.value,
				autoComplete: 'off',
				autoFocus: this.props.autoFocus
			})
		);
	}
});

module.exports = CodeMirror;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(4);

var focusNode = __webpack_require__(121);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(35);
var ExecutionEnvironment = __webpack_require__(5);
var FallbackCompositionState = __webpack_require__(256);
var SyntheticCompositionEvent = __webpack_require__(293);
var SyntheticInputEvent = __webpack_require__(296);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(128);
var ExecutionEnvironment = __webpack_require__(5);
var ReactInstrumentation = __webpack_require__(7);

var camelizeStyleName = __webpack_require__(230);
var dangerousStyleValue = __webpack_require__(302);
var hyphenateStyleName = __webpack_require__(237);
var memoizeStringOnly = __webpack_require__(240);
var warning = __webpack_require__(1);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(34);
var EventPropagators = __webpack_require__(35);
var ExecutionEnvironment = __webpack_require__(5);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactUpdates = __webpack_require__(9);
var SyntheticEvent = __webpack_require__(10);

var inputValueTracking = __webpack_require__(144);
var getEventTarget = __webpack_require__(84);
var isEventSupported = __webpack_require__(85);
var isTextInputElement = __webpack_require__(146);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var DOMLazyTree = __webpack_require__(25);
var ExecutionEnvironment = __webpack_require__(5);

var createNodesFromMarkup = __webpack_require__(233);
var emptyFunction = __webpack_require__(6);
var invariant = __webpack_require__(0);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(35);
var ReactDOMComponentTree = __webpack_require__(4);
var SyntheticMouseEvent = __webpack_require__(46);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var PooledClass = __webpack_require__(19);

var getTextContentAccessor = __webpack_require__(143);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(26);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactReconciler = __webpack_require__(27);

var instantiateReactComponent = __webpack_require__(145);
var KeyEscapeUtils = __webpack_require__(76);
var shouldUpdateReactComponent = __webpack_require__(86);
var traverseAllChildren = __webpack_require__(148);
var warning = __webpack_require__(1);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":"/emojimation"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(151);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(123)))

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(72);
var ReactDOMIDOperations = __webpack_require__(266);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(3);

var React = __webpack_require__(28);
var ReactComponentEnvironment = __webpack_require__(78);
var ReactCurrentOwner = __webpack_require__(11);
var ReactErrorUtils = __webpack_require__(79);
var ReactInstanceMap = __webpack_require__(36);
var ReactInstrumentation = __webpack_require__(7);
var ReactNodeTypes = __webpack_require__(138);
var ReactReconciler = __webpack_require__(27);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(44);
var invariant = __webpack_require__(0);
var shallowEqual = __webpack_require__(71);
var shouldUpdateReactComponent = __webpack_require__(86);
var warning = __webpack_require__(1);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(4);
var ReactDefaultInjection = __webpack_require__(274);
var ReactMount = __webpack_require__(137);
var ReactReconciler = __webpack_require__(27);
var ReactUpdates = __webpack_require__(9);
var ReactVersion = __webpack_require__(287);

var findDOMNode = __webpack_require__(303);
var getHostComponentFromComposite = __webpack_require__(142);
var renderSubtreeIntoContainer = __webpack_require__(310);
var warning = __webpack_require__(1);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(3);

var AutoFocusUtils = __webpack_require__(249);
var CSSPropertyOperations = __webpack_require__(251);
var DOMLazyTree = __webpack_require__(25);
var DOMNamespaces = __webpack_require__(73);
var DOMProperty = __webpack_require__(26);
var DOMPropertyOperations = __webpack_require__(130);
var EventPluginHub = __webpack_require__(34);
var EventPluginRegistry = __webpack_require__(74);
var ReactBrowserEventEmitter = __webpack_require__(45);
var ReactDOMComponentFlags = __webpack_require__(131);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactDOMInput = __webpack_require__(267);
var ReactDOMOption = __webpack_require__(268);
var ReactDOMSelect = __webpack_require__(132);
var ReactDOMTextarea = __webpack_require__(271);
var ReactInstrumentation = __webpack_require__(7);
var ReactMultiChild = __webpack_require__(280);
var ReactServerRenderingTransaction = __webpack_require__(285);

var emptyFunction = __webpack_require__(6);
var escapeTextContentForBrowser = __webpack_require__(48);
var invariant = __webpack_require__(0);
var isEventSupported = __webpack_require__(85);
var shallowEqual = __webpack_require__(71);
var inputValueTracking = __webpack_require__(144);
var validateDOMNesting = __webpack_require__(87);
var warning = __webpack_require__(1);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var validateDOMNesting = __webpack_require__(87);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var DOMLazyTree = __webpack_require__(25);
var ReactDOMComponentTree = __webpack_require__(4);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(72);
var ReactDOMComponentTree = __webpack_require__(4);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(3);

var DOMPropertyOperations = __webpack_require__(130);
var LinkedValueUtils = __webpack_require__(77);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactUpdates = __webpack_require__(9);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var React = __webpack_require__(28);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactDOMSelect = __webpack_require__(132);

var warning = __webpack_require__(1);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(5);

var getNodeForCharacterOffset = __webpack_require__(307);
var getTextContentAccessor = __webpack_require__(143);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(3);

var DOMChildrenOperations = __webpack_require__(72);
var DOMLazyTree = __webpack_require__(25);
var ReactDOMComponentTree = __webpack_require__(4);

var escapeTextContentForBrowser = __webpack_require__(48);
var invariant = __webpack_require__(0);
var validateDOMNesting = __webpack_require__(87);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(3);

var LinkedValueUtils = __webpack_require__(77);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactUpdates = __webpack_require__(9);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var ReactUpdates = __webpack_require__(9);
var Transaction = __webpack_require__(47);

var emptyFunction = __webpack_require__(6);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(248);
var BeforeInputEventPlugin = __webpack_require__(250);
var ChangeEventPlugin = __webpack_require__(252);
var DefaultEventPluginOrder = __webpack_require__(254);
var EnterLeaveEventPlugin = __webpack_require__(255);
var HTMLDOMPropertyConfig = __webpack_require__(257);
var ReactComponentBrowserEnvironment = __webpack_require__(259);
var ReactDOMComponent = __webpack_require__(262);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactDOMEmptyComponent = __webpack_require__(264);
var ReactDOMTreeTraversal = __webpack_require__(272);
var ReactDOMTextComponent = __webpack_require__(270);
var ReactDefaultBatchingStrategy = __webpack_require__(273);
var ReactEventListener = __webpack_require__(277);
var ReactInjection = __webpack_require__(278);
var ReactReconcileTransaction = __webpack_require__(283);
var SVGDOMPropertyConfig = __webpack_require__(288);
var SelectEventPlugin = __webpack_require__(289);
var SimpleEventPlugin = __webpack_require__(290);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(34);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var EventListener = __webpack_require__(120);
var ExecutionEnvironment = __webpack_require__(5);
var PooledClass = __webpack_require__(19);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactUpdates = __webpack_require__(9);

var getEventTarget = __webpack_require__(84);
var getUnboundedScrollPosition = __webpack_require__(235);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(26);
var EventPluginHub = __webpack_require__(34);
var EventPluginUtils = __webpack_require__(75);
var ReactComponentEnvironment = __webpack_require__(78);
var ReactEmptyComponent = __webpack_require__(133);
var ReactBrowserEventEmitter = __webpack_require__(45);
var ReactHostComponent = __webpack_require__(135);
var ReactUpdates = __webpack_require__(9);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var adler32 = __webpack_require__(301);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactComponentEnvironment = __webpack_require__(78);
var ReactInstanceMap = __webpack_require__(36);
var ReactInstrumentation = __webpack_require__(7);

var ReactCurrentOwner = __webpack_require__(11);
var ReactReconciler = __webpack_require__(27);
var ReactChildReconciler = __webpack_require__(258);

var emptyFunction = __webpack_require__(6);
var flattenChildren = __webpack_require__(304);
var invariant = __webpack_require__(0);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var CallbackQueue = __webpack_require__(129);
var PooledClass = __webpack_require__(19);
var ReactBrowserEventEmitter = __webpack_require__(45);
var ReactInputSelection = __webpack_require__(136);
var ReactInstrumentation = __webpack_require__(7);
var Transaction = __webpack_require__(47);
var ReactUpdateQueue = __webpack_require__(80);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactOwner = __webpack_require__(281);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var PooledClass = __webpack_require__(19);
var Transaction = __webpack_require__(47);
var ReactInstrumentation = __webpack_require__(7);
var ReactServerUpdateQueue = __webpack_require__(286);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(80);

var warning = __webpack_require__(1);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(35);
var ExecutionEnvironment = __webpack_require__(5);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactInputSelection = __webpack_require__(136);
var SyntheticEvent = __webpack_require__(10);

var getActiveElement = __webpack_require__(122);
var isTextInputElement = __webpack_require__(146);
var shallowEqual = __webpack_require__(71);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var EventListener = __webpack_require__(120);
var EventPropagators = __webpack_require__(35);
var ReactDOMComponentTree = __webpack_require__(4);
var SyntheticAnimationEvent = __webpack_require__(291);
var SyntheticClipboardEvent = __webpack_require__(292);
var SyntheticEvent = __webpack_require__(10);
var SyntheticFocusEvent = __webpack_require__(295);
var SyntheticKeyboardEvent = __webpack_require__(297);
var SyntheticMouseEvent = __webpack_require__(46);
var SyntheticDragEvent = __webpack_require__(294);
var SyntheticTouchEvent = __webpack_require__(298);
var SyntheticTransitionEvent = __webpack_require__(299);
var SyntheticUIEvent = __webpack_require__(37);
var SyntheticWheelEvent = __webpack_require__(300);

var emptyFunction = __webpack_require__(6);
var getEventCharCode = __webpack_require__(82);
var invariant = __webpack_require__(0);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(10);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(10);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(10);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(46);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(37);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(10);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(37);

var getEventCharCode = __webpack_require__(82);
var getEventKey = __webpack_require__(305);
var getEventModifierState = __webpack_require__(83);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(37);

var getEventModifierState = __webpack_require__(83);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(10);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(46);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(128);
var warning = __webpack_require__(1);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactCurrentOwner = __webpack_require__(11);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactInstanceMap = __webpack_require__(36);

var getHostComponentFromComposite = __webpack_require__(142);
var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(76);
var traverseAllChildren = __webpack_require__(148);
var warning = __webpack_require__(1);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":"/emojimation"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(151);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(123)))

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var getEventCharCode = __webpack_require__(82);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(5);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(48);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactMount = __webpack_require__(137);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(149);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._61);
  p._81 = 1;
  p._65 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._81 === 3) {
            val = val._65;
          }
          if (val._81 === 1) return res(i, val._65);
          if (val._81 === 2) reject(val._65);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(149);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._10 = null;
  Promise._97 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._10 = function (promise) {
    if (
      promise._81 === 2 && // IS REJECTED
      rejections[promise._72]
    ) {
      if (rejections[promise._72].logged) {
        onHandled(promise._72);
      } else {
        clearTimeout(rejections[promise._72].timeout);
      }
      delete rejections[promise._72];
    }
  };
  Promise._97 = function (promise, err) {
    if (promise._45 === 0) { // not yet handled
      promise._72 = id++;
      rejections[promise._72] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._72),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(38);

var invariant = __webpack_require__(0);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var PooledClass = __webpack_require__(314);
var ReactElement = __webpack_require__(29);

var emptyFunction = __webpack_require__(6);
var traverseAllChildren = __webpack_require__(324);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactElement = __webpack_require__(29);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(29),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(124);

module.exports = factory(isValidElement);

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(150),
    Component = _require.Component;

var _require2 = __webpack_require__(29),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(153);
var factory = __webpack_require__(110);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */


var _prodInvariant = __webpack_require__(38);

var ReactElement = __webpack_require__(29);

var invariant = __webpack_require__(0);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(38);

var ReactCurrentOwner = __webpack_require__(11);
var REACT_ELEMENT_TYPE = __webpack_require__(152);

var getIteratorFn = __webpack_require__(320);
var invariant = __webpack_require__(0);
var KeyEscapeUtils = __webpack_require__(313);
var warning = __webpack_require__(1);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//  weak
/* eslint guard-for-in: "off", no-restricted-syntax: "off" */
// Node constructor used to manage transitions internally
// Basically a modified preact component (https://github.com/developit/preact)

function extend(obj, props) {
  for (var i in props) {
    obj[i] = props[i]; // eslint-disable-line no-param-reassign
  }

  return obj;
}

function Node(key, data, type) {
  this.key = key;
  this.data = data;
  this.type = type;
  this.state = {};
}

extend(Node.prototype, {
  setState: function setState(state) {
    var s = this.state;
    extend(s, typeof state === 'function' ? state(s) : state);
  },
  updateData: function updateData(data) {
    this.data = data;

    return this;
  },
  updateType: function updateType(type) {
    this.type = type;

    return this;
  }
});

exports.default = Node;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Node = __webpack_require__(325);

var _Node2 = _interopRequireDefault(_Node);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Node2.default; /* eslint-disable flowtype/require-valid-file-annotation */

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(90);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(92);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(93);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(96);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(95);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(20);

var _react2 = _interopRequireDefault(_react);

var _d3Timer = __webpack_require__(69);

var _Node = __webpack_require__(326);

var _Node2 = _interopRequireDefault(_Node);

var _mergeKeys = __webpack_require__(330);

var _mergeKeys2 = _interopRequireDefault(_mergeKeys);

var _types = __webpack_require__(336);

var _transition = __webpack_require__(331);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//  weak
/* eslint max-len: "off" */

var NodeGroup = function (_Component) {
  (0, _inherits3.default)(NodeGroup, _Component);

  function NodeGroup() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, NodeGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = NodeGroup.__proto__ || (0, _getPrototypeOf2.default)(NodeGroup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      nodes: []
    }, _this.animate = function () {
      if (_this.unmounting) {
        return;
      }

      var pending = false;

      var nextNodeKeys = [];
      var length = _this.nodeKeys.length;

      for (var i = 0; i < length; i++) {
        var k = _this.nodeKeys[i];
        var n = _this.nodeHash[k];

        if (n.TRANSITION_SCHEDULES) {
          pending = true;
        }

        if (n.type === _types.LEAVE && !n.TRANSITION_SCHEDULES) {
          delete _this.nodeHash[k];
        } else {
          nextNodeKeys.push(k);
        }
      }

      if (!pending) {
        _this.interval.stop();
      }

      _this.nodeKeys = nextNodeKeys;
      _this.renderNodes();
    }, _this.nodeHash = {}, _this.nodeKeys = [], _this.interval = null, _this.unmounting = false, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(NodeGroup, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateNodes(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(next) {
      if (next.data !== this.props.data) {
        this.updateNodes(next);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this2 = this;

      this.unmounting = true;

      if (this.interval) {
        this.interval.stop();
      }

      this.nodeKeys.forEach(function (key) {
        _transition.stop.call(_this2.nodeHash[key]);
      });
    }
  }, {
    key: 'updateNodes',
    value: function updateNodes(props) {
      var data = props.data,
          keyAccessor = props.keyAccessor,
          start = props.start,
          enter = props.enter,
          update = props.update,
          leave = props.leave;


      var currKeyIndex = {};
      var currNodeKeys = this.nodeKeys;
      var currNodeKeysLength = this.nodeKeys.length;

      for (var i = 0; i < currNodeKeysLength; i++) {
        currKeyIndex[currNodeKeys[i]] = i;
      }

      var nextKeyIndex = {};
      var nextNodeKeys = [];

      for (var _i = 0; _i < data.length; _i++) {
        var d = data[_i];
        var k = keyAccessor(d);

        nextKeyIndex[k] = _i;
        nextNodeKeys.push(k);

        if (currKeyIndex[k] === undefined) {
          this.nodeHash[k] = new _Node2.default(k, d, _types.ENTER);
        }
      }

      for (var _i2 = 0; _i2 < currNodeKeysLength; _i2++) {
        var _k = currNodeKeys[_i2];
        var n = this.nodeHash[_k];

        if (nextKeyIndex[_k] !== undefined) {
          n.updateData(data[nextKeyIndex[_k]]);
          n.updateType(_types.UPDATE);
        } else {
          n.updateType(_types.LEAVE);
        }
      }

      this.nodeKeys = (0, _mergeKeys2.default)(currNodeKeys, currKeyIndex, nextNodeKeys, nextKeyIndex);

      for (var _i3 = 0; _i3 < this.nodeKeys.length; _i3++) {
        var _k2 = this.nodeKeys[_i3];
        var _n = this.nodeHash[_k2];
        var _d = _n.data;

        if (_n.type === _types.ENTER) {
          _n.setState(start(_d, nextKeyIndex[_k2]));
          _transition.transition.call(_n, enter(_d, nextKeyIndex[_k2]));
        } else if (_n.type === _types.LEAVE) {
          _transition.transition.call(_n, leave(_d, currKeyIndex[_k2]));
        } else {
          _transition.transition.call(_n, update(_d, nextKeyIndex[_k2]));
        }
      }

      if (!this.interval) {
        this.interval = (0, _d3Timer.interval)(this.animate);
      } else {
        this.interval.restart(this.animate);
      }

      this.renderNodes();
    }
  }, {
    key: 'renderNodes',
    value: function renderNodes() {
      var _this3 = this;

      this.setState(function () {
        return {
          nodes: _this3.nodeKeys.map(function (key) {
            return _this3.nodeHash[key];
          })
        };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var renderedChildren = this.props.children(this.state.nodes);
      return renderedChildren && _react2.default.Children.only(renderedChildren);
    }
  }]);
  return NodeGroup;
}(_react.Component);

NodeGroup.defaultProps = {
  enter: function enter() {},
  update: function update() {},
  leave: function leave() {}
};
exports.default = NodeGroup;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(90);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(92);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(93);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(96);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(95);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(20);

var _react2 = _interopRequireDefault(_react);

var _NodeGroup = __webpack_require__(155);

var _NodeGroup2 = _interopRequireDefault(_NodeGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//  weak
/* eslint max-len: "off" */

var tickKeyAccessor = function tickKeyAccessor(d) {
  return 'tick-' + d.val;
};

var TickGroup = function (_Component) {
  (0, _inherits3.default)(TickGroup, _Component);

  function TickGroup() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TickGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TickGroup.__proto__ || (0, _getPrototypeOf2.default)(TickGroup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      ticks: []
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TickGroup, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          scale = _props.scale,
          tickCount = _props.tickCount;

      var ticks = scale.ticks ? scale.ticks(tickCount) : [];
      this.updateTicks(ticks.map(function (d) {
        return { val: d };
      }));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(next) {
      if (next.scale !== this.props.scale) {
        var _scale = next.scale,
            _tickCount = next.tickCount;

        var ticks = _scale.ticks ? _scale.ticks(_tickCount) : [];
        this.updateTicks(ticks.map(function (d) {
          return { val: d };
        }));
      }
    }
  }, {
    key: 'updateTicks',
    value: function updateTicks(ticks) {
      this.setState(function () {
        return { ticks: ticks };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          start = _props2.start,
          enter = _props2.enter,
          update = _props2.update,
          leave = _props2.leave,
          children = _props2.children;


      return _react2.default.createElement(
        _NodeGroup2.default,
        {
          data: this.state.ticks,
          keyAccessor: tickKeyAccessor,
          start: start,
          enter: enter,
          update: update,
          leave: leave
        },
        children
      );
    }
  }]);
  return TickGroup;
}(_react.Component);

TickGroup.defaultProps = {
  enter: function enter() {},
  update: function update() {},
  leave: function leave() {}
};
exports.default = TickGroup;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _TickGroup = __webpack_require__(328);

var _TickGroup2 = _interopRequireDefault(_TickGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _TickGroup2.default; /* eslint-disable flowtype/require-valid-file-annotation */

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//  weak
/* eslint no-continue: "off" */
/* based on react-motion's mergeDiff (https://github.com/chenglou/react-motion) */

function mergeKeys(currNodeKeys, currKeyIndex, nextNodeKeys, nextKeyIndex) {
  var allKeys = [];

  for (var i = 0; i < nextNodeKeys.length; i++) {
    allKeys[i] = nextNodeKeys[i];
  }

  for (var _i = 0; _i < currNodeKeys.length; _i++) {
    if (nextKeyIndex[currNodeKeys[_i]] === undefined) {
      allKeys.push(currNodeKeys[_i]);
    }
  }

  return allKeys.sort(function (a, b) {
    var nextOrderA = nextKeyIndex[a];
    var nextOrderB = nextKeyIndex[b];
    var currOrderA = currKeyIndex[a];
    var currOrderB = currKeyIndex[b];

    if (nextOrderA != null && nextOrderB != null) {
      return nextKeyIndex[a] - nextKeyIndex[b];
    } else if (currOrderA != null && currOrderB != null) {
      return currKeyIndex[a] - currKeyIndex[b];
    } else if (nextOrderA != null) {
      for (var _i2 = 0; _i2 < nextNodeKeys.length; _i2++) {
        var pivot = nextNodeKeys[_i2];

        if (!currKeyIndex[pivot]) {
          continue;
        }

        if (nextOrderA < nextKeyIndex[pivot] && currOrderB > currKeyIndex[pivot]) {
          return -1;
        } else if (nextOrderA > nextKeyIndex[pivot] && currOrderB < currKeyIndex[pivot]) {
          return 1;
        }
      }

      return 1;
    }

    for (var _i3 = 0; _i3 < nextNodeKeys.length; _i3++) {
      var _pivot = nextNodeKeys[_i3];

      if (!currKeyIndex[_pivot]) {
        continue;
      }

      if (nextOrderB < nextKeyIndex[_pivot] && currOrderA > currKeyIndex[_pivot]) {
        return 1;
      } else if (nextOrderB > nextKeyIndex[_pivot] && currOrderA < currKeyIndex[_pivot]) {
        return -1;
      }
    }

    return -1;
  });
}

exports.default = mergeKeys;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _transition = __webpack_require__(334);

Object.defineProperty(exports, 'transition', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_transition).default;
  }
});

var _stop = __webpack_require__(333);

Object.defineProperty(exports, 'stop', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_stop).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(50);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = function (node, stateKey, id, timing, tweens) {
  var events = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

  var schedules = node.TRANSITION_SCHEDULES;
  if (!schedules) {
    node.TRANSITION_SCHEDULES = {}; // eslint-disable-line no-param-reassign
  } else if (id in schedules) {
    return;
  }

  var config = (0, _extends3.default)({ stateKey: stateKey, events: events, tweens: tweens }, timing, { timer: null, state: CREATED });
  create(node, id, config);
};

var _d3Timer = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CREATED = 0; //  weak
/* eslint no-use-before-define: "off" */
// Apapted from https://github.com/d3/d3-transition/blob/master/src/transition/schedule.js

var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;

function create(node, id, config) {
  var schedules = node.TRANSITION_SCHEDULES;

  // Initialize the transition timer when the transition is created.
  // Note the actual delay is not known until the first callback!
  var transition = (0, _extends3.default)({}, config);
  var n = transition.tweens.length;
  var tweens = new Array(n);

  schedules[id] = transition;
  transition.timer = (0, _d3Timer.timer)(schedule, 0, transition.time);

  function schedule(elapsed) {
    transition.state = SCHEDULED;
    transition.timer.restart(start, transition.delay, transition.time);

    // If the elapsed delay is less than our first sleep, start immediately.
    if (transition.delay <= elapsed) {
      start(elapsed - transition.delay);
    }
  }

  function start(elapsed) {
    // eslint-disable-line consistent-return
    // If the state is not SCHEDULED, then we previously errored on start.
    if (transition.state !== SCHEDULED) return stop();

    for (var sid in schedules) {
      // eslint-disable-line
      var s = schedules[sid];

      if (s.stateKey !== transition.stateKey) {
        continue; // eslint-disable-line no-continue
      }

      // While this element already has a starting transition during this frame,
      // defer starting an interrupting transition until that transition has a
      // chance to tick (and possibly end); see d3/d3-transition#54!
      if (s.state === STARTED) return (0, _d3Timer.timeout)(start);

      // 1. Interrupt the active transition, if any. dispatch the interrupt event.
      // 2. Cancel any pre-empted transitions. No interrupt event is dispatched
      // because the cancelled transitions never started. Note that this also
      // removes this transition from the pending list!

      if (s.state === RUNNING) {
        s.state = ENDED;
        s.timer.stop();
        if (s.events.interrupt && typeof s.events.interrupt === 'function') {
          s.events.interrupt.call(this);
        }
        delete schedules[sid];
      } else if (+sid < id) {
        s.state = ENDED;
        s.timer.stop();
        delete schedules[sid];
      }
    }

    // Defer the first tick to end of the current frame; see d3/d3#1576.
    // Note the transition may be canceled after start and before the first tick!
    // Note this must be scheduled before the start event; see d3/d3-transition#16!
    // Assuming this is successful, subsequent callbacks go straight to tick.
    (0, _d3Timer.timeout)(function () {
      if (transition.state === STARTED) {
        transition.state = RUNNING;
        transition.timer.restart(tick, transition.delay, transition.time);
        tick(elapsed);
      }
    });

    transition.state = STARTING;
    if (transition.events.start && typeof transition.events.start === 'function') {
      transition.events.start.call(node);
    }

    if (transition.state !== STARTING) {
      // interrupted
      return; // eslint-disable-line consistent-return
    }

    transition.state = STARTED;

    // Initialize the tween, deleting null tween.
    var j = -1;

    for (var i = 0; i < n; ++i) {
      var res = transition.tweens[i].call(node);

      if (res) {
        tweens[++j] = res;
      }
    }

    tweens.length = j + 1;
  }

  function tick(elapsed) {
    var t = 1;

    if (elapsed < transition.duration) {
      t = transition.ease.call(null, elapsed / transition.duration);
    } else {
      transition.timer.restart(stop);
      transition.state = ENDING;
    }

    var i = -1;

    while (++i < tweens.length) {
      tweens[i].call(null, t);
    }

    if (transition.state === ENDING) {
      if (transition.events.end && typeof transition.events.end === 'function') {
        transition.events.end.call(node);
      }
      stop();
    }
  }

  function stop() {
    transition.state = ENDED;
    transition.timer.stop();

    delete schedules[id];
    for (var i in schedules) {
      return;
    } // eslint-disable-line guard-for-in, no-restricted-syntax
    delete node.TRANSITION_SCHEDULES; // eslint-disable-line no-param-reassign
  }
}

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(91);

var _keys2 = _interopRequireDefault(_keys);

exports.default = stop;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//  weak

function stop() {
  var ts = this.TRANSITION_SCHEDULES;

  if (ts) {
    (0, _keys2.default)(ts).forEach(function (s) {
      ts[s].timer.stop();
    });
  }
}

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preset = undefined;

var _defineProperty2 = __webpack_require__(94);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _typeof2 = __webpack_require__(51);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(91);

var _keys2 = _interopRequireDefault(_keys);

var _extends5 = __webpack_require__(50);

var _extends6 = _interopRequireDefault(_extends5);

exports.newId = newId;
exports.default = transition;

var _d3Timer = __webpack_require__(69);

var _lodash = __webpack_require__(243);

var _lodash2 = _interopRequireDefault(_lodash);

var _tween = __webpack_require__(335);

var _tween2 = _interopRequireDefault(_tween);

var _schedule = __webpack_require__(332);

var _schedule2 = _interopRequireDefault(_schedule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//  weak

var id = 0;

function newId() {
  return ++id;
}

// from https://github.com/d3/d3-ease/blob/master/src/cubic.js
function easeCubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2; // eslint-disable-line
}

var preset = exports.preset = {
  time: null,
  delay: 0,
  duration: 250,
  ease: easeCubicInOut
};

function scheduleTransitions() {
  var _this = this;

  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var transitions = (0, _extends6.default)({}, config);

  var events = transitions.events || {};
  delete transitions.events;

  // each event handler should be called only once
  (0, _keys2.default)(events).forEach(function (d) {
    if (typeof events[d] !== 'function') {
      throw new Error('Event handlers must be a function');
    } else {
      events[d] = (0, _lodash2.default)(events[d]);
    }
  });

  var timing = transitions.timing || {};
  delete transitions.timing;

  (0, _keys2.default)(transitions).forEach(function (stateKey) {
    var tweens = [];

    if ((0, _typeof3.default)(transitions[stateKey]) === 'object' && Array.isArray(transitions[stateKey]) === false) {
      (0, _keys2.default)(transitions[stateKey]).forEach(function (attr) {
        var val = transitions[stateKey][attr];

        if (Array.isArray(val)) {
          if (val.length === 1) {
            tweens.push(_tween2.default.call(_this, stateKey, attr, val[0]));
          } else {
            _this.setState(function (state) {
              return (0, _defineProperty3.default)({}, stateKey, (0, _extends6.default)({}, state[stateKey], (0, _defineProperty3.default)({}, attr, val[0])));
            });

            tweens.push(_tween2.default.call(_this, stateKey, attr, val[1]));
          }
        } else if (typeof val === 'function') {
          var getResonanceCustomTween = function getResonanceCustomTween() {
            var resonanceCustomTween = function resonanceCustomTween(t) {
              _this.setState(function (state) {
                return (0, _defineProperty3.default)({}, stateKey, (0, _extends6.default)({}, state[stateKey], (0, _defineProperty3.default)({}, attr, val(t))));
              });
            };

            return resonanceCustomTween;
          };

          tweens.push(getResonanceCustomTween);
        } else {
          _this.setState(function (state) {
            return (0, _defineProperty3.default)({}, stateKey, (0, _extends6.default)({}, state[stateKey], (0, _defineProperty3.default)({}, attr, val)));
          });
          // This assures any existing transitions are stopped
          tweens.push(_tween2.default.call(_this, stateKey, attr, val));
        }
      });
    } else {
      var val = transitions[stateKey];

      if (Array.isArray(val)) {
        if (val.length === 1) {
          tweens.push(_tween2.default.call(_this, null, stateKey, val[0]));
        } else {
          _this.setState(function () {
            return (0, _defineProperty3.default)({}, stateKey, val[0]);
          });

          tweens.push(_tween2.default.call(_this, null, stateKey, val[1]));
        }
      } else if (typeof val === 'function') {
        var getResonanceCustomTween = function getResonanceCustomTween() {
          var resonanceCustomTween = function resonanceCustomTween(t) {
            _this.setState(function () {
              return (0, _defineProperty3.default)({}, stateKey, val(t));
            });
          };

          return resonanceCustomTween;
        };

        tweens.push(getResonanceCustomTween);
      } else {
        _this.setState(function () {
          return (0, _defineProperty3.default)({}, stateKey, val);
        });
        // This assures any existing transitions are stopped
        tweens.push(_tween2.default.call(_this, null, stateKey, val));
      }
    }

    var timingConfig = (0, _extends6.default)({}, preset, timing, { time: (0, _d3Timer.now)() });
    (0, _schedule2.default)(_this, stateKey, newId(), timingConfig, tweens, events);
  });
}

function transition(config) {
  var _this2 = this;

  if (Array.isArray(config)) {
    config.forEach(function (c) {
      scheduleTransitions.call(_this2, c);
    });
  } else {
    scheduleTransitions.call(this, config);
  }
}

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends3 = __webpack_require__(50);

var _extends4 = _interopRequireDefault(_extends3);

var _defineProperty2 = __webpack_require__(94);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.getInterpolator = getInterpolator;

exports.default = function (nameSpace, attr, value) {
  return getTween.call(this, nameSpace, attr, getInterpolator(attr, value), value);
};

var _d3Interpolate = __webpack_require__(212);

var _d3Color = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//  weak

function getTween(nameSpace, attr, interpol, value1) {
  return function tween() {
    var _this = this;

    var value0 = nameSpace ? this.state[nameSpace][attr] : this.state[attr];

    if (value0 === value1) {
      return null;
    }

    var i = interpol(value0, value1);

    var stateTween = void 0;

    if (nameSpace === null) {
      stateTween = function stateTween(t) {
        _this.setState(function () {
          return (0, _defineProperty3.default)({}, attr, i(t));
        });
      };
    } else {
      stateTween = function stateTween(t) {
        _this.setState(function (state) {
          return (0, _defineProperty3.default)({}, nameSpace, (0, _extends4.default)({}, state[nameSpace], (0, _defineProperty3.default)({}, attr, i(t))));
        });
      };
    }

    return stateTween;
  };
}

function getInterpolator(attr, value) {
  if (attr === 'transform') {
    return _d3Interpolate.interpolateTransformSvg;
  } else if (typeof value === 'number') {
    return _d3Interpolate.interpolateNumber;
  } else if (value instanceof _d3Color.color || (0, _d3Color.color)(value) !== null) {
    return _d3Interpolate.interpolateRgb;
  }

  return _d3Interpolate.interpolateString;
}

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//  weak

var ENTER = exports.ENTER = 'ENTER';
var UPDATE = exports.UPDATE = 'UPDATE';
var LEAVE = exports.LEAVE = 'LEAVE';

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NodeGroup__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NodeGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__NodeGroup__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__NodeGroup___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TickGroup__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TickGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TickGroup__);
/* unused harmony reexport TickGroup */
/* eslint-disable flowtype/require-valid-file-annotation */







/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 339 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(158);
module.exports = __webpack_require__(157);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.79262874.js